import "./module.css";
import {jsxs as $7XTbi$jsxs, jsx as $7XTbi$jsx, Fragment as $7XTbi$Fragment} from "react/jsx-runtime";
import $7XTbi$react, {useRef as $7XTbi$useRef, useEffect as $7XTbi$useEffect, forwardRef as $7XTbi$forwardRef, useState as $7XTbi$useState, useCallback as $7XTbi$useCallback, createContext as $7XTbi$createContext, useContext as $7XTbi$useContext, useMemo as $7XTbi$useMemo, useImperativeHandle as $7XTbi$useImperativeHandle, cloneElement as $7XTbi$cloneElement} from "react";
import $7XTbi$classnames from "classnames";
import $7XTbi$proptypes from "prop-types";
import {throttle as $7XTbi$throttle, useLocalize as $7XTbi$useLocalize, capitalizeFirstLetter as $7XTbi$capitalizeFirstLetter, getRandomString as $7XTbi$getRandomString, localize as $7XTbi$localize, getDateNextYear as $7XTbi$getDateNextYear, useOutsideClickEffect as $7XTbi$useOutsideClickEffect, useVerticalSwipe as $7XTbi$useVerticalSwipe, InSeparator as $7XTbi$InSeparator, InterPoint as $7XTbi$InterPoint, Logger as $7XTbi$Logger, useResponsiveValueState as $7XTbi$useResponsiveValueState, BYTES_PER_MB as $7XTbi$BYTES_PER_MB, styleTextBeforeToken as $7XTbi$styleTextBeforeToken, useEscapeKeyClose as $7XTbi$useEscapeKeyClose} from "@saviynt/common";
import {useFloating as $7XTbi$useFloating, offset as $7XTbi$offset, flip as $7XTbi$flip, shift as $7XTbi$shift, arrow as $7XTbi$arrow, autoUpdate as $7XTbi$autoUpdate, useHover as $7XTbi$useHover, useFocus as $7XTbi$useFocus, useDismiss as $7XTbi$useDismiss, useRole as $7XTbi$useRole, useTransitionStyles as $7XTbi$useTransitionStyles, useInteractions as $7XTbi$useInteractions, FloatingArrow as $7XTbi$FloatingArrow, FloatingPortal as $7XTbi$FloatingPortal, useClick as $7XTbi$useClick, FloatingFocusManager as $7XTbi$FloatingFocusManager, useFloatingTree as $7XTbi$useFloatingTree, useFloatingNodeId as $7XTbi$useFloatingNodeId, useFloatingParentNodeId as $7XTbi$useFloatingParentNodeId, useListItem as $7XTbi$useListItem, safePolygon as $7XTbi$safePolygon, useListNavigation as $7XTbi$useListNavigation, FloatingNode as $7XTbi$FloatingNode, useMergeRefs as $7XTbi$useMergeRefs, FloatingList as $7XTbi$FloatingList, FloatingTree as $7XTbi$FloatingTree} from "@floating-ui/react";
import $7XTbi$lottiereact from "lottie-react";
import $7XTbi$reactdatepicker from "react-datepicker";
import {useIntl as $7XTbi$useIntl} from "react-intl";
import {setHours as $7XTbi$setHours, setMinutes as $7XTbi$setMinutes} from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import $7XTbi$reactdom from "react-dom";
import $7XTbi$reactfocuslock from "react-focus-lock";
import {RemoveScroll as $7XTbi$RemoveScroll} from "react-remove-scroll";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}









const $65441b8e33d7ac73$export$486d921bfc157ff6 = 10;
const $65441b8e33d7ac73$export$18d1deb4684ad36c = 220;
const $65441b8e33d7ac73$export$aac4e82fdb62a982 = 200;
const $65441b8e33d7ac73$export$42a3bf4141986b1 = 1300; // Host app nav is 1200
const $65441b8e33d7ac73$export$15ea0c6dcd4860a0 = "rgba(0, 26, 64, 0.48)"; // Default overlay background color
const $65441b8e33d7ac73$export$49390a4605a2336a = {
    LIGHT: "light",
    DARK: "dark"
};
const $65441b8e33d7ac73$export$5aa24cb5f38e9127 = {
    TOP_START: "top-start",
    TOP: "top",
    TOP_END: "top-end",
    RIGHT_START: "right-start",
    RIGHT: "right",
    RIGHT_END: "right-end",
    BOTTOM_START: "bottom-start",
    BOTTOM: "bottom",
    BOTTOM_END: "bottom-end",
    LEFT_START: "left-start",
    LEFT: "left",
    LEFT_END: "left-end"
};
const $65441b8e33d7ac73$export$f37fc697bac1ac = {
    NONE: "none",
    START: "start",
    END: "end"
};
const $65441b8e33d7ac73$export$413a4c2603eff4ae = {
    SMALL: "small",
    MEDIUM: "medium",
    LARGE: "large",
    XLARGE: "xLarge"
};
const $65441b8e33d7ac73$export$ead22628fc157ba4 = {
    MEDIUM: "medium",
    LARGE: "large"
};
const $65441b8e33d7ac73$export$f34ec9f5cbfcdd45 = (0, $7XTbi$proptypes).shape({
    dataTheme: (0, $7XTbi$proptypes).oneOf(Object.values($65441b8e33d7ac73$export$49390a4605a2336a)),
    text: (0, $7XTbi$proptypes).string,
    placement: (0, $7XTbi$proptypes).oneOf(Object.values($65441b8e33d7ac73$export$5aa24cb5f38e9127)),
    maxWidth: (0, $7XTbi$proptypes).string,
    offset: (0, $7XTbi$proptypes).number,
    openDelay: (0, $7XTbi$proptypes).number,
    closeDelay: (0, $7XTbi$proptypes).number,
    isPortalEnabled: (0, $7XTbi$proptypes).bool,
    className: (0, $7XTbi$proptypes).string
});
const $65441b8e33d7ac73$export$836dc3e110fba957 = (0, $7XTbi$proptypes).shape({
    dataTheme: (0, $7XTbi$proptypes).oneOf(Object.values($65441b8e33d7ac73$export$49390a4605a2336a)),
    isOpen: (0, $7XTbi$proptypes).bool,
    setIsOpen: (0, $7XTbi$proptypes).func,
    trigger: (0, $7XTbi$proptypes).element,
    popoverContent: (0, $7XTbi$proptypes).element,
    placement: (0, $7XTbi$proptypes).oneOf(Object.values($65441b8e33d7ac73$export$5aa24cb5f38e9127)),
    offset: (0, $7XTbi$proptypes).number,
    isPortalEnabled: (0, $7XTbi$proptypes).bool,
    dataTestId: (0, $7XTbi$proptypes).string
});
const $65441b8e33d7ac73$export$5e945644cd84b2b0 = {
    DEFAULT: "default",
    QUESTION: "question",
    SUCCESS: "success",
    WARNING: "warning",
    CRITICAL: "critical",
    CUSTOM_ALERT: "customAlert",
    SAVIYNT: "saviynt",
    INVALID: "invalid"
};
const $65441b8e33d7ac73$export$800daf5fbbe96aff = {
    // Common
    OUTSIDE_CLICK_TARGET: "outside-click-target",
    // SidePanel
    SIDEPANEL_ASIDE: "sidepanel-aside",
    SIDEPANEL_CLOSE_BUTTON: "sidepanel-close-button",
    SIDEPANEL_UP_BUTTON: "sidpanel-up-button",
    SIDEPANEL_DOWN_BUTTON: "sidpanel-down-button",
    // Menu
    MENU_WRAPPER: "menu-wrapper",
    MENU_TRIGGER: "menu-trigger",
    MENU_DROPDOWN: "menu-dropdown",
    // Badge
    BADGE: "badge"
};
const $65441b8e33d7ac73$export$de87879afd52ccf9 = (0, $7XTbi$proptypes).oneOfType([
    (0, $7XTbi$proptypes).func,
    (0, $7XTbi$proptypes).shape({
        current: (0, $7XTbi$proptypes).instanceOf(Element)
    })
]);
const $65441b8e33d7ac73$export$1e9d3f41160d49dc = (0, $7XTbi$proptypes).shape({
    label: (0, $7XTbi$proptypes).string.isRequired,
    value: (0, $7XTbi$proptypes).string.isRequired,
    icon: (0, $7XTbi$proptypes).node
});
const $65441b8e33d7ac73$export$7f89d95782f61d72 = (0, $7XTbi$proptypes).shape({
    value: (0, $7XTbi$proptypes).string,
    children: (0, $7XTbi$proptypes).node,
    onChange: (0, $7XTbi$proptypes).func,
    moreContainerRef: $65441b8e33d7ac73$export$de87879afd52ccf9,
    isHorizontalScroll: (0, $7XTbi$proptypes).bool,
    horizontalParentRightPadding: (0, $7XTbi$proptypes).number,
    className: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string
});
const $65441b8e33d7ac73$export$9f3245bec405e186 = {
    neo: {
        common: {
            inputPlaceholder: {
                id: "neo.common.inputPlaceholder",
                defaultMessage: "Type to search"
            },
            loadingText: {
                id: "neo.common.loadingText",
                defaultMessage: "Loading..."
            },
            noDataAvailable: {
                id: "neo.common.noDataAvailable",
                defaultMessage: "No data available"
            }
        },
        alertBanner: {
            lessDetails: {
                id: "neo.alertBanner.lessDetails",
                defaultMessage: "Less Details"
            },
            moreDetails: {
                id: "neo.alertBanner.moreDetails",
                defaultMessage: "More Details"
            }
        }
    }
};
const $65441b8e33d7ac73$export$99eafb6aa688e40e = [
    "--color-overlay-secondary",
    "--color-overlay-primary",
    "--color-overlay-neutral",
    "--color-border-focus",
    "--color-border-savi-decorative",
    "--color-border-savi-subtlest",
    "--color-border-savi-subtle",
    "--color-border-savi-medium",
    "--color-border-savi-bold",
    "--color-border-info-decorative",
    "--color-border-info-subtlest",
    "--color-border-info-subtle",
    "--color-border-info-medium",
    "--color-border-info-bold",
    "--color-border-warning-decorative",
    "--color-border-warning-subtlest",
    "--color-border-warning-subtle",
    "--color-border-warning-medium",
    "--color-border-warning-bold",
    "--color-border-success-decorative",
    "--color-border-success-subtlest",
    "--color-border-success-subtle",
    "--color-border-success-medium",
    "--color-border-success-bold",
    "--color-border-critical-decorative",
    "--color-border-critical-subtlest",
    "--color-border-critical-subtle",
    "--color-border-critical-medium",
    "--color-border-critical-bold",
    "--color-border-primary-decorative",
    "--color-border-primary-subtlest",
    "--color-border-primary-subtle",
    "--color-border-primary-medium",
    "--color-border-primary-bold",
    "--color-border-secondary-decorative",
    "--color-border-secondary-subtlest",
    "--color-border-secondary-subtle",
    "--color-border-secondary-medium",
    "--color-border-secondary-bold",
    "--color-border-neutral-decorative",
    "--color-border-neutral-subtlest",
    "--color-border-neutral-subtle",
    "--color-border-neutral-medium",
    "--color-border-neutral-bold",
    "--color-background-blue-on-subtle-selected",
    "--color-background-blue-on-subtle-pressed",
    "--color-background-blue-on-subtle-hover",
    "--color-background-blue-subtlest",
    "--color-background-blue-subtle",
    "--color-background-blue-medium",
    "--color-background-blue-bold",
    "--color-background-coral-on-subtle-selected",
    "--color-background-coral-on-subtle-pressed",
    "--color-background-coral-on-subtle-hover",
    "--color-background-coral-subtlest",
    "--color-background-coral-subtle",
    "--color-background-coral-medium",
    "--color-background-coral-bold",
    "--color-background-green-on-subtle-selected",
    "--color-background-green-on-subtle-pressed",
    "--color-background-green-on-subtle-hover",
    "--color-background-green-subtlest",
    "--color-background-green-subtle",
    "--color-background-green-medium",
    "--color-background-green-bold",
    "--color-background-purple-on-subtle-selected",
    "--color-background-purple-on-subtle-pressed",
    "--color-background-purple-on-subtle-hover",
    "--color-background-purple-subtlest",
    "--color-background-purple-subtle",
    "--color-background-purple-medium",
    "--color-background-purple-bold",
    "--color-background-orange-on-subtle-selected",
    "--color-background-orange-on-subtle-pressed",
    "--color-background-orange-on-subtle-hover",
    "--color-background-orange-subtlest",
    "--color-background-orange-subtle",
    "--color-background-orange-medium",
    "--color-background-orange-bold",
    "--color-background-pink-on-subtle-selected",
    "--color-background-pink-on-subtle-pressed",
    "--color-background-pink-on-subtle-hover",
    "--color-background-pink-subtlest",
    "--color-background-pink-subtle",
    "--color-background-pink-medium",
    "--color-background-pink-bold",
    "--color-background-teal-on-subtle-selected",
    "--color-background-teal-on-subtle-pressed",
    "--color-background-teal-on-subtle-hover",
    "--color-background-teal-subtlest",
    "--color-background-teal-subtle",
    "--color-background-teal-medium",
    "--color-background-teal-bold",
    "--color-background-desaturated-subtlest",
    "--color-background-desaturated-subtle",
    "--color-background-desaturated-medium",
    "--color-background-desaturated-bold",
    "--color-background-desaturated-inverse",
    "--color-background-savi-on-subtle-selected",
    "--color-background-savi-on-subtle-pressed",
    "--color-background-savi-on-subtle-hover",
    "--color-background-savi-subtlest",
    "--color-background-savi-subtle",
    "--color-background-savi-medium",
    "--color-background-savi-bold",
    "--color-background-info-on-subtle-selected",
    "--color-background-info-on-subtle-pressed",
    "--color-background-info-on-subtle-hover",
    "--color-background-info-subtlest",
    "--color-background-info-subtle",
    "--color-background-info-medium",
    "--color-background-info-bold",
    "--color-background-warning-on-subtle-selected",
    "--color-background-warning-on-subtle-pressed",
    "--color-background-warning-on-subtle-hover",
    "--color-background-warning-subtlest",
    "--color-background-warning-subtle",
    "--color-background-warning-medium",
    "--color-background-warning-bold",
    "--color-background-success-on-subtle-selected",
    "--color-background-success-on-subtle-pressed",
    "--color-background-success-on-subtle-hover",
    "--color-background-success-subtlest",
    "--color-background-success-subtle",
    "--color-background-success-medium",
    "--color-background-success-bold",
    "--color-background-critical-on-subtle-selected",
    "--color-background-critical-on-subtle-pressed",
    "--color-background-critical-on-subtle-hover",
    "--color-background-critical-subtlest",
    "--color-background-critical-subtle",
    "--color-background-critical-medium",
    "--color-background-critical-bold",
    "--color-background-secondary-on-subtle-selected",
    "--color-background-secondary-on-subtle-pressed",
    "--color-background-secondary-on-subtle-hover",
    "--color-background-secondary-subtlest",
    "--color-background-secondary-subtle",
    "--color-background-secondary-medium",
    "--color-background-secondary-bold",
    "--color-background-primary-on-subtle-selected",
    "--color-background-primary-on-subtle-pressed",
    "--color-background-primary-on-subtle-hover",
    "--color-background-primary-subtlest",
    "--color-background-primary-subtle",
    "--color-background-primary-medium",
    "--color-background-primary-bold",
    "--color-background-neutral-disabled-medium",
    "--color-background-neutral-disabled-subtle",
    "--color-background-neutral-on-subtle-selected",
    "--color-background-neutral-on-subtle-pressed",
    "--color-background-neutral-on-subtle-hover",
    "--color-background-neutral-on-bold-disabled",
    "--color-background-neutral-on-bold-pressed",
    "--color-background-neutral-on-bold-selected",
    "--color-background-neutral-on-bold-hover",
    "--color-background-neutral-subtlest",
    "--color-background-neutral-subtle",
    "--color-background-neutral-medium",
    "--color-background-neutral-bold",
    "--color-page-subtle-desaturated",
    "--color-page-subtle",
    "--color-page-bold",
    "--color-foreground-blue-subtle",
    "--color-foreground-coral-subtle",
    "--color-foreground-green-subtle",
    "--color-foreground-purple-subtle",
    "--color-foreground-orange-subtle",
    "--color-foreground-pink-subtle",
    "--color-foreground-teal-subtle",
    "--color-foreground-savi-subtle",
    "--color-foreground-savi-medium",
    "--color-foreground-savi-bold",
    "--color-foreground-info-subtle",
    "--color-foreground-info-medium",
    "--color-foreground-info-bold",
    "--color-foreground-warning-subtle",
    "--color-foreground-warning-medium",
    "--color-foreground-warning-bold",
    "--color-foreground-success-subtle",
    "--color-foreground-success-medium",
    "--color-foreground-success-bold",
    "--color-foreground-critical-subtle",
    "--color-foreground-critical-medium",
    "--color-foreground-critical-bold",
    "--color-foreground-secondary-subtle",
    "--color-foreground-secondary-medium",
    "--color-foreground-secondary-bold",
    "--color-foreground-primary-subtle",
    "--color-foreground-primary-medium",
    "--color-foreground-primary-bold",
    "--color-foreground-neutral-inverse",
    "--color-foreground-neutral-disabled",
    "--color-foreground-neutral-subtle",
    "--color-foreground-neutral-medium",
    "--color-foreground-neutral-bold"
];


/**
 * 'Box' is a simple wrapper div for components and page elements.
 * It takes tag and className props.
 * The tag prop is intended to be used for simple semantic HTML
 * elements such as 'section', 'article', etc.
 */ const $9e3775a9a154967e$var$Box = /*#__PURE__*/ (0, $7XTbi$forwardRef)(({ children: children, tag: Tag, id: id, dataTheme: dataTheme, className: className, dataTestId: dataTestId }, ref)=>/*#__PURE__*/ (0, $7XTbi$jsx)(Tag, {
        id: id,
        "data-theme": dataTheme,
        className: className,
        "data-testid": dataTestId,
        ref: ref,
        children: children
    }));
$9e3775a9a154967e$var$Box.propTypes = {
    children: (0, $7XTbi$proptypes).node,
    tag: (0, $7XTbi$proptypes).string,
    id: (0, $7XTbi$proptypes).string,
    dataTheme: (0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$49390a4605a2336a))),
    className: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string
};
$9e3775a9a154967e$var$Box.defaultProps = {
    children: null,
    tag: "div",
    id: null,
    dataTheme: null,
    className: null,
    dataTestId: null
};
var $9e3775a9a154967e$export$2e2bcd8739ae039 = $9e3775a9a154967e$var$Box;







/**
 * `ButtonCore` is the foundational button component for the design system.
 * It provides essential button functionalities including click handling and
 * disabled states.
 */ const $553ba9ca1822b2c0$var$ButtonCore = /*#__PURE__*/ (0, $7XTbi$forwardRef)(({ id: id, type: type, onClick: onClick, isDisabled: isDisabled, children: children, onFocus: onFocus, onBlur: onBlur, ariaExpanded: ariaExpanded, tabIndex: tabIndex, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onKeyDown: onKeyDown, style: style, className: className, dataTheme: dataTheme, dataTestId: dataTestId }, ref)=>{
    const classes = (0, $7XTbi$classnames)("ButtonCore", className);
    return /*#__PURE__*/ (0, $7XTbi$jsx)("button", {
        ref: ref,
        id: id,
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        "aria-disabled": isDisabled,
        onFocus: onFocus,
        onBlur: onBlur,
        "aria-expanded": ariaExpanded,
        tabIndex: isDisabled ? -1 : tabIndex,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        style: style,
        className: classes,
        "data-theme": dataTheme,
        "data-testid": dataTestId,
        children: children
    });
});
$553ba9ca1822b2c0$var$ButtonCore.propTypes = {
    id: (0, $7XTbi$proptypes).string,
    type: (0, $7XTbi$proptypes).string,
    isDisabled: (0, $7XTbi$proptypes).bool,
    onClick: (0, $7XTbi$proptypes).func,
    children: (0, $7XTbi$proptypes).node,
    onFocus: (0, $7XTbi$proptypes).func,
    onBlur: (0, $7XTbi$proptypes).func,
    ariaExpanded: (0, $7XTbi$proptypes).string,
    tabIndex: (0, $7XTbi$proptypes).number,
    onMouseEnter: (0, $7XTbi$proptypes).func,
    onMouseLeave: (0, $7XTbi$proptypes).func,
    onMouseDown: (0, $7XTbi$proptypes).func,
    onMouseUp: (0, $7XTbi$proptypes).func,
    onKeyDown: (0, $7XTbi$proptypes).func,
    style: (0, $7XTbi$proptypes).element,
    className: (0, $7XTbi$proptypes).string,
    dataTheme: (0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$49390a4605a2336a))),
    dataTestId: (0, $7XTbi$proptypes).string
};
$553ba9ca1822b2c0$var$ButtonCore.defaultProps = {
    id: null,
    type: "button",
    isDisabled: false,
    onClick: ()=>{},
    children: null,
    onFocus: null,
    onBlur: null,
    ariaExpanded: "false",
    tabIndex: 0,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseDown: null,
    onMouseUp: null,
    onKeyDown: null,
    style: null,
    className: null,
    dataTheme: null,
    dataTestId: null
};
var $553ba9ca1822b2c0$export$2e2bcd8739ae039 = $553ba9ca1822b2c0$var$ButtonCore;






// eslint-disable-next-line import/prefer-default-export -- this is a collection module
/** Perform case-insensitive validation against object keys */ const $bdacd2991d6a3fd7$export$a6cc1b7066de015b = (entriesObject)=>(props, propName, componentName)=>{
        if (props[propName] === null) return; // allow null values
        // don't throw prop error based on casing. 'alertCritical' and 'AlertCritical' are valid.
        const lowerCaseKeys = Object.keys(entriesObject).map((obj)=>obj.toLowerCase());
        if (!lowerCaseKeys.includes(props[propName].toLowerCase())) throw new Error(`Invalid prop '${propName}' with value '${props[propName]}'
      supplied to '${componentName}'. Validation failed.`);
    };






/**
 * Do not edit directly
 * Generated on Wed Dec 18 2024 10:26:57 GMT+0000 (Coordinated Universal Time)
 */ const $3cad946ff8404ca5$export$5aef4e76b96cec9 = [
    "gray-50",
    "gray-100",
    "gray-200",
    "gray-300",
    "gray-400",
    "gray-500",
    "gray-600",
    "gray-700",
    "gray-800",
    "gray-900",
    "gray-1000",
    "gray-1100",
    "gray-000",
    "neutral-50",
    "neutral-100",
    "neutral-200",
    "neutral-300",
    "neutral-400",
    "neutral-500",
    "neutral-600",
    "neutral-700",
    "neutral-800",
    "neutral-900",
    "neutral-1000",
    "neutral-1100",
    "neutral-000",
    "indigo-50",
    "indigo-100",
    "indigo-200",
    "indigo-300",
    "indigo-400",
    "indigo-500",
    "indigo-600",
    "indigo-700",
    "indigo-800",
    "indigo-900",
    "indigo-1000",
    "indigo-1100",
    "navy-50",
    "navy-100",
    "navy-200",
    "navy-300",
    "navy-400",
    "navy-500",
    "navy-600",
    "navy-700",
    "navy-800",
    "navy-900",
    "navy-1000",
    "navy-1100",
    "critical-50",
    "critical-100",
    "critical-200",
    "critical-300",
    "critical-400",
    "critical-500",
    "critical-600",
    "critical-700",
    "critical-800",
    "critical-900",
    "critical-1000",
    "critical-1100",
    "success-50",
    "success-100",
    "success-200",
    "success-300",
    "success-400",
    "success-500",
    "success-600",
    "success-700",
    "success-800",
    "success-900",
    "success-1000",
    "success-1100",
    "warning-50",
    "warning-100",
    "warning-200",
    "warning-300",
    "warning-400",
    "warning-500",
    "warning-600",
    "warning-700",
    "warning-800",
    "warning-900",
    "warning-1000",
    "warning-1100",
    "info-50",
    "info-100",
    "info-200",
    "info-300",
    "info-400",
    "info-500",
    "info-600",
    "info-700",
    "info-800",
    "info-900",
    "info-1000",
    "info-1100",
    "teal-50",
    "teal-100",
    "teal-200",
    "teal-300",
    "teal-400",
    "teal-500",
    "teal-600",
    "teal-700",
    "teal-800",
    "teal-900",
    "teal-1000",
    "teal-1100",
    "pink-50",
    "pink-100",
    "pink-200",
    "pink-300",
    "pink-400",
    "pink-500",
    "pink-600",
    "pink-700",
    "pink-800",
    "pink-900",
    "pink-1000",
    "pink-1100",
    "orange-50",
    "orange-100",
    "orange-200",
    "orange-300",
    "orange-400",
    "orange-500",
    "orange-600",
    "orange-700",
    "orange-800",
    "orange-900",
    "orange-1000",
    "orange-1100",
    "purple-50",
    "purple-100",
    "purple-200",
    "purple-300",
    "purple-400",
    "purple-500",
    "purple-600",
    "purple-700",
    "purple-800",
    "purple-900",
    "purple-1000",
    "purple-1100",
    "green-50",
    "green-100",
    "green-200",
    "green-300",
    "green-400",
    "green-500",
    "green-600",
    "green-700",
    "green-800",
    "green-900",
    "green-1000",
    "green-1100",
    "coral-50",
    "coral-100",
    "coral-200",
    "coral-300",
    "coral-400",
    "coral-500",
    "coral-600",
    "coral-700",
    "coral-800",
    "coral-900",
    "coral-1000",
    "coral-1100",
    "blue-50",
    "blue-100",
    "blue-200",
    "blue-300",
    "blue-400",
    "blue-500",
    "blue-600",
    "blue-700",
    "blue-800",
    "blue-900",
    "blue-1000",
    "blue-1100"
];



function $f4c5e95c338bfebc$var$Color({ children: children, className: className, type: type, color: color, dataTestId: dataTestId }) {
    const classes = (0, $7XTbi$classnames)(color && `Color-${type}-${color}`, color && `Color-${color}`, className);
    return /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
        className: classes,
        "data-testid": dataTestId,
        children: children
    });
}
$f4c5e95c338bfebc$var$Color.propTypes = {
    type: (0, $7XTbi$proptypes).oneOf([
        "foreground",
        "background",
        "icon"
    ]),
    color: (0, $7XTbi$proptypes).oneOf((0, $3cad946ff8404ca5$export$5aef4e76b96cec9))
};
$f4c5e95c338bfebc$var$Color.defaultProps = {
    color: "navy-1000",
    type: "foreground"
};
var $f4c5e95c338bfebc$export$2e2bcd8739ae039 = $f4c5e95c338bfebc$var$Color;



var $836fa012cc7cf7fa$exports = {};

$parcel$export($836fa012cc7cf7fa$exports, "Account", function () { return $2c7126e809081d6f$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Add", function () { return $21c22c51af6b780c$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "AddCircle", function () { return $3b31951441ff7845$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "AlertCritical", function () { return $a5f864d3dcaef756$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "AlertCriticalFilledSeparateColors", function () { return $293ca7d4ab0c7617$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "AlertCriticalOutline", function () { return $e3b4864b84030299$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "AlertWarningFilledSeparateColors", function () { return $9a436358a490d910$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Application", function () { return $cbf56e8d7158506d$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "EndTerminateSubstract", function () { return $9fe53dc7b6c76ee5$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "ApproveSPH", function () { return $8344bc7949ddd5b5$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "ArrowDown", function () { return $3007e9ae6a3b68e2$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "ArrowLeft", function () { return $b4e7d6c1d80e5505$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "ArrowRight", function () { return $10c9c3f9fa4013ff$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "ArrowUp", function () { return $aa303e44a241afe7$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "AssetTargetSystem", function () { return $d5d1ce25e057fcf4$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Attachment", function () { return $2012113ada8e3d38$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "BookmarkFilled", function () { return $bb6875294203a5e7$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "BookmarkOutline", function () { return $7387a6ffe597c6a6$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "CloseCircle", function () { return $5943104a58081678$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "BoxGear", function () { return $53c8fad4feada24b$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "ButtonSelectChevronDown", function () { return $78c356643bfd0ab5$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "ButtonSelectChevronUp", function () { return $06d4a6e0cee447d4$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Calendar", function () { return $dcef6f0d4413fa26$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Certification", function () { return $1a6725b68239a721$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "CertsActionBtnSelectedBorderDash", function () { return $3b277bb06321f9c9$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "CertsActionBtnSelectedBorderSolid", function () { return $1f85fd5a5d0701fd$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Check", function () { return $4a947a406f1ef57f$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "CheckCircle", function () { return $c64e1c92bb7f6acd$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "CheckCircleFilledSeparateColors", function () { return $918d8242bed88b01$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "CheckCircleOutline", function () { return $fc23bee2e28b4704$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "CheckboxActive", function () { return $336c130256100a87$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Checkbox", function () { return $34aa03732bc37f62$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "CheckboxChecked", function () { return $f7a3091a389e2644$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "CheckboxCheckedDisabled", function () { return $b1e071e5e52d5c69$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "CheckboxDisabled", function () { return $fe87d99bfe819562$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "CheckboxHover", function () { return $3f49496bedc4e748$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "CheckboxIndeterminate", function () { return $594912d6e6084698$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "CheckboxIndeterminateDisabled", function () { return $4e040a48eda0bd65$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "ChevronDown", function () { return $0159560f7fe5113c$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "ChevronDownSmall", function () { return $af71e6ecf34c0a6d$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "ChevronLeft", function () { return $82210661d4ae108c$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "ChevronLeftSmall", function () { return $cbed1a02b72755fd$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "ChevronRight", function () { return $1ccc698f9e66bcbc$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "ChevronRightSmall", function () { return $99b4ee6f9920220b$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "ChevronUp", function () { return $2143bf4a3b3ecf78$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "ChevronUpSmall", function () { return $afe45638d0386a00$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Close", function () { return $915b5ce4ec050c86$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "ClosePanel", function () { return $a8621af63e8fde2f$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Code", function () { return $5314a1b4bbbbdf58$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Columns", function () { return $d28fda0e7cb7034f$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Comment", function () { return $109b4f6df784eb5d$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "ConfirmManager", function () { return $7ad453226fbb0b80$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "ConfirmManagerSPH", function () { return $0271f3f7264f0f9c$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "ConnectPlug", function () { return $38562215a482ec9d$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Consult", function () { return $f2874f8966ebea6e$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Copy", function () { return $bbda25edcfee28f9$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Critical", function () { return $8c432e129efe62f9$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Dashboard", function () { return $cfa4ca8b5b39fed0$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "DataAnalyze", function () { return $6b18ef98aaf91f0d$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Database", function () { return $0237db03d2bbbdec$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Delete", function () { return $300e3fe8fdfa5e29$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Document", function () { return $6f334fd7290063d4$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Download", function () { return $03bec61bf7e45902$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "DragHorizontal", function () { return $821d31fbf4da8455$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "DragVertical", function () { return $7e0f5b9294fb20eb$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "DynamicAttributes", function () { return $bdf5e65e09a9852d$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Edit", function () { return $83a8fb1b47dcf057$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Entitlement", function () { return $417e3d5615629032$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "ErrorSign", function () { return $e6558a9fb8c5ebf2$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "ExpandLeft", function () { return $14a898c4ab907c2b$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "ExpandRight", function () { return $af743c27f0b4a786$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Export", function () { return $5b3e65fb8470283b$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "ExtendEndDate", function () { return $62ab143e79aefec0$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Feature", function () { return $c31557939fdca4de$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Filter", function () { return $261f26890a2fa4a2$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Fix", function () { return $dfb30efc4b2b0b32$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "FrontIcon", function () { return $4fcbbe88afaa1e49$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Grid", function () { return $4ab03624f3f8f271$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "HalfBracket", function () { return $789401285deb3b51$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Hamburger", function () { return $aa99e4f582565a31$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Happy", function () { return $af76b8a5e920ac23$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Help", function () { return $ef65bd9583c4838e$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "HelpFilled", function () { return $54fd901d89cc9583$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "HelpFilledSeparateColors", function () { return $6be417bed896989b$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "HelpOutlined", function () { return $6b36533dbbb6d300$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Hierarchy", function () { return $c2dc3ad1adf0f9ac$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "ImageOutline", function () { return $95e98f86650c84cc$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Info", function () { return $5cad89942a71095f$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "InfoOutlined", function () { return $f29db2785159f53e$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "JobFunctions", function () { return $89a1581b8cd08deb$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Jump", function () { return $da5de97cf3a7326a$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "KeyBoard", function () { return $296c1624b3d139f1$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "LaunchRocket", function () { return $f96c63edfbec01a6$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "LeftArrow", function () { return $c595f6461facccb6$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "LinkChain", function () { return $8282ab85a668eef9$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Manager", function () { return $291798a9e40124e8$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "MenuHamburger", function () { return $0bca52681745aa88$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "AlertModalBackground", function () { return $0345d53ee9e1b395$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "MoreHorizontal", function () { return $d835331ee5611bac$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "MoreVertical", function () { return $ed6f91703d1891cf$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Neutral", function () { return $07980a25f80dab99$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "NotConfirmedByManager", function () { return $8f178723b360e48c$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Notification", function () { return $ee5900cac15b4ef8$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "NotificationWithBadge", function () { return $83d220cdb7aeb7d1$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Organization", function () { return $12586e7a1e4bfbcb$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Party", function () { return $268fa5ea90cfe0ce$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Password", function () { return $40361ad719b6c35d$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "PasswordCredentialUnlock", function () { return $26a624009ae0c3cc$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Potrait", function () { return $68e914f888fc2a13$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "PrivilgedAccess", function () { return $c54d1ea34b1aa993$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "PrivilegedSession", function () { return $cbdbbe1c8061d90e$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "RadioOutline", function () { return $1ea565f58b88b6e4$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "RadioOutlineHover", function () { return $f648fc672b85050e$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "RadioOutlinePressed", function () { return $873025c664017586$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "RadioOutlineSelected", function () { return $fe5e865658341929$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Reassign", function () { return $bb08c77c96d31bb6$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "ReassignItem", function () { return $94fb0f94563d2f84$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "ReassignUser", function () { return $2e08d42978d2896b$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Refresh", function () { return $bd1843b8604bf03b$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Reject", function () { return $f86d1a25415b9921$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "RejectSPH", function () { return $f3f2cbd8c1b0ba98$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Remove", function () { return $b9c633ddbd4ed232$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "RequestAccess", function () { return $8515f9049fa76acb$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "RequestApproval", function () { return $24aac56ab10dc3c1$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "RequestHistory", function () { return $ea7cb99023d8afba$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Required", function () { return $2e5d38074a046e48$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "RequiredInactive", function () { return $a6d6bfb396aa09db$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Resize", function () { return $802edaa9ae2feb1c$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Retry", function () { return $5b723d6c075f827a$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Revoked", function () { return $6cbf5b850dfed368$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Role", function () { return $9301384b43c41c12$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Rows", function () { return $3720e6bfc4840f79$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Sad", function () { return $45b41290c48964bc$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "NothingToShow", function () { return $d8e8cbf93c8fd9e6$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "SaveView", function () { return $da492545fa25e9c7$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "SaviCompSPH", function () { return $041e47b3894c6d81$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "SaviCompanion", function () { return $329d723da32f012d$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "SaviOwnReview", function () { return $25b394404c7cfe7d$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "SaviResetChat", function () { return $d61427d74748ad7c$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "SaviSmartApprove", function () { return $28ed693ff770056c$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "SaviSmartDecisions", function () { return $7d7495f6144daaa6$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "SaviSmartReject", function () { return $7f38fb7b9caf2018$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "SaviSPH", function () { return $c3efc9eb60727c4e$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "SaviyntCertified", function () { return $94e95aa1eee547d3$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Saviynt", function () { return $fdad0bbf65a21247$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "SaviyntFilledSeparateColors", function () { return $5298a389a88fd47f$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Search", function () { return $446eaf9115445e8a$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Server", function () { return $42ffb1f92d03f9d1$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Settings", function () { return $8df340de33e73709$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "SmartBrain", function () { return $6a1fd8d2214ee17f$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "SOD", function () { return $ebe4cdebd4cc6947$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Sort", function () { return $6a846eba55ef9400$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "SortDown", function () { return $a5910cdd7a0d0d28$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "SortNone", function () { return $1229793c5f6a2a01$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "SortUp", function () { return $e6b5904012ea0e0f$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "StarFilled", function () { return $eb0a486197cf00a5$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "StarHalfFilled", function () { return $9d67e94c84fd1a83$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "StarOutline", function () { return $7ed8c89d81a7c428$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Stop", function () { return $78a68170e705ac18$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "StopProcess", function () { return $4e1dda6281d87acc$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Subtract", function () { return $9e29b94c548bf2bd$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "SubtractCircle", function () { return $e6c544eeae94aa71$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Success", function () { return $77222dece5b8bf1e$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Terminate", function () { return $d072591f27916707$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Time", function () { return $63465845e617bd18$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "TooltipArrow", function () { return $814be1174f21653f$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Upload", function () { return $3539ae1d403c2ac9$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "User", function () { return $dccfce21d4968457$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "UserNoBg", function () { return $757be24f2993f6f1$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Vault", function () { return $b04d5adc061129f6$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "VisibilityOff", function () { return $f2f3d005fda9eb13$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "VisibilityOn", function () { return $e9dd00f2b344c48d$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Warning", function () { return $65e39a408da4e7b1$export$2e2bcd8739ae039; });
$parcel$export($836fa012cc7cf7fa$exports, "Workflow", function () { return $00392e192e2f6fba$export$2e2bcd8739ae039; });
// TODO: All Icons imported from Figma with correct names and default color, and height and width of 24px for basic SVG's, currently at least 24 Icon exports are incorrect, need to be addressed in peices to avoid regerssions
// TODO: Remove un-used Icon exports
// UI-1019 progress:
// Layout frame one - Filter, Edit, CloseCircle, AddCircle, EndTerminateSubstract
// Layout frame two - Password, Account


const $2c7126e809081d6f$var$SvgAccount = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fill: "#212328",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10.071 9.018a3.02 3.02 0 1 1 6.038 0 3.02 3.02 0 0 1-6.038 0ZM13.091 7a2.019 2.019 0 1 0-.001 4.038 2.019 2.019 0 0 0 0-4.038Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M13.119 12.666c-1.603 0-2.994.453-4.087 1.21H9.03l-.014.01a2.525 2.525 0 0 0-.19.149 3.735 3.735 0 0 0-.434.427c-.308.36-.665.925-.665 1.633V17.5a.5.5 0 0 0 1 0v-1.407c0-.366.189-.706.425-.981a2.74 2.74 0 0 1 .434-.405l.007-.005.003-.002.005-.004c.917-.634 2.107-1.031 3.518-1.031 1.397 0 2.639.451 3.609 1.098.356.238.537.566.63.85a1.933 1.933 0 0 1 .09.457v.046l.001.025.002.094.006.33c.003.269.003.611-.009.917a.5.5 0 1 0 1 .036 21.486 21.486 0 0 0 .003-1.305l-.002-.098v-.031l-.001-.014a1.8 1.8 0 0 0-.017-.222 2.92 2.92 0 0 0-.123-.546 2.592 2.592 0 0 0-1.025-1.37 7.511 7.511 0 0 0-4.164-1.267Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M4.092 4.167C4.092 3.522 4.614 3 5.258 3h13.667a3.167 3.167 0 0 1 3.167 3.167v13.666c0 .645-.522 1.167-1.167 1.167H7.258a3.167 3.167 0 0 1-3.166-3.167V4.167ZM5.258 4a.167.167 0 0 0-.166.167v13.666c0 1.197.97 2.167 2.166 2.167h13.667a.167.167 0 0 0 .167-.167V6.167c0-1.197-.97-2.167-2.167-2.167H5.258Z"
                })
            ]
        })
    });
var $2c7126e809081d6f$export$2e2bcd8739ae039 = $2c7126e809081d6f$var$SvgAccount;




const $21c22c51af6b780c$var$SvgAdd = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 3a.5.5 0 0 1 .5.5v8h8a.5.5 0 0 1 0 1h-8v8a.5.5 0 0 1-1 0v-8h-8a.5.5 0 0 1 0-1h8v-8A.5.5 0 0 1 12 3Z",
            fill: "#212328"
        })
    });
var $21c22c51af6b780c$export$2e2bcd8739ae039 = $21c22c51af6b780c$var$SvgAdd;




const $3b31951441ff7845$var$SvgAddCircle = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fill: "#212328",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M12.4 6a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5a.5.5 0 0 1 .5-.5Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12.4 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm-8 9a8 8 0 1 1 16 0 8 8 0 0 1-16 0Z"
                })
            ]
        })
    });
var $3b31951441ff7845$export$2e2bcd8739ae039 = $3b31951441ff7845$var$SvgAddCircle;




const $a5f864d3dcaef756$var$SvgAlertCritical = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "#CC1C10",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0ZM7.216 5.876a.779.779 0 1 1 1.546 0l-.376 3.01a.4.4 0 0 1-.794 0l-.376-3.01ZM7.99 11a.706.706 0 1 0 0-1.412.706.706 0 0 0 0 1.412Z"
        })
    });
var $a5f864d3dcaef756$export$2e2bcd8739ae039 = $a5f864d3dcaef756$var$SvgAlertCritical;




const $293ca7d4ab0c7617$var$SvgAlertCriticalFilledSeparateColors = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M87.5 50c0 20.71-16.79 37.5-37.5 37.5S12.5 70.71 12.5 50 29.29 12.5 50 12.5 87.5 29.29 87.5 50Z",
                fill: "#CC1C10"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("g", {
                fill: "#fff",
                children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M54.167 65.186a4.167 4.167 0 1 1-8.334 0 4.167 4.167 0 0 1 8.334 0ZM45.31 35.83a4.713 4.713 0 1 1 9.38 0l-1.827 18.267a2.878 2.878 0 0 1-5.726 0L45.31 35.83Z"
                })
            })
        ]
    });
var $293ca7d4ab0c7617$export$2e2bcd8739ae039 = $293ca7d4ab0c7617$var$SvgAlertCriticalFilledSeparateColors;




const $e3b4864b84030299$var$SvgAlertCriticalOutline = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M11 8.6a1.131 1.131 0 1 1 2.25 0l-.438 4.384a.69.69 0 0 1-1.374 0l-.439-4.385ZM13.125 15.645a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
                fill: "#212328"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.125 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm-8 9a8 8 0 1 1 16 0 8 8 0 0 1-16 0Z",
                fill: "#212328"
            })
        ]
    });
var $e3b4864b84030299$export$2e2bcd8739ae039 = $e3b4864b84030299$var$SvgAlertCriticalOutline;




const $9a436358a490d910$var$SvgAlertWarningFilledSeparateColors = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M54.221 19.037c-1.866-3.266-6.575-3.266-8.441 0L13.15 76.139c-1.852 3.241.488 7.273 4.22 7.273h65.26c3.733 0 6.073-4.032 4.221-7.273l-32.63-57.102Z",
                fill: "#E19701"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("g", {
                fill: "#fff",
                children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M53.464 67.895a3.464 3.464 0 1 1-6.93 0 3.464 3.464 0 0 1 6.93 0ZM45.944 43.274a4.076 4.076 0 1 1 8.11 0l-1.579 15.797a2.488 2.488 0 0 1-4.952 0l-1.58-15.797Z"
                })
            })
        ]
    });
var $9a436358a490d910$export$2e2bcd8739ae039 = $9a436358a490d910$var$SvgAlertWarningFilledSeparateColors;




const $cbf56e8d7158506d$var$SvgApplication = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M9.233 3.861a.5.5 0 1 0 0 1h6.334a.5.5 0 0 0 0-1H9.233ZM6.067 6.361a.5.5 0 0 1 .5-.5h11.666a.5.5 0 1 1 0 1H6.567a.5.5 0 0 1-.5-.5Z",
                fill: "#212328"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3.4 9.639c0-1.013.82-1.834 1.833-1.834h14.334c1.012 0 1.833.821 1.833 1.834v8.666c0 1.013-.82 1.834-1.833 1.834H5.233A1.833 1.833 0 0 1 3.4 18.305V9.64Zm1.833-.834a.833.833 0 0 0-.833.834v8.666c0 .46.373.834.833.834h14.334c.46 0 .833-.373.833-.834V9.64a.833.833 0 0 0-.833-.834H5.233Z",
                fill: "#212328"
            })
        ]
    });
var $cbf56e8d7158506d$export$2e2bcd8739ae039 = $cbf56e8d7158506d$var$SvgApplication;




const $9fe53dc7b6c76ee5$var$SvgEndTerminateSubstract = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fill: "#212328",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M7.067 11.482a.5.5 0 1 0 0 1h10.666a.5.5 0 1 0 0-1H7.067Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12.4 2.667a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm-8 9a8 8 0 1 1 16 0 8 8 0 0 1-16 0Z"
                })
            ]
        })
    });
var $9fe53dc7b6c76ee5$export$2e2bcd8739ae039 = $9fe53dc7b6c76ee5$var$SvgEndTerminateSubstract;




const $8344bc7949ddd5b5$var$SvgApproveSph = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 17,
        height: 17,
        viewBox: "0 0 17 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.402 4.144c.13.13.13.34 0 .471l-8.25 8.242a.334.334 0 0 1-.471 0l-3.084-3.1a.333.333 0 0 1 .473-.47l2.848 2.863 8.013-8.007c.13-.13.341-.13.472 0Z",
            fill: "#028329"
        })
    });
var $8344bc7949ddd5b5$export$2e2bcd8739ae039 = $8344bc7949ddd5b5$var$SvgApproveSph;




const $3007e9ae6a3b68e2$var$SvgArrowDown = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            d: "M19.087 14.51a.5.5 0 1 0-.708-.706l-5.482 5.484V3.493a.5.5 0 1 0-1 0v15.79l-5.477-5.48a.5.5 0 0 0-.707.708l6.333 6.336a.5.5 0 0 0 .708 0l6.333-6.336Z",
            fill: "#212328"
        })
    });
var $3007e9ae6a3b68e2$export$2e2bcd8739ae039 = $3007e9ae6a3b68e2$var$SvgArrowDown;




const $b4e7d6c1d80e5505$var$SvgArrowLeft = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            d: "M9.882 18.68a.5.5 0 0 0 .707-.707l-5.484-5.482H20.9a.5.5 0 1 0 0-1H5.11l5.48-5.477a.5.5 0 0 0-.708-.708L3.546 11.64a.5.5 0 0 0 0 .707l6.336 6.333Z",
            fill: "#212328"
        })
    });
var $b4e7d6c1d80e5505$export$2e2bcd8739ae039 = $b4e7d6c1d80e5505$var$SvgArrowLeft;




const $10c9c3f9fa4013ff$var$SvgArrowRight = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            d: "M14.917 5.306a.5.5 0 1 0-.707.708l5.485 5.482H3.9a.5.5 0 0 0 0 1h15.79l-5.48 5.477a.5.5 0 1 0 .707.707l6.336-6.333a.5.5 0 0 0 0-.707l-6.336-6.334Z",
            fill: "#212328"
        })
    });
var $10c9c3f9fa4013ff$export$2e2bcd8739ae039 = $10c9c3f9fa4013ff$var$SvgArrowRight;




const $aa303e44a241afe7$var$SvgArrowUp = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            d: "M5.713 9.476a.5.5 0 1 0 .707.706l5.482-5.484v15.795a.5.5 0 1 0 1 0V4.703l5.478 5.48a.5.5 0 1 0 .707-.707L12.753 3.14a.5.5 0 0 0-.707 0L5.713 9.476Z",
            fill: "#212328"
        })
    });
var $aa303e44a241afe7$export$2e2bcd8739ae039 = $aa303e44a241afe7$var$SvgArrowUp;




const $d5d1ce25e057fcf4$var$SvgAssetTargetSystem = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fill: "#212328",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10.82 8.325c-.885 0-1.602.717-1.602 1.601v4.148c0 .884.717 1.6 1.602 1.6h4.167c.884 0 1.601-.716 1.601-1.6V9.926c0-.884-.717-1.601-1.6-1.601H10.82ZM8.218 9.926a2.601 2.601 0 0 1 2.602-2.601h4.167a2.601 2.601 0 0 1 2.601 2.601v4.148a2.601 2.601 0 0 1-2.6 2.6H10.82a2.601 2.601 0 0 1-2.602-2.6V9.926Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12.902 3a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0v-6a.5.5 0 0 1 .5-.5ZM10.904 12a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1 0-1h6a.5.5 0 0 1 .5.5ZM21.904 12a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1 0-1h6a.5.5 0 0 1 .5.5ZM12.902 14a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0v-6a.5.5 0 0 1 .5-.5Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12.904 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-9 8a9 9 0 1 1 18 0 9 9 0 0 1-18 0Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M13.904 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
                })
            ]
        })
    });
var $d5d1ce25e057fcf4$export$2e2bcd8739ae039 = $d5d1ce25e057fcf4$var$SvgAssetTargetSystem;




const $2012113ada8e3d38$var$SvgAttachment = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.926 3.333c-.793 0-1.435.643-1.435 1.436v9.166a.51.51 0 0 0 1.018 0v-8.38a.417.417 0 1 1 .834 0v8.38a1.343 1.343 0 1 1-2.685 0V4.77a2.269 2.269 0 1 1 4.537 0v9.537a3.194 3.194 0 0 1-6.39 0v-8.75a.417.417 0 0 1 .834 0v8.75a2.361 2.361 0 1 0 4.722 0V4.769c0-.793-.642-1.436-1.435-1.436Z",
            fill: "#A800E0"
        })
    });
var $2012113ada8e3d38$export$2e2bcd8739ae039 = $2012113ada8e3d38$var$SvgAttachment;




const $bb6875294203a5e7$var$SvgBookmarkFilled = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            d: "M5.484 4.345C5.484 3.602 6.086 3 6.83 3H17.17c.743 0 1.345.602 1.345 1.345v15.981c0 .58-.686.888-1.12.503l-4.95-4.4a.672.672 0 0 0-.893 0l-4.95 4.4a.672.672 0 0 1-1.119-.503V4.345Z",
            fill: "#212328"
        })
    });
var $bb6875294203a5e7$export$2e2bcd8739ae039 = $bb6875294203a5e7$var$SvgBookmarkFilled;




const $7387a6ffe597c6a6$var$SvgBookmarkOutline = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.48 4.92C5.48 3.86 6.318 3 7.35 3h9.29c1.032 0 1.87.86 1.87 1.92v14.856c0 1.054-1.214 1.614-1.981.913l-4.421-4.034a.167.167 0 0 0-.226 0l-4.42 4.034c-.768.7-1.982.141-1.982-.913V4.92Zm1.87-.873c-.469 0-.85.391-.85.873v14.856c0 .15.174.23.283.13l4.421-4.033a1.168 1.168 0 0 1 1.582 0l4.42 4.033c.11.1.284.02.284-.13V4.92a.862.862 0 0 0-.85-.873H7.35Z",
            fill: "#212328"
        })
    });
var $7387a6ffe597c6a6$export$2e2bcd8739ae039 = $7387a6ffe597c6a6$var$SvgBookmarkOutline;




const $5943104a58081678$var$SvgCloseCircle = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fill: "#212328",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M8.157 16.243a.5.5 0 0 1 0-.707L11.693 12 8.157 8.464a.5.5 0 0 1 .707-.707l3.536 3.536 3.535-3.536a.5.5 0 1 1 .708.707L13.107 12l3.536 3.536a.5.5 0 0 1-.708.707L12.4 12.707l-3.536 3.536a.5.5 0 0 1-.707 0Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12.4 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm-8 9a8 8 0 1 1 16 0 8 8 0 0 1-16 0Z"
                })
            ]
        })
    });
var $5943104a58081678$export$2e2bcd8739ae039 = $5943104a58081678$var$SvgCloseCircle;




const $53c8fad4feada24b$var$SvgBoxGear = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fill: "#254B86",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3 4.929C3 3.863 3.863 3 4.929 3h4.5c1.065 0 1.928.863 1.928 1.929v4.5a1.928 1.928 0 0 1-1.928 1.928h-4.5A1.929 1.929 0 0 1 3 9.43v-4.5Zm1.929-.643a.643.643 0 0 0-.643.643v4.5c0 .355.288.642.643.642h4.5a.643.643 0 0 0 .642-.642v-4.5a.643.643 0 0 0-.642-.643h-4.5ZM3 14.571c0-1.065.863-1.928 1.929-1.928h4.5c1.065 0 1.928.863 1.928 1.928v4.5A1.929 1.929 0 0 1 9.43 21h-4.5A1.929 1.929 0 0 1 3 19.071v-4.5Zm1.929-.642a.643.643 0 0 0-.643.642v4.5c0 .355.288.643.643.643h4.5a.643.643 0 0 0 .642-.643v-4.5a.643.643 0 0 0-.642-.642h-4.5ZM12.643 4.929c0-1.066.863-1.929 1.928-1.929h4.5C20.137 3 21 3.863 21 4.929v4.5a1.929 1.929 0 0 1-1.929 1.928h-4.5a1.928 1.928 0 0 1-1.928-1.928v-4.5Zm1.928-.643a.643.643 0 0 0-.642.643v4.5c0 .355.287.642.642.642h4.5a.643.643 0 0 0 .643-.642v-4.5a.643.643 0 0 0-.643-.643h-4.5Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M16.5 17.786a1.286 1.286 0 1 0 0-2.572 1.286 1.286 0 0 0 0 2.572Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M15.05 12.383a.643.643 0 0 1 .587-.383h1.539c.24 0 .462.135.572.35l.367.717.464.245.842-.087a.643.643 0 0 1 .61.296l.808 1.28a.643.643 0 0 1-.014.708l-.47.683v.451l.506.64a.643.643 0 0 1 .055.716l-.743 1.312a.643.643 0 0 1-.56.326h-.883l-.456.239-.329.741a.643.643 0 0 1-.588.383h-1.534a.643.643 0 0 1-.57-.348l-.353-.682-.483-.202h-.918a.643.643 0 0 1-.545-.3l-.793-1.263a.643.643 0 0 1 .005-.693l.45-.691v-.476l-.486-.642a.643.643 0 0 1-.046-.705l.745-1.317a.643.643 0 0 1 .598-.324l.843.05.441-.26.338-.764Zm1.006.903-.253.57a.642.642 0 0 1-.26.293l-.788.465a.642.642 0 0 1-.366.088l-.639-.038-.34.6.362.477c.085.112.13.248.13.388v.883a.643.643 0 0 1-.104.35l-.33.507.386.613h.692c.085 0 .17.017.248.05l.818.342c.139.058.253.164.323.298l.28.542h.724l.25-.564a.643.643 0 0 1 .29-.31l.795-.416a.643.643 0 0 1 .298-.073h.667l.345-.61-.376-.476a.643.643 0 0 1-.139-.398v-.875c0-.13.04-.258.114-.365l.343-.498-.37-.584-.638.066a.642.642 0 0 1-.366-.071l-.816-.43a.642.642 0 0 1-.272-.276l-.281-.548h-.727Z"
                })
            ]
        })
    });
var $53c8fad4feada24b$export$2e2bcd8739ae039 = $53c8fad4feada24b$var$SvgBoxGear;




const $78c356643bfd0ab5$var$SvgButtonselectChevronDown = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.983 8.456a.417.417 0 0 1 .59 0L10 12.883l4.428-4.427a.417.417 0 1 1 .589.589l-4.722 4.722a.417.417 0 0 1-.59 0L4.983 9.045a.417.417 0 0 1 0-.59Z",
            fill: "#212328"
        })
    });
var $78c356643bfd0ab5$export$2e2bcd8739ae039 = $78c356643bfd0ab5$var$SvgButtonselectChevronDown;




const $06d4a6e0cee447d4$var$SvgButtonselectChevronUp = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.017 13.211a.417.417 0 0 1-.59 0L10 8.784 5.572 13.21a.417.417 0 0 1-.589-.589L9.705 7.9a.417.417 0 0 1 .59 0l4.722 4.722a.417.417 0 0 1 0 .59Z",
            fill: "#254B86"
        })
    });
var $06d4a6e0cee447d4$export$2e2bcd8739ae039 = $06d4a6e0cee447d4$var$SvgButtonselectChevronUp;




const $dcef6f0d4413fa26$var$SvgCalendar = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 20,
        height: 21,
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fill: "#3751FF",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M4.653 11.309c0-.23.186-.417.416-.417h1.667a.417.417 0 0 1 0 .833H5.07a.417.417 0 0 1-.416-.416ZM5.07 13.725a.417.417 0 0 0 0 .834h1.666a.417.417 0 0 0 0-.834H5.07ZM8.75 11.309c0-.23.186-.417.416-.417h1.667a.417.417 0 0 1 0 .833H9.166a.417.417 0 0 1-.416-.416ZM9.166 13.725a.417.417 0 0 0 0 .834h1.667a.417.417 0 0 0 0-.834H9.166ZM12.847 11.309c0-.23.187-.417.417-.417h1.667a.417.417 0 0 1 0 .833h-1.667a.417.417 0 0 1-.417-.416ZM13.264 13.725a.417.417 0 0 0 0 .834h1.667a.417.417 0 0 0 0-.834h-1.667Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M6.458 2.549c.23 0 .417.186.417.417v1h2.708v-1a.417.417 0 0 1 .834 0v1h2.708v-1a.417.417 0 1 1 .833 0v1h2.014c.844 0 1.528.683 1.528 1.527v10.528c0 .844-.684 1.528-1.528 1.528H4.028A1.528 1.528 0 0 1 2.5 16.02V5.493c0-.844.684-1.528 1.528-1.528h2.014v-1c0-.23.186-.416.416-.416Zm-.416 3.194V4.8H4.028a.694.694 0 0 0-.695.694v2.368h13.334V5.493a.694.694 0 0 0-.695-.694h-2.014v.944a.417.417 0 1 1-.833 0V4.8h-2.708v.944a.417.417 0 0 1-.834 0V4.8H6.875v.944a.417.417 0 0 1-.833 0ZM3.333 8.695v7.326c0 .384.311.694.695.694h11.944c.384 0 .695-.31.695-.694V8.695H3.333Z"
                })
            ]
        })
    });
var $dcef6f0d4413fa26$export$2e2bcd8739ae039 = $dcef6f0d4413fa26$var$SvgCalendar;




const $1a6725b68239a721$var$SvgCertification = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fill: "#212328",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M4.09 4a.5.5 0 0 1 .5-.5h11.332a2.5 2.5 0 0 1 2.5 2.5v2.5a.5.5 0 1 1-1 0V6a1.5 1.5 0 0 0-1.5-1.5H5.09v13.167a1.5 1.5 0 0 0 1.5 1.5h3.333a.5.5 0 0 1 0 1H6.59a2.5 2.5 0 0 1-2.5-2.5V4Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M7.246 7.5a.5.5 0 0 1 .5-.5h4.667a.5.5 0 1 1 0 1H7.746a.5.5 0 0 1-.5-.5ZM7.246 9.834a.5.5 0 0 1 .5-.5h4.667a.5.5 0 1 1 0 1H7.746a.5.5 0 0 1-.5-.5ZM7.246 12.167a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5ZM18.296 14.311a.5.5 0 0 1 0 .707l-2.351 2.351a.5.5 0 0 1-.707 0l-.982-.982a.5.5 0 0 1 .707-.707l.629.629 1.997-1.998a.5.5 0 0 1 .707 0Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M14.905 10.796c.73-.82 2.012-.82 2.741 0l.751.845c.12.134.279.226.455.262l1.107.228a1.833 1.833 0 0 1 1.37 2.374l-.356 1.073a.832.832 0 0 0 0 .525l.356 1.073a1.833 1.833 0 0 1-1.37 2.373l-1.107.228a.833.833 0 0 0-.455.263l-.75.845c-.73.82-2.012.82-2.741 0l-.752-.845a.833.833 0 0 0-.454-.263l-1.107-.228a1.833 1.833 0 0 1-1.37-2.373l.355-1.073a.833.833 0 0 0 0-.525l-.356-1.073a1.833 1.833 0 0 1 1.37-2.374l1.108-.228a.834.834 0 0 0 .455-.262l.75-.845Zm1.994.664a.833.833 0 0 0-1.246 0l-.751.845a1.832 1.832 0 0 1-1 .578l-1.108.228a.833.833 0 0 0-.623 1.079l.356 1.072c.125.376.125.78 0 1.156l-.356 1.073a.833.833 0 0 0 .623 1.079l1.107.227c.387.08.738.283 1.001.578l.75.845a.833.833 0 0 0 1.247 0l.75-.845a1.834 1.834 0 0 1 1.001-.578l1.108-.227c.488-.101.78-.606.622-1.08l-.356-1.072a1.834 1.834 0 0 1 0-1.155l.356-1.073a.833.833 0 0 0-.622-1.08l-1.108-.227a1.833 1.833 0 0 1-1-.578l-.751-.845Z"
                })
            ]
        })
    });
var $1a6725b68239a721$export$2e2bcd8739ae039 = $1a6725b68239a721$var$SvgCertification;




const $3b277bb06321f9c9$var$SvgCertsActionBtnSelectedBorderDash = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 50,
        height: 50,
        viewBox: "0 0 50 50",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("circle", {
            cx: 25,
            cy: 25,
            r: 24,
            stroke: "#254B86",
            strokeLinecap: "round",
            strokeDasharray: "4 4"
        })
    });
var $3b277bb06321f9c9$export$2e2bcd8739ae039 = $3b277bb06321f9c9$var$SvgCertsActionBtnSelectedBorderDash;




const $1f85fd5a5d0701fd$var$SvgCertsActionBtnSelectedBorderSolid = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 50,
        height: 50,
        viewBox: "0 0 50 50",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("circle", {
            cx: 25,
            cy: 25,
            r: 24,
            stroke: "#254B86",
            strokeLinecap: "round"
        })
    });
var $1f85fd5a5d0701fd$export$2e2bcd8739ae039 = $1f85fd5a5d0701fd$var$SvgCertsActionBtnSelectedBorderSolid;




const $4a947a406f1ef57f$var$SvgCheck = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M20.854 5.465a.5.5 0 0 1 0 .707L8.478 18.536a.5.5 0 0 1-.708-.001l-4.625-4.65a.5.5 0 1 1 .708-.706l4.273 4.295 12.02-12.01a.5.5 0 0 1 .707.001Z",
            fill: "#212328"
        })
    });
var $4a947a406f1ef57f$export$2e2bcd8739ae039 = $4a947a406f1ef57f$var$SvgCheck;




const $c64e1c92bb7f6acd$var$SvgCheckCircle = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10 17.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Zm3.906-9.085a.536.536 0 0 0-.758-.758L8.884 11.92 6.852 9.889a.536.536 0 1 0-.758.758l2.411 2.41c.21.21.549.21.758 0l4.643-4.642Z",
            fill: "#028329"
        })
    });
var $c64e1c92bb7f6acd$export$2e2bcd8739ae039 = $c64e1c92bb7f6acd$var$SvgCheckCircle;




const $918d8242bed88b01$var$SvgCheckCircleFilledSeparateColors = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M26.128 30.56h47.56v41.727h-47.56V30.56Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.5 50c0-20.71 16.79-37.5 37.5-37.5S87.5 29.29 87.5 50 70.71 87.5 50 87.5 12.5 70.71 12.5 50Zm56.244-10.312a2.083 2.083 0 1 0-2.946-2.946L43.7 58.839l-9.499-9.499a2.083 2.083 0 1 0-2.946 2.947l10.972 10.972a2.083 2.083 0 0 0 2.946 0l23.57-23.571Z",
                fill: "#028329"
            })
        ]
    });
var $918d8242bed88b01$export$2e2bcd8739ae039 = $918d8242bed88b01$var$SvgCheckCircleFilledSeparateColors;




const $fc23bee2e28b4704$var$SvgCheckCircleOutline = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 17,
        height: 17,
        viewBox: "0 0 17 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M11.5 6.833a.333.333 0 0 0-.472-.471L7.492 9.897l-1.52-1.52a.333.333 0 0 0-.471.472l1.755 1.755a.333.333 0 0 0 .472 0l3.771-3.771Z",
                fill: "#028329"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.5 2.483a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm-5.333 6a5.333 5.333 0 1 1 10.666 0 5.333 5.333 0 0 1-10.666 0Z",
                fill: "#028329"
            })
        ]
    });
var $fc23bee2e28b4704$export$2e2bcd8739ae039 = $fc23bee2e28b4704$var$SvgCheckCircleOutline;




const $336c130256100a87$var$SvgActive = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M.667 4.222A3.556 3.556 0 0 1 4.222.667h15.556a3.555 3.555 0 0 1 3.555 3.555v15.556a3.555 3.555 0 0 1-3.555 3.555H4.222a3.555 3.555 0 0 1-3.555-3.555V4.222Z",
                fill: "#CFD9E9"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0 4.222A4.222 4.222 0 0 1 4.222 0h15.556A4.222 4.222 0 0 1 24 4.222v15.556A4.222 4.222 0 0 1 19.778 24H4.222A4.222 4.222 0 0 1 0 19.778V4.222Zm4.222-2.889a2.889 2.889 0 0 0-2.889 2.89v15.555a2.889 2.889 0 0 0 2.89 2.889h15.555a2.889 2.889 0 0 0 2.889-2.89V4.223a2.889 2.889 0 0 0-2.89-2.889H4.223Z",
                fill: "#6888B5"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.003 6.207c.26.26.26.683 0 .943L9.35 17.793a.667.667 0 0 1-.944-.001l-3.982-4.003a.667.667 0 1 1 .946-.94l3.51 3.529L19.06 6.207c.261-.26.683-.26.943 0Z",
                fill: "#6888B5"
            })
        ]
    });
var $336c130256100a87$export$2e2bcd8739ae039 = $336c130256100a87$var$SvgActive;




const $34aa03732bc37f62$var$SvgCheckbox = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 2.815A2.815 2.815 0 0 1 2.815 0h10.37A2.815 2.815 0 0 1 16 2.815v10.37A2.815 2.815 0 0 1 13.185 16H2.815A2.815 2.815 0 0 1 0 13.185V2.815ZM2.815.889A1.926 1.926 0 0 0 .889 2.815v10.37c0 1.064.862 1.926 1.926 1.926h10.37a1.926 1.926 0 0 0 1.926-1.926V2.815A1.926 1.926 0 0 0 13.185.889H2.815Z",
            fill: "#6888B5"
        })
    });
var $34aa03732bc37f62$export$2e2bcd8739ae039 = $34aa03732bc37f62$var$SvgCheckbox;




const $f7a3091a389e2644$var$SvgChecked = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.37 0A2.37 2.37 0 0 0 0 2.37v11.26A2.37 2.37 0 0 0 2.37 16h11.26A2.37 2.37 0 0 0 16 13.63V2.37A2.37 2.37 0 0 0 13.63 0H2.37Zm10.822 4.767a.444.444 0 1 0-.628-.63L5.777 10.92l-2.34-2.353a.444.444 0 0 0-.63.626l2.654 2.67a.444.444 0 0 0 .63 0l7.101-7.095Z",
            fill: "#254B86"
        })
    });
var $f7a3091a389e2644$export$2e2bcd8739ae039 = $f7a3091a389e2644$var$SvgChecked;




const $b1e071e5e52d5c69$var$SvgCheckedDisabled = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.37 0A2.37 2.37 0 0 0 0 2.37v11.26A2.37 2.37 0 0 0 2.37 16h11.26A2.37 2.37 0 0 0 16 13.63V2.37A2.37 2.37 0 0 0 13.63 0H2.37Zm10.822 4.767a.444.444 0 1 0-.628-.63L5.777 10.92l-2.34-2.353a.444.444 0 0 0-.63.626l2.654 2.67a.444.444 0 0 0 .63 0l7.101-7.095Z",
            fill: "#9EA1B1"
        })
    });
var $b1e071e5e52d5c69$export$2e2bcd8739ae039 = $b1e071e5e52d5c69$var$SvgCheckedDisabled;




const $fe87d99bfe819562$var$SvgDisabled = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 2.815A2.815 2.815 0 0 1 2.815 0h10.37A2.815 2.815 0 0 1 16 2.815v10.37A2.815 2.815 0 0 1 13.185 16H2.815A2.815 2.815 0 0 1 0 13.185V2.815ZM2.815.889A1.926 1.926 0 0 0 .889 2.815v10.37c0 1.064.862 1.926 1.926 1.926h10.37a1.926 1.926 0 0 0 1.926-1.926V2.815A1.926 1.926 0 0 0 13.185.889H2.815Z",
            fill: "#9EA1B1"
        })
    });
var $fe87d99bfe819562$export$2e2bcd8739ae039 = $fe87d99bfe819562$var$SvgDisabled;




const $3f49496bedc4e748$var$SvgHover = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M2.815.444a2.37 2.37 0 0 0-2.37 2.37v10.371a2.37 2.37 0 0 0 2.37 2.37h10.37a2.37 2.37 0 0 0 2.37-2.37V2.815a2.37 2.37 0 0 0-2.37-2.37H2.815Zm10.377 4.323a.444.444 0 1 0-.628-.63L5.777 10.92l-2.34-2.353a.444.444 0 0 0-.63.626l2.654 2.67a.444.444 0 0 0 .63 0l7.101-7.095Z",
                    fill: "#CFD9E9"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M0 2.815A2.815 2.815 0 0 1 2.815 0h10.37A2.815 2.815 0 0 1 16 2.815v10.37A2.815 2.815 0 0 1 13.185 16H2.815A2.815 2.815 0 0 1 0 13.185V2.815ZM2.815.889A1.926 1.926 0 0 0 .889 2.815v10.37c0 1.064.862 1.926 1.926 1.926h10.37a1.926 1.926 0 0 0 1.926-1.926V2.815A1.926 1.926 0 0 0 13.185.889H2.815Z",
                    fill: "#6888B5"
                })
            ]
        })
    });
var $3f49496bedc4e748$export$2e2bcd8739ae039 = $3f49496bedc4e748$var$SvgHover;




const $594912d6e6084698$var$SvgIndeterminate = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M.444 2.815a2.37 2.37 0 0 1 2.37-2.37h10.371a2.37 2.37 0 0 1 2.37 2.37v10.37a2.37 2.37 0 0 1-2.37 2.37H2.815a2.37 2.37 0 0 1-2.37-2.37V2.815Z",
                fill: "#CFD9E9"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0 2.815A2.815 2.815 0 0 1 2.815 0h10.37A2.815 2.815 0 0 1 16 2.815v10.37A2.815 2.815 0 0 1 13.185 16H2.815A2.815 2.815 0 0 1 0 13.185V2.815ZM2.815.889A1.926 1.926 0 0 0 .889 2.815v10.37c0 1.064.862 1.926 1.926 1.926h10.37a1.926 1.926 0 0 0 1.926-1.926V2.815A1.926 1.926 0 0 0 13.185.889H2.815Z",
                fill: "#254B86"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.815 8c0-.245.199-.444.444-.444h9.482a.444.444 0 1 1 0 .888H3.259A.444.444 0 0 1 2.815 8Z",
                fill: "#254B86"
            })
        ]
    });
var $594912d6e6084698$export$2e2bcd8739ae039 = $594912d6e6084698$var$SvgIndeterminate;




const $4e040a48eda0bd65$var$SvgIndeterminateDisabled = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.37 0A2.37 2.37 0 0 0 0 2.37v11.26A2.37 2.37 0 0 0 2.37 16h11.26A2.37 2.37 0 0 0 16 13.63V2.37A2.37 2.37 0 0 0 13.63 0H2.37Zm.89 7.556a.444.444 0 1 0 0 .888h9.48a.444.444 0 1 0 0-.888H3.26Z",
            fill: "#9EA1B1"
        })
    });
var $4e040a48eda0bd65$export$2e2bcd8739ae039 = $4e040a48eda0bd65$var$SvgIndeterminateDisabled;




const $0159560f7fe5113c$var$SvgChevronDown = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.546 7.397a.5.5 0 0 1 .707 0l8.147 8.146 8.146-8.146a.5.5 0 0 1 .707.707l-8.5 8.5a.5.5 0 0 1-.707 0l-8.5-8.5a.5.5 0 0 1 0-.707Z",
            fill: "#212328"
        })
    });
var $0159560f7fe5113c$export$2e2bcd8739ae039 = $0159560f7fe5113c$var$SvgChevronDown;




const $af71e6ecf34c0a6d$var$SvgChevronDownSmall = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.38 10.147a.5.5 0 0 1 .707 0L12.4 15.46l5.313-5.313a.5.5 0 1 1 .707.707l-5.667 5.666a.5.5 0 0 1-.707 0L6.38 10.854a.5.5 0 0 1 0-.707Z",
            fill: "#212328"
        })
    });
var $af71e6ecf34c0a6d$export$2e2bcd8739ae039 = $af71e6ecf34c0a6d$var$SvgChevronDownSmall;




const $82210661d4ae108c$var$SvgChevronLeft = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.003 3.147a.5.5 0 0 1 0 .707L8.857 12l8.146 8.147a.5.5 0 0 1-.707.707l-8.5-8.5a.5.5 0 0 1 0-.707l8.5-8.5a.5.5 0 0 1 .707 0Z",
            fill: "#212328"
        })
    });
var $82210661d4ae108c$export$2e2bcd8739ae039 = $82210661d4ae108c$var$SvgChevronLeft;




const $cbed1a02b72755fd$var$SvgChevronLeftSmall = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.587 5.98a.5.5 0 0 1 0 .707L10.274 12l5.313 5.313a.5.5 0 0 1-.707.707l-5.667-5.666a.5.5 0 0 1 0-.707L14.88 5.98a.5.5 0 0 1 .707 0Z",
            fill: "#212328"
        })
    });
var $cbed1a02b72755fd$export$2e2bcd8739ae039 = $cbed1a02b72755fd$var$SvgChevronLeftSmall;




const $1ccc698f9e66bcbc$var$SvgChevronRight = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.796 20.854a.5.5 0 0 1 0-.707L15.943 12 7.796 3.854a.5.5 0 0 1 .707-.707l8.5 8.5a.5.5 0 0 1 0 .707l-8.5 8.5a.5.5 0 0 1-.707 0Z",
            fill: "#212328"
        })
    });
var $1ccc698f9e66bcbc$export$2e2bcd8739ae039 = $1ccc698f9e66bcbc$var$SvgChevronRight;




const $99b4ee6f9920220b$var$SvgChevronRightSmall = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.213 18.02a.5.5 0 0 1 0-.707L14.526 12 9.213 6.687a.5.5 0 1 1 .707-.707l5.667 5.667a.5.5 0 0 1 0 .707L9.92 18.02a.5.5 0 0 1-.707 0Z",
            fill: "#212328"
        })
    });
var $99b4ee6f9920220b$export$2e2bcd8739ae039 = $99b4ee6f9920220b$var$SvgChevronRightSmall;




const $2143bf4a3b3ecf78$var$SvgChevronUp = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.253 16.604a.5.5 0 0 1-.707 0L12.4 8.457l-8.147 8.147a.5.5 0 1 1-.707-.707l8.5-8.5a.5.5 0 0 1 .708 0l8.5 8.5a.5.5 0 0 1 0 .707Z",
            fill: "#212328"
        })
    });
var $2143bf4a3b3ecf78$export$2e2bcd8739ae039 = $2143bf4a3b3ecf78$var$SvgChevronUp;




const $afe45638d0386a00$var$SvgChevronUpSmall = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.42 15.854a.5.5 0 0 1-.707 0L12.4 10.54l-5.313 5.313a.5.5 0 1 1-.707-.707l5.667-5.667a.5.5 0 0 1 .707 0l5.666 5.667a.5.5 0 0 1 0 .707Z",
            fill: "#212328"
        })
    });
var $afe45638d0386a00$export$2e2bcd8739ae039 = $afe45638d0386a00$var$SvgChevronUpSmall;




const $915b5ce4ec050c86$var$SvgClose = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.622 2.622a.417.417 0 0 1 .59 0L10 9.411l6.789-6.789a.417.417 0 1 1 .589.59L10.589 10l6.789 6.789a.416.416 0 1 1-.59.59L10 10.588l-6.789 6.79a.417.417 0 0 1-.589-.59L9.411 10 2.622 3.212a.417.417 0 0 1 0-.59Z",
            fill: "#fff"
        })
    });
var $915b5ce4ec050c86$export$2e2bcd8739ae039 = $915b5ce4ec050c86$var$SvgClose;




const $a8621af63e8fde2f$var$SvgClosePanel = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 12,
        height: 12,
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M.098.098c.13-.13.34-.13.471 0L6 5.528l5.431-5.43a.333.333 0 1 1 .471.471L6.472 6l5.43 5.43a.333.333 0 0 1-.471.472L6 6.472l-5.431 5.43a.333.333 0 0 1-.471-.471L5.528 6 .099.569a.333.333 0 0 1 0-.471Z",
            fill: "#212328"
        })
    });
var $a8621af63e8fde2f$export$2e2bcd8739ae039 = $a8621af63e8fde2f$var$SvgClosePanel;




const $5314a1b4bbbbdf58$var$SvgCode = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            d: "M11.39 5.719c.217.077.33.316.252.532L8.865 14.03a.417.417 0 0 1-.785-.28l2.778-7.778a.417.417 0 0 1 .532-.252ZM6.954 6.972c.138.184.1.445-.084.584L3.611 10l3.26 2.444a.417.417 0 0 1-.5.667l-3.704-2.778a.417.417 0 0 1 0-.666L6.37 6.889a.417.417 0 0 1 .584.083ZM13.13 12.444a.417.417 0 0 0 .5.667l3.703-2.778a.416.416 0 0 0 0-.666L13.63 6.889a.417.417 0 1 0-.5.667L16.389 10l-3.26 2.444Z",
            fill: "#212328"
        })
    });
var $5314a1b4bbbbdf58$export$2e2bcd8739ae039 = $5314a1b4bbbbdf58$var$SvgCode;




const $d28fda0e7cb7034f$var$SvgColumns = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.756 4.833c0-1.012-.82-1.833-1.833-1.833H5.59c-1.013 0-1.834.82-1.834 1.833v14.334c0 1.012.821 1.833 1.834 1.833h14.333c1.013 0 1.833-.82 1.833-1.833V4.833ZM19.923 4c.46 0 .833.373.833.833v14.334c0 .46-.373.833-.833.833h-2.417V4h2.417Zm-3.417 0h-3.25v16h3.25V4Zm-7.5 0h3.25v16h-3.25V4Zm-1 0H5.59a.833.833 0 0 0-.834.833v14.334c0 .46.373.833.834.833h2.416V4Z",
            fill: "#212328"
        })
    });
var $d28fda0e7cb7034f$export$2e2bcd8739ae039 = $d28fda0e7cb7034f$var$SvgColumns;




const $109b4f6df784eb5d$var$SvgComment = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 17,
        height: 16,
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M5.013 5.556c0-.184.15-.334.333-.334h6.223a.333.333 0 1 1 0 .667H5.346a.333.333 0 0 1-.333-.333ZM5.346 7.445a.333.333 0 1 0 0 .666h4.445a.333.333 0 1 0 0-.666H5.346Z",
                fill: "#A800E0"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.458 3.778c0-.675.547-1.222 1.222-1.222h9.555c.675 0 1.223.547 1.223 1.222v5.778c0 .675-.548 1.222-1.223 1.222H8.264c-.363 0-.713.137-.98.383l-2.378 2.195a.333.333 0 0 1-.56-.245V10.89a.111.111 0 0 0-.11-.111H3.68a1.222 1.222 0 0 1-1.222-1.222V3.778Zm1.222-.556a.556.556 0 0 0-.556.556v5.778c0 .306.249.555.556.555h.555c.43 0 .778.348.778.778v1.46l1.819-1.678c.39-.36.901-.56 1.432-.56h4.971a.556.556 0 0 0 .556-.555V3.778a.556.556 0 0 0-.556-.556H3.68Z",
                fill: "#A800E0"
            })
        ]
    });
var $109b4f6df784eb5d$export$2e2bcd8739ae039 = $109b4f6df784eb5d$var$SvgComment;




const $7ad453226fbb0b80$var$SvgConfirmManager = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fill: "#212328",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M6.186 6.553a3.553 3.553 0 1 1 7.106 0 3.553 3.553 0 0 1-7.106 0ZM9.739 4a2.553 2.553 0 1 0 0 5.106 2.553 2.553 0 0 0 0-5.106Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M14.352 12.85a8.603 8.603 0 0 0-8.805 0c-.538.32-.867.9-.867 1.525V20.5a.5.5 0 0 1-1 0v-6.125c0-.978.514-1.884 1.355-2.384a9.602 9.602 0 0 1 9.83 0c.84.5 1.354 1.406 1.354 2.384v.146a.5.5 0 1 1-1 0v-.146c0-.626-.329-1.205-.867-1.525ZM20.974 14.71a.5.5 0 0 0-.707-.708l-5.448 5.443-1.815-1.825a.5.5 0 0 0-.71.705l2.17 2.18a.5.5 0 0 0 .708.002l5.802-5.798Z"
                })
            ]
        })
    });
var $7ad453226fbb0b80$export$2e2bcd8739ae039 = $7ad453226fbb0b80$var$SvgConfirmManager;




const $0271f3f7264f0f9c$var$SvgConfirmManagerSph = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 17,
        height: 17,
        viewBox: "0 0 17 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fill: "#028329",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M4.357 4.869a2.369 2.369 0 1 1 4.738 0 2.369 2.369 0 0 1-4.738 0Zm2.369-1.702a1.702 1.702 0 1 0 0 3.403 1.702 1.702 0 0 0 0-3.403Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M9.802 9.066a5.735 5.735 0 0 0-5.87 0c-.36.214-.579.6-.579 1.018v4.083a.333.333 0 0 1-.666 0v-4.083c0-.653.343-1.257.903-1.59a6.402 6.402 0 0 1 6.553 0c.56.333.903.937.903 1.59v.097a.333.333 0 0 1-.666 0v-.097c0-.418-.22-.804-.578-1.018ZM14.216 10.306a.333.333 0 0 0-.471-.472l-3.632 3.63-1.21-1.218a.333.333 0 1 0-.473.47l1.446 1.454a.333.333 0 0 0 .472.001l3.868-3.865Z"
                })
            ]
        })
    });
var $0271f3f7264f0f9c$export$2e2bcd8739ae039 = $0271f3f7264f0f9c$var$SvgConfirmManagerSph;




const $38562215a482ec9d$var$SvgConnectPlug = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M20.854 3.146a.5.5 0 0 1 0 .708l-1.992 1.992a3.838 3.838 0 0 1-.372 5.094l-1.414 1.414a.5.5 0 0 1-.707 0L11.646 7.63a.5.5 0 0 1 0-.707L13.06 5.51a3.84 3.84 0 0 1 5.094-.372l.812-.811 1.18-1.18a.5.5 0 0 1 .708 0Zm-3.962 2.41a2.84 2.84 0 0 0-3.116.653l-.006.006-1.063 1.063 4.015 4.015 1.07-1.069a2.839 2.839 0 0 0-.9-4.668Zm-6.427 5.146a.5.5 0 0 1 0 .707l-1.536 1.535 2.127 2.127 1.535-1.536a.5.5 0 0 1 .707.707l-1.535 1.536.59.59a.5.5 0 0 1 0 .708L10.94 18.49a3.842 3.842 0 0 1-5.094.372l-1.992 1.992a.5.5 0 0 1-.708-.708l1.992-1.992a3.84 3.84 0 0 1 .372-5.094l1.414-1.414a.5.5 0 0 1 .707 0l.591.591 1.536-1.535a.5.5 0 0 1 .707 0Zm-2.597 2.596-.59-.59-1.07 1.068a2.839 2.839 0 1 0 4.016 4.015l.006-.006 1.063-1.063-.59-.59h-.001v-.001l-2.833-2.833Z",
            fill: "#212328"
        })
    });
var $38562215a482ec9d$export$2e2bcd8739ae039 = $38562215a482ec9d$var$SvgConnectPlug;




const $f2874f8966ebea6e$var$SvgConsult = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fill: "#212328",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M3.625 6.167c0-1.013.821-1.834 1.834-1.834h13.224c1.013 0 1.834.821 1.834 1.834v2.247a.5.5 0 0 1-1 0V6.167a.833.833 0 0 0-.834-.834H5.46a.833.833 0 0 0-.834.834v7.927c0 .46.374.834.834.834h1.315a.5.5 0 0 1 .5.5v2.48l2.664-2.824a.5.5 0 0 1 .728.687L7.138 19.51a.5.5 0 0 1-.864-.343v-3.24h-.815a1.833 1.833 0 0 1-1.834-1.833V6.167Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M18.57 10.323a.5.5 0 0 1 .707 0l2.202 2.2a.5.5 0 0 1 0 .708l-2.202 2.2a.5.5 0 0 1-.707-.707l1.348-1.347h-7.244a.5.5 0 0 1 0-1h7.244L18.57 11.03a.5.5 0 0 1 0-.707ZM14.627 19.52a.5.5 0 0 1-.708 0l-2.201-2.2a.503.503 0 0 1-.07-.62.499.499 0 0 1 .07-.088l2.201-2.2a.5.5 0 1 1 .707.706l-1.347 1.348h7.029a.5.5 0 1 1 0 1h-7.03l1.348 1.347a.5.5 0 0 1 0 .707Z"
                })
            ]
        })
    });
var $f2874f8966ebea6e$export$2e2bcd8739ae039 = $f2874f8966ebea6e$var$SvgConsult;




const $bbda25edcfee28f9$var$SvgCopy = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M4.5 3.687c-1.012 0-1.833.821-1.833 1.834v10.47c0 1.012.82 1.833 1.833 1.833h1a.5.5 0 1 0 0-1h-1a.833.833 0 0 1-.833-.834V5.52c0-.46.373-.833.833-.833h8.925c.46 0 .833.373.833.834v.598a.5.5 0 0 0 1 0v-.598c0-1.013-.82-1.834-1.833-1.834H4.5Z",
                fill: "#3751FF"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.137 7.55c-1.013 0-1.834.822-1.834 1.834v10.47c0 1.012.821 1.833 1.834 1.833h8.924c1.012 0 1.833-.82 1.833-1.833V9.384c0-1.012-.82-1.833-1.833-1.833H9.137Zm-.834 1.834c0-.46.373-.833.834-.833h8.924c.46 0 .833.373.833.833v10.47c0 .46-.373.833-.833.833H9.137a.833.833 0 0 1-.834-.833V9.384Z",
                fill: "#3751FF"
            })
        ]
    });
var $bbda25edcfee28f9$export$2e2bcd8739ae039 = $bbda25edcfee28f9$var$SvgCopy;




const $8c432e129efe62f9$var$SvgCritical = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 32,
        height: 32,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M28 16c0 6.627-5.373 12-12 12S4 22.627 4 16 9.373 4 16 4s12 5.373 12 12Zm-13.568-4.249a1.558 1.558 0 1 1 3.092 0l-.752 6.02a.8.8 0 0 1-1.587 0l-.753-6.02ZM15.978 22a1.412 1.412 0 1 0 0-2.824 1.412 1.412 0 0 0 0 2.824Z",
            fill: "#fff"
        })
    });
var $8c432e129efe62f9$export$2e2bcd8739ae039 = $8c432e129efe62f9$var$SvgCritical;




const $cfa4ca8b5b39fed0$var$SvgDashboard = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("g", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            fill: "#212328",
            children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M5.4 3c-.645 0-1.167.522-1.167 1.167v4c0 .644.522 1.166 1.167 1.166h5.333c.644 0 1.167-.522 1.167-1.166v-4C11.9 3.522 11.377 3 10.733 3H5.4Zm-.167 1.167c0-.092.075-.167.167-.167h5.333c.092 0 .167.075.167.167v4a.167.167 0 0 1-.167.166H5.4a.167.167 0 0 1-.167-.166v-4ZM5.4 10.667c-.645 0-1.167.522-1.167 1.166v8c0 .645.522 1.167 1.167 1.167h5.333c.644 0 1.167-.522 1.167-1.167v-8c0-.644-.523-1.166-1.167-1.166H5.4Zm-.167 1.166c0-.092.075-.166.167-.166h5.333c.092 0 .167.074.167.166v8a.167.167 0 0 1-.167.167H5.4a.167.167 0 0 1-.167-.167v-8ZM12.9 4.167c0-.645.522-1.167 1.166-1.167H19.4c.644 0 1.166.522 1.166 1.167v8c0 .644-.522 1.166-1.166 1.166h-5.334a1.167 1.167 0 0 1-1.166-1.166v-8ZM14.066 4a.167.167 0 0 0-.166.167v8c0 .092.074.166.166.166H19.4a.167.167 0 0 0 .166-.166v-8A.167.167 0 0 0 19.4 4h-5.334ZM14.066 14.667c-.644 0-1.166.522-1.166 1.166v4c0 .645.522 1.167 1.166 1.167H19.4c.644 0 1.166-.522 1.166-1.167v-4c0-.644-.522-1.166-1.166-1.166h-5.334Zm-.166 1.166c0-.092.074-.166.166-.166H19.4c.092 0 .166.074.166.166v4A.167.167 0 0 1 19.4 20h-5.334a.167.167 0 0 1-.166-.167v-4Z"
            })
        })
    });
var $cfa4ca8b5b39fed0$export$2e2bcd8739ae039 = $cfa4ca8b5b39fed0$var$SvgDashboard;




const $6b18ef98aaf91f0d$var$SvgDataAnalyze = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fill: "#00245B",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M13.939 7.056a.417.417 0 1 0-.655-.515l-2.775 3.531-2.029-1.91a.417.417 0 0 0-.609.04l-1.805 2.223a.417.417 0 0 0 .646.525l1.523-1.874 2.035 1.915a.417.417 0 0 0 .613-.046l3.056-3.889Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M2.5 4.97c0-.845.684-1.529 1.528-1.529h11.944c.844 0 1.528.684 1.528 1.528v7.548c0 .844-.684 1.528-1.528 1.528H4.028A1.528 1.528 0 0 1 2.5 12.517V4.97Zm1.528-.695a.694.694 0 0 0-.695.694v7.548c0 .384.311.694.695.694h11.944c.384 0 .695-.31.695-.694V4.97a.694.694 0 0 0-.695-.694H4.028Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M6.092 16.142c0-.23.186-.416.416-.416h6.983a.417.417 0 0 1 0 .833H6.508a.417.417 0 0 1-.416-.417Z"
                })
            ]
        })
    });
var $6b18ef98aaf91f0d$export$2e2bcd8739ae039 = $6b18ef98aaf91f0d$var$SvgDataAnalyze;




const $0237db03d2bbbdec$var$SvgDatabase = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.288 3.93C7.774 3.35 9.794 3 12 3c2.205 0 4.225.349 5.711.93.742.29 1.376.649 1.834 1.072.457.423.775.95.775 1.558 0 .075-.005.149-.015.221.01.038.015.078.015.12V17.38c0 .612-.31 1.146-.767 1.579-.455.431-1.088.797-1.829 1.093C16.24 20.645 14.22 21 12 21c-2.22 0-4.24-.355-5.725-.948-.741-.296-1.373-.662-1.828-1.093-.457-.433-.767-.967-.767-1.579V6.9c0-.04.005-.08.014-.119a1.736 1.736 0 0 1-.014-.221c0-.608.317-1.135.775-1.558.457-.423 1.091-.781 1.833-1.071ZM5.134 5.737c-.334.309-.454.587-.454.824 0 .236.12.515.454.824.334.31.845.61 1.518.874 1.344.526 3.234.862 5.348.862 2.113 0 4.003-.336 5.347-.862.673-.263 1.184-.565 1.518-.874.334-.309.455-.588.455-.824 0-.237-.12-.515-.454-.824-.335-.31-.846-.61-1.519-.874C16.003 4.336 14.113 4 12 4c-2.114 0-4.004.336-5.348.862-.673.263-1.184.565-1.518.874ZM4.68 8.31v4.03c0 .168.095.399.43.675.33.273.84.542 1.515.777 1.346.47 3.243.768 5.375.768s4.028-.299 5.374-.768c.676-.235 1.185-.504 1.516-.777.334-.276.43-.507.43-.675V8.31c-.432.34-.982.634-1.609.88-1.486.581-3.506.93-5.711.93-2.206 0-4.226-.349-5.712-.93-.627-.246-1.177-.54-1.608-.88Zm14.64 5.634c-.433.309-.986.573-1.617.793-1.478.514-3.491.823-5.703.823-2.213 0-4.226-.309-5.704-.823-.63-.22-1.184-.484-1.616-.793v3.436c0 .25.124.54.455.853.332.315.84.622 1.511.89C7.986 19.658 9.874 20 12 20c2.125 0 4.014-.342 5.353-.877.671-.268 1.18-.575 1.512-.89.33-.314.455-.602.455-.853v-3.435Z",
            fill: "#212328"
        })
    });
var $0237db03d2bbbdec$export$2e2bcd8739ae039 = $0237db03d2bbbdec$var$SvgDatabase;




const $300e3fe8fdfa5e29$var$SvgDelete = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.16 4.028v.317H4.65a.417.417 0 0 0 0 .834h10.698a.417.417 0 0 0 0-.834h-2.508v-.317c0-.844-.684-1.528-1.528-1.528H8.687c-.844 0-1.528.684-1.528 1.528Zm1.527-.695a.694.694 0 0 0-.694.695v.317h4.014v-.317a.694.694 0 0 0-.694-.695H8.687Z",
                fill: "#00245B"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M11.783 8.723c.23 0 .417.187.417.417v5.052a.417.417 0 1 1-.833 0V9.14c0-.23.186-.417.416-.417ZM8.634 9.14a.417.417 0 1 0-.834 0v5.052a.417.417 0 0 0 .834 0V9.14Z",
                fill: "#00245B"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.27 5.831a.972.972 0 0 0-.966 1.078l1.067 9.725c.054.493.47.866.967.866h7.325a.972.972 0 0 0 .966-.866l1.067-9.725a.972.972 0 0 0-.967-1.078H5.271Zm-.137.988a.139.139 0 0 1 .138-.154h9.458c.083 0 .148.071.139.154L13.8 16.543a.139.139 0 0 1-.138.124H6.338a.139.139 0 0 1-.138-.124L5.133 6.819Z",
                fill: "#00245B"
            })
        ]
    });
var $300e3fe8fdfa5e29$export$2e2bcd8739ae039 = $300e3fe8fdfa5e29$var$SvgDelete;




const $6f334fd7290063d4$var$SvgDocument = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fill: "#00245B",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M5.809 7.64c0-.23.186-.417.417-.417h2.833a.417.417 0 0 1 0 .833H6.226a.417.417 0 0 1-.417-.417ZM6.226 10.056a.417.417 0 0 0 0 .833h6.666a.417.417 0 1 0 0-.833H6.226ZM5.809 13.306c0-.23.186-.417.417-.417h6.666a.417.417 0 1 1 0 .834H6.226a.417.417 0 0 1-.417-.417Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M5.11 2.5c-.845 0-1.529.684-1.529 1.527v11.946c0 .843.684 1.527 1.528 1.527h9.782c.844 0 1.528-.684 1.528-1.527V6.825c0-.412-.167-.807-.463-1.095l-2.878-2.798a1.528 1.528 0 0 0-1.065-.432H5.109Zm-.695 1.527c0-.383.31-.694.694-.694h6.595v2.5c0 .418.228.781.562 1.024.331.242.76.365 1.188.365h2.132v8.75c0 .384-.311.695-.695.695H5.11a.694.694 0 0 1-.694-.694V4.027ZM15.43 6.388a.714.714 0 0 0-.056-.06l-2.838-2.76v2.265c0 .097.053.229.22.35.169.124.419.205.697.205h1.977Z"
                })
            ]
        })
    });
var $6f334fd7290063d4$export$2e2bcd8739ae039 = $6f334fd7290063d4$var$SvgDocument;




const $03bec61bf7e45902$var$SvgDownload = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            d: "M10 2.5c.23 0 .417.187.417.417v10.732l3.604-3.605a.417.417 0 1 1 .589.589l-4.315 4.316a.417.417 0 0 1-.59 0l-4.314-4.316a.417.417 0 1 1 .59-.59l3.603 3.605V2.917c0-.23.186-.417.416-.417ZM3.384 16.667a.417.417 0 1 0 0 .833h13.232a.417.417 0 1 0 0-.833H3.384Z",
            fill: "#D1D7FF"
        })
    });
var $03bec61bf7e45902$export$2e2bcd8739ae039 = $03bec61bf7e45902$var$SvgDownload;




const $821d31fbf4da8455$var$SvgDragHorizontal = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            d: "M4.567 12.834a1.667 1.667 0 1 0 0 3.333 1.667 1.667 0 0 0 0-3.334ZM19.233 12.834a1.667 1.667 0 1 0 0 3.333 1.667 1.667 0 0 0 0-3.334ZM10.233 14.5a1.667 1.667 0 1 1 3.334 0 1.667 1.667 0 0 1-3.334 0ZM19.233 6.833a1.667 1.667 0 1 0 0 3.334 1.667 1.667 0 0 0 0-3.333ZM2.9 8.5a1.667 1.667 0 1 1 3.333 0 1.667 1.667 0 0 1-3.333 0ZM11.9 6.833a1.667 1.667 0 1 0 0 3.334 1.667 1.667 0 0 0 0-3.333Z",
            fill: "#212328"
        })
    });
var $821d31fbf4da8455$export$2e2bcd8739ae039 = $821d31fbf4da8455$var$SvgDragHorizontal;




const $7e0f5b9294fb20eb$var$SvgDragVertical = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            d: "M11.566 4.167a1.667 1.667 0 1 0-3.333 0 1.667 1.667 0 0 0 3.333 0ZM11.566 18.833a1.667 1.667 0 1 0-3.333 0 1.667 1.667 0 0 0 3.333 0ZM9.9 9.833a1.667 1.667 0 1 1 0 3.334 1.667 1.667 0 0 1 0-3.334ZM17.567 18.833a1.667 1.667 0 1 0-3.334 0 1.667 1.667 0 0 0 3.334 0ZM15.9 2.5a1.667 1.667 0 1 1 0 3.333 1.667 1.667 0 0 1 0-3.333ZM17.567 11.5a1.667 1.667 0 1 0-3.334 0 1.667 1.667 0 0 0 3.334 0Z",
            fill: "#212328"
        })
    });
var $7e0f5b9294fb20eb$export$2e2bcd8739ae039 = $7e0f5b9294fb20eb$var$SvgDragVertical;




const $bdf5e65e09a9852d$var$SvgDynamicAttributes = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fill: "#00245B",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3 4.833C3 3.821 3.82 3 4.833 3H9.5c1.012 0 1.833.82 1.833 1.833V9.5c0 1.012-.82 1.833-1.833 1.833H4.833A1.833 1.833 0 0 1 3 9.5V4.833ZM4.833 4A.833.833 0 0 0 4 4.833V9.5c0 .46.373.833.833.833H9.5c.46 0 .833-.373.833-.833V4.833A.833.833 0 0 0 9.5 4H4.833ZM3 14.5c0-1.012.82-1.833 1.833-1.833H9.5c1.012 0 1.833.82 1.833 1.833v4.667c0 1.012-.82 1.833-1.833 1.833H4.833A1.833 1.833 0 0 1 3 19.167V14.5Zm1.833-.833A.833.833 0 0 0 4 14.5v4.667c0 .46.373.833.833.833H9.5c.46 0 .833-.373.833-.833V14.5a.833.833 0 0 0-.833-.833H4.833ZM14.5 3c-1.012 0-1.833.82-1.833 1.833V9.5c0 1.012.82 1.833 1.833 1.833h4.667c1.012 0 1.833-.82 1.833-1.833V4.833C21 3.821 20.18 3 19.167 3H14.5Zm-.833 1.833c0-.46.373-.833.833-.833h4.667c.46 0 .833.373.833.833V9.5c0 .46-.373.833-.833.833H14.5a.833.833 0 0 1-.833-.833V4.833Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M16.833 18.056a1.222 1.222 0 1 0 0-2.445 1.222 1.222 0 0 0 0 2.445Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M15.556 12.964a.5.5 0 0 1 .457-.297h1.463a.5.5 0 0 1 .445.272l.365.713.502.264.833-.086a.5.5 0 0 1 .474.23l.77 1.217a.5.5 0 0 1-.011.551l-.467.678v.502l.505.639a.5.5 0 0 1 .043.556l-.707 1.248a.5.5 0 0 1-.435.253h-.867l-.492.258-.328.74a.5.5 0 0 1-.458.298H16.19a.5.5 0 0 1-.444-.27l-.354-.685-.517-.216h-.895a.5.5 0 0 1-.423-.234l-.755-1.2a.5.5 0 0 1 .005-.539l.446-.685v-.522l-.485-.64a.5.5 0 0 1-.036-.549l.709-1.251a.5.5 0 0 1 .464-.253l.836.05.479-.283.336-.759Zm.783.703-.27.607a.5.5 0 0 1-.202.229l-.75.442a.5.5 0 0 1-.284.068l-.676-.04-.393.694.388.512a.5.5 0 0 1 .101.302v.839a.5.5 0 0 1-.081.273l-.353.54.437.696h.72a.5.5 0 0 1 .193.038l.777.326a.5.5 0 0 1 .251.231l.298.576h.828l.267-.603a.5.5 0 0 1 .225-.24l.756-.396a.5.5 0 0 1 .232-.057h.699l.397-.7-.404-.512a.5.5 0 0 1-.108-.31v-.832a.5.5 0 0 1 .088-.283l.368-.534-.427-.676-.676.07a.5.5 0 0 1-.285-.056l-.775-.409a.5.5 0 0 1-.212-.214l-.298-.581h-.832Z"
                })
            ]
        })
    });
var $bdf5e65e09a9852d$export$2e2bcd8739ae039 = $bdf5e65e09a9852d$var$SvgDynamicAttributes;




const $83a8fb1b47dcf057$var$SvgEdit = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fill: "#212328",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M20.648 3.718a2.533 2.533 0 0 0-1.326-.687c-.484-.083-1.05-.011-1.46.4L3.936 17.354a.5.5 0 0 0-.142.29l-.365 2.79a.5.5 0 0 0 .57.56l2.739-.419a.5.5 0 0 0 .278-.14L20.942 6.51c.411-.411.482-.98.398-1.464a2.532 2.532 0 0 0-.692-1.328Zm-2.079.42c.105-.106.297-.17.583-.121.284.048.581.2.79.41.21.207.363.505.412.79.05.289-.015.482-.12.586l-1.631 1.632-1.666-1.665 1.632-1.632ZM16.23 6.476l1.666 1.665-11.471 11.47-1.919.293.258-1.963L16.23 6.477Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M9.849 19.783a.5.5 0 1 0 0 1h11.023a.5.5 0 1 0 0-1H9.849Z"
                })
            ]
        })
    });
var $83a8fb1b47dcf057$export$2e2bcd8739ae039 = $83a8fb1b47dcf057$var$SvgEdit;




const $417e3d5615629032$var$SvgEntitlement = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 21,
        height: 21,
        viewBox: "0 0 21 21",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M3.833 2.642a.417.417 0 0 0-.416.416v11.39c0 1.15.932 2.082 2.083 2.082h5.649a.417.417 0 1 0 0-.833H5.5c-.69 0-1.25-.56-1.25-1.25V3.475h9.028c.69 0 1.25.56 1.25 1.25v2.134a.417.417 0 1 0 .833 0V4.725c0-1.15-.933-2.083-2.083-2.083H3.833Z",
                fill: "#00245B"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M6.464 5.558a.417.417 0 1 0 0 .834h4.445a.417.417 0 1 0 0-.834H6.464ZM6.048 7.92c0-.23.186-.417.416-.417h4.445a.417.417 0 1 1 0 .833H6.464a.417.417 0 0 1-.416-.417ZM6.464 9.447a.417.417 0 1 0 0 .834h2.223a.417.417 0 0 0 0-.834H6.464Z",
                fill: "#00245B"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.75 10.836a2.917 2.917 0 1 1 5.037 2.003v4.386a.417.417 0 0 1-.708.298l-1.412-1.382-1.413 1.382a.417.417 0 0 1-.708-.298v-4.386a2.907 2.907 0 0 1-.796-2.003Zm2.917-2.083a2.083 2.083 0 1 0 0 4.166 2.083 2.083 0 0 0 0-4.166Zm-1.287 4.701v2.78l.995-.974a.417.417 0 0 1 .583 0l.996.974v-2.78a2.905 2.905 0 0 1-1.287.299c-.462 0-.9-.108-1.287-.299Z",
                fill: "#00245B"
            })
        ]
    });
var $417e3d5615629032$export$2e2bcd8739ae039 = $417e3d5615629032$var$SvgEntitlement;




const $e6558a9fb8c5ebf2$var$SvgErrorSign = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 120,
        height: 120,
        viewBox: "0 0 120 120",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "m75.515 9.113-1.705 6.364a1.5 1.5 0 0 1-2.898-.777l1.835-6.846a2.5 2.5 0 0 1 3.062-1.768l4.302 1.153a2.5 2.5 0 0 1 1.767 3.061l-1.834 6.847a1.5 1.5 0 1 1-2.898-.776l1.705-6.364-3.336-.894ZM61.985 53.814a1.5 1.5 0 0 1 1.06 1.837l-13.087 48.842h3.574L66.38 56.545a1.5 1.5 0 1 1 2.897.776l-10.565 39.43h5.685l-.367-2.204a1.5 1.5 0 0 1 2.96-.493l.449 2.697h2.286l-.55-8.809a1.5 1.5 0 1 1 2.993-.187l.563 8.996h2.08l-.47-4.22a1.5 1.5 0 1 1 2.982-.332l.619 5.566a1.5 1.5 0 0 1-1.42 1.985H57.908l-1.27 4.743h2.006a1.5 1.5 0 1 1 0 3H22.275a1.5 1.5 0 0 1 0-3h24.578l1.27-4.742h-10.92c-.427 0-.811-.178-1.084-.464a1.496 1.496 0 0 1-.498-1.116V90.43a1.5 1.5 0 0 1 3 0v6.322h3.116l.38-1.524a1.5 1.5 0 1 1 2.911.728l-.199.796h4.098l11.22-41.876a1.5 1.5 0 0 1 1.838-1.061ZM66.912 47.895a1.936 1.936 0 1 0 1.001-3.74 1.936 1.936 0 0 0-1.001 3.74ZM69.365 30.84 67.64 41.08a1.064 1.064 0 0 0 2.047.55l3.627-9.731a2.053 2.053 0 1 0-3.95-1.058Z",
                fill: "#00245B"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M72.424 19.081c1.354-1.288 3.592-.689 4.12 1.104l10.232 34.697c.552 1.873-1.16 3.628-3.045 3.122l-36.44-9.764c-1.887-.505-2.491-2.88-1.077-4.226l26.21-24.933Zm1.474 2.738-24.97 23.754 34.718 9.303-9.748-33.057Z",
                fill: "#00245B"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M33.069 92.04a1.5 1.5 0 0 0-2.929.65l.903 4.06H5.5a1.5 1.5 0 1 0 0 3h27.283c.346 0 .664-.116.918-.313a1.5 1.5 0 0 0 .658-1.59l-1.29-5.807ZM83.423 98.25c0-.053.003-.106.008-.158.011-.2.062-.4.157-.591l1.29-2.581a1.5 1.5 0 0 1 2.684 1.342l-.245.489H114.5a1.5 1.5 0 0 1 0 3H84.923a1.5 1.5 0 0 1-1.5-1.5ZM61.802 105.993a1.5 1.5 0 0 1 1.5-1.5h2.846a1.5 1.5 0 1 1 0 3h-2.846a1.5 1.5 0 0 1-1.5-1.5ZM91.352 100.287a1.5 1.5 0 0 1 1.256 1.709l-.381 2.497h15.379a1.5 1.5 0 1 1 0 3H90.48a1.5 1.5 0 0 1-1.483-1.727l.645-4.223a1.5 1.5 0 0 1 1.71-1.256ZM86.391 102.893a1.5 1.5 0 1 0-2.639 1.427l.094.173h-7.209a1.5 1.5 0 1 0 0 3h9.725a1.5 1.5 0 0 0 1.32-2.214l-1.29-2.386ZM41.152 110.364a1.5 1.5 0 0 0 0 3h41.292a1.5 1.5 0 0 0 0-3H41.152ZM80.704 88.93a1.5 1.5 0 0 1 1.5 1.5v7.741a1.5 1.5 0 0 1-3 0V90.43a1.5 1.5 0 0 1 1.5-1.5Z",
                fill: "#00245B"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M77.219 17.67c-.53-1.792-2.767-2.392-4.121-1.104L43.563 44.663c-1.414 1.345-.81 3.72 1.076 4.226l41.064 11.003c1.886.505 3.597-1.25 3.045-3.122l-11.53-39.1Zm-6.19-3.277c2.98-2.835 7.904-1.516 9.067 2.43l11.53 39.099c1.214 4.12-2.55 7.98-6.7 6.868L43.864 51.787c-4.149-1.112-5.48-6.337-2.368-9.298L71.03 14.393Z",
                fill: "#FF6F26"
            })
        ]
    });
var $e6558a9fb8c5ebf2$export$2e2bcd8739ae039 = $e6558a9fb8c5ebf2$var$SvgErrorSign;




const $14a898c4ab907c2b$var$SvgExpandLeft = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fill: "#212328",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M13.417 3.857a.5.5 0 0 0-.7-.714l-8.667 8.5a.5.5 0 0 0 0 .714l8.666 8.5a.5.5 0 1 0 .7-.714L5.115 12l8.303-8.143Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M20.75 3.857a.5.5 0 1 0-.7-.714l-8.667 8.5a.5.5 0 0 0 0 .714l8.667 8.5a.5.5 0 0 0 .7-.714L12.447 12l8.303-8.143Z"
                })
            ]
        })
    });
var $14a898c4ab907c2b$export$2e2bcd8739ae039 = $14a898c4ab907c2b$var$SvgExpandLeft;




const $af743c27f0b4a786$var$SvgExpandRight = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fill: "#212328",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M11.383 20.143a.5.5 0 0 0 .7.714l8.667-8.5a.5.5 0 0 0 0-.714l-8.667-8.5a.5.5 0 1 0-.7.714L19.686 12l-8.303 8.143Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M4.05 20.143a.5.5 0 0 0 .7.714l8.667-8.5a.5.5 0 0 0 0-.714l-8.667-8.5a.5.5 0 0 0-.7.714L12.352 12 4.05 20.143Z"
                })
            ]
        })
    });
var $af743c27f0b4a786$export$2e2bcd8739ae039 = $af743c27f0b4a786$var$SvgExpandRight;




const $5b3e65fb8470283b$var$SvgExport = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M12.754 3.147a.5.5 0 0 0-.728.02L8.12 7.075a.5.5 0 1 0 .707.707L11.9 4.709V16.5a.5.5 0 1 0 1 0V4.707l3.073 3.074a.5.5 0 0 0 .707-.707l-3.925-3.927Z",
                fill: "#212328"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M4.4 19.167V16.5a.5.5 0 0 0-1 0v2.666C3.4 20.179 4.22 21 5.233 21h14.334c1.012 0 1.833-.82 1.833-1.833V16.5a.5.5 0 0 0-1 0v2.666c0 .46-.373.833-.833.833H5.233a.833.833 0 0 1-.833-.833Z",
                fill: "#212328"
            })
        ]
    });
var $5b3e65fb8470283b$export$2e2bcd8739ae039 = $5b3e65fb8470283b$var$SvgExport;




const $62ab143e79aefec0$var$SvgExtendEndDate = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            fill: "#212328",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M8.604 4.465a.5.5 0 0 1 .5.5v1.013h4.794V4.965a.5.5 0 0 1 1 0v1.013h2.311c1.013 0 1.834.82 1.834 1.833V12.1a.5.5 0 1 1-1 0v-1.2H4.46a.499.499 0 0 1-.06-.003V17.7c0 .46.373.834.833.834h9.104a.5.5 0 0 1 0 1H5.233A1.833 1.833 0 0 1 3.4 17.7v-9.89c0-1.012.82-1.833 1.833-1.833h2.871V4.965a.5.5 0 0 1 .5-.5Zm9.439 3.346v2.09H4.46c-.02 0-.04 0-.06.003V7.811c0-.46.373-.833.833-.833h2.871V7.99a.5.5 0 0 0 1 0V6.978h4.794V7.99a.5.5 0 0 0 1 0V6.978h2.311c.46 0 .834.373.834.833Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M12.523 14.366a.43.43 0 0 0 0-.661.582.582 0 0 0-.75 0l-1.555 1.371a.442.442 0 0 0-.155.331c0 .124.055.243.155.331l1.555 1.372a.582.582 0 0 0 .75 0 .43.43 0 0 0 0-.662l-.525-.463h7.617l-.44.44a.5.5 0 1 0 .707.707l1.371-1.371a.5.5 0 0 0 0-.707l-1.371-1.372a.5.5 0 1 0-.707.707l.595.596h-7.948l.7-.619Zm-1.157 1.02-.023.021.023.02v-.04Z"
                })
            ]
        })
    });
var $62ab143e79aefec0$export$2e2bcd8739ae039 = $62ab143e79aefec0$var$SvgExtendEndDate;




const $c31557939fdca4de$var$SvgFeature = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 32,
        height: 33,
        viewBox: "0 0 32 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fill: "#212328",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12.667 11.254a2.889 2.889 0 1 0 0 5.778 2.889 2.889 0 0 0 0-5.778Zm-1.555 2.889a1.556 1.556 0 1 1 3.11 0 1.556 1.556 0 0 1-3.11 0Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M20.157 22.124a1.555 1.555 0 1 0 1.556-2.694 1.555 1.555 0 0 0-1.556 2.694Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10.878 5.476a.667.667 0 0 0-.61.397l-.788 1.78-1.274.753-1.952-.118a.667.667 0 0 0-.62.337l-1.546 2.732a.667.667 0 0 0 .048.73l1.144 1.511v1.408l-1.042 1.6a.667.667 0 0 0-.006.719l1.646 2.617a.667.667 0 0 0 .564.312h2.039l1.348.564.843 1.63c.114.222.343.361.592.361h3.181a.665.665 0 0 0 .17-.022l1.024.591.638.838-.064 1.372a.666.666 0 0 0 .332.609l2.143 1.237a.666.666 0 0 0 .727-.039l1.161-.847 1.05.043 1.314.759c.208.12.464.119.671-.003l2.097-1.233a.667.667 0 0 0 .322-.672l-.21-1.43.485-.841 1.313-.624a.667.667 0 0 0 .38-.63l-.099-2.44a.667.667 0 0 0-.393-.582l-1.348-.603-.573-.91.07-1.416a.667.667 0 0 0-.332-.61l-2.15-1.241a.666.666 0 0 0-.725.039l-1.185.864-1.058.01-.21-.138v-1.594l1.094-1.586a.667.667 0 0 0 .015-.735L19.425 8.32a.667.667 0 0 0-.632-.307l-1.946.2-1.327-.7-.858-1.674a.667.667 0 0 0-.594-.363h-3.19Zm2.99 14.17.07 1.83H11.67l-.768-1.485a.667.667 0 0 0-.334-.31l-1.696-.709a.667.667 0 0 0-.258-.052H6.811l-1.223-1.944.917-1.408a.667.667 0 0 0 .108-.364v-1.83a.667.667 0 0 0-.135-.402l-1.014-1.34 1.125-1.988 1.74.105a.667.667 0 0 0 .38-.092l1.633-.965a.667.667 0 0 0 .27-.304l.7-1.578h2.35l.768 1.5a.667.667 0 0 0 .282.285l1.692.892a.667.667 0 0 0 .38.074l1.735-.18 1.222 1.934-.961 1.396a.667.667 0 0 0-.118.378v1.019a.666.666 0 0 0-.394.09l-2.104 1.237a.667.667 0 0 0-.323.658l.177 1.413-.5.867-1.286.652a.667.667 0 0 0-.364.62Zm9.015-4.16-1.007.735a.667.667 0 0 1-.386.128l-1.476.015a.666.666 0 0 1-.374-.11l-1.054-.697-1.368.805.15 1.2a.667.667 0 0 1-.084.417l-.711 1.232a.667.667 0 0 1-.276.261l-1.08.55.06 1.608 1.144.66a.667.667 0 0 1 .197.174l.867 1.137a.667.667 0 0 1 .135.435l-.056 1.21 1.415.817 1-.73a.667.667 0 0 1 .42-.127l1.446.06a.666.666 0 0 1 .306.089l1.12.646 1.374-.809-.178-1.215a.666.666 0 0 1 .082-.43l.706-1.223a.666.666 0 0 1 .29-.268l1.102-.524-.063-1.589-1.155-.517a.667.667 0 0 1-.292-.253l-.793-1.259a.667.667 0 0 1-.101-.388l.06-1.22-1.42-.82Z"
                })
            ]
        })
    });
var $c31557939fdca4de$export$2e2bcd8739ae039 = $c31557939fdca4de$var$SvgFeature;




const $261f26890a2fa4a2$var$SvgFilter = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fill: "#212328",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M7.9 7.334a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5ZM10.4 9.5a.5.5 0 0 0 0 1h4a.5.5 0 1 0 0-1h-4Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3.4 4.107C3.4 3.496 3.896 3 4.507 3h15.786c.611 0 1.107.496 1.107 1.107v4.436a4.75 4.75 0 0 1-1.594 3.55l-3.59 3.191a.833.833 0 0 0-.28.623v2.772c0 .508-.346.95-.839 1.074l-4.857 1.214a1.107 1.107 0 0 1-1.376-1.074v-3.986a.833.833 0 0 0-.28-.623l-3.59-3.19A4.75 4.75 0 0 1 3.4 8.542V4.107ZM4.507 4a.107.107 0 0 0-.107.107v4.436a3.75 3.75 0 0 0 1.259 2.803l3.59 3.191c.391.348.615.847.615 1.37v3.986a.107.107 0 0 0 .133.104l4.857-1.214a.107.107 0 0 0 .082-.104v-2.772c0-.523.224-1.022.615-1.37l3.59-3.191A3.75 3.75 0 0 0 20.4 8.543V4.107A.107.107 0 0 0 20.293 4H4.507Z"
                })
            ]
        })
    });
var $261f26890a2fa4a2$export$2e2bcd8739ae039 = $261f26890a2fa4a2$var$SvgFilter;




const $dfb30efc4b2b0b32$var$SvgFix = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 24,
        height: 25,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("g", {
            fill: "#fff",
            children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M3.5 7.047a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1h-11ZM3.5 12.38a.5.5 0 0 0 0 1h15.793l-1.813 1.814a.5.5 0 1 0 .707.707l2.661-2.661a.498.498 0 0 0 .006-.713L18.187 9.86a.5.5 0 1 0-.707.708l1.813 1.813H3.5ZM3 18.214a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5Z"
            })
        })
    });
var $dfb30efc4b2b0b32$export$2e2bcd8739ae039 = $dfb30efc4b2b0b32$var$SvgFix;




const $4fcbbe88afaa1e49$var$SvgFrontIcon = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            d: "M4.947 8.252a8 8 0 1 1-.707 7.071.5.5 0 0 0-.936.353 9 9 0 1 0 .969-8.22V4.42a.5.5 0 0 0-1.001 0v4.333a.5.5 0 0 0 .5.5h4.333a.5.5 0 0 0 0-1H4.947Z",
            fill: "#fff"
        })
    });
var $4fcbbe88afaa1e49$export$2e2bcd8739ae039 = $4fcbbe88afaa1e49$var$SvgFrontIcon;




const $4ab03624f3f8f271$var$SvgGrid = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            d: "M14.684 18.711a1.346 1.346 0 0 1-1.34-1.344v-2.685a1.341 1.341 0 0 1 .392-.948 1.338 1.338 0 0 1 .947-.388h2.68a1.34 1.34 0 0 1 1.346 1.336v2.685a1.343 1.343 0 0 1-1.346 1.344h-2.68Zm-8.05 0a1.349 1.349 0 0 1-1.345-1.344v-2.685a1.343 1.343 0 0 1 .832-1.237c.163-.066.338-.1.514-.1h2.683a1.332 1.332 0 0 1 1.336 1.337v2.685a1.338 1.338 0 0 1-1.336 1.344H6.635Zm8.05-8.053a1.331 1.331 0 0 1-.948-.392 1.333 1.333 0 0 1-.392-.948V6.637a1.347 1.347 0 0 1 .826-1.242 1.34 1.34 0 0 1 .514-.104h2.68a1.347 1.347 0 0 1 1.345 1.346v2.681a1.342 1.342 0 0 1-1.346 1.34h-2.68Zm-8.05 0a1.341 1.341 0 0 1-1.241-.826 1.343 1.343 0 0 1-.104-.514V6.637A1.35 1.35 0 0 1 6.635 5.29h2.683a1.341 1.341 0 0 1 1.336 1.346v2.681a1.328 1.328 0 0 1-.388.948 1.336 1.336 0 0 1-.948.392H6.635Z",
            fill: "#676B80"
        })
    });
var $4ab03624f3f8f271$export$2e2bcd8739ae039 = $4ab03624f3f8f271$var$SvgGrid;




const $789401285deb3b51$var$SvgHalfBracket = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 8,
        height: 19,
        viewBox: "0 0 8 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            d: "M1 .5v14a4 4 0 0 0 4 4h2",
            stroke: "#CFD9E9",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
var $789401285deb3b51$export$2e2bcd8739ae039 = $789401285deb3b51$var$SvgHalfBracket;




const $aa99e4f582565a31$var$SvgHamburger = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6 8h12a1 1 0 1 0 0-2H6a1 1 0 0 0 0 2Zm12 5H6a1 1 0 0 1 0-2h12a1 1 0 0 1 0 2Zm0 5H6a1 1 0 0 1 0-2h12a1 1 0 0 1 0 2Z",
            fill: "#141419"
        })
    });
var $aa99e4f582565a31$export$2e2bcd8739ae039 = $aa99e4f582565a31$var$SvgHamburger;




const $af76b8a5e920ac23$var$SvgHappy = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fill: "#212328",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M9.756 13.4a.5.5 0 1 0-.8.6l.4-.3-.4.3.001.002.002.002.005.006.015.02.053.064a5.555 5.555 0 0 0 .933.86c.64.465 1.591.946 2.791.946s2.152-.48 2.791-.946a5.556 5.556 0 0 0 .933-.86l.053-.065.016-.02.005-.005.001-.002.001-.002a.5.5 0 0 0-.8-.6l-.007.009a3.513 3.513 0 0 1-.187.211c-.136.142-.34.334-.603.525-.53.385-1.278.755-2.203.755-.924 0-1.673-.37-2.203-.755a4.562 4.562 0 0 1-.755-.694 1.877 1.877 0 0 1-.035-.042l-.007-.01ZM10.69 9.45a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0ZM15.49 10.117a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12.756 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm-8 9a8 8 0 1 1 16 0 8 8 0 0 1-16 0Z"
                })
            ]
        })
    });
var $af76b8a5e920ac23$export$2e2bcd8739ae039 = $af76b8a5e920ac23$var$SvgHappy;




const $ef65bd9583c4838e$var$SvgHelp = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M20 15.833c-1.005 0-1.752.746-1.752 1.585a.5.5 0 1 1-1 0c0-1.463 1.269-2.585 2.752-2.585 1.483 0 2.752 1.122 2.752 2.585 0 .762-.35 1.44-.892 1.906l-.02.018c-.352.302-.689.593-.946.91-.259.32-.394.617-.394.918v.566a.5.5 0 1 1-1 0v-.566c0-.62.283-1.135.617-1.547.315-.39.713-.732 1.044-1.017l.046-.04c.343-.294.545-.703.545-1.148 0-.84-.747-1.585-1.752-1.585ZM20 24.667a.75.75 0 1 0 0-1.502.75.75 0 0 0 0 1.502Z",
                fill: "#212328"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11 20a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm9-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z",
                fill: "#212328"
            })
        ]
    });
var $ef65bd9583c4838e$export$2e2bcd8739ae039 = $ef65bd9583c4838e$var$SvgHelp;




const $54fd901d89cc9583$var$SvgHelpFilled = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.4 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm0 4.833c-1.005 0-1.752.746-1.752 1.585a.5.5 0 0 1-1 0c0-1.463 1.269-2.585 2.752-2.585 1.483 0 2.752 1.122 2.752 2.585 0 .762-.35 1.44-.892 1.906l-.021.018c-.35.302-.688.593-.945.91-.26.32-.394.617-.394.918v.566a.5.5 0 1 1-1 0v-.566c0-.62.283-1.134.616-1.547.316-.39.714-.732 1.045-1.016l.046-.04c.342-.295.545-.704.545-1.149 0-.84-.747-1.585-1.752-1.585Zm.75 8.083a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z",
            fill: "#212328"
        })
    });
var $54fd901d89cc9583$export$2e2bcd8739ae039 = $54fd901d89cc9583$var$SvgHelpFilled;




const $6be417bed896989b$var$SvgHelpFilledSeparateColors = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.5 50c0-20.71 16.79-37.5 37.5-37.5S87.5 29.29 87.5 50 70.71 87.5 50 87.5 12.5 70.71 12.5 50Z",
                fill: "#573BDC"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("g", {
                fill: "#fff",
                children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M42.698 39.243c0-3.499 3.115-6.604 7.302-6.604 4.187 0 7.301 3.105 7.301 6.604 0 1.852-.845 3.557-2.27 4.785l-.194.166c-1.378 1.186-3.038 2.613-4.352 4.237-1.39 1.717-2.569 3.862-2.569 6.445v2.356a2.083 2.083 0 0 0 4.167 0v-2.356c0-1.253.563-2.491 1.641-3.824 1.072-1.325 2.478-2.535 3.939-3.792l.086-.075c2.26-1.945 3.72-4.768 3.72-7.942 0-6.097-5.29-10.77-11.47-10.77-6.179 0-11.468 4.673-11.468 10.77a2.083 2.083 0 1 0 4.167 0ZM50 69.444a3.128 3.128 0 1 0 0-6.256 3.128 3.128 0 0 0 0 6.256Z"
                })
            })
        ]
    });
var $6be417bed896989b$export$2e2bcd8739ae039 = $6be417bed896989b$var$SvgHelpFilledSeparateColors;




const $6b36533dbbb6d300$var$SvgHelpOutlined = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fill: "#212328",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M12 7.833c-1.005 0-1.752.746-1.752 1.585a.5.5 0 1 1-1 0c0-1.463 1.269-2.585 2.752-2.585 1.483 0 2.752 1.122 2.752 2.585 0 .762-.35 1.44-.892 1.906l-.02.018c-.351.302-.689.593-.946.91-.259.32-.394.617-.394.918v.566a.5.5 0 1 1-1 0v-.566c0-.62.283-1.134.617-1.547.315-.39.713-.732 1.044-1.016l.046-.04c.343-.295.545-.704.545-1.149 0-.84-.747-1.585-1.752-1.585ZM12 16.667a.75.75 0 1 0 0-1.502.75.75 0 0 0 0 1.502Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm9-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z"
                })
            ]
        })
    });
var $6b36533dbbb6d300$export$2e2bcd8739ae039 = $6b36533dbbb6d300$var$SvgHelpOutlined;




const $c2dc3ad1adf0f9ac$var$SvgHierarchy = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 21,
        height: 20,
        viewBox: "0 0 21 20",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.917 9.83a2.64 2.64 0 1 0-.833 0v2.393c0 .23.186.416.416.416h2.394a2.641 2.641 0 0 0 2.19 2.19v2.394a.417.417 0 0 0 .833 0v-2.394a2.64 2.64 0 1 0-3.023-3.023H5.917V9.83ZM3.695 7.222a1.806 1.806 0 1 1 3.61 0 1.806 1.806 0 0 1-3.61 0Zm6.805 6.805a1.806 1.806 0 1 0 0-3.61 1.806 1.806 0 0 0 0 3.61Z",
            fill: "#212328"
        })
    });
var $c2dc3ad1adf0f9ac$export$2e2bcd8739ae039 = $c2dc3ad1adf0f9ac$var$SvgHierarchy;




const $95e98f86650c84cc$var$SvgImageOutline = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.025 8.636a.972.972 0 0 1 1.375 0l1.895 1.895a.416.416 0 0 1 .122.294v3.205c0 .23-.187.416-.417.416H5a.417.417 0 0 1-.417-.416v-1.428c0-.11.044-.216.122-.295l2.436-2.436a.972.972 0 0 1 1.375 0l1.137 1.137 2.372-2.372Zm-2.961 2.961-1.137-1.136a.139.139 0 0 0-.196 0l-2.314 2.314v.838h1.63l2.017-2.016Zm-.838 2.016h6.357v-2.615l-1.772-1.773a.139.139 0 0 0-.197 0l-4.388 4.388ZM6.29 5.62a1.667 1.667 0 1 0 0 3.334 1.667 1.667 0 0 0 0-3.333Zm-.834 1.668a.833.833 0 1 1 1.667 0 .833.833 0 0 1-1.667 0Z",
                fill: "#212328"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.5 5.139c0-.844.684-1.528 1.528-1.528h11.944c.844 0 1.528.684 1.528 1.528v9.722c0 .844-.684 1.528-1.528 1.528H4.028A1.528 1.528 0 0 1 2.5 14.86V5.14Zm1.528-.695a.694.694 0 0 0-.695.695v9.722c0 .384.311.694.695.694h11.944c.384 0 .695-.31.695-.694V5.14a.694.694 0 0 0-.695-.695H4.028Z",
                fill: "#212328"
            })
        ]
    });
var $95e98f86650c84cc$export$2e2bcd8739ae039 = $95e98f86650c84cc$var$SvgImageOutline;




const $5cad89942a71095f$var$SvgInfo = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 32,
        height: 32,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16 4C9.373 4 4 9.373 4 16s5.373 12 12 12 12-5.373 12-12S22.627 4 16 4Zm1.598 6.556a1.222 1.222 0 1 1-2.444 0 1.222 1.222 0 0 1 2.444 0Zm-.199 3.488a.666.666 0 0 1 .16.648l-1.881 6.51 1.6-.877a.667.667 0 0 1 .641 1.168l-2.068 1.136c-.867.476-1.877-.333-1.602-1.283l1.708-5.912-1.204.3a.667.667 0 0 1-.322-1.293l2.327-.581a.667.667 0 0 1 .641.184Z",
            fill: "#573BDC"
        })
    });
var $5cad89942a71095f$export$2e2bcd8739ae039 = $5cad89942a71095f$var$SvgInfo;




const $f29db2785159f53e$var$SvgInfoOutline = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M13.599 7.917a.917.917 0 1 1-1.834 0 .917.917 0 0 1 1.834 0ZM13.45 10.533a.5.5 0 0 1 .12.486l-1.412 4.883 1.2-.659a.5.5 0 1 1 .481.877l-1.551.852a.833.833 0 0 1-1.202-.962l1.282-4.435-.903.226a.5.5 0 1 1-.242-.97l1.745-.436a.5.5 0 0 1 .481.138Z",
                fill: "#212328"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.4 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm-8 9a8 8 0 1 1 16 0 8 8 0 0 1-16 0Z",
                fill: "#212328"
            })
        ]
    });
var $f29db2785159f53e$export$2e2bcd8739ae039 = $f29db2785159f53e$var$SvgInfoOutline;




const $89a1581b8cd08deb$var$SvgJobFunction = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fill: "#212328",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M8.09 7.667h-2.5c-1.013 0-1.834.82-1.834 1.833v7.667c0 1.012.821 1.833 1.834 1.833h6.5a.5.5 0 0 0 0-1h-6.5a.833.833 0 0 1-.834-.833v-4.5h6.667a.5.5 0 1 0 0-1H4.756V9.5c0-.46.373-.833.834-.833h12.666c.46 0 .834.373.834.833v.667a.5.5 0 1 0 1 0V9.5c0-1.012-.821-1.833-1.834-1.833h-2.5V6.5c0-1.012-.82-1.833-1.833-1.833h-4c-1.013 0-1.833.82-1.833 1.833v1.167Zm1-1.167c0-.46.373-.833.833-.833h4c.46 0 .833.373.833.833v1.167H9.09V6.5Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M18.59 14.833a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M15.904 10.631a.5.5 0 0 1 .458-.298h1.595a.5.5 0 0 1 .445.272l.405.791.573.302.922-.095a.5.5 0 0 1 .474.23l.84 1.327a.5.5 0 0 1-.011.551l-.518.751v.578l.561.709a.5.5 0 0 1 .043.557l-.77 1.36a.5.5 0 0 1-.436.254h-.957l-.561.293-.364.823a.5.5 0 0 1-.458.297h-1.59a.5.5 0 0 1-.445-.27l-.393-.762-.588-.245h-.985a.5.5 0 0 1-.424-.234l-.822-1.309a.5.5 0 0 1 .004-.539l.494-.759v-.598l-.538-.71a.5.5 0 0 1-.037-.549l.774-1.365a.5.5 0 0 1 .465-.253l.925.055.547-.323.372-.841Zm.783.702-.306.69a.5.5 0 0 1-.203.229l-.817.482a.5.5 0 0 1-.284.069l-.766-.046-.457.808.44.582a.5.5 0 0 1 .102.302v.915a.5.5 0 0 1-.081.273l-.4.615.505.803h.81a.5.5 0 0 1 .193.04l.848.354a.5.5 0 0 1 .251.232l.337.652h.961l.303-.684a.5.5 0 0 1 .226-.24l.824-.432a.5.5 0 0 1 .232-.057h.79l.46-.815-.46-.581a.5.5 0 0 1-.108-.31v-.908a.5.5 0 0 1 .089-.283l.418-.607-.497-.787-.765.08a.5.5 0 0 1-.285-.056l-.846-.446a.5.5 0 0 1-.212-.214l-.338-.66h-.964Z"
                })
            ]
        })
    });
var $89a1581b8cd08deb$export$2e2bcd8739ae039 = $89a1581b8cd08deb$var$SvgJobFunction;




const $da5de97cf3a7326a$var$SvgJump = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 21,
        height: 20,
        viewBox: "0 0 21 20",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M18 2.924a.416.416 0 0 0-.417-.423h-3.889a.417.417 0 0 0 0 .833h2.883l-7.76 7.761a.417.417 0 0 0 .589.59l7.76-7.761v2.883a.417.417 0 1 0 .834 0V2.924Z",
                fill: "#3751FF"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M4.528 6.11a.694.694 0 0 0-.695.694v9.167c0 .384.311.695.695.695h9.167c.383 0 .694-.311.694-.695v-4.583a.417.417 0 1 1 .833 0v4.583c0 .844-.684 1.528-1.527 1.528H4.528A1.528 1.528 0 0 1 3 15.97V6.804c0-.844.684-1.528 1.528-1.528H9.11a.417.417 0 0 1 0 .834H4.528Z",
                fill: "#3751FF"
            })
        ]
    });
var $da5de97cf3a7326a$export$2e2bcd8739ae039 = $da5de97cf3a7326a$var$SvgJump;




const $296c1624b3d139f1$var$SvgKeyboard = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M6.667 7.596a.833.833 0 1 1-1.667 0 .833.833 0 0 1 1.667 0ZM4.861 13.333c0-.23.187-.416.417-.416h9.444a.417.417 0 0 1 0 .833H5.278a.417.417 0 0 1-.417-.417ZM8.611 8.43a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667ZM12.222 7.596a.833.833 0 1 1-1.667 0 .833.833 0 0 1 1.667 0ZM14.166 8.43a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667ZM8.055 10.378a.833.833 0 1 1-1.666 0 .833.833 0 0 1 1.666 0ZM10 11.211a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666ZM13.611 10.378a.833.833 0 1 1-1.667 0 .833.833 0 0 1 1.667 0Z",
                fill: "#00245B"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.028 4.583c-.844 0-1.528.684-1.528 1.528v7.778c0 .844.684 1.528 1.528 1.528h11.944c.844 0 1.528-.684 1.528-1.528V6.11c0-.844-.684-1.528-1.528-1.528H4.028Zm-.695 1.528c0-.383.311-.694.695-.694h11.944c.384 0 .694.31.694.694v7.778c0 .383-.31.694-.694.694H4.028a.694.694 0 0 1-.695-.694V6.11Z",
                fill: "#00245B"
            })
        ]
    });
var $296c1624b3d139f1$export$2e2bcd8739ae039 = $296c1624b3d139f1$var$SvgKeyboard;




const $f96c63edfbec01a6$var$SvgLaunchRocket = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.925 3.066c.965.138 1.842.492 2.38 1.03.537.537.89 1.414 1.029 2.38.14.978.068 2.111-.308 3.21-.364 1.066-.993 1.975-1.712 2.804-.414.478-.87.942-1.33 1.397.256.403.376.865.4 1.313.031.6-.106 1.212-.356 1.707-.211.42-.63.899-1.013 1.299-.268.28-.552.556-.772.77l-.25.246a.5.5 0 0 1-.707 0l-1.491-1.491a1.837 1.837 0 0 1-1.796-.47l-.657-.658-.935 1.69a.5.5 0 0 1-.791.111l-3.62-3.62a.5.5 0 0 1 .111-.79l1.69-.937-.657-.657a1.837 1.837 0 0 1-.471-1.795l-1.49-1.49a.5.5 0 0 1 0-.708c.065-.065.148-.151.244-.25.215-.22.491-.504.771-.772.4-.382.88-.802 1.299-1.013A3.465 3.465 0 0 1 9.2 6.017c.448.023.91.143 1.313.398.455-.46.919-.915 1.397-1.33.829-.718 1.738-1.347 2.803-1.711a6.996 6.996 0 0 1 3.212-.308Zm-8.15 4.087c-.189-.08-.4-.126-.628-.138a2.466 2.466 0 0 0-1.204.25c-.27.136-.653.457-1.058.843-.238.227-.458.452-.65.649l.968.968 2.571-2.572Zm-.797 5.672a.501.501 0 0 0-.01-.01l-1.121-1.122a.837.837 0 0 1 0-1.184l2.405-2.405c.205-.205.405-.41.603-.61.573-.584 1.126-1.147 1.71-1.653.778-.674 1.575-1.215 2.471-1.52a5.996 5.996 0 0 1 2.747-.265c.846.121 1.486.418 1.815.746.328.329.625.969.745 1.815a5.997 5.997 0 0 1-.263 2.747c-.306.895-.847 1.693-1.521 2.47-.507.585-1.069 1.137-1.652 1.71-.202.199-.406.4-.61.604l-2.406 2.405a.837.837 0 0 1-1.184 0l-1.121-1.12a.5.5 0 0 0-.01-.011l-2.598-2.598Zm-.446.968-1.36.753 2.681 2.682.754-1.36-2.075-2.075Zm6.143 3.404.968.968c.197-.192.422-.412.649-.65.386-.405.707-.788.843-1.058.173-.342.272-.78.25-1.204a1.845 1.845 0 0 0-.138-.627l-2.572 2.571Zm1.119-8.519a1.841 1.841 0 1 0-2.604 2.604 1.841 1.841 0 0 0 2.604-2.604Zm-3.311-.707a2.841 2.841 0 1 1 4.018 4.018 2.841 2.841 0 0 1-4.018-4.018Zm-7.284 7.847a.5.5 0 0 1 0 .707l-.946.946a.5.5 0 1 1-.707-.707l.946-.946a.5.5 0 0 1 .707 0Zm2.037 1.346a.5.5 0 0 1 0 .707L4.87 20.236a.5.5 0 1 1-.707-.707l2.364-2.365a.5.5 0 0 1 .708 0Zm1.346 2.037a.5.5 0 0 1 0 .707l-.946.945a.5.5 0 1 1-.707-.707l.946-.945a.5.5 0 0 1 .707 0Z",
            fill: "#212328"
        })
    });
var $f96c63edfbec01a6$export$2e2bcd8739ae039 = $f96c63edfbec01a6$var$SvgLaunchRocket;




const $c595f6461facccb6$var$SvgLeftArrow = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 16,
        height: 17,
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            d: "M6.322 13.334a.333.333 0 1 0 .47-.471L3.138 9.208h10.53a.333.333 0 1 0 0-.667H3.14L6.793 4.89a.333.333 0 1 0-.471-.472L2.098 8.641a.333.333 0 0 0 0 .471l4.224 4.222Z",
            fill: "#212328"
        })
    });
var $c595f6461facccb6$export$2e2bcd8739ae039 = $c595f6461facccb6$var$SvgLeftArrow;




const $8282ab85a668eef9$var$SvgLinkChain = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.577 3.65a4.085 4.085 0 0 1 5.776 5.777l-.005.005-2.2 2.201a4.086 4.086 0 0 1-6.161-.441.417.417 0 1 1 .667-.5 3.252 3.252 0 0 0 4.904.352l2.198-2.198a3.252 3.252 0 0 0-4.598-4.598L9.898 5.5a.417.417 0 1 1-.588-.59l1.267-1.26ZM7.314 7.427a4.085 4.085 0 0 1 4.7 1.381.417.417 0 0 1-.668.5 3.252 3.252 0 0 0-4.904-.352l-2.198 2.199a3.252 3.252 0 0 0 4.598 4.597l1.26-1.252a.417.417 0 0 1 .588.59l-1.267 1.26a4.085 4.085 0 0 1-5.776-5.777l.005-.005 2.2-2.201a4.085 4.085 0 0 1 1.462-.94Z",
            fill: "#3751FF"
        })
    });
var $8282ab85a668eef9$export$2e2bcd8739ae039 = $8282ab85a668eef9$var$SvgLinkChain;




const $291798a9e40124e8$var$SvgManager = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.786 6.553a3.553 3.553 0 1 1 7.106 0 3.553 3.553 0 0 1-7.106 0ZM9.339 4a2.553 2.553 0 1 0 0 5.106 2.553 2.553 0 0 0 0-5.106Z",
                fill: "#3751FF"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M13.952 12.85a8.603 8.603 0 0 0-8.806 0c-.537.32-.866.9-.866 1.525V20.5a.5.5 0 0 1-1 0v-6.125c0-.978.514-1.884 1.355-2.384a9.603 9.603 0 0 1 9.83 0c.84.5 1.354 1.406 1.354 2.384v.146a.5.5 0 1 1-1 0v-.146c0-.626-.329-1.205-.867-1.525ZM20.574 14.71a.5.5 0 1 0-.707-.708l-5.448 5.443-1.815-1.825a.5.5 0 0 0-.71.705l2.17 2.18a.5.5 0 0 0 .707.002l5.803-5.798Z",
                fill: "#3751FF"
            })
        ]
    });
var $291798a9e40124e8$export$2e2bcd8739ae039 = $291798a9e40124e8$var$SvgManager;




const $0bca52681745aa88$var$SvgMenuHamburger = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("g", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            fill: "#212328",
            children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M3 17.333a.5.5 0 0 1 .5-.5h17a.5.5 0 1 1 0 1h-17a.5.5 0 0 1-.5-.5ZM3 12a.5.5 0 0 1 .5-.5h17a.5.5 0 0 1 0 1h-17A.5.5 0 0 1 3 12ZM3 6.667a.5.5 0 0 1 .5-.5h17a.5.5 0 0 1 0 1h-17a.5.5 0 0 1-.5-.5Z"
            })
        })
    });
var $0bca52681745aa88$export$2e2bcd8739ae039 = $0bca52681745aa88$var$SvgMenuHamburger;




const $0345d53ee9e1b395$var$SvgModalIslandBgVector = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 480,
        height: 108,
        viewBox: "0 0 480 108",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            d: "M0 108c17.32-6.929 65.912-11.82 127.446-11.82 61.534 0 153.679 8.458 208.738 11.82 55.058 3.362 105.877 0 143.816-6.929V0H0v108Z",
            fill: "#E5F7E0"
        })
    });
var $0345d53ee9e1b395$export$2e2bcd8739ae039 = $0345d53ee9e1b395$var$SvgModalIslandBgVector;




const $d835331ee5611bac$var$SvgMoreHorizontal = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            d: "M6.733 12A1.667 1.667 0 1 1 3.4 12a1.667 1.667 0 0 1 3.333 0ZM21.4 12a1.667 1.667 0 1 1-3.333 0 1.667 1.667 0 0 1 3.333 0ZM12.4 13.667a1.667 1.667 0 1 0 0-3.334 1.667 1.667 0 0 0 0 3.334Z",
            fill: "#212328"
        })
    });
var $d835331ee5611bac$export$2e2bcd8739ae039 = $d835331ee5611bac$var$SvgMoreHorizontal;




const $ed6f91703d1891cf$var$SvgMoreVertical = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            d: "M12.15 17.667a1.667 1.667 0 1 1 0 3.333 1.667 1.667 0 0 1 0-3.333ZM12.15 3a1.667 1.667 0 1 1 0 3.333 1.667 1.667 0 0 1 0-3.333ZM13.816 12a1.667 1.667 0 1 0-3.333 0 1.667 1.667 0 0 0 3.333 0Z",
            fill: "#212328"
        })
    });
var $ed6f91703d1891cf$export$2e2bcd8739ae039 = $ed6f91703d1891cf$var$SvgMoreVertical;




const $07980a25f80dab99$var$SvgNeutral = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fill: "#212328",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M10.023 10.117a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334ZM16.156 9.45a.667.667 0 1 1-1.333 0 .667.667 0 0 1 1.333 0ZM9.356 14.527a.5.5 0 0 0 0 1h6.8a.5.5 0 1 0 0-1h-6.8Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12.756 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm-8 9a8 8 0 1 1 16 0 8 8 0 0 1-16 0Z"
                })
            ]
        })
    });
var $07980a25f80dab99$export$2e2bcd8739ae039 = $07980a25f80dab99$var$SvgNeutral;




const $8f178723b360e48c$var$SvgNotConfirmedManager = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fill: "#00245B",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M9.579 3a3.564 3.564 0 1 0 0 7.128 3.564 3.564 0 0 0 0-7.128ZM7.015 6.564a2.564 2.564 0 1 1 5.128 0 2.564 2.564 0 0 1-5.128 0Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M5.652 12.701c2.354-1.402 5.29-1.349 7.659.062a.5.5 0 1 0 .511-.86c-2.668-1.59-5.999-1.66-8.682-.06l-.347.206A3.672 3.672 0 0 0 3 15.204V20.5a.5.5 0 0 0 1 0v-5.296c0-.942.496-1.814 1.304-2.296l.348-.207Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M15.999 12.459a1.322 1.322 0 0 1 2.002 0c.641.735.98.936 1.929 1.136.786.165 1.254.992 1.001 1.769-.303.932-.299 1.353 0 2.272.253.777-.215 1.604-1.001 1.77-.962.201-1.298.411-1.929 1.135a1.322 1.322 0 0 1-2.002 0c-.631-.724-.967-.934-1.929-1.136-.786-.165-1.254-.992-1.001-1.769.299-.92.303-1.34 0-2.272-.253-.777.215-1.604 1.001-1.77.962-.201 1.298-.411 1.929-1.135Zm1.472.48a.622.622 0 0 0-.942 0c-.715.822-1.212 1.133-2.316 1.365a.644.644 0 0 0-.47.832c.339 1.044.348 1.657 0 2.728a.644.644 0 0 0 .47.832c1.076.226 1.58.52 2.316 1.364.25.288.691.288.942 0 .715-.82 1.212-1.132 2.316-1.364a.644.644 0 0 0 .47-.832c-.339-1.044-.348-1.657 0-2.728a.644.644 0 0 0-.47-.832c-1.076-.226-1.58-.52-2.316-1.364Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M15.382 14.849a.35.35 0 0 1 .501 0L17 15.989l1.117-1.14a.35.35 0 0 1 .501 0 .367.367 0 0 1 0 .512L17.502 16.5l1.116 1.14a.367.367 0 0 1 0 .511.35.35 0 0 1-.501 0L17 17.011l-1.117 1.14a.35.35 0 0 1-.501 0 .367.367 0 0 1 0-.512l1.116-1.139-1.116-1.14a.367.367 0 0 1 0-.511Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "m18.001 12.459-.094.082.094-.082Zm-2.002 0-.095-.082.095.082Zm3.93 1.136.027-.123-.026.123Zm1.002 1.769-.119-.039.12.039Zm0 2.272-.119.039.12-.039Zm-1.001 1.77.026.122-.026-.123ZM18 20.54l-.094-.082.094.082Zm-2.002 0 .094-.082-.094.082Zm-1.929-1.136-.026.123.026-.123Zm-1.001-1.769.119.039-.12-.039Zm0-2.272.119-.039-.12.039Zm1.001-1.77-.026-.122.026.123Zm2.459-.654-.094-.083.094.083Zm.942 0 .094-.083-.094.083Zm-3.258 1.364-.026-.123.026.123Zm-.47.832-.12.039.12-.04Zm0 2.728-.12-.039.12.04Zm.47.832.026-.122-.026.122Zm2.316 1.364-.094.083.094-.082Zm.942 0 .094.083-.094-.082Zm2.316-1.364-.026-.122.026.122Zm.47-.832.12-.039-.12.04Zm0-2.728-.118-.039.119.039Zm-.47-.832.026-.123-.026.123Zm-3.904.545-.09.087.09-.087Zm-.501 0-.09-.088.09.088ZM17 15.989l-.09.087.09.09.09-.09-.09-.088Zm1.117-1.14.089.087-.09-.087Zm.501 0-.089.087.09-.087Zm0 .512-.089-.088.09.088ZM17.502 16.5l-.09-.087-.085.087.085.087.09-.087Zm1.116 1.14-.089.087.09-.088Zm0 .511-.089-.087.09.087Zm-.501 0 .089-.087-.09.087ZM17 17.011l.09-.087-.09-.09-.09.09.09.088Zm-1.117 1.14.09.088-.09-.088Zm-.501 0-.09.088.09-.088Zm0-.512-.09-.087.09.087Zm1.116-1.139.09.087.085-.087-.085-.087-.09.087Zm-1.116-1.14-.09.088.09-.087Zm2.714-2.983a1.447 1.447 0 0 0-2.191 0l.188.164a1.197 1.197 0 0 1 1.814 0l.189-.164Zm2.954 3.026c.275-.845-.234-1.75-1.094-1.93l-.052.244c.71.15 1.139.9.908 1.608l.238.078Zm-1.094 4.125c.86-.181 1.37-1.086 1.094-1.93l-.238.077c.23.708-.197 1.459-.908 1.608l.052.245Zm-4.051 1.095a1.447 1.447 0 0 0 2.19 0l-.188-.164a1.197 1.197 0 0 1-1.814 0l-.188.164Zm-2.955-3.026c-.275.845.234 1.75 1.094 1.93l.052-.244c-.71-.15-1.139-.9-.908-1.608l-.238-.078Zm1.094-4.125c-.86.181-1.37 1.086-1.094 1.93l.238-.077c-.23-.708.197-1.459.908-1.608l-.052-.245Zm2.58-.45c.2-.23.552-.23.753 0l.188-.165a.747.747 0 0 0-1.13 0l.188.165Zm-2.763 2.075a.52.52 0 0 1 .378-.671l-.052-.245a.769.769 0 0 0-.564.994l.238-.078Zm.378 3.477a.52.52 0 0 1-.378-.671l-.238-.078c-.141.434.12.9.564.994l.052-.245Zm3.138 1.404c-.201.23-.553.23-.754 0l-.188.165c.3.345.83.345 1.13 0l-.188-.165Zm2.762-2.075a.52.52 0 0 1-.378.671l.052.245a.769.769 0 0 0 .564-.994l-.238.078Zm-.378-3.477a.52.52 0 0 1 .378.671l.238.078a.769.769 0 0 0-.564-.994l-.052.245Zm-3.788.335a.475.475 0 0 0-.68 0l.178.175a.225.225 0 0 1 .323 0l.178-.175Zm1.116 1.14-1.116-1.14-.18.175 1.118 1.14.178-.175Zm.939-1.14-1.117 1.14.178.175 1.117-1.14-.178-.175Zm.68 0a.475.475 0 0 0-.68 0l.178.175a.225.225 0 0 1 .323 0l.179-.175Zm0 .687a.492.492 0 0 0 0-.687l-.179.175c.091.093.091.245 0 .337l.179.175Zm-1.117 1.14 1.117-1.14-.179-.175-1.117 1.14.179.174Zm1.117.964-1.117-1.14-.179.175 1.117 1.14.179-.175Zm0 .687a.492.492 0 0 0 0-.687l-.179.175c.091.093.091.244 0 .337l.179.175Zm-.68 0a.475.475 0 0 0 .68 0l-.179-.175a.225.225 0 0 1-.323 0l-.178.175Zm-1.117-1.14 1.116 1.14.179-.175-1.117-1.14-.178.175Zm-.939 1.14 1.117-1.14-.178-.175-1.117 1.14.178.175Zm-.68 0a.475.475 0 0 0 .68 0l-.178-.175a.225.225 0 0 1-.323 0l-.179.175Zm0-.687a.492.492 0 0 0 0 .687l.179-.175a.242.242 0 0 1 0-.337l-.179-.175Zm1.117-1.14-1.117 1.14.179.175 1.117-1.14-.179-.174Zm-1.117-.964 1.117 1.14.179-.175-1.117-1.14-.179.175Zm0-.687a.492.492 0 0 0 0 .687l.179-.175a.242.242 0 0 1 0-.337l-.179-.175Zm4.664-1.289c-.47-.098-.777-.195-1.043-.352-.265-.157-.5-.378-.817-.743l-.189.164c.323.37.578.617.88.794.3.178.639.281 1.117.382l.052-.245Zm-2.58-.45c.373.426.693.722 1.062.939.369.217.779.35 1.323.465l.052-.245c-.532-.111-.912-.238-1.249-.435-.336-.198-.635-.472-.999-.889l-.188.165Zm2.763 2.075c-.176.542-.265.977-.264 1.413 0 .436.092.864.264 1.393l.238-.078c-.168-.515-.251-.916-.252-1.315-.001-.4.08-.807.252-1.335l-.238-.078Zm.911 2.5c-.148-.455-.22-.775-.22-1.093 0-.317.07-.64.22-1.101l-.238-.078c-.153.47-.232.824-.232 1.18s.081.706.232 1.17l.238-.078Zm-1.289.977c-.559.117-.974.257-1.342.476-.368.22-.68.513-1.042.928l.188.165c.354-.406.647-.678.982-.878.335-.2.72-.332 1.266-.446l-.052-.245Zm-1.665 2.05c.313-.36.544-.581.81-.74.265-.157.573-.256 1.05-.356l-.052-.245c-.485.102-.826.208-1.126.387-.3.179-.553.424-.871.79l.189.163Zm-1.473-.646c-.372-.427-.692-.722-1.06-.939-.37-.217-.78-.35-1.324-.465l-.052.245c.532.111.913.238 1.249.436.336.197.635.47.999.888l.188-.165Zm-2.579-.45c.477.1.785.2 1.05.357.266.158.497.379.81.738l.189-.164c-.318-.365-.57-.61-.87-.79-.302-.178-.642-.284-1.127-.386l-.052.245Zm-.183-1.625c.176-.542.265-.977.264-1.413 0-.436-.092-.864-.264-1.393l-.238.078c.168.515.251.916.252 1.315.001.4-.08.807-.252 1.335l.238.078Zm-.911-2.5c.15.461.22.784.22 1.101 0 .318-.072.638-.22 1.093l.238.078c.15-.464.231-.814.232-1.17 0-.356-.08-.71-.232-1.18l-.238.078Zm2.955-3.026c-.314.359-.545.58-.81.738-.266.158-.574.257-1.05.357l.05.245c.486-.102.826-.208 1.127-.387.3-.179.553-.424.871-.79l-.188-.163Zm-1.666 2.049c.559-.117.974-.257 1.342-.476.368-.22.68-.513 1.042-.928l-.188-.165c-.354.406-.647.678-.982.878-.335.2-.72.332-1.266.446l.052.245Z"
                })
            ]
        })
    });
var $8f178723b360e48c$export$2e2bcd8739ae039 = $8f178723b360e48c$var$SvgNotConfirmedManager;




const $ee5900cac15b4ef8$var$SvgNotification = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 3c-1.541 0-2.74.4-3.654 1.07-.911.667-1.504 1.575-1.884 2.537-.754 1.905-.703 4.092-.595 5.305v.003a1.105 1.105 0 0 1-.428.98 4.161 4.161 0 0 0-1.784 3.466 1.938 1.938 0 0 0 1.89 1.956H9.156c.096.698.391 1.352.857 1.845.53.561 1.241.873 1.988.835.746.038 1.459-.274 1.988-.835a3.348 3.348 0 0 0 .857-1.845h3.609a1.938 1.938 0 0 0 1.89-1.956 4.162 4.162 0 0 0-1.784-3.466 1.107 1.107 0 0 1-.428-.98v-.002c.108-1.213.16-3.401-.594-5.306-.38-.962-.973-1.87-1.884-2.538C14.74 3.4 13.541 3 12 3Zm1.832 15.317h-3.664c.086.454.289.86.571 1.159.353.374.796.549 1.23.522l.031-.002.031.002c.434.027.877-.148 1.23-.522.282-.3.485-.705.57-1.159Zm-7.14-5.45c.146-.327.204-.687.17-1.044-.103-1.17-.136-3.166.53-4.849.329-.832.822-1.569 1.545-2.098C9.656 4.35 10.639 4 12 4c1.36 0 2.344.35 3.063.876.723.53 1.216 1.266 1.545 2.098.666 1.683.632 3.679.528 4.849a2.106 2.106 0 0 0 .83 1.876l.008.006.008.006a3.16 3.16 0 0 1 1.363 2.643V16.367a.939.939 0 0 1-.91.95H5.565a.938.938 0 0 1-.91-.95V16.354a3.161 3.161 0 0 1 1.363-2.643l.008-.006.008-.006c.287-.216.514-.502.659-.831Z",
            fill: "#212328"
        })
    });
var $ee5900cac15b4ef8$export$2e2bcd8739ae039 = $ee5900cac15b4ef8$var$SvgNotification;




const $83d220cdb7aeb7d1$var$SvgNotificationWithBadge = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.89 2.187A7.5 7.5 0 0 0 4.25 9v3.195a.75.75 0 0 1-.18.488l-.806.94A5.25 5.25 0 0 0 2 17.04v.21a2.25 2.25 0 0 0 2.25 2.25h3.825a3.751 3.751 0 0 0 7.35 0h3.825a2.25 2.25 0 0 0 2.25-2.25v-.21a5.25 5.25 0 0 0-1.264-3.417l-.805-.94a.75.75 0 0 1-.181-.488v-.998a5.286 5.286 0 0 1-1.5 0v.998c0 .537.192 1.057.542 1.464l.805.94A3.75 3.75 0 0 1 20 17.04v.211a.75.75 0 0 1-.75.75h-15a.75.75 0 0 1-.75-.75v-.21c0-.895.32-1.761.903-2.44l.805-.94a2.25 2.25 0 0 0 .542-1.465V9a6 6 0 0 1 8.183-5.59c.258-.455.581-.866.958-1.223ZM11.75 21c.98 0 1.813-.626 2.122-1.5H9.628A2.25 2.25 0 0 0 11.75 21Z",
                fill: "#000"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("circle", {
                cx: 18.5,
                cy: 6,
                r: 4,
                fill: "#3751FF"
            })
        ]
    });
var $83d220cdb7aeb7d1$export$2e2bcd8739ae039 = $83d220cdb7aeb7d1$var$SvgNotificationWithBadge;




const $12586e7a1e4bfbcb$var$SvgOrganization = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M7 6.236a.5.5 0 0 1 .5.5v1.667a.5.5 0 0 1-1 0V6.736a.5.5 0 0 1 .5-.5ZM7.5 11.403a.5.5 0 0 0-1 0v1.667a.5.5 0 0 0 1 0v-1.667ZM10.333 6.236a.5.5 0 0 1 .5.5v1.667a.5.5 0 1 1-1 0V6.736a.5.5 0 0 1 .5-.5ZM10.833 11.403a.5.5 0 1 0-1 0v1.667a.5.5 0 0 0 1 0v-1.667ZM15.833 12.236a.5.5 0 0 1 .5.5v1.334a.5.5 0 1 1-1 0v-1.334a.5.5 0 0 1 .5-.5ZM16.333 16.403a.5.5 0 1 0-1 0v1.333a.5.5 0 1 0 1 0v-1.333ZM18.5 12.236a.5.5 0 0 1 .5.5v1.334a.5.5 0 0 1-1 0v-1.334a.5.5 0 0 1 .5-.5ZM19 16.403a.5.5 0 0 0-1 0v1.333a.5.5 0 1 0 1 0v-1.333Z",
                fill: "#212328"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.667 3C4.022 3 3.5 3.522 3.5 4.167V20.5a.5.5 0 0 0 .5.5h17a.5.5 0 0 0 .5-.5v-9.667c0-.644-.522-1.166-1.167-1.166h-6.5v-5.5c0-.645-.522-1.167-1.166-1.167h-8Zm8.166 1.167A.167.167 0 0 0 12.667 4h-8a.167.167 0 0 0-.167.167V20h2v-3.597a.5.5 0 0 1 .5-.5h3.333a.5.5 0 0 1 .5.5V20h2V4.167ZM9.833 20v-3.097H7.5V20h2.333Zm4-9.333h6.5c.092 0 .167.074.167.166V20h-6.667v-9.333Z",
                fill: "#212328"
            })
        ]
    });
var $12586e7a1e4bfbcb$export$2e2bcd8739ae039 = $12586e7a1e4bfbcb$var$SvgOrganization;




const $268fa5ea90cfe0ce$var$SvgParty = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fill: "#212328",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M11.906 4.346a.5.5 0 0 0-.949-.316l-.882 2.647a.5.5 0 1 0 .949.316l.882-2.647Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M13.726 11.454a.5.5 0 0 1-.707.007c-.996-.977-1.978-1.745-2.755-2.202-.393-.23-.708-.367-.933-.422a.975.975 0 0 0-.138-.025c.004.036.012.086.03.154.06.237.207.568.452.976.486.808 1.294 1.825 2.316 2.846 1.02 1.021 2.037 1.83 2.846 2.315.408.245.738.393.975.453.068.018.118.026.154.03a.803.803 0 0 0-.01-.069c-.03-.171-.122-.42-.291-.742a.5.5 0 1 1 .884-.466c.192.363.335.716.392 1.03.053.297.052.696-.236.985a.997.997 0 0 1-.042.038.498.498 0 0 1-.225.153L5.125 20.286a.5.5 0 0 1-.633-.632L8.263 8.34a.498.498 0 0 1 .153-.225.885.885 0 0 1 .039-.041c.325-.325.787-.288 1.113-.208.36.088.772.278 1.203.531.867.51 1.912 1.334 2.948 2.35a.5.5 0 0 1 .007.707Zm.596 4.507c.076.045.151.089.226.13l-2.58.86c-.449-.329-1.167-.943-2.038-2-1.05-1.273-1.482-2.744-1.646-3.511l.403-1.21c.042.075.085.15.13.226.54.897 1.405 1.978 2.466 3.04 1.062 1.06 2.142 1.926 3.04 2.465Zm-6.589-2.868-.988 2.965c.221.419.493.845.828 1.25.268.326.522.61.758.856l2.507-.836a14.072 14.072 0 0 1-1.68-1.74 8.883 8.883 0 0 1-1.425-2.495Zm-1.976 5.928.571-1.712c.143.214.3.426.473.636.167.203.33.391.488.566l-1.532.51Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M21.02 13.125a.5.5 0 0 0-.632-.316l-2.662.886a.5.5 0 0 0 .315.949l2.663-.886a.5.5 0 0 0 .316-.633ZM16.108 12.044a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1ZM17.778 12.03a.5.5 0 1 1-.707-.706.5.5 0 0 1 .707.707ZM11.631 11.959a.5.5 0 1 0 .707-.707.5.5 0 0 0-.707.707ZM13.596 5.874a.5.5 0 1 1-.707-.707.5.5 0 0 1 .707.707ZM13.552 7.568a.5.5 0 1 0-.707-.707l-.118.118-.118-.118a.5.5 0 1 0-.707.707l.118.118-.118.118a.5.5 0 1 0 .707.707l.118-.118.118.118a.5.5 0 1 0 .707-.707l-.118-.118.118-.118ZM17.34 8.146a.5.5 0 0 0-.708-.707l-2.24 2.24a.5.5 0 0 0 .707.708l2.24-2.241Z"
                })
            ]
        })
    });
var $268fa5ea90cfe0ce$export$2e2bcd8739ae039 = $268fa5ea90cfe0ce$var$SvgParty;




const $40361ad719b6c35d$var$SvgPassword = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fill: "#212328",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M7.678 13.24c0 .07.026.122.078.157l.503.373a.248.248 0 0 0 .112.026c.075 0 .127-.024.156-.07a.231.231 0 0 0 .044-.06l.32-.737.321.736.035.061c.029.046.08.07.156.07.04 0 .078-.01.112-.026l.503-.373a.175.175 0 0 0 .078-.156.186.186 0 0 0-.035-.104c0-.006-.017-.026-.052-.06l-.598-.52.798-.079.069-.017a.167.167 0 0 0 .087-.07.208.208 0 0 0 .043-.12l-.009-.053-.199-.598a.128.128 0 0 0-.07-.095.213.213 0 0 0-.12-.035.096.096 0 0 0-.044.009l-.07.034-.693.408.182-.78.009-.07c0-.046-.02-.089-.06-.13a.164.164 0 0 0-.13-.06H8.57a.191.191 0 0 0-.191.19l.009.07.173.771-.685-.399c-.029-.023-.052-.034-.069-.034a.142.142 0 0 0-.043-.009.182.182 0 0 0-.096.026c-.052.023-.083.058-.095.104l-.2.598a.182.182 0 0 0 .017.147c.024.053.059.084.105.096l.07.017.788.078-.59.52c-.034.035-.051.055-.051.06a.186.186 0 0 0-.035.105ZM11.537 13.24c0 .07.026.122.078.157l.503.373a.248.248 0 0 0 .113.026c.075 0 .127-.024.156-.07a.23.23 0 0 0 .043-.06l.32-.737.321.736.035.061c.029.046.08.07.156.07.04 0 .078-.01.113-.026l.502-.373a.175.175 0 0 0 .078-.156.186.186 0 0 0-.034-.104.237.237 0 0 0-.052-.06l-.598-.52.797-.079.07-.017a.167.167 0 0 0 .086-.07.208.208 0 0 0 .043-.12l-.008-.053-.2-.598a.128.128 0 0 0-.069-.095.214.214 0 0 0-.121-.035.096.096 0 0 0-.044.009l-.069.034-.693.408.182-.78.008-.07c0-.046-.02-.089-.06-.13a.164.164 0 0 0-.13-.06h-.633a.191.191 0 0 0-.19.19l.008.07.173.771-.684-.399c-.03-.023-.052-.034-.07-.034a.141.141 0 0 0-.043-.009.182.182 0 0 0-.095.026c-.052.023-.084.058-.096.104l-.199.598a.182.182 0 0 0 .017.147c.024.053.058.084.104.096l.07.017.788.078-.589.52c-.035.035-.052.055-.052.06a.186.186 0 0 0-.035.105ZM15.397 13.24c0 .07.026.122.078.157l.502.373a.248.248 0 0 0 .113.026c.075 0 .127-.024.156-.07a.233.233 0 0 0 .043-.06l.321-.737.32.736.035.061c.03.046.081.07.156.07.04 0 .078-.01.113-.026l.503-.373a.175.175 0 0 0 .078-.156.186.186 0 0 0-.035-.104.237.237 0 0 0-.052-.06l-.598-.52.797-.079.07-.017a.167.167 0 0 0 .086-.07.208.208 0 0 0 .044-.12l-.009-.053-.2-.598a.128.128 0 0 0-.069-.095.214.214 0 0 0-.12-.035.096.096 0 0 0-.044.009l-.07.034-.693.408.182-.78.009-.07c0-.046-.02-.089-.06-.13a.164.164 0 0 0-.13-.06h-.634a.191.191 0 0 0-.19.19l.008.07.174.771-.685-.399c-.029-.023-.052-.034-.07-.034a.142.142 0 0 0-.043-.009.182.182 0 0 0-.095.026c-.052.023-.084.058-.095.104l-.2.598a.182.182 0 0 0 .017.147c.024.053.058.084.105.096l.07.017.788.078-.59.52c-.034.035-.052.055-.052.06a.186.186 0 0 0-.034.105Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M13.057 3.1a.5.5 0 0 0-.6 0l-1.718 1.29a6.167 6.167 0 0 1-4.717 1.152l-1.183-.197a.5.5 0 0 0-.583.493v6.334c0 2.921 1.574 5.133 3.383 6.596.905.732 1.88 1.286 2.771 1.658.882.369 1.72.574 2.346.574.628 0 1.466-.208 2.348-.578a11.612 11.612 0 0 0 2.77-1.666c1.808-1.466 3.382-3.678 3.382-6.584V5.838a.5.5 0 0 0-.582-.493l-1.183.197a6.166 6.166 0 0 1-4.717-1.152L13.056 3.1Zm-7.8 3.328.6.1A7.167 7.167 0 0 0 11.34 5.19l1.416-1.064 1.417 1.064a7.167 7.167 0 0 0 5.482 1.34l.601-.1v5.743c0 2.511-1.354 4.463-3.011 5.807-.828.671-1.72 1.18-2.529 1.52-.819.345-1.517.501-1.96.501-.443 0-1.142-.155-1.96-.496-.81-.338-1.701-.845-2.528-1.514-1.656-1.339-3.012-3.29-3.012-5.818V6.428Z"
                })
            ]
        })
    });
var $40361ad719b6c35d$export$2e2bcd8739ae039 = $40361ad719b6c35d$var$SvgPassword;




const $26a624009ae0c3cc$var$SvgPasswordCredentialUnlock = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "m7.136 17.218-.606-.457a.177.177 0 0 1-.075-.13.24.24 0 0 1 .028-.15c0-.006.019-.025.056-.056l.625-.542-.82-.065a.256.256 0 0 0-.057-.01c-.006-.005-.012-.008-.019-.008a.2.2 0 0 1-.112-.094.264.264 0 0 1-.018-.168l.233-.719c.013-.05.047-.087.103-.112a.218.218 0 0 1 .15-.018c.012 0 .036.01.074.028l.7.43-.178-.803a.154.154 0 0 1-.009-.047v-.028a.205.205 0 0 1 .205-.205h.756c.056 0 .103.021.14.065.044.043.066.09.066.14v.028a.154.154 0 0 1-.01.046l-.196.803.72-.43a.225.225 0 0 1 .074-.027.21.21 0 0 1 .15.018c.055.025.09.063.102.112l.233.72a.264.264 0 0 1-.019.167.167.167 0 0 1-.112.094.072.072 0 0 0-.028.009.282.282 0 0 0-.046.01l-.822.074.626.532c.037.03.056.05.056.056a.208.208 0 0 1 .037.15.17.17 0 0 1-.084.13l-.607.457a.279.279 0 0 1-.158.028.21.21 0 0 1-.13-.084l-.02-.018a.147.147 0 0 0-.028-.038l-.326-.765-.318.765a.147.147 0 0 1-.028.037l-.018.02c-.025.043-.069.07-.13.083a.279.279 0 0 1-.16-.028ZM11.293 17.218l-.607-.457a.177.177 0 0 1-.075-.13.24.24 0 0 1 .028-.15c0-.006.019-.025.056-.056l.626-.542-.822-.065a.257.257 0 0 0-.056-.01c-.006-.005-.012-.008-.018-.008a.2.2 0 0 1-.112-.094.264.264 0 0 1-.019-.168l.233-.719c.013-.05.047-.087.103-.112a.218.218 0 0 1 .15-.018c.012 0 .037.01.074.028l.7.43-.177-.803a.155.155 0 0 1-.01-.047v-.028a.205.205 0 0 1 .205-.205h.757c.056 0 .102.021.14.065.043.043.065.09.065.14v.028a.155.155 0 0 1-.01.046l-.195.803.718-.43a.224.224 0 0 1 .075-.027.21.21 0 0 1 .15.018c.055.025.09.063.102.112l.233.72a.264.264 0 0 1-.018.167.167.167 0 0 1-.112.094.072.072 0 0 0-.028.009.282.282 0 0 0-.047.01l-.821.074.625.532c.037.03.056.05.056.056a.209.209 0 0 1 .037.15.17.17 0 0 1-.084.13l-.606.457a.279.279 0 0 1-.159.028.21.21 0 0 1-.13-.084l-.02-.018a.147.147 0 0 0-.027-.038l-.327-.765-.317.765a.147.147 0 0 1-.028.037l-.019.02c-.025.043-.068.07-.13.083a.279.279 0 0 1-.16-.028ZM15.449 17.218l-.607-.457a.177.177 0 0 1-.074-.13.24.24 0 0 1 .028-.15c0-.006.018-.025.056-.056l.625-.542-.821-.065a.256.256 0 0 0-.056-.01c-.007-.005-.013-.008-.02-.008a.2.2 0 0 1-.111-.094.264.264 0 0 1-.019-.168l.234-.719c.012-.05.046-.087.102-.112a.217.217 0 0 1 .15-.018c.012 0 .037.01.074.028l.7.43-.177-.803a.155.155 0 0 1-.01-.047v-.028c0-.05.02-.097.057-.14a.205.205 0 0 1 .149-.066h.756c.056 0 .103.022.14.066.044.043.065.09.065.14v.028a.152.152 0 0 1-.01.046l-.195.803.719-.43a.224.224 0 0 1 .074-.027.21.21 0 0 1 .15.018c.056.025.09.063.102.112l.234.72a.263.263 0 0 1-.02.167.167.167 0 0 1-.111.094.072.072 0 0 0-.028.009.282.282 0 0 0-.047.01l-.821.074.625.532c.038.03.056.05.056.056a.209.209 0 0 1 .038.15.17.17 0 0 1-.084.13l-.607.457a.279.279 0 0 1-.159.028.21.21 0 0 1-.13-.084l-.02-.018a.145.145 0 0 0-.027-.038l-.327-.765-.317.765a.145.145 0 0 1-.028.037l-.019.02c-.025.043-.068.07-.13.083a.279.279 0 0 1-.16-.028Z",
                fill: "#212328"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.437 7.196C8.437 5.939 9.484 4 12.002 4s3.565 1.94 3.565 3.196a.5.5 0 1 0 1 0c0-1.7-1.392-4.196-4.565-4.196-3.174 0-4.565 2.496-4.565 4.195v2.457H5.204c-1.012 0-1.833.82-1.833 1.833v7.681c0 1.013.82 1.834 1.833 1.834H18.8c1.012 0 1.833-.821 1.833-1.834v-7.68c0-1.013-.82-1.834-1.833-1.834H8.437V7.196Zm-.513 3.456h-2.72a.833.833 0 0 0-.833.833v7.681c0 .46.373.834.833.834H18.8c.46 0 .833-.373.833-.834v-7.68a.833.833 0 0 0-.833-.834H7.949a.506.506 0 0 1-.025 0Z",
                fill: "#212328"
            })
        ]
    });
var $26a624009ae0c3cc$export$2e2bcd8739ae039 = $26a624009ae0c3cc$var$SvgPasswordCredentialUnlock;




const $68e914f888fc2a13$var$SvgPotrait = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 49,
        height: 48,
        viewBox: "0 0 49 48",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.32 6.333a2.333 2.333 0 0 0-2.333 2.334v30.667a2.333 2.333 0 0 0 2.334 2.333h23.333a2.333 2.333 0 0 0 2.333-2.334V8.668a2.333 2.333 0 0 0-2.333-2.333H13.321Zm-.333 2.334c0-.184.15-.333.334-.333h23.333c.184 0 .333.149.333.333v30.667c0 .184-.149.333-.333.333H13.321a.333.333 0 0 1-.334-.334V8.668Z",
                fill: "#212328"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M18.987 36h12",
                stroke: "#000",
                strokeWidth: 2,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("circle", {
                cx: 24.987,
                cy: 14,
                r: 2,
                fill: "#000"
            })
        ]
    });
var $68e914f888fc2a13$export$2e2bcd8739ae039 = $68e914f888fc2a13$var$SvgPotrait;




const $c54d1ea34b1aa993$var$SvgPrivilegedAccess = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.449 3.78a.5.5 0 0 0-.898 0L8.255 10.5l-4.41-4.197a.5.5 0 0 0-.837.453L4.97 17.424a.5.5 0 0 0 .492.41h13.076a.5.5 0 0 0 .492-.41l1.962-10.667a.5.5 0 0 0-.837-.453l-4.41 4.197L12.45 3.78Zm-3.596 7.774L12 5.135l3.147 6.417a.5.5 0 0 0 .794.142L19.73 8.09l-1.608 8.743H5.878L4.27 8.09l3.79 3.605a.5.5 0 0 0 .793-.142Z",
                fill: "#212328"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M5.462 19.5a.5.5 0 0 0 0 1h13.076a.5.5 0 1 0 0-1H5.462Z",
                fill: "#212328"
            })
        ]
    });
var $c54d1ea34b1aa993$export$2e2bcd8739ae039 = $c54d1ea34b1aa993$var$SvgPrivilegedAccess;




const $cbdbbe1c8061d90e$var$SvgPrivilegedSession = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M8.307 14.13a.5.5 0 0 1-.5-.5v-3.281a.5.5 0 1 1 1 0v3.28a.5.5 0 0 1-.5.5ZM11.189 13.63a.5.5 0 0 0 1 0V9.014a.5.5 0 0 0-1 0v4.616ZM14.898 14.13a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 1 0v6a.5.5 0 0 1-.5.5Z",
                fill: "#254B86"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.665 5.963c0-1.013.82-1.834 1.833-1.834H18.83c1.013 0 1.834.821 1.834 1.834v9.333c0 1.013-.821 1.834-1.834 1.834H4.498a1.833 1.833 0 0 1-1.833-1.834V5.963Zm1.833-.834a.833.833 0 0 0-.833.834v9.333c0 .46.373.834.833.834H18.83c.46 0 .834-.374.834-.834V5.963a.833.833 0 0 0-.834-.834H4.498Z",
                fill: "#254B86"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M7.474 18.87a.5.5 0 1 0 0 1h8.38a.5.5 0 0 0 0-1h-8.38Z",
                fill: "#254B86"
            })
        ]
    });
var $cbdbbe1c8061d90e$export$2e2bcd8739ae039 = $cbdbbe1c8061d90e$var$SvgPrivilegedSession;




const $1ea565f58b88b6e4$var$SvgRadioOutline = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 21,
        height: 21,
        viewBox: "0 0 21 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M.146 10.136c0-5.522 4.477-10 10-10s10 4.478 10 10c0 5.523-4.477 10-10 10s-10-4.477-10-10Zm10-8.889a8.889 8.889 0 1 0 0 17.778 8.889 8.889 0 0 0 0-17.778Z",
            fill: "#6888B5"
        })
    });
var $1ea565f58b88b6e4$export$2e2bcd8739ae039 = $1ea565f58b88b6e4$var$SvgRadioOutline;




const $f648fc672b85050e$var$SvgRadioOutlineHover = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 21,
        height: 21,
        viewBox: "0 0 21 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M.146 10.136c0-5.522 4.477-10 10-10s10 4.478 10 10c0 5.523-4.477 10-10 10s-10-4.477-10-10Zm10-8.889a8.889 8.889 0 1 0 0 17.778 8.889 8.889 0 0 0 0-17.778Z",
                fill: "#6888B5"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M17.368 10.136a7.222 7.222 0 1 1-14.444 0 7.222 7.222 0 0 1 14.444 0Z",
                fill: "#CFD9E9"
            })
        ]
    });
var $f648fc672b85050e$export$2e2bcd8739ae039 = $f648fc672b85050e$var$SvgRadioOutlineHover;




const $873025c664017586$var$SvgRadioOutlinePressed = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 21,
        height: 21,
        viewBox: "0 0 21 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fill: "#6888B5",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M.646 10.136c0-5.522 4.477-10 10-10s10 4.478 10 10c0 5.523-4.477 10-10 10s-10-4.477-10-10Zm10-8.889a8.889 8.889 0 1 0 0 17.778 8.889 8.889 0 0 0 0-17.778Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M17.868 10.136a7.222 7.222 0 1 1-14.444 0 7.222 7.222 0 0 1 14.444 0Z"
                })
            ]
        })
    });
var $873025c664017586$export$2e2bcd8739ae039 = $873025c664017586$var$SvgRadioOutlinePressed;




const $fe5e865658341929$var$SvgRadioOutlineSelected = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 21,
        height: 21,
        viewBox: "0 0 21 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
                fill: "#254B86",
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        d: "M10.146 17.359a7.222 7.222 0 1 0 0-14.445 7.222 7.222 0 0 0 0 14.445Z"
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M10.146.136c-5.523 0-10 4.478-10 10 0 5.523 4.477 10 10 10s10-4.477 10-10c0-5.522-4.477-10-10-10Zm-8.889 10a8.889 8.889 0 1 1 17.778 0 8.889 8.889 0 0 1-17.778 0Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("defs", {
                children: /*#__PURE__*/ (0, $7XTbi$jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        fill: "#fff",
                        transform: "translate(.146 .136)",
                        d: "M0 0h20v20H0z"
                    })
                })
            })
        ]
    });
var $fe5e865658341929$export$2e2bcd8739ae039 = $fe5e865658341929$var$SvgRadioOutlineSelected;




const $bb08c77c96d31bb6$var$SvgReassign = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M7.324 12.467c2.053-1.072 4.502-1.106 6.534-.028.404.214.604.34.732.434.088.065.137.109.206.17l.152.134a.5.5 0 0 0 .648-.762 5.705 5.705 0 0 1-.096-.085c-.088-.078-.193-.17-.317-.262a6.885 6.885 0 0 0-.856-.513c-2.337-1.238-5.134-1.191-7.466.026l-.669.35a3.922 3.922 0 0 0-2.106 3.476V20.5a.5.5 0 0 0 1 0v-5.093c0-1.088.604-2.086 1.569-2.59l.67-.35Z",
                fill: "#3751FF"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.665 3a3.564 3.564 0 1 0 0 7.128 3.564 3.564 0 0 0 0-7.128ZM8.1 6.564a2.564 2.564 0 1 1 5.128 0 2.564 2.564 0 0 1-5.128 0Z",
                fill: "#3751FF"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M18.064 19.889a.498.498 0 0 0 .706.008l1.992-1.94a.504.504 0 0 0 0-.721l-1.954-1.878a.502.502 0 0 0-.693.725l.896.862h-7.346a.5.5 0 0 0 0 1h7.68l-1.27 1.236a.502.502 0 0 0-.011.708Z",
                fill: "#3751FF"
            })
        ]
    });
var $bb08c77c96d31bb6$export$2e2bcd8739ae039 = $bb08c77c96d31bb6$var$SvgReassign;




const $94fb0f94563d2f84$var$SvgReassignItem = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fill: "#212328",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M5.233 4.34c-1.012 0-1.833.82-1.833 1.833v11.654c0 1.013.82 1.834 1.833 1.834H8.9a.5.5 0 0 0 0-1H5.233a.833.833 0 0 1-.833-.834V6.173c0-.46.373-.833.833-.833h8.844c.46 0 .833.373.833.833v5.34a.5.5 0 1 0 1 0v-5.34c0-1.013-.82-1.833-1.833-1.833H5.233Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M18.032 12.655a.5.5 0 0 1 .707-.014l2.507 2.41a.5.5 0 0 1 .003.719l-2.557 2.49a.5.5 0 0 1-.698-.716l1.634-1.592h-9.96a.5.5 0 1 1 0-1H19.7l-1.654-1.59a.5.5 0 0 1-.014-.707Z"
                })
            ]
        })
    });
var $94fb0f94563d2f84$export$2e2bcd8739ae039 = $94fb0f94563d2f84$var$SvgReassignItem;




const $2e08d42978d2896b$var$SvgReassignUser = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fill: "#212328",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M7.724 12.467c2.053-1.072 4.502-1.106 6.535-.028.403.214.604.34.731.434.088.065.137.109.206.17.04.036.087.078.153.134a.5.5 0 0 0 .647-.762l-.096-.085c-.088-.078-.193-.17-.317-.262a6.87 6.87 0 0 0-.856-.513c-2.337-1.238-5.134-1.191-7.466.026l-.669.35a3.922 3.922 0 0 0-2.106 3.476V20.5a.5.5 0 0 0 1 0v-5.093c0-1.088.605-2.086 1.569-2.59l.67-.35Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11.065 3a3.564 3.564 0 1 0 0 7.128 3.564 3.564 0 0 0 0-7.128ZM8.501 6.564a2.564 2.564 0 1 1 5.128 0 2.564 2.564 0 0 1-5.128 0Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M18.464 19.889a.498.498 0 0 0 .706.008l1.992-1.94a.505.505 0 0 0 0-.721l-1.954-1.878a.502.502 0 0 0-.693.725l.896.862h-7.346a.5.5 0 0 0 0 1h7.68l-1.269 1.236a.502.502 0 0 0-.012.708Z"
                })
            ]
        })
    });
var $2e08d42978d2896b$export$2e2bcd8739ae039 = $2e08d42978d2896b$var$SvgReassignUser;




const $bd1843b8604bf03b$var$SvgRefresh = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            d: "M4.64 9.285a8 8 0 0 1 13.077-2.662l1.974 1.975h-3.23a.5.5 0 1 0 0 1h4.427a.499.499 0 0 0 .51-.5V4.661a.5.5 0 1 0-1 0v3.23l-1.974-1.974A9 9 0 0 0 3.712 8.912a.5.5 0 1 0 .927.373ZM18.398 17.376a7.975 7.975 0 0 0 1.764-2.662.5.5 0 0 1 .927.374 9 9 0 0 1-14.713 2.996l-1.974-1.975v3.23a.5.5 0 1 1-1 0v-4.437a.498.498 0 0 1 .506-.5H8.34a.5.5 0 0 1 0 1H5.109l1.975 1.975a8 8 0 0 0 11.314-.001Z",
            fill: "#212328"
        })
    });
var $bd1843b8604bf03b$export$2e2bcd8739ae039 = $bd1843b8604bf03b$var$SvgRefresh;




const $f86d1a25415b9921$var$SvgReject = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.4 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM7.108 6A8 8 0 0 1 18.4 17.293L7.107 6.001Zm-.708.708A8 8 0 0 0 17.692 18L6.4 6.707Z",
            fill: "#212328"
        })
    });
var $f86d1a25415b9921$export$2e2bcd8739ae039 = $f86d1a25415b9921$var$SvgReject;




const $f3f2cbd8c1b0ba98$var$SvgRejectSph = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 17,
        height: 17,
        viewBox: "0 0 17 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.726 2.049a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm-3.529 2a5.333 5.333 0 0 1 7.528 7.528L5.197 4.049Zm-.471.472a5.333 5.333 0 0 0 7.528 7.528L4.726 4.52Z",
            fill: "#CC1C10"
        })
    });
var $f3f2cbd8c1b0ba98$export$2e2bcd8739ae039 = $f3f2cbd8c1b0ba98$var$SvgRejectSph;




const $b9c633ddbd4ed232$var$SvgRemove = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 17,
        viewBox: "0 0 16 17",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2 8.5c0-.184.15-.333.333-.333h11.334a.333.333 0 0 1 0 .666H2.333A.333.333 0 0 1 2 8.5Z",
            fill: "#fff"
        })
    });
var $b9c633ddbd4ed232$export$2e2bcd8739ae039 = $b9c633ddbd4ed232$var$SvgRemove;




const $8515f9049fa76acb$var$SvgRequestAccess = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.067 2.526a1.91 1.91 0 1 0 .507 2.883l1.398.807-.284.491a.333.333 0 0 0 .578.334l.283-.492.593.343-.509.881a.333.333 0 1 0 .578.333l.675-1.17a.333.333 0 0 0-.122-.455l-1.16-.67a.34.34 0 0 0-.02-.011l-1.677-.969a1.91 1.91 0 0 0-.84-2.305ZM5.035 3.558a1.243 1.243 0 1 1 2.153 1.243 1.243 1.243 0 0 1-2.153-1.243ZM8.656 9.498a.999.999 0 0 1 .5.81l3.283-1.257a1.15 1.15 0 0 1 .977 2.074l-4.225 2.39a1.666 1.666 0 0 1-1.264.155l-2.218-.613a2.333 2.333 0 0 0-1.244 0l-1.593.441a.333.333 0 0 1-.419-.273l-.45-3.096a.333.333 0 0 1 .217-.361l1.27-.457a.555.555 0 0 0 .204-.13l.708-.707a1.667 1.667 0 0 1 2.01-.267l2.244 1.291Zm-3.782-.553a1 1 0 0 1 1.205-.16l2.245 1.29a.333.333 0 0 1-.248.611l-2.2-.563a.333.333 0 1 0-.166.646l2.2.563c.3.077.608.01.843-.165a.331.331 0 0 0 .072-.018l3.853-1.476a.483.483 0 0 1 .41.872l-4.225 2.39a1 1 0 0 1-.759.093l-2.218-.613a3 3 0 0 0-1.598 0l-1.23.34-.356-2.452 1.013-.364c.17-.061.323-.159.45-.286l.709-.708Z",
            fill: "#fff"
        })
    });
var $8515f9049fa76acb$export$2e2bcd8739ae039 = $8515f9049fa76acb$var$SvgRequestAccess;




const $24aac56ab10dc3c1$var$SvgRequestApproval = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fill: "#212328",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M4.04 4.167C4.04 3.522 4.561 3 5.205 3H15.85a3.167 3.167 0 0 1 3.167 3.167v1.827a.5.5 0 0 1-1 0V6.167C18.017 4.97 17.047 4 15.85 4H5.206a.167.167 0 0 0-.167.167v13.34c0 1.196.97 2.166 2.167 2.166h2.328a.5.5 0 1 1 0 1H7.206a3.167 3.167 0 0 1-3.167-3.167V4.166Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M7.504 6.118a.5.5 0 0 0 0 1h7.847a.5.5 0 0 0 0-1H7.503ZM7.004 9.598a.5.5 0 0 1 .5-.5h3.335a.5.5 0 0 1 0 1H7.504a.5.5 0 0 1-.5-.5ZM7.004 12.577a.5.5 0 0 1 .5-.5h.948a.5.5 0 0 1 0 1h-.948a.5.5 0 0 1-.5-.5ZM11.339 15.432a4.567 4.567 0 0 1 6.577-4.102.5.5 0 1 0 .44-.898 5.567 5.567 0 1 0 1.988 1.64.5.5 0 0 0-.764-.038l-3.933 4.237-1.225-1.283a.5.5 0 1 0-.723.69l1.591 1.667a.5.5 0 0 0 .728-.005l3.863-4.16a4.567 4.567 0 1 1-8.542 2.252Z"
                })
            ]
        })
    });
var $24aac56ab10dc3c1$export$2e2bcd8739ae039 = $24aac56ab10dc3c1$var$SvgRequestApproval;




const $ea7cb99023d8afba$var$SvgRequestHistory = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 21,
        height: 21,
        viewBox: "0 0 21 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M4.208 2.983a.972.972 0 0 0-.972.972v11.117a2.639 2.639 0 0 0 2.639 2.639h1.94a.417.417 0 1 0 0-.834h-1.94a1.806 1.806 0 0 1-1.806-1.805V3.955c0-.076.062-.139.14-.139h8.87c.996 0 1.805.809 1.805 1.806v1.523a.417.417 0 1 0 .833 0V5.622a2.639 2.639 0 0 0-2.639-2.639h-8.87Z",
                fill: "#212328"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M5.707 5.998c0-.23.186-.416.416-.416h6.539a.417.417 0 0 1 0 .833H6.123a.417.417 0 0 1-.416-.417ZM6.123 8.065a.417.417 0 0 0 0 .833h2.78a.417.417 0 0 0 0-.833h-2.78ZM6.123 10.547a.417.417 0 1 0 0 .833h.79a.417.417 0 1 0 0-.833h-.79ZM13.542 10.685a.417.417 0 0 0-.834 0v2.926c0 .11.044.216.122.295l1.219 1.218a.416.416 0 1 0 .59-.589l-1.097-1.097v-2.753Z",
                fill: "#212328"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.486 13.344a4.64 4.64 0 1 1 9.278 0 4.64 4.64 0 0 1-9.278 0Zm4.639-3.806a3.806 3.806 0 1 0 0 7.612 3.806 3.806 0 0 0 0-7.612Z",
                fill: "#212328"
            })
        ]
    });
var $ea7cb99023d8afba$export$2e2bcd8739ae039 = $ea7cb99023d8afba$var$SvgRequestHistory;




const $2e5d38074a046e48$var$SvgRequired = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 12,
        height: 24,
        viewBox: "0 0 12 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            d: "M1.456 9.928a.323.323 0 0 1-.144-.288c0-.064.021-.128.064-.192 0-.01.032-.048.096-.112l1.088-.96-1.456-.144L.976 8.2c-.085-.021-.15-.08-.192-.176a.336.336 0 0 1-.032-.272l.368-1.104c.021-.085.08-.15.176-.192a.336.336 0 0 1 .176-.048c.021 0 .048.005.08.016.032 0 .075.021.128.064l1.264.736-.32-1.424-.016-.128a.352.352 0 0 1 .352-.352h1.168c.096 0 .176.037.24.112a.336.336 0 0 1 .112.24l-.016.128-.336 1.44 1.28-.752.128-.064a.178.178 0 0 1 .08-.016c.085 0 .16.021.224.064a.237.237 0 0 1 .128.176l.368 1.104.016.096c0 .075-.027.15-.08.224a.308.308 0 0 1-.16.128l-.128.032-1.472.144 1.104.96c.064.064.096.101.096.112a.344.344 0 0 1 .064.192.323.323 0 0 1-.144.288l-.928.688a.459.459 0 0 1-.208.048c-.139 0-.235-.043-.288-.128l-.064-.112-.592-1.36-.592 1.36a.426.426 0 0 1-.08.112c-.053.085-.15.128-.288.128a.459.459 0 0 1-.208-.048l-.928-.688Z",
            fill: "#CC1C10"
        })
    });
var $2e5d38074a046e48$export$2e2bcd8739ae039 = $2e5d38074a046e48$var$SvgRequired;




const $a6d6bfb396aa09db$var$SvgRequiredInactive = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 12,
        height: 24,
        viewBox: "0 0 12 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            d: "M1.456 9.928a.323.323 0 0 1-.144-.288c0-.064.021-.128.064-.192 0-.01.032-.048.096-.112l1.088-.96-1.456-.144L.976 8.2c-.085-.021-.15-.08-.192-.176a.336.336 0 0 1-.032-.272l.368-1.104c.021-.085.08-.15.176-.192a.336.336 0 0 1 .176-.048c.021 0 .048.005.08.016.032 0 .075.021.128.064l1.264.736-.32-1.424-.016-.128a.352.352 0 0 1 .352-.352h1.168c.096 0 .176.037.24.112a.336.336 0 0 1 .112.24l-.016.128-.336 1.44 1.28-.752.128-.064a.178.178 0 0 1 .08-.016c.085 0 .16.021.224.064a.237.237 0 0 1 .128.176l.368 1.104.016.096c0 .075-.027.15-.08.224a.308.308 0 0 1-.16.128l-.128.032-1.472.144 1.104.96c.064.064.096.101.096.112a.344.344 0 0 1 .064.192.323.323 0 0 1-.144.288l-.928.688a.459.459 0 0 1-.208.048c-.139 0-.235-.043-.288-.128l-.064-.112-.592-1.36-.592 1.36a.426.426 0 0 1-.08.112c-.053.085-.15.128-.288.128a.459.459 0 0 1-.208-.048l-.928-.688Z",
            fill: "#A36A00"
        })
    });
var $a6d6bfb396aa09db$export$2e2bcd8739ae039 = $a6d6bfb396aa09db$var$SvgRequiredInactive;




const $802edaa9ae2feb1c$var$SvgResize = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("g", {
            fill: "#254B86",
            children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M13.902 2.569a.333.333 0 0 0-.471-.471L2.098 13.43a.333.333 0 0 0 .471.471L13.902 2.57ZM13.894 7.234a.333.333 0 1 0-.471-.471l-6.667 6.666a.333.333 0 0 0 .472.472l6.666-6.667Z"
            })
        })
    });
var $802edaa9ae2feb1c$export$2e2bcd8739ae039 = $802edaa9ae2feb1c$var$SvgResize;




const $5b723d6c075f827a$var$SvgRetry = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            d: "M4.123 6.877a6.667 6.667 0 1 1-.59 5.893.417.417 0 0 0-.78.294 7.5 7.5 0 1 0 .807-6.85v-2.53a.417.417 0 1 0-.833 0v3.61c0 .23.186.417.417.417h3.61a.417.417 0 1 0 0-.834H4.123Z",
            fill: "#00245B"
        })
    });
var $5b723d6c075f827a$export$2e2bcd8739ae039 = $5b723d6c075f827a$var$SvgRetry;




const $6cbf5b850dfed368$var$SvgRevoked = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fill: "#00245B",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M9.579 3a3.564 3.564 0 1 0 0 7.128 3.564 3.564 0 0 0 0-7.128ZM7.015 6.564a2.564 2.564 0 1 1 5.128 0 2.564 2.564 0 0 1-5.128 0Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M5.652 12.701c2.354-1.402 5.29-1.349 7.659.062a.5.5 0 1 0 .511-.86c-2.668-1.59-5.999-1.66-8.682-.06l-.347.206A3.672 3.672 0 0 0 3 15.204V20.5a.5.5 0 0 0 1 0v-5.296c0-.942.496-1.814 1.304-2.296l.348-.207ZM18.682 14.146a.5.5 0 0 1 0 .708l-2.475 2.474 2.475 2.475a.5.5 0 0 1-.707.707L15.5 18.035l-2.475 2.475a.5.5 0 1 1-.707-.707l2.475-2.475-2.475-2.474a.5.5 0 0 1 .707-.708l2.475 2.475 2.475-2.475a.5.5 0 0 1 .707 0Z"
                })
            ]
        })
    });
var $6cbf5b850dfed368$export$2e2bcd8739ae039 = $6cbf5b850dfed368$var$SvgRevoked;




const $9301384b43c41c12$var$SvgRole = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 21,
        viewBox: "0 0 20 21",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.057 3.212a2.64 2.64 0 1 0 0 5.278 2.64 2.64 0 0 0 0-5.278ZM8.251 5.85a1.806 1.806 0 1 1 3.612 0 1.806 1.806 0 0 1-3.612 0Z",
                fill: "#00245B"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M6.699 10.67a6.45 6.45 0 0 1 6.602 0 1.3 1.3 0 0 1 .635 1.116v4.62a.417.417 0 1 0 .833 0v-4.62c0-.752-.396-1.448-1.041-1.833a7.283 7.283 0 0 0-.82-.42 3.467 3.467 0 0 1 3.488.035c.168.1.27.281.27.476v3.722a.417.417 0 1 0 .834 0v-3.722c0-.489-.257-.942-.678-1.192a4.3 4.3 0 0 0-4.4 0l-.474.282a.422.422 0 0 0-.058.042 7.289 7.289 0 0 0-3.781 0 .42.42 0 0 0-.059-.041l-.474-.283a4.298 4.298 0 0 0-4.399 0c-.42.25-.677.703-.677 1.192v3.722a.417.417 0 1 0 .833 0v-3.722c0-.195.103-.376.27-.476a3.464 3.464 0 0 1 3.487-.034 7.293 7.293 0 0 0-.818.42 2.133 2.133 0 0 0-1.041 1.832v4.62a.417.417 0 0 0 .833 0v-4.62a1.3 1.3 0 0 1 .635-1.117Z",
                fill: "#00245B"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3.736 6.134a1.673 1.673 0 1 1 3.346 0 1.673 1.673 0 0 1-3.346 0Zm1.673-.84a.84.84 0 1 0 0 1.68.84.84 0 0 0 0-1.68ZM16.263 6.134a1.673 1.673 0 1 0-3.346 0 1.673 1.673 0 0 0 3.346 0Zm-1.673-.84a.84.84 0 1 1 0 1.68.84.84 0 0 1 0-1.68Z",
                fill: "#00245B"
            })
        ]
    });
var $9301384b43c41c12$export$2e2bcd8739ae039 = $9301384b43c41c12$var$SvgRole;




const $3720e6bfc4840f79$var$SvgRows = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.59 3c-1.013 0-1.834.82-1.834 1.833v14.334c0 1.012.821 1.833 1.834 1.833h14.333c1.013 0 1.833-.82 1.833-1.833V4.833c0-1.012-.82-1.833-1.833-1.833H5.59Zm-.834 1.833c0-.46.373-.833.834-.833h14.333c.46 0 .833.373.833.833V7.25h-16V4.833Zm0 3.417v3.25h16V8.25h-16Zm0 7.5V12.5h16v3.25h-16Zm0 1v2.417c0 .46.373.833.834.833h14.333c.46 0 .833-.373.833-.833V16.75h-16Z",
            fill: "#212328"
        })
    });
var $3720e6bfc4840f79$export$2e2bcd8739ae039 = $3720e6bfc4840f79$var$SvgRows;




const $45b41290c48964bc$var$SvgSad = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fill: "#212328",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "m16.156 15.4.4-.3a.5.5 0 0 1-.8.6l-.007-.009a3.57 3.57 0 0 0-.186-.211 4.565 4.565 0 0 0-.604-.526c-.529-.385-1.278-.754-2.203-.754-.924 0-1.673.37-2.202.754a4.558 4.558 0 0 0-.756.694l-.035.043-.007.009a.5.5 0 0 1-.8-.6v-.001h.002l.001-.003.005-.006.015-.02.053-.065a5.562 5.562 0 0 1 .933-.86c.64-.465 1.591-.945 2.791-.945s2.152.48 2.791.945a5.565 5.565 0 0 1 .933.86c.023.027.04.05.054.065l.015.02.005.006.001.002v.001l-.399.3ZM10.69 9.45a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0ZM15.49 10.117a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12.756 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm-8 9a8 8 0 1 1 16 0 8 8 0 0 1-16 0Z"
                })
            ]
        })
    });
var $45b41290c48964bc$export$2e2bcd8739ae039 = $45b41290c48964bc$var$SvgSad;




const $d8e8cbf93c8fd9e6$var$SvgSavNothingToShow = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 66,
        height: 64,
        viewBox: "0 0 66 64",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "m6.577 25.2 26.456 13.227L59.489 25.2M6.577 33.11v14.137l26.456 13.228 26.456-13.228V33.109",
                stroke: "#00245B",
                strokeWidth: 1.761,
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "m6.577 25.2 7.781-3.891m45.13 3.89-15.1-7.55M6.568 25.21 1 30.78l26.456 13.227 5.422-5.422M33.035 38.43l5.51 5.509L65 30.71l-5.431-5.432",
                stroke: "#00245B",
                strokeWidth: 1.761,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M33.033 42.992v17.482",
                stroke: "#00245B",
                strokeWidth: 1.761,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M35.544 32.086s4.152-4.03 2.704-8.162c-3.165-9.029-19.505 1.814-20.666-7.748-.676-5.567 3.567-11.614 8.788-11.055 5.794.62 8.407 8.934 13.712 8.472 4.062-.354 8.016-6.716 8.016-6.716",
                stroke: "#6E7FFF",
                strokeWidth: 1.761,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeDasharray: "3.52 4.7"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "m46.731 6.361-.863-1.154a1.817 1.817 0 0 0-3.029.18v0A1.817 1.817 0 0 0 44.198 8.1l1.431.17M48.366 7.305l1.432.17a1.817 1.817 0 0 1 1.358 2.713v0a1.817 1.817 0 0 1-3.029.18l-.863-1.154",
                stroke: "#00245B",
                strokeWidth: 1.761,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M46.437 8.823 48.11 6.35",
                stroke: "#00245B",
                strokeWidth: 2.936,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $d8e8cbf93c8fd9e6$export$2e2bcd8739ae039 = $d8e8cbf93c8fd9e6$var$SvgSavNothingToShow;




const $da492545fa25e9c7$var$SvgSaveView = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 25,
        viewBox: "0 0 24 25",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M12.002 3.501a.5.5 0 0 1 .5.5v8.904l1.737-1.738a.5.5 0 1 1 .707.707l-2.572 2.573a.5.5 0 0 1-.727.02l-2.592-2.593a.5.5 0 1 1 .707-.707l1.74 1.74V4.002a.5.5 0 0 1 .5-.5Z",
                fill: "#00245B"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M4.316 19.665c0 1.013.821 1.834 1.834 1.834h11.7c1.013 0 1.834-.821 1.834-1.834V8.563c0-1.013-.82-1.833-1.833-1.833H16.15a.5.5 0 0 0 0 1h1.7c.46 0 .834.373.834.833v11.102c0 .46-.373.834-.833.834H6.15a.833.833 0 0 1-.834-.834V8.563c0-.46.373-.833.834-.833h2a.5.5 0 0 0 0-1h-2c-1.013 0-1.834.82-1.834 1.833v11.102Z",
                fill: "#00245B"
            })
        ]
    });
var $da492545fa25e9c7$export$2e2bcd8739ae039 = $da492545fa25e9c7$var$SvgSaveView;




const $041e47b3894c6d81$var$SvgSaviCompSph = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 17,
        height: 17,
        viewBox: "0 0 17 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.5 2.5a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm-3.528 2a5.333 5.333 0 0 1 7.528 7.528L4.972 4.5Zm-.472.472a5.333 5.333 0 0 0 7.528 7.528L4.5 4.972Z",
                fill: "url(#a)"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("defs", {
                children: /*#__PURE__*/ (0, $7XTbi$jsxs)("linearGradient", {
                    id: "a",
                    x1: 2.5,
                    y1: 14.5,
                    x2: 14.5,
                    y2: 2.5,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $7XTbi$jsx)("stop", {
                            stopColor: "#4C00AC"
                        }),
                        /*#__PURE__*/ (0, $7XTbi$jsx)("stop", {
                            offset: 1,
                            stopColor: "#8000AC"
                        })
                    ]
                })
            })
        ]
    });
var $041e47b3894c6d81$export$2e2bcd8739ae039 = $041e47b3894c6d81$var$SvgSaviCompSph;




const $329d723da32f012d$var$SvgSaviCompanion = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M12.946 3.067a.5.5 0 0 0-.5 0L9.904 4.535a.5.5 0 0 0 .5.866l2.292-1.324 6.86 3.962V11a.5.5 0 0 0 1 0V7.75a.5.5 0 0 0-.25-.433l-7.36-4.25Z",
                fill: "url(#a)"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M8.07 5.593a.5.5 0 0 1 .123-.05.499.499 0 0 1 .418.037l2.63 1.516 1.205-.696a.5.5 0 0 1 .5 0l4.474 2.584a.5.5 0 0 1 .25.433v5.166a.5.5 0 0 1-.25.433l-1.036.598a.5.5 0 0 1-.5-.866l.786-.453v-4.59l-3.974-2.294-1.182.682a.498.498 0 0 1-.206.065.498.498 0 0 1-.33-.06L8.353 6.585 5.834 8.039V11a.5.5 0 0 1-1 0V7.75a.5.5 0 0 1 .25-.433l2.987-1.724Z",
                fill: "url(#b)"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M5.834 13a.5.5 0 0 0-1 0v3.25a.5.5 0 0 0 .25.433l7.362 4.25a.5.5 0 0 0 .5 0l2.66-1.536a.5.5 0 0 0-.5-.866l-2.41 1.392-6.862-3.962V13Z",
                fill: "url(#c)"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M20.557 13a.5.5 0 0 0-1 0v2.961l-2.302 1.33-2.644-1.524a.5.5 0 0 0-.554.036l-1.361.786-3.975-2.294v-4.59l.869-.501a.5.5 0 0 0-.5-.866l-1.119.646a.5.5 0 0 0-.25.433v5.166a.5.5 0 0 0 .25.433l4.475 2.584a.5.5 0 0 0 .5 0l1.42-.82 2.612 1.505a.498.498 0 0 0 .31.063.497.497 0 0 0 .251-.067l2.768-1.598a.5.5 0 0 0 .25-.433V13Z",
                fill: "url(#d)"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M12.954 9.405a.504.504 0 0 0-.517 0l-1.868 1.079a.5.5 0 0 0-.25.433v2.166a.5.5 0 0 0 .25.433l.47.271a.5.5 0 0 0 .5-.866l-.22-.126v-1.59l1.377-.794 1.376.794v1.59l-1.626.939a.5.5 0 0 0 .5.866l1.876-1.084a.5.5 0 0 0 .25-.433v-2.166a.5.5 0 0 0-.25-.433l-1.868-1.079Z",
                fill: "url(#e)"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7XTbi$jsxs)("linearGradient", {
                        id: "a",
                        x1: 4.834,
                        y1: 21,
                        x2: 22.671,
                        y2: 5.42,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7XTbi$jsx)("stop", {
                                stopColor: "#4C00AC"
                            }),
                            /*#__PURE__*/ (0, $7XTbi$jsx)("stop", {
                                offset: 1,
                                stopColor: "#8000AC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsxs)("linearGradient", {
                        id: "b",
                        x1: 4.834,
                        y1: 21,
                        x2: 22.671,
                        y2: 5.42,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7XTbi$jsx)("stop", {
                                stopColor: "#4C00AC"
                            }),
                            /*#__PURE__*/ (0, $7XTbi$jsx)("stop", {
                                offset: 1,
                                stopColor: "#8000AC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsxs)("linearGradient", {
                        id: "c",
                        x1: 4.834,
                        y1: 21,
                        x2: 22.671,
                        y2: 5.42,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7XTbi$jsx)("stop", {
                                stopColor: "#4C00AC"
                            }),
                            /*#__PURE__*/ (0, $7XTbi$jsx)("stop", {
                                offset: 1,
                                stopColor: "#8000AC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsxs)("linearGradient", {
                        id: "d",
                        x1: 4.834,
                        y1: 21,
                        x2: 22.671,
                        y2: 5.42,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7XTbi$jsx)("stop", {
                                stopColor: "#4C00AC"
                            }),
                            /*#__PURE__*/ (0, $7XTbi$jsx)("stop", {
                                offset: 1,
                                stopColor: "#8000AC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsxs)("linearGradient", {
                        id: "e",
                        x1: 4.834,
                        y1: 21,
                        x2: 22.671,
                        y2: 5.42,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7XTbi$jsx)("stop", {
                                stopColor: "#4C00AC"
                            }),
                            /*#__PURE__*/ (0, $7XTbi$jsx)("stop", {
                                offset: 1,
                                stopColor: "#8000AC"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $329d723da32f012d$export$2e2bcd8739ae039 = $329d723da32f012d$var$SvgSaviCompanion;




const $25b394404c7cfe7d$var$SvgSaviOwnReview = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 73,
        height: 73,
        viewBox: "0 0 73 73",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.566 14.833a.9.9 0 0 1 .9-.9h18.859a.9.9 0 0 1 0 1.8h-18.86a.9.9 0 0 1-.9-.9ZM17.566 19.548a.9.9 0 0 1 .9-.9h18.859a.9.9 0 1 1 0 1.8h-18.86a.9.9 0 0 1-.9-.9ZM17.566 28.977a.9.9 0 0 1 .9-.9h33.003a.9.9 0 0 1 0 1.8H18.466a.9.9 0 0 1-.9-.9ZM17.566 43.121a.9.9 0 0 1 .9-.9h7.032a.9.9 0 1 1 0 1.8h-7.032a.9.9 0 0 1-.9-.9Zm30.64 0a.9.9 0 0 1 .9-.9h2.363a.9.9 0 1 1 0 1.8h-2.363a.9.9 0 0 1-.9-.9ZM17.566 33.692a.9.9 0 0 1 .9-.9h10.957a.9.9 0 0 1 0 1.8H18.466a.9.9 0 0 1-.9-.9Zm26.772 0a.9.9 0 0 1 .9-.9h6.231a.9.9 0 1 1 0 1.8h-6.23a.9.9 0 0 1-.9-.9ZM17.566 47.836a.9.9 0 0 1 .9-.9h7.712a.9.9 0 1 1 0 1.8h-7.712a.9.9 0 0 1-.9-.9ZM17.566 38.407a.9.9 0 0 1 .9-.9h7.661a.9.9 0 0 1 0 1.8h-7.661a.9.9 0 0 1-.9-.9ZM43.22 38.782a.9.9 0 0 1 0 1.273l-7.072 7.072a.9.9 0 0 1-1.273 0l-3.445-3.445a.9.9 0 0 1 1.273-1.273l2.808 2.809 6.436-6.436a.9.9 0 0 1 1.273 0Z",
                fill: "#FC3DA6"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M58.742 19.68a5.674 5.674 0 0 1 1.067 3.322v32.772a.9.9 0 0 1-1.8 0V23.002a3.9 3.9 0 0 0-3.9-3.9h-9.344a.9.9 0 0 1-.9-.9V4.958H14.16a1.5 1.5 0 0 0-1.5 1.5v51.777a1.5 1.5 0 0 0 1.5 1.5h32.855a.9.9 0 0 1 0 1.8H14.16a3.3 3.3 0 0 1-3.3-3.3V7.95a1.479 1.479 0 0 0-1.157 1.443v49.4a3.9 3.9 0 0 0 3.9 3.9H49.47a.9.9 0 1 1 0 1.8H13.604a5.7 5.7 0 0 1-5.7-5.7v-49.4a3.279 3.279 0 0 1 2.974-3.264 3.3 3.3 0 0 1 3.283-2.971h30.565a.933.933 0 0 1 .07 0 .898.898 0 0 1 .663.326l.004.006L58.57 19.353c.082.1.14.21.173.327ZM45.665 6.56v10.742h8.444c.15 0 .298.006.445.017L45.664 6.56Z",
                fill: "#00245B"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "m45.439 3.462.024.028-.024-.028ZM37.325 33.825a9.134 9.134 0 0 0-8.785 6.637.3.3 0 0 1-.577-.164c1.155-4.082 4.91-7.073 9.362-7.073a.3.3 0 1 1 0 .6ZM28.062 41.157a.3.3 0 0 1 .249.344 9.199 9.199 0 0 0-.116 1.454.3.3 0 1 1-.6 0 9.8 9.8 0 0 1 .123-1.55.3.3 0 0 1 .344-.248ZM46.755 42.654a.3.3 0 0 1 .3.3c0 .608-.056 1.203-.163 1.78a.3.3 0 0 1-.59-.11c.1-.54.153-1.099.153-1.67a.3.3 0 0 1 .3-.3ZM46.19 46.189a.3.3 0 0 1 .167.39 9.747 9.747 0 0 1-7.065 5.906.3.3 0 0 1-.12-.588 9.146 9.146 0 0 0 6.628-5.541.3.3 0 0 1 .39-.167ZM38.434 52.324a.3.3 0 0 1-.274.325 9.865 9.865 0 0 1-.835.035.3.3 0 0 1 0-.6c.264 0 .526-.011.784-.033a.3.3 0 0 1 .325.273Z",
                fill: "#00245B"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M24.638 42.955c0-7.007 5.68-12.687 12.687-12.687s12.687 5.68 12.687 12.687c0 3.085-1.102 5.914-2.933 8.113l2.115 2.115 1.03-1.03a.9.9 0 0 1 1.273 0L63.165 63.82a3.257 3.257 0 0 1-4.606 4.606L46.89 56.76a.9.9 0 0 1 0-1.273l1.03-1.03-2.088-2.09a12.64 12.64 0 0 1-8.507 3.275c-7.007 0-12.687-5.68-12.687-12.686Zm12.687-10.887c-6.013 0-10.887 4.874-10.887 10.887 0 6.012 4.874 10.886 10.887 10.886 6.013 0 10.887-4.874 10.887-10.886 0-6.013-4.874-10.887-10.887-10.887Zm11.474 24.054 2.062-2.06.422.422-1.426 1.426a.3.3 0 0 0 .424.425l1.426-1.427.41.41-1.426 1.426a.3.3 0 1 0 .424.424l1.426-1.426.41.409-1.01 1.01a.3.3 0 1 0 .424.424l1.01-1.01 8.518 8.518a1.457 1.457 0 0 1-2.062 2.061L48.8 56.122Z",
                fill: "#00245B"
            })
        ]
    });
var $25b394404c7cfe7d$export$2e2bcd8739ae039 = $25b394404c7cfe7d$var$SvgSaviOwnReview;




const $d61427d74748ad7c$var$SvgSaviResetChat = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 25,
        viewBox: "0 0 25 25",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M6.951 8.833a.5.5 0 0 1 .5-.5h9.333a.5.5 0 1 1 0 1H7.451a.5.5 0 0 1-.5-.5ZM7.451 11.666a.5.5 0 0 0 0 1h6.667a.5.5 0 1 0 0-1H7.45Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3.118 6.166c0-1.012.82-1.833 1.833-1.833h14.333c1.013 0 1.834.82 1.834 1.833v8.667c0 1.012-.821 1.833-1.834 1.833h-7.457c-.545 0-1.07.206-1.47.575L6.79 20.534a.5.5 0 0 1-.839-.368v-3.333a.167.167 0 0 0-.167-.167h-.833a1.833 1.833 0 0 1-1.833-1.833V6.166Zm1.833-.833a.833.833 0 0 0-.833.833v8.667c0 .46.373.833.833.833h.833c.645 0 1.167.523 1.167 1.167v2.191l2.728-2.518a3.167 3.167 0 0 1 2.148-.84h7.457c.46 0 .834-.373.834-.833V6.166a.833.833 0 0 0-.834-.833H4.951Z",
                fill: "#fff"
            })
        ]
    });
var $d61427d74748ad7c$export$2e2bcd8739ae039 = $d61427d74748ad7c$var$SvgSaviResetChat;




const $28ed693ff770056c$var$SvgSaviSmartApprove = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 57,
        height: 57,
        viewBox: "0 0 57 57",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M28.419 13.523a.7.7 0 0 1 .7.7v3.866a.7.7 0 1 1-1.4 0v-3.866a.7.7 0 0 1 .7-.7ZM23.442 14.51a.7.7 0 0 1 .914.38l1.478 3.573a.7.7 0 0 1-1.294.535l-1.477-3.573a.7.7 0 0 1 .379-.914ZM20.2 17.337a.7.7 0 0 0-.99.99l2.733 2.734a.7.7 0 1 0 .99-.99L20.2 17.337ZM16.39 21.555a.7.7 0 0 1 .914-.378l3.571 1.481a.7.7 0 1 1-.536 1.293l-3.571-1.481a.7.7 0 0 1-.379-.915ZM16.095 25.846a.7.7 0 1 0 0 1.4h3.866a.7.7 0 1 0 0-1.4h-3.866ZM16.383 31.523a.7.7 0 0 1 .38-.915l3.572-1.477a.7.7 0 1 1 .535 1.294l-3.572 1.477a.7.7 0 0 1-.915-.38ZM19.21 34.765a.7.7 0 0 0 .99.99l2.733-2.734a.7.7 0 1 0-.99-.99l-2.734 2.734ZM33.904 32.032a.7.7 0 0 1 .99 0l2.734 2.733a.7.7 0 1 1-.99.99l-2.734-2.733a.7.7 0 0 1 0-.99ZM36.498 29.141a.7.7 0 1 0-.536 1.293l3.57 1.482a.7.7 0 0 0 .537-1.293L36.5 29.14ZM36.176 26.546a.7.7 0 0 1 .7-.7h3.866a.7.7 0 1 1 0 1.4h-3.866a.7.7 0 0 1-.7-.7ZM35.967 22.668a.7.7 0 1 0 .535 1.293l3.572-1.477a.7.7 0 0 0-.534-1.294l-3.573 1.478ZM33.904 21.061a.7.7 0 0 1 0-.99l2.734-2.734a.7.7 0 1 1 .99.99l-2.734 2.734a.7.7 0 0 1-.99 0ZM31.22 18.497a.7.7 0 0 0 1.32.467l1.262-3.567a.7.7 0 0 0-1.32-.467l-1.262 3.567Z",
                fill: "#D057FF"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M28.483 4.025c-12.425 0-22.497 10.072-22.497 22.497 0 5.25 1.797 10.077 4.81 13.904a.7.7 0 0 1-1.1.866 23.798 23.798 0 0 1-5.11-14.77c0-13.198 10.7-23.897 23.897-23.897 13.198 0 23.898 10.699 23.898 23.897 0 5.574-1.91 10.705-5.11 14.77a.7.7 0 1 1-1.1-.866 22.398 22.398 0 0 0 4.81-13.904c0-12.425-10.073-22.497-22.498-22.497Z",
                fill: "#00245B"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M28.418 10.324c-6.42 0-11.969 3.736-14.59 9.153a.233.233 0 1 1-.42-.203c2.696-5.573 8.404-9.417 15.01-9.417a.233.233 0 0 1 0 .467ZM44.85 26.289c.129 0 .233.104.233.233 0 5.056-2.251 9.586-5.805 12.642a.233.233 0 0 1-.305-.354 16.161 16.161 0 0 0 5.644-12.288c0-.129.104-.233.233-.233Z",
                fill: "#00245B"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M22.47 10.166a.233.233 0 0 1-.136.3c-.628.239-1.238.512-1.827.82a.233.233 0 1 1-.216-.415 17.527 17.527 0 0 1 1.877-.84.233.233 0 0 1 .301.135ZM19.123 11.81c.07.109.04.253-.068.324-4.697 3.063-7.801 8.363-7.801 14.388a.233.233 0 0 1-.467 0c0-6.19 3.19-11.633 8.013-14.78a.233.233 0 0 1 .323.069ZM43.731 34.791a.233.233 0 0 1 .09.318 17.7 17.7 0 0 1-3.253 4.19.233.233 0 1 1-.322-.338 17.234 17.234 0 0 0 3.168-4.08.233.233 0 0 1 .317-.09Z",
                fill: "#00245B"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M26.102 30.458a4.566 4.566 0 1 0-2.172-4.779l-9.456 4.598a1.984 1.984 0 0 0 1.513 3.66l10.115-3.48Zm-.85-3.936a3.166 3.166 0 1 1 6.333 0 3.166 3.166 0 0 1-6.333 0Zm-1.343.724-8.823 4.29a.584.584 0 0 0 .446 1.077l9.341-3.213a4.546 4.546 0 0 1-.964-2.154Z",
                fill: "#00245B"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M29.75 41.604h11.586a.7.7 0 0 0 .468-.18 19.982 19.982 0 0 0 6.646-14.902c0-11.063-8.969-20.031-20.032-20.031s-20.03 8.968-20.03 20.03a19.982 19.982 0 0 0 6.645 14.904.7.7 0 0 0 .468.179h8.166c-.118.139-.234.28-.346.425-.56.723-1.058 1.565-1.217 2.59a.66.66 0 0 1-.167.35c-.076.078-.146.102-.206.102h-3.204a.7.7 0 0 0-.7.7v7.059a.7.7 0 0 0 .7.7h4.678c.045 0 .089.013.126.037l.949.613c.717.464 1.553.711 2.407.711h7.318a2.103 2.103 0 0 0 1.834-3.136 2.102 2.102 0 0 0 .435-3.177c.334-.373.537-.864.537-1.404 0-.539-.203-1.03-.537-1.403a2.103 2.103 0 0 0-1.567-3.507h-4.285c-.443 0-.535-.124-.563-.165-.052-.076-.1-.224-.109-.495ZM28.418 7.891c-10.29 0-18.63 8.341-18.63 18.63a18.58 18.58 0 0 0 5.984 13.683h9.15l.132-.151c.35-.41.546-.925.657-1.518.093-.491.121-.986.15-1.49l.022-.36c.02-.301.046-.612.098-.9.051-.283.136-.589.298-.86.172-.288.427-.53.787-.662.343-.125.718-.126 1.1-.057.482.087.883.288 1.194.598.305.305.483.675.592 1.042.194.66.193 1.445.193 2.088v.118c0 .59-.096 1.213-.187 1.769l-.03.186-.033.197h11.17a18.58 18.58 0 0 0 5.985-13.682c0-10.29-8.342-18.631-18.632-18.631Zm-1.33 30.903c-.138.729-.403 1.507-.971 2.17-.222.259-.458.517-.686.765l-.194.214a15.9 15.9 0 0 0-.81.944c-.49.632-.832 1.252-.94 1.946-.075.489-.353 1.015-.803 1.335v5.962h.52c.315 0 .623.09.888.262l.948.613c.49.317 1.063.486 1.647.486h7.327a.703.703 0 0 0-.008-1.406.7.7 0 1 1 0-1.4h.702a.703.703 0 0 0 0-1.407.701.701 0 1 1 0-1.4.703.703 0 0 0 .012-1.407h-.013a.7.7 0 0 1-.7-.7v-.009a.7.7 0 0 1 .7-.691h.013a.703.703 0 1 0-.032-1.407h-4.266c-.728 0-1.345-.227-1.72-.777-.337-.494-.373-1.108-.347-1.625.024-.47.11-.993.191-1.48l.03-.187c.093-.563.169-1.08.169-1.543v-.016c0-.733 0-1.334-.136-1.794-.063-.214-.146-.354-.239-.447-.086-.086-.218-.17-.453-.211-.233-.042-.337-.018-.371-.006-.017.007-.035.014-.065.064a1.23 1.23 0 0 0-.123.394c-.037.203-.059.447-.078.74l-.018.315c-.03.509-.064 1.114-.175 1.703Zm-6.104 7.677h.3v5.659h-2.057v-5.66h.445v2.2a.233.233 0 0 0 .466 0v-2.2h.38v3.167a.233.233 0 0 0 .466 0v-3.166Z",
                fill: "#00245B"
            })
        ]
    });
var $28ed693ff770056c$export$2e2bcd8739ae039 = $28ed693ff770056c$var$SvgSaviSmartApprove;




const $7d7495f6144daaa6$var$SvgSaviSmartDecisions = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 73,
        height: 73,
        viewBox: "0 0 73 73",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M28.74 7.737a.3.3 0 1 0-.194-.567c-.482.165-.945.37-1.387.608a.3.3 0 1 0 .285.528 8.655 8.655 0 0 1 1.297-.569ZM25.674 9.57a.3.3 0 0 0-.406-.442 9.276 9.276 0 0 0-2.997 6.839 9.27 9.27 0 0 0 2.631 6.482.3.3 0 1 0 .43-.418 8.67 8.67 0 0 1-2.461-6.064c0-2.53 1.08-4.808 2.803-6.398ZM40.87 15.967a.3.3 0 1 0-.6 0c0 .363-.022.72-.065 1.072a.3.3 0 0 0 .596.073c.046-.375.07-.758.07-1.145ZM40.471 18.672a.3.3 0 1 0-.574-.174 8.721 8.721 0 0 1-3.693 4.834.3.3 0 1 0 .32.508 9.321 9.321 0 0 0 3.947-5.168ZM35.333 24.474a.3.3 0 0 0-.243-.548 8.669 8.669 0 0 1-3.52.74.3.3 0 1 0 0 .6 9.27 9.27 0 0 0 3.763-.792Z",
                fill: "#00245B"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M31.57 3.16c-7.073 0-12.807 5.733-12.807 12.807 0 7.073 5.734 12.807 12.808 12.807 7.073 0 12.807-5.734 12.807-12.807 0-7.074-5.734-12.808-12.807-12.808ZM20.564 15.966c0-6.08 4.928-11.008 11.008-11.008 6.079 0 11.007 4.929 11.007 11.008 0 6.079-4.928 11.007-11.007 11.007-6.08 0-11.008-4.928-11.008-11.007ZM23.526 41.52a8.044 8.044 0 1 1 16.089 0 8.044 8.044 0 0 1-16.089 0Zm8.045-6.244a6.244 6.244 0 1 0 0 12.49 6.244 6.244 0 0 0 0-12.49ZM31.57 54.267a8.044 8.044 0 1 0 0 16.09 8.044 8.044 0 0 0 0-16.09Zm-6.244 8.045a6.244 6.244 0 1 1 12.489 0 6.244 6.244 0 0 1-12.489 0Z",
                fill: "#00245B"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M46.509 13.243a.9.9 0 0 1 .9-.9h21.79a.9.9 0 1 1 0 1.8H47.41a.9.9 0 0 1-.9-.9ZM47.408 17.79a.9.9 0 0 0 0 1.8h13.62a.9.9 0 1 0 0-1.8h-13.62ZM41.917 38.797a.9.9 0 0 1 .9-.9h21.791a.9.9 0 0 1 0 1.8H42.817a.9.9 0 0 1-.9-.9ZM42.817 43.345a.9.9 0 0 0 0 1.8h13.62a.9.9 0 1 0 0-1.8h-13.62ZM41.917 59.588a.9.9 0 0 1 .9-.9h21.791a.9.9 0 0 1 0 1.8H42.817a.9.9 0 0 1-.9-.9ZM42.817 64.136a.9.9 0 1 0 0 1.8h13.62a.9.9 0 0 0 0-1.8h-13.62Z",
                fill: "#00245B"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M32.436 14.061a.3.3 0 0 0 .3.3h2.787a.3.3 0 0 1 .263.444l-4.517 8.298c-.15.273-.564.168-.564-.143v-5.085a.3.3 0 0 0-.3-.3h-2.787a.3.3 0 0 1-.263-.444l4.518-8.3c.148-.274.563-.168.563.143v5.087ZM12.184 10.148a.9.9 0 0 0-1.273 1.272l2.635 2.635H6.2a3.3 3.3 0 0 0-3.3 3.3v42.557a3.3 3.3 0 0 0 3.3 3.3h3.365a.9.9 0 1 0 0-1.8H6.2a1.5 1.5 0 0 1-1.5-1.5V17.355a1.5 1.5 0 0 1 1.5-1.5h7.374l-2.663 2.663a.9.9 0 1 0 1.273 1.273l4.185-4.185a.9.9 0 0 0 0-1.273l-4.185-4.185ZM12.329 61.412a.9.9 0 1 0 0 1.8h3.485a.9.9 0 0 0 0-1.8h-3.485ZM17.798 62.312a.9.9 0 0 1 .9-.9H19.7a.9.9 0 0 1 0 1.8h-1.002a.9.9 0 0 1-.9-.9Z",
                fill: "#6E7FFF"
            })
        ]
    });
var $7d7495f6144daaa6$export$2e2bcd8739ae039 = $7d7495f6144daaa6$var$SvgSaviSmartDecisions;




const $7f38fb7b9caf2018$var$SvgSaviSmartReject = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 57,
        height: 57,
        viewBox: "0 0 57 57",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M28.185 13.523a.7.7 0 0 1 .7.7v3.866a.7.7 0 1 1-1.4 0v-3.866a.7.7 0 0 1 .7-.7ZM23.209 14.51a.7.7 0 0 1 .914.38l1.477 3.573a.7.7 0 1 1-1.293.535l-1.478-3.573a.7.7 0 0 1 .38-.914ZM19.966 17.337a.7.7 0 0 0-.99.99l2.734 2.734a.7.7 0 1 0 .99-.99l-2.734-2.734ZM16.156 21.555a.7.7 0 0 1 .915-.378l3.57 1.481a.7.7 0 1 1-.536 1.293l-3.57-1.481a.7.7 0 0 1-.38-.915ZM15.861 25.846a.7.7 0 1 0 0 1.4h3.867a.7.7 0 1 0 0-1.4H15.86ZM16.15 31.523a.7.7 0 0 1 .38-.915l3.572-1.477a.7.7 0 1 1 .535 1.294l-3.573 1.477a.7.7 0 0 1-.914-.38ZM18.976 34.765a.7.7 0 0 0 .99.99l2.734-2.734a.7.7 0 1 0-.99-.99l-2.734 2.734ZM33.67 32.032a.7.7 0 0 1 .99 0l2.734 2.733a.7.7 0 1 1-.99.99l-2.734-2.733a.7.7 0 0 1 0-.99ZM36.265 29.141a.7.7 0 0 0-.537 1.293l3.571 1.482a.7.7 0 0 0 .537-1.293l-3.571-1.482ZM35.943 26.546a.7.7 0 0 1 .7-.7h3.866a.7.7 0 1 1 0 1.4h-3.867a.7.7 0 0 1-.7-.7ZM35.733 22.668a.7.7 0 1 0 .535 1.293l3.573-1.477a.7.7 0 0 0-.535-1.294l-3.573 1.478ZM33.67 21.061a.7.7 0 0 1 0-.99l2.734-2.734a.7.7 0 0 1 .99.99l-2.734 2.734a.7.7 0 0 1-.99 0ZM31.85 15.886a.7.7 0 1 0 1.294.537l.41-.991a.7.7 0 1 0-1.292-.537l-.411.991Z",
                fill: "#FF4451"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M28.25 4.025c-12.425 0-22.497 10.072-22.497 22.497 0 5.25 1.796 10.077 4.81 13.904a.7.7 0 0 1-1.101.866 23.798 23.798 0 0 1-5.11-14.77c0-13.198 10.7-23.897 23.898-23.897s23.897 10.699 23.897 23.897c0 5.574-1.909 10.705-5.109 14.77a.7.7 0 0 1-1.1-.866 22.398 22.398 0 0 0 4.81-13.904c0-12.425-10.073-22.497-22.498-22.497Z",
                fill: "#00245B"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M19.567 11.628a.233.233 0 0 0-.243-.398c-.589.358-1.153.75-1.69 1.172a.233.233 0 1 0 .288.367c.523-.41 1.072-.792 1.645-1.141ZM16.658 13.54a.233.233 0 0 1-.007.33c-4.053 3.876-6.128 9.657-5.019 15.579a.233.233 0 1 1-.458.086c-1.14-6.084.992-12.022 5.154-16.002a.233.233 0 0 1 .33.007ZM45.224 31.892a.233.233 0 1 0-.442-.149 17.236 17.236 0 0 1-2.362 4.593.233.233 0 0 0 .378.274 17.7 17.7 0 0 0 2.426-4.718Z",
                fill: "#00245B"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M13.072 21.497c1.904-5.709 6.927-10.126 13.294-10.95a.233.233 0 1 0-.06-.464c-6.551.849-11.718 5.394-13.676 11.267a.233.233 0 1 0 .442.147ZM44.712 24.269a.233.233 0 0 1 .261.201 16.628 16.628 0 0 1-4.134 13.283.233.233 0 1 1-.347-.312 16.162 16.162 0 0 0 4.019-12.91.233.233 0 0 1 .201-.262Z",
                fill: "#00245B"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m33.596 13.21-5.793 8.761a4.567 4.567 0 1 0 4.526 2.63l4.697-9.41a1.984 1.984 0 0 0-3.43-1.98Zm1.946.589a.584.584 0 0 0-.778.184l-5.378 8.132c.78.212 1.476.625 2.03 1.18l4.357-8.73a.584.584 0 0 0-.23-.766Zm-7.357 9.556a3.166 3.166 0 1 0 0 6.333 3.166 3.166 0 0 0 0-6.332Z",
                fill: "#00245B"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M41.102 41.604h-3.36v1.676a.7.7 0 0 1-.7.7h-3.204c-.06 0-.13.024-.206.102a.659.659 0 0 0-.167.35c-.159 1.025-.657 1.867-1.218 2.59-.28.362-.585.705-.88 1.029l-.206.226c-.225.246-.44.481-.646.722-.351.41-.546.924-.658 1.518-.092.49-.12.985-.15 1.49l-.021.358c-.02.302-.046.613-.098.9a2.57 2.57 0 0 1-.298.862c-.172.287-.428.53-.787.661-.343.125-.718.126-1.1.058-.482-.087-.883-.289-1.194-.6a2.408 2.408 0 0 1-.592-1.04c-.195-.66-.194-1.445-.193-2.088v-.12c0-.59.095-1.212.186-1.768l.031-.186c.083-.502.155-.94.174-1.326.023-.448-.039-.667-.105-.765-.029-.042-.12-.166-.564-.166h-4.285a2.103 2.103 0 0 1-1.567-3.507 2.096 2.096 0 0 1-.519-1.676h-3.507a.7.7 0 0 1-.468-.18 19.983 19.983 0 0 1-6.646-14.902c0-11.063 8.968-20.031 20.031-20.031 11.063 0 20.031 8.968 20.031 20.03a19.983 19.983 0 0 1-6.646 14.904.7.7 0 0 1-.468.179ZM9.555 26.522c0-10.29 8.341-18.631 18.631-18.631 10.29 0 18.631 8.341 18.631 18.63a18.58 18.58 0 0 1-5.985 13.683h-3.089v-3.982a.7.7 0 0 0-.7-.7h-4.678a.233.233 0 0 1-.127-.038l-.948-.613a4.433 4.433 0 0 0-2.408-.71h-7.307l-.011-.001a2.103 2.103 0 0 0-1.833 3.136 2.102 2.102 0 0 0-.64 2.908h-3.551a18.58 18.58 0 0 1-5.985-13.682Zm19.898 21.566c-.568.662-.833 1.44-.97 2.17-.111.588-.146 1.194-.175 1.702l-.018.315a6.716 6.716 0 0 1-.079.74 1.224 1.224 0 0 1-.122.394c-.03.05-.048.058-.065.064-.034.012-.139.037-.371-.005-.235-.043-.367-.125-.454-.212-.093-.092-.175-.232-.238-.447-.136-.46-.136-1.061-.136-1.794V51c0-.462.076-.98.168-1.543l.03-.186c.081-.487.168-1.01.192-1.481.026-.516-.01-1.13-.347-1.625-.375-.55-.992-.777-1.721-.777H20.861a.703.703 0 0 1-.013-1.407h.013a.7.7 0 0 0 .7-.693v-.007a.7.7 0 0 0-.7-.7h-.013a.703.703 0 0 1 .013-1.406.7.7 0 0 0 .406-1.27l-.007-.006a.697.697 0 0 0-.399-.124.703.703 0 1 1 0-1.407h.702a.7.7 0 0 0 .7-.7V37.649a.7.7 0 0 0-.7-.682.703.703 0 0 1-.008-1.407h7.326c.585 0 1.157.169 1.648.486l.948.614c.264.17.572.262.887.262h.52v5.961c-.45.32-.727.846-.803 1.335-.107.694-.45 1.315-.94 1.947-.245.316-.518.624-.809.944l-.19.207-.005.006c-.227.249-.463.506-.685.765Zm6.445-5.508h.445v-5.658h-2.057v5.658h.3v-3.166a.233.233 0 0 1 .466 0v3.166h.38v-2.2a.233.233 0 0 1 .466 0v2.2Z",
                fill: "#00245B"
            })
        ]
    });
var $7f38fb7b9caf2018$export$2e2bcd8739ae039 = $7f38fb7b9caf2018$var$SvgSaviSmartReject;




const $c3efc9eb60727c4e$var$SvgSaviSph = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 17,
        height: 17,
        viewBox: "0 0 17 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.402 4.144c.13.13.13.34 0 .471l-8.25 8.242a.334.334 0 0 1-.471 0l-3.084-3.1a.333.333 0 0 1 .473-.47l2.848 2.863 8.013-8.007c.13-.13.341-.13.472 0Z",
                fill: "url(#a)"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("defs", {
                children: /*#__PURE__*/ (0, $7XTbi$jsxs)("linearGradient", {
                    id: "a",
                    x1: 2.5,
                    y1: 12.955,
                    x2: 11.028,
                    y2: 1.468,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $7XTbi$jsx)("stop", {
                            stopColor: "#4C00AC"
                        }),
                        /*#__PURE__*/ (0, $7XTbi$jsx)("stop", {
                            offset: 1,
                            stopColor: "#8000AC"
                        })
                    ]
                })
            })
        ]
    });
var $c3efc9eb60727c4e$export$2e2bcd8739ae039 = $c3efc9eb60727c4e$var$SvgSaviSph;




const $94e95aa1eee547d3$var$SvgSaviyntCertified = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.304 3.707a1.5 1.5 0 0 1 2.192 0l.777.831a.5.5 0 0 0 .382.158l1.137-.038a1.5 1.5 0 0 1 1.55 1.55l-.038 1.137a.5.5 0 0 0 .158.382l.831.777a1.5 1.5 0 0 1 0 2.192l-.831.777a.5.5 0 0 0-.158.382l.038 1.137a1.5 1.5 0 0 1-1.55 1.55l-.176-.006.615 6.147a.5.5 0 0 1-.755.479L12.4 19.316l-3.076 1.846a.5.5 0 0 1-.755-.479l.615-6.147-.176.006a1.5 1.5 0 0 1-1.55-1.55l.039-1.137a.5.5 0 0 0-.159-.382l-.831-.777a1.5 1.5 0 0 1 0-2.192l.831-.777a.5.5 0 0 0 .159-.382l-.039-1.137a1.5 1.5 0 0 1 1.55-1.55l1.137.038a.5.5 0 0 0 .382-.158l.777-.831Zm2.969 10.955a.5.5 0 0 1 .335-.158l.529 5.288-2.48-1.488a.5.5 0 0 0-.514 0l-2.48 1.488.53-5.288a.5.5 0 0 1 .334.158l.777.83a1.5 1.5 0 0 0 2.192 0l.777-.83ZM12.765 4.39a.5.5 0 0 0-.73 0l-.777.83a1.5 1.5 0 0 1-1.147.476l-1.137-.039a.5.5 0 0 0-.516.517l.038 1.137a1.5 1.5 0 0 1-.475 1.147l-.831.776a.5.5 0 0 0 0 .731l.831.777a1.5 1.5 0 0 1 .475 1.146l-.038 1.138a.5.5 0 0 0 .516.516l1.137-.038a1.5 1.5 0 0 1 1.147.475l.777.831a.5.5 0 0 0 .73 0l.777-.831a1.5 1.5 0 0 1 1.147-.475l1.137.038a.5.5 0 0 0 .517-.516l-.039-1.137a1.5 1.5 0 0 1 .475-1.147l.831-.777a.5.5 0 0 0 0-.73l-.831-.777a1.5 1.5 0 0 1-.475-1.147l.039-1.137a.5.5 0 0 0-.517-.517l-1.137.039a1.5 1.5 0 0 1-1.147-.475l-.777-.831Z",
                fill: "#212328"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M12.468 12.267c-.44 0-.83-.063-1.17-.188a1.726 1.726 0 0 1-.804-.58c-.197-.262-.304-.587-.32-.998-.003-.054.024-.073.072-.073h1.141c.048 0 .083.024.083.073v.458l.927.65.926-.65v-.147a.433.433 0 0 0-.164-.367 1.072 1.072 0 0 0-.433-.232 7.116 7.116 0 0 0-.55-.148c-.215-.05-.431-.099-.647-.162a2.746 2.746 0 0 1-.618-.264 1.385 1.385 0 0 1-.464-.446c-.117-.181-.176-.416-.176-.706 0-.316.08-.59.241-.824.161-.234.392-.414.694-.54.302-.127.732-.19 1.164-.19a3.5 3.5 0 0 1 1.096.175c.305.104.539.267.726.498.204.253.33.531.33.943 0 .051-.016.074-.072.074H13.4c-.044 0-.077-.025-.077-.073v-.31l-.926-.65-.927.65v.153c.004.175.054.257.173.35.119.092.282.12.473.166.219.054.372.089.543.127.242.055.449.1.681.161.23.06.446.156.639.27.193.114.348.245.466.426.117.182.175.418.175.71 0 .36-.086.663-.259.91-.173.247-.42.434-.743.562-.322.128-.706.192-1.15.192Z",
                fill: "#212328"
            })
        ]
    });
var $94e95aa1eee547d3$export$2e2bcd8739ae039 = $94e95aa1eee547d3$var$SvgSaviyntCertified;




const $fdad0bbf65a21247$var$SvgSaviyntLogoFilled = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.4 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm-2.196 13.957c.679.251 1.458.376 2.337.376.89 0 1.657-.127 2.302-.383.645-.255 1.14-.63 1.486-1.123.345-.494.518-1.1.518-1.82 0-.584-.117-1.057-.352-1.42-.234-.362-.545-.625-.931-.853a5.03 5.03 0 0 0-1.277-.54c-.43-.111-.816-.198-1.254-.297l-.109-.024a50.398 50.398 0 0 1-1.254-.294c-.31-.073-.576-.136-.778-.294-.237-.184-.337-.349-.345-.699-.003-.139 0-.305 0-.305l1.853-1.3 1.853 1.3V9.9c0 .097.065.146.152.146h2.101c.111 0 .145-.045.145-.148 0-.823-.252-1.379-.662-1.887-.373-.462-.842-.786-1.45-.995a7.004 7.004 0 0 0-2.192-.35c-.865 0-1.724.127-2.328.38-.604.253-1.067.613-1.388 1.08-.321.467-.482 1.016-.482 1.649 0 .579.117 1.05.351 1.412.235.362.544.666.928.892a5.49 5.49 0 0 0 1.237.528c.43.126.864.225 1.293.323.442.1.718.18 1.1.295.375.114.648.263.867.465.218.202.328.377.328.734v.294L12.4 16.02l-1.853-1.3v-.917c0-.097-.07-.146-.167-.146H8.098c-.097 0-.15.04-.145.146.034.822.248 1.473.642 1.995.393.523.93.91 1.609 1.16Z",
            fill: "#212328"
        })
    });
var $fdad0bbf65a21247$export$2e2bcd8739ae039 = $fdad0bbf65a21247$var$SvgSaviyntLogoFilled;




const $5298a389a88fd47f$var$SvgSaviyntLogoFilledSeparateColors = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.098 50c0-20.71 16.79-37.5 37.5-37.5s37.5 16.79 37.5 37.5-16.79 37.5-37.5 37.5-37.5-16.79-37.5-37.5Z",
                fill: "#10123D"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M51.187 72.222c-3.665 0-6.911-.522-9.74-1.565-2.829-1.044-5.064-2.655-6.704-4.834-1.642-2.178-2.532-4.888-2.673-8.314-.018-.445.201-.608.604-.608h9.51c.402 0 .694.203.694.608v3.818l7.72 5.42 7.72-5.42V60.1c0-1.488-.456-2.214-1.367-3.057-.913-.842-2.05-1.462-3.61-1.937a59.537 59.537 0 0 0-4.586-1.23c-1.788-.409-3.592-.821-5.387-1.346-1.796-.526-3.551-1.259-5.152-2.2-1.6-.94-2.89-2.209-3.866-3.718-.977-1.51-1.465-3.47-1.465-5.883 0-2.634.67-4.924 2.009-6.87 1.338-1.946 3.266-3.445 5.783-4.5 2.517-1.053 6.094-1.58 9.698-1.58 3.303 0 6.595.583 9.132 1.454 2.537.872 4.492 2.224 6.046 4.15 1.708 2.115 2.757 4.429 2.757 7.86 0 .427-.14.615-.603.615h-8.754c-.363 0-.635-.203-.635-.608v-2.577l-7.72-5.42-7.72 5.42s-.012.691 0 1.271c.03 1.457.45 2.144 1.435 2.913.993.774 2.355.998 3.947 1.39 1.817.448 3.094.737 4.521 1.058 2.016.454 3.743.837 5.68 1.34 1.907.497 3.709 1.297 5.32 2.247 1.61.95 2.904 2.047 3.88 3.556.977 1.51 1.466 3.481 1.466 5.913 0 3-.72 5.528-2.16 7.585-1.44 2.057-3.503 3.617-6.191 4.681-2.688 1.064-5.884 1.596-9.589 1.596Z",
                fill: "#fff"
            })
        ]
    });
var $5298a389a88fd47f$export$2e2bcd8739ae039 = $5298a389a88fd47f$var$SvgSaviyntLogoFilledSeparateColors;




const $446eaf9115445e8a$var$SvgSearch = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.333 2.5a5.833 5.833 0 1 0 3.763 10.29l.03.034 4.666 4.559a.417.417 0 1 0 .583-.596l-4.666-4.559a.37.37 0 0 0-.018-.017A5.833 5.833 0 0 0 8.334 2.5Zm-5 5.833a5 5 0 1 1 10 0 5 5 0 0 1-10 0Z",
            fill: "#717385"
        })
    });
var $446eaf9115445e8a$export$2e2bcd8739ae039 = $446eaf9115445e8a$var$SvgSearch;




const $42ffb1f92d03f9d1$var$SvgServer = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M4.833 4.531A.833.833 0 0 0 4 5.365v4.062c0 .46.373.833.833.833h14.334c.46 0 .833-.373.833-.833V5.365a.833.833 0 0 0-.833-.834h-8.188a.5.5 0 0 1 0-1h8.188c1.012 0 1.833.821 1.833 1.834v4.062c0 1.013-.82 1.833-1.833 1.833H4.833A1.833 1.833 0 0 1 3 9.427V5.365c0-1.013.82-1.834 1.833-1.834H8.12a.5.5 0 0 1 0 1H4.833Z",
                fill: "#212328"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M6.464 6.896a.5.5 0 0 0 0 1h2.125a.5.5 0 1 0 0-1H6.464ZM6.464 16.104a.5.5 0 1 0 0 1h2.125a.5.5 0 0 0 0-1H6.464ZM10.662 7.396a.5.5 0 0 1 .5-.5h6.374a.5.5 0 0 1 0 1h-6.375a.5.5 0 0 1-.5-.5ZM11.162 16.104a.5.5 0 1 0 0 1h6.374a.5.5 0 0 0 0-1h-6.375Z",
                fill: "#212328"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M20 18.635c0 .46-.373.834-.833.834H15.88a.5.5 0 1 0 0 1h3.287c1.012 0 1.833-.821 1.833-1.834v-4.062c0-1.013-.82-1.833-1.833-1.833H4.833C3.821 12.74 3 13.56 3 14.573v4.062c0 1.013.82 1.834 1.833 1.834h8.188a.5.5 0 0 0 0-1H4.833A.833.833 0 0 1 4 18.635v-4.062c0-.46.373-.833.833-.833h14.334c.46 0 .833.373.833.833v4.062Z",
                fill: "#212328"
            })
        ]
    });
var $42ffb1f92d03f9d1$export$2e2bcd8739ae039 = $42ffb1f92d03f9d1$var$SvgServer;




const $8df340de33e73709$var$SvgSettings = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            fill: "#3751FF",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M9.864 7.54a2.596 2.596 0 1 0 0 5.192 2.596 2.596 0 0 0 0-5.192ZM8.1 10.136a1.763 1.763 0 1 1 3.526 0 1.763 1.763 0 0 1-3.526 0Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M8.416 2.5a.417.417 0 0 0-.381.248l-.72 1.627-1.223.722-1.78-.107a.417.417 0 0 0-.388.21l-1.37 2.418a.417.417 0 0 0 .03.457L3.633 9.46v1.357l-.951 1.46a.417.417 0 0 0-.004.449l1.457 2.317c.077.122.21.195.353.195h1.84l1.284.538.775 1.5a.417.417 0 0 0 .37.225h2.818a.417.417 0 0 0 .38-.248l.712-1.606 1.24-.65h1.811c.15 0 .289-.08.363-.21l1.365-2.41a.417.417 0 0 0-.036-.464l-1.095-1.384V9.197l1-1.45a.417.417 0 0 0 .008-.46l-1.486-2.35a.417.417 0 0 0-.395-.192l-1.775.183-1.27-.67-.786-1.531a.417.417 0 0 0-.37-.227H8.416Zm-.394 2.334.665-1.5h2.3l.728 1.422c.04.076.101.138.177.178l1.498.79a.417.417 0 0 0 .237.046l1.644-.17 1.201 1.9-.916 1.33a.417.417 0 0 0-.074.237v1.606c0 .094.032.185.09.259l1.01 1.277-1.107 1.954h-1.67a.417.417 0 0 0-.193.048l-1.46.764a.416.416 0 0 0-.188.2l-.66 1.492H9.01l-.728-1.41a.416.416 0 0 0-.21-.192l-1.5-.629a.417.417 0 0 0-.162-.032H4.718l-1.193-1.897.873-1.34a.417.417 0 0 0 .068-.228V9.32c0-.09-.03-.179-.085-.251L3.414 7.79l1.107-1.954 1.648.099a.417.417 0 0 0 .237-.057l1.447-.855a.417.417 0 0 0 .169-.19Z"
                })
            ]
        })
    });
var $8df340de33e73709$export$2e2bcd8739ae039 = $8df340de33e73709$var$SvgSettings;




const $6a1fd8d2214ee17f$var$SvgSmartBrain = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 36,
        height: 36,
        viewBox: "0 0 36 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M0 0h36v36H0z"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M13.704 19.811a4.208 4.208 0 1 1-4.119 4.296",
                stroke: "#212328",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M22.297 19.811a4.208 4.208 0 1 0 4.118 4.296M13.99 12.341a4.713 4.713 0 0 1-4.752 5.526M22.01 12.341a4.713 4.713 0 0 0 4.752 5.526",
                stroke: "#212328",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M11.768 24.768a.75.75 0 0 0 .029-1.5l-.03 1.5Zm-5.366-9.866.592.46-.592-.46Zm2.666-1.584.068.747a.75.75 0 0 0 .678-.822l-.746.075Zm8.93-1.698-.749-.016.75.016Zm-.75 12.401a.75.75 0 1 0 1.5-.005l-1.5.005Zm-5.451-.752c-1.746-.034-3.116-.278-4.162-1.208l-.996 1.121c1.469 1.306 3.312 1.55 5.128 1.587l.03-1.5ZM7.635 22.06c-1.092-.97-1.664-2.366-1.634-3.683l-1.5-.034c-.04 1.756.715 3.574 2.138 4.838l.996-1.12Zm-1.634-3.683c.032-1.385.373-2.219.993-3.016l-1.185-.92c-.827 1.064-1.27 2.213-1.308 3.902l1.5.034Zm.993-3.016c.632-.813 1.378-1.227 2.142-1.297L9 12.571c-1.25.114-2.352.791-3.19 1.87l1.184.921Zm2.82-2.12A6.387 6.387 0 0 1 9.89 11.5c.114-.611.314-1.127.58-1.465l-1.178-.929c-.475.603-.74 1.383-.876 2.12a7.884 7.884 0 0 0-.093 2.168l1.492-.151Zm.655-3.207c.632-.803 1.76-1.43 2.596-1.484l-.097-1.497c-1.33.086-2.827.973-3.677 2.052l1.178.929Zm2.596-1.484c1.066-.069 1.942-.04 2.733.478l.822-1.255c-1.234-.809-2.553-.79-3.652-.72l.097 1.497Zm2.733.478c.872.57 1.479 1.306 1.451 2.575l1.5.033c.042-1.944-.974-3.107-2.129-3.863l-.822 1.255Zm1.451 2.575c-.028 1.298-.012 8.828 0 12.417l1.5-.005c-.012-3.605-.028-11.106 0-12.38l-1.5-.032Z",
                fill: "#212328"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M24.233 24.768a.75.75 0 0 1-.03-1.5l.03 1.5Zm5.365-9.866-.592.46.592-.46Zm-2.666-1.584-.068.747a.75.75 0 0 1-.678-.822l.746.075Zm-8.93-1.698.749-.016-.75.016Zm.75 12.401a.75.75 0 1 1-1.5-.005l1.5.005Zm5.451-.752c1.746-.034 3.116-.278 4.162-1.208l.996 1.121c-1.469 1.306-3.312 1.55-5.128 1.587l-.03-1.5Zm4.162-1.208c1.091-.97 1.664-2.366 1.634-3.683l1.5-.034c.04 1.756-.715 3.574-2.138 4.838l-.997-1.12Zm1.634-3.683c-.032-1.385-.373-2.219-.993-3.016l1.184-.92c.828 1.064 1.27 2.213 1.308 3.902l-1.5.034Zm-.993-3.016c-.632-.813-1.378-1.227-2.142-1.297L27 12.571c1.25.114 2.352.791 3.19 1.87l-1.184.921Zm-2.82-2.12c.052-.51.036-1.14-.075-1.742-.114-.611-.314-1.127-.58-1.465l1.178-.929c.475.603.74 1.383.877 2.12.138.748.158 1.521.092 2.168l-1.492-.151Zm-.655-3.207c-.632-.803-1.76-1.43-2.595-1.484l.096-1.497c1.33.086 2.827.973 3.677 2.052l-1.178.929ZM22.936 8.55c-1.067-.069-1.943-.04-2.734.478l-.822-1.255c1.234-.809 2.553-.79 3.652-.72l-.096 1.497Zm-2.734.478c-.872.57-1.479 1.306-1.451 2.575l-1.5.033c-.042-1.944.974-3.107 2.129-3.863l.822 1.255Zm-1.451 2.575c.028 1.298.012 8.828 0 12.417l-1.5-.005c.012-3.605.028-11.106 0-12.38l1.5-.032Z",
                fill: "#212328"
            })
        ]
    });
var $6a1fd8d2214ee17f$export$2e2bcd8739ae039 = $6a1fd8d2214ee17f$var$SvgSmartBrain;




const $ebe4cdebd4cc6947$var$SvgSod = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 21,
        height: 21,
        viewBox: "0 0 21 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M11.194 12.577a.694.694 0 1 1-1.388 0 .694.694 0 0 1 1.388 0ZM10.5 6.744a.754.754 0 0 0-.75.829l.292 2.94a.46.46 0 0 0 .916 0l.293-2.94a.754.754 0 0 0-.751-.83Z",
                fill: "#212328"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.5 3a5.139 5.139 0 0 0-5.139 5.14v7.5c0 .23.187.416.417.416h9.444c.23 0 .417-.187.417-.417v-7.5C15.639 5.301 13.339 3 10.5 3ZM6.194 8.14a4.306 4.306 0 1 1 8.612 0v7.083H6.194V8.139Z",
                fill: "#212328"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M6.71 17.166a.417.417 0 1 0 0 .833h7.565a.417.417 0 1 0 0-.833H6.71Z",
                fill: "#212328"
            })
        ]
    });
var $ebe4cdebd4cc6947$export$2e2bcd8739ae039 = $ebe4cdebd4cc6947$var$SvgSod;




const $6a846eba55ef9400$var$SvgSort = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            d: "M17.378 12.01a.417.417 0 0 1 0 .59l-3.264 3.265a.416.416 0 0 1-.59 0L10.262 12.6a.417.417 0 1 1 .59-.589l2.552 2.553V4.748a.417.417 0 0 1 .833 0v9.816l2.552-2.553a.417.417 0 0 1 .59 0ZM2.622 7.4a.417.417 0 1 0 .59.589l2.552-2.553v9.816a.417.417 0 0 0 .833 0V5.436l2.552 2.553a.417.417 0 1 0 .59-.59L6.475 4.136a.417.417 0 0 0-.59 0L2.623 7.4Z",
            fill: "#212328"
        })
    });
var $6a846eba55ef9400$export$2e2bcd8739ae039 = $6a846eba55ef9400$var$SvgSort;




const $a5910cdd7a0d0d28$var$SvgSortDown = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.26 2.124a.333.333 0 0 0-.52 0L4.184 6.57a.333.333 0 0 0 .26.541h7.112a.333.333 0 0 0 .26-.541L8.261 2.124ZM8 2.866l2.862 3.578H5.138L8 2.866ZM8.26 13.876a.333.333 0 0 1-.52 0L4.184 9.43a.333.333 0 0 1 .26-.541h7.112a.333.333 0 0 1 .26.541l-3.555 4.445Z",
            fill: "#212328"
        })
    });
var $a5910cdd7a0d0d28$export$2e2bcd8739ae039 = $a5910cdd7a0d0d28$var$SvgSortDown;




const $1229793c5f6a2a01$var$SvgSortNone = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 16,
        height: 17,
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("g", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            fill: "#212328",
            children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M8.26 3.005a.333.333 0 0 0-.52 0L4.184 7.45a.333.333 0 0 0 .26.541h7.112a.333.333 0 0 0 .26-.541L8.261 3.005ZM8 3.747l2.862 3.577H5.138L8 3.747ZM8.26 14.756a.333.333 0 0 1-.52 0l-3.556-4.444a.333.333 0 0 1 .26-.542h7.112a.333.333 0 0 1 .26.542l-3.555 4.444Zm2.602-4.319H5.138L8 14.015l2.862-3.578Z"
            })
        })
    });
var $1229793c5f6a2a01$export$2e2bcd8739ae039 = $1229793c5f6a2a01$var$SvgSortNone;




const $e6b5904012ea0e0f$var$SvgSortUp = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.26 2.124a.333.333 0 0 0-.52 0L4.184 6.57a.333.333 0 0 0 .26.541h7.112a.333.333 0 0 0 .26-.541L8.261 2.124ZM8.26 13.876a.333.333 0 0 1-.52 0L4.184 9.43a.333.333 0 0 1 .26-.541h7.112a.333.333 0 0 1 .26.541l-3.555 4.445Zm2.602-4.32H5.138L8 13.134l2.862-3.578Z",
            fill: "#212328"
        })
    });
var $e6b5904012ea0e0f$export$2e2bcd8739ae039 = $e6b5904012ea0e0f$var$SvgSortUp;




const $eb0a486197cf00a5$var$SvgStarFilled = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.9 3.416a.5.5 0 0 1 .476.346l1.894 5.83h6.13a.5.5 0 0 1 .294.904l-4.96 3.603 1.895 5.83a.5.5 0 0 1-.77.56l-4.96-3.604-4.958 3.603a.5.5 0 0 1-.77-.558l1.894-5.83-4.959-3.604a.5.5 0 0 1 .294-.904h6.13l1.894-5.83a.5.5 0 0 1 .476-.346Z",
            fill: "#212328"
        })
    });
var $eb0a486197cf00a5$export$2e2bcd8739ae039 = $eb0a486197cf00a5$var$SvgStarFilled;




const $9d67e94c84fd1a83$var$SvgStarHalfFilled = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.376 3.762a.5.5 0 0 0-.952 0L9.53 9.592H3.4a.5.5 0 0 0-.294.904l4.96 3.603-1.895 5.83a.5.5 0 0 0 .77.56l4.959-3.604 4.96 3.603a.5.5 0 0 0 .769-.558l-1.895-5.83 4.96-3.604a.5.5 0 0 0-.294-.904h-6.13l-1.894-5.83Zm-.47 12.005c.101.002.202.033.288.096l4.008 2.912-1.53-4.712a.5.5 0 0 1 .18-.56l4.01-2.911h-4.955a.5.5 0 0 1-.476-.346l-1.524-4.692v10.213Z",
            fill: "#212328"
        })
    });
var $9d67e94c84fd1a83$export$2e2bcd8739ae039 = $9d67e94c84fd1a83$var$SvgStarHalfFilled;




const $7ed8c89d81a7c428$var$SvgStarOutline = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.9 3.416a.5.5 0 0 1 .476.346l1.894 5.83h6.13a.5.5 0 0 1 .294.904l-4.96 3.603 1.895 5.83a.5.5 0 0 1-.77.56l-4.96-3.604-4.958 3.603a.5.5 0 0 1-.77-.558l1.894-5.83-4.959-3.604a.5.5 0 0 1 .294-.904h6.13l1.894-5.83a.5.5 0 0 1 .476-.346Zm0 2.118-1.531 4.712a.5.5 0 0 1-.476.346H4.94l4.008 2.912a.5.5 0 0 1 .182.559l-1.531 4.712 4.008-2.912a.5.5 0 0 1 .588 0l4.008 2.912-1.53-4.712a.5.5 0 0 1 .18-.56l4.01-2.911h-4.955a.5.5 0 0 1-.476-.346L11.9 5.534Z",
            fill: "#212328"
        })
    });
var $7ed8c89d81a7c428$export$2e2bcd8739ae039 = $7ed8c89d81a7c428$var$SvgStarOutline;




const $78a68170e705ac18$var$SvgStop = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 21,
        height: 21,
        viewBox: "0 0 21 21",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.14 4.282c0-.844.685-1.528 1.528-1.528h11.945c.844 0 1.528.684 1.528 1.528v11.944c0 .844-.684 1.528-1.528 1.528H4.668a1.528 1.528 0 0 1-1.527-1.528V4.282Z",
            fill: "#5D017D"
        })
    });
var $78a68170e705ac18$export$2e2bcd8739ae039 = $78a68170e705ac18$var$SvgStop;




const $4e1dda6281d87acc$var$SvgStopProcess = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 21,
        height: 21,
        viewBox: "0 0 21 21",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M3.833 10.238a6.667 6.667 0 0 1 10.74-5.277h-1.295a.417.417 0 0 0 0 .833H15.5c.23 0 .417-.187.417-.417V3.155a.417.417 0 0 0-.834 0v1.146a7.5 7.5 0 1 0 2.596 3.76.417.417 0 0 0-.797.242 6.667 6.667 0 1 1-13.048 1.935Z",
                fill: "#3751FF"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M13.572 7.755a.417.417 0 0 0-.589-.59L10.5 9.65 8.017 7.166a.417.417 0 0 0-.59.59l2.484 2.482-2.483 2.483a.417.417 0 0 0 .589.59l2.483-2.483 2.483 2.483a.417.417 0 1 0 .59-.59l-2.484-2.483 2.483-2.483Z",
                fill: "#3751FF"
            })
        ]
    });
var $4e1dda6281d87acc$export$2e2bcd8739ae039 = $4e1dda6281d87acc$var$SvgStopProcess;




const $9e29b94c548bf2bd$var$SvgSubtract = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.4 12a.5.5 0 0 1 .5-.5h17a.5.5 0 0 1 0 1h-17a.5.5 0 0 1-.5-.5Z",
            fill: "#212328"
        })
    });
var $9e29b94c548bf2bd$export$2e2bcd8739ae039 = $9e29b94c548bf2bd$var$SvgSubtract;




const $e6c544eeae94aa71$var$SvgSubtractCircle = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M6.688 11.482a.5.5 0 1 0 0 1h10.667a.5.5 0 1 0 0-1H6.688Z",
                fill: "#212328"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.021 2.667a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm-8 9a8 8 0 1 1 16 0 8 8 0 0 1-16 0Z",
                fill: "#212328"
            })
        ]
    });
var $e6c544eeae94aa71$export$2e2bcd8739ae039 = $e6c544eeae94aa71$var$SvgSubtractCircle;




const $77222dece5b8bf1e$var$SvgSuccess = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 32,
        height: 32,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16 28c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12Zm6.249-14.537a.857.857 0 1 0-1.212-1.212l-6.823 6.822-3.25-3.25a.857.857 0 1 0-1.213 1.212l3.857 3.857a.857.857 0 0 0 1.212 0l7.429-7.429Z",
            fill: "#fff"
        })
    });
var $77222dece5b8bf1e$export$2e2bcd8739ae039 = $77222dece5b8bf1e$var$SvgSuccess;




const $d072591f27916707$var$SvgTerminate = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fill: "#212328",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M9.979 3.333a3.564 3.564 0 1 0 0 7.128 3.564 3.564 0 0 0 0-7.128ZM7.415 6.897a2.564 2.564 0 1 1 5.128 0 2.564 2.564 0 0 1-5.128 0Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M6.638 12.8a7.117 7.117 0 0 1 6.54-.025.5.5 0 0 0 .457-.89 8.117 8.117 0 0 0-7.46.03l-.675.352a3.91 3.91 0 0 0-2.1 3.465v5.101a.5.5 0 1 0 1 0v-5.1a2.91 2.91 0 0 1 1.562-2.58l.676-.352Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M20.085 20.012a4.5 4.5 0 1 0-.007.007l.004-.004.003-.003Zm-5.988-5.275a3.5 3.5 0 0 0 4.9 4.9l-4.9-4.9Zm.707-.707 4.9 4.9a3.5 3.5 0 0 0-4.9-4.9Z"
                })
            ]
        })
    });
var $d072591f27916707$export$2e2bcd8739ae039 = $d072591f27916707$var$SvgTerminate;




const $63465845e617bd18$var$SvgTime = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fill: "#212328",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M12.5 6.65a.5.5 0 0 0-1 0v5.888a.5.5 0 0 0 .146.354l2.453 2.453a.5.5 0 0 0 .707-.708L12.5 12.331V6.65Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm-8 9a8 8 0 1 1 16 0 8 8 0 0 1-16 0Z"
                })
            ]
        })
    });
var $63465845e617bd18$export$2e2bcd8739ae039 = $63465845e617bd18$var$SvgTime;




const $814be1174f21653f$var$SvgTooltipArrow = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 8,
        height: 16,
        viewBox: "0 0 8 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            d: "m0 8 8-8v16L0 8Z",
            fill: "#212328"
        })
    });
var $814be1174f21653f$export$2e2bcd8739ae039 = $814be1174f21653f$var$SvgTooltipArrow;




const $3539ae1d403c2ac9$var$SvgUpload = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            d: "M10 17.51a.417.417 0 0 1-.417-.417V6.361L5.98 9.966a.417.417 0 1 1-.59-.59L9.706 5.06a.417.417 0 0 1 .59 0l4.314 4.317a.417.417 0 0 1-.589.59L10.417 6.36v10.732c0 .23-.187.417-.417.417ZM16.616 3.343a.417.417 0 0 0 0-.833H3.384a.417.417 0 1 0 0 .833h13.232Z",
            fill: "#fff"
        })
    });
var $3539ae1d403c2ac9$export$2e2bcd8739ae039 = $3539ae1d403c2ac9$var$SvgUpload;




const $dccfce21d4968457$var$SvgUser = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 44,
        height: 44,
        viewBox: "0 0 44 44",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("rect", {
                x: 1,
                y: 1,
                width: 42,
                height: 42,
                rx: 21,
                fill: "#CFD9E9"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.138 10.001a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm-4.667 6a4.667 4.667 0 1 1 9.334 0 4.667 4.667 0 0 1-9.334 0Z",
                fill: "#254B86"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M13.908 27.278a15.811 15.811 0 0 1 16.184 0 3.453 3.453 0 0 1 1.686 2.966v3.088a.667.667 0 0 0 1.333 0v-3.088a4.786 4.786 0 0 0-2.336-4.112 17.144 17.144 0 0 0-17.55 0 4.786 4.786 0 0 0-2.336 4.112v3.088a.667.667 0 0 0 1.334 0v-3.088c0-1.217.64-2.343 1.685-2.966Z",
                fill: "#254B86"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("rect", {
                x: 1,
                y: 1,
                width: 42,
                height: 42,
                rx: 21,
                stroke: "#F2F4F8",
                strokeWidth: 2
            })
        ]
    });
var $dccfce21d4968457$export$2e2bcd8739ae039 = $dccfce21d4968457$var$SvgUser;




const $757be24f2993f6f1$var$SvgUserNobg = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 17,
        viewBox: "0 0 16 17",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.069 2.5a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-2.333 3a2.333 2.333 0 1 1 4.666 0 2.333 2.333 0 0 1-4.666 0Z",
                fill: "#00245B"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M3.954 11.139a7.905 7.905 0 0 1 8.092 0c.523.311.843.875.843 1.483v1.544a.333.333 0 0 0 .667 0v-1.544c0-.843-.444-1.624-1.169-2.056a8.572 8.572 0 0 0-8.774 0 2.393 2.393 0 0 0-1.168 2.056v1.544a.333.333 0 0 0 .666 0v-1.544c0-.608.32-1.172.843-1.483Z",
                fill: "#00245B"
            })
        ]
    });
var $757be24f2993f6f1$export$2e2bcd8739ae039 = $757be24f2993f6f1$var$SvgUserNobg;




const $b04d5adc061129f6$var$SvgVault = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 24,
        height: 25,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.833 4.631C3.821 4.631 3 5.452 3 6.465v11.088c0 1.013.82 1.834 1.833 1.834h.894v1.41a.5.5 0 0 0 1 0v-1.41h10.448v1.41a.5.5 0 1 0 1 0v-1.41h.992c1.012 0 1.833-.821 1.833-1.834V6.465c0-1.013-.82-1.834-1.833-1.834H4.833Zm12.85 13.756h1.484c.46 0 .833-.373.833-.834V12.51h-1.468a4.322 4.322 0 1 1 0-1H20V6.465a.833.833 0 0 0-.833-.834H4.833A.833.833 0 0 0 4 6.465v11.088c0 .46.373.834.833.834h12.851Zm-.16-6.878a3.322 3.322 0 1 0 0 1h-2.047a1.334 1.334 0 1 1 0-1h2.047Z",
            fill: "#212328"
        })
    });
var $b04d5adc061129f6$export$2e2bcd8739ae039 = $b04d5adc061129f6$var$SvgVault;




const $f2f3d005fda9eb13$var$SvgVisibilityOff = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fill: "#212328",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M20.007 4.462a.5.5 0 0 0-.707-.707l-3.477 3.477c-1.186-.59-2.473-.962-3.79-.962L12 6.271a.508.508 0 0 0-.033 0c-1.831 0-3.605.72-5.13 1.744a14.488 14.488 0 0 0-3.74 3.688.501.501 0 0 0 0 .594 14.485 14.485 0 0 0 3.88 3.78l-2.984 2.985a.5.5 0 0 0 .707.707L20.007 4.462ZM7.701 15.354l1.64-1.64a3.163 3.163 0 0 1 4.39-4.39l1.342-1.341c-.986-.448-2.015-.713-3.04-.713H12a.508.508 0 0 1-.033 0c-1.572 0-3.154.622-4.573 1.575A13.532 13.532 0 0 0 4.114 12a13.53 13.53 0 0 0 3.28 3.155c.102.068.204.134.307.199Zm5.303-5.302a2.163 2.163 0 0 0-2.936 2.936l2.936-2.936Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "m14.935 10.854-.822.823a2.163 2.163 0 0 1-2.42 2.42l-.823.822a3.163 3.163 0 0 0 4.065-4.065Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M11.967 16.73c-.82 0-1.641-.17-2.441-.466l-.77.77c1.021.433 2.106.695 3.211.695h.066c1.831 0 3.605-.72 5.13-1.744a14.484 14.484 0 0 0 3.74-3.688.502.502 0 0 0 0-.594 14.53 14.53 0 0 0-3.38-3.437l-.716.717A13.573 13.573 0 0 1 19.887 12a13.53 13.53 0 0 1-3.281 3.155c-1.419.953-3 1.574-4.573 1.574L12 16.73a.515.515 0 0 0-.033 0Z"
                })
            ]
        })
    });
var $f2f3d005fda9eb13$export$2e2bcd8739ae039 = $f2f3d005fda9eb13$var$SvgVisibilityOff;




const $e9dd00f2b344c48d$var$SvgVisibilityOn = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            fill: "#254B86",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "M9.973 7.323a2.636 2.636 0 1 0 0 5.273 2.636 2.636 0 0 0 0-5.273ZM8.17 9.96a1.803 1.803 0 1 1 3.605 0 1.803 1.803 0 0 1-3.605 0Z"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                    d: "m9.973 14.775.027-.001h.027c1.527 0 3.005-.6 4.276-1.453a12.07 12.07 0 0 0 3.12-3.079.418.418 0 0 0 0-.484 12.07 12.07 0 0 0-3.12-3.079c-1.271-.854-2.75-1.454-4.276-1.454L10 5.226h-.027c-1.527 0-3.005.6-4.276 1.453a12.071 12.071 0 0 0-3.12 3.079.418.418 0 0 0 0 .484 12.07 12.07 0 0 0 3.12 3.079c1.271.854 2.75 1.454 4.276 1.454ZM6.162 7.37a11.276 11.276 0 0 0-2.734 2.63 11.276 11.276 0 0 0 2.734 2.628c1.182.795 2.5 1.313 3.81 1.313h.055c1.31 0 2.629-.518 3.811-1.313A11.277 11.277 0 0 0 16.572 10a11.277 11.277 0 0 0-2.734-2.629c-1.182-.794-2.5-1.312-3.81-1.312L10 6.058h-.027c-1.31 0-2.629.519-3.811 1.313Z"
                })
            ]
        })
    });
var $e9dd00f2b344c48d$export$2e2bcd8739ae039 = $e9dd00f2b344c48d$var$SvgVisibilityOn;




const $65e39a408da4e7b1$var$SvgWarning = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 32,
        height: 32,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.213 24.49 14.434 5.836a1.792 1.792 0 0 1 3.128 0L27.789 24.49a1.757 1.757 0 0 1-1.564 2.591H5.777a1.754 1.754 0 0 1-1.564-2.591Zm10.22-11.59a1.558 1.558 0 1 1 3.09 0l-.751 6.02a.8.8 0 0 1-1.587 0l-.753-6.02Zm1.545 10.25a1.412 1.412 0 1 0 0-2.824 1.412 1.412 0 0 0 0 2.824Z",
            fill: "#212328"
        })
    });
var $65e39a408da4e7b1$export$2e2bcd8739ae039 = $65e39a408da4e7b1$var$SvgWarning;




const $00392e192e2f6fba$var$SvgWorkflow = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.167 3.183a.5.5 0 1 0-.708.706l1.071 1.074H8.096a3.833 3.833 0 0 0 0 7.667h5.742a2.833 2.833 0 1 1 0 5.667H7.333v-.5c0-.645-.522-1.167-1.166-1.167h-2c-.645 0-1.167.522-1.167 1.167v2c0 .644.522 1.166 1.167 1.166h2c.644 0 1.166-.522 1.166-1.166v-.5h6.505a3.833 3.833 0 0 0 0-7.667H8.096a2.833 2.833 0 1 1 0-5.667h6.434l-1.07 1.074a.5.5 0 0 0 .707.706l1.922-1.927a.5.5 0 0 0 0-.706l-1.922-1.927ZM4 17.797c0-.093.075-.167.167-.167h2c.092 0 .166.074.166.167v2a.167.167 0 0 1-.166.166h-2A.167.167 0 0 1 4 19.797v-2ZM18.833 3.296a2.167 2.167 0 1 0 0 4.334 2.167 2.167 0 0 0 0-4.334Zm-1.166 2.167a1.167 1.167 0 1 1 2.333 0 1.167 1.167 0 0 1-2.333 0Z",
            fill: "#212328"
        })
    });
var $00392e192e2f6fba$export$2e2bcd8739ae039 = $00392e192e2f6fba$var$SvgWorkflow;





const $1745e04e4ee31a1f$var$SIZES = {
    "xx-xxxSmall": "xx-xxxSmall",
    "x-xxxSmall": "x-xxxSmall",
    xxxSmall: "xxxSmall",
    xxSmall: "xxSmall",
    xSmall: "xSmall",
    small: "small",
    smallMedium: "smallMedium",
    medium: "medium",
    large: "large",
    xLarge: "xLarge",
    xxLarge: "xxLarge"
};
function $1745e04e4ee31a1f$var$Icon({ kind: kind, color: color, size: size, rotate: rotate, className: className, dataTestId: dataTestId }) {
    if (!kind) return null;
    const iconName = kind.charAt(0).toUpperCase() + kind.slice(1);
    const IconSvg = $836fa012cc7cf7fa$exports[iconName];
    const classes = (0, $7XTbi$classnames)("Icon", size && `Icon--${size}`, rotate && `Icon--rotate-${rotate}`, className);
    return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $f4c5e95c338bfebc$export$2e2bcd8739ae039), {
        color: color,
        className: classes,
        type: "icon",
        dataTestId: `Icon-${dataTestId || kind}`,
        children: IconSvg && /*#__PURE__*/ (0, $7XTbi$jsx)(IconSvg, {})
    });
}
$1745e04e4ee31a1f$var$Icon.propTypes = {
    kind: $bdacd2991d6a3fd7$export$a6cc1b7066de015b($836fa012cc7cf7fa$exports),
    color: (0, $7XTbi$proptypes).oneOf((0, $3cad946ff8404ca5$export$5aef4e76b96cec9)),
    size: (0, $7XTbi$proptypes).oneOf(Object.values($1745e04e4ee31a1f$var$SIZES)),
    rotate: (0, $7XTbi$proptypes).oneOf([
        "90",
        "180",
        "270"
    ]),
    className: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string
};
$1745e04e4ee31a1f$var$Icon.defaultProps = {
    kind: null,
    color: null,
    size: "medium",
    rotate: null,
    className: null,
    dataTestId: null
};
var $1745e04e4ee31a1f$export$2e2bcd8739ae039 = $1745e04e4ee31a1f$var$Icon;


/* eslint-disable react/jsx-curly-spacing */ 





/* eslint-disable object-curly-newline */ /* eslint-disable react/jsx-props-no-spreading */ 







function $8ff3b7072736807a$var$TooltipComponent({ dataTheme: dataTheme, trigger: trigger, text: text, placement: placement, openDelay: openDelay, closeDelay: closeDelay, closeDelayAfterClick: closeDelayAfterClick, maxWidth: maxWidth, offset: offset, arrowStaticOffset: arrowStaticOffset, isWordBreak: isWordBreak, isDisabled: isDisabled, onClose: onClose, isPortalEnabled: isPortalEnabled, className: className, dataTestId: dataTestId }) {
    const [isOpen, setIsOpen] = (0, $7XTbi$useState)(false);
    const arrowRef = (0, $7XTbi$useRef)(null);
    // handle calling onClose after the tooltip is closed
    (0, $7XTbi$useEffect)(()=>{
        if (isOpen && onClose) {
            const closeTimeout = setTimeout(()=>{
                onClose();
                setIsOpen(false);
            }, closeDelayAfterClick);
            return ()=>clearTimeout(closeTimeout);
        }
        return ()=>{}; // noop cleanup (consistent return)
    }, [
        isOpen,
        onClose,
        closeDelayAfterClick
    ]);
    const tooltipClasses = (0, $7XTbi$classnames)("TooltipComponent", isWordBreak && "TooltipComponent--isWordBreak", text?.length < 1 || !text && "TooltipComponent--isTextEmpty", className);
    const { refs: refs, floatingStyles: floatingStyles, context: context } = (0, $7XTbi$useFloating)({
        open: isOpen,
        onOpenChange: setIsOpen,
        placement: placement,
        middleware: [
            (0, $7XTbi$offset)({
                mainAxis: offset.y || offset,
                crossAxis: offset.x || 0
            }),
            (0, $7XTbi$flip)(),
            (0, $7XTbi$shift)(),
            (0, $7XTbi$arrow)({
                element: arrowRef.current,
                padding: 8
            })
        ],
        whileElementsMounted: (0, $7XTbi$autoUpdate)
    });
    const hoverInteraction = (0, $7XTbi$useHover)(context, {
        move: false,
        enabled: !isDisabled,
        delay: {
            open: openDelay,
            close: closeDelay
        }
    });
    const focusInteraction = (0, $7XTbi$useFocus)(context, {
        enabled: !isDisabled,
        delay: {
            open: openDelay,
            close: closeDelay
        }
    });
    const dismissInteraction = (0, $7XTbi$useDismiss)(context, {
        enabled: !isDisabled
    });
    const roleInteraction = (0, $7XTbi$useRole)(context, {
        role: "tooltip"
    });
    const { isMounted: isMounted, styles: transitionStyles } = (0, $7XTbi$useTransitionStyles)(context, {
        duration: {
            open: 150,
            close: 150
        },
        open: {
            opacity: 1,
            transitionProperty: "opacity",
            transitionDuration: "150ms",
            transitionTimingFunction: "ease-in"
        },
        // TODO: Close transition currently not functioning
        close: {
            opacity: 0,
            transitionProperty: "opacity",
            transitionDuration: "150ms",
            transitionTimingFunction: "ease-out"
        }
    });
    const { getReferenceProps: getReferenceProps, getFloatingProps: getFloatingProps } = (0, $7XTbi$useInteractions)([
        hoverInteraction,
        focusInteraction,
        dismissInteraction,
        roleInteraction
    ]);
    const tooltipStyle = {
        ...floatingStyles,
        ...transitionStyles,
        maxWidth: maxWidth
    };
    const showTooltip = ()=>{
        if (dataTestId) setIsOpen(true);
    };
    const getToolTipKind = ()=>{
        const tooltipContent = /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
            "data-theme": dataTheme || (0, $65441b8e33d7ac73$export$49390a4605a2336a).DARK,
            ref: refs.setFloating,
            style: tooltipStyle,
            className: tooltipClasses,
            role: "tooltip",
            ...getFloatingProps(),
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                    className: "TooltipComponent-text",
                    children: text || ""
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)((0, $7XTbi$FloatingArrow), {
                    ref: arrowRef,
                    context: context,
                    width: 14,
                    height: 9,
                    tipRadius: 2,
                    fill: "var(--color-background-neutral-subtlest, #0C0D10)",
                    staticOffset: arrowStaticOffset
                })
            ]
        });
        return isPortalEnabled ? /*#__PURE__*/ (0, $7XTbi$jsx)((0, $7XTbi$FloatingPortal), {
            children: tooltipContent
        }) : tooltipContent;
    };
    return /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
        className: "TooltipComponent-container",
        dataTestId: dataTestId,
        dataTheme: dataTheme,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                ref: refs.setReference,
                ...getReferenceProps(),
                onFocus: !isDisabled ? showTooltip : ()=>{},
                onMouseOver: !isDisabled ? showTooltip : ()=>{},
                children: trigger
            }),
            isMounted && isOpen && getToolTipKind()
        ]
    });
}
$8ff3b7072736807a$var$TooltipComponent.propTypes = {
    dataTheme: (0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$49390a4605a2336a))),
    trigger: (0, $7XTbi$proptypes).element.isRequired,
    text: (0, $7XTbi$proptypes).string,
    placement: (0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$5aa24cb5f38e9127))),
    maxWidth: (0, $7XTbi$proptypes).string,
    offset: (0, $7XTbi$proptypes).oneOfType([
        (0, $7XTbi$proptypes).number,
        (0, $7XTbi$proptypes).shape({
            y: (0, $7XTbi$proptypes).number,
            x: (0, $7XTbi$proptypes).number
        })
    ]),
    arrowStaticOffset: (0, $7XTbi$proptypes).string,
    openDelay: (0, $7XTbi$proptypes).number,
    closeDelay: (0, $7XTbi$proptypes).number,
    closeDelayAfterClick: (0, $7XTbi$proptypes).number,
    isWordBreak: (0, $7XTbi$proptypes).bool,
    isDisabled: (0, $7XTbi$proptypes).bool,
    onClose: (0, $7XTbi$proptypes).func,
    isPortalEnabled: (0, $7XTbi$proptypes).bool,
    className: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string
};
$8ff3b7072736807a$var$TooltipComponent.defaultProps = {
    dataTheme: null,
    text: null,
    placement: (0, $65441b8e33d7ac73$export$5aa24cb5f38e9127).BOTTOM,
    maxWidth: "11rem",
    offset: 8,
    arrowStaticOffset: null,
    openDelay: 100,
    closeDelay: 10,
    closeDelayAfterClick: 500,
    isWordBreak: true,
    isDisabled: false,
    onClose: null,
    isPortalEnabled: false,
    className: null,
    dataTestId: null
};
var $8ff3b7072736807a$export$2e2bcd8739ae039 = $8ff3b7072736807a$var$TooltipComponent;
$8ff3b7072736807a$var$TooltipComponent.displayName = "Tooltip";



const $5f880a93b57cab01$var$THROTTLE_INTERACTION_IN_MS = 1000;
const $5f880a93b57cab01$var$TOUCH_DEVICE_OPEN_DELAY_IN_MS = 10;
const $5f880a93b57cab01$var$MOUSE_DEVICE_OPEN_DELAY_IN_MS = 1000;
const $5f880a93b57cab01$var$KINDS_MAP = [
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "body1",
    "body1-bold",
    "body2",
    "body2-bold",
    "body3",
    "body3-bold",
    "body4",
    "body4-bold",
    "label"
].reduce((acc, kind)=>({
        ...acc,
        [kind]: kind
    }), {});
const $5f880a93b57cab01$var$FONTS_MAP = [
    "display-d",
    "h1-d",
    "h2-d",
    "h3-d",
    "h4-d",
    "h5-d",
    "body1-d",
    "body1-bold-d",
    "body2-d",
    "body2-bold-d",
    "body3-d",
    "body3-bold-d",
    "body4-d",
    "body4-bold-d",
    "display-m",
    "h1-m",
    "h2-m",
    "h3-m",
    "h4-m",
    "h5-m",
    "body1-m",
    "body1-bold-m",
    "body2-m",
    "body2-bold-m",
    "body3-m",
    "body3-bold-m",
    "body4-m",
    "body4-bold-m"
].reduce((acc, font)=>({
        ...acc,
        [font]: font
    }), {});
const $5f880a93b57cab01$var$VARIENTS = [
    1,
    2,
    3,
    4
];
const $5f880a93b57cab01$var$BOLD_OPTION = "-bold";
function $5f880a93b57cab01$var$Typography({ dataTheme: dataTheme, kind: kind, variant: variant, bold: bold, desktop: desktop, mobile: mobile, color: color, htmlFor: htmlFor, children: children, isDisabled: isDisabled, isNoWrap: isNoWrap, lineLimit: lineLimit, tooltipConfigs: tooltipConfigs, className: className, dataTestId: dataTestId }) {
    const [isTextOverflowed, setIsTextOverflowed] = (0, $7XTbi$useState)(false);
    const [tooltipMaxWidth, setTooltipMaxWidth] = (0, $7XTbi$useState)("11rem");
    const textRef = (0, $7XTbi$useRef)(null);
    const Tag = [
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "label"
    ].includes(kind) ? kind : "p";
    // Compute kind dynamically for <P>. Default to body1 if kind is not provided.
    const computedKind = kind || variant && `body${variant}${bold ? $5f880a93b57cab01$var$BOLD_OPTION : ""}` || "body1";
    // Display Tooltip Conditions
    const shouldAddToolTip = isTextOverflowed && lineLimit && typeof children === "string";
    // Move default tip Position and delay changed on touch devices, UX request
    const isTouchDevice = window.matchMedia("(pointer: coarse)").matches;
    const desktopClass = `Typography-${desktop || `${computedKind}-d`}`;
    const mobileClass = `Typography-mobile-${mobile || `${computedKind}-m`}`;
    const typographyClasses = (0, $7XTbi$classnames)("Typography", desktopClass, mobileClass, (computedKind === "label" || isNoWrap) && "Typography--isNoWrap", isDisabled && "Typography--isDisabled", lineLimit && "Typography--hasLineLimit", lineLimit && `Typography-lineLimit--${lineLimit}`, className);
    const tooltipClasses = (0, $7XTbi$classnames)("Typography-tooltipBase", tooltipConfigs?.className);
    // Calculation of truncation width
    const calculateTooltipOverflow = (element)=>{
        if (lineLimit === 1) return element.scrollWidth > element.clientWidth;
        return element.scrollHeight > element.clientHeight;
    };
    // Measure overflow on interaction (hover or focus) Only check overflow on hover to reduce overhead
    const handleInteraction = ()=>{
        const el = textRef.current;
        if (el) {
            const isOverflow = calculateTooltipOverflow(el);
            if (!tooltipConfigs?.maxWidth) setTooltipMaxWidth(`${el.offsetWidth}px`);
            setIsTextOverflowed(isOverflow);
        }
    };
    const handleMouseEnter = lineLimit ? (0, $7XTbi$throttle)(handleInteraction, $5f880a93b57cab01$var$THROTTLE_INTERACTION_IN_MS) : null;
    const getTypography = ()=>{
        if (Tag === "label") return /*#__PURE__*/ (0, $7XTbi$jsx)("label", {
            ref: textRef,
            onMouseEnter: handleMouseEnter,
            className: typographyClasses,
            "data-color": color,
            htmlFor: htmlFor,
            "aria-disabled": isDisabled,
            "data-theme": dataTheme,
            "data-testid": dataTestId,
            children: children
        });
        return /*#__PURE__*/ (0, $7XTbi$jsx)(Tag, {
            ref: textRef,
            onMouseEnter: handleMouseEnter,
            className: typographyClasses,
            "data-color": color,
            "data-theme": dataTheme,
            "data-testid": dataTestId,
            children: children
        });
    };
    const typography = getTypography();
    if (shouldAddToolTip) return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $8ff3b7072736807a$export$2e2bcd8739ae039), {
        trigger: typography,
        text: children,
        // From config prop
        dataTheme: tooltipConfigs?.dataTheme,
        placement: tooltipConfigs?.placement || isTouchDevice ? (0, $65441b8e33d7ac73$export$5aa24cb5f38e9127).TOP : (0, $65441b8e33d7ac73$export$5aa24cb5f38e9127).BOTTOM,
        openDelay: tooltipConfigs?.openDelay || isTouchDevice ? $5f880a93b57cab01$var$TOUCH_DEVICE_OPEN_DELAY_IN_MS : $5f880a93b57cab01$var$MOUSE_DEVICE_OPEN_DELAY_IN_MS,
        closeDelay: tooltipConfigs?.closeDelay,
        closeDelayAfterClick: tooltipConfigs?.closeDelayAfterClick,
        maxWidth: tooltipConfigs?.maxWidth || tooltipMaxWidth,
        offset: tooltipConfigs?.offset,
        arrowStaticOffset: tooltipConfigs?.arrowStaticOffset,
        isWordBreak: tooltipConfigs?.isWordBreak,
        isDisabled: tooltipConfigs?.isDisabled || isDisabled,
        isPortalEnabled: tooltipConfigs?.isPortalEnabled,
        className: tooltipClasses,
        dataTestId: tooltipConfigs?.dataTestId
    });
    return typography;
}
$5f880a93b57cab01$var$Typography.propTypes = {
    dataTheme: (0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$49390a4605a2336a))),
    kind: (0, $7XTbi$proptypes).oneOf(Object.keys($5f880a93b57cab01$var$KINDS_MAP)),
    variant: (0, $7XTbi$proptypes).oneOf($5f880a93b57cab01$var$VARIENTS),
    bold: (0, $7XTbi$proptypes).bool,
    desktop: (0, $7XTbi$proptypes).oneOf([
        ...Object.keys($5f880a93b57cab01$var$FONTS_MAP),
        null
    ]),
    mobile: (0, $7XTbi$proptypes).oneOf([
        ...Object.keys($5f880a93b57cab01$var$FONTS_MAP),
        null
    ]),
    color: (0, $7XTbi$proptypes).oneOf((0, $65441b8e33d7ac73$export$99eafb6aa688e40e)),
    htmlFor: (0, $7XTbi$proptypes).string,
    children: (0, $7XTbi$proptypes).oneOfType([
        (0, $7XTbi$proptypes).string,
        (0, $7XTbi$proptypes).node
    ]).isRequired,
    isDisabled: (0, $7XTbi$proptypes).bool,
    isNoWrap: (0, $7XTbi$proptypes).bool,
    lineLimit: (0, $7XTbi$proptypes).number,
    tooltipConfigs: (0, $7XTbi$proptypes).shape({
        dataTheme: (0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$49390a4605a2336a))),
        placement: (0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$5aa24cb5f38e9127))),
        maxWidth: (0, $7XTbi$proptypes).string,
        offset: (0, $7XTbi$proptypes).oneOfType([
            (0, $7XTbi$proptypes).number,
            (0, $7XTbi$proptypes).shape({
                y: (0, $7XTbi$proptypes).number,
                x: (0, $7XTbi$proptypes).number
            })
        ]),
        arrowStaticOffset: (0, $7XTbi$proptypes).string,
        openDelay: (0, $7XTbi$proptypes).number,
        closeDelay: (0, $7XTbi$proptypes).number,
        closeDelayAfterClick: (0, $7XTbi$proptypes).number,
        isWordBreak: (0, $7XTbi$proptypes).bool,
        isDisabled: (0, $7XTbi$proptypes).bool,
        isPortalEnabled: (0, $7XTbi$proptypes).bool,
        className: (0, $7XTbi$proptypes).string,
        dataTestId: (0, $7XTbi$proptypes).string
    }),
    className: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string
};
$5f880a93b57cab01$var$Typography.defaultProps = {
    dataTheme: null,
    kind: null,
    variant: null,
    bold: false,
    desktop: null,
    mobile: null,
    color: null,
    htmlFor: "",
    isDisabled: false,
    isNoWrap: false,
    lineLimit: null,
    tooltipConfigs: null,
    className: null,
    dataTestId: null
};
var $5f880a93b57cab01$export$2e2bcd8739ae039 = $5f880a93b57cab01$var$Typography;



const $52b0e94fcd4b9f4d$var$ACCORDION_SHIFT_OFFSET = 8;
const $52b0e94fcd4b9f4d$var$PIXELS_PER_REM = 16;
const $52b0e94fcd4b9f4d$var$OVERFLOW_VISIBLE_STYLE_DELAY = 250;
function $52b0e94fcd4b9f4d$var$AccordionStepper({ isExpanded: isExpanded, isCritical: isCritical, setIsExpanded: setIsExpanded, prefixIconKind: prefixIconKind, headerText: headerText, primarySupportingText: primarySupportingText, secondarySupportingText: secondarySupportingText, isShowingSupportingTextOnExpanded: isShowingSupportingTextOnExpanded, accordionValue: accordionValue, suffixLink: suffixLink, children: children, buttonClassName: buttonClassName, contentPanelClassName: contentPanelClassName, CriticalMessage: CriticalMessage, dataTestId: dataTestId }) {
    const contentPanelRef = (0, $7XTbi$useRef)(null);
    const setExpandedClass = (content)=>`AccordionStepper-${content} ${isExpanded && `AccordionStepper-${content}--isExpanded`}`;
    const showingTextClass = !isShowingSupportingTextOnExpanded ? "AccordionStepper-supportingContent--isShowingSupportingTextOnExpanded" : null;
    const secondaryTextClass = secondarySupportingText && !isExpanded && accordionValue ? "AccordionStepper-supportingContent--hasSecondaryText" : null;
    const articleClasses = (0, $7XTbi$classnames)("AccordionStepper-article", isCritical && "AccordionStepper-article--isCritical", secondarySupportingText && accordionValue && "AccordionStepper-article--hasSecondaryText");
    const buttonClasses = (0, $7XTbi$classnames)(setExpandedClass("button"), isExpanded && !suffixLink && "AccordionStepper-button--noSuffixLink", secondarySupportingText && accordionValue && "AccordionStepper-button--hasSecondaryText", buttonClassName);
    const supportingContentClasses = (0, $7XTbi$classnames)(setExpandedClass("supportingContent"), showingTextClass, secondaryTextClass);
    const contentPanelClasses = (0, $7XTbi$classnames)(setExpandedClass("contentPanel"), contentPanelClassName);
    const contentPanelWrapperClasses = (0, $7XTbi$classnames)("AccordionStepper-contentPanelWrapper", isExpanded ? `AccordionStepper-contentPanelWrapper--isExpanded` : `AccordionStepper-contentPanelWrapper--isNotExpanded`);
    const prefixIconClasses = setExpandedClass("prefixIcon");
    const bodyContentClasses = setExpandedClass("bodyContent");
    const headerTextClasses = setExpandedClass("header");
    // TODO: Conider refactoring to reduce the preformence impact of recalculateHeight recall for screen width changes.
    (0, $7XTbi$useEffect)(()=>{
        let timeoutId;
        let lastWidth = window.innerWidth;
        const recalculateHeight = ()=>{
            if (contentPanelRef.current) {
                if (isExpanded) {
                    const height = contentPanelRef.current.scrollHeight;
                    const heightInRem = height / $52b0e94fcd4b9f4d$var$PIXELS_PER_REM;
                    contentPanelRef.current.style.maxHeight = `${heightInRem + $52b0e94fcd4b9f4d$var$ACCORDION_SHIFT_OFFSET}rem`;
                    if (timeoutId) clearTimeout(timeoutId);
                    timeoutId = setTimeout(()=>{
                        contentPanelRef.current.style.overflow = "visible";
                    }, $52b0e94fcd4b9f4d$var$OVERFLOW_VISIBLE_STYLE_DELAY);
                } else {
                    contentPanelRef.current.style.maxHeight = "0";
                    contentPanelRef.current.style.overflow = "hidden";
                }
            }
        };
        recalculateHeight();
        const handleResize = ()=>{
            const currentWidth = window.innerWidth;
            // TODO: update these values with breakpoint variables when we actually cement them
            if (lastWidth > 1440 && currentWidth <= 1440 || lastWidth > 1024 && currentWidth <= 1024 || lastWidth <= 1024 && currentWidth > 1024 || lastWidth > 600 && currentWidth <= 600 || lastWidth <= 600 && currentWidth > 600 || lastWidth > 375 && currentWidth <= 375) recalculateHeight();
            lastWidth = currentWidth;
        };
        window.addEventListener("resize", handleResize);
        const observer = new MutationObserver(recalculateHeight);
        observer.observe(contentPanelRef.current, {
            childList: true,
            subtree: true
        });
        return ()=>{
            window.removeEventListener("resize", handleResize);
            observer.disconnect();
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, [
        isExpanded
    ]);
    const renderedSupportingText = ()=>/*#__PURE__*/ (0, $7XTbi$jsxs)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
            className: supportingContentClasses,
            children: [
                accordionValue && !isExpanded ? /*#__PURE__*/ (0, $7XTbi$jsx)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
                    className: "AccordionStepper-accordionValue",
                    children: accordionValue
                }) : /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5f880a93b57cab01$export$2e2bcd8739ae039), {
                    kind: "body1",
                    className: "AccordionStepper-supportingText",
                    children: primarySupportingText
                }),
                !isExpanded && secondarySupportingText && accordionValue ? /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5f880a93b57cab01$export$2e2bcd8739ae039), {
                    kind: "body1",
                    className: "AccordionStepper-supportingText",
                    children: secondarySupportingText
                }) : null
            ]
        });
    return /*#__PURE__*/ (0, $7XTbi$jsxs)("article", {
        className: "AccordionStepper-inlineBox",
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
                className: articleClasses,
                dataTestId: dataTestId,
                children: [
                    /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $553ba9ca1822b2c0$export$2e2bcd8739ae039), {
                        type: "button",
                        ariaExpanded: isExpanded ? "true" : "false",
                        className: buttonClasses,
                        onClick: ()=>setIsExpanded(!isExpanded),
                        dataTestId: `${dataTestId}-button`,
                        children: [
                            /*#__PURE__*/ (0, $7XTbi$jsx)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
                                className: prefixIconClasses,
                                children: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                                    kind: prefixIconKind
                                })
                            }),
                            /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
                                className: bodyContentClasses,
                                children: [
                                    /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5f880a93b57cab01$export$2e2bcd8739ae039), {
                                        kind: "h4",
                                        desktop: "body2-d",
                                        mobile: "body2-m",
                                        className: headerTextClasses,
                                        children: headerText
                                    }),
                                    renderedSupportingText()
                                ]
                            }),
                            isExpanded && suffixLink,
                            !isExpanded && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
                                className: "AccordionStepper-suffixIcon",
                                children: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                                    kind: "edit"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsx)("section", {
                        ref: contentPanelRef,
                        className: contentPanelWrapperClasses,
                        children: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
                            className: contentPanelClasses,
                            "data-testid": `${dataTestId}-content-panel`,
                            children: children
                        })
                    })
                ]
            }),
            CriticalMessage
        ]
    });
}
$52b0e94fcd4b9f4d$var$AccordionStepper.propTypes = {
    isExpanded: (0, $7XTbi$proptypes).bool.isRequired,
    isCritical: (0, $7XTbi$proptypes).bool,
    setIsExpanded: (0, $7XTbi$proptypes).func.isRequired,
    prefixIconKind: (0, $7XTbi$proptypes).string.isRequired,
    headerText: (0, $7XTbi$proptypes).string.isRequired,
    primarySupportingText: (0, $7XTbi$proptypes).string.isRequired,
    secondarySupportingText: (0, $7XTbi$proptypes).string,
    isShowingSupportingTextOnExpanded: (0, $7XTbi$proptypes).bool,
    accordionValue: (0, $7XTbi$proptypes).node,
    suffixLink: (0, $7XTbi$proptypes).node,
    children: (0, $7XTbi$proptypes).node,
    buttonClassName: (0, $7XTbi$proptypes).string,
    contentPanelClassName: (0, $7XTbi$proptypes).string,
    CriticalMessage: (0, $7XTbi$proptypes).node,
    dataTestId: (0, $7XTbi$proptypes).string
};
$52b0e94fcd4b9f4d$var$AccordionStepper.defaultProps = {
    isCritical: false,
    secondarySupportingText: null,
    isShowingSupportingTextOnExpanded: false,
    accordionValue: null,
    suffixLink: null,
    children: null,
    buttonClassName: null,
    contentPanelClassName: null,
    CriticalMessage: null,
    dataTestId: null
};
var $52b0e94fcd4b9f4d$export$2e2bcd8739ae039 = $52b0e94fcd4b9f4d$var$AccordionStepper;


/* eslint-disable indent */ /* eslint-disable react/jsx-curly-spacing */ /* eslint-disable react/jsx-wrap-multilines */ 













const $e34ff86c7a827ee6$var$SIZES = {
    small: "small",
    medium: "medium",
    large: "large"
};
const $e34ff86c7a827ee6$var$KINDS = {
    bold: "bold",
    outlinedSecondary: "outlinedSecondary",
    outlinedNeutral: "outlinedNeutral",
    ghost: "ghost",
    outlinedCritical: "outlinedCritical",
    saviGhost: "saviGhost"
};
const $e34ff86c7a827ee6$var$ButtonIcon = /*#__PURE__*/ (0, $7XTbi$forwardRef)(({ id: id, dataTheme: dataTheme, size: size, kind: kind, tabIndex: tabIndex, isDisabled: isDisabled, isSelected: isSelected, icon: icon, onClick: onClick, className: className, dataTestId: dataTestId }, ref)=>{
    const buttonIconClass = (0, $7XTbi$classnames)("ButtonIcon", `ButtonIcon--${size}`, `ButtonIcon-${kind}`, isDisabled && `ButtonIcon-${kind}--isDisabled`, isSelected && `ButtonIcon-${kind}--isSelected`, dataTheme && `ButtonIcon--${dataTheme}`, className);
    const buttonIconOverlayClass = (0, $7XTbi$classnames)("ButtonIcon-overlay", `ButtonIcon-overlay-${kind}`, isSelected && `ButtonIcon-overlay-${kind}--isSelected`);
    return /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $553ba9ca1822b2c0$export$2e2bcd8739ae039), {
        ref: ref,
        id: id,
        dataTheme: dataTheme,
        tabIndex: tabIndex,
        onClick: (e)=>onClick(e),
        isDisabled: isDisabled,
        className: buttonIconClass,
        dataTestId: dataTestId,
        children: [
            icon,
            /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                className: buttonIconOverlayClass
            })
        ]
    });
});
$e34ff86c7a827ee6$var$ButtonIcon.defaultProps = {
    id: null,
    dataTheme: null,
    size: $e34ff86c7a827ee6$var$SIZES.large,
    kind: $e34ff86c7a827ee6$var$KINDS.bold,
    tabIndex: 0,
    isDisabled: false,
    isSelected: false,
    onClick: ()=>{},
    className: null,
    dataTestId: null
};
$e34ff86c7a827ee6$var$ButtonIcon.propTypes = {
    id: (0, $7XTbi$proptypes).string,
    dataTheme: (0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$49390a4605a2336a))),
    size: (0, $7XTbi$proptypes).oneOf(Object.values($e34ff86c7a827ee6$var$SIZES)),
    kind: (0, $7XTbi$proptypes).oneOf(Object.values($e34ff86c7a827ee6$var$KINDS)),
    tabIndex: (0, $7XTbi$proptypes).number,
    isDisabled: (0, $7XTbi$proptypes).bool,
    isSelected: (0, $7XTbi$proptypes).bool,
    icon: (0, $7XTbi$proptypes).node.isRequired,
    onClick: (0, $7XTbi$proptypes).func,
    className: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string
};
var $e34ff86c7a827ee6$export$2e2bcd8739ae039 = $e34ff86c7a827ee6$var$ButtonIcon;











const $47010fca98b98efb$var$KINDS = {
    link: "link",
    button: "button"
};
const $47010fca98b98efb$var$COLORS = {
    brand: "brand",
    neutral: "neutral",
    neutralInverse: "neutralInverse"
};
const $47010fca98b98efb$var$SIZES = {
    small: "small",
    medium: "medium",
    large: "large"
};
const $47010fca98b98efb$var$TARGETS = {
    _blank: "_blank",
    _self: "_self",
    _parent: "_parent",
    _top: "_top"
};
const $47010fca98b98efb$var$handleKeyDown = (e)=>{
    if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        e.currentTarget.querySelector("a").click();
    }
};
function $47010fca98b98efb$var$Link({ RouterComponent: RouterComponent, kind: kind, color: color, size: size, url: url, text: text, target: target, rel: rel, prefixIconKind: prefixIconKind, suffixIconKind: suffixIconKind, suffixIconRotate: suffixIconRotate, onClick: onClick, shouldStopPropagation: shouldStopPropagation, isDisabled: isDisabled, tabIndex: tabIndex, className: className, dataTheme: dataTheme, dataTestId: dataTestId }) {
    const handleClick = (e)=>{
        if (isDisabled) return;
        if (shouldStopPropagation) e.stopPropagation();
        if (kind === "link" && !onClick) return;
        onClick?.(e);
    };
    const classes = (0, $7XTbi$classnames)("Link", `Link--${color}`, `Link--${size}`, isDisabled && "Link--isDisabled", className);
    const buttonClasses = (0, $7XTbi$classnames)("ButtonLink", `ButtonLink--${color}`, `ButtonLink--${size}`, isDisabled && "ButtonLink--isDisabled", className);
    const renderedPrefixIcon = prefixIconKind && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
        className: "Link-icon",
        kind: prefixIconKind
    });
    const renderedSuffixIcon = suffixIconKind && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
        className: "Link-icon",
        kind: suffixIconKind,
        rotate: suffixIconRotate
    });
    const renderedLinkContent = /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $7XTbi$Fragment), {
        children: [
            renderedPrefixIcon,
            /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                className: "Link-textWrapper",
                "data-theme": dataTheme,
                children: text
            }),
            renderedSuffixIcon
        ]
    });
    if (kind === "button") return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $553ba9ca1822b2c0$export$2e2bcd8739ae039), {
        className: buttonClasses,
        onClick: (e)=>handleClick(e),
        tabIndex: isDisabled ? -1 : tabIndex,
        role: "button",
        dataTheme: dataTheme,
        dataTestId: dataTestId,
        "aria-label": text,
        onKeyDown: $47010fca98b98efb$var$handleKeyDown,
        children: renderedLinkContent
    });
    if (RouterComponent) return /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
        className: classes,
        tabIndex: isDisabled ? -1 : tabIndex,
        role: "link",
        "data-theme": dataTheme,
        "data-testid": dataTestId,
        "aria-label": text,
        onKeyDown: $47010fca98b98efb$var$handleKeyDown,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)(RouterComponent, {
            to: url,
            className: "Link-router Link-wrapper",
            onClick: (e)=>handleClick(e),
            "aria-label": text,
            target: target,
            rel: rel,
            tabIndex: "-1",
            children: renderedLinkContent
        })
    });
    return /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
        className: classes,
        tabIndex: isDisabled ? -1 : tabIndex,
        role: "link",
        "data-theme": dataTheme,
        "data-testid": dataTestId,
        "aria-label": text,
        onKeyDown: $47010fca98b98efb$var$handleKeyDown,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("a", {
            href: url,
            className: "Link-router Link-wrapper",
            onClick: (e)=>handleClick(e),
            "aria-label": text,
            target: target,
            rel: rel,
            tabIndex: "-1",
            children: renderedLinkContent
        })
    });
}
$47010fca98b98efb$var$Link.propTypes = {
    RouterComponent: (0, $7XTbi$proptypes).elementType,
    kind: (0, $7XTbi$proptypes).oneOf(Object.values($47010fca98b98efb$var$KINDS)),
    color: (0, $7XTbi$proptypes).oneOf(Object.values($47010fca98b98efb$var$COLORS)),
    size: (0, $7XTbi$proptypes).oneOf(Object.values($47010fca98b98efb$var$SIZES)),
    url: (0, $7XTbi$proptypes).string,
    text: (0, $7XTbi$proptypes).string.isRequired,
    target: (0, $7XTbi$proptypes).oneOf(Object.values($47010fca98b98efb$var$TARGETS)),
    rel: (0, $7XTbi$proptypes).string,
    prefixIconKind: (0, $7XTbi$proptypes).string,
    suffixIconKind: (0, $7XTbi$proptypes).string,
    suffixIconRotate: (0, $7XTbi$proptypes).string,
    onClick: (0, $7XTbi$proptypes).func,
    shouldStopPropagation: (0, $7XTbi$proptypes).bool,
    isDisabled: (0, $7XTbi$proptypes).bool,
    tabIndex: (0, $7XTbi$proptypes).number,
    className: (0, $7XTbi$proptypes).string,
    dataTheme: (0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$49390a4605a2336a))),
    dataTestId: (0, $7XTbi$proptypes).string
};
$47010fca98b98efb$var$Link.defaultProps = {
    RouterComponent: null,
    kind: $47010fca98b98efb$var$KINDS.link,
    color: $47010fca98b98efb$var$COLORS.brand,
    size: $47010fca98b98efb$var$SIZES.medium,
    url: null,
    target: $47010fca98b98efb$var$TARGETS._blank,
    rel: "noopener noreferrer",
    prefixIconKind: null,
    suffixIconKind: null,
    suffixIconRotate: null,
    onClick: null,
    shouldStopPropagation: false,
    isDisabled: false,
    tabIndex: 0,
    className: null,
    dataTheme: null,
    dataTestId: null
};
var $47010fca98b98efb$export$2e2bcd8739ae039 = $47010fca98b98efb$var$Link;








var $111f6dd21e46efa5$exports = {};
$111f6dd21e46efa5$exports = JSON.parse('{"v":"5.10.2","fr":60,"ip":0,"op":49,"w":20,"h":20,"nm":"Dots-Inline","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Dot-06_White","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.6,"y":1},"o":{"x":0.32,"y":0.836},"t":4,"s":[2.5,10.5,0],"to":[0,-0.75,0],"ti":[0,0.083,0]},{"i":{"x":0.68,"y":0.061},"o":{"x":0.4,"y":0},"t":20,"s":[2.5,6,0],"to":[0,-0.083,0],"ti":[0,-0.667,0]},{"t":36,"s":[2.5,10,0]}],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":0,"s":[125,75,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":4,"s":[125,75,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":10,"s":[75,125,100]},{"t":20,"s":[100,100,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[4,4],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[0.215686276555,0.317647069693,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Dot-05_White","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.6,"y":1},"o":{"x":0.32,"y":0.836},"t":10,"s":[10,10.5,0],"to":[0,-0.75,0],"ti":[0,0.083,0]},{"i":{"x":0.68,"y":0.061},"o":{"x":0.4,"y":0},"t":26,"s":[10,6,0],"to":[0,-0.083,0],"ti":[0,-0.667,0]},{"t":42,"s":[10,10,0]}],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":6,"s":[125,75,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":10,"s":[125,75,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":16,"s":[75,125,100]},{"t":26,"s":[100,100,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[4,4],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[0.215686276555,0.317647069693,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Dot-04_White","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.6,"y":1},"o":{"x":0.32,"y":0.836},"t":16,"s":[17.5,10.5,0],"to":[0,-0.75,0],"ti":[0,0.083,0]},{"i":{"x":0.68,"y":0.061},"o":{"x":0.4,"y":0},"t":32,"s":[17.5,6,0],"to":[0,-0.083,0],"ti":[0,-0.667,0]},{"t":48,"s":[17.5,10,0]}],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":12,"s":[125,75,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":16,"s":[125,75,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":22,"s":[75,125,100]},{"t":32,"s":[100,100,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[4,4],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[0.215686276555,0.317647069693,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0}],"markers":[]}');


var $42f71ef150ad4f79$exports = {};
$42f71ef150ad4f79$exports = JSON.parse('{"v":"5.10.2","fr":60,"ip":0,"op":49,"w":20,"h":20,"nm":"Dots-Inline","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Dot-06_White","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.6,"y":1},"o":{"x":0.32,"y":0.836},"t":4,"s":[2.5,10.5,0],"to":[0,-0.75,0],"ti":[0,0.083,0]},{"i":{"x":0.68,"y":0.061},"o":{"x":0.4,"y":0},"t":20,"s":[2.5,6,0],"to":[0,-0.083,0],"ti":[0,-0.667,0]},{"t":36,"s":[2.5,10,0]}],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":0,"s":[125,75,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":4,"s":[125,75,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":10,"s":[75,125,100]},{"t":20,"s":[100,100,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[4,4],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[0.800000011921,0.109803922474,0.06274510175,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Dot-05_White","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.6,"y":1},"o":{"x":0.32,"y":0.836},"t":10,"s":[10,10.5,0],"to":[0,-0.75,0],"ti":[0,0.083,0]},{"i":{"x":0.68,"y":0.061},"o":{"x":0.4,"y":0},"t":26,"s":[10,6,0],"to":[0,-0.083,0],"ti":[0,-0.667,0]},{"t":42,"s":[10,10,0]}],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":6,"s":[125,75,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":10,"s":[125,75,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":16,"s":[75,125,100]},{"t":26,"s":[100,100,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[4,4],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[0.800000011921,0.109803922474,0.06274510175,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Dot-04_White","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.6,"y":1},"o":{"x":0.32,"y":0.836},"t":16,"s":[17.5,10.5,0],"to":[0,-0.75,0],"ti":[0,0.083,0]},{"i":{"x":0.68,"y":0.061},"o":{"x":0.4,"y":0},"t":32,"s":[17.5,6,0],"to":[0,-0.083,0],"ti":[0,-0.667,0]},{"t":48,"s":[17.5,10,0]}],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":12,"s":[125,75,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":16,"s":[125,75,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":22,"s":[75,125,100]},{"t":32,"s":[100,100,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[4,4],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[0.800000011921,0.109803922474,0.06274510175,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0}],"markers":[]}');


var $7f4dab8d974f43f4$exports = {};
$7f4dab8d974f43f4$exports = JSON.parse('{"v":"5.10.2","fr":60,"ip":0,"op":49,"w":20,"h":20,"nm":"Dots-Inline","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Dot-06_White","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.6,"y":1},"o":{"x":0.32,"y":0.836},"t":4,"s":[2.5,10.5,0],"to":[0,-0.75,0],"ti":[0,0.083,0]},{"i":{"x":0.68,"y":0.061},"o":{"x":0.4,"y":0},"t":20,"s":[2.5,6,0],"to":[0,-0.083,0],"ti":[0,-0.667,0]},{"t":36,"s":[2.5,10,0]}],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":0,"s":[125,75,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":4,"s":[125,75,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":10,"s":[75,125,100]},{"t":20,"s":[100,100,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[4,4],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[0.313725501299,0.207843139768,0.835294127464,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Dot-05_White","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.6,"y":1},"o":{"x":0.32,"y":0.836},"t":10,"s":[10,10.5,0],"to":[0,-0.75,0],"ti":[0,0.083,0]},{"i":{"x":0.68,"y":0.061},"o":{"x":0.4,"y":0},"t":26,"s":[10,6,0],"to":[0,-0.083,0],"ti":[0,-0.667,0]},{"t":42,"s":[10,10,0]}],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":6,"s":[125,75,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":10,"s":[125,75,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":16,"s":[75,125,100]},{"t":26,"s":[100,100,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[4,4],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[0.313725501299,0.207843139768,0.835294127464,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Dot-04_White","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.6,"y":1},"o":{"x":0.32,"y":0.836},"t":16,"s":[17.5,10.5,0],"to":[0,-0.75,0],"ti":[0,0.083,0]},{"i":{"x":0.68,"y":0.061},"o":{"x":0.4,"y":0},"t":32,"s":[17.5,6,0],"to":[0,-0.083,0],"ti":[0,-0.667,0]},{"t":48,"s":[17.5,10,0]}],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":12,"s":[125,75,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":16,"s":[125,75,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":22,"s":[75,125,100]},{"t":32,"s":[100,100,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[4,4],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[0.313725501299,0.207843139768,0.835294127464,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0}],"markers":[]}');


var $d2c552d5d7a4680a$exports = {};
$d2c552d5d7a4680a$exports = JSON.parse('{"v":"5.10.2","fr":60,"ip":0,"op":49,"w":20,"h":20,"nm":"Dots-Inline_A","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Dot-06_White","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.6,"y":1},"o":{"x":0.32,"y":0.836},"t":4,"s":[2.5,10.5,0],"to":[0,-0.75,0],"ti":[0,0.083,0]},{"i":{"x":0.68,"y":0.061},"o":{"x":0.4,"y":0},"t":20,"s":[2.5,6,0],"to":[0,-0.083,0],"ti":[0,-0.667,0]},{"t":36,"s":[2.5,10,0]}],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":0,"s":[125,75,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":4,"s":[125,75,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":10,"s":[75,125,100]},{"t":20,"s":[100,100,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[4,4],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Dot-05_White","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.6,"y":1},"o":{"x":0.32,"y":0.836},"t":10,"s":[10,10.5,0],"to":[0,-0.75,0],"ti":[0,0.083,0]},{"i":{"x":0.68,"y":0.061},"o":{"x":0.4,"y":0},"t":26,"s":[10,6,0],"to":[0,-0.083,0],"ti":[0,-0.667,0]},{"t":42,"s":[10,10,0]}],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":6,"s":[125,75,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":10,"s":[125,75,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":16,"s":[75,125,100]},{"t":26,"s":[100,100,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[4,4],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Dot-04_White","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.6,"y":1},"o":{"x":0.32,"y":0.836},"t":16,"s":[17.5,10.5,0],"to":[0,-0.75,0],"ti":[0,0.083,0]},{"i":{"x":0.68,"y":0.061},"o":{"x":0.4,"y":0},"t":32,"s":[17.5,6,0],"to":[0,-0.083,0],"ti":[0,-0.667,0]},{"t":48,"s":[17.5,10,0]}],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":12,"s":[125,75,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":16,"s":[125,75,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":22,"s":[75,125,100]},{"t":32,"s":[100,100,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[4,4],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0}],"markers":[]}');


var $781845b48580a07e$exports = {};
$781845b48580a07e$exports = JSON.parse('{"nm":"Flow 1","ddd":0,"h":192,"w":192,"meta":{"g":"LottieFiles Figma v67"},"layers":[{"ty":4,"nm":"Green check","sr":1,"st":0,"op":170.97,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[18,18],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[18,18],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[18,18],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[18,18],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[18,18],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[18,18],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[18,18],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[18,18],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[18,18],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[18,18],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[18,18],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[18,18],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[18,18],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[18,18],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[18,18],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[18,18],"t":170},{"s":[18,18],"t":182}]},"s":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100,100],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100,100],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100,100],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100,100],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[100,100],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100,100],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100,100],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100,100],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100,100],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100,100],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[100,100],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100,100],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100,100],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100,100],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[100,100],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[100,100],"t":170},{"s":[100,100],"t":182}]},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[96,119],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[96,119],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[96,119],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[96,119],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[96,119],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[96,119],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[96,119],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[96,101.55],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[96,103.09],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[96,103],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[96,103],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[96,103],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[96,120.45],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[96,118.91],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[96,119],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[96,119],"t":170},{"s":[96,119],"t":182}]},"r":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[0],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[0],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[0],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[0],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[0],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[0],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[0],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[0],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[0],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[0],"t":170},{"s":[0],"t":182}]},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[0],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[0],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[0],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[99.46],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[100],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[0],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[0.54],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[0],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[0],"t":170},{"s":[0],"t":182}]}},"shapes":[{"ty":"sh","bm":0,"hd":false,"nm":"","d":1,"ks":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,-9.93938],[9.9394,0],[0,9.9394],[-9.93938,0]],"o":[[9.9394,0],[0,9.9394],[-9.93938,0],[0,-9.93938],[0,0]],"v":[[18,0],[36,18],[18,36],[0,18],[18,0]]}],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,-9.93938],[9.9394,0],[0,9.9394],[-9.93938,0]],"o":[[9.9394,0],[0,9.9394],[-9.93938,0],[0,-9.93938],[0,0]],"v":[[18,0],[36,18],[18,36],[0,18],[18,0]]}],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[0,-9.93938],[9.9394,0],[0,9.9394],[-9.93938,0]],"o":[[9.9394,0],[0,9.9394],[-9.93938,0],[0,-9.93938],[0,0]],"v":[[18,0],[36,18],[18,36],[0,18],[18,0]]}],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,-9.93938],[9.9394,0],[0,9.9394],[-9.93938,0]],"o":[[9.9394,0],[0,9.9394],[-9.93938,0],[0,-9.93938],[0,0]],"v":[[18,0],[36,18],[18,36],[0,18],[18,0]]}],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,-9.93938],[9.9394,0],[0,9.9394],[-9.93938,0]],"o":[[9.9394,0],[0,9.9394],[-9.93938,0],[0,-9.93938],[0,0]],"v":[[18,0],[36,18],[18,36],[0,18],[18,0]]}],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,-9.93938],[9.9394,0],[0,9.9394],[-9.93938,0]],"o":[[9.9394,0],[0,9.9394],[-9.93938,0],[0,-9.93938],[0,0]],"v":[[18,0],[36,18],[18,36],[0,18],[18,0]]}],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,-9.93938],[9.9394,0],[0,9.9394],[-9.93938,0]],"o":[[9.9394,0],[0,9.9394],[-9.93938,0],[0,-9.93938],[0,0]],"v":[[18,0],[36,18],[18,36],[0,18],[18,0]]}],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[0,-9.93938],[9.9394,0],[0,9.9394],[-9.93938,0]],"o":[[9.9394,0],[0,9.9394],[-9.93938,0],[0,-9.93938],[0,0]],"v":[[18,0],[36,18],[18,36],[0,18],[18,0]]}],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,-9.93938],[9.9394,0],[0,9.9394],[-9.93938,0]],"o":[[9.9394,0],[0,9.9394],[-9.93938,0],[0,-9.93938],[0,0]],"v":[[18,0],[36,18],[18,36],[0,18],[18,0]]}],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,-9.93938],[9.9394,0],[0,9.9394],[-9.93938,0]],"o":[[9.9394,0],[0,9.9394],[-9.93938,0],[0,-9.93938],[0,0]],"v":[[18,0],[36,18],[18,36],[0,18],[18,0]]}],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,-9.93938],[9.9394,0],[0,9.9394],[-9.93938,0]],"o":[[9.9394,0],[0,9.9394],[-9.93938,0],[0,-9.93938],[0,0]],"v":[[18,0],[36,18],[18,36],[0,18],[18,0]]}],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,-9.93938],[9.9394,0],[0,9.9394],[-9.93938,0]],"o":[[9.9394,0],[0,9.9394],[-9.93938,0],[0,-9.93938],[0,0]],"v":[[18,0],[36,18],[18,36],[0,18],[18,0]]}],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[0,-9.93938],[9.9394,0],[0,9.9394],[-9.93938,0]],"o":[[9.9394,0],[0,9.9394],[-9.93938,0],[0,-9.93938],[0,0]],"v":[[18,0],[36,18],[18,36],[0,18],[18,0]]}],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,-9.93938],[9.9394,0],[0,9.9394],[-9.93938,0]],"o":[[9.9394,0],[0,9.9394],[-9.93938,0],[0,-9.93938],[0,0]],"v":[[18,0],[36,18],[18,36],[0,18],[18,0]]}],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,-9.93938],[9.9394,0],[0,9.9394],[-9.93938,0]],"o":[[9.9394,0],[0,9.9394],[-9.93938,0],[0,-9.93938],[0,0]],"v":[[18,0],[36,18],[18,36],[0,18],[18,0]]}],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,-9.94],[9.94,0],[0,9.94],[-9.94,0]],"o":[[9.94,0],[0,9.94],[-9.94,0],[0,-9.94],[0,0]],"v":[[18,0],[36,18],[18,36],[0,18],[18,0]]}],"t":170},{"s":[{"c":true,"i":[[0,0],[0,-9.94],[9.94,0],[0,9.94],[-9.94,0]],"o":[[9.94,0],[0,9.94],[-9.94,0],[0,-9.94],[0,0]],"v":[[18,0],[36,18],[18,36],[0,18],[18,0]]}],"t":182}]}},{"ty":"sh","bm":0,"hd":false,"nm":"","d":1,"ks":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,0],[-0.7509200000000007,0.751100000000001],[-0.7455999999999996,-0.7462],[0,0],[0,0],[-0.7508999999999979,-0.7510999999999992],[0.75,-0.75],[0,0],[0.7508999999999997,0.7510999999999974],[0.019899999999999807,0.02190000000000225]],"o":[[0,0],[-0.750770000000001,-0.7512000000000008],[0.7510699999999986,-0.7508999999999997],[0,0],[0,0],[0.751100000000001,-0.7510999999999992],[0.751100000000001,0.7508999999999997],[0,0],[-0.75,0.75],[-0.021099999999998786,-0.021100000000000563],[0,0]],"v":[[14.2621,23.8465],[9.85523,19.436],[9.85523,16.7087],[12.5824,16.7087],[15.6892,19.818],[23.4179,12.0893],[26.145,12.0893],[26.145,14.8165],[17.0506,23.9109],[14.3234,23.9109],[14.2621,23.8465]]}],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,0],[-0.7509200000000007,0.751100000000001],[-0.7455999999999996,-0.7462],[0,0],[0,0],[-0.7508999999999979,-0.7510999999999992],[0.75,-0.75],[0,0],[0.7508999999999997,0.7510999999999974],[0.019899999999999807,0.02190000000000225]],"o":[[0,0],[-0.750770000000001,-0.7512000000000008],[0.7510699999999986,-0.7508999999999997],[0,0],[0,0],[0.751100000000001,-0.7510999999999992],[0.751100000000001,0.7508999999999997],[0,0],[-0.75,0.75],[-0.021099999999998786,-0.021100000000000563],[0,0]],"v":[[14.2621,23.8465],[9.85523,19.436],[9.85523,16.7087],[12.5824,16.7087],[15.6892,19.818],[23.4179,12.0893],[26.145,12.0893],[26.145,14.8165],[17.0506,23.9109],[14.3234,23.9109],[14.2621,23.8465]]}],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[0,0],[-0.7509200000000007,0.751100000000001],[-0.7455999999999996,-0.7462],[0,0],[0,0],[-0.7508999999999979,-0.7510999999999992],[0.75,-0.75],[0,0],[0.7508999999999997,0.7510999999999974],[0.019899999999999807,0.02190000000000225]],"o":[[0,0],[-0.750770000000001,-0.7512000000000008],[0.7510699999999986,-0.7508999999999997],[0,0],[0,0],[0.751100000000001,-0.7510999999999992],[0.751100000000001,0.7508999999999997],[0,0],[-0.75,0.75],[-0.021099999999998786,-0.021100000000000563],[0,0]],"v":[[14.2621,23.8465],[9.85523,19.436],[9.85523,16.7087],[12.5824,16.7087],[15.6892,19.818],[23.4179,12.0893],[26.145,12.0893],[26.145,14.8165],[17.0506,23.9109],[14.3234,23.9109],[14.2621,23.8465]]}],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,0],[-0.7509200000000007,0.751100000000001],[-0.7455999999999996,-0.7462],[0,0],[0,0],[-0.7508999999999979,-0.7510999999999992],[0.75,-0.75],[0,0],[0.7508999999999997,0.7510999999999974],[0.019899999999999807,0.02190000000000225]],"o":[[0,0],[-0.750770000000001,-0.7512000000000008],[0.7510699999999986,-0.7508999999999997],[0,0],[0,0],[0.751100000000001,-0.7510999999999992],[0.751100000000001,0.7508999999999997],[0,0],[-0.75,0.75],[-0.021099999999998786,-0.021100000000000563],[0,0]],"v":[[14.2621,23.8465],[9.85523,19.436],[9.85523,16.7087],[12.5824,16.7087],[15.6892,19.818],[23.4179,12.0893],[26.145,12.0893],[26.145,14.8165],[17.0506,23.9109],[14.3234,23.9109],[14.2621,23.8465]]}],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,0],[-0.7509200000000007,0.751100000000001],[-0.7455999999999996,-0.7462],[0,0],[0,0],[-0.7508999999999979,-0.7510999999999992],[0.75,-0.75],[0,0],[0.7508999999999997,0.7510999999999974],[0.019899999999999807,0.02190000000000225]],"o":[[0,0],[-0.750770000000001,-0.7512000000000008],[0.7510699999999986,-0.7508999999999997],[0,0],[0,0],[0.751100000000001,-0.7510999999999992],[0.751100000000001,0.7508999999999997],[0,0],[-0.75,0.75],[-0.021099999999998786,-0.021100000000000563],[0,0]],"v":[[14.2621,23.8465],[9.85523,19.436],[9.85523,16.7087],[12.5824,16.7087],[15.6892,19.818],[23.4179,12.0893],[26.145,12.0893],[26.145,14.8165],[17.0506,23.9109],[14.3234,23.9109],[14.2621,23.8465]]}],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,0],[-0.7509200000000007,0.751100000000001],[-0.7455999999999996,-0.7462],[0,0],[0,0],[-0.7508999999999979,-0.7510999999999992],[0.75,-0.75],[0,0],[0.7508999999999997,0.7510999999999974],[0.019899999999999807,0.02190000000000225]],"o":[[0,0],[-0.750770000000001,-0.7512000000000008],[0.7510699999999986,-0.7508999999999997],[0,0],[0,0],[0.751100000000001,-0.7510999999999992],[0.751100000000001,0.7508999999999997],[0,0],[-0.75,0.75],[-0.021099999999998786,-0.021100000000000563],[0,0]],"v":[[14.2621,23.8465],[9.85523,19.436],[9.85523,16.7087],[12.5824,16.7087],[15.6892,19.818],[23.4179,12.0893],[26.145,12.0893],[26.145,14.8165],[17.0506,23.9109],[14.3234,23.9109],[14.2621,23.8465]]}],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,0],[-0.7509200000000007,0.751100000000001],[-0.7455999999999996,-0.7462],[0,0],[0,0],[-0.7508999999999979,-0.7510999999999992],[0.75,-0.75],[0,0],[0.7508999999999997,0.7510999999999974],[0.019899999999999807,0.02190000000000225]],"o":[[0,0],[-0.750770000000001,-0.7512000000000008],[0.7510699999999986,-0.7508999999999997],[0,0],[0,0],[0.751100000000001,-0.7510999999999992],[0.751100000000001,0.7508999999999997],[0,0],[-0.75,0.75],[-0.021099999999998786,-0.021100000000000563],[0,0]],"v":[[14.2621,23.8465],[9.85523,19.436],[9.85523,16.7087],[12.5824,16.7087],[15.6892,19.818],[23.4179,12.0893],[26.145,12.0893],[26.145,14.8165],[17.0506,23.9109],[14.3234,23.9109],[14.2621,23.8465]]}],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[0,0],[-0.7509200000000007,0.751100000000001],[-0.7455999999999996,-0.7462],[0,0],[0,0],[-0.7508999999999979,-0.7510999999999992],[0.75,-0.75],[0,0],[0.7508999999999997,0.7510999999999974],[0.019899999999999807,0.02190000000000225]],"o":[[0,0],[-0.750770000000001,-0.7512000000000008],[0.7510699999999986,-0.7508999999999997],[0,0],[0,0],[0.751100000000001,-0.7510999999999992],[0.751100000000001,0.7508999999999997],[0,0],[-0.75,0.75],[-0.021099999999998786,-0.021100000000000563],[0,0]],"v":[[14.2621,23.8465],[9.85523,19.436],[9.85523,16.7087],[12.5824,16.7087],[15.6892,19.818],[23.4179,12.0893],[26.145,12.0893],[26.145,14.8165],[17.0506,23.9109],[14.3234,23.9109],[14.2621,23.8465]]}],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,0],[-0.7509200000000007,0.751100000000001],[-0.7455999999999996,-0.7462],[0,0],[0,0],[-0.7508999999999979,-0.7510999999999992],[0.75,-0.75],[0,0],[0.7508999999999997,0.7510999999999974],[0.019899999999999807,0.02190000000000225]],"o":[[0,0],[-0.750770000000001,-0.7512000000000008],[0.7510699999999986,-0.7508999999999997],[0,0],[0,0],[0.751100000000001,-0.7510999999999992],[0.751100000000001,0.7508999999999997],[0,0],[-0.75,0.75],[-0.021099999999998786,-0.021100000000000563],[0,0]],"v":[[14.2621,23.8465],[9.85523,19.436],[9.85523,16.7087],[12.5824,16.7087],[15.6892,19.818],[23.4179,12.0893],[26.145,12.0893],[26.145,14.8165],[17.0506,23.9109],[14.3234,23.9109],[14.2621,23.8465]]}],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,0],[-0.7509200000000007,0.751100000000001],[-0.7455999999999996,-0.7462],[0,0],[0,0],[-0.7508999999999979,-0.7510999999999992],[0.75,-0.75],[0,0],[0.7508999999999997,0.7510999999999974],[0.019899999999999807,0.02190000000000225]],"o":[[0,0],[-0.750770000000001,-0.7512000000000008],[0.7510699999999986,-0.7508999999999997],[0,0],[0,0],[0.751100000000001,-0.7510999999999992],[0.751100000000001,0.7508999999999997],[0,0],[-0.75,0.75],[-0.021099999999998786,-0.021100000000000563],[0,0]],"v":[[14.2621,23.8465],[9.85523,19.436],[9.85523,16.7087],[12.5824,16.7087],[15.6892,19.818],[23.4179,12.0893],[26.145,12.0893],[26.145,14.8165],[17.0506,23.9109],[14.3234,23.9109],[14.2621,23.8465]]}],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,0],[-0.7509200000000007,0.751100000000001],[-0.7455999999999996,-0.7462],[0,0],[0,0],[-0.7508999999999979,-0.7510999999999992],[0.75,-0.75],[0,0],[0.7508999999999997,0.7510999999999974],[0.019899999999999807,0.02190000000000225]],"o":[[0,0],[-0.750770000000001,-0.7512000000000008],[0.7510699999999986,-0.7508999999999997],[0,0],[0,0],[0.751100000000001,-0.7510999999999992],[0.751100000000001,0.7508999999999997],[0,0],[-0.75,0.75],[-0.021099999999998786,-0.021100000000000563],[0,0]],"v":[[14.2621,23.8465],[9.85523,19.436],[9.85523,16.7087],[12.5824,16.7087],[15.6892,19.818],[23.4179,12.0893],[26.145,12.0893],[26.145,14.8165],[17.0506,23.9109],[14.3234,23.9109],[14.2621,23.8465]]}],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,0],[-0.7509200000000007,0.751100000000001],[-0.7455999999999996,-0.7462],[0,0],[0,0],[-0.7508999999999979,-0.7510999999999992],[0.75,-0.75],[0,0],[0.7508999999999997,0.7510999999999974],[0.019899999999999807,0.02190000000000225]],"o":[[0,0],[-0.750770000000001,-0.7512000000000008],[0.7510699999999986,-0.7508999999999997],[0,0],[0,0],[0.751100000000001,-0.7510999999999992],[0.751100000000001,0.7508999999999997],[0,0],[-0.75,0.75],[-0.021099999999998786,-0.021100000000000563],[0,0]],"v":[[14.2621,23.8465],[9.85523,19.436],[9.85523,16.7087],[12.5824,16.7087],[15.6892,19.818],[23.4179,12.0893],[26.145,12.0893],[26.145,14.8165],[17.0506,23.9109],[14.3234,23.9109],[14.2621,23.8465]]}],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[0,0],[-0.7509200000000007,0.751100000000001],[-0.7455999999999996,-0.7462],[0,0],[0,0],[-0.7508999999999979,-0.7510999999999992],[0.75,-0.75],[0,0],[0.7508999999999997,0.7510999999999974],[0.019899999999999807,0.02190000000000225]],"o":[[0,0],[-0.750770000000001,-0.7512000000000008],[0.7510699999999986,-0.7508999999999997],[0,0],[0,0],[0.751100000000001,-0.7510999999999992],[0.751100000000001,0.7508999999999997],[0,0],[-0.75,0.75],[-0.021099999999998786,-0.021100000000000563],[0,0]],"v":[[14.2621,23.8465],[9.85523,19.436],[9.85523,16.7087],[12.5824,16.7087],[15.6892,19.818],[23.4179,12.0893],[26.145,12.0893],[26.145,14.8165],[17.0506,23.9109],[14.3234,23.9109],[14.2621,23.8465]]}],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,0],[-0.7509200000000007,0.751100000000001],[-0.7455999999999996,-0.7462],[0,0],[0,0],[-0.7508999999999979,-0.7510999999999992],[0.75,-0.75],[0,0],[0.7508999999999997,0.7510999999999974],[0.019899999999999807,0.02190000000000225]],"o":[[0,0],[-0.750770000000001,-0.7512000000000008],[0.7510699999999986,-0.7508999999999997],[0,0],[0,0],[0.751100000000001,-0.7510999999999992],[0.751100000000001,0.7508999999999997],[0,0],[-0.75,0.75],[-0.021099999999998786,-0.021100000000000563],[0,0]],"v":[[14.2621,23.8465],[9.85523,19.436],[9.85523,16.7087],[12.5824,16.7087],[15.6892,19.818],[23.4179,12.0893],[26.145,12.0893],[26.145,14.8165],[17.0506,23.9109],[14.3234,23.9109],[14.2621,23.8465]]}],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,0],[-0.7509200000000007,0.751100000000001],[-0.7455999999999996,-0.7462],[0,0],[0,0],[-0.7508999999999979,-0.7510999999999992],[0.75,-0.75],[0,0],[0.7508999999999997,0.7510999999999974],[0.019899999999999807,0.02190000000000225]],"o":[[0,0],[-0.750770000000001,-0.7512000000000008],[0.7510699999999986,-0.7508999999999997],[0,0],[0,0],[0.751100000000001,-0.7510999999999992],[0.751100000000001,0.7508999999999997],[0,0],[-0.75,0.75],[-0.021099999999998786,-0.021100000000000563],[0,0]],"v":[[14.2621,23.8465],[9.85523,19.436],[9.85523,16.7087],[12.5824,16.7087],[15.6892,19.818],[23.4179,12.0893],[26.145,12.0893],[26.145,14.8165],[17.0506,23.9109],[14.3234,23.9109],[14.2621,23.8465]]}],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,0],[-0.75,0.75],[-0.75,-0.75],[0,0],[0,0],[-0.75,-0.75],[0.75,-0.75],[0,0],[0.75,0.75],[0.02,0.02]],"o":[[0,0],[-0.75,-0.75],[0.75,-0.75],[0,0],[0,0],[0.75,-0.75],[0.75,0.75],[0,0],[-0.75,0.75],[-0.02,-0.02],[0,0]],"v":[[14.26,23.85],[9.86,19.44],[9.86,16.71],[12.58,16.71],[15.69,19.82],[23.42,12.09],[26.15,12.09],[26.15,14.82],[17.05,23.91],[14.32,23.91],[14.26,23.85]]}],"t":170},{"s":[{"c":true,"i":[[0,0],[0,0],[-0.75,0.75],[-0.75,-0.75],[0,0],[0,0],[-0.75,-0.75],[0.75,-0.75],[0,0],[0.75,0.75],[0.02,0.02]],"o":[[0,0],[-0.75,-0.75],[0.75,-0.75],[0,0],[0,0],[0.75,-0.75],[0.75,0.75],[0,0],[-0.75,0.75],[-0.02,-0.02],[0,0]],"v":[[14.26,23.85],[9.86,19.44],[9.86,16.71],[12.58,16.71],[15.69,19.82],[23.42,12.09],[26.15,12.09],[26.15,14.82],[17.05,23.91],[14.32,23.91],[14.26,23.85]]}],"t":182}]}},{"ty":"fl","bm":0,"hd":false,"nm":"","c":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0,0.7295,0],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0,0.7295,0],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[0,0.7295,0],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[0,0.7295,0],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[0,0.7295,0],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0,0.7295,0],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0,0.7295,0],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[0,0.7295,0],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[0,0.7295,0],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0,0.7295,0],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[0,0.7295,0],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0,0.7295,0],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[0,0.7295,0],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[0,0.7295,0],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[0,0.7295,0],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[0,0.7295,0],"t":170},{"s":[0,0.7295,0],"t":182}]},"r":2,"o":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[100],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[100],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[100],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[100],"t":170},{"s":[100],"t":182}]}}],"ind":1},{"ty":4,"nm":"Union","sr":1,"st":0,"op":170.97,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[56,70],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[56,70],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[56,70],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[56,70],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[56,70],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[56,70],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[56,70],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[56,70],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[56,70],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[56,70],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[56,70],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[56,70],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[56,70],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[56,70],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[56,70],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[56,70],"t":170},{"s":[56,70],"t":182}]},"s":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100,100],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100,100],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100,100],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100,100],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[100,100],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100,100],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100,100],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100,100],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100,100],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100,100],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[100,100],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100,100],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100,100],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100,100],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[100,100],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[100,100],"t":170},{"s":[100,100],"t":182}]},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[96,96],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[96,96],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[96,96],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[96,96],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[96,96],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[96,96],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[96,96],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[96,96],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[96,96],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[96,96],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[96,96],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[96,96],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[96,96],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[96,96],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[96,96],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[96,96],"t":170},{"s":[96,96],"t":182}]},"r":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[-90],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[-90],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[8.16],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[-0.49],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[0.01],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[0],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[0],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[0],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[-98.16],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[-89.51],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[-90.01],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[-90],"t":170},{"s":[-90],"t":182}]},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[100],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[100],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[100],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[100],"t":170},{"s":[100],"t":182}]}},"shapes":[{"ty":"sh","bm":0,"hd":false,"nm":"","d":1,"ks":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,-5.1060300000000005],[0,0],[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0]],"o":[[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0],[0,-5.10603],[0,0],[0,0]],"v":[[9.33334,0],[0,9.24529],[0,130.755],[9.33334,140],[102.667,140],[112,130.755],[112,9.24528],[102.667,0],[9.33334,0]]}],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,-5.1060300000000005],[0,0],[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0]],"o":[[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0],[0,-5.10603],[0,0],[0,0]],"v":[[9.33334,0],[0,9.24529],[0,130.755],[9.33334,140],[102.667,140],[112,130.755],[112,9.24528],[102.667,0],[9.33334,0]]}],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[0,-5.1060300000000005],[0,0],[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0]],"o":[[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0],[0,-5.10603],[0,0],[0,0]],"v":[[9.33334,0],[0,9.24529],[0,130.755],[9.33334,140],[102.667,140],[112,130.755],[112,9.24528],[102.667,0],[9.33334,0]]}],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,-5.1060300000000005],[0,0],[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0]],"o":[[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0],[0,-5.10603],[0,0],[0,0]],"v":[[9.33334,0],[0,9.24529],[0,130.755],[9.33334,140],[102.667,140],[112,130.755],[112,9.24528],[102.667,0],[9.33334,0]]}],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,-5.1060300000000005],[0,0],[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0]],"o":[[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0],[0,-5.10603],[0,0],[0,0]],"v":[[9.33334,0],[0,9.24529],[0,130.755],[9.33334,140],[102.667,140],[112,130.755],[112,9.24528],[102.667,0],[9.33334,0]]}],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,-5.1060300000000005],[0,0],[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0]],"o":[[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0],[0,-5.10603],[0,0],[0,0]],"v":[[9.33334,0],[0,9.24529],[0,130.755],[9.33334,140],[102.667,140],[112,130.755],[112,9.24528],[102.667,0],[9.33334,0]]}],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,-5.1060300000000005],[0,0],[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0]],"o":[[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0],[0,-5.10603],[0,0],[0,0]],"v":[[9.33334,0],[0,9.24529],[0,130.755],[9.33334,140],[102.667,140],[112,130.755],[112,9.24528],[102.667,0],[9.33334,0]]}],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[0,-5.1060300000000005],[0,0],[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0]],"o":[[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0],[0,-5.10603],[0,0],[0,0]],"v":[[9.33334,0],[0,9.24529],[0,130.755],[9.33334,140],[102.667,140],[112,130.755],[112,9.24528],[102.667,0],[9.33334,0]]}],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,-5.1060300000000005],[0,0],[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0]],"o":[[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0],[0,-5.10603],[0,0],[0,0]],"v":[[9.33334,0],[0,9.24529],[0,130.755],[9.33334,140],[102.667,140],[112,130.755],[112,9.24528],[102.667,0],[9.33334,0]]}],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,-5.1060300000000005],[0,0],[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0]],"o":[[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0],[0,-5.10603],[0,0],[0,0]],"v":[[9.33334,0],[0,9.24529],[0,130.755],[9.33334,140],[102.667,140],[112,130.755],[112,9.24528],[102.667,0],[9.33334,0]]}],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,-5.1060300000000005],[0,0],[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0]],"o":[[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0],[0,-5.10603],[0,0],[0,0]],"v":[[9.33334,0],[0,9.24529],[0,130.755],[9.33334,140],[102.667,140],[112,130.755],[112,9.24528],[102.667,0],[9.33334,0]]}],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,-5.1060300000000005],[0,0],[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0]],"o":[[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0],[0,-5.10603],[0,0],[0,0]],"v":[[9.33334,0],[0,9.24529],[0,130.755],[9.33334,140],[102.667,140],[112,130.755],[112,9.24528],[102.667,0],[9.33334,0]]}],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[0,-5.1060300000000005],[0,0],[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0]],"o":[[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0],[0,-5.10603],[0,0],[0,0]],"v":[[9.33334,0],[0,9.24529],[0,130.755],[9.33334,140],[102.667,140],[112,130.755],[112,9.24528],[102.667,0],[9.33334,0]]}],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,-5.1060300000000005],[0,0],[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0]],"o":[[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0],[0,-5.10603],[0,0],[0,0]],"v":[[9.33334,0],[0,9.24529],[0,130.755],[9.33334,140],[102.667,140],[112,130.755],[112,9.24528],[102.667,0],[9.33334,0]]}],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,-5.1060300000000005],[0,0],[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0]],"o":[[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0],[0,-5.10603],[0,0],[0,0]],"v":[[9.33334,0],[0,9.24529],[0,130.755],[9.33334,140],[102.667,140],[112,130.755],[112,9.24528],[102.667,0],[9.33334,0]]}],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,-5.11],[0,0],[-5.15,0],[0,0],[0,5.11],[0,0],[5.15,0],[0,0]],"o":[[-5.15,0],[0,0],[0,5.11],[0,0],[5.15,0],[0,0],[0,-5.11],[0,0],[0,0]],"v":[[9.33,0],[0,9.25],[0,130.76],[9.33,140],[102.67,140],[112,130.76],[112,9.25],[102.67,0],[9.33,0]]}],"t":170},{"s":[{"c":true,"i":[[0,0],[0,-5.11],[0,0],[-5.15,0],[0,0],[0,5.11],[0,0],[5.15,0],[0,0]],"o":[[-5.15,0],[0,0],[0,5.11],[0,0],[5.15,0],[0,0],[0,-5.11],[0,0],[0,0]],"v":[[9.33,0],[0,9.25],[0,130.76],[9.33,140],[102.67,140],[112,130.76],[112,9.25],[102.67,0],[9.33,0]]}],"t":182}]}},{"ty":"sh","bm":0,"hd":false,"nm":"","d":1,"ks":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[-0.7363800000000005,0],[0,0],[0,-0.7294299999999989],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0]],"o":[[0,-0.7294400000000003],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0],[-0.7363800000000005,0],[0,0],[0,0]],"v":[[8,9.24529],[9.33334,7.92453],[102.667,7.92453],[104,9.24528],[104,130.755],[102.667,132.075],[9.33334,132.075],[8,130.755],[8,9.24529]]}],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[-0.7363800000000005,0],[0,0],[0,-0.7294299999999989],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0]],"o":[[0,-0.7294400000000003],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0],[-0.7363800000000005,0],[0,0],[0,0]],"v":[[8,9.24529],[9.33334,7.92453],[102.667,7.92453],[104,9.24528],[104,130.755],[102.667,132.075],[9.33334,132.075],[8,130.755],[8,9.24529]]}],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[-0.7363800000000005,0],[0,0],[0,-0.7294299999999989],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0]],"o":[[0,-0.7294400000000003],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0],[-0.7363800000000005,0],[0,0],[0,0]],"v":[[8,9.24529],[9.33334,7.92453],[102.667,7.92453],[104,9.24528],[104,130.755],[102.667,132.075],[9.33334,132.075],[8,130.755],[8,9.24529]]}],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[-0.7363800000000005,0],[0,0],[0,-0.7294299999999989],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0]],"o":[[0,-0.7294400000000003],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0],[-0.7363800000000005,0],[0,0],[0,0]],"v":[[8,9.24529],[9.33334,7.92453],[102.667,7.92453],[104,9.24528],[104,130.755],[102.667,132.075],[9.33334,132.075],[8,130.755],[8,9.24529]]}],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[-0.7363800000000005,0],[0,0],[0,-0.7294299999999989],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0]],"o":[[0,-0.7294400000000003],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0],[-0.7363800000000005,0],[0,0],[0,0]],"v":[[8,9.24529],[9.33334,7.92453],[102.667,7.92453],[104,9.24528],[104,130.755],[102.667,132.075],[9.33334,132.075],[8,130.755],[8,9.24529]]}],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[-0.7363800000000005,0],[0,0],[0,-0.7294299999999989],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0]],"o":[[0,-0.7294400000000003],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0],[-0.7363800000000005,0],[0,0],[0,0]],"v":[[8,9.24529],[9.33334,7.92453],[102.667,7.92453],[104,9.24528],[104,130.755],[102.667,132.075],[9.33334,132.075],[8,130.755],[8,9.24529]]}],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[-0.7363800000000005,0],[0,0],[0,-0.7294299999999989],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0]],"o":[[0,-0.7294400000000003],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0],[-0.7363800000000005,0],[0,0],[0,0]],"v":[[8,9.24529],[9.33334,7.92453],[102.667,7.92453],[104,9.24528],[104,130.755],[102.667,132.075],[9.33334,132.075],[8,130.755],[8,9.24529]]}],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[-0.7363800000000005,0],[0,0],[0,-0.7294299999999989],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0]],"o":[[0,-0.7294400000000003],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0],[-0.7363800000000005,0],[0,0],[0,0]],"v":[[8,9.24529],[9.33334,7.92453],[102.667,7.92453],[104,9.24528],[104,130.755],[102.667,132.075],[9.33334,132.075],[8,130.755],[8,9.24529]]}],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[-0.7363800000000005,0],[0,0],[0,-0.7294299999999989],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0]],"o":[[0,-0.7294400000000003],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0],[-0.7363800000000005,0],[0,0],[0,0]],"v":[[8,9.24529],[9.33334,7.92453],[102.667,7.92453],[104,9.24528],[104,130.755],[102.667,132.075],[9.33334,132.075],[8,130.755],[8,9.24529]]}],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[-0.7363800000000005,0],[0,0],[0,-0.7294299999999989],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0]],"o":[[0,-0.7294400000000003],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0],[-0.7363800000000005,0],[0,0],[0,0]],"v":[[8,9.24529],[9.33334,7.92453],[102.667,7.92453],[104,9.24528],[104,130.755],[102.667,132.075],[9.33334,132.075],[8,130.755],[8,9.24529]]}],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[-0.7363800000000005,0],[0,0],[0,-0.7294299999999989],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0]],"o":[[0,-0.7294400000000003],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0],[-0.7363800000000005,0],[0,0],[0,0]],"v":[[8,9.24529],[9.33334,7.92453],[102.667,7.92453],[104,9.24528],[104,130.755],[102.667,132.075],[9.33334,132.075],[8,130.755],[8,9.24529]]}],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[-0.7363800000000005,0],[0,0],[0,-0.7294299999999989],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0]],"o":[[0,-0.7294400000000003],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0],[-0.7363800000000005,0],[0,0],[0,0]],"v":[[8,9.24529],[9.33334,7.92453],[102.667,7.92453],[104,9.24528],[104,130.755],[102.667,132.075],[9.33334,132.075],[8,130.755],[8,9.24529]]}],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[-0.7363800000000005,0],[0,0],[0,-0.7294299999999989],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0]],"o":[[0,-0.7294400000000003],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0],[-0.7363800000000005,0],[0,0],[0,0]],"v":[[8,9.24529],[9.33334,7.92453],[102.667,7.92453],[104,9.24528],[104,130.755],[102.667,132.075],[9.33334,132.075],[8,130.755],[8,9.24529]]}],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[-0.7363800000000005,0],[0,0],[0,-0.7294299999999989],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0]],"o":[[0,-0.7294400000000003],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0],[-0.7363800000000005,0],[0,0],[0,0]],"v":[[8,9.24529],[9.33334,7.92453],[102.667,7.92453],[104,9.24528],[104,130.755],[102.667,132.075],[9.33334,132.075],[8,130.755],[8,9.24529]]}],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[-0.7363800000000005,0],[0,0],[0,-0.7294299999999989],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0]],"o":[[0,-0.7294400000000003],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0],[-0.7363800000000005,0],[0,0],[0,0]],"v":[[8,9.24529],[9.33334,7.92453],[102.667,7.92453],[104,9.24528],[104,130.755],[102.667,132.075],[9.33334,132.075],[8,130.755],[8,9.24529]]}],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[-0.74,0],[0,0],[0,-0.73],[0,0],[0.74,0],[0,0],[0,0.73],[0,0]],"o":[[0,-0.73],[0,0],[0.74,0],[0,0],[0,0.73],[0,0],[-0.74,0],[0,0],[0,0]],"v":[[8,9.25],[9.33,7.92],[102.67,7.92],[104,9.25],[104,130.76],[102.67,132.07],[9.33,132.07],[8,130.76],[8,9.25]]}],"t":170},{"s":[{"c":true,"i":[[0,0],[-0.74,0],[0,0],[0,-0.73],[0,0],[0.74,0],[0,0],[0,0.73],[0,0]],"o":[[0,-0.73],[0,0],[0.74,0],[0,0],[0,0.73],[0,0],[-0.74,0],[0,0],[0,0]],"v":[[8,9.25],[9.33,7.92],[102.67,7.92],[104,9.25],[104,130.76],[102.67,132.07],[9.33,132.07],[8,130.76],[8,9.25]]}],"t":182}]}},{"ty":"sh","bm":0,"hd":false,"nm":"","d":1,"ks":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[-2.2090999999999994,0],[0,0],[0,-2.209000000000003],[2.2091000000000065,0],[0,0],[0,2.209000000000003]],"o":[[0,-2.209000000000003],[0,0],[2.2091000000000065,0],[0,2.209000000000003],[0,0],[-2.2090999999999994,0],[0,0]],"v":[[28,118],[32,114],[80,114],[84,118],[80,122],[32,122],[28,118]]}],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[-2.2090999999999994,0],[0,0],[0,-2.209000000000003],[2.2091000000000065,0],[0,0],[0,2.209000000000003]],"o":[[0,-2.209000000000003],[0,0],[2.2091000000000065,0],[0,2.209000000000003],[0,0],[-2.2090999999999994,0],[0,0]],"v":[[28,118],[32,114],[80,114],[84,118],[80,122],[32,122],[28,118]]}],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[-2.2090999999999994,0],[0,0],[0,-2.209000000000003],[2.2091000000000065,0],[0,0],[0,2.209000000000003]],"o":[[0,-2.209000000000003],[0,0],[2.2091000000000065,0],[0,2.209000000000003],[0,0],[-2.2090999999999994,0],[0,0]],"v":[[28,118],[32,114],[80,114],[84,118],[80,122],[32,122],[28,118]]}],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[-2.2090999999999994,0],[0,0],[0,-2.209000000000003],[2.2091000000000065,0],[0,0],[0,2.209000000000003]],"o":[[0,-2.209000000000003],[0,0],[2.2091000000000065,0],[0,2.209000000000003],[0,0],[-2.2090999999999994,0],[0,0]],"v":[[28,118],[32,114],[80,114],[84,118],[80,122],[32,122],[28,118]]}],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[-2.2090999999999994,0],[0,0],[0,-2.209000000000003],[2.2091000000000065,0],[0,0],[0,2.209000000000003]],"o":[[0,-2.209000000000003],[0,0],[2.2091000000000065,0],[0,2.209000000000003],[0,0],[-2.2090999999999994,0],[0,0]],"v":[[28,118],[32,114],[80,114],[84,118],[80,122],[32,122],[28,118]]}],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[-2.2090999999999994,0],[0,0],[0,-2.209000000000003],[2.2091000000000065,0],[0,0],[0,2.209000000000003]],"o":[[0,-2.209000000000003],[0,0],[2.2091000000000065,0],[0,2.209000000000003],[0,0],[-2.2090999999999994,0],[0,0]],"v":[[28,118],[32,114],[80,114],[84,118],[80,122],[32,122],[28,118]]}],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[-2.2090999999999994,0],[0,0],[0,-2.209000000000003],[2.2091000000000065,0],[0,0],[0,2.209000000000003]],"o":[[0,-2.209000000000003],[0,0],[2.2091000000000065,0],[0,2.209000000000003],[0,0],[-2.2090999999999994,0],[0,0]],"v":[[28,118],[32,114],[80,114],[84,118],[80,122],[32,122],[28,118]]}],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[-2.2090999999999994,0],[0,0],[0,-2.209000000000003],[2.2091000000000065,0],[0,0],[0,2.209000000000003]],"o":[[0,-2.209000000000003],[0,0],[2.2091000000000065,0],[0,2.209000000000003],[0,0],[-2.2090999999999994,0],[0,0]],"v":[[28,118],[32,114],[80,114],[84,118],[80,122],[32,122],[28,118]]}],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[-2.2090999999999994,0],[0,0],[0,-2.209000000000003],[2.2091000000000065,0],[0,0],[0,2.209000000000003]],"o":[[0,-2.209000000000003],[0,0],[2.2091000000000065,0],[0,2.209000000000003],[0,0],[-2.2090999999999994,0],[0,0]],"v":[[28,118],[32,114],[80,114],[84,118],[80,122],[32,122],[28,118]]}],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[-2.2090999999999994,0],[0,0],[0,-2.209000000000003],[2.2091000000000065,0],[0,0],[0,2.209000000000003]],"o":[[0,-2.209000000000003],[0,0],[2.2091000000000065,0],[0,2.209000000000003],[0,0],[-2.2090999999999994,0],[0,0]],"v":[[28,118],[32,114],[80,114],[84,118],[80,122],[32,122],[28,118]]}],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[-2.2090999999999994,0],[0,0],[0,-2.209000000000003],[2.2091000000000065,0],[0,0],[0,2.209000000000003]],"o":[[0,-2.209000000000003],[0,0],[2.2091000000000065,0],[0,2.209000000000003],[0,0],[-2.2090999999999994,0],[0,0]],"v":[[28,118],[32,114],[80,114],[84,118],[80,122],[32,122],[28,118]]}],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[-2.2090999999999994,0],[0,0],[0,-2.209000000000003],[2.2091000000000065,0],[0,0],[0,2.209000000000003]],"o":[[0,-2.209000000000003],[0,0],[2.2091000000000065,0],[0,2.209000000000003],[0,0],[-2.2090999999999994,0],[0,0]],"v":[[28,118],[32,114],[80,114],[84,118],[80,122],[32,122],[28,118]]}],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[-2.2090999999999994,0],[0,0],[0,-2.209000000000003],[2.2091000000000065,0],[0,0],[0,2.209000000000003]],"o":[[0,-2.209000000000003],[0,0],[2.2091000000000065,0],[0,2.209000000000003],[0,0],[-2.2090999999999994,0],[0,0]],"v":[[28,118],[32,114],[80,114],[84,118],[80,122],[32,122],[28,118]]}],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[-2.2090999999999994,0],[0,0],[0,-2.209000000000003],[2.2091000000000065,0],[0,0],[0,2.209000000000003]],"o":[[0,-2.209000000000003],[0,0],[2.2091000000000065,0],[0,2.209000000000003],[0,0],[-2.2090999999999994,0],[0,0]],"v":[[28,118],[32,114],[80,114],[84,118],[80,122],[32,122],[28,118]]}],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[-2.2090999999999994,0],[0,0],[0,-2.209000000000003],[2.2091000000000065,0],[0,0],[0,2.209000000000003]],"o":[[0,-2.209000000000003],[0,0],[2.2091000000000065,0],[0,2.209000000000003],[0,0],[-2.2090999999999994,0],[0,0]],"v":[[28,118],[32,114],[80,114],[84,118],[80,122],[32,122],[28,118]]}],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[-2.21,0],[0,0],[0,-2.21],[2.21,0],[0,0],[0,2.21]],"o":[[0,-2.21],[0,0],[2.21,0],[0,2.21],[0,0],[-2.21,0],[0,0]],"v":[[28,118],[32,114],[80,114],[84,118],[80,122],[32,122],[28,118]]}],"t":170},{"s":[{"c":true,"i":[[0,0],[-2.21,0],[0,0],[0,-2.21],[2.21,0],[0,0],[0,2.21]],"o":[[0,-2.21],[0,0],[2.21,0],[0,2.21],[0,0],[-2.21,0],[0,0]],"v":[[28,118],[32,114],[80,114],[84,118],[80,122],[32,122],[28,118]]}],"t":182}]}},{"ty":"sh","bm":0,"hd":false,"nm":"","d":1,"ks":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,4.418300000000002],[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0]],"o":[[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0],[0,4.418300000000002],[0,0]],"v":[[56,38],[64,30],[56,22],[48,30],[56,38]]}],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,4.418300000000002],[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0]],"o":[[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0],[0,4.418300000000002],[0,0]],"v":[[56,38],[64,30],[56,22],[48,30],[56,38]]}],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[0,4.418300000000002],[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0]],"o":[[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0],[0,4.418300000000002],[0,0]],"v":[[56,38],[64,30],[56,22],[48,30],[56,38]]}],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,4.418300000000002],[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0]],"o":[[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0],[0,4.418300000000002],[0,0]],"v":[[56,38],[64,30],[56,22],[48,30],[56,38]]}],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,4.418300000000002],[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0]],"o":[[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0],[0,4.418300000000002],[0,0]],"v":[[56,38],[64,30],[56,22],[48,30],[56,38]]}],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,4.418300000000002],[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0]],"o":[[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0],[0,4.418300000000002],[0,0]],"v":[[56,38],[64,30],[56,22],[48,30],[56,38]]}],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,4.418300000000002],[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0]],"o":[[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0],[0,4.418300000000002],[0,0]],"v":[[56,38],[64,30],[56,22],[48,30],[56,38]]}],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[0,4.418300000000002],[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0]],"o":[[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0],[0,4.418300000000002],[0,0]],"v":[[56,38],[64,30],[56,22],[48,30],[56,38]]}],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,4.418300000000002],[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0]],"o":[[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0],[0,4.418300000000002],[0,0]],"v":[[56,38],[64,30],[56,22],[48,30],[56,38]]}],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,4.418300000000002],[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0]],"o":[[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0],[0,4.418300000000002],[0,0]],"v":[[56,38],[64,30],[56,22],[48,30],[56,38]]}],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,4.418300000000002],[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0]],"o":[[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0],[0,4.418300000000002],[0,0]],"v":[[56,38],[64,30],[56,22],[48,30],[56,38]]}],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,4.418300000000002],[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0]],"o":[[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0],[0,4.418300000000002],[0,0]],"v":[[56,38],[64,30],[56,22],[48,30],[56,38]]}],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[0,4.418300000000002],[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0]],"o":[[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0],[0,4.418300000000002],[0,0]],"v":[[56,38],[64,30],[56,22],[48,30],[56,38]]}],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,4.418300000000002],[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0]],"o":[[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0],[0,4.418300000000002],[0,0]],"v":[[56,38],[64,30],[56,22],[48,30],[56,38]]}],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,4.418300000000002],[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0]],"o":[[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0],[0,4.418300000000002],[0,0]],"v":[[56,38],[64,30],[56,22],[48,30],[56,38]]}],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,4.42],[4.42,0],[0,-4.42],[-4.42,0]],"o":[[4.42,0],[0,-4.42],[-4.42,0],[0,4.42],[0,0]],"v":[[56,38],[64,30],[56,22],[48,30],[56,38]]}],"t":170},{"s":[{"c":true,"i":[[0,0],[0,4.42],[4.42,0],[0,-4.42],[-4.42,0]],"o":[[4.42,0],[0,-4.42],[-4.42,0],[0,4.42],[0,0]],"v":[[56,38],[64,30],[56,22],[48,30],[56,38]]}],"t":182}]}},{"ty":"fl","bm":0,"hd":false,"nm":"","c":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0,0,0],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0,0,0],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[0,0,0],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[0,0,0],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[0,0,0],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0,0,0],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0,0,0],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[0,0,0],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[0,0,0],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0,0,0],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[0,0,0],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0,0,0],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[0,0,0],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[0,0,0],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[0,0,0],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[0,0,0],"t":170},{"s":[0,0,0],"t":182}]},"r":2,"o":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[100],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[100],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[100],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[100],"t":170},{"s":[100],"t":182}]}}],"ind":2},{"ty":4,"nm":"One Bg","sr":1,"st":0,"op":170.97,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[96,96],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[96,96],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[96,96],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[96,96],"t":41.77022171020508},{"s":[96,96],"t":56.65533256530762}]},"s":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100,100],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100,100],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100,100],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100,100],"t":41.77022171020508},{"s":[100,100],"t":56.65533256530762}]},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[96,96],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[96,96],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[96,96],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[96,96],"t":41.77022171020508},{"s":[96,96],"t":56.65533256530762}]},"r":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[0],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[0],"t":41.77022171020508},{"s":[0],"t":56.65533256530762}]},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100],"t":41.77022171020508},{"s":[100],"t":56.65533256530762}]}},"shapes":[{"ty":"sh","bm":0,"hd":false,"nm":"","d":1,"ks":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[192,0],[192,192],[0,192],[0,0]]}],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[192,0],[192,192],[0,192],[0,0]]}],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[192,0],[192,192],[0,192],[0,0]]}],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[192,0],[192,192],[0,192],[0,0]]}],"t":41.77022171020508},{"s":[{"c":true,"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[192,0],[192,192],[0,192],[0,0]]}],"t":56.65533256530762}]}},{"ty":"fl","bm":0,"hd":false,"nm":"","c":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[1,1,1],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[1,1,1],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[1,1,1],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[1,1,1],"t":41.77022171020508},{"s":[1,1,1],"t":56.65533256530762}]},"r":1,"o":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100],"t":41.77022171020508},{"s":[100],"t":56.65533256530762}]}}],"ind":3}],"v":"5.7.0","fr":60,"op":169.97,"ip":0,"assets":[]}');


var $3c69c006dec20133$exports = {};
$3c69c006dec20133$exports = JSON.parse('{"v":"5.10.2","fr":60,"ip":0,"op":137,"w":20,"h":20,"nm":"Loop-Inline","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Load-Ellipse_White","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[1]},{"t":136,"s":[361]}],"ix":10},"p":{"a":0,"k":[10,10,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[18,18],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.4],"y":[1]},"o":{"x":[0.24],"y":[0]},"t":76,"s":[1]},{"t":136,"s":[99]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.76],"y":[1]},"o":{"x":[0.6],"y":[0]},"t":0,"s":[0]},{"t":60,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.215686276555,0.317647069693,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0}],"markers":[]}');


var $d42e58628ac616c3$exports = {};
$d42e58628ac616c3$exports = JSON.parse('{"v":"5.10.2","fr":60,"ip":0,"op":137,"w":20,"h":20,"nm":"Loop-Inline","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Load-Ellipse_White","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[1]},{"t":136,"s":[361]}],"ix":10},"p":{"a":0,"k":[10,10,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[18,18],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.4],"y":[1]},"o":{"x":[0.24],"y":[0]},"t":76,"s":[1]},{"t":136,"s":[99]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.76],"y":[1]},"o":{"x":[0.6],"y":[0]},"t":0,"s":[0]},{"t":60,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.800000011921,0.109803922474,0.06274510175,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0}],"markers":[]}');


var $523530ab0c1f8cdc$exports = {};
$523530ab0c1f8cdc$exports = JSON.parse('{"v":"5.10.2","fr":60,"ip":0,"op":137,"w":20,"h":20,"nm":"Loop-Inline","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Load-Ellipse_White","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[1]},{"t":136,"s":[361]}],"ix":10},"p":{"a":0,"k":[10,10,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[18,18],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.4],"y":[1]},"o":{"x":[0.24],"y":[0]},"t":76,"s":[1]},{"t":136,"s":[99]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.76],"y":[1]},"o":{"x":[0.6],"y":[0]},"t":0,"s":[0]},{"t":60,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.313725501299,0.207843139768,0.835294127464,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0}],"markers":[]}');


var $21340c71d2b5092c$exports = {};
$21340c71d2b5092c$exports = JSON.parse('{"v":"5.10.2","fr":60,"ip":0,"op":137,"w":20,"h":20,"nm":"Loop-Inline","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Load-Ellipse_White","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[1]},{"t":136,"s":[361]}],"ix":10},"p":{"a":0,"k":[10,10,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[18,18],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.4],"y":[1]},"o":{"x":[0.24],"y":[0]},"t":76,"s":[1]},{"t":136,"s":[99]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.76],"y":[1]},"o":{"x":[0.6],"y":[0]},"t":0,"s":[0]},{"t":60,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0}],"markers":[]}');


var $a1ce7d97fdc501f5$exports = {};
$a1ce7d97fdc501f5$exports = JSON.parse('{"v":"5.10.2","fr":60,"ip":0,"op":137,"w":80,"h":80,"nm":"Loop-Large","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Load-Ellipse","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[1]},{"t":136,"s":[361]}],"ix":10},"p":{"a":0,"k":[40,40,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[68,68],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.4],"y":[1]},"o":{"x":[0.24],"y":[0]},"t":76,"s":[1]},{"t":136,"s":[99]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.76],"y":[1]},"o":{"x":[0.6],"y":[0]},"t":0,"s":[0]},{"t":60,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.227450996637,0.329411774874,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":12,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Load-Ellipse 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[1]},{"t":136,"s":[361]}],"ix":10},"p":{"a":0,"k":[40,40,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[68,68],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.4],"y":[1]},"o":{"x":[0.24],"y":[0]},"t":84,"s":[1]},{"t":136,"s":[99]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.76],"y":[1]},"o":{"x":[0.6],"y":[0]},"t":0,"s":[0]},{"t":68,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.577236533165,0.633032739162,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":12,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Load-Ellipse 3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[1]},{"t":136,"s":[361]}],"ix":10},"p":{"a":0,"k":[40,40,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[68,68],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.4],"y":[1]},"o":{"x":[0.24],"y":[0]},"t":94,"s":[1]},{"t":136,"s":[99]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.76],"y":[1]},"o":{"x":[0.6],"y":[0]},"t":0,"s":[0]},{"t":78,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.857766509056,0.876538455486,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":12,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0}],"markers":[]}');


var $63fe6ed56ad205df$exports = {};
$63fe6ed56ad205df$exports = JSON.parse('{"v":"5.10.2","fr":60,"ip":0,"op":137,"w":80,"h":80,"nm":"Loop-Large","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":4,"ty":4,"nm":"Load-Ellipse 6","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[1]},{"t":136,"s":[361]}],"ix":10},"p":{"a":0,"k":[40,40,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[68,68],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.4],"y":[1]},"o":{"x":[0.24],"y":[0]},"t":76,"s":[1]},{"t":136,"s":[99]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.76],"y":[1]},"o":{"x":[0.6],"y":[0]},"t":0,"s":[0]},{"t":60,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":12,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Load-Ellipse 5","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[1]},{"t":136,"s":[361]}],"ix":10},"p":{"a":0,"k":[40,40,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[68,68],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.4],"y":[1]},"o":{"x":[0.24],"y":[0]},"t":84,"s":[1]},{"t":136,"s":[99]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.76],"y":[1]},"o":{"x":[0.6],"y":[0]},"t":0,"s":[0]},{"t":68,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":50,"ix":4},"w":{"a":0,"k":12,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"Load-Ellipse 4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[1]},{"t":136,"s":[361]}],"ix":10},"p":{"a":0,"k":[40,40,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[68,68],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.4],"y":[1]},"o":{"x":[0.24],"y":[0]},"t":94,"s":[1]},{"t":136,"s":[99]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.76],"y":[1]},"o":{"x":[0.6],"y":[0]},"t":0,"s":[0]},{"t":78,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":25,"ix":4},"w":{"a":0,"k":12,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0}],"markers":[]}');


var $8ab0ce2b798b4e98$exports = {};
$8ab0ce2b798b4e98$exports = JSON.parse('{"v":"5.10.2","fr":60,"ip":0,"op":113,"w":40,"h":40,"nm":"Skeleton_Circle","ddd":0,"assets":[{"id":"comp_0","nm":"Shape_PreCOMP","fr":60,"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Shape_MATTE","td":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[20,20,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"sy":[{"bm":{"a":0,"k":1,"ix":1},"o":{"a":0,"k":100,"ix":2},"gf":{"a":0,"ix":3},"gs":{"a":0,"k":100,"ix":4},"a":{"a":0,"k":0,"ix":5},"gt":{"a":0,"k":1,"ix":6},"re":{"a":0,"k":0,"ix":7},"al":{"a":0,"k":1,"ix":8},"s":{"a":0,"k":100,"ix":9},"of":{"a":0,"k":[-120,0],"ix":10},"ty":8,"nm":"Gradient Overlay"}],"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[40,40],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Shape Layer 1","tt":1,"tp":1,"sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.24],"y":[1]},"o":{"x":[0.76],"y":[0]},"t":56,"s":[100]},{"t":112,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.6,"y":1},"o":{"x":0.32,"y":0.94},"t":0,"s":[-20,20,0],"to":[6.667,0,0],"ti":[-6.667,0,0]},{"t":56,"s":[20,20,0]}],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[40,40],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[0.854901969433,0.86274510622,0.898039221764,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0}]}],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Shape_MATTE","td":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[20,20,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"sy":[{"bm":{"a":0,"k":1,"ix":1},"o":{"a":0,"k":100,"ix":2},"gf":{"a":0,"ix":3},"gs":{"a":0,"k":100,"ix":4},"a":{"a":0,"k":0,"ix":5},"gt":{"a":0,"k":1,"ix":6},"re":{"a":0,"k":0,"ix":7},"al":{"a":0,"k":1,"ix":8},"s":{"a":0,"k":100,"ix":9},"of":{"a":0,"k":[-120,0],"ix":10},"ty":8,"nm":"Gradient Overlay"}],"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[40,40],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0},{"ddd":0,"ind":2,"ty":0,"nm":"Shape_PreCOMP","tt":1,"tp":1,"refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[20,20,0],"ix":2,"l":2},"a":{"a":0,"k":[20,20,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"ef":[{"ty":29,"nm":"Gaussian Blur","np":5,"mn":"ADBE Gaussian Blur 2","ix":1,"en":1,"ef":[{"ty":0,"nm":"Blurriness","mn":"ADBE Gaussian Blur 2-0001","ix":1,"v":{"a":0,"k":12,"ix":1}},{"ty":7,"nm":"Blur Dimensions","mn":"ADBE Gaussian Blur 2-0002","ix":2,"v":{"a":0,"k":1,"ix":2}},{"ty":7,"nm":"Repeat Edge Pixels","mn":"ADBE Gaussian Blur 2-0003","ix":3,"v":{"a":0,"k":1,"ix":3}}]}],"w":40,"h":40,"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Shape","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[20,20,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"sy":[{"bm":{"a":0,"k":1,"ix":1},"o":{"a":0,"k":100,"ix":2},"gf":{"a":0,"ix":3},"gs":{"a":0,"k":100,"ix":4},"a":{"a":0,"k":0,"ix":5},"gt":{"a":0,"k":1,"ix":6},"re":{"a":0,"k":0,"ix":7},"al":{"a":0,"k":1,"ix":8},"s":{"a":0,"k":100,"ix":9},"of":{"a":0,"k":[-120,0],"ix":10},"ty":8,"nm":"Gradient Overlay"}],"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[40,40],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[0.945098042488,0.949019610882,0.964705884457,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0}],"markers":[]}');


var $8f659d18c956cd64$exports = {};
$8f659d18c956cd64$exports = JSON.parse('{"v":"5.10.2","fr":60,"ip":0,"op":113,"w":120,"h":120,"nm":"Skeleton_Square","ddd":0,"assets":[{"id":"comp_0","nm":"Shape_PreCOMP","fr":60,"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Shape_MATTE","td":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[60,28,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[120,120],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":4,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,32],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Shape Layer 2","tt":1,"tp":1,"sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.24],"y":[1]},"o":{"x":[0.76],"y":[0]},"t":56,"s":[100]},{"t":112,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.6,"y":1},"o":{"x":0.32,"y":0.94},"t":0,"s":[-60,60,0],"to":[20,0,0],"ti":[-20,0,0]},{"t":56,"s":[60,60,0]}],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[120,120],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[0.854901969433,0.86274510622,0.898039221764,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0}]}],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Shape_MATTE","td":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[60,28,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[120,120],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":4,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,32],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0},{"ddd":0,"ind":2,"ty":0,"nm":"Shape_PreCOMP","tt":1,"tp":1,"refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[60,60,0],"ix":2,"l":2},"a":{"a":0,"k":[60,60,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"ef":[{"ty":29,"nm":"Gaussian Blur","np":5,"mn":"ADBE Gaussian Blur 2","ix":1,"en":1,"ef":[{"ty":0,"nm":"Blurriness","mn":"ADBE Gaussian Blur 2-0001","ix":1,"v":{"a":0,"k":12,"ix":1}},{"ty":7,"nm":"Blur Dimensions","mn":"ADBE Gaussian Blur 2-0002","ix":2,"v":{"a":0,"k":1,"ix":2}},{"ty":7,"nm":"Repeat Edge Pixels","mn":"ADBE Gaussian Blur 2-0003","ix":3,"v":{"a":0,"k":1,"ix":3}}]}],"w":120,"h":120,"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Square","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[60,28,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"sy":[{"bm":{"a":0,"k":1,"ix":1},"o":{"a":0,"k":100,"ix":2},"gf":{"a":0,"ix":3},"gs":{"a":0,"k":100,"ix":4},"a":{"a":0,"k":0,"ix":5},"gt":{"a":0,"k":1,"ix":6},"re":{"a":0,"k":0,"ix":7},"al":{"a":0,"k":1,"ix":8},"s":{"a":0,"k":100,"ix":9},"of":{"a":0,"k":[-120,0],"ix":10},"ty":8,"nm":"Gradient Overlay"}],"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[120,120],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":4,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[0.945098042488,0.949019610882,0.964705884457,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,32],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0}],"markers":[]}');


var $fc02bd95caddb1ce$exports = {};
$fc02bd95caddb1ce$exports = JSON.parse('{"v":"5.10.2","fr":60,"ip":0,"op":113,"w":120,"h":16,"nm":"Skeleton_Text","ddd":0,"assets":[{"id":"comp_0","nm":"Shape_PreCOMP","fr":60,"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Text_MATTE","td":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[60,-24,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[120,16],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":4,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,32],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Shape Layer 1","tt":1,"tp":1,"sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.24],"y":[1]},"o":{"x":[0.76],"y":[0]},"t":56,"s":[100]},{"t":112,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.6,"y":1},"o":{"x":0.32,"y":0.94},"t":0,"s":[-60,8,0],"to":[20,0,0],"ti":[-20,0,0]},{"t":56,"s":[60,8,0]}],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[120,16],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[0.854901969433,0.86274510622,0.898039221764,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0}]}],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Text_MATTE","td":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[60,-24,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[120,16],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":4,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,32],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0},{"ddd":0,"ind":2,"ty":0,"nm":"Shape_PreCOMP","tt":1,"tp":1,"refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[60,8,0],"ix":2,"l":2},"a":{"a":0,"k":[60,8,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"ef":[{"ty":29,"nm":"Gaussian Blur","np":5,"mn":"ADBE Gaussian Blur 2","ix":1,"en":1,"ef":[{"ty":0,"nm":"Blurriness","mn":"ADBE Gaussian Blur 2-0001","ix":1,"v":{"a":0,"k":12,"ix":1}},{"ty":7,"nm":"Blur Dimensions","mn":"ADBE Gaussian Blur 2-0002","ix":2,"v":{"a":0,"k":1,"ix":2}},{"ty":7,"nm":"Repeat Edge Pixels","mn":"ADBE Gaussian Blur 2-0003","ix":3,"v":{"a":0,"k":1,"ix":3}}]}],"w":120,"h":16,"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Shape","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[60,-24,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[120,16],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":4,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[0.945098042488,0.949019610882,0.964705884457,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,32],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0}],"markers":[]}');



const $199d1dc410e8acb9$var$KINDS = {
    LOOP: "loop",
    DOTS: "dots",
    SKELETON: "skeleton"
};
const $199d1dc410e8acb9$var$FORMATS = {
    MAIN: "main",
    INLINE: "inline",
    CIRCLE: "circle",
    TEXT: "text",
    SQUARE: "square"
};
const $199d1dc410e8acb9$var$COLORS = {
    BRAND: "brand",
    INFO: "info",
    CRITICAL: "critical",
    INVERSE: "inverse"
};
const $199d1dc410e8acb9$var$SIZES = {
    SMALL: "small",
    MEDIUM: "medium",
    LARGE: "large"
};
const $199d1dc410e8acb9$var$LOTTIE_MAP = {
    LoopMainBrand: (/*@__PURE__*/$parcel$interopDefault($a1ce7d97fdc501f5$exports)),
    LoopMainInverse: (/*@__PURE__*/$parcel$interopDefault($63fe6ed56ad205df$exports)),
    DotsInlineBrand: (/*@__PURE__*/$parcel$interopDefault($111f6dd21e46efa5$exports)),
    DotsInlineCritical: (/*@__PURE__*/$parcel$interopDefault($42f71ef150ad4f79$exports)),
    DotsInlineInfo: (/*@__PURE__*/$parcel$interopDefault($7f4dab8d974f43f4$exports)),
    DotsInlineInverse: (/*@__PURE__*/$parcel$interopDefault($d2c552d5d7a4680a$exports)),
    LandscapeModeLoader: (/*@__PURE__*/$parcel$interopDefault($781845b48580a07e$exports)),
    LoopInlineBrand: (/*@__PURE__*/$parcel$interopDefault($3c69c006dec20133$exports)),
    LoopInlineCritical: (/*@__PURE__*/$parcel$interopDefault($d42e58628ac616c3$exports)),
    LoopInlineInfo: (/*@__PURE__*/$parcel$interopDefault($523530ab0c1f8cdc$exports)),
    LoopInlineInverse: (/*@__PURE__*/$parcel$interopDefault($21340c71d2b5092c$exports)),
    SkeletonCircleInverse: (/*@__PURE__*/$parcel$interopDefault($8ab0ce2b798b4e98$exports)),
    SkeletonSquareInverse: (/*@__PURE__*/$parcel$interopDefault($8f659d18c956cd64$exports)),
    SkeletonTextInverse: (/*@__PURE__*/$parcel$interopDefault($fc02bd95caddb1ce$exports))
};
function $199d1dc410e8acb9$var$Loader({ kind: kind, format: format, size: size, color: color, className: className, dataTestId: dataTestId }) {
    const classes = (0, $7XTbi$classnames)("Loader", `Loader--${format}${(0, $7XTbi$capitalizeFirstLetter)(size)}`, className);
    const caseKind = (0, $7XTbi$capitalizeFirstLetter)(kind);
    const caseFormat = (0, $7XTbi$capitalizeFirstLetter)(format);
    const caseColor = (0, $7XTbi$capitalizeFirstLetter)(color);
    const matchString = `${caseKind}${caseFormat}${caseColor}`;
    const lottieData = $199d1dc410e8acb9$var$LOTTIE_MAP[matchString] || (0, (/*@__PURE__*/$parcel$interopDefault($a1ce7d97fdc501f5$exports)));
    return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $7XTbi$lottiereact), {
        role: "status",
        className: classes,
        animationData: lottieData,
        "data-testid": dataTestId
    });
}
$199d1dc410e8acb9$var$Loader.propTypes = {
    kind: (0, $7XTbi$proptypes).oneOf(Object.values($199d1dc410e8acb9$var$KINDS)).isRequired,
    format: (0, $7XTbi$proptypes).oneOf(Object.values($199d1dc410e8acb9$var$FORMATS)).isRequired,
    color: (0, $7XTbi$proptypes).oneOf(Object.values($199d1dc410e8acb9$var$COLORS)).isRequired,
    size: (0, $7XTbi$proptypes).oneOf(Object.values($199d1dc410e8acb9$var$SIZES)),
    className: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string
};
$199d1dc410e8acb9$var$Loader.defaultProps = {
    className: null,
    dataTestId: null,
    size: $199d1dc410e8acb9$var$SIZES.MEDIUM
};
var $199d1dc410e8acb9$export$2e2bcd8739ae039 = $199d1dc410e8acb9$var$Loader;




// KINDS are low and high emphasis
const $cc675143c5103274$var$KIND = {
    LOW: "low",
    HIGH: "high"
};
const $cc675143c5103274$var$COLOR_THEMES = {
    CRITICAL: "Critical",
    WARNING: "Warning",
    SUCCESS: "Success",
    INFORMATION: "Information",
    SAVI: "Savi",
    TEST: "test"
};
const $cc675143c5103274$var$HIGH_EMP_ALT_TEXT_COLOR = "--color-foreground-neutral-inverse";
function $cc675143c5103274$var$AlertBanner({ id: id, colorTheme: colorTheme, kind: kind, isFloating: isFloating, position: position, title: title, description: description, isVisible: isVisible, isLoading: isLoading, onCancel: onCancel, expandingContent: expandingContent, expandButtonLabels: expandButtonLabels, content: content, isColonVisible: isColonVisible, shouldAutoDismiss: shouldAutoDismiss, autoDismissDelay: autoDismissDelay, shouldAnimate: shouldAnimate, LinkComponent: LinkComponent, className: className, dataTestId: dataTestId }) {
    const [isBodyExpanded, setIsBodyExpanded] = (0, $7XTbi$useState)(null);
    const [shouldRender, setShouldRender] = (0, $7XTbi$useState)(isVisible);
    const [expandBodyStyles, setExpandBodyStyles] = (0, $7XTbi$useState)({
        height: "auto",
        paddingBottom: "0.5rem",
        visibility: "hidden"
    });
    const bannerRef = (0, $7XTbi$useRef)(null);
    const bodyRef = (0, $7XTbi$useRef)();
    const localize = (0, $7XTbi$useLocalize)();
    const COLLAPSE_BUTTON_TEXT = localize((0, $65441b8e33d7ac73$export$9f3245bec405e186).neo.alertBanner.lessDetails);
    const EXPAND_BUTTON_TEXT = localize((0, $65441b8e33d7ac73$export$9f3245bec405e186).neo.alertBanner.moreDetails);
    const expandText = isBodyExpanded ? expandButtonLabels?.expanded || COLLAPSE_BUTTON_TEXT : expandButtonLabels?.collapsed || EXPAND_BUTTON_TEXT;
    const handleAnimationEnd = (0, $7XTbi$useCallback)(()=>{
        if (!isVisible) setShouldRender(false);
    }, [
        isVisible
    ]);
    (0, $7XTbi$useEffect)(()=>{
        const bannerRefCurrent = bannerRef.current;
        if (isVisible) setShouldRender(true);
        else if (!shouldAnimate) setShouldRender(false);
        if (bannerRefCurrent) bannerRefCurrent.addEventListener("animationend", handleAnimationEnd);
        return ()=>{
            if (bannerRefCurrent) bannerRefCurrent.removeEventListener("animationend", handleAnimationEnd);
        };
    }, [
        isVisible,
        shouldAnimate,
        isFloating,
        handleAnimationEnd
    ]);
    (0, $7XTbi$useEffect)(()=>{
        let dismissTimer;
        if (shouldAutoDismiss && isVisible) dismissTimer = setTimeout(onCancel, autoDismissDelay);
        return ()=>clearTimeout(dismissTimer);
    }, [
        shouldAutoDismiss,
        isVisible,
        autoDismissDelay,
        onCancel
    ]);
    (0, $7XTbi$useEffect)(()=>{
        if (!expandingContent) return;
        if (isBodyExpanded) {
            const timer = setTimeout(()=>{
                setExpandBodyStyles({
                    height: "auto",
                    paddingBottom: "0.5rem",
                    visibility: "visible"
                });
            }, 200);
            // eslint-disable-next-line consistent-return
            return ()=>clearTimeout(timer);
        }
        setExpandBodyStyles({
            height: "0",
            visibility: "hidden"
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isBodyExpanded
    ]);
    if (!shouldRender) return null;
    // Helper constants for kinds
    const isHighEmphasis = kind === $cc675143c5103274$var$KIND.HIGH;
    const isLowEmphasis = kind === $cc675143c5103274$var$KIND.LOW;
    // Helper constants for themes
    const isThemeCritical = colorTheme === $cc675143c5103274$var$COLOR_THEMES.CRITICAL;
    const isThemeWarning = colorTheme === $cc675143c5103274$var$COLOR_THEMES.WARNING;
    const isThemeSuccess = colorTheme === $cc675143c5103274$var$COLOR_THEMES.SUCCESS;
    const isThemeInformation = colorTheme === $cc675143c5103274$var$COLOR_THEMES.INFORMATION;
    const isThemeSavi = colorTheme === $cc675143c5103274$var$COLOR_THEMES.SAVI;
    const floatingStylesObj = isFloating ? {
        position: position.type,
        top: position.top,
        right: position.right,
        bottom: position.bottom,
        left: position.left,
        transition: shouldAnimate ? "" : "none"
    } : {};
    const alertClasses = (0, $7XTbi$classnames)("AlertBanner-container", isVisible && "AlertBanner-container--isVisible", isLoading && "AlertBanner-container--isLoading", isBodyExpanded && "AlertBanner-container--isBodyExpanded", expandingContent && "AlertBanner-container--shouldContentExpand", isFloating && "AlertBanner--isFloating", isThemeCritical && "AlertBanner-critical", isThemeWarning && `AlertBanner-warning--${kind}`, isThemeSuccess && `AlertBanner-success--${kind}`, isThemeInformation && `AlertBanner-information--${kind}`, isThemeSavi && "AlertBanner-savi", className);
    const renderAlertIcon = ()=>{
        switch(true){
            case isLoading:
                return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $199d1dc410e8acb9$export$2e2bcd8739ae039), {
                    kind: "loop",
                    format: "inline",
                    color: "info",
                    className: "AlertBanner-loader",
                    dataTestId: "alertbanner-loader-icon"
                });
            case isThemeCritical:
                return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                    kind: "Critical",
                    color: "neutral-000",
                    size: "large",
                    dataTestId: "alertbanner-icon-critical-high"
                });
            case isThemeSuccess && isHighEmphasis:
                return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                    kind: "Success",
                    color: "neutral-000",
                    size: "large",
                    dataTestId: "alertbanner-icon-success-high"
                });
            case isThemeSuccess && isLowEmphasis:
                return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                    kind: "Success",
                    color: "success-700",
                    size: "large",
                    dataTestId: "alertbanner-icon-success-low"
                });
            case isThemeWarning && isHighEmphasis:
                return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                    kind: "Warning",
                    color: "neutral-1000",
                    size: "large",
                    dataTestId: "alertbanner-icon-warning-high"
                });
            case isThemeWarning && isLowEmphasis:
                return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                    kind: "Warning",
                    color: "warning-500",
                    size: "large",
                    dataTestId: "alertbanner-icon-warning-low"
                });
            case isThemeInformation && isHighEmphasis:
                return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                    kind: "Info",
                    color: "neutral-000",
                    size: "large",
                    dataTestId: "alertbanner-icon-info-high"
                });
            case isThemeInformation && isLowEmphasis:
                return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                    kind: "Info",
                    color: "info-700",
                    size: "large",
                    dataTestId: "alertbanner-icon-info-low"
                });
            case isThemeSavi && isHighEmphasis:
                return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                    kind: "SaviCompanion",
                    color: "neutral-000",
                    size: "large",
                    dataTestId: "alertbanner-icon-savi-high"
                });
            default:
                return null;
        }
    };
    const closeButtonBackgroundType = ()=>{
        switch(true){
            case isThemeCritical && isHighEmphasis || isThemeSuccess && isHighEmphasis || isThemeInformation && isHighEmphasis || isThemeSavi && isHighEmphasis:
                return (0, $65441b8e33d7ac73$export$49390a4605a2336a).DARK;
            case isThemeWarning && isHighEmphasis || isThemeSuccess && isLowEmphasis || isThemeWarning && isLowEmphasis || isThemeInformation && isLowEmphasis:
                return null;
            default:
                return null;
        }
    };
    const getTypographyColor = ()=>{
        switch(true){
            case (isThemeCritical || isThemeSuccess || isThemeInformation || isThemeSavi) && isHighEmphasis:
                return $cc675143c5103274$var$HIGH_EMP_ALT_TEXT_COLOR;
            default:
                return null;
        }
    };
    const typographyColor = getTypographyColor();
    const showMore = ()=>{
        setExpandBodyStyles({
            height: `calc(${bodyRef?.current?.scrollHeight}px + 0.5rem)`,
            visibility: "visible"
        });
        setIsBodyExpanded((prev)=>!prev);
    };
    return /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
        id: id,
        ref: bannerRef,
        className: alertClasses,
        style: floatingStylesObj,
        "data-testid": dataTestId,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
            className: "AlertBanner",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                    className: "AlertBanner-section",
                    children: [
                        /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                            className: "AlertBanner-header",
                            children: [
                                /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                                    className: "AlertBanner-icon",
                                    children: renderAlertIcon()
                                }),
                                /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
                                    className: "AlertBanner-headerTextWrapper",
                                    children: [
                                        /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $5f880a93b57cab01$export$2e2bcd8739ae039), {
                                            kind: "h4",
                                            desktop: "h4-d",
                                            mobile: "h4-d",
                                            color: typographyColor,
                                            className: "AlertBanner-title",
                                            children: [
                                                title,
                                                isColonVisible && ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $5f880a93b57cab01$export$2e2bcd8739ae039), {
                                            kind: "body2",
                                            desktop: "body2-d",
                                            mobile: "body2-d",
                                            color: typographyColor,
                                            className: "AlertBanner-description",
                                            children: [
                                                /*#__PURE__*/ (0, $7XTbi$jsxs)("span", {
                                                    className: "AlertBanner-mobileTitle",
                                                    children: [
                                                        title,
                                                        isColonVisible && ":"
                                                    ]
                                                }),
                                                description
                                            ]
                                        }),
                                        LinkComponent && /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                                            className: "AlertBanner-link",
                                            children: LinkComponent
                                        }),
                                        expandingContent && // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                        /*#__PURE__*/ (0, $7XTbi$jsx)((0, $47010fca98b98efb$export$2e2bcd8739ae039), {
                                            text: expandText,
                                            kind: "button",
                                            onClick: showMore,
                                            suffixIconKind: "ChevronDown",
                                            suffixIconRotate: isBodyExpanded ? "180" : null,
                                            className: "AlertBanner-expandButtonDesktop",
                                            dataTestId: "alertbanner-expand-desktop"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7XTbi$jsx)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
                            className: "AlertBanner-closeButtonWrapper",
                            children: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $e34ff86c7a827ee6$export$2e2bcd8739ae039), {
                                size: "medium",
                                kind: "ghost",
                                onClick: onCancel,
                                icon: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                                    kind: "Close"
                                }),
                                dataTheme: closeButtonBackgroundType(),
                                className: "AlertBanner-closeButton",
                                dataTestId: "alertbanner-close-button"
                            })
                        })
                    ]
                }),
                expandingContent && /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                    className: "AlertBanner-expandingBody",
                    children: [
                        /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                            ref: bodyRef,
                            className: "AlertBanner-expandingContent",
                            "data-testid": "alertbanner-expandingContent",
                            style: expandBodyStyles,
                            children: typeof expandingContent === "string" ? /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5f880a93b57cab01$export$2e2bcd8739ae039), {
                                kind: "body2",
                                color: typographyColor,
                                className: "AlertBanner-expandingContentText",
                                children: expandingContent
                            }) : expandingContent
                        }),
                        /*#__PURE__*/ (0, $7XTbi$jsx)((0, $47010fca98b98efb$export$2e2bcd8739ae039), {
                            text: expandText,
                            kind: "button",
                            onClick: showMore,
                            suffixIconKind: "ChevronDown",
                            suffixIconRotate: isBodyExpanded ? "180" : null,
                            className: "AlertBanner-expandButtonTabletDown",
                            dataTestId: "alertbanner-expand-tablet"
                        })
                    ]
                }),
                content && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
                    className: "AlertBanner-body",
                    children: typeof content === "string" ? /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5f880a93b57cab01$export$2e2bcd8739ae039), {
                        kind: "body2",
                        color: typographyColor,
                        className: "AlertBanner-contentText",
                        children: content
                    }) : content
                })
            ]
        })
    });
}
$cc675143c5103274$var$AlertBanner.defaultProps = {
    id: null,
    kind: $cc675143c5103274$var$KIND.HIGH,
    isFloating: false,
    position: {
        type: undefined,
        top: undefined,
        right: undefined,
        bottom: undefined,
        left: undefined
    },
    isVisible: true,
    isLoading: false,
    expandingContent: null,
    expandButtonLabels: null,
    content: null,
    isColonVisible: true,
    shouldAutoDismiss: false,
    autoDismissDelay: 5000,
    shouldAnimate: true,
    LinkComponent: null,
    className: null,
    dataTestId: null
};
$cc675143c5103274$var$AlertBanner.propTypes = {
    id: (0, $7XTbi$proptypes).string,
    colorTheme: (0, $7XTbi$proptypes).oneOf(Object.values($cc675143c5103274$var$COLOR_THEMES)).isRequired,
    kind: (0, $7XTbi$proptypes).oneOf(Object.values($cc675143c5103274$var$KIND)),
    isFloating: (0, $7XTbi$proptypes).bool,
    position: (0, $7XTbi$proptypes).shape({
        type: (0, $7XTbi$proptypes).oneOf([
            "absolute",
            "fixed"
        ]),
        top: (0, $7XTbi$proptypes).string,
        right: (0, $7XTbi$proptypes).string,
        bottom: (0, $7XTbi$proptypes).string,
        left: (0, $7XTbi$proptypes).string
    }),
    title: (0, $7XTbi$proptypes).string.isRequired,
    description: (0, $7XTbi$proptypes).string.isRequired,
    isVisible: (0, $7XTbi$proptypes).bool,
    isLoading: (0, $7XTbi$proptypes).bool,
    onCancel: (0, $7XTbi$proptypes).func.isRequired,
    expandingContent: (0, $7XTbi$proptypes).oneOfType([
        (0, $7XTbi$proptypes).node,
        (0, $7XTbi$proptypes).string
    ]),
    expandButtonLabels: (0, $7XTbi$proptypes).shape({
        expanded: (0, $7XTbi$proptypes).string.isRequired,
        collapsed: (0, $7XTbi$proptypes).string.isRequired
    }),
    content: (0, $7XTbi$proptypes).oneOfType([
        (0, $7XTbi$proptypes).node,
        (0, $7XTbi$proptypes).string
    ]),
    isColonVisible: (0, $7XTbi$proptypes).bool,
    shouldAutoDismiss: (0, $7XTbi$proptypes).bool,
    autoDismissDelay: (0, $7XTbi$proptypes).number,
    shouldAnimate: (0, $7XTbi$proptypes).bool,
    LinkComponent: (0, $7XTbi$proptypes).node,
    className: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string
};
var $cc675143c5103274$export$2e2bcd8739ae039 = $cc675143c5103274$var$AlertBanner;


/* eslint-disable react/jsx-curly-spacing */ 




const $c9ce95d8036e4d67$var$AlertBannerContext = /*#__PURE__*/ (0, $7XTbi$createContext)();
/**
 * Hook to access and manage the alert banner stack.
 * Throws an error if used outside the AlertBannerProvider.
 *
 * @returns {function} - Function to push alert banner data into the stack.
 * @throws Will throw an error if used outside AlertBannerProvider.
 */ const $c9ce95d8036e4d67$var$useAlertBannerStack = ()=>{
    const context = (0, $7XTbi$useContext)($c9ce95d8036e4d67$var$AlertBannerContext);
    if (!context || !context.pushAlertBannerData) throw new Error("useAlertBannerStack must be used within an AlertBannerProvider");
    return context.pushAlertBannerData;
};
function $c9ce95d8036e4d67$export$d5e01b4fb519ae55({ id: id, isVisible: isVisible, ...props }) {
    const pushAlertBannerData = $c9ce95d8036e4d67$var$useAlertBannerStack();
    const bannerIdRef = (0, $7XTbi$useRef)(id || `${Date.now()}-${Math.random()}`);
    const bannerId = bannerIdRef.current;
    (0, $7XTbi$useEffect)(()=>{
        pushAlertBannerData({
            ...props,
            id: bannerId,
            isVisible: isVisible
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        bannerId,
        isVisible,
        props
    ]);
    return null;
}
$c9ce95d8036e4d67$export$d5e01b4fb519ae55.defaultProps = (0, $cc675143c5103274$export$2e2bcd8739ae039).defaultProps;
$c9ce95d8036e4d67$export$d5e01b4fb519ae55.propTypes = (0, $cc675143c5103274$export$2e2bcd8739ae039).propTypes;
function $c9ce95d8036e4d67$export$75c3033471110567({ children: children, className: className }) {
    const [alertBannerData, setAlertBannerData] = (0, $7XTbi$useState)([]);
    const { id: id, kind: kind, isVisible: isVisible, isLoading: isLoading, expandingContent: expandingContent, expandButtonLabels: expandButtonLabels, content: content, isColonVisible: isColonVisible, shouldAutoDismiss: shouldAutoDismiss, autoDismissDelay: autoDismissDelay, shouldAnimate: shouldAnimate, LinkComponent: LinkComponent, className: defaultClassName, dataTestId: dataTestId } = (0, $cc675143c5103274$export$2e2bcd8739ae039).defaultProps;
    const alertStackClasses = (0, $7XTbi$classnames)("AlertBannerStack", className);
    const pushAlertBannerData = (0, $7XTbi$useCallback)((banner)=>{
        setAlertBannerData((prev)=>{
            if (!banner.isVisible) return prev.filter((b)=>b.id !== banner.id);
            const index = prev.findIndex((b)=>b.id === banner.id);
            if (index !== -1) {
                const updatedBannerData = [
                    ...prev
                ];
                updatedBannerData[index] = banner;
                return updatedBannerData;
            }
            return [
                ...prev,
                banner
            ];
        });
    }, []);
    const contextValue = (0, $7XTbi$useMemo)(()=>({
            pushAlertBannerData: pushAlertBannerData
        }), [
        pushAlertBannerData
    ]);
    return /*#__PURE__*/ (0, $7XTbi$jsxs)($c9ce95d8036e4d67$var$AlertBannerContext.Provider, {
        value: contextValue,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("section", {
                className: alertStackClasses,
                children: alertBannerData.filter((banner)=>banner.isVisible).map((banner)=>/*#__PURE__*/ (0, $7XTbi$jsx)((0, $cc675143c5103274$export$2e2bcd8739ae039), {
                        colorTheme: banner.colorTheme,
                        title: banner.title,
                        description: banner.description,
                        onCancel: ()=>{
                            banner.onCancel();
                            setAlertBannerData((prevState)=>prevState.map((currBanner)=>currBanner.id === banner.id ? {
                                        ...currBanner,
                                        isVisible: false
                                    } : currBanner));
                        },
                        // Optional
                        kind: banner?.kind ?? kind,
                        isVisible: banner.isVisible ?? isVisible,
                        isLoading: banner?.isLoading ?? isLoading,
                        expandingContent: banner?.expandingContent ?? expandingContent,
                        expandButtonLabels: banner?.expandButtonLabels ?? expandButtonLabels,
                        content: banner?.content ?? content,
                        isColonVisible: banner?.isColonVisible ?? isColonVisible,
                        shouldAutoDismiss: banner?.shouldAutoDismiss ?? shouldAutoDismiss,
                        autoDismissDelay: banner?.autoDismissDelay ?? autoDismissDelay,
                        shouldAnimate: banner?.shouldAnimate ?? shouldAnimate,
                        LinkComponent: banner?.LinkComponent ?? LinkComponent,
                        className: (0, $7XTbi$classnames)("AlertBanner-stackingWrapper", banner?.className ?? defaultClassName),
                        dataTestId: banner?.dataTestId ?? dataTestId
                    }, banner.id ?? id))
            }),
            children
        ]
    });
}
$c9ce95d8036e4d67$export$75c3033471110567.propTypes = {
    children: (0, $7XTbi$proptypes).node,
    className: (0, $7XTbi$proptypes).string
};
$c9ce95d8036e4d67$export$75c3033471110567.defaultProps = {
    children: null,
    className: null
};








var $865682af0d4dfb4e$exports = {};

$parcel$export($865682af0d4dfb4e$exports, "Account", function () { return $b14f0a2d7578f39c$export$2e2bcd8739ae039; });
$parcel$export($865682af0d4dfb4e$exports, "AD", function () { return $408677eee8269470$export$2e2bcd8739ae039; });
$parcel$export($865682af0d4dfb4e$exports, "Application", function () { return $e552e02c4a1881cf$export$2e2bcd8739ae039; });
$parcel$export($865682af0d4dfb4e$exports, "AWS", function () { return $ca445b81649c320a$export$2e2bcd8739ae039; });
$parcel$export($865682af0d4dfb4e$exports, "Azure", function () { return $baf62fdf8ce6f0f2$export$2e2bcd8739ae039; });
$parcel$export($865682af0d4dfb4e$exports, "AzureAD", function () { return $a949c4422181d892$export$2e2bcd8739ae039; });
$parcel$export($865682af0d4dfb4e$exports, "CertsAccount", function () { return $88ad8133e2828917$export$2e2bcd8739ae039; });
$parcel$export($865682af0d4dfb4e$exports, "Database", function () { return $445683242766d0f7$export$2e2bcd8739ae039; });
$parcel$export($865682af0d4dfb4e$exports, "Entitlement", function () { return $d52ac54e69bff60e$export$2e2bcd8739ae039; });
$parcel$export($865682af0d4dfb4e$exports, "GCP", function () { return $30c933a95067ca90$export$2e2bcd8739ae039; });
$parcel$export($865682af0d4dfb4e$exports, "Okta", function () { return $dfa477212024ca80$export$2e2bcd8739ae039; });
$parcel$export($865682af0d4dfb4e$exports, "Placeholder", function () { return $f6afa0644eaaa4d5$export$2e2bcd8739ae039; });
$parcel$export($865682af0d4dfb4e$exports, "Role", function () { return $03107b67e34bed37$export$2e2bcd8739ae039; });
$parcel$export($865682af0d4dfb4e$exports, "Salesforce", function () { return $3c2d13cb209e1859$export$2e2bcd8739ae039; });
$parcel$export($865682af0d4dfb4e$exports, "SAP", function () { return $e4040e23594ddf7a$export$2e2bcd8739ae039; });
$parcel$export($865682af0d4dfb4e$exports, "Saviynt", function () { return $6f063c714e5f6bd6$export$2e2bcd8739ae039; });
$parcel$export($865682af0d4dfb4e$exports, "Server", function () { return $873eda64c54e759b$export$2e2bcd8739ae039; });
$parcel$export($865682af0d4dfb4e$exports, "User", function () { return $6db0c7d3dd0c426c$export$2e2bcd8739ae039; });
$parcel$export($865682af0d4dfb4e$exports, "WebAppConsole", function () { return $ef9438da78c6de61$export$2e2bcd8739ae039; });
$parcel$export($865682af0d4dfb4e$exports, "Windows", function () { return $a7518da02a1bec1a$export$2e2bcd8739ae039; });


const $b14f0a2d7578f39c$var$SvgAccount = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 41,
        height: 41,
        viewBox: "0 0 41 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("rect", {
                x: 0.902,
                y: 0.253,
                width: 40,
                height: 40,
                rx: 20,
                fill: "#EBEDFF"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.253 14.213a3.96 3.96 0 1 1 7.92 0 3.96 3.96 0 0 1-7.92 0Zm3.96-2.849a2.849 2.849 0 1 0 0 5.697 2.849 2.849 0 0 0 0-5.697Z",
                fill: "#254B86"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M25.902 26.734a1.482 1.482 0 1 0 0-2.963 1.482 1.482 0 0 0 0 2.963Z",
                fill: "#254B86"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M24.908 20.253c-.22 0-.419.13-.508.33l-.414.935-.608.36-1.027-.062a.556.556 0 0 0-.517.28l-.86 1.518a.555.555 0 0 0 .041.609l.598.79v.664l-.55.843a.556.556 0 0 0-.004.6l.915 1.453c.101.162.279.26.47.26h1.095l.653.273.437.846c.095.185.286.3.494.3h1.767c.22 0 .42-.129.508-.33l.405-.913.623-.327h1.064c.2 0 .385-.107.484-.282l.856-1.511a.555.555 0 0 0-.047-.619l-.624-.788v-.642l.575-.834a.555.555 0 0 0 .012-.612l-.932-1.475a.556.556 0 0 0-.527-.256l-1.025.106-.636-.335-.45-.879a.556.556 0 0 0-.495-.302h-1.773Zm.022 1.878.34-.767h1.071l.376.733a.556.556 0 0 0 .235.238l.94.495a.556.556 0 0 0 .316.062l.85-.088.553.874-.465.674a.555.555 0 0 0-.098.316v1.007c0 .125.042.247.12.345l.511.646-.512.905h-.877a.555.555 0 0 0-.258.063l-.916.48a.556.556 0 0 0-.25.267l-.337.76H25.46l-.375-.724a.555.555 0 0 0-.279-.258l-.942-.394a.557.557 0 0 0-.214-.043h-.9l-.562-.893.445-.683a.556.556 0 0 0 .09-.304v-1.016a.556.556 0 0 0-.113-.335l-.49-.648.509-.898.851.052c.11.006.22-.02.316-.077l.908-.536a.556.556 0 0 0 .225-.253Z",
                fill: "#254B86"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M13.849 21.032c2.615-1.558 5.878-1.5 8.51.069a.555.555 0 1 0 .568-.955c-2.965-1.767-6.665-1.845-9.647-.069l-.386.23a4.08 4.08 0 0 0-1.992 3.506v5.884a.556.556 0 1 0 1.112 0v-5.884c0-1.046.55-2.015 1.449-2.55l.386-.23Z",
                fill: "#254B86"
            })
        ]
    });
var $b14f0a2d7578f39c$export$2e2bcd8739ae039 = $b14f0a2d7578f39c$var$SvgAccount;




const $408677eee8269470$var$SvgActiveDirectory = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        d: "M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24Z",
                        fill: "#00AAF2"
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        d: "M36.133 25.363v5.067c0 .593-.183.715-.746.624-3.774-.563-7.593-1.08-11.397-1.613-.684-.092-.928-.335-.928-1.08.061-2.694.03-5.4 0-8.126 0-.594.182-.776.776-.776 3.895.03 7.73.03 11.55.03.624 0 .776.244.776.807-.062 1.704-.032 3.378-.032 5.067ZM29.666 18.515c-1.917 0-3.835-.03-5.75 0-.593 0-.837-.121-.837-.806.03-2.754.03-5.463 0-8.187 0-.532.183-.715.685-.806 3.926-.563 7.85-1.111 11.777-1.704.686-.092.564.365.564.745 0 2.435.03 4.915 0 7.35 0 .9-.031 1.796 0 2.694.03.563-.183.715-.715.715-1.89-.031-3.806 0-5.724 0ZM16.976 19.535h4.29c.457 0 .655.15.655.624v8.46c0 .487-.213.532-.654.487a853.75 853.75 0 0 0-8.521-1.233c-.564-.09-.746-.274-.746-.866.03-2.25.03-4.504 0-6.8 0-.563.15-.715.715-.715 1.446.043 2.83.043 4.26.043ZM16.976 18.515h-4.23c-.533 0-.716-.182-.716-.745.031-2.222.031-4.443 0-6.68 0-.533.15-.715.716-.807a266.71 266.71 0 0 0 8.522-1.233c.655-.092.715.121.715.654V17.8c0 .593-.243.684-.776.684-1.416 0-2.847.031-4.231.031ZM16.215 35.5a.114.114 0 0 1-.075-.03.102.102 0 0 1-.03-.075l.01-.045 1.205-3.225c.023-.083.082-.125.175-.125h.545c.087 0 .145.042.175.125l1.205 3.225a.15.15 0 0 1 .005.045c0 .03-.01.055-.03.075a.096.096 0 0 1-.07.03h-.435a.15.15 0 0 1-.1-.03.137.137 0 0 1-.045-.065l-.235-.61H17.03l-.235.61a.145.145 0 0 1-.145.095h-.435Zm2.125-1.28-.57-1.545-.565 1.545h1.135ZM20.933 35.55c-.367 0-.66-.102-.88-.305-.217-.203-.332-.485-.346-.845l-.005-.2.005-.2c.014-.36.129-.642.345-.845.22-.203.514-.305.88-.305.26 0 .48.047.66.14a.999.999 0 0 1 .405.345c.09.133.139.26.145.38a.095.095 0 0 1-.034.085.116.116 0 0 1-.085.035h-.44a.143.143 0 0 1-.08-.02.279.279 0 0 1-.05-.08.574.574 0 0 0-.2-.28.524.524 0 0 0-.31-.085.505.505 0 0 0-.4.165c-.097.107-.149.27-.155.49l-.006.185.005.165c.014.437.199.655.555.655.13 0 .235-.028.316-.085a.591.591 0 0 0 .195-.28.207.207 0 0 1 .05-.075.12.12 0 0 1 .08-.025h.44c.033 0 .061.012.085.035a.095.095 0 0 1 .034.085.78.78 0 0 1-.14.375 1.06 1.06 0 0 1-.4.345c-.18.097-.403.145-.67.145ZM23.839 35.5c-.303 0-.532-.078-.685-.235-.15-.16-.225-.393-.225-.7V33.43h-.395a.116.116 0 0 1-.085-.035.133.133 0 0 1-.035-.09v-.285c0-.033.012-.062.035-.085a.116.116 0 0 1 .085-.035h.395v-.83c0-.037.012-.065.035-.085a.116.116 0 0 1 .085-.035h.405c.037 0 .065.012.085.035.023.02.035.048.035.085v.83h.625c.037 0 .065.012.085.035.023.02.035.048.035.085v.285a.122.122 0 0 1-.035.09.116.116 0 0 1-.085.035h-.625v1.085c0 .143.025.252.075.325.05.073.133.11.25.11h.345c.033 0 .062.012.085.035a.116.116 0 0 1 .035.085v.31a.116.116 0 0 1-.035.085.106.106 0 0 1-.085.035h-.405ZM24.907 32.47a.116.116 0 0 1-.084-.035.116.116 0 0 1-.035-.085v-.36c0-.033.011-.062.035-.085a.116.116 0 0 1 .084-.035h.456c.033 0 .061.012.085.035.026.023.04.052.04.085v.36a.115.115 0 0 1-.035.085.122.122 0 0 1-.09.035h-.456Zm.02 3.03a.116.116 0 0 1-.084-.035.116.116 0 0 1-.035-.085v-2.36c0-.033.011-.062.035-.085a.116.116 0 0 1 .084-.035h.416c.036 0 .064.012.084.035.024.02.035.048.035.085v2.36a.115.115 0 0 1-.035.085.106.106 0 0 1-.084.035h-.416ZM27.046 35.5a.19.19 0 0 1-.115-.03.252.252 0 0 1-.065-.095l-.935-2.32-.01-.045c0-.03.01-.055.03-.075a.11.11 0 0 1 .08-.035h.405c.063 0 .107.032.13.095l.665 1.755.665-1.755a.208.208 0 0 1 .045-.065.126.126 0 0 1 .085-.03h.41a.09.09 0 0 1 .07.035c.023.02.035.045.035.075 0 .02-.002.035-.005.045l-.94 2.32a.252.252 0 0 1-.065.095.19.19 0 0 1-.115.03h-.37ZM30.024 35.55c-.37 0-.665-.107-.885-.32-.216-.217-.331-.52-.345-.91l-.005-.125.005-.125c.017-.38.134-.678.35-.895.22-.217.514-.325.88-.325.394 0 .697.12.91.36.217.24.325.56.325.96v.105a.115.115 0 0 1-.035.085.122.122 0 0 1-.09.035h-1.66v.04a.815.815 0 0 0 .15.465.475.475 0 0 0 .395.185.574.574 0 0 0 .475-.23.333.333 0 0 1 .07-.07.194.194 0 0 1 .085-.015h.43c.03 0 .055.01.075.03a.076.076 0 0 1 .035.065c0 .08-.048.175-.145.285a1.17 1.17 0 0 1-.405.28c-.176.08-.381.12-.615.12Zm.555-1.575v-.015a.718.718 0 0 0-.15-.475.49.49 0 0 0-.405-.18.491.491 0 0 0-.405.18.735.735 0 0 0-.145.475v.015h1.105ZM12.917 41.5a.116.116 0 0 1-.085-.035.116.116 0 0 1-.035-.085v-3.255c0-.037.01-.067.03-.09a.122.122 0 0 1 .09-.035h1.22c.98 0 1.48.453 1.5 1.36.007.193.01.323.01.39 0 .063-.003.192-.01.385-.013.467-.138.812-.375 1.035-.236.22-.603.33-1.1.33h-1.245Zm1.22-.575c.28 0 .482-.062.605-.185.124-.127.189-.333.195-.62.007-.2.01-.325.01-.375 0-.053-.003-.177-.01-.37-.006-.273-.076-.475-.21-.605-.13-.13-.335-.195-.615-.195h-.62v2.35h.645ZM16.353 38.47a.116.116 0 0 1-.085-.035.115.115 0 0 1-.035-.085v-.36c0-.033.011-.062.035-.085a.116.116 0 0 1 .085-.035h.455c.033 0 .061.012.085.035a.11.11 0 0 1 .04.085v.36a.116.116 0 0 1-.035.085.122.122 0 0 1-.09.035h-.455Zm.02 3.03a.116.116 0 0 1-.085-.035.115.115 0 0 1-.035-.085v-2.36c0-.033.012-.062.035-.085a.116.116 0 0 1 .085-.035h.415c.037 0 .065.012.085.035.023.02.035.048.035.085v2.36a.116.116 0 0 1-.035.085.106.106 0 0 1-.085.035h-.415ZM17.691 41.5a.116.116 0 0 1-.085-.035.116.116 0 0 1-.035-.085v-2.355c0-.033.012-.062.035-.085a.109.109 0 0 1 .085-.04h.405c.037 0 .067.012.09.035a.122.122 0 0 1 .035.09v.205a.793.793 0 0 1 .3-.245.994.994 0 0 1 .42-.085h.205c.037 0 .065.012.085.035.023.02.035.048.035.085v.36a.116.116 0 0 1-.035.085.106.106 0 0 1-.085.035h-.39a.5.5 0 0 0-.37.135.5.5 0 0 0-.135.37v1.375a.116.116 0 0 1-.035.085.122.122 0 0 1-.09.035h-.435ZM20.742 41.55c-.37 0-.665-.107-.885-.32-.217-.217-.332-.52-.345-.91l-.005-.125.005-.125c.017-.38.133-.678.35-.895.22-.217.513-.325.88-.325.393 0 .697.12.91.36.217.24.325.56.325.96v.105a.116.116 0 0 1-.035.085.122.122 0 0 1-.09.035h-1.66v.04a.815.815 0 0 0 .15.465.475.475 0 0 0 .395.185.574.574 0 0 0 .475-.23.33.33 0 0 1 .07-.07.194.194 0 0 1 .085-.015h.43c.03 0 .055.01.075.03a.077.077 0 0 1 .035.065c0 .08-.048.175-.145.285a1.17 1.17 0 0 1-.405.28c-.177.08-.382.12-.615.12Zm.555-1.575v-.015a.718.718 0 0 0-.15-.475.491.491 0 0 0-.405-.18.491.491 0 0 0-.405.18.734.734 0 0 0-.145.475v.015h1.105ZM23.633 41.55c-.367 0-.66-.102-.88-.305-.217-.203-.332-.485-.345-.845l-.005-.2.005-.2c.013-.36.128-.642.345-.845.22-.203.513-.305.88-.305.26 0 .48.047.66.14a.999.999 0 0 1 .405.345c.09.133.138.26.145.38a.095.095 0 0 1-.035.085.116.116 0 0 1-.085.035h-.44a.143.143 0 0 1-.08-.02.279.279 0 0 1-.05-.08.574.574 0 0 0-.2-.28.524.524 0 0 0-.31-.085.505.505 0 0 0-.4.165c-.097.107-.149.27-.155.49l-.005.185.005.165c.013.437.198.655.555.655.13 0 .235-.028.315-.085a.591.591 0 0 0 .195-.28.207.207 0 0 1 .05-.075.12.12 0 0 1 .08-.025h.44c.033 0 .061.012.085.035a.095.095 0 0 1 .035.085.78.78 0 0 1-.14.375 1.06 1.06 0 0 1-.4.345c-.18.097-.404.145-.67.145ZM26.54 41.5c-.304 0-.532-.078-.686-.235-.15-.16-.225-.393-.225-.7V39.43h-.395a.116.116 0 0 1-.085-.035.133.133 0 0 1-.035-.09v-.285c0-.033.012-.062.035-.085a.116.116 0 0 1 .085-.035h.395v-.83c0-.037.012-.065.035-.085a.116.116 0 0 1 .085-.035h.405c.037 0 .065.012.085.035.023.02.035.048.035.085v.83h.625c.037 0 .065.012.085.035.023.02.035.048.035.085v.285a.122.122 0 0 1-.035.09.116.116 0 0 1-.085.035h-.625v1.085c0 .143.025.252.075.325.05.073.134.11.25.11h.345c.034 0 .062.012.085.035a.116.116 0 0 1 .035.085v.31a.116.116 0 0 1-.035.085.106.106 0 0 1-.085.035h-.405ZM28.658 41.55c-.39 0-.692-.1-.905-.3-.214-.203-.329-.48-.345-.83l-.005-.22.005-.22c.016-.347.133-.622.35-.825.216-.203.516-.305.9-.305.383 0 .683.102.9.305.216.203.333.478.35.825.003.04.005.113.005.22s-.002.18-.005.22c-.017.35-.132.627-.345.83-.214.2-.515.3-.905.3Zm0-.495a.517.517 0 0 0 .41-.165c.096-.113.15-.278.16-.495.003-.033.005-.098.005-.195s-.002-.162-.005-.195c-.01-.217-.064-.38-.16-.49a.51.51 0 0 0-.41-.17.51.51 0 0 0-.41.17c-.097.11-.15.273-.16.49l-.005.195.005.195c.01.217.063.382.16.495.096.11.233.165.41.165ZM30.587 41.5a.116.116 0 0 1-.085-.035.116.116 0 0 1-.035-.085v-2.355c0-.033.011-.062.035-.085a.109.109 0 0 1 .085-.04h.405c.036 0 .066.012.09.035a.121.121 0 0 1 .035.09v.205a.793.793 0 0 1 .3-.245.995.995 0 0 1 .42-.085h.205c.036 0 .065.012.085.035.023.02.035.048.035.085v.36a.115.115 0 0 1-.035.085.106.106 0 0 1-.085.035h-.39a.5.5 0 0 0-.37.135.5.5 0 0 0-.135.37v1.375a.115.115 0 0 1-.035.085.122.122 0 0 1-.09.035h-.435ZM33.022 42.45a.096.096 0 0 1-.07-.03.096.096 0 0 1-.03-.07c0-.03.006-.057.02-.08l.39-.925-.96-2.265a.188.188 0 0 1-.02-.07.122.122 0 0 1 .035-.075.095.095 0 0 1 .075-.035h.405c.063 0 .108.032.135.095l.665 1.635.685-1.635c.026-.063.071-.095.135-.095h.4c.026 0 .05.01.07.03a.09.09 0 0 1 .035.07c0 .023-.007.05-.02.08l-1.415 3.275c-.03.063-.077.095-.14.095h-.395Z",
                        fill: "#fff"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("defs", {
                children: /*#__PURE__*/ (0, $7XTbi$jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h48v48H0z"
                    })
                })
            })
        ]
    });
var $408677eee8269470$export$2e2bcd8739ae039 = $408677eee8269470$var$SvgActiveDirectory;




const $e552e02c4a1881cf$var$SvgApplication = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 49,
        height: 48,
        viewBox: "0 0 49 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("rect", {
                x: 0.05,
                width: 48,
                height: 48,
                rx: 24,
                fill: "#EBEDFF"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "m13.175 24.75-.75-8.625 9.75-3 .75.75v8.25l-.75 1.125-8.25 2.625-.75-1.125ZM12.8 38.25v-9l9.75-3 .75.75v8.25l-.75 1.125L13.925 39l-1.125-.75ZM25.925 21.75l-.75-9.375 9.75-3 .75.75v8.25l-.75 1.5-8.25 2.25-.75-.375ZM25.55 34.125l-.375-9 9.75-2.625.75.375V31.5l-.75 1.5-8.625 2.625-.75-1.5Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                fill: "#033176",
                children: [
                    /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        d: "M12.617 17.363c0-1.084.842-2.211 1.88-2.519l7.093-2.101c1.039-.308 1.88.321 1.88 1.404v7.398c0 1.083-.841 2.21-1.88 2.519l-7.093 2.1c-1.038.308-1.88-.32-1.88-1.404v-7.397Zm1.88-1.734c-.623.184-1.128.86-1.128 1.51v7.398c0 .65.505 1.027 1.128.843l7.093-2.101c.623-.185 1.129-.861 1.129-1.511V14.37c0-.65-.506-1.027-1.129-.842l-7.093 2.1Z"
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        d: "M11.3 16.704c0-1.083.842-2.21 1.88-2.519l7.402-2.192c.868-.257 1.572.268 1.572 1.173l-.752.223c0-.472-.367-.134-.82 0l-6.552 2.027c-.624.184-1.177.919-1.177 1.569l.14 7.061c0 .542-.52.885 0 .73v.786c-.935.276-1.693-.29-1.693-1.265v-7.593ZM12.617 30.532c0-1.083.842-2.21 1.88-2.518l7.093-2.101c1.039-.308 1.88.32 1.88 1.404v7.398c0 1.083-.841 2.21-1.88 2.518l-7.093 2.101c-1.038.308-1.88-.32-1.88-1.404v-7.398Zm1.88-1.734c-.623.185-1.128.862-1.128 1.512v7.397c0 .65.505 1.027 1.128.843l7.093-2.101c.623-.185 1.129-.861 1.129-1.511V27.54c0-.65-.506-1.027-1.129-.843l-7.093 2.101Z"
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        d: "M11.3 29.874c0-1.083.842-2.211 1.88-2.519l7.384-2.187c.878-.26 1.59.272 1.59 1.188l-.752.222c0-.482-.376-.36-.838-.222l-6.534 2.006c-.624.184-1.037.862-1.037 1.512v7.119c0 .541-.52 1.108 0 .954v.784c-.935.277-1.693-.289-1.693-1.264v-7.593ZM25.288 26.905c0-1.036.805-2.114 1.798-2.408l7.225-2.14c.993-.294 1.798.307 1.798 1.342v7.536c0 1.036-.805 2.114-1.798 2.408l-7.225 2.14c-.993.294-1.798-.307-1.798-1.342v-7.536Zm1.798-1.658c-.596.177-1.08.823-1.08 1.445v7.536c0 .621.484.982 1.08.805l7.225-2.14c.596-.177 1.079-.823 1.079-1.445v-7.536c0-.62-.483-.982-1.079-.805l-7.225 2.14Z"
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        d: "M23.954 26.32c0-1.083.842-2.21 1.881-2.518l7.404-2.193c.867-.257 1.57.268 1.57 1.172l-.753.223c0-.471-.366-.134-.817 0l-6.656 1.827c-.623.185-.784.92-.784 1.57l-.127 7.06c0 .557-.533 1.083 0 .925v.785c-.949.28-1.718-.294-1.718-1.283v-7.567ZM25.288 13.735c0-1.036.805-2.114 1.798-2.408l7.225-2.14c.993-.294 1.798.307 1.798 1.342v7.536c0 1.036-.805 2.114-1.798 2.408l-7.225 2.14c-.993.294-1.798-.307-1.798-1.342v-7.536Zm1.798-1.658c-.596.177-1.08.823-1.08 1.445v7.536c0 .62.484.982 1.08.805l7.225-2.14c.596-.177 1.079-.823 1.079-1.445v-7.536c0-.621-.483-.982-1.079-.805l-7.225 2.14Z"
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        d: "M23.954 13.15c0-1.083.842-2.21 1.881-2.518l7.372-2.184c.885-.262 1.602.274 1.602 1.196l-.753.223c0-.49-1.119-.083-1.588.056l-5.492 1.962c-.623.184-1.304.92-1.304 1.57v6.798c0 .556-.533 1.121 0 .963v.785c-.949.28-1.718-.293-1.718-1.283v-7.567Z"
                    })
                ]
            })
        ]
    });
var $e552e02c4a1881cf$export$2e2bcd8739ae039 = $e552e02c4a1881cf$var$SvgApplication;




const $ca445b81649c320a$var$SvgAws = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        d: "M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24Z",
                        fill: "#233040"
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        d: "M16.492 21.567c-.009.33.032.658.12.976.098.27.215.534.35.788a.477.477 0 0 1 .077.25.434.434 0 0 1-.209.33l-.69.46a.526.526 0 0 1-.285.1.505.505 0 0 1-.329-.154 3.386 3.386 0 0 1-.394-.515 8.724 8.724 0 0 1-.34-.646 4.051 4.051 0 0 1-3.223 1.513 3.003 3.003 0 0 1-2.193-.79 2.816 2.816 0 0 1-.809-2.104 2.822 2.822 0 0 1 1-2.258 3.987 3.987 0 0 1 2.685-.855c.39.003.778.032 1.162.088.406.055.822.142 1.261.24v-.8a2.429 2.429 0 0 0-.515-1.754 2.523 2.523 0 0 0-1.787-.504c-.398 0-.796.048-1.183.143-.403.096-.8.22-1.184.373a3.136 3.136 0 0 1-.384.142.677.677 0 0 1-.175.033c-.154 0-.23-.11-.23-.34v-.537a.694.694 0 0 1 .076-.383.82.82 0 0 1 .307-.23c.44-.218.903-.383 1.381-.493a6.645 6.645 0 0 1 1.71-.209c1.304 0 2.258.296 2.872.888a3.628 3.628 0 0 1 .91 2.696v3.55l.019.002Zm-4.45 1.666a3.552 3.552 0 0 0 1.129-.198c.402-.138.761-.38 1.042-.7a1.74 1.74 0 0 0 .372-.7c.075-.312.112-.632.11-.953v-.46a9.151 9.151 0 0 0-1.009-.187 8.258 8.258 0 0 0-1.03-.066 2.527 2.527 0 0 0-1.634.438 1.528 1.528 0 0 0-.537 1.261 1.414 1.414 0 0 0 1.556 1.567l.001-.002Zm8.8 1.184a.612.612 0 0 1-.416-.11.893.893 0 0 1-.23-.427l-2.575-8.471a1.917 1.917 0 0 1-.1-.439.241.241 0 0 1 .264-.274h1.073a.607.607 0 0 1 .428.11c.11.12.186.268.219.428l1.841 7.256 1.71-7.256a.77.77 0 0 1 .209-.428.754.754 0 0 1 .438-.11h.879a.66.66 0 0 1 .438.11.739.739 0 0 1 .209.428l1.732 7.344 1.896-7.347a.94.94 0 0 1 .219-.428.715.715 0 0 1 .427-.109h1.02a.244.244 0 0 1 .274.274 1.558 1.558 0 0 1-.099.45l-2.641 8.473a.84.84 0 0 1-.23.428.7.7 0 0 1-.417.109h-.943a.66.66 0 0 1-.438-.11.777.777 0 0 1-.209-.438l-1.698-7.071-1.689 7.06a.856.856 0 0 1-.208.439.68.68 0 0 1-.439.109h-.944Zm14.086.296a7.258 7.258 0 0 1-1.688-.198 4.985 4.985 0 0 1-1.261-.438.79.79 0 0 1-.34-.307.773.773 0 0 1-.066-.307v-.559c0-.23.087-.34.25-.34a.62.62 0 0 1 .197.033c.066.022.165.066.274.11.388.17.792.298 1.207.383.429.087.866.131 1.304.131a2.958 2.958 0 0 0 1.6-.361 1.181 1.181 0 0 0 .57-1.041 1.067 1.067 0 0 0-.296-.768c-.32-.272-.7-.467-1.107-.57l-1.59-.494a3.343 3.343 0 0 1-1.754-1.117 2.611 2.611 0 0 1-.55-1.59 2.44 2.44 0 0 1 .296-1.216c.196-.354.465-.66.79-.9a3.48 3.48 0 0 1 1.14-.57c.45-.13.918-.192 1.387-.185.246-.002.491.013.735.044.25.033.482.077.712.12.22.056.428.11.626.176.16.05.314.116.46.197a.95.95 0 0 1 .329.274.59.59 0 0 1 .1.362v.515c0 .23-.087.35-.25.35a1.14 1.14 0 0 1-.416-.131 5.015 5.015 0 0 0-2.105-.428 2.829 2.829 0 0 0-1.458.307 1.058 1.058 0 0 0-.515.976 1.036 1.036 0 0 0 .329.778c.356.282.767.488 1.206.603l1.556.494c.661.168 1.255.534 1.7 1.05.335.44.512.98.505 1.534a2.82 2.82 0 0 1-.285 1.271 2.95 2.95 0 0 1-.8.965c-.362.282-.776.49-1.217.614-.51.158-1.04.236-1.574.233h-.002Z",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        d: "M34.283 28.188c1.173-.143 3.76-.45 4.22.142.461.581-.514 3.026-.953 4.108-.131.329.154.459.45.209 1.929-1.622 2.433-5.01 2.038-5.503-.392-.48-3.781-.897-5.842.55-.318.23-.262.538.087.494Z",
                        fill: "#F90"
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        d: "M23.651 34.118c4.505 0 9.744-1.414 13.35-4.078.593-.438.078-1.107-.526-.833a32.55 32.55 0 0 1-12.44 2.543 32.871 32.871 0 0 1-16.311-4.33c-.405-.24-.713.176-.373.483a24.154 24.154 0 0 0 16.3 6.215Z",
                        fill: "#F90"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("rect", {
                x: 0.5,
                y: 0.5,
                width: 47,
                height: 47,
                rx: 23.5,
                stroke: "#515466"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("defs", {
                children: /*#__PURE__*/ (0, $7XTbi$jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, $7XTbi$jsx)("rect", {
                        width: 48,
                        height: 48,
                        rx: 24,
                        fill: "#fff"
                    })
                })
            })
        ]
    });
var $ca445b81649c320a$export$2e2bcd8739ae039 = $ca445b81649c320a$var$SvgAws;




const $baf62fdf8ce6f0f2$var$SvgAzure = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M48 24c0 13.255-10.745 24-24 24S0 37.255 0 24 10.745 0 24 0s24 10.745 24 24Z",
                fill: "#0089D6"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M12.084 24.57A3044.234 3044.234 0 0 0 8 31.659c0 .007 1.661.007 3.69.007l3.691-.004 10.242-21.97A.845.845 0 0 0 25.7 9.5c-.008.003-2.156 1.803-4.774 4l-4.759 3.993-4.084 7.077ZM28.061 32.156l-5.186.917-7.512 1.33h24.788l-.05-.088c-.017-.033-1.324-2.297-3.254-5.641l-3.427-5.94c-3.896-6.75-6.635-11.483-6.643-11.466-.023.038-4.05 11.128-4.05 11.15 0 .012 1.755 2.111 3.9 4.662l3.9 4.638-.072.015-2.393.423Z",
                fill: "#fff"
            })
        ]
    });
var $baf62fdf8ce6f0f2$export$2e2bcd8739ae039 = $baf62fdf8ce6f0f2$var$SvgAzure;




const $a949c4422181d892$var$SvgAzureAd = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        d: "M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24Z",
                        fill: "#00BEF2"
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        d: "M23.122 37.71a3.835 3.835 0 0 1-1.841-1.606 3.74 3.74 0 0 1 .082-3.084c.364-.75.364-.775.129-.95-.129-.095-1.689-.962-3.45-1.912a859.195 859.195 0 0 1-3.4-1.841c-.14-.082-.375 0-.797.27a3.046 3.046 0 0 1-3.929-.27 3.25 3.25 0 0 1-.164-4.609 3.132 3.132 0 0 1 3.272-.821c.634.211.645.211 1.044-.094.469-.35 4.233-3.788 6.05-5.512l1.255-1.196-.376-.786a3.528 3.528 0 0 1 .962-4.4 3.17 3.17 0 0 1 2.31-.75 3.542 3.542 0 0 1 3.225 4.844c-.247.633-.247.645-.011 1.032.2.34 3.588 4.433 5.382 6.52.206.28.475.504.786.657a4.29 4.29 0 0 0 .891-.258 3.188 3.188 0 0 1 3.378 5.336 2.767 2.767 0 0 1-2.158.832 2.654 2.654 0 0 1-1.595-.445 2.09 2.09 0 0 0-1.079-.376c-.282.071-4.609 3.038-5.57 3.812-.587.481-.634.657-.329 1.372a3.465 3.465 0 0 1-.07 2.5 3.732 3.732 0 0 1-2.05 1.759c-.63.228-1.322.22-1.947-.023Zm.2-12.923v-6.685l-.375-.517a2.663 2.663 0 0 0-.446-.515c-.15 0-7.728 6.883-7.728 7.024.073.258.159.513.258.762.145.403.224.827.234 1.255-.011.317-.011.669-.011.786.011.27 2.545 1.888 6.345 4.081 1.043.61 1.407.762 1.536.656.15-.127.187-1.429.187-6.847Zm3.213 5.91c5.02-3.154 5.958-3.787 6.016-4.022.06-.412.092-.827.094-1.243l.035-.985-2.556-3.037c-2.744-3.25-3.752-4.35-3.987-4.35a4.278 4.278 0 0 0-.915.516l-.774.515.035 6.674c.035 5.98.082 6.989.305 6.989.023.011.821-.469 1.747-1.056Z",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        d: "m23.122 37.71-.237.571.013.005.224-.575Zm-1.841-1.606-.57.24a.62.62 0 0 0 .037.072l.533-.312Zm-.292-1.551-.618-.017.618.017Zm.374-1.533.556.27v-.001l-.556-.27Zm.129-.95.371-.495-.007-.005-.364.5Zm-3.45-1.912-.293.544.293-.544Zm-3.4-1.841-.311.534.01.005.301-.539Zm-.797.27-.333-.521a.69.69 0 0 0-.034.023l.367.498Zm-2.014.585-.042.616.042-.616Zm-1.915-.855.43-.443-.01-.01-.42.453Zm-.747-1.031-.562.257.562-.257Zm-.09-2.496-.578-.217.579.217Zm.673-1.082-.45-.424v.001l.45.423Zm1.516-.889-.15-.599.15.6Zm1.756.068-.196.586.196-.586Zm1.044-.094-.37-.495-.006.004.376.491Zm6.05-5.512.425.448-.425-.448Zm1.255-1.196.426.447a.618.618 0 0 0 .131-.713l-.558.266Zm-.376-.786.558-.266-.009-.017-.549.284Zm.962-4.4.38.488a.582.582 0 0 0 .021-.018l-.401-.47Zm2.31-.75-.049.617a.653.653 0 0 0 .037.001l.012-.617Zm1.634.436-.297.542.297-.542Zm1.246 1.143-.515.342.515-.342Zm.345 3.265-.575-.227v.003l.575.224Zm-.011 1.032.532-.313-.004-.008-.528.321Zm5.382 6.52.498-.366a.654.654 0 0 0-.029-.036l-.469.402Zm.786.657-.273.554c.118.058.25.077.38.055l-.107-.609Zm.891-.258.236.572.02-.01-.256-.562Zm3.378 5.336-.4-.472a.598.598 0 0 0-.043.041l.443.431Zm-2.158.832.039-.616a.617.617 0 0 0-.067 0l.028.617Zm-1.595-.445-.355.506.011.008.344-.514Zm-1.079-.376.036-.617a.62.62 0 0 0-.186.018l.15.6Zm-5.57 3.812-.388-.481-.004.003.391.478Zm-.329 1.372.582-.207a.57.57 0 0 0-.014-.035l-.568.242Zm-.07 2.5.544.292a.644.644 0 0 0 .025-.053l-.57-.239Zm-2.05 1.759-.206-.583-.005.002.21.581Zm-1.747-19.633h.618a.618.618 0 0 0-.118-.363l-.5.364Zm-.375-.515-.516.34.016.023.5-.364Zm-.446-.516.412-.46a.618.618 0 0 0-.412-.159v.619Zm-7.728 7.024h-.618c0 .057.008.113.023.168l.595-.168Zm.258.762.581-.209a.681.681 0 0 0-.007-.018l-.574.227Zm.234 1.255.618.023a.57.57 0 0 0 0-.037l-.617.014Zm-.011.786h-.618v.026l.618-.026Zm6.345 4.081.311-.534-.003-.001-.308.535Zm1.536.656.392.478.008-.007-.4-.47Zm3.4-.936-.328-.524a.618.618 0 0 0-.29.524h.618Zm6.016-4.023.6.15a.591.591 0 0 0 .012-.06l-.611-.09Zm.094-1.243-.617-.022v.018l.617.004Zm.035-.985.618.022a.617.617 0 0 0-.145-.42l-.472.398Zm-2.556-3.037.473-.398v-.001l-.473.399Zm-3.987-4.35v-.618c-.081 0-.161.015-.236.046l.236.572Zm-.915.516.343.514a.726.726 0 0 0 .024-.018l-.367-.496Zm-.774.515-.343-.514a.618.618 0 0 0-.275.518l.618-.003Zm.035 6.674-.618.003.618-.003Zm.305 6.989.272-.555a.617.617 0 0 0-.272-.063v.618Zm1.747-1.056.331.523a.618.618 0 0 0 .288-.523h-.619ZM24 48.618c13.596 0 24.618-11.022 24.618-24.618h-1.236c0 12.913-10.468 23.382-23.382 23.382v1.236ZM48.618 24C48.618 10.404 37.596-.618 24-.618V.618C36.913.618 47.382 11.086 47.382 24h1.236ZM24-.618C10.404-.618-.618 10.404-.618 24H.618C.618 11.086 11.086.618 24 .618V-.618ZM-.618 24c0 13.596 11.022 24.618 24.618 24.618v-1.236C11.086 47.382.618 36.914.618 24H-.618Zm23.977 13.14a3.218 3.218 0 0 1-1.545-1.348l-1.067.624a4.453 4.453 0 0 0 2.138 1.865l.474-1.141Zm-1.509-1.276a3.122 3.122 0 0 1-.243-1.295l-1.236-.033c-.016.62.1 1.236.34 1.808l1.14-.48Zm-.243-1.295c.012-.444.118-.88.312-1.28l-1.112-.54a4.356 4.356 0 0 0-.436 1.787l1.236.033Zm.312-1.28c.09-.184.164-.34.218-.466.05-.116.107-.261.127-.413a.804.804 0 0 0-.137-.58c-.094-.132-.223-.224-.264-.255l-.742.989.031.023.008.007.002.002-.003-.003a.26.26 0 0 1-.042-.05.448.448 0 0 1-.078-.295c.003-.02.006-.026 0-.007a1.244 1.244 0 0 1-.037.095c-.041.095-.103.223-.195.414l1.112.539Zm-.063-1.719a6 6 0 0 0-.404-.242c-.195-.111-.459-.26-.773-.434-.629-.348-1.461-.804-2.344-1.28l-.586 1.088c.879.474 1.707.927 2.33 1.273.313.173.572.319.761.427.21.12.291.17.288.167l.728-.999Zm-3.52-1.956a859.198 859.198 0 0 1-3.392-1.836l-.604 1.078c.11.062 1.65.898 3.409 1.846l.586-1.088Zm-3.382-1.83c-.3-.175-.609-.116-.804-.05-.202.07-.417.19-.638.332l.665 1.041c.097-.061.175-.108.24-.142a.952.952 0 0 1 .131-.06c.025-.009.013 0-.026 0a.382.382 0 0 1-.191-.054l.623-1.068Zm-1.476.305a2.429 2.429 0 0 1-1.605.466l-.084 1.233c.865.06 1.723-.19 2.422-.704l-.733-.995Zm-1.605.466a2.428 2.428 0 0 1-1.526-.681l-.862.886a3.665 3.665 0 0 0 2.304 1.028l.084-1.233Zm-1.537-.692a2.632 2.632 0 0 1-.606-.835l-1.123.515c.213.464.515.881.89 1.228l.839-.908Zm-.606-.835a2.632 2.632 0 0 1-.238-1.003l-1.235.044c.018.51.137 1.01.35 1.474l1.123-.515Zm-.238-1.003a2.633 2.633 0 0 1 .166-1.018l-1.157-.434c-.179.477-.262.986-.244 1.496l1.235-.044Zm.166-1.018c.122-.325.307-.623.545-.876l-.902-.846c-.349.372-.62.81-.8 1.288l1.157.434Zm.543-.875c.33-.349.752-.596 1.217-.713l-.3-1.199a3.75 3.75 0 0 0-1.815 1.064l.898.848Zm1.217-.713a2.515 2.515 0 0 1 1.41.054l.392-1.172a3.75 3.75 0 0 0-2.102-.081l.3 1.199Zm1.41.054c.152.05.294.098.416.13.123.031.276.061.445.046.348-.03.603-.25.754-.365l-.751-.982a2.326 2.326 0 0 1-.18.132c-.014.008.016-.012.067-.016.037-.003.043.006-.026-.012a5.83 5.83 0 0 1-.334-.105l-.39 1.172Zm1.61-.185c.265-.198 1.355-1.176 2.566-2.28a273.59 273.59 0 0 0 3.539-3.279l-.85-.896c-.905.858-2.297 2.145-3.522 3.263-1.244 1.134-2.27 2.05-2.473 2.202l.74.99Zm6.106-5.56 1.255-1.196-.853-.894-1.255 1.196.853.894Zm1.386-1.91-.375-.785-1.116.533.376.786 1.115-.534Zm-.384-.802a2.91 2.91 0 0 1-.258-1.958l-1.208-.264a4.146 4.146 0 0 0 .368 2.79l1.098-.568Zm-.258-1.958a2.91 2.91 0 0 1 1.051-1.671l-.761-.975a4.146 4.146 0 0 0-1.498 2.382l1.208.264Zm1.072-1.689c.255-.218.55-.383.87-.487l-.382-1.175c-.473.153-.912.4-1.291.723l.803.94Zm.87-.487c.319-.104.655-.143.99-.117l.098-1.232c-.497-.04-.996.02-1.47.174l.382 1.175Zm1.027-.115c.472.01.935.133 1.349.36l.594-1.084a4.16 4.16 0 0 0-1.92-.511l-.023 1.235Zm1.349.36c.414.226.767.55 1.028.943l1.029-.685a4.16 4.16 0 0 0-1.463-1.342l-.594 1.084Zm1.028.943c.262.393.424.843.474 1.313l1.23-.13a4.16 4.16 0 0 0-.675-1.868l-1.029.685Zm.474 1.313c.05.47-.015.944-.189 1.383l1.15.454c.247-.624.339-1.3.268-1.967l-1.229.13Zm-.19 1.386a7.89 7.89 0 0 0-.151.409c-.038.117-.075.26-.077.417-.004.34.172.6.264.75l1.057-.64a1.92 1.92 0 0 1-.096-.167c-.002-.004.011.027.01.07 0 .027-.006.023.018-.051.024-.075.063-.176.127-.34l-1.152-.448Zm.032 1.57c.05.084.154.221.26.357.118.153.276.352.464.585a295.382 295.382 0 0 0 4.723 5.667l.937-.805a293.07 293.07 0 0 1-4.697-5.637 43.886 43.886 0 0 1-.583-.741c-.038-.051-.045-.063-.039-.053l-1.065.626Zm5.418 6.573c.264.359.61.648 1.01.845l.546-1.11a1.546 1.546 0 0 1-.561-.468l-.995.733Zm1.39.899a4.91 4.91 0 0 0 1.02-.295l-.47-1.144a3.68 3.68 0 0 1-.764.221l.214 1.218Zm1.04-.304a2.57 2.57 0 0 1 1.797-.122l.354-1.185a3.806 3.806 0 0 0-2.662.181l.51 1.126Zm1.797-.122a2.57 2.57 0 0 1 1.436 1.088l1.045-.662a3.806 3.806 0 0 0-2.127-1.61l-.354 1.184Zm1.436 1.088a2.57 2.57 0 0 1 .37 1.763l1.221.187a3.806 3.806 0 0 0-.546-2.611l-1.045.66Zm.37 1.763a2.57 2.57 0 0 1-.88 1.572l.798.944a3.806 3.806 0 0 0 1.303-2.329l-1.222-.187Zm-.924 1.613a2.15 2.15 0 0 1-.767.507l.445 1.153a3.385 3.385 0 0 0 1.208-.798l-.886-.862Zm-.767.507c-.29.111-.6.16-.91.14l-.077 1.233c.488.031.976-.044 1.432-.22l-.445-1.153Zm-.976.14c-.434.019-.862-.101-1.223-.343l-.688 1.028c.58.388 1.27.58 1.967.549l-.056-1.235Zm-1.212-.335a2.71 2.71 0 0 0-1.398-.487l-.072 1.234c.273.016.536.108.76.265l.71-1.012Zm-1.584-.469c-.108.027-.21.085-.244.103-.06.032-.13.074-.208.12-.155.095-.357.224-.59.375-.465.304-1.067.708-1.687 1.134-1.233.844-2.576 1.793-3.079 2.198l.775.962c.459-.369 1.76-1.29 3.002-2.14.616-.423 1.21-.822 1.665-1.118.228-.15.417-.27.556-.354.07-.043.122-.073.157-.092.062-.033.025-.007-.047.011l-.3-1.199Zm-5.812 3.933c-.274.225-.605.508-.708.93-.101.42.06.827.203 1.162l1.137-.484a2.33 2.33 0 0 1-.127-.348c-.015-.064-.005-.064-.012-.038-.006.026-.015.023.025-.024.046-.053.124-.126.265-.242l-.783-.956Zm-.52 2.057c.238.668.217 1.4-.057 2.054l1.14.478a4.083 4.083 0 0 0 .082-2.946l-1.164.414Zm-.032 2.001a3.114 3.114 0 0 1-1.71 1.468l.41 1.166a4.35 4.35 0 0 0 2.39-2.05l-1.09-.584Zm-1.716 1.47a2.15 2.15 0 0 1-1.512-.018l-.448 1.151c.764.298 1.61.308 2.38.03l-.42-1.163Zm-.918-12.366v-6.685h-1.236v6.685h1.236Zm-.118-7.05-.376-.515-1 .727.376.516 1-.727Zm-.36-.492a3.284 3.284 0 0 0-.549-.636l-.824.92c.13.118.245.251.342.397l1.031-.681Zm-.961-.794c-.123 0-.215.038-.236.046a.691.691 0 0 0-.152.085 2.162 2.162 0 0 0-.107.08c-.073.058-.168.137-.28.233-.227.192-.539.465-.905.79-.735.65-1.698 1.516-2.656 2.387-.958.87-1.912 1.746-2.627 2.413-.357.334-.658.617-.87.824-.105.102-.193.19-.257.256-.03.032-.063.067-.09.1a.898.898 0 0 0-.104.157c-.01.021-.062.127-.062.272h1.236c0 .143-.051.246-.06.263a.568.568 0 0 1-.04.07c-.007.012-.014.02-.017.024l-.005.007.009-.01.027-.03c.047-.049.122-.124.225-.223.203-.197.496-.474.851-.806.71-.663 1.66-1.534 2.615-2.403.956-.868 1.915-1.73 2.644-2.376.365-.323.67-.59.886-.774a9.686 9.686 0 0 1 .28-.23l.009-.007.003-.002-.005.003a.438.438 0 0 1-.086.044c-.017.007-.105.044-.226.044v-1.236Zm-8.323 7.81c.079.28.172.554.278.823l1.15-.455a7.252 7.252 0 0 1-.238-.703l-1.19.336Zm.272.805c.122.34.19.698.198 1.06l1.235-.03a4.597 4.597 0 0 0-.27-1.449l-1.163.419Zm.198 1.023c-.012.33-.012.692-.012.808h1.236c0-.118 0-.46.011-.763l-1.235-.045Zm-.011.834c.009.215.12.366.152.408.05.067.107.127.158.176.104.1.242.21.398.327.316.238.768.543 1.327.902 1.121.72 2.714 1.678 4.618 2.777l.617-1.07c-1.895-1.095-3.47-2.042-4.567-2.747-.551-.353-.973-.64-1.253-.85a3.396 3.396 0 0 1-.286-.233c-.027-.026-.028-.03-.019-.017a.543.543 0 0 1 .09.275l-1.235.052Zm6.65 4.589c.52.303.902.513 1.18.631.137.058.288.112.44.132.155.02.403.016.62-.163l-.784-.955a.445.445 0 0 1 .324-.107c.015.002-.014 0-.115-.044-.197-.084-.518-.256-1.042-.561l-.623 1.067Zm2.248.593c.178-.15.232-.357.249-.422.027-.102.044-.22.058-.343.027-.251.047-.617.06-1.128.029-1.029.038-2.718.038-5.425h-1.236c0 2.71-.01 4.382-.037 5.39-.014.508-.032.83-.054 1.029-.01.1-.02.148-.024.163-.014.052.006-.086.146-.205l.8.941Zm3.33-.884c2.507-1.576 4.004-2.528 4.883-3.116.436-.293.736-.506.934-.666.098-.08.188-.16.26-.241a.887.887 0 0 0 .21-.373l-1.2-.3c.029-.115.086-.17.07-.151-.01.01-.042.043-.119.105-.15.123-.41.309-.843.599-.86.576-2.342 1.518-4.853 3.096l.657 1.047Zm6.298-4.457c.064-.44.098-.884.1-1.328l-1.235-.008a8.364 8.364 0 0 1-.088 1.158l1.223.178Zm.1-1.31.035-.985-1.235-.044-.035.985 1.235.044Zm-.11-1.405-2.556-3.037-.946.795 2.557 3.038.945-.796Zm-2.557-3.038c-1.371-1.625-2.317-2.721-2.951-3.413-.316-.344-.565-.6-.758-.775a2.446 2.446 0 0 0-.285-.226.858.858 0 0 0-.465-.155v1.235c-.168 0-.26-.078-.214-.047.018.011.06.043.136.11.148.135.366.356.675.693.615.671 1.545 1.75 2.918 3.375l.944-.797Zm-4.695-4.523a4.895 4.895 0 0 0-1.046.59l.735.994c.241-.178.504-.327.782-.441l-.47-1.143Zm-1.022.573-.774.516.686 1.029.774-.516-.686-1.029Zm-1.049 1.034.035 6.673 1.236-.007-.035-6.673-1.236.007Zm.035 6.673c.018 2.986.038 4.747.083 5.761.022.5.05.854.096 1.091.022.112.058.257.133.388a.704.704 0 0 0 .611.364v-1.236c.27 0 .417.18.46.254.03.052.025.072.01-.004-.027-.139-.054-.41-.076-.911-.043-.985-.063-2.72-.081-5.714l-1.236.007Zm.651 7.541a.62.62 0 0 0 .52.013c.031-.013.059-.027.076-.035a3.67 3.67 0 0 0 .134-.073c.1-.057.236-.137.396-.234.323-.195.758-.464 1.224-.76l-.661-1.044c-.46.292-.888.556-1.201.745a17.41 17.41 0 0 1-.453.264c-.008.005 0 0 .015-.006a.53.53 0 0 1 .175-.04.615.615 0 0 1 .319.06l-.544 1.11Zm2.638-1.61v-.002h-1.236v.002h1.236Z",
                        fill: "#fff"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("defs", {
                children: /*#__PURE__*/ (0, $7XTbi$jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h48v48H0z"
                    })
                })
            })
        ]
    });
var $a949c4422181d892$export$2e2bcd8739ae039 = $a949c4422181d892$var$SvgAzureAd;




const $88ad8133e2828917$var$SvgCertsAccount = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M0 24C0 10.745 10.745 0 24 0s24 10.745 24 24-10.745 24-24 24S0 37.255 0 24Z",
                fill: "#EBEDFF"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.867 20.521a3.522 3.522 0 1 1 7.044 0 3.522 3.522 0 0 1-7.044 0Zm3.522-2.355a2.356 2.356 0 1 0 0 4.711 2.356 2.356 0 0 0 0-4.711Z",
                fill: "#00245B"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M24.423 24.777c-1.87 0-3.493.528-4.768 1.41l-.003.003-.016.01a2.79 2.79 0 0 0-.222.174c-.138.115-.32.283-.505.499-.36.42-.776 1.079-.776 1.904v1.64a.583.583 0 1 0 1.166 0v-1.64c0-.428.22-.824.495-1.145a3.2 3.2 0 0 1 .487-.457l.02-.016.009-.005.003-.003.006-.004c1.07-.74 2.458-1.203 4.104-1.203 1.63 0 3.079.526 4.21 1.28.416.278.627.66.736.993a2.238 2.238 0 0 1 .104.533v.034l.001.01v.01l.001.028.003.11.006.384c.003.314.003.714-.01 1.07a.583.583 0 0 0 1.166.043 25.043 25.043 0 0 0 .004-1.523l-.003-.114v-.052l-.003-.06a3.41 3.41 0 0 0-.16-.835 3.024 3.024 0 0 0-1.197-1.6 8.764 8.764 0 0 0-4.858-1.478Z",
                fill: "#00245B"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.891 14.861c0-.752.61-1.361 1.361-1.361h15.945a3.694 3.694 0 0 1 3.694 3.694V33.14c0 .752-.609 1.361-1.36 1.361H17.585a3.694 3.694 0 0 1-3.695-3.694V14.86Zm1.361-.194a.194.194 0 0 0-.194.194v15.945a2.528 2.528 0 0 0 2.528 2.527H33.53a.194.194 0 0 0 .195-.194V17.194a2.528 2.528 0 0 0-2.528-2.527H15.253Z",
                fill: "#00245B"
            })
        ]
    });
var $88ad8133e2828917$export$2e2bcd8739ae039 = $88ad8133e2828917$var$SvgCertsAccount;




const $445683242766d0f7$var$SvgDatabase = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("rect", {
                width: 40,
                height: 40,
                rx: 20,
                fill: "#EBEDFF"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.654 11.034C15.306 10.388 17.55 10 20 10s4.695.388 6.347 1.034c.824.322 1.528.72 2.037 1.19.508.47.86 1.055.86 1.732 0 .083-.005.165-.015.246.01.042.016.086.016.131v11.645c0 .68-.345 1.273-.852 1.754-.506.48-1.209.885-2.032 1.214-1.65.66-3.895 1.054-6.36 1.054-2.466 0-4.712-.394-6.362-1.054-.823-.329-1.525-.735-2.031-1.214-.507-.481-.852-1.074-.852-1.754V14.333c0-.045.005-.09.016-.131a1.92 1.92 0 0 1-.016-.246c0-.677.352-1.261.86-1.732.509-.47 1.214-.867 2.038-1.19ZM12.37 13.04c-.37.343-.504.653-.504.916 0 .262.134.572.504.915.372.344.94.678 1.688.971 1.493.585 3.593.958 5.941.958s4.449-.373 5.942-.958c.748-.293 1.316-.627 1.687-.97.37-.344.505-.654.505-.916 0-.263-.134-.573-.505-.916-.371-.344-.939-.678-1.687-.971-1.493-.585-3.594-.958-5.942-.958-2.348 0-4.448.373-5.941.958-.748.292-1.316.627-1.688.97Zm-.504 2.86v4.478c0 .187.106.443.477.75.368.303.934.602 1.684.863 1.496.521 3.603.853 5.972.853 2.37 0 4.477-.332 5.972-.853.75-.261 1.316-.56 1.684-.864.371-.306.478-.562.478-.75V15.9c-.48.378-1.09.705-1.787.977-1.652.646-3.896 1.034-6.347 1.034-2.45 0-4.694-.388-6.346-1.034-.697-.272-1.308-.599-1.787-.977Zm16.267 6.26c-.481.343-1.096.637-1.796.88-1.643.573-3.88.916-6.338.916s-4.695-.343-6.337-.915c-.7-.244-1.315-.538-1.796-.88v3.817c0 .278.138.599.505.948.37.35.934.69 1.68.989 1.488.594 3.587.974 5.948.974 2.362 0 4.46-.38 5.949-.974.745-.298 1.31-.64 1.679-.99.368-.348.506-.669.506-.947V22.16Z",
                fill: "#254B86"
            })
        ]
    });
var $445683242766d0f7$export$2e2bcd8739ae039 = $445683242766d0f7$var$SvgDatabase;




const $d52ac54e69bff60e$var$SvgEntitlement = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 48,
        height: 49,
        viewBox: "0 0 48 49",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M0 24.5C0 11.245 10.745.5 24 .5s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24Z",
                fill: "#EBEDFF"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M14.667 14a.583.583 0 0 0-.584.583v15.945A2.917 2.917 0 0 0 17 33.444h7.908a.583.583 0 1 0 0-1.166H17a1.75 1.75 0 0 1-1.75-1.75V15.167h12.639c.966 0 1.75.783 1.75 1.75v2.987a.583.583 0 1 0 1.166 0v-2.987A2.917 2.917 0 0 0 27.89 14H14.667Z",
                fill: "#00245B"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M18.35 18.083a.583.583 0 0 0 0 1.167h6.222a.583.583 0 0 0 0-1.167H18.35ZM17.767 21.389c0-.322.26-.583.583-.583h6.222a.583.583 0 1 1 0 1.166H18.35a.583.583 0 0 1-.584-.583ZM18.35 23.528a.583.583 0 1 0 0 1.166h3.11a.583.583 0 1 0 0-1.166h-3.11Z",
                fill: "#00245B"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M25.75 25.472a4.083 4.083 0 1 1 7.052 2.804v6.14a.583.583 0 0 1-.991.418l-1.978-1.935-1.977 1.934a.583.583 0 0 1-.991-.416v-6.141a4.07 4.07 0 0 1-1.115-2.804Zm4.083-2.916a2.917 2.917 0 1 0 0 5.833 2.917 2.917 0 0 0 0-5.833Zm-1.802 6.581v3.893l1.394-1.364a.583.583 0 0 1 .816 0l1.394 1.364v-3.893a4.067 4.067 0 0 1-1.802.419c-.646 0-1.258-.15-1.802-.419Z",
                fill: "#00245B"
            })
        ]
    });
var $d52ac54e69bff60e$export$2e2bcd8739ae039 = $d52ac54e69bff60e$var$SvgEntitlement;




const $30c933a95067ca90$var$SvgGcp = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 41,
        height: 40,
        viewBox: "0 0 41 40",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M40.05 20c0 11.046-8.955 20-20 20-11.046 0-20-8.954-20-20s8.954-20 20-20c11.045 0 20 8.954 20 20Z",
                fill: "#ECF3FE"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M24.374 13.268h.989l2.818-2.818.139-1.197a12.666 12.666 0 0 0-20.61 6.181c.315-.128.662-.15.99-.06l5.637-.929s.286-.474.434-.445a7.031 7.031 0 0 1 9.622-.732h-.019Z",
                fill: "#EA4335"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M32.196 15.434a12.698 12.698 0 0 0-3.827-6.17l-3.956 3.955a7.031 7.031 0 0 1 2.581 5.58v.701a3.52 3.52 0 1 1 0 7.042h-7.04l-.703.712v4.22l.702.703h7.042a9.158 9.158 0 0 0 5.201-16.743Z",
                fill: "#4285F4"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M12.902 32.137h7.042V26.5h-7.041c-.502 0-.998-.108-1.454-.316l-.989.306-2.838 2.819-.247.989a9.107 9.107 0 0 0 5.527 1.84Z",
                fill: "#34A853"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M12.902 13.852a9.157 9.157 0 0 0-5.527 16.416l4.083-4.083a3.522 3.522 0 1 1 4.659-4.66l4.083-4.082a9.15 9.15 0 0 0-7.297-3.591Z",
                fill: "#FBBC05"
            })
        ]
    });
var $30c933a95067ca90$export$2e2bcd8739ae039 = $30c933a95067ca90$var$SvgGcp;




const $dfa477212024ca80$var$SvgOkta = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        d: "M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24Z",
                        fill: "#007DC1"
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        d: "M9.376 20.776a4.876 4.876 0 1 0-.004 9.752 4.876 4.876 0 0 0 .004-9.752Zm0 7.32a2.443 2.443 0 1 1 0-4.887 2.443 2.443 0 0 1 0 4.887ZM17.945 27.291a.43.43 0 0 1 .737-.3c1.222 1.241 3.238 3.373 3.25 3.383a.343.343 0 0 0 .175.117c.07.018.141.024.213.019h2.2a.429.429 0 0 0 .33-.689l-3.646-3.732-.194-.194c-.417-.494-.368-.688.107-1.192l2.889-3.228a.422.422 0 0 0-.34-.678H21.67a.602.602 0 0 0-.194.019.366.366 0 0 0-.194.117c-.009.009-1.608 1.735-2.6 2.791a.437.437 0 0 1-.756-.3v-5.536a.386.386 0 0 0-.416-.388h-1.628a.374.374 0 0 0-.417.35v12.271c0 .282.232.359.426.359h1.629a.394.394 0 0 0 .417-.369v-2.82h.01ZM31.246 30.064l-.174-1.629a.387.387 0 0 0-.456-.34 2.443 2.443 0 0 1-2.811-2.278v-2.132a.458.458 0 0 1 .456-.475h2.18a.407.407 0 0 0 .389-.417V21.25a.408.408 0 0 0-.369-.456h-2.2a.454.454 0 0 1-.465-.436v-2.47a.393.393 0 0 0-.418-.388h-1.619a.371.371 0 0 0-.398.378v7.94a4.872 4.872 0 0 0 4.877 4.74c.217-.002.434-.018.65-.05a.396.396 0 0 0 .358-.444ZM42.993 28.017c-1.377 0-1.59-.494-1.59-2.346v-4.468a.417.417 0 0 0-.426-.417h-1.629a.427.427 0 0 0-.426.417v.204a4.814 4.814 0 0 0-2.404-.64 4.875 4.875 0 1 0 3.17 8.579 2.628 2.628 0 0 0 2.345 1.172c.194 0 1.242.04 1.242-.455v-1.735a.307.307 0 0 0-.282-.311Zm-6.466.078a2.444 2.444 0 1 1-.004-4.89 2.444 2.444 0 0 1 .006 4.89h-.002Z",
                        fill: "#fff"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("defs", {
                children: /*#__PURE__*/ (0, $7XTbi$jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h48v48H0z"
                    })
                })
            })
        ]
    });
var $dfa477212024ca80$export$2e2bcd8739ae039 = $dfa477212024ca80$var$SvgOkta;




const $f6afa0644eaaa4d5$var$SvgPlaceholder = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 49,
        height: 48,
        viewBox: "0 0 49 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("rect", {
                x: 0.05,
                width: 48,
                height: 48,
                rx: 24,
                fill: "#EBEDFF"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "m13.175 24.75-.75-8.625 9.75-3 .75.75v8.25l-.75 1.125-8.25 2.625-.75-1.125ZM12.8 38.25v-9l9.75-3 .75.75v8.25l-.75 1.125L13.925 39l-1.125-.75ZM25.925 21.75l-.75-9.375 9.75-3 .75.75v8.25l-.75 1.5-8.25 2.25-.75-.375ZM25.55 34.125l-.375-9 9.75-2.625.75.375V31.5l-.75 1.5-8.625 2.625-.75-1.5Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                fill: "#033176",
                children: [
                    /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        d: "M12.617 17.363c0-1.084.842-2.211 1.88-2.519l7.093-2.101c1.039-.308 1.88.321 1.88 1.404v7.398c0 1.083-.841 2.21-1.88 2.519l-7.093 2.1c-1.038.308-1.88-.32-1.88-1.404v-7.397Zm1.88-1.734c-.623.184-1.128.86-1.128 1.51v7.398c0 .65.505 1.027 1.128.843l7.093-2.101c.623-.185 1.129-.861 1.129-1.511V14.37c0-.65-.506-1.027-1.129-.842l-7.093 2.1Z"
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        d: "M11.3 16.704c0-1.083.842-2.21 1.88-2.519l7.402-2.192c.868-.257 1.572.268 1.572 1.173l-.752.223c0-.472-.367-.134-.82 0l-6.552 2.027c-.624.184-1.177.919-1.177 1.569l.14 7.061c0 .542-.52.885 0 .73v.786c-.935.276-1.693-.29-1.693-1.265v-7.593ZM12.617 30.532c0-1.083.842-2.21 1.88-2.518l7.093-2.101c1.039-.308 1.88.32 1.88 1.404v7.398c0 1.083-.841 2.21-1.88 2.518l-7.093 2.101c-1.038.308-1.88-.32-1.88-1.404v-7.398Zm1.88-1.734c-.623.185-1.128.862-1.128 1.512v7.397c0 .65.505 1.027 1.128.843l7.093-2.101c.623-.185 1.129-.861 1.129-1.511V27.54c0-.65-.506-1.027-1.129-.843l-7.093 2.101Z"
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        d: "M11.3 29.874c0-1.083.842-2.211 1.88-2.519l7.384-2.187c.878-.26 1.59.272 1.59 1.188l-.752.222c0-.482-.376-.36-.838-.222l-6.534 2.006c-.624.184-1.037.862-1.037 1.512v7.119c0 .541-.52 1.108 0 .954v.784c-.935.277-1.693-.289-1.693-1.264v-7.593ZM25.288 26.905c0-1.036.805-2.114 1.798-2.408l7.225-2.14c.993-.294 1.798.307 1.798 1.342v7.536c0 1.036-.805 2.114-1.798 2.408l-7.225 2.14c-.993.294-1.798-.307-1.798-1.342v-7.536Zm1.798-1.658c-.596.177-1.08.823-1.08 1.445v7.536c0 .621.484.982 1.08.805l7.225-2.14c.596-.177 1.079-.823 1.079-1.445v-7.536c0-.62-.483-.982-1.079-.805l-7.225 2.14Z"
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        d: "M23.954 26.32c0-1.083.842-2.21 1.881-2.518l7.404-2.193c.867-.257 1.57.268 1.57 1.172l-.753.223c0-.471-.366-.134-.817 0l-6.656 1.827c-.623.185-.784.92-.784 1.57l-.127 7.06c0 .557-.533 1.083 0 .925v.785c-.949.28-1.718-.294-1.718-1.283v-7.567ZM25.288 13.735c0-1.036.805-2.114 1.798-2.408l7.225-2.14c.993-.294 1.798.307 1.798 1.342v7.536c0 1.036-.805 2.114-1.798 2.408l-7.225 2.14c-.993.294-1.798-.307-1.798-1.342v-7.536Zm1.798-1.658c-.596.177-1.08.823-1.08 1.445v7.536c0 .62.484.982 1.08.805l7.225-2.14c.596-.177 1.079-.823 1.079-1.445v-7.536c0-.621-.483-.982-1.079-.805l-7.225 2.14Z"
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        d: "M23.954 13.15c0-1.083.842-2.21 1.881-2.518l7.372-2.184c.885-.262 1.602.274 1.602 1.196l-.753.223c0-.49-1.119-.083-1.588.056l-5.492 1.962c-.623.184-1.304.92-1.304 1.57v6.798c0 .556-.533 1.121 0 .963v.785c-.949.28-1.718-.293-1.718-1.283v-7.567Z"
                    })
                ]
            })
        ]
    });
var $f6afa0644eaaa4d5$export$2e2bcd8739ae039 = $f6afa0644eaaa4d5$var$SvgPlaceholder;




const $03107b67e34bed37$var$SvgRole = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 49,
        height: 48,
        viewBox: "0 0 49 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M.5 24c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24S.5 37.255.5 24Z",
                fill: "#EBEDFF"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M24.58 14.473a3.695 3.695 0 1 0 0 7.39 3.695 3.695 0 0 0 0-7.39Zm-2.528 3.694a2.528 2.528 0 1 1 5.056 0 2.528 2.528 0 0 1-5.056 0Z",
                fill: "#00245B"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M19.878 24.913a9.03 9.03 0 0 1 9.244 0c.55.328.888.922.888 1.564v6.468a.583.583 0 1 0 1.167 0v-6.468a2.987 2.987 0 0 0-1.458-2.566 10.217 10.217 0 0 0-1.147-.588 4.854 4.854 0 0 1 4.882.049c.235.14.38.393.38.666v5.211a.583.583 0 0 0 1.166 0v-5.21c0-.685-.36-1.32-.949-1.67a6.02 6.02 0 0 0-6.16 0l-.664.396a.6.6 0 0 0-.082.058 10.203 10.203 0 0 0-5.293 0 .58.58 0 0 0-.082-.058l-.663-.395a6.017 6.017 0 0 0-6.16 0c-.587.35-.947.983-.947 1.668v5.211a.583.583 0 1 0 1.167 0v-5.211c0-.273.143-.526.378-.666a4.85 4.85 0 0 1 4.881-.049c-.39.17-.773.366-1.145.588a2.987 2.987 0 0 0-1.458 2.566v6.468a.583.583 0 1 0 1.167 0v-6.468c0-.642.338-1.236.889-1.564Z",
                fill: "#00245B"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.73 18.564a2.342 2.342 0 1 1 4.685 0 2.342 2.342 0 0 1-4.684 0Zm2.343-1.176a1.175 1.175 0 1 0 0 2.35 1.175 1.175 0 0 0 0-2.35ZM33.269 18.564a2.342 2.342 0 1 0-4.685 0 2.342 2.342 0 0 0 4.685 0Zm-2.343-1.176a1.176 1.176 0 1 1 0 2.352 1.176 1.176 0 0 1 0-2.352Z",
                fill: "#00245B"
            })
        ]
    });
var $03107b67e34bed37$export$2e2bcd8739ae039 = $03107b67e34bed37$var$SvgRole;




const $3c2d13cb209e1859$var$SvgSalesforce = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M48 24c0 13.255-10.745 24-24 24S0 37.255 0 24 10.745 0 24 0s24 10.745 24 24Z",
                fill: "#00A1E0"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.159 14.61a6.015 6.015 0 0 1 4.35-1.866 6.076 6.076 0 0 1 5.296 3.139 7.315 7.315 0 0 1 2.988-.638 7.465 7.465 0 1 1-1.462 14.787 5.406 5.406 0 0 1-7.087 2.23 6.166 6.166 0 0 1-11.462-.278 5.688 5.688 0 0 1-1.178.123 5.759 5.759 0 0 1-5.725-5.79A5.816 5.816 0 0 1 9.742 21.3a6.665 6.665 0 0 1 11.418-6.68",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.878 24.445c-.022.057.008.068.015.078a2.096 2.096 0 0 0 1.223.358c.703 0 1.14-.375 1.14-.977v-.012c0-.557-.494-.76-.955-.905l-.06-.02c-.35-.113-.65-.212-.65-.442v-.011c0-.197.176-.344.448-.344.311.006.617.085.894.228 0 0 .068.044.093-.021l.144-.386a.066.066 0 0 0-.034-.08 1.993 1.993 0 0 0-1.01-.27h-.07a.982.982 0 0 0-1.095.95v.012c0 .589.497.78.96.911l.075.024c.338.104.63.196.63.431v.012c0 .218-.19.38-.495.38a1.663 1.663 0 0 1-.907-.26c-.049-.03-.078-.05-.116-.074a.056.056 0 0 0-.056-.01.056.056 0 0 0-.037.042l-.139.386m10.303 0c-.022.057.008.068.014.078a2.096 2.096 0 0 0 1.223.358c.703 0 1.141-.375 1.141-.977v-.012c0-.557-.49-.76-.955-.905l-.06-.02c-.35-.113-.651-.212-.651-.442v-.011c0-.197.177-.344.449-.344.311.007.617.085.893.228 0 0 .069.044.094-.021.013-.036.13-.35.142-.386a.065.065 0 0 0-.034-.08 1.993 1.993 0 0 0-1.009-.27h-.07a.983.983 0 0 0-1.094.95v.012c0 .589.496.78.96.911l.075.024c.339.104.63.196.63.431v.012c0 .218-.19.38-.496.38a1.659 1.659 0 0 1-.906-.26c-.05-.03-.079-.05-.117-.074a.06.06 0 0 0-.078.008.06.06 0 0 0-.014.024l-.139.386m7.036-1.178a1.46 1.46 0 0 1-.187.797.724.724 0 0 1-1.142 0 1.809 1.809 0 0 1 0-1.595.625.625 0 0 1 .57-.277.633.633 0 0 1 .572.277c.139.241.204.518.188.796m.59-.632a1.417 1.417 0 0 0-.268-.51 1.28 1.28 0 0 0-.452-.344 1.639 1.639 0 0 0-1.26 0c-.175.08-.33.197-.452.343-.123.15-.215.324-.268.51a2.35 2.35 0 0 0 0 1.264c.053.187.144.36.268.51.123.147.277.263.451.341a1.67 1.67 0 0 0 1.26 0c.174-.078.329-.194.451-.34.123-.15.215-.324.268-.51.115-.414.115-.85 0-1.264m4.826 1.614a.056.056 0 0 0-.075-.035c-.088.035-.18.061-.273.078a2.098 2.098 0 0 1-.322.023.896.896 0 0 1-.672-.253 1.12 1.12 0 0 1-.252-.803 1.247 1.247 0 0 1 .226-.774.77.77 0 0 1 .652-.288c.21-.003.42.027.621.09 0 0 .046.02.068-.041l.148-.401a.054.054 0 0 0-.018-.06.053.053 0 0 0-.02-.01 2.277 2.277 0 0 0-.392-.098 2.954 2.954 0 0 0-.442-.03 1.598 1.598 0 0 0-.654.127 1.354 1.354 0 0 0-.759.854c-.066.204-.1.418-.098.633-.021.426.119.844.392 1.17a1.484 1.484 0 0 0 1.16.437c.285.001.568-.049.835-.148a.052.052 0 0 0 .027-.032.054.054 0 0 0-.004-.041l-.148-.398Zm1.031-1.312c.019-.167.074-.327.162-.47a.633.633 0 0 1 .569-.288.616.616 0 0 1 .557.288.975.975 0 0 1 .13.47h-1.423.005Zm1.98-.417a1.247 1.247 0 0 0-.255-.465 1.161 1.161 0 0 0-.378-.288 1.45 1.45 0 0 0-.57-.115 1.563 1.563 0 0 0-.657.127 1.31 1.31 0 0 0-.458.35 1.436 1.436 0 0 0-.27.516c-.059.206-.088.42-.087.634-.002.215.029.43.09.636a1.276 1.276 0 0 0 .789.838c.231.083.476.123.722.117.346.018.69-.05 1.002-.2.022-.012.042-.033.016-.095l-.13-.364a.058.058 0 0 0-.075-.035 1.905 1.905 0 0 1-.817.147.815.815 0 0 1-.911-.895h1.992a.059.059 0 0 0 .058-.052 2.126 2.126 0 0 0-.06-.856h-.001Zm-17.907.417c.019-.167.074-.327.162-.47a.633.633 0 0 1 .569-.288.616.616 0 0 1 .557.288.977.977 0 0 1 .13.47h-1.423.005Zm1.98-.417a1.244 1.244 0 0 0-.255-.465 1.161 1.161 0 0 0-.379-.288 1.45 1.45 0 0 0-.57-.115 1.563 1.563 0 0 0-.656.127 1.31 1.31 0 0 0-.458.35 1.442 1.442 0 0 0-.27.516 2.24 2.24 0 0 0-.086.634c-.003.215.028.43.09.636a1.272 1.272 0 0 0 .788.838c.231.083.476.123.722.117.345.018.69-.05 1.002-.2.022-.012.042-.033.016-.095l-.13-.364a.057.057 0 0 0-.052-.039.06.06 0 0 0-.023.004 1.905 1.905 0 0 1-.817.147.815.815 0 0 1-.911-.895h1.992a.058.058 0 0 0 .058-.052 2.126 2.126 0 0 0-.06-.856h-.001Zm-6.28 1.716a.389.389 0 0 1-.114-.118.476.476 0 0 1-.06-.258.435.435 0 0 1 .177-.383.895.895 0 0 1 .577-.144c.181.003.361.018.54.046v.904c-.177.036-.357.06-.537.072a.893.893 0 0 1-.583-.117v-.002Zm.792-1.398a4.44 4.44 0 0 0-.31-.008c-.166-.001-.33.02-.49.063-.15.038-.29.104-.416.192a.928.928 0 0 0-.395.786c-.004.156.027.311.091.454.06.124.149.23.26.311.122.086.26.145.405.175.173.038.35.056.527.054.203 0 .405-.016.604-.05.168-.028.335-.06.5-.097.067-.016.14-.036.14-.036a.063.063 0 0 0 .046-.065v-1.816a1.111 1.111 0 0 0-.317-.878c-.26-.2-.585-.297-.913-.275a3.28 3.28 0 0 0-.533.05c-.216.038-.423.114-.613.223a.062.062 0 0 0-.018.08l.142.378a.05.05 0 0 0 .065.032 2.018 2.018 0 0 1 .9-.218.804.804 0 0 1 .49.13c.109.082.164.208.164.473v.084a7.132 7.132 0 0 0-.328-.039v-.002Zm16.014-1.024a.052.052 0 0 0 0-.043.054.054 0 0 0-.03-.03 1.755 1.755 0 0 0-.333-.056.987.987 0 0 0-.512.083.883.883 0 0 0-.336.248v-.242a.057.057 0 0 0-.034-.055.056.056 0 0 0-.023-.005h-.51a.056.056 0 0 0-.041.018.057.057 0 0 0-.016.042v2.964a.06.06 0 0 0 .06.06h.522a.06.06 0 0 0 .06-.06v-1.491a1.746 1.746 0 0 1 .067-.522.749.749 0 0 1 .173-.294.603.603 0 0 1 .246-.148.973.973 0 0 1 .485-.011c.039.004.06-.02.073-.053.034-.091.131-.364.15-.418",
                fill: "#00A1E0"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M27.362 20.441a1.678 1.678 0 0 0-.196-.049 1.55 1.55 0 0 0-.27-.02 1.139 1.139 0 0 0-.843.302 1.645 1.645 0 0 0-.4.902l-.024.135h-.452a.067.067 0 0 0-.066.058l-.075.414c-.005.04.012.064.065.063h.442l-.448 2.491c-.026.167-.066.33-.12.49-.03.102-.077.197-.138.284a.369.369 0 0 1-.182.14.735.735 0 0 1-.235.034.911.911 0 0 1-.16-.018.477.477 0 0 1-.107-.035.055.055 0 0 0-.042.001.054.054 0 0 0-.03.031 29.759 29.759 0 0 0-.152.428.06.06 0 0 0 .017.043.06.06 0 0 0 .019.013 1.201 1.201 0 0 0 .473.081c.166.003.331-.022.488-.075a.914.914 0 0 0 .368-.257 1.32 1.32 0 0 0 .259-.445c.078-.216.137-.439.175-.666l.448-2.536h.655a.068.068 0 0 0 .067-.058l.074-.413c.005-.04-.012-.065-.065-.064h-.638c.022-.153.057-.303.105-.449a.576.576 0 0 1 .14-.212.411.411 0 0 1 .166-.104.69.69 0 0 1 .213-.03.84.84 0 0 1 .266.041c.064.02.073 0 .086-.03l.152-.419a.053.053 0 0 0-.036-.069m-8.885 4.302a.057.057 0 0 1-.034.056.056.056 0 0 1-.023.005h-.528a.058.058 0 0 1-.057-.06v-4.248a.059.059 0 0 1 .016-.042.058.058 0 0 1 .041-.018h.528a.056.056 0 0 1 .041.018.058.058 0 0 1 .016.042v4.245",
                fill: "#00A1E0"
            })
        ]
    });
var $3c2d13cb209e1859$export$2e2bcd8739ae039 = $3c2d13cb209e1859$var$SvgSalesforce;




const $e4040e23594ddf7a$var$SvgSap = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        d: "M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24Z",
                        fill: "#1976D2"
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M33.888 17.304H29.56l.014 10.176-3.767-10.18h-3.736l-3.216 8.5c-.343-2.163-2.579-2.91-4.339-3.469-1.162-.372-2.396-.92-2.383-1.527.01-.5.66-.96 1.95-.891a7.058 7.058 0 0 1 3.156.85l1.5-2.611A11.65 11.65 0 0 0 13.856 17h-.01a5.931 5.931 0 0 0-4.314 1.575A3.634 3.634 0 0 0 8.5 21.09a3.378 3.378 0 0 0 1.481 3.01c.9.601 1.89 1.054 2.933 1.341 1.197.371 2.175.694 2.162 1.38-.007.252-.109.492-.284.674a1.898 1.898 0 0 1-1.389.436 5.957 5.957 0 0 1-3.57-1.018L8.5 29.558a9.262 9.262 0 0 0 4.71 1.23l.391-.003a5.878 5.878 0 0 0 3.717-1.175c.056-.044.106-.09.158-.136l-.163.845 3.65-.012.654-1.677c.743.247 1.521.37 2.303.365a7.24 7.24 0 0 0 2.25-.345l.457 1.657 6.55.006.016-3.823h1.392c3.369 0 5.36-1.714 5.36-4.59 0-3.2-1.937-4.596-6.057-4.596Zm-9.967 8.7a3.915 3.915 0 0 1-1.381-.242l1.366-4.312h.026l1.344 4.325c-.436.153-.894.23-1.355.229Zm10.22-2.479h-.95V20.05h.95c1.266 0 2.278.422 2.278 1.715 0 1.34-1.012 1.76-2.278 1.76Z",
                        fill: "#fff"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("defs", {
                children: /*#__PURE__*/ (0, $7XTbi$jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h48v48H0z"
                    })
                })
            })
        ]
    });
var $e4040e23594ddf7a$export$2e2bcd8739ae039 = $e4040e23594ddf7a$var$SvgSap;




const $6f063c714e5f6bd6$var$SvgSaviynt = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M-.18 24c0-13.255 10.745-24 24-24 13.254 0 24 10.745 24 24s-10.746 24-24 24c-13.255 0-24-10.745-24-24Z",
                        fill: "#10123D"
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        d: "M24.197 38.223c-2.346 0-4.424-.334-6.234-1.002-1.81-.668-3.24-1.699-4.29-3.093-1.051-1.395-1.621-3.129-1.712-5.322-.011-.285.13-.389.387-.389h6.086c.258 0 .445.13.445.39v2.443l4.94 3.468 4.942-3.468v-.786c0-.952-.292-1.417-.876-1.956-.584-.54-1.311-.936-2.31-1.24a38.133 38.133 0 0 0-2.935-.788c-1.144-.261-2.299-.525-3.448-.861a14.638 14.638 0 0 1-3.297-1.408 7.381 7.381 0 0 1-2.474-2.38c-.625-.966-.938-2.22-.938-3.764 0-1.686.429-3.152 1.286-4.397s2.09-2.205 3.701-2.88c1.611-.674 3.9-1.011 6.207-1.011 2.113 0 4.22.373 5.845.93 1.623.558 2.874 1.424 3.869 2.656 1.093 1.354 1.764 2.835 1.764 5.03 0 .274-.09.394-.386.394h-5.602c-.232 0-.406-.13-.406-.39v-1.648l-4.941-3.469-4.941 3.469s-.008.442 0 .813c.02.933.287 1.373.918 1.864.636.496 1.507.64 2.526.89 1.163.287 1.98.472 2.894.677 1.29.29 2.395.536 3.635.858 1.22.318 2.374.83 3.405 1.438 1.03.608 1.858 1.31 2.483 2.276.625.966.938 2.228.938 3.784 0 1.92-.461 3.538-1.382 4.855-.922 1.316-2.242 2.315-3.963 2.995-1.72.682-3.765 1.022-6.136 1.022Z",
                        fill: "#fff"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("defs", {
                children: /*#__PURE__*/ (0, $7XTbi$jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h48v48H0z"
                    })
                })
            })
        ]
    });
var $6f063c714e5f6bd6$export$2e2bcd8739ae039 = $6f063c714e5f6bd6$var$SvgSaviynt;




const $873eda64c54e759b$var$SvgServer = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 41,
        height: 41,
        viewBox: "0 0 41 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("rect", {
                x: 0.5,
                y: 0.586,
                width: 40,
                height: 40,
                rx: 20,
                fill: "#EBEDFF"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M12.537 12.288a.926.926 0 0 0-.926.926v4.514c0 .511.415.926.926.926h15.926a.926.926 0 0 0 .926-.926v-4.514a.926.926 0 0 0-.926-.926h-9.098a.556.556 0 0 1 0-1.111h9.098c1.125 0 2.037.912 2.037 2.037v4.514a2.037 2.037 0 0 1-2.037 2.037H12.537a2.037 2.037 0 0 1-2.037-2.037v-4.514c0-1.125.912-2.037 2.037-2.037h3.652a.555.555 0 1 1 0 1.11h-3.652Z",
                fill: "#254B86"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M14.348 14.915a.556.556 0 1 0 0 1.111h2.361a.556.556 0 0 0 0-1.11h-2.36ZM14.348 25.147a.556.556 0 1 0 0 1.11h2.361a.556.556 0 0 0 0-1.11h-2.36ZM19.013 15.47c0-.306.248-.555.555-.555h7.084a.556.556 0 1 1 0 1.111h-7.084a.556.556 0 0 1-.555-.555ZM19.568 25.147a.556.556 0 1 0 0 1.11h7.084a.556.556 0 0 0 0-1.11h-7.084Z",
                fill: "#254B86"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M29.389 27.96a.926.926 0 0 1-.926.925h-3.652a.555.555 0 1 0 0 1.111h3.652A2.037 2.037 0 0 0 30.5 27.96v-4.514a2.037 2.037 0 0 0-2.037-2.037H12.537a2.037 2.037 0 0 0-2.037 2.037v4.514c0 1.125.912 2.037 2.037 2.037h9.098a.556.556 0 0 0 0-1.11h-9.098a.926.926 0 0 1-.926-.927v-4.514c0-.511.415-.926.926-.926h15.926c.511 0 .926.415.926.926v4.514Z",
                fill: "#254B86"
            })
        ]
    });
var $873eda64c54e759b$export$2e2bcd8739ae039 = $873eda64c54e759b$var$SvgServer;




const $6db0c7d3dd0c426c$var$SvgUser = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        viewBox: "0 0 250 250",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M0 125C0 55.964 55.968 0 124.999 0 194.037 0 250 55.964 250 125s-55.963 125-125.001 125C55.968 250 0 194.036 0 125Z",
                fill: "#EBEDFF"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M122.616 60c-14.912 0-27 12.313-27 27.505 0 15.182 12.088 27.504 27 27.504 14.914 0 27.001-12.322 27.001-27.504C149.617 72.313 137.53 60 122.616 60Zm-20.997 27.505c0-11.818 9.396-21.4 20.997-21.4 11.601 0 20.998 9.582 20.998 21.4 0 11.808-9.397 21.39-20.998 21.39s-20.997-9.582-20.997-21.39Z",
                fill: "#00245B"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M85.581 139.195c22.438-13.615 50.391-13.615 72.828 0 4.707 2.851 7.588 8.022 7.588 13.596v14.156c0 1.687 1.341 3.053 2.997 3.053 1.665 0 3.006-1.366 3.006-3.053v-14.156c0-7.728-3.996-14.889-10.521-18.85-24.327-14.761-54.64-14.761-78.967 0C75.987 137.902 72 145.063 72 152.791v14.156c0 1.687 1.341 3.053 2.997 3.053s2.997-1.366 2.997-3.053v-14.156c0-5.574 2.88-10.745 7.587-13.596Z",
                fill: "#00245B"
            })
        ]
    });
var $6db0c7d3dd0c426c$export$2e2bcd8739ae039 = $6db0c7d3dd0c426c$var$SvgUser;




const $ef9438da78c6de61$var$SvgWebAppConsole = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 41,
        height: 41,
        viewBox: "0 0 41 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("rect", {
                x: 0.902,
                y: 0.253,
                width: 40,
                height: 40,
                rx: 20,
                fill: "#EBEDFF"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M15.43 15.036a.891.891 0 1 1-1.782 0 .891.891 0 0 1 1.782 0ZM17.274 15.927a.891.891 0 1 0 0-1.782.891.891 0 0 0 0 1.782ZM20.902 15.036a.891.891 0 1 1-1.782 0 .891.891 0 0 1 1.782 0Z",
                fill: "#254B86"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.902 13.743c0-1.125.912-2.037 2.037-2.037h15.926c1.125 0 2.037.912 2.037 2.037v13.02a2.037 2.037 0 0 1-2.037 2.037H12.94a2.037 2.037 0 0 1-2.037-2.038v-13.02Zm2.037-.926a.926.926 0 0 0-.925.926v3.34H29.79v-3.34a.926.926 0 0 0-.926-.926H12.94Zm-.925 13.945v-8.568H29.79v8.569a.926.926 0 0 1-.926.925H12.94a.926.926 0 0 1-.925-.925Z",
                fill: "#254B86"
            })
        ]
    });
var $ef9438da78c6de61$export$2e2bcd8739ae039 = $ef9438da78c6de61$var$SvgWebAppConsole;




const $a7518da02a1bec1a$var$SvgWindows = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsxs)("g", {
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        d: "M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24Z",
                        fill: "#00AAF2"
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        d: "M28.33 23.26c.765.004 1.529.008 2.293.008.766 0 1.532-.004 2.296-.008 1.524-.008 3.042-.016 4.544.008.636 0 .891-.182.855-.855a47.43 47.43 0 0 1-.009-2.147c.004-.357.009-.715.009-1.073.024-1.943.016-3.91.008-5.869a696.03 696.03 0 0 1-.008-2.919c0-.06.002-.122.005-.184.017-.404.033-.802-.676-.707-3.53.534-7.058 1.036-10.586 1.539l-3.497.499c-.6.109-.819.327-.819.964a437.52 437.52 0 0 1 0 9.788c0 .819.291.964 1 .964 1.529-.024 3.057-.016 4.585-.008ZM38.355 37.514v-6.058c0-.505-.002-1.01-.004-1.513-.007-1.51-.014-3.018.041-4.546 0-.673-.182-.964-.928-.964-4.566 0-9.152 0-13.809-.037-.71 0-.928.219-.928.928v.018c.037 3.25.073 6.483 0 9.698 0 .892.291 1.183 1.11 1.292 1.12.157 2.241.312 3.363.468 3.431.477 6.863.953 10.264 1.46.673.11.892-.036.892-.746ZM15.45 24.488h5.13c.546 0 .783.181.783.745V35.35c0 .582-.255.637-.783.582-3.402-.509-6.798-1-10.188-1.473-.673-.109-.892-.329-.892-1.039.037-2.692.037-5.385 0-8.132 0-.673.182-.855.855-.855 1.728.055 3.384.055 5.095.055ZM10.392 23.269h5.058c.829 0 1.672-.01 2.519-.018.845-.01 1.694-.019 2.538-.019.637 0 .928-.109.928-.818v-9.68c0-.636-.072-.89-.855-.782-3.39.546-6.786 1.037-10.188 1.474-.673.11-.855.327-.855.964.037 2.675.037 5.331 0 7.987 0 .673.218.892.854.892Z",
                        fill: "#fff"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("defs", {
                children: /*#__PURE__*/ (0, $7XTbi$jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h48v48H0z"
                    })
                })
            })
        ]
    });
var $a7518da02a1bec1a$export$2e2bcd8739ae039 = $a7518da02a1bec1a$var$SvgWindows;





const $f999930470b087cd$var$SIZES = {
    xxSmall: "xxSmall",
    xSmall: "xSmall",
    small: "small",
    medium: "medium",
    large: "large",
    xLarge: "xLarge",
    xxLarge: "xxLarge"
};
const $f999930470b087cd$var$logoToComponentMap = {
    account: "Account",
    ad: "AD",
    aws: "AWS",
    azure: "Azure",
    azure_ad: "AzureAD",
    certsaccount: "CertsAccount",
    entitlement: "Entitlement",
    gcp: "GCP",
    okta: "Okta",
    role: "Role",
    sap: "SAP",
    saviynt: "Saviynt",
    salesforce: "Salesforce",
    webappconsole: "WebAppConsole",
    application: "Application",
    database: "Database",
    server: "Server",
    user: "User",
    windows: "Windows",
    placeholder: "Placeholder"
};
function $f999930470b087cd$var$ApplicationIcon({ className: className, size: size, icon: icon, logo: logo, dataTestId: dataTestId }) {
    const classes = (0, $7XTbi$classnames)("ApplicationIcon", className, size && `ApplicationIcon--${size}`);
    if (icon) return /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
        className: classes,
        "data-testid": dataTestId,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
            kind: icon,
            color: "neutral-1000",
            className: "ApplicationIcon-icon"
        })
    });
    const logoName = logo ? $f999930470b087cd$var$logoToComponentMap[logo.toLowerCase()] : $f999930470b087cd$var$logoToComponentMap.placeholder;
    const Logo = $865682af0d4dfb4e$exports[logoName] || $865682af0d4dfb4e$exports.Placeholder;
    return /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
        className: classes,
        "data-testid": dataTestId,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)(Logo, {})
    });
}
$f999930470b087cd$var$ApplicationIcon.propTypes = {
    size: (0, $7XTbi$proptypes).oneOf(Object.values($f999930470b087cd$var$SIZES)),
    className: (0, $7XTbi$proptypes).string,
    icon: (0, $7XTbi$proptypes).oneOfType([
        (0, $7XTbi$proptypes).oneOf(Object.keys($836fa012cc7cf7fa$exports)),
        (0, $7XTbi$proptypes).element
    ]),
    logo: (0, $7XTbi$proptypes).oneOfType([
        (0, $7XTbi$proptypes).oneOf(Object.keys($f999930470b087cd$var$logoToComponentMap)),
        (0, $7XTbi$proptypes).string
    ]),
    dataTestId: (0, $7XTbi$proptypes).string
};
$f999930470b087cd$var$ApplicationIcon.defaultProps = {
    size: $f999930470b087cd$var$SIZES.small,
    className: null,
    icon: null,
    logo: null,
    dataTestId: null
};
var $f999930470b087cd$export$2e2bcd8739ae039 = $f999930470b087cd$var$ApplicationIcon;









const $f0cbdef548412548$var$SIZES = {
    xxSmall: "xxSmall",
    xSmall: "xSmall",
    small: "small",
    medium: "medium",
    large: "large",
    xLarge: "xLarge",
    xxLarge: "xxLarge"
};
function $f0cbdef548412548$var$Avatar({ alt: alt, src: src, size: size, children: children, className: className, dataTestId: dataTestId }) {
    const avatarClass = (0, $7XTbi$classnames)("Avatar", `Avatar--${size}`, className);
    return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
        className: avatarClass,
        dataTestId: dataTestId,
        children: src ? /*#__PURE__*/ (0, $7XTbi$jsx)("img", {
            className: "Avatar-img",
            alt: alt,
            src: src
        }) : children || /*#__PURE__*/ (0, $7XTbi$jsx)((0, $dccfce21d4968457$export$2e2bcd8739ae039), {})
    });
}
$f0cbdef548412548$var$Avatar.propTypes = {
    size: (0, $7XTbi$proptypes).oneOf(Object.values($f0cbdef548412548$var$SIZES)),
    src: (0, $7XTbi$proptypes).string,
    alt: (0, $7XTbi$proptypes).string,
    children: (0, $7XTbi$proptypes).node,
    className: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string
};
$f0cbdef548412548$var$Avatar.defaultProps = {
    size: $f0cbdef548412548$var$SIZES.small,
    alt: "",
    src: "",
    children: null,
    className: null,
    dataTestId: null
};
var $f0cbdef548412548$export$2e2bcd8739ae039 = $f0cbdef548412548$var$Avatar;









const $7897891fa90cac71$var$COLORS = {
    PRIMARY: "primary",
    SECONDARY: "secondary",
    NEUTRAL: "neutral",
    SUCCESS: "success",
    ERROR: "error",
    WARNING: "warning",
    INFO: "info"
};
const $7897891fa90cac71$var$KINDS = {
    DOT: "dot",
    NUMBER: "number"
};
const $7897891fa90cac71$var$SIZES = {
    SMALL: "small",
    MEDIUM: "medium"
};
const $7897891fa90cac71$var$STYLES = {
    FILLED: "filled",
    OUTLINED: "outlined"
};
function $7897891fa90cac71$var$Badge({ color: color, kind: kind, size: size, badgeStyle: // badgeStyle not style. Stlye is a default HTML prop and causes eslint warnings.
badgeStyle, number: number, className: className, dataTheme: dataTheme, dataTestId: dataTestId }) {
    const badgeClasses = (0, $7XTbi$classnames)("Badge", color && `Badge--${color}`, kind && `Badge--${kind}`, size && `Badge--${size}`, badgeStyle && `Badge--${badgeStyle}`, className);
    const getAbbreviateNumber = ()=>{
        const absNumber = Math.abs(number);
        if (absNumber >= 1e9) return `${(number / 1e9).toPrecision(3).replace(/\.0+$|(\.\d*[1-9])0+$/, "$1")}B`;
        if (absNumber >= 1e6) return `${(number / 1e6).toPrecision(3).replace(/\.0+$|(\.\d*[1-9])0+$/, "$1")}M`;
        if (absNumber >= 1e3) return `${(number / 1e3).toPrecision(3).replace(/\.0+$|(\.\d*[1-9])0+$/, "$1")}K`;
        return number.toString();
    };
    const isNumberValid = number !== null && number !== undefined;
    return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
        tag: "div",
        className: badgeClasses,
        dataTheme: dataTheme,
        dataTestId: dataTestId,
        children: isNumberValid && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
            tag: "div",
            className: "Badge-number",
            children: getAbbreviateNumber()
        })
    });
}
$7897891fa90cac71$var$Badge.propTypes = {
    color: (0, $7XTbi$proptypes).oneOf(Object.values($7897891fa90cac71$var$COLORS)),
    kind: (0, $7XTbi$proptypes).oneOf(Object.values($7897891fa90cac71$var$KINDS)),
    size: (0, $7XTbi$proptypes).oneOf(Object.values($7897891fa90cac71$var$SIZES)),
    badgeStyle: (0, $7XTbi$proptypes).oneOf(Object.values($7897891fa90cac71$var$STYLES)),
    number: (0, $7XTbi$proptypes).number,
    className: (0, $7XTbi$proptypes).string,
    dataTheme: (0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$49390a4605a2336a))),
    dataTestId: (0, $7XTbi$proptypes).string
};
$7897891fa90cac71$var$Badge.defaultProps = {
    kind: $7897891fa90cac71$var$KINDS.DOT,
    size: $7897891fa90cac71$var$SIZES.SMALL,
    color: $7897891fa90cac71$var$COLORS.PRIMARY,
    badgeStyle: $7897891fa90cac71$var$STYLES.FILLED,
    number: null,
    className: null,
    dataTheme: null,
    dataTestId: null
};
var $7897891fa90cac71$export$2e2bcd8739ae039 = $7897891fa90cac71$var$Badge;












const $9a0a9a7cc0462999$var$SIZES = {
    small: "small",
    medium: "medium",
    large: "large"
};
const $9a0a9a7cc0462999$var$KINDS = {
    filled: "filled",
    outlined: "outlined",
    subtle: "subtle",
    ghost: "ghost"
};
function $9a0a9a7cc0462999$var$Button({ dataTheme: dataTheme, size: size, kind: kind, isDisabled: isDisabled, isEnabled: isEnabled, isLoading: isLoading, isSuccess: isSuccess, onClick: onClick, children: children, leftIcon: leftIcon, rightIcon: rightIcon, type: type, LoaderComp: LoaderComp, loaderText: loaderText, className: className, dataTestId: dataTestId }) {
    const buttonClass = (0, $7XTbi$classnames)("Button", `Button-${kind}`, `Button--${size}`, isEnabled && `Button-${kind}--isEnabled`, isLoading && "Button--isLoading", isDisabled && "Button--isDisabled", isSuccess && `Button-${kind}--isSuccess`, !leftIcon && !children && `Button-square--${size}`, !rightIcon && !children && `Button-square--${size}`, className);
    const leftIconClass = (0, $7XTbi$classnames)("Button-left-icon", `Button-icons--${size}`);
    const childrenClass = (0, $7XTbi$classnames)("Button-children", !children && "Button-children-null", loaderText === "" && isLoading && "Button-children--isLoadingTextEmpty");
    const rightIconClass = (0, $7XTbi$classnames)("Button-right-icon", `Button-icons--${size}`);
    const buttonIconOverlayClass = (0, $7XTbi$classnames)("Button-overlay", `Button-overlay-${kind}`, isEnabled && `Button-overlay-${kind}--isEnabled`);
    return /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $553ba9ca1822b2c0$export$2e2bcd8739ae039), {
        dataTheme: dataTheme,
        type: type,
        tabIndex: isLoading || isSuccess ? -1 : 0,
        onClick: onClick,
        isDisabled: isDisabled,
        className: buttonClass,
        dataTestId: dataTestId,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                className: "Button-content-container",
                children: [
                    isLoading && (LoaderComp || /*#__PURE__*/ (0, $7XTbi$jsx)((0, $199d1dc410e8acb9$export$2e2bcd8739ae039), {
                        kind: "dots",
                        format: "inline",
                        color: "brand"
                    })),
                    leftIcon && !isLoading && /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                        className: leftIconClass,
                        children: isSuccess ? /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                            kind: "Check"
                        }) : leftIcon
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                        className: childrenClass,
                        children: [
                            !isLoading && !isSuccess && children,
                            isLoading && loaderText,
                            isSuccess && "Success"
                        ]
                    }),
                    rightIcon && /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                        className: rightIconClass,
                        children: rightIcon
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                className: buttonIconOverlayClass
            })
        ]
    });
}
$9a0a9a7cc0462999$var$Button.propTypes = {
    dataTheme: (0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$49390a4605a2336a))),
    kind: (0, $7XTbi$proptypes).oneOf(Object.values($9a0a9a7cc0462999$var$KINDS)),
    size: (0, $7XTbi$proptypes).oneOf(Object.values($9a0a9a7cc0462999$var$SIZES)),
    isEnabled: (0, $7XTbi$proptypes).bool,
    isDisabled: (0, $7XTbi$proptypes).bool,
    isLoading: (0, $7XTbi$proptypes).bool,
    isSuccess: (0, $7XTbi$proptypes).bool,
    onClick: (0, $7XTbi$proptypes).func,
    leftIcon: (0, $7XTbi$proptypes).element,
    children: (0, $7XTbi$proptypes).node,
    rightIcon: (0, $7XTbi$proptypes).element,
    type: (0, $7XTbi$proptypes).string,
    LoaderComp: (0, $7XTbi$proptypes).element,
    loaderText: (0, $7XTbi$proptypes).string,
    className: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string
};
$9a0a9a7cc0462999$var$Button.defaultProps = {
    dataTheme: null,
    kind: $9a0a9a7cc0462999$var$KINDS.filled,
    size: $9a0a9a7cc0462999$var$SIZES.medium,
    isEnabled: false,
    isDisabled: false,
    isLoading: false,
    isSuccess: false,
    onClick: ()=>{},
    leftIcon: null,
    children: null,
    rightIcon: null,
    type: "button",
    LoaderComp: null,
    loaderText: "Loading",
    className: null,
    dataTestId: null
};
var $9a0a9a7cc0462999$export$2e2bcd8739ae039 = $9a0a9a7cc0462999$var$Button;














const $6ce488bd8de8fd90$var$KINDS = {
    RECTANGLE: "rectangle",
    PILL: "pill",
    ICON: "icon"
};
const $6ce488bd8de8fd90$var$SIZES = {
    LARGE: "large",
    MEDIUM: "medium",
    SMALL: "small"
};
function $6ce488bd8de8fd90$var$ButtonSelect({ kind: kind, size: size, label: label, isOpen: isOpen, isDisabled: isDisabled, onClick: onClick, prefixIcon: prefixIcon, BadgeComp: BadgeComp, widthConfigs: widthConfigs, isIconSvgFilled: isIconSvgFilled, dataTheme: dataTheme, className: className, dataTestId: dataTestId }) {
    const buttonSelectClasses = (0, $7XTbi$classnames)("ButtonSelect", `ButtonSelect--${kind}`, `ButtonSelect--${size}`, isDisabled && "ButtonSelect--isDisabled", isOpen && `ButtonSelect--${kind}--isOpen`, BadgeComp && "ButtonSelect--hasBadge", className);
    const buttonSelectLabelClasses = (0, $7XTbi$classnames)("ButtonSelect-label");
    const buttonSelectOverlayClasses = (0, $7XTbi$classnames)("ButtonSelect-overlay", `ButtonSelect-overlay--${kind}`);
    // Size info:
    // RECTANGLE: LARGE and MEDIUM sizes are the same.
    // PILL: only has one size (MEDIUM)
    const getChevronIconSize = ()=>{
        switch(kind){
            case $6ce488bd8de8fd90$var$KINDS.PILL:
                return "xSmall";
            case $6ce488bd8de8fd90$var$KINDS.RECTANGLE:
                return size === $6ce488bd8de8fd90$var$SIZES.SMALL ? "xSmall" : "smallMedium";
            default:
                return $6ce488bd8de8fd90$var$SIZES.MEDIUM;
        }
    };
    const inlineStyle = widthConfigs && {
        minWidth: widthConfigs.minWidth,
        width: widthConfigs.width,
        maxWidth: widthConfigs.maxWidth
    };
    return /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $553ba9ca1822b2c0$export$2e2bcd8739ae039), {
        className: buttonSelectClasses,
        isDisabled: isDisabled,
        onClick: onClick,
        dataTestId: dataTestId,
        dataTheme: dataTheme,
        style: inlineStyle,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                className: "ButtonSelect-content-container",
                children: [
                    prefixIcon && /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                        className: (0, $7XTbi$classnames)(`ButtonSelect--${kind}-prefixIcon`, isIconSvgFilled && "ButtonSelect--isIconSvgFilled"),
                        children: prefixIcon
                    }),
                    kind === $6ce488bd8de8fd90$var$KINDS.ICON ? null : /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $7XTbi$Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5f880a93b57cab01$export$2e2bcd8739ae039), {
                                kind: "label",
                                className: buttonSelectLabelClasses,
                                children: label
                            }),
                            /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                                className: (0, $7XTbi$classnames)(`ButtonSelect--${kind}-chevron`, isIconSvgFilled && "ButtonSelect--isIconSvgFilled"),
                                children: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                                    kind: "ButtonSelectChevronUp",
                                    size: getChevronIconSize(),
                                    rotate: !isOpen ? "180" : null
                                })
                            })
                        ]
                    }),
                    BadgeComp
                ]
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                className: buttonSelectOverlayClasses
            })
        ]
    });
}
$6ce488bd8de8fd90$var$ButtonSelect.propTypes = {
    kind: (0, $7XTbi$proptypes).oneOf(Object.values($6ce488bd8de8fd90$var$KINDS)),
    size: (0, $7XTbi$proptypes).oneOf(Object.values($6ce488bd8de8fd90$var$SIZES)),
    label: (0, $7XTbi$proptypes).oneOfType([
        (0, $7XTbi$proptypes).string,
        (0, $7XTbi$proptypes).element
    ]),
    isOpen: (0, $7XTbi$proptypes).bool,
    isDisabled: (0, $7XTbi$proptypes).bool,
    onClick: (0, $7XTbi$proptypes).func,
    prefixIcon: (0, $7XTbi$proptypes).element,
    BadgeComp: (0, $7XTbi$proptypes).element,
    widthConfigs: (0, $7XTbi$proptypes).shape({
        minWidth: (0, $7XTbi$proptypes).string || null,
        width: (0, $7XTbi$proptypes).string || null,
        maxWidth: (0, $7XTbi$proptypes).string || null
    }),
    isIconSvgFilled: (0, $7XTbi$proptypes).bool,
    dataTheme: (0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$49390a4605a2336a))),
    className: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string
};
$6ce488bd8de8fd90$var$ButtonSelect.defaultProps = {
    kind: $6ce488bd8de8fd90$var$KINDS.RECTANGLE,
    size: $6ce488bd8de8fd90$var$SIZES.MEDIUM,
    label: null,
    isOpen: false,
    isDisabled: false,
    onClick: ()=>{},
    prefixIcon: null,
    BadgeComp: null,
    widthConfigs: null,
    isIconSvgFilled: true,
    dataTheme: null,
    className: null,
    dataTestId: null
};
var $6ce488bd8de8fd90$export$2e2bcd8739ae039 = $6ce488bd8de8fd90$var$ButtonSelect;
















// eslint-disable-next-line import/prefer-default-export
const $8eee7a4b0ef1a5aa$export$57732b6846a8df7c = {
    small: "small",
    medium: "medium",
    large: "large",
    small_width: 16,
    small_height: 16,
    medium_width: 20,
    medium_height: 20,
    large_width: 24,
    large_height: 24
};



function $5cd0de390a6b8fe6$var$CheckboxCore({ id: id, name: name, size: size, isChecked: isChecked, isDisabled: isDisabled, isIndeterminate: isIndeterminate, handleChange: handleChange, shouldStopCorePropagation: shouldStopCorePropagation, tabIndex: tabIndex, dataTestId: dataTestId }) {
    let checkboxContent;
    let classes = (0, $7XTbi$classnames)("Checkbox-icon", `Checkbox-icon--${size}`, isChecked && "Checkbox-icon--checked", isDisabled && "Checkbox-icon--disabled", isIndeterminate && "Checkbox-icon--indeterminate");
    if (isIndeterminate && isDisabled) checkboxContent = /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
        kind: "CheckboxIndeterminateDisabled",
        color: null,
        className: classes
    });
    else if (isIndeterminate) checkboxContent = /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
        kind: "CheckboxIndeterminate",
        color: null,
        className: classes
    });
    else if (isDisabled && isChecked) checkboxContent = /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
        kind: "CheckboxCheckedDisabled",
        color: null,
        className: classes
    });
    else if (isDisabled) checkboxContent = /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
        kind: "CheckboxDisabled",
        color: null,
        className: classes
    });
    else if (isChecked) checkboxContent = /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
        kind: "CheckboxChecked",
        color: null,
        className: classes
    });
    else checkboxContent = /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
        kind: "Checkbox",
        color: null,
        className: classes += " Checkbox-icon--default"
    });
    const handleOnclick = (e)=>{
        if (shouldStopCorePropagation) e.stopPropagation();
    };
    return /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
        className: "Checkbox--core",
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("input", {
                id: id,
                type: "checkbox",
                name: name,
                disabled: isDisabled,
                className: "Checkbox-input",
                "data-testid": dataTestId,
                tabIndex: isDisabled ? "-1" : tabIndex,
                checked: isChecked,
                onChange: handleChange,
                onClick: (e)=>handleOnclick(e)
            }),
            checkboxContent,
            !isChecked && !isDisabled && !isIndeterminate && /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $7XTbi$Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                        kind: "CheckboxHover",
                        color: null,
                        className: (0, $7XTbi$classnames)("Checkbox-icon", "Checkbox-icon--hover", `Checkbox-icon--${size}`)
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                        kind: "CheckboxActive",
                        color: null,
                        className: (0, $7XTbi$classnames)("Checkbox-icon", "Checkbox-icon--active", `Checkbox-icon--${size}`)
                    })
                ]
            })
        ]
    });
}
$5cd0de390a6b8fe6$var$CheckboxCore.propTypes = {
    id: (0, $7XTbi$proptypes).string,
    name: (0, $7XTbi$proptypes).string,
    size: (0, $7XTbi$proptypes).oneOf([
        (0, $8eee7a4b0ef1a5aa$export$57732b6846a8df7c).small,
        (0, $8eee7a4b0ef1a5aa$export$57732b6846a8df7c).medium,
        (0, $8eee7a4b0ef1a5aa$export$57732b6846a8df7c).large
    ]),
    isChecked: (0, $7XTbi$proptypes).bool,
    isDisabled: (0, $7XTbi$proptypes).bool,
    isIndeterminate: (0, $7XTbi$proptypes).bool,
    handleChange: (0, $7XTbi$proptypes).func,
    shouldStopCorePropagation: (0, $7XTbi$proptypes).bool,
    tabIndex: (0, $7XTbi$proptypes).oneOfType([
        (0, $7XTbi$proptypes).number,
        (0, $7XTbi$proptypes).string
    ]),
    dataTestId: (0, $7XTbi$proptypes).string
};
$5cd0de390a6b8fe6$var$CheckboxCore.defaultProps = {
    id: null,
    name: null,
    size: (0, $8eee7a4b0ef1a5aa$export$57732b6846a8df7c).medium,
    isChecked: undefined,
    isDisabled: false,
    isIndeterminate: false,
    handleChange: null,
    shouldStopCorePropagation: false,
    tabIndex: "0",
    dataTestId: ""
};
var $5cd0de390a6b8fe6$export$2e2bcd8739ae039 = $5cd0de390a6b8fe6$var$CheckboxCore;



const $6f2a5bc47790b485$var$SIZES = {
    small: "small",
    medium: "medium",
    large: "large"
};
// TODO: A form label must be associated with a control. Needs to be updated in all Checkboxes.
function $6f2a5bc47790b485$var$CheckboxBase({ name: name, size: size, isChecked: isChecked, isDisabled: isDisabled, isIndeterminate: isIndeterminate, handleChange: handleChange, shouldStopCorePropagation: shouldStopCorePropagation, showHoverEffect: showHoverEffect, tabIndex: tabIndex, dataTestId: dataTestId, error: error }) {
    const checkboxBaseClasses = (0, $7XTbi$classnames)("Checkbox", "Checkbox--base", isDisabled && "Checkbox--disabled", !showHoverEffect && "Checkbox--hoverEffectDisabled", error && "Checkbox--error");
    return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
        className: checkboxBaseClasses,
        dataTestId: dataTestId,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("label", {
            className: "Checkbox-label",
            children: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5cd0de390a6b8fe6$export$2e2bcd8739ae039), {
                name: name,
                size: size,
                isChecked: isChecked,
                isDisabled: isDisabled,
                isIndeterminate: isIndeterminate,
                handleChange: handleChange,
                shouldStopCorePropagation: shouldStopCorePropagation,
                tabIndex: isDisabled ? "-1" : tabIndex,
                dataTestId: dataTestId
            })
        })
    });
}
$6f2a5bc47790b485$var$CheckboxBase.propTypes = {
    name: (0, $7XTbi$proptypes).string,
    size: (0, $7XTbi$proptypes).oneOf([
        $6f2a5bc47790b485$var$SIZES.small,
        $6f2a5bc47790b485$var$SIZES.medium,
        $6f2a5bc47790b485$var$SIZES.large
    ]),
    isChecked: (0, $7XTbi$proptypes).bool,
    isDisabled: (0, $7XTbi$proptypes).bool,
    isIndeterminate: (0, $7XTbi$proptypes).bool,
    handleChange: (0, $7XTbi$proptypes).func,
    shouldStopCorePropagation: (0, $7XTbi$proptypes).bool,
    showHoverEffect: (0, $7XTbi$proptypes).bool,
    tabIndex: (0, $7XTbi$proptypes).oneOfType([
        (0, $7XTbi$proptypes).number,
        (0, $7XTbi$proptypes).string
    ]),
    error: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string
};
$6f2a5bc47790b485$var$CheckboxBase.defaultProps = {
    name: null,
    size: $6f2a5bc47790b485$var$SIZES.medium,
    isChecked: undefined,
    isDisabled: false,
    isIndeterminate: false,
    handleChange: null,
    shouldStopCorePropagation: false,
    showHoverEffect: true,
    tabIndex: 0,
    error: null,
    dataTestId: null
};
var $6f2a5bc47790b485$export$2e2bcd8739ae039 = $6f2a5bc47790b485$var$CheckboxBase;










function $536cb93ffe633380$var$CheckboxCard({ name: name, label: label, size: size, title: title, icon: icon, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, handleChange: handleChange, showHoverEffect: showHoverEffect, showHoverLabel: showHoverLabel, dataTestId: dataTestId, error: error }) {
    const classes = (0, $7XTbi$classnames)("Checkbox", "Checkbox-card", isDisabled && "Checkbox--disabled", icon && "Checkbox--withIcon", isChecked && "Checkbox--checked", !showHoverEffect && "Checkbox--hoverEffectDisabled", error && "Checkbox--error");
    const renderedError = error && /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
        className: "Checkbox-errorWrapper",
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                kind: "alertCritical",
                color: "critical-700",
                size: "xxxSmall"
            }),
            error
        ]
    });
    const renderedLabelTitleIcon = (title || label) && /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
        className: "Checkbox-iconTextWrapper",
        children: [
            icon && /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                className: "Checkbox-iconWrapper",
                children: icon
            }),
            /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                className: "Checkbox-textWrapper",
                children: [
                    /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                        className: "Checkbox-titleText",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                        className: "Checkbox-labelText",
                        title: showHoverLabel ? label : undefined,
                        children: label
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
        className: "Checkbox-container",
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                className: classes,
                children: [
                    /*#__PURE__*/ (0, $7XTbi$jsxs)("label", {
                        className: "Checkbox-label",
                        children: [
                            renderedLabelTitleIcon,
                            /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5cd0de390a6b8fe6$export$2e2bcd8739ae039), {
                                name: name,
                                size: size,
                                isChecked: isChecked,
                                isDisabled: isDisabled,
                                isIndeterminate: isIndeterminate,
                                handleChange: handleChange,
                                dataTestId: dataTestId
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                        className: "Checkbox-overlay"
                    })
                ]
            }),
            renderedError
        ]
    });
}
$536cb93ffe633380$var$CheckboxCard.propTypes = {
    name: (0, $7XTbi$proptypes).string,
    size: (0, $7XTbi$proptypes).oneOf([
        (0, $8eee7a4b0ef1a5aa$export$57732b6846a8df7c).small,
        (0, $8eee7a4b0ef1a5aa$export$57732b6846a8df7c).medium,
        (0, $8eee7a4b0ef1a5aa$export$57732b6846a8df7c).large
    ]),
    title: (0, $7XTbi$proptypes).string,
    label: (0, $7XTbi$proptypes).string,
    icon: (0, $7XTbi$proptypes).element,
    isChecked: (0, $7XTbi$proptypes).bool,
    isDisabled: (0, $7XTbi$proptypes).bool,
    isIndeterminate: (0, $7XTbi$proptypes).bool,
    handleChange: (0, $7XTbi$proptypes).func,
    showHoverEffect: (0, $7XTbi$proptypes).bool,
    showHoverLabel: (0, $7XTbi$proptypes).bool,
    error: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string
};
$536cb93ffe633380$var$CheckboxCard.defaultProps = {
    name: null,
    size: (0, $8eee7a4b0ef1a5aa$export$57732b6846a8df7c).medium,
    title: null,
    label: null,
    icon: null,
    isChecked: false,
    isDisabled: false,
    isIndeterminate: false,
    handleChange: null,
    showHoverEffect: false,
    showHoverLabel: true,
    error: null,
    dataTestId: null
};
var $536cb93ffe633380$export$2e2bcd8739ae039 = $536cb93ffe633380$var$CheckboxCard;










/*
https://www.figma.com/file/KACl1WLOzsyCUU5kKqp1Ep/Saviynt-Design-System-Component-Library?type=design&node-id=16463-151491
*/ const $3c49893d725b8480$var$TEXT_POSITIONS = {
    BEFORE: "before",
    AFTER: "after"
};
function $3c49893d725b8480$var$CheckboxSimpleText({ name: name, size: size, label: label, isDisabled: isDisabled, isIndeterminate: isIndeterminate, textPosition: textPosition, isChecked: isChecked, handleChange: handleChange, showHoverEffect: showHoverEffect, showHoverLabel: showHoverLabel, tabIndex: tabIndex, dataTestId: dataTestId }) {
    const checkboxId = `checkbox-${(0, $7XTbi$getRandomString)(9)}`; // 9 is my random pick for the length.
    const classes = (0, $7XTbi$classnames)("Checkbox", "Checkbox--simpleText", isDisabled && "Checkbox--disabled", isChecked && " Checkbox--checked", !showHoverEffect && "Checkbox--hoverEffectDisabled");
    const labelTextClass = `Checkbox-labelText Checkbox-labelText--${textPosition}`;
    const renderedLabel = /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
        className: "Checkbox-iconTextWrapper",
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
            className: labelTextClass,
            title: showHoverLabel ? label : undefined,
            children: label
        })
    });
    return /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
        className: "Checkbox-container",
        "data-testid": dataTestId,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
            className: classes,
            children: /*#__PURE__*/ (0, $7XTbi$jsxs)("label", {
                className: "Checkbox-label",
                htmlFor: checkboxId,
                children: [
                    textPosition === $3c49893d725b8480$var$TEXT_POSITIONS.BEFORE && renderedLabel,
                    /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5cd0de390a6b8fe6$export$2e2bcd8739ae039), {
                        id: checkboxId,
                        name: name,
                        size: size,
                        isChecked: isChecked,
                        isDisabled: isDisabled,
                        isIndeterminate: isIndeterminate,
                        handleChange: handleChange,
                        dataTestId: dataTestId,
                        tabIndex: isDisabled ? -1 : tabIndex
                    }),
                    textPosition === $3c49893d725b8480$var$TEXT_POSITIONS.AFTER && renderedLabel
                ]
            })
        })
    });
}
$3c49893d725b8480$var$CheckboxSimpleText.propTypes = {
    name: (0, $7XTbi$proptypes).string,
    size: (0, $7XTbi$proptypes).oneOf([
        (0, $8eee7a4b0ef1a5aa$export$57732b6846a8df7c).small,
        (0, $8eee7a4b0ef1a5aa$export$57732b6846a8df7c).medium,
        (0, $8eee7a4b0ef1a5aa$export$57732b6846a8df7c).large
    ]),
    label: (0, $7XTbi$proptypes).string.isRequired,
    textPosition: (0, $7XTbi$proptypes).oneOf(Object.values($3c49893d725b8480$var$TEXT_POSITIONS)),
    isDisabled: (0, $7XTbi$proptypes).bool,
    isChecked: (0, $7XTbi$proptypes).bool,
    isIndeterminate: (0, $7XTbi$proptypes).bool,
    handleChange: (0, $7XTbi$proptypes).func,
    showHoverEffect: (0, $7XTbi$proptypes).bool,
    showHoverLabel: (0, $7XTbi$proptypes).bool,
    dataTestId: (0, $7XTbi$proptypes).string,
    tabIndex: (0, $7XTbi$proptypes).oneOfType([
        (0, $7XTbi$proptypes).string,
        (0, $7XTbi$proptypes).number
    ])
};
$3c49893d725b8480$var$CheckboxSimpleText.defaultProps = {
    name: null,
    size: (0, $8eee7a4b0ef1a5aa$export$57732b6846a8df7c).medium,
    textPosition: $3c49893d725b8480$var$TEXT_POSITIONS.AFTER,
    isDisabled: false,
    isChecked: undefined,
    isIndeterminate: false,
    showHoverEffect: false,
    showHoverLabel: false,
    handleChange: null,
    dataTestId: null,
    tabIndex: 0
};
var $3c49893d725b8480$export$2e2bcd8739ae039 = $3c49893d725b8480$var$CheckboxSimpleText;










function $61b39899b304676f$var$CheckboxWithText({ name: name, size: size, label: label, title: title, icon: icon, isDisabled: isDisabled, isIndeterminate: isIndeterminate, textPosition: textPosition, isChecked: isChecked, handleChange: handleChange, showHoverEffect: showHoverEffect, showHoverLabel: showHoverLabel, dataTestId: dataTestId, error: error, tabIndex: tabIndex }) {
    const classes = (0, $7XTbi$classnames)("Checkbox", "Checkbox--withText", isDisabled && "Checkbox--disabled", icon && "Checkbox--withIcon", isChecked && " Checkbox--checked", !showHoverEffect && "Checkbox--hoverEffectDisabled", error && "Checkbox--error");
    const renderedError = error && /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
        className: "Checkbox-errorWrapper",
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                kind: "alertCritical",
                color: "critical-700",
                size: "xxxSmall"
            }),
            error
        ]
    });
    const labelTextClass = `Checkbox-labelText Checkbox-labelText--${textPosition}`;
    const titleTextClass = `Checkbox-titleText Checkbox-titleText--${textPosition}`;
    const renderedLabelAndTitle = (title || label) && /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
        className: "Checkbox-iconTextWrapper",
        children: [
            icon && /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                className: "Checkbox-iconWrapper",
                children: icon
            }),
            title ? /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                className: titleTextClass,
                children: title
            }) : label && /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                className: labelTextClass,
                title: showHoverLabel ? label : undefined,
                children: label
            })
        ]
    });
    return /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
        className: "Checkbox-container",
        "data-testid": dataTestId,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                className: classes,
                children: [
                    /*#__PURE__*/ (0, $7XTbi$jsxs)("label", {
                        className: "Checkbox-label",
                        children: [
                            textPosition === "before" && renderedLabelAndTitle,
                            /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5cd0de390a6b8fe6$export$2e2bcd8739ae039), {
                                name: name,
                                size: size,
                                isChecked: isChecked,
                                isDisabled: isDisabled,
                                isIndeterminate: isIndeterminate,
                                handleChange: handleChange,
                                dataTestId: dataTestId,
                                tabIndex: isDisabled ? -1 : tabIndex
                            }),
                            textPosition === "after" && renderedLabelAndTitle
                        ]
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                        className: "Checkbox-overlay"
                    })
                ]
            }),
            renderedError
        ]
    });
}
$61b39899b304676f$var$CheckboxWithText.propTypes = {
    name: (0, $7XTbi$proptypes).string,
    size: (0, $7XTbi$proptypes).oneOf([
        (0, $8eee7a4b0ef1a5aa$export$57732b6846a8df7c).small,
        (0, $8eee7a4b0ef1a5aa$export$57732b6846a8df7c).medium,
        (0, $8eee7a4b0ef1a5aa$export$57732b6846a8df7c).large
    ]),
    title: (0, $7XTbi$proptypes).string,
    label: (0, $7XTbi$proptypes).string,
    textPosition: (0, $7XTbi$proptypes).oneOf([
        "before",
        "after"
    ]),
    icon: (0, $7XTbi$proptypes).element,
    isDisabled: (0, $7XTbi$proptypes).bool,
    isChecked: (0, $7XTbi$proptypes).bool,
    isIndeterminate: (0, $7XTbi$proptypes).bool,
    handleChange: (0, $7XTbi$proptypes).func,
    showHoverEffect: (0, $7XTbi$proptypes).bool,
    showHoverLabel: (0, $7XTbi$proptypes).bool,
    error: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string,
    tabIndex: (0, $7XTbi$proptypes).oneOfType([
        (0, $7XTbi$proptypes).string,
        (0, $7XTbi$proptypes).number
    ])
};
$61b39899b304676f$var$CheckboxWithText.defaultProps = {
    name: null,
    size: (0, $8eee7a4b0ef1a5aa$export$57732b6846a8df7c).medium,
    title: null,
    label: null,
    textPosition: "before",
    icon: null,
    isDisabled: false,
    isChecked: undefined,
    isIndeterminate: false,
    showHoverEffect: false,
    showHoverLabel: false,
    handleChange: null,
    error: null,
    dataTestId: null,
    tabIndex: 0
};
var $61b39899b304676f$export$2e2bcd8739ae039 = $61b39899b304676f$var$CheckboxWithText;


const $ea632b95ffcf8459$var$TEXT_POSITIONS = {
    BEFORE: "before",
    AFTER: "after"
};
const $ea632b95ffcf8459$var$KINDS = {
    base: "base",
    simpleText: "simpleText",
    text: "text",
    card: "card"
};
const $ea632b95ffcf8459$var$SIZES = {
    small: "small",
    medium: "medium",
    large: "large"
};
/**
 * Icon props should have these colors:
 * - neutral-600 (disabled)
 * - navy-900 (all other states)
 */ function $ea632b95ffcf8459$var$Checkbox(props) {
    const { kind: kind, name: name, size: size, label: label, title: title, icon: icon, isDisabled: isDisabled, isIndeterminate: isIndeterminate, textPosition: textPosition, isChecked: isChecked, onChange: onChange, shouldStopCorePropagation: shouldStopCorePropagation, showHoverEffect: showHoverEffect, tabIndex: tabIndex, showHoverLabel: showHoverLabel, dataTestId: dataTestId, error: error } = props;
    const handleChange = (e)=>{
        onChange?.(e);
    };
    switch(kind){
        case $ea632b95ffcf8459$var$KINDS.text:
            return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $61b39899b304676f$export$2e2bcd8739ae039), {
                name: name,
                size: size,
                label: label,
                title: title,
                icon: icon,
                isChecked: isChecked,
                isDisabled: isDisabled,
                isIndeterminate: isIndeterminate,
                textPosition: textPosition,
                handleChange: handleChange,
                showHoverEffect: showHoverEffect,
                showHoverLabel: showHoverLabel,
                dataTestId: dataTestId,
                error: error
            });
        case $ea632b95ffcf8459$var$KINDS.simpleText:
            return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $3c49893d725b8480$export$2e2bcd8739ae039), {
                name: name,
                size: size,
                label: label,
                isChecked: isChecked,
                isDisabled: isDisabled,
                isIndeterminate: isIndeterminate,
                textPosition: textPosition,
                handleChange: handleChange,
                showHoverEffect: showHoverEffect,
                showHoverLabel: showHoverLabel,
                tabIndex: tabIndex,
                dataTestId: dataTestId
            });
        case $ea632b95ffcf8459$var$KINDS.card:
            return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $536cb93ffe633380$export$2e2bcd8739ae039), {
                name: name,
                label: label,
                size: size,
                title: title,
                icon: icon,
                isDisabled: isDisabled,
                isChecked: isChecked,
                isIndeterminate: isIndeterminate,
                handleChange: handleChange,
                showHoverEffect: showHoverEffect,
                showHoverLabel: showHoverLabel,
                dataTestId: dataTestId,
                error: error
            });
        case $ea632b95ffcf8459$var$KINDS.base:
            return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $6f2a5bc47790b485$export$2e2bcd8739ae039), {
                name: name,
                size: size,
                isChecked: isChecked,
                isDisabled: isDisabled,
                isIndeterminate: isIndeterminate,
                handleChange: handleChange,
                shouldStopCorePropagation: shouldStopCorePropagation,
                showHoverEffect: showHoverEffect,
                tabIndex: isDisabled ? "-1" : tabIndex,
                dataTestId: dataTestId,
                error: error
            });
        default:
            return null;
    }
}
$ea632b95ffcf8459$var$Checkbox.propTypes = {
    name: (0, $7XTbi$proptypes).string,
    kind: (0, $7XTbi$proptypes).oneOf(Object.values($ea632b95ffcf8459$var$KINDS)),
    size: (0, $7XTbi$proptypes).oneOf([
        $ea632b95ffcf8459$var$SIZES.small,
        $ea632b95ffcf8459$var$SIZES.medium,
        $ea632b95ffcf8459$var$SIZES.large
    ]),
    isChecked: (0, $7XTbi$proptypes).bool,
    isDisabled: (0, $7XTbi$proptypes).bool,
    isIndeterminate: (0, $7XTbi$proptypes).bool,
    onChange: (0, $7XTbi$proptypes).func,
    shouldStopCorePropagation: (0, $7XTbi$proptypes).bool,
    title: (0, $7XTbi$proptypes).string,
    label: (0, $7XTbi$proptypes).string,
    textPosition: (0, $7XTbi$proptypes).oneOf(Object.values($ea632b95ffcf8459$var$TEXT_POSITIONS)),
    icon: (0, $7XTbi$proptypes).element,
    showHoverEffect: (0, $7XTbi$proptypes).bool,
    tabIndex: (0, $7XTbi$proptypes).oneOfType([
        (0, $7XTbi$proptypes).number,
        (0, $7XTbi$proptypes).string
    ]),
    showHoverLabel: (0, $7XTbi$proptypes).bool,
    error: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string
};
$ea632b95ffcf8459$var$Checkbox.defaultProps = {
    name: null,
    kind: $ea632b95ffcf8459$var$KINDS.text,
    textPosition: $ea632b95ffcf8459$var$TEXT_POSITIONS.BEFORE,
    size: $ea632b95ffcf8459$var$SIZES.medium,
    isChecked: undefined,
    isDisabled: false,
    isIndeterminate: false,
    onChange: ()=>{},
    shouldStopCorePropagation: false,
    title: null,
    label: null,
    icon: null,
    showHoverEffect: false,
    tabIndex: 0,
    showHoverLabel: false,
    error: null,
    dataTestId: null
};
var $ea632b95ffcf8459$export$2e2bcd8739ae039 = $ea632b95ffcf8459$var$Checkbox;







/**
 * ##### Every Checkbox requires a unique name prop.
 */ function $1c832d45f8fbd688$var$CheckboxGroup({ checkboxes: checkboxes, groupLabel: groupLabel, dataTestId: dataTestId, error: error }) {
    const renderedCheckboxGroup = /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
        className: "CheckboxGroup-container",
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsxs)("fieldset", {
                className: "CheckboxGroup",
                "data-testid": dataTestId,
                children: [
                    /*#__PURE__*/ (0, $7XTbi$jsx)("legend", {
                        className: "CheckboxGroup-legend",
                        children: groupLabel
                    }),
                    checkboxes.map((checkbox)=>/*#__PURE__*/ (0, $7XTbi$jsx)((0, $7XTbi$react).Fragment, {
                            children: checkbox
                        }, checkbox.name))
                ]
            }),
            error && /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                className: "CheckboxGroup-error",
                children: [
                    /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                        kind: "AlertCritical",
                        color: "critical-600",
                        size: "xxxSmall"
                    }),
                    error
                ]
            })
        ]
    });
    return renderedCheckboxGroup;
}
$1c832d45f8fbd688$var$CheckboxGroup.propTypes = {
    checkboxes: (0, $7XTbi$proptypes).arrayOf((0, $7XTbi$proptypes).element).isRequired,
    groupLabel: (0, $7XTbi$proptypes).string,
    error: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string
};
$1c832d45f8fbd688$var$CheckboxGroup.defaultProps = {
    groupLabel: null,
    error: null,
    dataTestId: null
};
var $1c832d45f8fbd688$export$2e2bcd8739ae039 = $1c832d45f8fbd688$var$CheckboxGroup;









const $b7a25e567a023755$var$SIZES = {
    xxSmall: "xxSmall",
    xSmall: "xSmall",
    small: "small",
    medium: "medium",
    large: "large"
};
const $b7a25e567a023755$var$KINDS = {
    outlined: "outlined",
    boldFilled: "boldFilled",
    subtleFilled: "subtleFilled"
};
const $b7a25e567a023755$var$COLORS = {
    neutral: "neutral",
    brandPrimary: "brandPrimary",
    brandSecondary: "brandSecondary",
    critical: "critical",
    success: "success",
    warning: "warning",
    info: "info"
};
function $b7a25e567a023755$var$Chip({ isDarkMode: isDarkMode, size: size, kind: kind, color: color, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, label: label, leftIcon: leftIcon, rightIcon: rightIcon, className: className, dataTestId: dataTestId }) {
    const chipClass = (0, $7XTbi$classnames)("Chip", `Chip-${kind}`, `Chip--${size}`, `Chip--${color}`, isSelected && `Chip-${kind}--isSelected Chip--isSelected`, isDisabled && `Chip--isDisabled Chip-${kind}--isDisabled `, className);
    const chipContentClass = (0, $7XTbi$classnames)("Chip-content-container", `Chip-content-container--${size}`);
    const leftIconClass = (0, $7XTbi$classnames)("Chip-left-icon", `Chip-icons--${size}`);
    const labelClass = (0, $7XTbi$classnames)(`Chip-label`, `Chip-label--${size}`);
    const rightIconClass = (0, $7XTbi$classnames)("Chip-right-icon", `Chip-icons--${size}`);
    const buttonIconOverlayClass = (0, $7XTbi$classnames)("Chip-overlay", `Chip-overlay-${kind}`, isSelected && `Chip-overlay-${kind}--isSelected`, `Chip-overlay--${color}`);
    return /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $553ba9ca1822b2c0$export$2e2bcd8739ae039), {
        type: "button",
        onClick: onClick,
        isDisabled: isDisabled,
        className: chipClass,
        dataTestId: dataTestId,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                className: chipContentClass,
                children: [
                    leftIcon && /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                        className: leftIconClass,
                        children: leftIcon
                    }),
                    label && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5f880a93b57cab01$export$2e2bcd8739ae039), {
                        kind: "body3",
                        className: labelClass,
                        children: label
                    }),
                    rightIcon && /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                        className: rightIconClass,
                        children: rightIcon
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                className: buttonIconOverlayClass
            })
        ]
    });
}
$b7a25e567a023755$var$Chip.propTypes = {
    isDarkMode: (0, $7XTbi$proptypes).bool,
    size: (0, $7XTbi$proptypes).oneOf(Object.values($b7a25e567a023755$var$SIZES)),
    kind: (0, $7XTbi$proptypes).oneOf(Object.values($b7a25e567a023755$var$KINDS)),
    color: (0, $7XTbi$proptypes).oneOf(Object.values($b7a25e567a023755$var$COLORS)),
    isSelected: (0, $7XTbi$proptypes).bool,
    isDisabled: (0, $7XTbi$proptypes).bool,
    onClick: (0, $7XTbi$proptypes).func,
    leftIcon: (0, $7XTbi$proptypes).element,
    label: (0, $7XTbi$proptypes).oneOfType([
        (0, $7XTbi$proptypes).string,
        (0, $7XTbi$proptypes).node
    ]),
    rightIcon: (0, $7XTbi$proptypes).element,
    className: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string
};
$b7a25e567a023755$var$Chip.defaultProps = {
    isDarkMode: false,
    size: $b7a25e567a023755$var$SIZES.medium,
    kind: $b7a25e567a023755$var$KINDS.outlined,
    color: $b7a25e567a023755$var$COLORS.neutral,
    isSelected: false,
    isDisabled: false,
    onClick: ()=>{},
    leftIcon: null,
    label: null,
    rightIcon: null,
    className: null,
    dataTestId: null
};
var $b7a25e567a023755$export$2e2bcd8739ae039 = $b7a25e567a023755$var$Chip;
















const $db995900dd9f9eb4$var$msgs = {
    neo: {
        dateTimePicker: {
            invalidDateType: {
                id: "neo.dateTimePicker.invalidDateType",
                defaultMessage: "Error: minDate and maxDate must be of type Date"
            }
        }
    }
};
const $db995900dd9f9eb4$var$SIZES = {
    small: "small",
    large: "large"
};
const $db995900dd9f9eb4$var$KINDS = {
    dateStart: "dateStart",
    dateEnd: "dateEnd",
    timeStart: "timeStart",
    timeEnd: "timeEnd",
    dateAndTimeStart: "dateAndTimeStart",
    dateAndTimeEnd: "dateAndTimeEnd"
};
const $db995900dd9f9eb4$var$startKinds = [
    "dateStart",
    "timeStart",
    "dateAndTimeStart"
];
const $db995900dd9f9eb4$var$endKinds = [
    "dateEnd",
    "timeEnd",
    "dateAndTimeEnd"
];
const $db995900dd9f9eb4$var$dateKinds = [
    "dateEnd",
    "dateStart"
];
const $db995900dd9f9eb4$var$timeKinds = [
    "timeStart",
    "timeEnd"
];
const $db995900dd9f9eb4$var$dateAndTimeKinds = [
    "dateAndTimeStart",
    "dateAndTimeEnd"
];
const $db995900dd9f9eb4$var$DATES_FORMAT = {
    MDY: "MM/dd/yyyy",
    HM: "h:mm aa",
    HMS: "h:mm:ss aa",
    MDYHM: "MM/dd/yyyy, h:mm aa"
};
/**
 * #### WIP TODO:
 * - Replace encode SVG in css files with ButtonIcon comp from DSL.
 */ function $db995900dd9f9eb4$var$DateAndTimePicker({ kind: kind, size: size, label: label, labelTypography: labelTypography, isRequired: isRequired, isCritical: isCritical, setIsCritical: setIsCritical, isDisabled: isDisabled, isReadOnly: isReadOnly, CriticalHelperText: CriticalHelperText, HelperText: HelperText, backgroundColor: backgroundColor, startDate: startDate, setStartDate: setStartDate, endDate: endDate, setEndDate: setEndDate, filterTime: filterTime, maxDate: maxDate, minDate: minDate, dateFormat: dateFormat, timeIntervals: timeIntervals, timeHeaderText: timeHeaderText, timeMin: timeMin, timeMax: timeMax, excludeDates: excludeDates, excludeTimes: excludeTimes }) {
    const startDatePickerRef = (0, $7XTbi$useRef)(null);
    const endDatePickerRef = (0, $7XTbi$useRef)(null);
    const [isUsingMouse, setIsUsingMouse] = (0, $7XTbi$useState)(false);
    const intl = (0, $7XTbi$useIntl)();
    const INVALID_DATE_TYPE_ERROR = (0, $7XTbi$localize)(intl, $db995900dd9f9eb4$var$msgs.neo.dateTimePicker.invalidDateType);
    const handleMouseDown = ()=>{
        setIsUsingMouse(true);
    };
    const handleKeyDown = (event)=>{
        if (event.key === "Tab") setIsUsingMouse(false);
    };
    const addEventListeners = ()=>{
        document.addEventListener("mousedown", handleMouseDown);
        document.addEventListener("keydown", handleKeyDown);
    };
    const removeEventListeners = ()=>{
        document.removeEventListener("mousedown", handleMouseDown);
        document.removeEventListener("keydown", handleKeyDown);
    };
    (0, $7XTbi$useEffect)(()=>{
        addEventListeners();
        return removeEventListeners;
    }, []);
    // This changes the close button rendered tabIndex to 0
    (0, $7XTbi$useEffect)(()=>{
        const clearButtons = document.querySelectorAll(".react-datepicker__input-container .react-datepicker__close-icon");
        clearButtons.forEach((button)=>{
            const currentButton = button;
            currentButton.tabIndex = 0;
        });
    });
    // This changes the close button rendered tabIndex to 0
    (0, $7XTbi$useEffect)(()=>{
        const clearButtons = document.querySelectorAll(".react-datepicker__input-container .react-datepicker__close-icon");
        clearButtons.forEach((button)=>{
            const currentButton = button;
            currentButton.tabIndex = 0;
        });
    });
    const popperOptionsArray = [
        // TODO: New ticket to handle the popper position
        {
            name: "offset",
            options: {
                offset: [
                    100,
                    0
                ]
            }
        },
        {
            name: "preventOverflow",
            options: {
                boundary: "viewport",
                altAxis: true,
                padding: 10
            }
        }
    ];
    const pickerContainerClass = (0, $7XTbi$classnames)("DateAndTimeInputField-inputContainer", isDisabled && "DateAndTimeInputField-inputContainer--isDisabled", isReadOnly && "DateAndTimeInputField-inputContainer--isReadOnly");
    const pickerClass = (0, $7XTbi$classnames)("DatePicker-input", `DatePicker-input--${size}`, `DatePicker-input--${backgroundColor}`, `DatePicker-input-${kind}`, isDisabled && `DatePicker-input--isDisabled`, isCritical && `DatePicker-input--isCritical`, isReadOnly && `DatePicker-input--isReadOnly`, isUsingMouse && "DatePicker-input-noOutline");
    const suffixButtonClass = (0, $7XTbi$classnames)("DateAndTimeInputField-suffixButton", isRequired && isCritical && "DateAndTimeInputField-suffixButton--isCritical", isReadOnly && `DateAndTimeInputField-suffixButton--isReadOnly`, isUsingMouse && "DateAndTimeInputField-noOutline");
    if (minDate && !(minDate instanceof Date) || maxDate && !(maxDate instanceof Date)) return /*#__PURE__*/ (0, $7XTbi$jsx)("p", {
        className: "DateAndTimeInputField-errorMessage",
        children: INVALID_DATE_TYPE_ERROR
    });
    const getSuffixButtonIcon = ()=>{
        switch(kind){
            case "dateStart":
            case "dateEnd":
            case "dateAndTimeStart":
            case "dateAndTimeEnd":
                return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                    className: "DateAndTimeInputField-suffixButton-icon",
                    kind: "calendar",
                    color: "navy-700",
                    size: "smallMedium"
                });
            case "timeStart":
            case "timeEnd":
                return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                    className: "DateAndTimeInputField-suffixButton-icon",
                    kind: "Time",
                    color: "navy-700",
                    size: "smallMedium"
                });
            default:
                return null;
        }
    };
    const suffixButtonClick = ()=>{
        if (startDatePickerRef.current) startDatePickerRef.current.input.click();
        if (endDatePickerRef.current) endDatePickerRef.current.input.click();
    };
    // Variables to build a Picker
    // Picker Ref
    const pickerRef = ()=>{
        switch(kind){
            case "dateStart":
            case "timeStart":
            case "dateAndTimeStart":
                return startDatePickerRef;
            case "dateEnd":
            case "timeEnd":
            case "dateAndTimeEnd":
                return endDatePickerRef;
            default:
                return null;
        }
    };
    // Kind Date or Time month toggle
    // TODO: try to use the top const vars here, mayber chagne to is...Date
    const isKindDate = ()=>kind === "dateStart" || kind === "dateEnd" || kind === "dateAndTimeStart" || kind === "dateAndTimeEnd";
    // PlaceHolder
    const placeHolderKind = ()=>{
        switch(kind){
            case "dateStart":
            case "dateEnd":
                return "MM/DD/YYYY";
            case "dateAndTimeStart":
            case "dateAndTimeEnd":
                return "MM/DD/YYYY, HH:MM";
            case "timeStart":
            case "timeEnd":
                return dateFormat === "h:mm aa" ? "HH : MM" : "HH : MM : SS";
            default:
                return null;
        }
    };
    // Start or End Variables
    const pickerStartOrEnd = (toggle)=>{
        if (toggle === "start" && $db995900dd9f9eb4$var$startKinds.includes(kind)) return true;
        if (toggle === "end" && $db995900dd9f9eb4$var$endKinds.includes(kind)) return true;
        return false;
    };
    const valueSelectKind = ()=>{
        if ($db995900dd9f9eb4$var$startKinds.includes(kind)) return startDate;
        if ($db995900dd9f9eb4$var$endKinds.includes(kind)) return endDate;
        return null;
    };
    const onChangeKind = (date)=>{
        if ($db995900dd9f9eb4$var$startKinds.includes(kind)) return setStartDate(date);
        if ($db995900dd9f9eb4$var$endKinds.includes(kind)) {
            if (setIsCritical) setIsCritical(false);
            return setEndDate(date);
        }
        return null;
    };
    const getTimeSelect = (timeSelector)=>{
        if ($db995900dd9f9eb4$var$dateKinds.includes(kind)) return false;
        if (timeSelector === 1 && ($db995900dd9f9eb4$var$timeKinds.includes(kind) || $db995900dd9f9eb4$var$dateAndTimeKinds.includes(kind))) return true;
        if (timeSelector === 2 && $db995900dd9f9eb4$var$timeKinds.includes(kind)) return true;
        return false;
    };
    // Date formating functions
    const getMinTimeForEndTime = (startDateProp)=>{
        if (!startDate) return null;
        const selectedDate = new Date(startDateProp);
        const hours = selectedDate.getHours();
        const minutes = selectedDate.getMinutes();
        const newDate = (0, $7XTbi$setHours)((0, $7XTbi$setMinutes)(new Date(), minutes), hours);
        return newDate;
    };
    const getMaxTimeForStartTime = (endDateProp)=>{
        if (!endDate) return null;
        const selectedDate = new Date(endDateProp);
        const hours = selectedDate.getHours();
        const minutes = selectedDate.getMinutes();
        const newDate = (0, $7XTbi$setHours)((0, $7XTbi$setMinutes)(new Date(), minutes), hours);
        return newDate;
    };
    const handleMaxDate = ()=>{
        if ($db995900dd9f9eb4$var$timeKinds.includes(kind)) return null;
        const nextYearDate = (0, $7XTbi$getDateNextYear)();
        if ($db995900dd9f9eb4$var$endKinds.includes(kind)) return maxDate || nextYearDate;
        if ($db995900dd9f9eb4$var$startKinds.includes(kind)) return endDate || maxDate || nextYearDate;
        return nextYearDate;
    };
    const handleMinDate = ()=>{
        if ($db995900dd9f9eb4$var$timeKinds.includes(kind)) return null;
        if ($db995900dd9f9eb4$var$startKinds.includes(kind)) return minDate || new Date();
        if ($db995900dd9f9eb4$var$endKinds.includes(kind)) return startDate || minDate || new Date();
        return new Date();
    };
    const handleMaxTime = ()=>{
        if ($db995900dd9f9eb4$var$dateKinds.includes(kind)) return null;
        if ($db995900dd9f9eb4$var$endKinds.includes(kind)) return (0, $7XTbi$setHours)((0, $7XTbi$setMinutes)(new Date(), timeMax.minutes), timeMax.hours);
        if ($db995900dd9f9eb4$var$startKinds.includes(kind)) return getMaxTimeForStartTime(endDate) || (0, $7XTbi$setHours)((0, $7XTbi$setMinutes)(new Date(), timeMax.minutes), timeMax.hours);
        return new Date();
    };
    const handleMinTime = ()=>{
        if ($db995900dd9f9eb4$var$dateKinds.includes(kind)) return null;
        if ($db995900dd9f9eb4$var$startKinds.includes(kind)) return (0, $7XTbi$setHours)((0, $7XTbi$setMinutes)(new Date(), timeMin.minutes), timeMin.hours);
        if ($db995900dd9f9eb4$var$endKinds.includes(kind)) return getMinTimeForEndTime(startDate) || (0, $7XTbi$setHours)((0, $7XTbi$setMinutes)(new Date(), timeMin.minutes), timeMin.hours);
        return new Date();
    };
    return /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
        className: "DateAndTimeInputField-container",
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                className: "DateAndTimeInputField-labelContainer",
                children: [
                    isRequired && /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                        className: "DateAndTimeInputField--isRequired",
                        children: !startDate && /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                            className: `DateAndTimeInputField--isRequired--${isCritical ? "isCritical" : "isWarning"}`,
                            children: "*"
                        })
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5f880a93b57cab01$export$2e2bcd8739ae039), {
                        kind: labelTypography || "label",
                        htmlFor: label,
                        children: label
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                className: pickerContainerClass,
                children: [
                    /*#__PURE__*/ (0, $7XTbi$jsx)((0, $7XTbi$reactdatepicker), {
                        tabIndex: 0,
                        ref: pickerRef(),
                        showMonthYearDropdown: isKindDate(),
                        showDisabledMonthNavigation: isKindDate(),
                        placeholderText: placeHolderKind(),
                        className: pickerClass,
                        calendarClassName: "DatePicker-calendar",
                        selectsStart: pickerStartOrEnd("start"),
                        selectsEnd: pickerStartOrEnd("end"),
                        selected: valueSelectKind(),
                        isClearable: !!valueSelectKind(),
                        onChange: (date)=>onChangeKind(date),
                        showTimeSelect: getTimeSelect(1),
                        showTimeSelectOnly: getTimeSelect(2),
                        startDate: startDate,
                        endDate: endDate,
                        filterTime: filterTime,
                        timeIntervals: timeIntervals,
                        timeCaption: timeHeaderText,
                        dateFormat: dateFormat,
                        maxDate: handleMaxDate(),
                        minDate: handleMinDate(),
                        maxTime: handleMaxTime(),
                        minTime: handleMinTime(),
                        excludeDates: excludeDates,
                        excludeTimes: excludeTimes,
                        readOnly: isReadOnly,
                        // Popper
                        wrapperClassName: "DatePicker-wrapper",
                        showPopperArrow: false,
                        popperModifiers: popperOptionsArray
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $553ba9ca1822b2c0$export$2e2bcd8739ae039), {
                        type: "button",
                        tabIndex: 0,
                        onClick: ()=>suffixButtonClick(),
                        isDisabled: isDisabled,
                        className: suffixButtonClass,
                        children: [
                            getSuffixButtonIcon(),
                            /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                                "aria-hidden": "true",
                                className: (0, $7XTbi$classnames)("DateAndTimeInputField-suffixButton-overlay", isDisabled && "DateAndTimeInputField-suffixButton-overlay--isDisabled")
                            })
                        ]
                    })
                ]
            }),
            HelperText || isCritical && CriticalHelperText
        ]
    });
}
$db995900dd9f9eb4$var$DateAndTimePicker.defaultProps = {
    kind: $db995900dd9f9eb4$var$KINDS.dateStart,
    size: $db995900dd9f9eb4$var$SIZES.large,
    label: null,
    labelTypography: null,
    isDisabled: false,
    isRequired: false,
    isCritical: false,
    setIsCritical: ()=>{},
    isReadOnly: false,
    CriticalHelperText: null,
    HelperText: null,
    backgroundColor: "neutral",
    startDate: null,
    setStartDate: null,
    endDate: null,
    setEndDate: null,
    filterTime: null,
    dateFormat: $db995900dd9f9eb4$var$DATES_FORMAT.MDY,
    timeIntervals: 15,
    timeHeaderText: "Time",
    timeMin: {
        minutes: 0,
        hours: 0
    },
    timeMax: {
        minutes: 0,
        hours: 23
    },
    excludeDates: null,
    excludeTimes: null
};
$db995900dd9f9eb4$var$DateAndTimePicker.propTypes = {
    kind: (0, $7XTbi$proptypes).oneOf(Object.values($db995900dd9f9eb4$var$KINDS)),
    size: (0, $7XTbi$proptypes).oneOf(Object.values($db995900dd9f9eb4$var$SIZES)),
    label: (0, $7XTbi$proptypes).string,
    labelTypography: (0, $7XTbi$proptypes).string,
    isDisabled: (0, $7XTbi$proptypes).bool,
    isRequired: (0, $7XTbi$proptypes).bool,
    isCritical: (0, $7XTbi$proptypes).bool,
    setIsCritical: (0, $7XTbi$proptypes).func,
    isReadOnly: (0, $7XTbi$proptypes).bool,
    CriticalHelperText: (0, $7XTbi$proptypes).node,
    HelperText: (0, $7XTbi$proptypes).node,
    backgroundColor: (0, $7XTbi$proptypes).oneOf([
        "neutral",
        "secondary"
    ]),
    startDate: (0, $7XTbi$proptypes).instanceOf(Date),
    setStartDate: (0, $7XTbi$proptypes).func,
    endDate: (0, $7XTbi$proptypes).instanceOf(Date),
    setEndDate: (0, $7XTbi$proptypes).func,
    filterTime: (0, $7XTbi$proptypes).func,
    maxDate: (0, $7XTbi$proptypes).instanceOf(Date).isRequired,
    minDate: (0, $7XTbi$proptypes).instanceOf(Date).isRequired,
    dateFormat: (0, $7XTbi$proptypes).oneOf(Object.values($db995900dd9f9eb4$var$DATES_FORMAT)),
    timeIntervals: (0, $7XTbi$proptypes).number,
    timeHeaderText: (0, $7XTbi$proptypes).string,
    // Minutes: 0-59 Hours: 0-23
    timeMin: (0, $7XTbi$proptypes).shape({
        minutes: (0, $7XTbi$proptypes).number,
        hours: (0, $7XTbi$proptypes).number
    }),
    // Minutes: 0-59 Hours: 0-23
    timeMax: (0, $7XTbi$proptypes).shape({
        minutes: (0, $7XTbi$proptypes).number,
        hours: (0, $7XTbi$proptypes).number
    }),
    excludeDates: (0, $7XTbi$proptypes).arrayOf((0, $7XTbi$proptypes).instanceOf(Date)),
    excludeTimes: (0, $7XTbi$proptypes).arrayOf((0, $7XTbi$proptypes).instanceOf(Date))
};
var $db995900dd9f9eb4$export$2e2bcd8739ae039 = $db995900dd9f9eb4$var$DateAndTimePicker;


/* eslint-disable react/jsx-curly-spacing */ /* eslint-disable react/jsx-wrap-multilines */ /* eslint-disable object-curly-newline */ 










/**
 * NOTE: min/max supported widths: 375px - 480px
 *
 * WIP TODO:
 * - Make bigger Drawer, not mobile drawer component, will have anchor positions
 */ const $2262e7f4cc382b2a$var$MobileDrawer = /*#__PURE__*/ (0, $7XTbi$forwardRef)(({ isOpen: isOpen, setIsOpen: setIsOpen, isSwipeEnabled: isSwipeEnabled, isCloseButtonEnabled: isCloseButtonEnabled, isOutsideClickEnabled: isOutsideClickEnabled, headerContent: headerContent, content: content, footerActionBar: footerActionBar, maxHeight: maxHeight, fixedHeight: fixedHeight, swipeSensitivity: swipeSensitivity, dataTheme: dataTheme, className: className, dataTestId: dataTestId }, ref)=>{
    const [dropdownOpenHeight, setDropdownOpenHeight] = (0, $7XTbi$useState)(0);
    const drawerRef = (0, $7XTbi$useRef)(null);
    const contentRef = (0, $7XTbi$useRef)(null);
    const overlayRef = (0, $7XTbi$useRef)(null);
    const overlayBgClasses = (0, $7XTbi$classnames)("MobileDrawer-background", isOpen && `MobileDrawer-background--isOpen`);
    const mobileDrawerClasses = (0, $7XTbi$classnames)("MobileDrawer", isOpen && "MobileDrawer--isOpen", className);
    const contentClasses = (0, $7XTbi$classnames)("MobileDrawer-content");
    /** focusOnlyMobileDrawerElements makes the tab order locked to only the focusable components inside the mobileDrawer */ const focusOnlyMobileDrawerElements = (e)=>{
        if (!drawerRef.current) return;
        const focusableElements = drawerRef.current.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];
        // 9 is the Tab Keyy
        if (e.keyCode === 9) {
            if (e.shiftKey) {
                if (document.activeElement === firstElement) {
                    lastElement.focus();
                    e.preventDefault();
                }
            } else if (document.activeElement === lastElement) {
                firstElement.focus();
                e.preventDefault();
            }
        }
    };
    // Used to get the final height of the container the set it to 0 for the transition animation to play
    (0, $7XTbi$useEffect)(()=>{
        const drawerCurrent = drawerRef.current;
        const drawerContent = contentRef.current;
        const overlayCurrent = overlayRef.current;
        if (!drawerCurrent || !drawerContent || !overlayCurrent) return;
        const initialHeight = drawerCurrent.offsetHeight;
        if (isOpen) {
            setDropdownOpenHeight(fixedHeight ? overlayCurrent.clientHeight - fixedHeight : initialHeight);
            if (maxHeight) drawerCurrent.style.maxHeight = maxHeight;
            drawerCurrent.style.height = "0px";
            drawerContent.style.overflowY = "hidden";
            overlayCurrent.style.opacity = 0;
        }
        setTimeout(()=>{
            drawerContent.style.overflowY = "auto";
            if (!fixedHeight) drawerCurrent.style.height = "auto";
        }, (0, $65441b8e33d7ac73$export$18d1deb4684ad36c));
    }, [
        fixedHeight,
        isOpen,
        maxHeight
    ]);
    // Uses the dropdownOpenHeight from the initial useEffect to set the height of the container for the transition animation to play
    (0, $7XTbi$useEffect)(()=>{
        const drawerCurrent = drawerRef.current;
        const overlayCurrent = overlayRef.current;
        if (!drawerCurrent && !overlayCurrent) return;
        if (dropdownOpenHeight > 0) {
            drawerCurrent.style.height = `${dropdownOpenHeight}px`;
            drawerCurrent.style.opacity = 1;
            overlayCurrent.style.opacity = 1;
        }
    }, [
        dropdownOpenHeight
    ]);
    const toggleDrawerOpen = (0, $7XTbi$useCallback)(()=>{
        if (isOpen) {
            const drawerCurrent = drawerRef.current;
            const drawerContent = contentRef.current;
            const overlayCurrent = overlayRef.current;
            if (drawerCurrent && drawerContent && overlayCurrent) {
                const currentHeight = drawerCurrent.offsetHeight;
                drawerCurrent.style.height = `${currentHeight}px`;
                setTimeout(()=>{
                    drawerCurrent.style.height = "0px";
                    drawerContent.style.overflowY = "hidden";
                    overlayCurrent.style.opacity = 0;
                }, (0, $65441b8e33d7ac73$export$486d921bfc157ff6));
                setTimeout(()=>{
                    drawerCurrent.style.opacity = 0;
                    setIsOpen(false);
                }, (0, $65441b8e33d7ac73$export$18d1deb4684ad36c));
            }
        }
    }, [
        isOpen,
        setIsOpen
    ]);
    (0, $7XTbi$useEffect)(()=>{
        if (isOpen) {
            document.body.classList.add("MobileDrawer--isOpen--bodyScrollLock");
            document.addEventListener("keydown", focusOnlyMobileDrawerElements);
            const mobileDrawer = drawerRef?.current;
            if (mobileDrawer) {
                if (isCloseButtonEnabled && !isSwipeEnabled) {
                    const closeButton = mobileDrawer.querySelector("#mobileDrawerClose");
                    closeButton?.focus();
                } else {
                    const focusableElements = mobileDrawer.querySelectorAll('button, [href], li, input, select, textarea, [tabindex]:not([tabindex="-1"])');
                    if (focusableElements?.length > 0) focusableElements[0].focus();
                }
            }
        } else document.body.classList.remove("MobileDrawer--isOpen--bodyScrollLock");
        return ()=>{
            document.body.classList.remove("MobileDrawer--isOpen--bodyScrollLock");
            document.removeEventListener("keydown", focusOnlyMobileDrawerElements);
        };
    }, [
        isOpen,
        isCloseButtonEnabled,
        isSwipeEnabled
    ]);
    const closeOnEscapeKeyDown = (0, $7XTbi$useCallback)((e)=>{
        if (e.key === "Escape") toggleDrawerOpen();
    }, [
        toggleDrawerOpen
    ]);
    (0, $7XTbi$useEffect)(()=>{
        document.body.addEventListener("keydown", closeOnEscapeKeyDown);
        return ()=>{
            document.body.removeEventListener("keydown", closeOnEscapeKeyDown);
        };
    }, [
        closeOnEscapeKeyDown
    ]);
    // Only close on swipe enabled
    (0, $7XTbi$useOutsideClickEffect)(drawerRef, toggleDrawerOpen, isOpen && isOutsideClickEnabled);
    (0, $7XTbi$useEffect)(()=>{
        if (isOpen) {
            document.body.classList.add("MobileDrawer--isOpen--bodyScrollLock");
            document.addEventListener("keydown", focusOnlyMobileDrawerElements);
            const mobileDrawer = drawerRef?.current;
            if (mobileDrawer) {
                if (isCloseButtonEnabled && !isSwipeEnabled) {
                    const closeButton = mobileDrawer.querySelector("#mobileDrawerClose");
                    closeButton?.focus();
                } else {
                    const focusableElements = mobileDrawer.querySelectorAll('button, [href], li, input, select, textarea, [tabindex]:not([tabindex="-1"])');
                    if (focusableElements?.length > 0) focusableElements[0].focus();
                }
            }
        } else document.body.classList.remove("MobileDrawer--isOpen--bodyScrollLock");
        return ()=>{
            document.body.classList.remove("MobileDrawer--isOpen--bodyScrollLock");
            document.removeEventListener("keydown", focusOnlyMobileDrawerElements);
        };
    }, [
        isOpen,
        isCloseButtonEnabled,
        isSwipeEnabled
    ]);
    (0, $7XTbi$useImperativeHandle)(ref, ()=>({
            closeDrawer () {
                toggleDrawerOpen();
            }
        }));
    // Custom hook to add the swipe feature to the drawer
    const swipeHandle = (0, $7XTbi$useVerticalSwipe)({
        onSwipedUp: ()=>{},
        onSwipedDown: ()=>toggleDrawerOpen()
    }, swipeSensitivity);
    const swipeDirection = swipeHandle.displacement.direction;
    const swipeTravel = swipeHandle.boundedDistance;
    // Uses the dropdownOpenHeight from the initial useEffect to set the height of the container for the transition animation to play
    (0, $7XTbi$useEffect)(()=>{
        const drawerCurrent = drawerRef.current;
        const overlayCurrent = overlayRef.current;
        if (!drawerCurrent && !overlayCurrent) return;
        // Manipulate dropDown height based on the swipe direction and distance
        const heightToReduce = isSwipeEnabled && swipeDirection === "D" ? swipeTravel : 0;
        if (dropdownOpenHeight > 0) {
            drawerCurrent.style.height = `${dropdownOpenHeight - heightToReduce}px`;
            drawerCurrent.style.opacity = 1;
            overlayCurrent.style.opacity = 1;
        }
    }, [
        dropdownOpenHeight,
        swipeTravel,
        swipeDirection,
        isSwipeEnabled,
        isOpen
    ]);
    const getHeader = ()=>{
        if (isSwipeEnabled) return /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
            tag: "div",
            className: "MobileDrawer-swipeHandlerWrap",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                    id: "mobileDrawerClose",
                    className: "MobileDrawer-swipeHandle"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                    className: "MobileDrawer-swipeHandleHandler",
                    onTouchStart: swipeHandle.handlers.onTouchStart,
                    onTouchMove: swipeHandle.handlers.onTouchMove,
                    onTouchEnd: swipeHandle.handlers.onTouchEnd
                })
            ]
        });
        return /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
            tag: "div",
            className: "MobileDrawer-headerAndCloseOptions",
            children: [
                isCloseButtonEnabled && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $e34ff86c7a827ee6$export$2e2bcd8739ae039), {
                    size: "medium",
                    kind: "ghost",
                    id: "mobileDrawerClose",
                    className: "MobileDrawer-closeButton",
                    dataTestId: "mobileDrawerCloseButton",
                    icon: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                        kind: "Close"
                    }),
                    onClick: ()=>toggleDrawerOpen()
                }),
                headerContent
            ]
        });
    };
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $7XTbi$reactdom).createPortal(/*#__PURE__*/ (0, $7XTbi$jsxs)((0, $7XTbi$Fragment), {
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
                tag: "div",
                ref: overlayRef,
                className: overlayBgClasses,
                dataTestId: "MobileDrawer-background"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
                tag: "aside",
                id: "MobileDrawer",
                ref: drawerRef,
                className: mobileDrawerClasses,
                dataTestId: dataTestId,
                dataTheme: dataTheme,
                children: [
                    (headerContent || isSwipeEnabled || isCloseButtonEnabled) && getHeader(),
                    /*#__PURE__*/ (0, $7XTbi$jsx)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
                        tag: "div",
                        ref: contentRef,
                        className: contentClasses,
                        children: content
                    }),
                    footerActionBar
                ]
            })
        ]
    }), document.body);
});
$2262e7f4cc382b2a$var$MobileDrawer.propTypes = {
    isOpen: (0, $7XTbi$proptypes).bool.isRequired,
    setIsOpen: (0, $7XTbi$proptypes).func.isRequired,
    isSwipeEnabled: (0, $7XTbi$proptypes).bool,
    isCloseButtonEnabled: (0, $7XTbi$proptypes).bool,
    isOutsideClickEnabled: (0, $7XTbi$proptypes).bool,
    headerContent: (0, $7XTbi$proptypes).element,
    content: (0, $7XTbi$proptypes).element,
    footerActionBar: (0, $7XTbi$proptypes).element,
    maxHeight: (0, $7XTbi$proptypes).string,
    fixedHeight: (0, $7XTbi$proptypes).number,
    swipeSensitivity: (0, $7XTbi$proptypes).number,
    dataTheme: (0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$49390a4605a2336a))),
    className: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string
};
$2262e7f4cc382b2a$var$MobileDrawer.defaultProps = {
    isSwipeEnabled: false,
    isCloseButtonEnabled: false,
    isOutsideClickEnabled: true,
    headerContent: null,
    content: null,
    footerActionBar: null,
    maxHeight: null,
    fixedHeight: null,
    swipeSensitivity: 50,
    dataTheme: null,
    className: null,
    dataTestId: null
};
var $2262e7f4cc382b2a$export$2e2bcd8739ae039 = $2262e7f4cc382b2a$var$MobileDrawer;


/* eslint-disable react/jsx-no-useless-fragment */ 








function $7082d2d2e186ccb9$var$MobileDrawerItem({ option: option, onClick: onClick, BadgeComp: BadgeComp, prefixIcon: prefixIcon, suffixIcon: suffixIcon, tabIndex: tabIndex, className: className }) {
    const { label: label, secondaryLabel: secondaryLabel, value: value, prefixIcon: optionPrefixIcon, suffixIcon: optionSuffixIcon, hasTabBar: hasTabBar, isMulti: isMulti, isRadio: isRadio, isChecked: isChecked, isDisabled: isDisabled, isSuffixOnlyOnChecked: isSuffixOnlyOnChecked } = option;
    const mobileDrawerItemClasses = (0, $7XTbi$classnames)("MobileDrawerItem", isChecked && "MobileDrawerItem--isChecked", isDisabled && "MobileDrawerItem--isDisabled", className);
    const hasPrefixIcon = prefixIcon || optionPrefixIcon || isRadio || isMulti;
    const prefixClasses = (0, $7XTbi$classnames)("MobileDrawerItem-prefixWrapper", isMulti && "MobileDrawerItem-prefixWrapper--isMulti", isRadio && "MobileDrawerItem-prefixWrapper--isRadio", !hasPrefixIcon && "MobileDrawerItem-prefixWrapper--hasNoPrefixIcon");
    const handleOptionClick = (event)=>{
        // prevent the default behavior and event bubbling.
        event.preventDefault();
        event.stopPropagation();
        if (isDisabled) return;
        onClick(event.target);
    };
    const getPrefixElement = ()=>{
        if (isMulti) return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $ea632b95ffcf8459$export$2e2bcd8739ae039), {
            kind: "base",
            tabIndex: -1,
            isChecked: isChecked,
            isDisabled: isDisabled,
            size: "small"
        });
        if (isRadio) return /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $7XTbi$Fragment), {
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                    className: "MobileDrawerItem-radioCircle"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                    className: "MobileDrawerItem-radioCircleFiller"
                })
            ]
        });
        if (prefixIcon) return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $7XTbi$Fragment), {
            children: prefixIcon
        });
        if (optionPrefixIcon) return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
            kind: optionPrefixIcon,
            className: "MobileDrawerItem-optionPrefixIcon"
        });
        return null;
    };
    const getSuffixElement = ()=>{
        if (isSuffixOnlyOnChecked) {
            if (!isChecked) return null;
            if (suffixIcon) return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $7XTbi$Fragment), {
                children: suffixIcon
            });
            if (optionSuffixIcon) return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                kind: optionSuffixIcon,
                className: "MobileDrawerItem-optionSuffixIcon"
            });
        }
        if (suffixIcon) return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $7XTbi$Fragment), {
            children: suffixIcon
        });
        if (optionSuffixIcon) return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
            kind: optionSuffixIcon
        });
        return null;
    };
    const isCheckedAndNotMultiOrRadio = isChecked && !isRadio && !isMulti;
    return /*#__PURE__*/ (0, $7XTbi$jsxs)("li", {
        onClick: handleOptionClick,
        className: mobileDrawerItemClasses,
        role: "option",
        "aria-selected": isChecked,
        tabIndex: isDisabled ? -1 : tabIndex,
        onKeyDown: (e)=>{
            if (e.key === "Enter" || e.key === " ") handleOptionClick(e);
        },
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
                className: prefixClasses,
                children: getPrefixElement()
            }),
            /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
                className: "MobileDrawerItem-text",
                children: [
                    /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
                        className: "MobileDrawerItem-primaryLabelWrapper",
                        children: [
                            /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5f880a93b57cab01$export$2e2bcd8739ae039), {
                                kind: "label",
                                desktop: isCheckedAndNotMultiOrRadio ? "body2-bold-d" : "body2-d",
                                mobile: isCheckedAndNotMultiOrRadio ? "body2-bold-m" : "body2-m",
                                className: "MobileDrawerItem-label",
                                children: label
                            }),
                            BadgeComp
                        ]
                    }),
                    secondaryLabel && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5f880a93b57cab01$export$2e2bcd8739ae039), {
                        kind: "body3",
                        desktop: "body3-m",
                        mobile: "body3-m",
                        className: "MobileDrawerItem-secondaryLabel",
                        children: secondaryLabel
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
                className: "MobileDrawerItem-suffixWrapper",
                children: getSuffixElement()
            }),
            hasTabBar && /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                className: "MobileDrawerItem-tabBar"
            })
        ]
    }, value);
}
$7082d2d2e186ccb9$var$MobileDrawerItem.propTypes = {
    option: (0, $7XTbi$proptypes).shape({
        label: (0, $7XTbi$proptypes).string.isRequired,
        secondaryLabel: (0, $7XTbi$proptypes).string,
        value: (0, $7XTbi$proptypes).string.isRequired,
        suffixIcon: (0, $7XTbi$proptypes).string,
        prefixIcon: (0, $7XTbi$proptypes).string,
        hasTabBar: (0, $7XTbi$proptypes).bool,
        isMulti: (0, $7XTbi$proptypes).bool,
        isRadio: (0, $7XTbi$proptypes).bool,
        isChecked: (0, $7XTbi$proptypes).bool,
        isDisabled: (0, $7XTbi$proptypes).bool,
        isSuffixOnlyOnChecked: (0, $7XTbi$proptypes).bool
    }),
    onClick: (0, $7XTbi$proptypes).func.isRequired,
    BadgeComp: (0, $7XTbi$proptypes).element,
    prefixIcon: (0, $7XTbi$proptypes).element,
    suffixIcon: (0, $7XTbi$proptypes).element,
    tabIndex: (0, $7XTbi$proptypes).oneOfType([
        (0, $7XTbi$proptypes).number,
        (0, $7XTbi$proptypes).string
    ]),
    className: (0, $7XTbi$proptypes).string
};
$7082d2d2e186ccb9$var$MobileDrawerItem.defaultProps = {
    option: (0, $7XTbi$proptypes).shape({
        label: null,
        secondaryLabel: null,
        value: null,
        suffixIcon: null,
        prefixIcon: null,
        hasTabBar: null,
        isMulti: null,
        isRadio: null,
        isChecked: false,
        isDisabled: false,
        isSuffixOnlyOnChecked: false
    }),
    BadgeComp: null,
    prefixIcon: null,
    suffixIcon: null,
    tabIndex: 0,
    className: null
};
var $7082d2d2e186ccb9$export$2e2bcd8739ae039 = $7082d2d2e186ccb9$var$MobileDrawerItem;







function $d194faea1a3958a2$var$FooterActionBar({ isDarkMode: isDarkMode, size: size, children: children, isScrolled: isScrolled, dataTestId: dataTestId, className: className }) {
    const classes = (0, $7XTbi$classnames)("FooterActionBar", `FooterActionBar--${size}`, isScrolled && "FooterActionBar--isScrolled", className);
    return /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
        id: "FooterActionBar",
        className: classes,
        "data-testid": dataTestId,
        children: children
    });
}
$d194faea1a3958a2$var$FooterActionBar.propTypes = {
    isDarkMode: (0, $7XTbi$proptypes).bool,
    size: (0, $7XTbi$proptypes).oneOf([
        "small",
        "large"
    ]),
    children: (0, $7XTbi$proptypes).node.isRequired,
    isScrolled: (0, $7XTbi$proptypes).bool,
    dataTestId: (0, $7XTbi$proptypes).string,
    className: (0, $7XTbi$proptypes).string
};
$d194faea1a3958a2$var$FooterActionBar.defaultProps = {
    isDarkMode: false,
    size: "large",
    isScrolled: false,
    dataTestId: null,
    className: null
};
var $d194faea1a3958a2$export$2e2bcd8739ae039 = $d194faea1a3958a2$var$FooterActionBar;











function $b115cb52efe220d2$var$GridItem({ mobile: mobile, tablet: tablet, desktop: desktop, className: className, children: children }) {
    const classes = (0, $7XTbi$classnames)("Grid-item", mobile !== null && `Grid-item--mobile-${mobile}`, tablet !== null && `Grid-item--tablet-${tablet}`, desktop !== null && `Grid-item--desktop-${desktop}`, className);
    return /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
        className: classes,
        children: children
    });
}
$b115cb52efe220d2$var$GridItem.propTypes = {
    mobile: (0, $7XTbi$proptypes).number,
    tablet: (0, $7XTbi$proptypes).number,
    desktop: (0, $7XTbi$proptypes).number,
    className: (0, $7XTbi$proptypes).string,
    children: (0, $7XTbi$proptypes).node
};
$b115cb52efe220d2$var$GridItem.defaultProps = {
    mobile: null,
    tablet: null,
    desktop: null,
    className: null,
    children: null
};
var $b115cb52efe220d2$export$2e2bcd8739ae039 = $b115cb52efe220d2$var$GridItem;



/**
 * A very rough Grid container component.
 *
 * @component
 * @param {number} spacing - spacing between grid items.
 * @param {string} className - additional CSS class name for the grid container.
 * @param {string} dataTestId - data-testid attribute for testing purposes.
 * @param {ReactNode} children - child elements to be rendered inside the grid container.
 * @returns {JSX.Element} The rendered Grid component.
 */ function $53adb6ae63fe1b6d$var$Grid({ spacing: spacing, className: className, dataTestId: dataTestId, children: children }) {
    const style = {
        // assume 1 spacing unit is 8px
        ...spacing && {
            gap: `${spacing * 8 / 16}rem`
        }
    };
    const classes = (0, $7XTbi$classnames)("Grid", className);
    return /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
        className: classes,
        style: style,
        "data-testid": dataTestId,
        children: children
    });
}
$53adb6ae63fe1b6d$var$Grid.propTypes = {
    spacing: (0, $7XTbi$proptypes).number,
    className: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string,
    children: (0, $7XTbi$proptypes).node
};
$53adb6ae63fe1b6d$var$Grid.defaultProps = {
    spacing: 1,
    className: null,
    dataTestId: null,
    children: null
};
$53adb6ae63fe1b6d$var$Grid.Item = (0, $b115cb52efe220d2$export$2e2bcd8739ae039);
var $53adb6ae63fe1b6d$export$2e2bcd8739ae039 = $53adb6ae63fe1b6d$var$Grid;


/* eslint-disable react/jsx-curly-spacing */ 












const $1471ed0e1adc19c1$var$SvgSaviynt = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 88,
        height: 25,
        viewBox: "0 0 88 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            d: "M17.118 15.39c0-2.466 1.637-4.384 6.001-4.384h3.274v-.274c0-1.37-.546-2.465-2.455-2.465-1.91 0-2.455 1.096-2.455 1.917h-3.82v-.273c0-1.918 1.91-4.657 6.275-4.657 4.364 0 6.274 2.74 6.274 6.026v7.944h-3.546l-.273-1.096h-.273c-.546.548-1.91 1.37-4.092 1.37-3 0-4.91-1.644-4.91-4.109Zm9.275-1.918h-3.001c-1.91 0-2.455.821-2.455 1.643 0 .822.546 1.37 2.182 1.37 2.183 0 3.274-1.37 3.274-3.013Zm8.4 5.752-4.91-13.422v-.274h3.82l3.273 9.587h.273l3.273-9.587h3.82v.274L39.43 19.224h-4.637Zm10.206 0V5.528h3.819v13.696h-3.82Zm5.296 5.342v-3.264h2.457c1.092 0 1.365-.272 1.638-1.088l.273-.8v-.272L49.476 5.8v-.272h3.822l3.276 9.247h.273l3.277-9.247h3.822V5.8l-5.46 14.142c-1.366 3.536-2.458 4.624-5.734 4.624h-2.457Zm14.323-5.342V5.528h3.547l.272 1.096h.273c.819-.822 1.91-1.37 3.547-1.37 3.546 0 5.456 2.74 5.456 5.479v8.49h-3.82V11.28c0-1.917-.818-2.739-2.455-2.739-1.636 0-3 1.096-3 3.287v7.396h-3.82Zm20.243 0c-3 0-4.365-2.187-4.365-4.379V8.82h-2.455V5.532h2.455V1.697h3.82v3.835h3V8.82h-3v6.026c0 .822.272 1.096 1.09 1.096h2.183v3.283h-2.728Zm-76.043.274c-1.561 0-2.944-.222-4.149-.667-1.205-.444-2.157-1.13-2.856-2.058C1.114 15.845.734 14.69.675 13.23c-.008-.19.085-.26.257-.26h4.05c.172 0 .297.087.297.26v1.626l3.288 2.309 3.289-2.309v-.523c0-.634-.194-.943-.583-1.302-.388-.359-.873-.623-1.538-.825a25.362 25.362 0 0 0-1.953-.524 39.37 39.37 0 0 1-2.295-.574 9.738 9.738 0 0 1-2.194-.937c-.682-.4-1.231-.94-1.647-1.584-.416-.643-.624-1.478-.624-2.506 0-1.122.285-2.097.855-2.926.57-.829 1.392-1.468 2.464-1.917C5.413.79 6.937.566 8.472.566c1.407 0 2.81.248 3.89.62 1.081.37 1.913.947 2.576 1.767.727.901 1.174 1.887 1.174 3.348 0 .182-.06.262-.257.262h-3.729c-.154 0-.27-.086-.27-.259V5.206L8.567 2.898 5.28 5.206s-.006.295 0 .542c.013.62.19.913.61 1.24.424.33 1.004.426 1.682.593.774.19 1.318.314 1.926.45.859.194 1.595.357 2.42.572.812.211 1.58.552 2.266.956.686.405 1.237.873 1.653 1.516.416.643.624 1.482.624 2.518 0 1.278-.307 2.355-.92 3.231-.613.877-1.492 1.541-2.637 1.994-1.145.454-2.507.68-4.085.68Z",
            fill: "#10123D"
        })
    });
var $1471ed0e1adc19c1$export$2e2bcd8739ae039 = $1471ed0e1adc19c1$var$SvgSaviynt;




const $020b1f15818f2234$var$SvgSaviyntWhite = (props)=>/*#__PURE__*/ (0, $7XTbi$jsx)("svg", {
        width: 88,
        height: 25,
        viewBox: "0 0 88 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
            d: "M17.118 15.39c0-2.466 1.637-4.384 6.001-4.384h3.274v-.274c0-1.37-.546-2.465-2.455-2.465-1.91 0-2.455 1.096-2.455 1.917h-3.82v-.273c0-1.918 1.91-4.657 6.275-4.657 4.364 0 6.274 2.74 6.274 6.026v7.944h-3.546l-.273-1.096h-.273c-.546.548-1.91 1.37-4.092 1.37-3 0-4.91-1.644-4.91-4.109Zm9.275-1.918h-3.001c-1.91 0-2.455.821-2.455 1.643 0 .822.546 1.37 2.182 1.37 2.183 0 3.274-1.37 3.274-3.013Zm8.4 5.752-4.91-13.422v-.274h3.82l3.273 9.587h.273l3.273-9.587h3.82v.274L39.43 19.224h-4.637Zm10.206 0V5.528h3.819v13.696h-3.82Zm5.296 5.342v-3.264h2.457c1.092 0 1.365-.272 1.638-1.088l.273-.8v-.272L49.476 5.8v-.272h3.822l3.276 9.247h.273l3.277-9.247h3.822V5.8l-5.46 14.142c-1.366 3.536-2.458 4.624-5.734 4.624h-2.457Zm14.323-5.342V5.528h3.547l.272 1.096h.273c.819-.822 1.91-1.37 3.547-1.37 3.546 0 5.456 2.74 5.456 5.479v8.49h-3.82V11.28c0-1.917-.818-2.739-2.455-2.739-1.636 0-3 1.096-3 3.287v7.396h-3.82Zm20.243 0c-3 0-4.365-2.187-4.365-4.379V8.82h-2.455V5.532h2.455V1.697h3.82v3.835h3V8.82h-3v6.026c0 .822.272 1.096 1.09 1.096h2.183v3.283h-2.728Zm-76.043.274c-1.561 0-2.944-.222-4.149-.667-1.205-.444-2.157-1.13-2.856-2.058C1.114 15.845.734 14.69.675 13.23c-.008-.19.085-.26.257-.26h4.05c.172 0 .297.087.297.26v1.626l3.288 2.309 3.289-2.309v-.523c0-.634-.194-.943-.583-1.302-.388-.359-.873-.623-1.538-.825a25.362 25.362 0 0 0-1.953-.524 39.37 39.37 0 0 1-2.295-.574 9.738 9.738 0 0 1-2.194-.937c-.682-.4-1.231-.94-1.647-1.584-.416-.643-.624-1.478-.624-2.506 0-1.122.285-2.097.855-2.926.57-.829 1.392-1.468 2.464-1.917C5.413.79 6.937.566 8.472.566c1.407 0 2.81.248 3.89.62 1.081.37 1.913.947 2.576 1.767.727.901 1.174 1.887 1.174 3.348 0 .182-.06.262-.257.262h-3.729c-.154 0-.27-.086-.27-.259V5.206L8.567 2.898 5.28 5.206s-.006.295 0 .542c.013.62.19.913.61 1.24.424.33 1.004.426 1.682.593.774.19 1.318.314 1.926.45.859.194 1.595.357 2.42.572.812.211 1.58.552 2.266.956.686.405 1.237.873 1.653 1.516.416.643.624 1.482.624 2.518 0 1.278-.307 2.355-.92 3.231-.613.877-1.492 1.541-2.637 1.994-1.145.454-2.507.68-4.085.68Z",
            fill: "#fff"
        })
    });
var $020b1f15818f2234$export$2e2bcd8739ae039 = $020b1f15818f2234$var$SvgSaviyntWhite;



const $540f31a7d1651db4$var$LOGOS = {
    saviynt: "saviynt",
    saviyntWhite: "saviyntWhite"
};
const $540f31a7d1651db4$var$getSVG = (kind)=>{
    switch(kind){
        case $540f31a7d1651db4$var$LOGOS.saviyntWhite:
            return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $020b1f15818f2234$export$2e2bcd8739ae039), {});
        // Add more logos here
        default:
            return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1471ed0e1adc19c1$export$2e2bcd8739ae039), {});
    }
};
function $540f31a7d1651db4$var$Logo({ kind: kind, className: className, onClick: onClick, tabIndex: tabIndex }) {
    const classes = (0, $7XTbi$classnames)("Logo", `Logo-kind--${kind}`, onClick && "Logo--click", className);
    const onKeyUp = onClick ? (e)=>e.key === "Enter" && onClick() : null;
    return /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
        className: classes,
        onClick: onClick,
        role: "button",
        onKeyUp: onKeyUp,
        tabIndex: tabIndex ?? onClick ? 0 : null,
        children: $540f31a7d1651db4$var$getSVG(kind)
    });
}
$540f31a7d1651db4$var$Logo.propTypes = {
    kind: (0, $7XTbi$proptypes).oneOf(Object.values($540f31a7d1651db4$var$LOGOS)),
    onClick: (0, $7XTbi$proptypes).func,
    className: (0, $7XTbi$proptypes).string,
    /** Should be specified if onClick is provided. If onClick is provided but tabIndex is not, 0 will be used to adhere to a11y standards. */ tabIndex: (0, $7XTbi$proptypes).number
};
$540f31a7d1651db4$var$Logo.defaultProps = {
    kind: "saviynt",
    onClick: null,
    className: null,
    tabIndex: null
};
var $540f31a7d1651db4$export$2e2bcd8739ae039 = $540f31a7d1651db4$var$Logo;



function $4a15bfc3fe1685a3$var$Header({ dataTestId: dataTestId, helpOnClick: helpOnClick, notificationsOnClick: notificationsOnClick, avatarOnClick: avatarOnClick, user: user, isScrolled: isScrolled, className: className }) {
    const classes = (0, $7XTbi$classnames)("Header", isScrolled && "Header--scrolled", className);
    return /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
        id: "Header",
        className: classes,
        "data-testid": dataTestId,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                className: "Header-extraContent",
                children: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $540f31a7d1651db4$export$2e2bcd8739ae039), {
                    className: "Header-logo"
                })
            }),
            /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                className: "Header-actionItems",
                children: [
                    helpOnClick && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $e34ff86c7a827ee6$export$2e2bcd8739ae039), {
                        kind: "ghost",
                        icon: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                            kind: "HelpOutlined",
                            size: "medium",
                            color: "neutral-1000"
                        }),
                        onClick: ()=>{
                            console.log("Help feature does not exist yet");
                        }
                    }),
                    notificationsOnClick && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $e34ff86c7a827ee6$export$2e2bcd8739ae039), {
                        kind: "ghost",
                        icon: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                            kind: "Notification",
                            size: "medium",
                            color: "neutral-1000"
                        }),
                        onClick: ()=>{
                            console.log("Notifications feature does not exist yet");
                        }
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsx)((0, $e34ff86c7a827ee6$export$2e2bcd8739ae039), {
                        kind: "ghost",
                        className: "Header-avatar",
                        icon: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $f0cbdef548412548$export$2e2bcd8739ae039), {
                            alt: "avatar",
                            size: "small",
                            src: user?.url,
                            children: !user?.url && user?.name.charAt(0)
                        }),
                        onClick: avatarOnClick
                    })
                ]
            })
        ]
    });
}
$4a15bfc3fe1685a3$var$Header.propTypes = {
    dataTestId: (0, $7XTbi$proptypes).string,
    helpOnClick: (0, $7XTbi$proptypes).func,
    notificationsOnClick: (0, $7XTbi$proptypes).func,
    avatarOnClick: (0, $7XTbi$proptypes).func,
    // TODO: this object needs to be updated with the correct props
    user: (0, $7XTbi$proptypes).shape({
        name: (0, $7XTbi$proptypes).string,
        url: (0, $7XTbi$proptypes).string
    }),
    isScrolled: (0, $7XTbi$proptypes).bool,
    className: (0, $7XTbi$proptypes).string
};
$4a15bfc3fe1685a3$var$Header.defaultProps = {
    dataTestId: null,
    helpOnClick: null,
    notificationsOnClick: null,
    avatarOnClick: null,
    user: null,
    isScrolled: false,
    className: null
};
var $4a15bfc3fe1685a3$export$2e2bcd8739ae039 = $4a15bfc3fe1685a3$var$Header;








var $b67c12058b656330$exports = {};

$parcel$export($b67c12058b656330$exports, "Error", function () { return $68b4c82af668a364$export$2e2bcd8739ae039; });


const $68b4c82af668a364$var$SvgError = (props)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("svg", {
        width: 120,
        height: 120,
        viewBox: "0 0 120 120",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "m75.515 9.113-1.705 6.364a1.5 1.5 0 0 1-2.898-.776l1.835-6.847a2.5 2.5 0 0 1 3.062-1.768L80.11 7.24a2.5 2.5 0 0 1 1.767 3.062l-1.834 6.847a1.5 1.5 0 1 1-2.898-.777l1.705-6.364-3.336-.894ZM61.985 53.814a1.5 1.5 0 0 1 1.06 1.837l-13.087 48.842h3.574L66.38 56.545a1.5 1.5 0 1 1 2.897.776l-10.565 39.43h5.685l-.367-2.204a1.5 1.5 0 0 1 2.96-.493l.449 2.697h2.286l-.55-8.809a1.5 1.5 0 1 1 2.993-.187l.563 8.996h2.08l-.47-4.22a1.5 1.5 0 1 1 2.982-.332l.619 5.567a1.5 1.5 0 0 1-1.42 1.985H57.908l-1.27 4.742h2.006a1.5 1.5 0 0 1 0 3H48.04a.829.829 0 0 1-.07 0H22.274a1.5 1.5 0 1 1 0-3h24.578l1.27-4.742h-10.92c-.427 0-.811-.178-1.084-.463a1.496 1.496 0 0 1-.498-1.116V90.43a1.5 1.5 0 0 1 3 0v6.32h3.116l.38-1.523a1.5 1.5 0 1 1 2.911.728l-.199.796h4.098l11.22-41.876a1.5 1.5 0 0 1 1.838-1.06ZM66.912 47.895a1.936 1.936 0 1 0 1.001-3.74 1.936 1.936 0 0 0-1.001 3.74ZM69.365 30.841l-1.725 10.24a1.064 1.064 0 0 0 2.047.549l3.627-9.73a2.053 2.053 0 1 0-3.95-1.059Z",
                fill: "#00245B"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M72.424 19.081c1.354-1.288 3.592-.689 4.12 1.105l10.232 34.697c.552 1.872-1.16 3.627-3.045 3.122l-36.44-9.765c-1.887-.505-2.491-2.88-1.077-4.226l26.21-24.933Zm1.474 2.738-24.97 23.754 34.718 9.303-9.748-33.057Z",
                fill: "#00245B"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                d: "M33.069 92.04a1.5 1.5 0 0 0-2.929.65l.903 4.06H5.5a1.5 1.5 0 0 0 0 3h27.283c.346 0 .664-.116.918-.312a1.5 1.5 0 0 0 .658-1.591l-1.29-5.807ZM83.423 98.25c0-.053.003-.106.008-.158.011-.2.062-.4.157-.59l1.29-2.582a1.5 1.5 0 0 1 2.684 1.342l-.245.489H114.5a1.5 1.5 0 0 1 0 3H84.923a1.5 1.5 0 0 1-1.5-1.5ZM61.802 105.993a1.5 1.5 0 0 1 1.5-1.5h2.846a1.5 1.5 0 0 1 0 3h-2.846a1.5 1.5 0 0 1-1.5-1.5ZM91.352 100.287a1.5 1.5 0 0 1 1.256 1.71l-.381 2.496h15.379a1.5 1.5 0 1 1 0 3H90.48a1.5 1.5 0 0 1-1.483-1.726l.645-4.224a1.5 1.5 0 0 1 1.71-1.256ZM86.391 102.893a1.5 1.5 0 0 0-2.639 1.427l.094.173h-7.209a1.5 1.5 0 0 0 0 3h9.725a1.5 1.5 0 0 0 1.32-2.213l-1.29-2.387ZM41.152 110.364a1.5 1.5 0 0 0 0 3h41.292a1.5 1.5 0 1 0 0-3H41.152ZM80.704 88.93a1.5 1.5 0 0 1 1.5 1.5v7.742a1.5 1.5 0 0 1-3 0V90.43a1.5 1.5 0 0 1 1.5-1.5Z",
                fill: "#00245B"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M77.219 17.671c-.53-1.793-2.767-2.393-4.121-1.104L43.563 44.663c-1.414 1.346-.81 3.72 1.076 4.226l41.064 11.003c1.886.506 3.597-1.249 3.045-3.122l-11.53-39.099Zm-6.19-3.278c2.98-2.834 7.904-1.515 9.067 2.43l11.53 39.099c1.214 4.12-2.55 7.98-6.7 6.868L43.864 51.787c-4.149-1.112-5.48-6.337-2.368-9.297L71.03 14.392Z",
                fill: "#FF6F26"
            })
        ]
    });
var $68b4c82af668a364$export$2e2bcd8739ae039 = $68b4c82af668a364$var$SvgError;





function $956ec155f2f59366$var$Illustration({ kind: kind, className: className, dataTestId: dataTestId }) {
    if (!kind) return null;
    const illustrationName = kind.charAt(0).toUpperCase() + kind.slice(1);
    const IllustrationSvg = $b67c12058b656330$exports[illustrationName];
    const classes = (0, $7XTbi$classnames)("Illustration", `Illustration--${kind}`, className);
    return IllustrationSvg && /*#__PURE__*/ (0, $7XTbi$jsx)(IllustrationSvg, {
        className: classes,
        "data-testid": dataTestId
    });
}
$956ec155f2f59366$var$Illustration.propTypes = {
    kind: $bdacd2991d6a3fd7$export$a6cc1b7066de015b($b67c12058b656330$exports),
    className: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string
};
$956ec155f2f59366$var$Illustration.defaultProps = {
    kind: null,
    className: null,
    dataTestId: null
};
var $956ec155f2f59366$export$2e2bcd8739ae039 = $956ec155f2f59366$var$Illustration;










// eslint-disable-next-line import/prefer-default-export
const $0866b0e278d3a53e$export$9f3245bec405e186 = {
    neo: {
        inlineMessage: {
            missingReqField: {
                id: "neo.inlineMessage.missingReqField",
                defaultMessage: "This required field is incomplete"
            }
        }
    }
};



const $fb956946457df475$var$SIZES = {
    SMALL: "small",
    MEDIUM: "medium"
};
const $fb956946457df475$var$KINDS = {
    PLAIN: "plain",
    BACKGROUND: "background",
    MISSING_REQUIRED_FIELD: "missingRequiredField"
};
const $fb956946457df475$var$COLOR_THEMES = {
    NEUTRAL: "neutral",
    CRITICAL: "critical",
    WARNING: "warning",
    SUCCESS: "success",
    INFO: "info",
    DISABLED: "disabled"
};
function $fb956946457df475$var$InlineMessage({ kind: kind, size: size, leftIcon: leftIcon, text: text, children: children, colorTheme: colorTheme, linkComponent: linkComponent, isDismissible: isDismissible, isVisible: isVisible, onDismiss: onDismiss, className: className }) {
    const intl = (0, $7XTbi$useIntl)();
    if (!isVisible) return null;
    const MISSING_REQUIRED_FIELD_TEXT = (0, $7XTbi$localize)(intl, (0, $0866b0e278d3a53e$export$9f3245bec405e186).neo.inlineMessage.missingReqField);
    const classes = (0, $7XTbi$classnames)("InlineMessage", colorTheme && `InlineMessage--${colorTheme}`, `InlineMessage--${kind}`, `InlineMessage--${size}`, kind === $fb956946457df475$var$KINDS.MISSING_REQUIRED_FIELD && "InlineMessage--critical", className);
    const renderByKind = ()=>{
        switch(kind){
            case $fb956946457df475$var$KINDS.MISSING_REQUIRED_FIELD:
                return /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                    className: "InlineMessage-leftContent",
                    children: [
                        /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                            className: "InlineMessage-leftIconContainer",
                            children: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                                kind: "AlertCritical",
                                color: "critical-700"
                            })
                        }),
                        /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                            className: "InlineMessage-textContainer",
                            children: MISSING_REQUIRED_FIELD_TEXT
                        })
                    ]
                });
            default:
                return /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                    className: "InlineMessage-leftContent",
                    children: [
                        leftIcon && /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                            className: "InlineMessage-leftIconContainer",
                            children: leftIcon
                        }),
                        text && /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                            className: "InlineMessage-textContainer",
                            children: text
                        }),
                        children,
                        linkComponent && /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                            className: "InlineMessage-linkContainer",
                            children: linkComponent
                        })
                    ]
                });
        }
    };
    return /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
        role: "status",
        className: classes,
        children: [
            renderByKind(),
            isDismissible && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $e34ff86c7a827ee6$export$2e2bcd8739ae039), {
                kind: "ghost",
                size: "small",
                icon: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                    kind: "close",
                    color: "neutral-100",
                    size: "medium"
                }),
                onClick: onDismiss
            })
        ]
    });
}
$fb956946457df475$var$InlineMessage.propTypes = {
    kind: (0, $7XTbi$proptypes).string,
    size: (0, $7XTbi$proptypes).oneOf(Object.values($fb956946457df475$var$SIZES)),
    leftIcon: (0, $7XTbi$proptypes).element,
    text: (0, $7XTbi$proptypes).string,
    children: (0, $7XTbi$proptypes).element,
    colorTheme: (0, $7XTbi$proptypes).oneOf(Object.values($fb956946457df475$var$COLOR_THEMES)),
    linkComponent: (0, $7XTbi$proptypes).element,
    isDismissible: (0, $7XTbi$proptypes).bool,
    isVisible: (0, $7XTbi$proptypes).bool,
    onDismiss: (0, $7XTbi$proptypes).func,
    className: (0, $7XTbi$proptypes).string
};
$fb956946457df475$var$InlineMessage.defaultProps = {
    kind: $fb956946457df475$var$KINDS.PLAIN,
    size: $fb956946457df475$var$SIZES.MEDIUM,
    leftIcon: null,
    text: null,
    children: null,
    colorTheme: null,
    linkComponent: null,
    isDismissible: false,
    isVisible: true,
    onDismiss: ()=>{},
    className: null
};
var $fb956946457df475$export$2e2bcd8739ae039 = $fb956946457df475$var$InlineMessage;


/* eslint-disable react/jsx-curly-spacing */ /* eslint-disable indent */ 












const $866a094b111604e5$var$TYPES = {
    text: "text",
    password: "password",
    email: "email",
    number: "number",
    date: "date",
    time: "time",
    file: "file"
};
const $866a094b111604e5$var$INPUTMODE = {
    NONE: "none",
    TEXT: "text",
    DECIMAL: "decimal",
    NUMERIC: "numeric",
    TEL: "tel",
    SEARCH: "search",
    EMAIL: "email",
    URL: "url"
};
const $866a094b111604e5$var$InputCore = /*#__PURE__*/ (0, $7XTbi$forwardRef)(({ name: name, id: id, type: type, inputmode: inputmode, placeholder: placeholder, className: className, regexPattern: regexPattern, autoComplete: autoComplete, onChange: onChange, onClick: onClick, value: value, isReadOnly: isReadOnly, isDisabled: isDisabled, isRequired: isRequired, ariaDescribedBy: ariaDescribedBy, onMouseDown: onMouseDown, onKeyDown: onKeyDown, multiple: multiple, accept: accept, maxLength: maxLength, tabIndex: tabIndex, dataTestId: dataTestId }, ref)=>{
    const inputCoreClass = (0, $7XTbi$classnames)("InputCore", className);
    return /*#__PURE__*/ (0, $7XTbi$jsx)("input", {
        name: name,
        id: id,
        type: type,
        inputMode: inputmode,
        pattern: regexPattern,
        placeholder: placeholder,
        className: inputCoreClass,
        autoComplete: autoComplete,
        onChange: onChange,
        onClick: onClick,
        ...type !== "file" ? {
            value: value
        } : {},
        readOnly: isReadOnly,
        disabled: isDisabled,
        required: isRequired,
        "aria-describedby": ariaDescribedBy,
        onMouseDown: onMouseDown,
        onKeyDown: onKeyDown,
        multiple: multiple,
        accept: accept,
        maxLength: maxLength,
        ref: ref,
        tabIndex: isDisabled ? -1 : tabIndex,
        "data-testid": dataTestId
    });
});
$866a094b111604e5$var$InputCore.propTypes = {
    name: (0, $7XTbi$proptypes).string,
    id: (0, $7XTbi$proptypes).string,
    type: (0, $7XTbi$proptypes).oneOf(Object.values($866a094b111604e5$var$TYPES)),
    inputmode: (0, $7XTbi$proptypes).oneOf(Object.values($866a094b111604e5$var$INPUTMODE)),
    placeholder: (0, $7XTbi$proptypes).string,
    className: (0, $7XTbi$proptypes).string,
    regexPattern: (0, $7XTbi$proptypes).string,
    autoComplete: (0, $7XTbi$proptypes).string,
    onChange: (0, $7XTbi$proptypes).func,
    onClick: (0, $7XTbi$proptypes).func,
    value: (props, propName, componentName)=>{
        if (props.type !== "file") {
            // validate value prop only if type is not 'file'
            // if type is not file, value must be a string or number.
            const valueType = typeof props[propName];
            if (props[propName] !== undefined && valueType !== "string" && valueType !== "number") return new Error(`Invalid prop \`${propName}\` of type \`${valueType}\` supplied to \`${componentName}\`, expected \`string\` or \`number\`.`);
        }
        return null; // no error
    },
    isReadOnly: (0, $7XTbi$proptypes).bool,
    isDisabled: (0, $7XTbi$proptypes).bool,
    isRequired: (0, $7XTbi$proptypes).bool,
    ariaDescribedBy: (0, $7XTbi$proptypes).string,
    onMouseDown: (0, $7XTbi$proptypes).func,
    onKeyDown: (0, $7XTbi$proptypes).func,
    multiple: (0, $7XTbi$proptypes).bool,
    accept: (0, $7XTbi$proptypes).string,
    maxLength: (0, $7XTbi$proptypes).number,
    tabIndex: (0, $7XTbi$proptypes).oneOfType([
        (0, $7XTbi$proptypes).number,
        (0, $7XTbi$proptypes).string
    ]),
    dataTestId: (0, $7XTbi$proptypes).string
};
$866a094b111604e5$var$InputCore.defaultProps = {
    name: null,
    id: null,
    type: $866a094b111604e5$var$TYPES.text,
    inputmode: $866a094b111604e5$var$INPUTMODE.TEXT,
    placeholder: null,
    className: null,
    regexPattern: ".*",
    autoComplete: "off",
    onChange: null,
    onClick: null,
    value: null,
    isReadOnly: false,
    isDisabled: false,
    isRequired: false,
    ariaDescribedBy: "",
    onMouseDown: null,
    onKeyDown: null,
    multiple: false,
    accept: null,
    maxLength: null,
    tabIndex: 0,
    dataTestId: null
};
var $866a094b111604e5$export$2e2bcd8739ae039 = $866a094b111604e5$var$InputCore;






const $731fa4d5266ff6fc$var$TextareaCore = /*#__PURE__*/ (0, $7XTbi$forwardRef)(({ name: name, id: id, placeholder: placeholder, className: className, autoComplete: autoComplete, onChange: onChange, onClick: onClick, value: value, isReadOnly: isReadOnly, isDisabled: isDisabled, isRequired: isRequired, ariaDescribedby: ariaDescribedby, onMouseDown: onMouseDown, onKeyDown: onKeyDown, rows: rows, cols: cols, maxLength: maxLength, textAreaMaxHeight: textAreaMaxHeight, dataTestId: dataTestId }, ref)=>{
    const textareaCoreClass = (0, $7XTbi$classnames)("TextareaCore", className);
    return /*#__PURE__*/ (0, $7XTbi$jsx)("textarea", {
        name: name,
        id: id,
        ref: ref,
        placeholder: placeholder,
        className: textareaCoreClass,
        autoComplete: autoComplete,
        onChange: onChange,
        onClick: onClick,
        value: value,
        readOnly: isReadOnly,
        disabled: isDisabled,
        required: isRequired,
        "aria-describedby": ariaDescribedby,
        "aria-required": isRequired,
        onMouseDown: onMouseDown,
        onKeyDown: onKeyDown,
        rows: rows,
        cols: cols,
        maxLength: maxLength,
        style: {
            maxHeight: textAreaMaxHeight
        },
        "data-testid": dataTestId
    });
});
$731fa4d5266ff6fc$var$TextareaCore.propTypes = {
    name: (0, $7XTbi$proptypes).string,
    id: (0, $7XTbi$proptypes).string,
    placeholder: (0, $7XTbi$proptypes).string,
    className: (0, $7XTbi$proptypes).string,
    autoComplete: (0, $7XTbi$proptypes).string,
    onChange: (0, $7XTbi$proptypes).func,
    onClick: (0, $7XTbi$proptypes).func,
    value: (0, $7XTbi$proptypes).string,
    isReadOnly: (0, $7XTbi$proptypes).bool,
    isDisabled: (0, $7XTbi$proptypes).bool,
    isRequired: (0, $7XTbi$proptypes).bool,
    ariaDescribedby: (0, $7XTbi$proptypes).string,
    onMouseDown: (0, $7XTbi$proptypes).func,
    onKeyDown: (0, $7XTbi$proptypes).func,
    rows: (0, $7XTbi$proptypes).number,
    cols: (0, $7XTbi$proptypes).number,
    maxLength: (0, $7XTbi$proptypes).number,
    textAreaMaxHeight: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string
};
$731fa4d5266ff6fc$var$TextareaCore.defaultProps = {
    name: null,
    id: null,
    placeholder: null,
    className: null,
    autoComplete: "off",
    onChange: null,
    onClick: null,
    value: "",
    isReadOnly: false,
    isDisabled: false,
    isRequired: false,
    ariaDescribedby: "",
    onMouseDown: null,
    onKeyDown: null,
    rows: 4,
    cols: null,
    maxLength: null,
    textAreaMaxHeight: "31.5rem",
    dataTestId: null
};
var $731fa4d5266ff6fc$export$2e2bcd8739ae039 = $731fa4d5266ff6fc$var$TextareaCore;



const $5f5001b799eea6c0$var$msgs = {
    neo: {
        inputField: {
            bracketsErrorMsg: {
                id: "neo.inputField.bracketsErrorMsg",
                defaultMessage: "Please make sure there are no angle brackets (< >) in your text."
            }
        }
    }
};
const $5f5001b799eea6c0$var$SIZES = {
    SMALL: "small",
    MEDIUM: "medium",
    LARGE: "large"
};
const $5f5001b799eea6c0$var$InputField = /*#__PURE__*/ (0, $7XTbi$forwardRef)(({ id: id, name: name, placeholder: placeholder, kind: kind, size: size, type: type, inputmode: inputmode, label: label, regexPattern: regexPattern, isRequired: isRequired, isCritical: isCritical, isReadOnly: isReadOnly, CriticalHelperText: CriticalHelperText, HelperText: HelperText, isDisabled: isDisabled, prefixIcon: prefixIcon, suffixButtonType: suffixButtonType, suffixIsToggle: suffixIsToggle, suffixOnClick: suffixOnClick, onChange: onChange, onClick: onClick, onKeyDown: onKeyDown, backgroundColor: backgroundColor, value: value, setValue: setValue, setIsCritical: setIsCritical, minRequiredChars: minRequiredChars, maxLength: maxLength, shouldDisallowBrackets: shouldDisallowBrackets, tabIndex: tabIndex, textAreaMaxHeight: textAreaMaxHeight, resetValue: resetValue, suffixButtonIcon: suffixButtonIcon, suffixButtonIconOnClick: suffixButtonIconOnClick, isResetButtonVisible: isResetButtonVisible, className: className, dataTestId: dataTestId }, ref)=>{
    const [isUsingMouse, setIsUsingMouse] = (0, $7XTbi$useState)(false);
    const [doesValueHaveBrackets, setDoesValueHaveBrackets] = (0, $7XTbi$useState)(false);
    const localize = (0, $7XTbi$useLocalize)();
    const bracketsErrorMsg = /*#__PURE__*/ (0, $7XTbi$jsx)((0, $fb956946457df475$export$2e2bcd8739ae039), {
        text: localize($5f5001b799eea6c0$var$msgs.neo.inputField.bracketsErrorMsg),
        colorTheme: "critical",
        size: "small",
        leftIcon: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
            kind: "AlertCritical",
            color: "critical-700"
        })
    });
    const showResetButton = isResetButtonVisible && value?.length > 0 && !isDisabled && kind !== "multiline";
    const handleMouseDown = ()=>setIsUsingMouse(true);
    const handleKeyDown = (event)=>{
        if (event.key === "Tab") setIsUsingMouse(false);
    };
    const addEventListeners = ()=>{
        document.addEventListener("mousedown", handleMouseDown);
        document.addEventListener("keydown", handleKeyDown);
    };
    const removeEventListeners = ()=>{
        document.removeEventListener("mousedown", handleMouseDown);
        document.removeEventListener("keydown", handleKeyDown);
    };
    (0, $7XTbi$useEffect)(()=>{
        addEventListeners();
        return removeEventListeners;
    }, []);
    const inputClass = (0, $7XTbi$classnames)("InputField-input", `InputField--${size}`, `InputField--${kind}`, `InputField--${backgroundColor}`, !value && "InputField-input--hasNoValue", prefixIcon && `InputField-input-prefixIcon--${size}`, suffixButtonIcon && `InputField-input-suffixButtonIcon--${size}`, suffixButtonType && `InputField-input-suffixButton`, isDisabled && `InputField-input--isDisabled`, (isCritical || doesValueHaveBrackets) && `InputField-input--isCritical`, isReadOnly && `InputField-input--isReadOnly`, isUsingMouse && "InputField-noOutline", className);
    const multilineClass = (0, $7XTbi$classnames)("InputField-input", `InputField--${kind}`, `InputField--${backgroundColor}`, isDisabled && `InputField-input--isDisabled`, (isCritical || doesValueHaveBrackets) && `InputField-input--isCritical`, isReadOnly && `InputField-input--isReadOnly`, isUsingMouse && "InputField-noOutline", className);
    const closeClass = (0, $7XTbi$classnames)(`InputField-closeButtonContainer`, kind === "multiline" ? "InputField-closeButtonContainer--multiline" : `InputField-closeButtonContainer--${size}`, suffixButtonType && `InputField-closeButtonContainer--suffixButton`, isReadOnly && `InputField-closeButtonContainer--isReadOnly`);
    const suffixButtonClass = (0, $7XTbi$classnames)("InputField-suffixButton", isRequired && (isCritical || doesValueHaveBrackets) && "InputField-suffixButton--isCritical", (isCritical || doesValueHaveBrackets) && "InputField-suffixButton--isCritical", isDisabled && "InputField-suffixButton--isDisabled", isReadOnly && `InputField-suffixButton--isReadOnly`);
    const clearValue = ()=>{
        setValue?.("");
        setDoesValueHaveBrackets(false);
        if (resetValue) resetValue();
    };
    const getSuffixButtonIcon = ()=>{
        switch(suffixButtonType){
            case "password":
                if (!suffixIsToggle) return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                    className: "InputField-suffixButton-icon",
                    kind: "visibilityOn",
                    visibilityOn: true,
                    size: "smallMedium"
                });
                return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                    className: "InputField-suffixButton-icon",
                    kind: "visibilityOff",
                    size: "smallMedium"
                });
            case "date":
                return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                    className: "InputField-suffixButton-icon",
                    kind: "calendar",
                    size: "smallMedium"
                });
            case "dropdown":
                return /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                    className: "InputField-suffixButton-icon",
                    children: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                        className: "InputField-suffixButton-icon",
                        kind: "chevronDown",
                        size: "smallMedium",
                        rotate: suffixIsToggle ? "180" : null
                    })
                });
            case "attachment":
                return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                    className: "InputField-suffixButton-icon",
                    kind: "Attachment",
                    size: "small",
                    color: "purple-700"
                });
            case "timePicker":
                return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                    className: "InputField-suffixButton-icon",
                    kind: "time",
                    size: "smallMedium"
                });
            case "arrowUp":
                return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                    className: "InputField-suffixButton-icon",
                    kind: "arrowUp",
                    size: "smallMedium"
                });
            default:
                return null;
        }
    };
    const checkTypeNumber = (typeValue)=>{
        if (type === "number" || inputmode === "numeric") {
            const numericValue = typeValue.replace(/\D/g, "");
            return numericValue;
        }
        return typeValue;
    };
    const onInputChange = (event)=>{
        onChange?.(event);
        if (!setValue) return;
        let valueLocal = event.target.value;
        const hasAngleBrackets = /<|>/.test(valueLocal);
        if (shouldDisallowBrackets && hasAngleBrackets) {
            setDoesValueHaveBrackets(true);
            setValue(valueLocal);
            return;
        }
        setDoesValueHaveBrackets(false);
        valueLocal = checkTypeNumber(valueLocal);
        setValue(valueLocal);
        if (valueLocal.trim().length >= minRequiredChars) {
            setDoesValueHaveBrackets(false);
            setIsCritical?.(false);
        }
    };
    const renderInlineMessage = ()=>{
        if (doesValueHaveBrackets && shouldDisallowBrackets) return bracketsErrorMsg;
        if (CriticalHelperText && isCritical) return /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
            children: CriticalHelperText
        });
        if (HelperText) return /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
            children: HelperText
        });
        return null;
    };
    const shouldRequiredAsteriskRender = Boolean(shouldDisallowBrackets ? isCritical || value?.replace(/[<>]/g, "")?.trim()?.length < minRequiredChars : isCritical || value?.trim()?.length < minRequiredChars);
    return /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
        className: "InputField-Container",
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
            className: `InputField InputField-${kind}`,
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                    className: "InputField-labelContainer",
                    children: [
                        isRequired && /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                            className: "InputField--isRequired",
                            children: shouldRequiredAsteriskRender && /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                                className: `InputField--isRequired--${isCritical ? "isCritical" : "isWarning"}`,
                                children: "*"
                            })
                        }),
                        kind !== "search" && label
                    ]
                }),
                /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                    className: "InputField-inputContainer",
                    children: [
                        kind === "multiline" ? /*#__PURE__*/ (0, $7XTbi$jsx)((0, $731fa4d5266ff6fc$export$2e2bcd8739ae039), {
                            name: name,
                            id: id,
                            ref: ref,
                            placeholder: placeholder,
                            className: multilineClass,
                            autoComplete: "off",
                            onChange: onInputChange,
                            onClick: onClick,
                            value: value,
                            isReadOnly: isReadOnly,
                            isDisabled: isDisabled,
                            isRequired: isRequired,
                            ariaDescribedBy: placeholder,
                            maxLength: maxLength,
                            rows: 4,
                            onKeyDown: onKeyDown,
                            tabIndex: isDisabled ? -1 : tabIndex,
                            textAreaMaxHeight: textAreaMaxHeight,
                            dataTestId: dataTestId
                        }) : /*#__PURE__*/ (0, $7XTbi$jsx)((0, $866a094b111604e5$export$2e2bcd8739ae039), {
                            name: name,
                            id: id,
                            ref: ref,
                            type: type,
                            inputmode: inputmode,
                            placeholder: placeholder,
                            className: inputClass,
                            autoComplete: "off",
                            onChange: onInputChange,
                            onClick: onClick,
                            value: value,
                            isReadOnly: isReadOnly,
                            isDisabled: isDisabled,
                            isRequired: isRequired,
                            ariaDescribedBy: placeholder,
                            regexPattern: regexPattern,
                            maxLength: maxLength,
                            onMouseDown: handleMouseDown,
                            onKeyDown: onKeyDown || handleKeyDown,
                            tabIndex: isDisabled ? -1 : tabIndex,
                            dataTestId: dataTestId
                        }),
                        prefixIcon && /*#__PURE__*/ (0, $7XTbi$jsx)("i", {
                            className: `InputField-prefixIcon InputField-prefixIcon--${size}`,
                            children: prefixIcon
                        }),
                        showResetButton && /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                            className: closeClass,
                            children: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $e34ff86c7a827ee6$export$2e2bcd8739ae039), {
                                size: "small",
                                kind: "saviGhost",
                                tabIndex: tabIndex,
                                className: "InputField-closeButtonIcon",
                                icon: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                                    kind: "close",
                                    color: "neutral-1000",
                                    size: "xSmall"
                                }),
                                onClick: ()=>clearValue()
                            })
                        }),
                        suffixButtonIcon && /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                            className: (0, $7XTbi$classnames)("InputField-suffixButtonIcon", `InputField-suffixButtonIcon--${size}`),
                            children: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $e34ff86c7a827ee6$export$2e2bcd8739ae039), {
                                size: "medium",
                                kind: "saviGhost",
                                icon: suffixButtonIcon,
                                onClick: suffixButtonIconOnClick
                            })
                        }),
                        suffixButtonType && /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $553ba9ca1822b2c0$export$2e2bcd8739ae039), {
                            type: "button",
                            tabIndex: isDisabled ? -1 : tabIndex,
                            onClick: ()=>suffixOnClick(),
                            isDisabled: isDisabled,
                            className: suffixButtonClass,
                            children: [
                                getSuffixButtonIcon(),
                                /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                                    "aria-hidden": "true",
                                    className: (0, $7XTbi$classnames)("InputField-suffixButton-overlay", isDisabled && "InputField-suffixButton-overlay--isDisabled")
                                })
                            ]
                        })
                    ]
                }),
                renderInlineMessage()
            ]
        })
    });
});
$5f5001b799eea6c0$var$InputField.propTypes = {
    name: (0, $7XTbi$proptypes).string.isRequired,
    id: (0, $7XTbi$proptypes).string,
    placeholder: (0, $7XTbi$proptypes).string.isRequired,
    kind: (0, $7XTbi$proptypes).oneOf([
        "search",
        "singleline",
        "multiline"
    ]),
    size: (0, $7XTbi$proptypes).oneOf(Object.values($5f5001b799eea6c0$var$SIZES)),
    type: (0, $7XTbi$proptypes).string,
    isResetButtonVisible: (0, $7XTbi$proptypes).bool,
    inputmode: (0, $7XTbi$proptypes).string,
    label: (0, $7XTbi$proptypes).element,
    isDisabled: (0, $7XTbi$proptypes).bool,
    className: (0, $7XTbi$proptypes).string,
    regexPattern: (0, $7XTbi$proptypes).string,
    isRequired: (0, $7XTbi$proptypes).bool,
    isCritical: (0, $7XTbi$proptypes).bool,
    isReadOnly: (0, $7XTbi$proptypes).bool,
    prefixIcon: (0, $7XTbi$proptypes).node,
    suffixButtonIcon: (0, $7XTbi$proptypes).node,
    CriticalHelperText: (0, $7XTbi$proptypes).node,
    HelperText: (0, $7XTbi$proptypes).node,
    suffixButtonType: (0, $7XTbi$proptypes).oneOf([
        "date",
        "password",
        "dropdown",
        "timePicker",
        "attachment",
        "arrowUp"
    ]),
    suffixIsToggle: (0, $7XTbi$proptypes).bool,
    suffixOnClick: (0, $7XTbi$proptypes).func,
    onChange: (0, $7XTbi$proptypes).func,
    onClick: (0, $7XTbi$proptypes).func,
    suffixButtonIconOnClick: (0, $7XTbi$proptypes).func,
    onKeyDown: (0, $7XTbi$proptypes).func,
    backgroundColor: (0, $7XTbi$proptypes).oneOf([
        "neutral",
        "secondary"
    ]),
    value: (0, $7XTbi$proptypes).oneOfType([
        (0, $7XTbi$proptypes).string,
        (0, $7XTbi$proptypes).number
    ]),
    setValue: (0, $7XTbi$proptypes).func,
    setIsCritical: (0, $7XTbi$proptypes).func,
    minRequiredChars: (0, $7XTbi$proptypes).number,
    maxLength: (0, $7XTbi$proptypes).number,
    shouldDisallowBrackets: (0, $7XTbi$proptypes).bool,
    tabIndex: (0, $7XTbi$proptypes).oneOfType([
        (0, $7XTbi$proptypes).number,
        (0, $7XTbi$proptypes).string
    ]),
    textAreaMaxHeight: (0, $7XTbi$proptypes).string,
    resetValue: (0, $7XTbi$proptypes).func,
    dataTestId: (0, $7XTbi$proptypes).string
};
$5f5001b799eea6c0$var$InputField.defaultProps = {
    id: null,
    type: "text",
    inputmode: "text",
    kind: "singleline",
    size: "large",
    className: null,
    regexPattern: ".*",
    label: null,
    isDisabled: false,
    isRequired: false,
    isCritical: false,
    isReadOnly: false,
    CriticalHelperText: null,
    HelperText: null,
    prefixIcon: null,
    suffixButtonIcon: null,
    suffixButtonType: null,
    suffixIsToggle: false,
    suffixOnClick: null,
    onChange: null,
    onClick: null,
    suffixButtonIconOnClick: null,
    onKeyDown: null,
    backgroundColor: "neutral",
    value: null,
    setValue: null,
    setIsCritical: null,
    minRequiredChars: 1,
    maxLength: null,
    shouldDisallowBrackets: true,
    tabIndex: 0,
    textAreaMaxHeight: "31.5rem",
    resetValue: null,
    dataTestId: null,
    isResetButtonVisible: true
};
var $5f5001b799eea6c0$export$2e2bcd8739ae039 = $5f5001b799eea6c0$var$InputField;

















function $a6b89decab5c12d4$var$Category({ data: data }) {
    return /*#__PURE__*/ (0, $7XTbi$jsxs)("span", {
        className: "Category-content",
        children: [
            data.icon,
            /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                className: "Category-text--bold",
                children: "Account"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)((0, $7XTbi$InSeparator), {}),
            /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                className: "Category-text--bold",
                children: data.platform
            })
        ]
    });
}
(0, $7XTbi$proptypes).Category = {
    data: (0, $7XTbi$proptypes).shape({
        icon: (0, $7XTbi$proptypes).element,
        account: (0, $7XTbi$proptypes).string,
        platform: (0, $7XTbi$proptypes).string
    })
};
(0, $7XTbi$proptypes).defaultProps = {
    data: null
};
var $a6b89decab5c12d4$export$2e2bcd8739ae039 = $a6b89decab5c12d4$var$Category;









function $e9d948d3cec4d879$var$AvatarText({ text: text, avatar: avatar }) {
    return /*#__PURE__*/ (0, $7XTbi$jsxs)("span", {
        className: "AvatarText",
        children: [
            avatar,
            /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                className: "AvatarText-text",
                children: text
            })
        ]
    });
}
var $e9d948d3cec4d879$export$2e2bcd8739ae039 = $e9d948d3cec4d879$var$AvatarText;





const $0e9bdb27c44e19e8$var$IconText = ({ text: text, icon: icon })=>{
    return /*#__PURE__*/ (0, $7XTbi$jsxs)("span", {
        className: "IconText",
        children: [
            icon,
            /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                className: "IconText-text",
                children: text
            })
        ]
    });
};
var $0e9bdb27c44e19e8$export$2e2bcd8739ae039 = $0e9bdb27c44e19e8$var$IconText;



const $0b19dad34cf666b8$var$KINDS = {
    iconText: "icon-text",
    avatarText: "avatar-text",
    labelValue: "label-value",
    text: "text"
};
function $0b19dad34cf666b8$var$LabelValue({ label: label, value: value }) {
    return /*#__PURE__*/ (0, $7XTbi$jsxs)("span", {
        className: "ListRow-labelValue",
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsxs)("span", {
                children: [
                    label,
                    ":\xa0"
                ]
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                className: "ListRow-text",
                children: value
            })
        ]
    });
}
function $0b19dad34cf666b8$var$Description({ data: data }) {
    return /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
        className: "ListRow-description",
        children: data.map((item, index)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                className: "ListRow-description-content",
                children: [
                    index > 0 && /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                        className: "ListRow-separator",
                        children: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $7XTbi$InterPoint), {
                            font: "body3"
                        })
                    }),
                    item.kind === "icon-text" && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $0e9bdb27c44e19e8$export$2e2bcd8739ae039), {
                        icon: item.icon,
                        text: item.text
                    }),
                    item.kind === "label-value" && /*#__PURE__*/ (0, $7XTbi$jsx)($0b19dad34cf666b8$var$LabelValue, {
                        label: item.label,
                        value: item.value
                    }),
                    item.kind === "avatar-text" && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $e9d948d3cec4d879$export$2e2bcd8739ae039), {
                        avatar: item.avatar,
                        text: item.text
                    }),
                    item.kind === "text" && /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                        className: "ListRow-description-content-text",
                        children: item.text
                    })
                ]
            }, index))
    });
}
(0, $7XTbi$proptypes).Description = {
    data: (0, $7XTbi$proptypes).arrayOf((0, $7XTbi$proptypes).shape({
        kind: (0, $7XTbi$proptypes).oneOf(Object.values($0b19dad34cf666b8$var$KINDS)).isRequired,
        icon: (0, $7XTbi$proptypes).element,
        text: (0, $7XTbi$proptypes).string,
        avatar: (0, $7XTbi$proptypes).element,
        label: (0, $7XTbi$proptypes).string,
        value: (0, $7XTbi$proptypes).string
    }))
};
(0, $7XTbi$proptypes).defaultProps = {
    data: []
};
var $0b19dad34cf666b8$export$2e2bcd8739ae039 = $0b19dad34cf666b8$var$Description;






function $bea95b8eb3515299$var$LabelValueForTitle({ label: label, value: value }) {
    return /*#__PURE__*/ (0, $7XTbi$jsxs)("span", {
        className: "ListRow-labelValue",
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsxs)("span", {
                className: "ListRow-labelValue-label",
                children: [
                    label,
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                className: "ListRow-labelValue-text",
                children: value
            })
        ]
    });
}
function $bea95b8eb3515299$var$Title({ data: data }) {
    const dataArray = Array.isArray(data) ? data : [
        data
    ];
    return /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
        className: "ListRow-title",
        children: dataArray.map((item, index)=>/*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                className: "ListRow-title-content",
                children: [
                    index > 0 && /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                        className: "ListRow-separator",
                        children: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $7XTbi$InterPoint), {
                            font: "body3"
                        })
                    }),
                    item.kind === "label-value" && /*#__PURE__*/ (0, $7XTbi$jsx)($bea95b8eb3515299$var$LabelValueForTitle, {
                        label: item.label,
                        value: item.value
                    }),
                    item.kind === "text" && item.text
                ]
            }, item.text || item.label))
    });
}
var $bea95b8eb3515299$export$2e2bcd8739ae039 = $bea95b8eb3515299$var$Title;



function $8cfc7d204d9eaf39$var$ListRowAccount({ category: category, title: title, description: description }) {
    return /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
        className: "ListRowAccount-data",
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                className: "ListRowAccount-data-category",
                children: category && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $a6b89decab5c12d4$export$2e2bcd8739ae039), {
                    data: category
                })
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                className: "ListRowAccount-data-title",
                children: title.length > 0 && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $bea95b8eb3515299$export$2e2bcd8739ae039), {
                    data: title
                })
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                className: "ListRowAccount-data-description",
                children: description.length > 0 && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $0b19dad34cf666b8$export$2e2bcd8739ae039), {
                    data: description
                })
            })
        ]
    });
}
$8cfc7d204d9eaf39$var$ListRowAccount.propTypes = {
    category: (0, $7XTbi$proptypes).shape({
        account: (0, $7XTbi$proptypes).string,
        icon: (0, $7XTbi$proptypes).node,
        platform: (0, $7XTbi$proptypes).string
    }),
    title: (0, $7XTbi$proptypes).arrayOf((0, $7XTbi$proptypes).shape({
        kind: (0, $7XTbi$proptypes).oneOf([
            "text",
            "label-value"
        ]),
        text: (0, $7XTbi$proptypes).string,
        value: (0, $7XTbi$proptypes).string
    })),
    description: (0, $7XTbi$proptypes).arrayOf((0, $7XTbi$proptypes).shape({
        kind: (0, $7XTbi$proptypes).oneOf([
            "icon-text",
            "avatar-text",
            "label-value",
            "text"
        ]).isRequired,
        icon: (0, $7XTbi$proptypes).element,
        text: (0, $7XTbi$proptypes).string,
        avatar: (0, $7XTbi$proptypes).element,
        label: (0, $7XTbi$proptypes).string,
        value: (0, $7XTbi$proptypes).string
    }))
};
$8cfc7d204d9eaf39$var$ListRowAccount.defaultProps = {
    category: null,
    title: [],
    description: []
};
var $8cfc7d204d9eaf39$export$2e2bcd8739ae039 = $8cfc7d204d9eaf39$var$ListRowAccount;








function $838d6cab6e92f326$var$ListRowSession({ title: title, description: description }) {
    return /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
        className: "ListRowSession-data",
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                className: "ListRowSession-data-title",
                children: title.length > 0 && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $bea95b8eb3515299$export$2e2bcd8739ae039), {
                    data: title
                })
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                className: "ListRowSession-data-description",
                children: description && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $0b19dad34cf666b8$export$2e2bcd8739ae039), {
                    data: description
                })
            })
        ]
    });
}
$838d6cab6e92f326$var$ListRowSession.propTypes = {
    title: (0, $7XTbi$proptypes).arrayOf((0, $7XTbi$proptypes).shape({
        kind: (0, $7XTbi$proptypes).oneOf([
            "text",
            "label-value"
        ]),
        text: (0, $7XTbi$proptypes).string,
        value: (0, $7XTbi$proptypes).string
    })),
    description: (0, $7XTbi$proptypes).arrayOf((0, $7XTbi$proptypes).shape({
        kind: (0, $7XTbi$proptypes).oneOf([
            "icon-text",
            "avatar-text",
            "label-value",
            "text"
        ]).isRequired,
        icon: (0, $7XTbi$proptypes).element,
        text: (0, $7XTbi$proptypes).string,
        avatar: (0, $7XTbi$proptypes).element,
        label: (0, $7XTbi$proptypes).string,
        value: (0, $7XTbi$proptypes).string
    }))
};
$838d6cab6e92f326$var$ListRowSession.defaultProps = {
    title: [],
    description: []
};
var $838d6cab6e92f326$export$2e2bcd8739ae039 = $838d6cab6e92f326$var$ListRowSession;








function $aaa9cfb6f823414a$var$ListRowTarget({ title: title, description: description }) {
    return /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
        className: "ListRowTarget-data",
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                className: "ListRowTarget-data-title",
                children: title.length > 0 && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $bea95b8eb3515299$export$2e2bcd8739ae039), {
                    data: title
                })
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                className: "ListRowTarget-data-description",
                children: description.length > 0 && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $0b19dad34cf666b8$export$2e2bcd8739ae039), {
                    data: description
                })
            })
        ]
    });
}
$aaa9cfb6f823414a$var$ListRowTarget.propTypes = {
    title: (0, $7XTbi$proptypes).arrayOf((0, $7XTbi$proptypes).shape({
        kind: (0, $7XTbi$proptypes).oneOf([
            "text",
            "label-value"
        ]),
        text: (0, $7XTbi$proptypes).string,
        value: (0, $7XTbi$proptypes).string
    })),
    description: (0, $7XTbi$proptypes).arrayOf((0, $7XTbi$proptypes).shape({
        kind: (0, $7XTbi$proptypes).oneOf([
            "icon-text",
            "avatar-text",
            "label-value",
            "text"
        ]).isRequired,
        icon: (0, $7XTbi$proptypes).element,
        text: (0, $7XTbi$proptypes).string,
        avatar: (0, $7XTbi$proptypes).element,
        label: (0, $7XTbi$proptypes).string,
        value: (0, $7XTbi$proptypes).string
    }))
};
$aaa9cfb6f823414a$var$ListRowTarget.defaultProps = {
    title: [],
    description: []
};
var $aaa9cfb6f823414a$export$2e2bcd8739ae039 = $aaa9cfb6f823414a$var$ListRowTarget;



const $d21d00ad66b7d185$var$KINDS = {
    account: "account",
    role: "role",
    endpoint: "endpoint",
    session: "session"
};
function $d21d00ad66b7d185$var$ListRowContent({ kind: kind, category: category, title: title, description: description }) {
    switch(kind){
        case $d21d00ad66b7d185$var$KINDS.account:
            return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $8cfc7d204d9eaf39$export$2e2bcd8739ae039), {
                category: category,
                title: title,
                description: description
            });
        case $d21d00ad66b7d185$var$KINDS.role:
        case $d21d00ad66b7d185$var$KINDS.endpoint:
            return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $aaa9cfb6f823414a$export$2e2bcd8739ae039), {
                title: title,
                description: description
            });
        case $d21d00ad66b7d185$var$KINDS.session:
            return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $838d6cab6e92f326$export$2e2bcd8739ae039), {
                title: title,
                description: description
            });
        default:
            return null;
    }
}
function $d21d00ad66b7d185$var$ListRow({ type: type, hasBookmark: hasBookmark, onRowClick: onRowClick, applicationIcon: applicationIcon, category: category, title: title, description: description, status: status, primaryIcon: primaryIcon, secondaryIcon: secondaryIcon, moreOptionsIcon: moreOptionsIcon, moreOptionOnClick: moreOptionOnClick, dataTestId: dataTestId, className: className }) {
    const classes = (0, $7XTbi$classnames)("ListRow-row-data", className);
    const bookmarkIcon = /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
        kind: "BookmarkOutline",
        color: null,
        size: "medium"
    });
    const buttonIconHandler = (e)=>{
        e.stopPropagation();
        moreOptionOnClick();
    };
    const moreOptionIcon = /*#__PURE__*/ (0, $7XTbi$jsx)((0, $e34ff86c7a827ee6$export$2e2bcd8739ae039), {
        size: "large",
        kind: "ghost",
        icon: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
            kind: "moreVertical",
            color: "navy-500"
        }),
        onClick: (e)=>buttonIconHandler(e, "moreOption")
    });
    const renderSecondaryIcon = ()=>{
        if (secondaryIcon) return /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
            className: "ListRow-icon",
            children: secondaryIcon
        });
        // for sessions, show a blank icon for alignment.
        if (type === $d21d00ad66b7d185$var$KINDS.session) return /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
            className: "ListRow-icon Listrow-iconBlank"
        });
        return null;
    };
    return /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
        className: "ListRow-container",
        onClick: onRowClick,
        role: "presentation",
        "data-testid": dataTestId,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                className: "ListRow-hover-span"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                className: classes,
                children: [
                    /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                        className: "ListRow-sectionLeft",
                        children: [
                            /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                                className: "ListRow-bookmark-badgeContainer",
                                children: hasBookmark && /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                                    className: "ListRow-bookmark",
                                    children: bookmarkIcon
                                })
                            }),
                            applicationIcon && /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                                className: "ListRow-applicationIcon",
                                children: applicationIcon
                            }),
                            /*#__PURE__*/ (0, $7XTbi$jsx)($d21d00ad66b7d185$var$ListRowContent, {
                                kind: type,
                                category: category,
                                title: title,
                                description: description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                        className: "ListRow-sectionRight",
                        children: [
                            status && /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                                className: "ListRow-status",
                                children: status
                            }),
                            primaryIcon && /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                                className: "ListRow-icon",
                                children: primaryIcon
                            }),
                            renderSecondaryIcon(),
                            /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                                className: `${moreOptionsIcon ? "ListRow-verticalIcon" : "ListRow-verticalIcon-hidden"}`,
                                children: moreOptionsIcon || moreOptionIcon
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
$d21d00ad66b7d185$var$ListRowContent.propTypes = {
    kind: (0, $7XTbi$proptypes).string,
    category: (0, $7XTbi$proptypes).shape({
        account: (0, $7XTbi$proptypes).string,
        icon: (0, $7XTbi$proptypes).node,
        platform: (0, $7XTbi$proptypes).string
    }),
    title: (0, $7XTbi$proptypes).arrayOf((0, $7XTbi$proptypes).shape({
        kind: (0, $7XTbi$proptypes).oneOf([
            "text",
            "label-value"
        ]),
        text: (0, $7XTbi$proptypes).string,
        value: (0, $7XTbi$proptypes).string
    })),
    description: (0, $7XTbi$proptypes).arrayOf((0, $7XTbi$proptypes).shape({
        kind: (0, $7XTbi$proptypes).oneOf([
            "icon-text",
            "avatar-text",
            "label-value",
            "text"
        ]).isRequired,
        icon: (0, $7XTbi$proptypes).element,
        text: (0, $7XTbi$proptypes).string,
        avatar: (0, $7XTbi$proptypes).element,
        label: (0, $7XTbi$proptypes).string,
        value: (0, $7XTbi$proptypes).string
    }))
};
$d21d00ad66b7d185$var$ListRowContent.defaultProps = {
    kind: "",
    category: null,
    title: [],
    description: []
};
$d21d00ad66b7d185$var$ListRow.propTypes = {
    applicationIcon: (0, $7XTbi$proptypes).node,
    status: (0, $7XTbi$proptypes).oneOfType([
        (0, $7XTbi$proptypes).string,
        (0, $7XTbi$proptypes).bool,
        (0, $7XTbi$proptypes).node
    ]),
    primaryIcon: (0, $7XTbi$proptypes).node,
    secondaryIcon: (0, $7XTbi$proptypes).node,
    moreOptionsIcon: (0, $7XTbi$proptypes).element,
    moreOptionOnClick: (0, $7XTbi$proptypes).func,
    onRowClick: (0, $7XTbi$proptypes).func,
    className: (0, $7XTbi$proptypes).string,
    hasBookmark: (0, $7XTbi$proptypes).bool,
    type: (0, $7XTbi$proptypes).oneOf(Object.values($d21d00ad66b7d185$var$KINDS)),
    category: (0, $7XTbi$proptypes).shape({
        account: (0, $7XTbi$proptypes).string,
        icon: (0, $7XTbi$proptypes).node,
        platform: (0, $7XTbi$proptypes).string
    }),
    title: (0, $7XTbi$proptypes).arrayOf((0, $7XTbi$proptypes).shape({
        kind: (0, $7XTbi$proptypes).oneOf([
            "text",
            "label-value"
        ]),
        text: (0, $7XTbi$proptypes).string,
        value: (0, $7XTbi$proptypes).string
    })),
    description: (0, $7XTbi$proptypes).arrayOf((0, $7XTbi$proptypes).shape({
        kind: (0, $7XTbi$proptypes).oneOf([
            "icon-text",
            "avatar-text",
            "label-value",
            "text"
        ]).isRequired,
        icon: (0, $7XTbi$proptypes).element,
        text: (0, $7XTbi$proptypes).string,
        avatar: (0, $7XTbi$proptypes).element,
        label: (0, $7XTbi$proptypes).string,
        value: (0, $7XTbi$proptypes).string
    })),
    dataTestId: (0, $7XTbi$proptypes).string
};
$d21d00ad66b7d185$var$ListRow.defaultProps = {
    applicationIcon: null,
    status: "",
    primaryIcon: null,
    secondaryIcon: null,
    moreOptionsIcon: null,
    moreOptionOnClick: ()=>{},
    onRowClick: ()=>{},
    className: null,
    hasBookmark: true,
    type: null,
    category: null,
    title: [],
    description: [],
    dataTestId: null
};
var $d21d00ad66b7d185$export$2e2bcd8739ae039 = $d21d00ad66b7d185$var$ListRow;







/* eslint-disable react/jsx-curly-spacing */ /* eslint-disable react/jsx-curly-newline */ /* eslint-disable indent */ /* eslint-disable react/jsx-props-no-spreading */ 





var $95b6a6a77b568132$exports = {};

$parcel$export($95b6a6a77b568132$exports, "useAdjustDropdownHeight", function () { return $1a24ce14a1841475$export$d269ac3552e3437f; });
$parcel$export($95b6a6a77b568132$exports, "useManageDropdownHeight", function () { return $6cb28ba18cf98155$export$28f8a6921de3d9b4; });
$parcel$export($95b6a6a77b568132$exports, "useMenuControlImperative", function () { return $aaccccad0f77307b$export$141ab6e47836fbe; });
$parcel$export($95b6a6a77b568132$exports, "useOverlayContextManager", function () { return $33f9c97b2967408a$export$2e2bcd8739ae039; });
$parcel$export($95b6a6a77b568132$exports, "useOverlayTransition", function () { return $487d37a99b6b914a$export$a734948050b9a715; });
$parcel$export($95b6a6a77b568132$exports, "useCheckboxGroup", function () { return $81f183f6a8c46f0f$export$49ff6f28c54f1cbe; });
$parcel$export($95b6a6a77b568132$exports, "useScrollbarWidth", function () { return $bdc6e08e9265483c$export$99f94e553b895c19; });
$parcel$export($95b6a6a77b568132$exports, "useTooltipText", function () { return $050849284656386f$export$5516774f584ac19; });
$parcel$export($95b6a6a77b568132$exports, "useUploadFile", function () { return $efc7314c0ba6153c$export$25a37a5353d087d9; });
/* eslint-disable import/prefer-default-export */ 
const $1a24ce14a1841475$export$d269ac3552e3437f = ({ dropdownOpenHeight: dropdownOpenHeight, dropdownRef: dropdownRef })=>{
    (0, $7XTbi$useEffect)(()=>{
        const dropdownCurrent = dropdownRef.current;
        if (!dropdownCurrent) return;
        if (dropdownOpenHeight > 0) dropdownCurrent.style.height = `${dropdownOpenHeight}px`;
    }, [
        dropdownOpenHeight,
        dropdownRef
    ]);
};


/* eslint-disable import/prefer-default-export */ 

const $6cb28ba18cf98155$export$28f8a6921de3d9b4 = ({ isOpen: isOpen, setDropdownOpenHeight: setDropdownOpenHeight, dropdownRef: dropdownRef, itemsRef: itemsRef })=>{
    (0, $7XTbi$useEffect)(()=>{
        const dropdownCurrent = dropdownRef.current;
        const menuItems = itemsRef.current;
        if (!isOpen) {
            setDropdownOpenHeight(0);
            return;
        }
        if (!dropdownCurrent || !menuItems) return;
        const initialHeight = dropdownCurrent.offsetHeight;
        if (isOpen) {
            setDropdownOpenHeight(initialHeight);
            dropdownCurrent.style.height = "0px";
            menuItems.style.overflowY = "hidden";
        }
        const timer = setTimeout(()=>{
            menuItems.style.overflowY = "auto";
            dropdownCurrent.style.height = "auto";
        }, (0, $65441b8e33d7ac73$export$18d1deb4684ad36c));
        // eslint-disable-next-line consistent-return
        return ()=>clearTimeout(timer);
    }, [
        isOpen,
        setDropdownOpenHeight,
        dropdownRef,
        itemsRef
    ]);
};


/* eslint-disable import/prefer-default-export */ 

const $aaccccad0f77307b$export$141ab6e47836fbe = (options = {})=>{
    const { mediaQueries: mediaQueries = [], targetQuery: targetQuery = "", defaultIsOpen: defaultIsOpen = false, onOpenChange: onOpenChange } = options;
    const menuRef = (0, $7XTbi$useRef)(null);
    const [mediaQueryValue, setMediaQueryValue] = (0, $7XTbi$useState)(0);
    // handle responsive state
    (0, $7XTbi$useResponsiveValueState)(setMediaQueryValue, mediaQueries);
    // find matching query
    const matchingQuery = mediaQueries.find((item)=>item.label === targetQuery);
    const isMatchingWidth = matchingQuery?.value <= mediaQueryValue;
    (0, $7XTbi$useEffect)(()=>{
        if (!menuRef.current) return;
        if (isMatchingWidth) menuRef.current.closeDropdown();
        else if (defaultIsOpen) menuRef.current.openDropdown();
        if (onOpenChange) onOpenChange(!isMatchingWidth);
    }, [
        isMatchingWidth,
        defaultIsOpen,
        onOpenChange
    ]);
    return {
        menuRef: menuRef,
        isMatchingWidth: isMatchingWidth,
        openMenu: ()=>menuRef.current?.openDropdown(),
        closeMenu: ()=>menuRef.current?.closeDropdown()
    };
}; // Temporary do not use, END








/* eslint-disable import/prefer-default-export */ 

/**
 * Custom hook to manage overlay transition states, including opening and closing animations.
 *
 * @param {boolean} isOpen
 * - Boolean indicating whether the overlay should be open.
 *
 * @param {React.RefObject} [closeButtonIconRef=null]
 * - Optional ref to the close button element, which will be focused when the overlay opens.
 *
 * @returns {Object} - Returns an object containing:
 * - `renderContent` (boolean): Whether the overlay content should be rendered.
 * - `isOpening` (boolean): Whether the overlay is in the opening transition state.
 * - `isClosing` (boolean): Whether the overlay is in the closing transition state.
 */ function $487d37a99b6b914a$export$a734948050b9a715(isOpen, closeButtonIconRef = null) {
    const [renderContent, setRenderContent] = (0, $7XTbi$useState)(false);
    const [isOpening, setIsOpening] = (0, $7XTbi$useState)(false);
    const [isClosing, setIsClosing] = (0, $7XTbi$useState)(false);
    (0, $7XTbi$useEffect)(()=>{
        let timeoutId;
        if (renderContent && closeButtonIconRef) closeButtonIconRef?.current?.focus();
        if (isOpen) {
            setRenderContent(true);
            setIsClosing(false);
            setIsOpening(false);
            timeoutId = setTimeout(()=>{
                setIsOpening(true);
            }, (0, $65441b8e33d7ac73$export$486d921bfc157ff6));
        } else if (renderContent) {
            setIsClosing(true);
            setIsOpening(false);
            timeoutId = setTimeout(()=>{
                setRenderContent(false);
                setIsClosing(false);
            }, (0, $65441b8e33d7ac73$export$aac4e82fdb62a982));
        }
        return ()=>clearTimeout(timeoutId);
    }, [
        isOpen,
        renderContent,
        closeButtonIconRef
    ]);
    return {
        renderContent: renderContent,
        isOpening: isOpening,
        isClosing: isClosing
    };
}




const $84700a637e00ff00$var$OverlayContext = /*#__PURE__*/ (0, $7XTbi$createContext)(// TODO: @Jacob, Temp fix for UI-1020, need to address wrapper for ECM envs (ModalIsland part 1)
{
    registerContentRef: ()=>{},
    unregisterContentRef: ()=>{},
    setOverlayBGColor: ()=>{}
} // TODO: END
);
const $84700a637e00ff00$export$ea8f71083e90600f = ()=>{
    const context = (0, $7XTbi$useContext)($84700a637e00ff00$var$OverlayContext);
    // TODO: @Jacob, Temp fix for UI-1020, need to address wrapper for ECM envs (ModalIsland part 1)
    if (context === undefined) {
        (0, $7XTbi$Logger).error("useOverlay must be used within an OverlayProvider");
        return {
            // TODO: @Jacob, Temp fix for UI-1020, need to address wrapper for ECM envs (ModalIsland part 1)
            registerContentRef: ()=>{},
            unregisterContentRef: ()=>{},
            setOverlayBGColor: ()=>{}
        };
    }
    return context;
};
function $84700a637e00ff00$export$c6fdb837b070b4ff({ backgroundColor: backgroundColor, dataTestId: dataTestId }) {
    const { isOverlayVisible: isOverlayVisible, highestZIndex: highestZIndex } = $84700a637e00ff00$export$ea8f71083e90600f();
    const { renderContent: renderContent, isOpening: isOpening, isClosing: isClosing } = (0, $487d37a99b6b914a$export$a734948050b9a715)(isOverlayVisible);
    const overlayClasses = (0, $7XTbi$classnames)("Neo-Overlay", isOpening && "Neo-Overlay--isOpening", isClosing && "Neo-Overlay--isClosing");
    if (!renderContent) return null;
    return /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
        className: overlayClasses,
        style: {
            background: backgroundColor,
            zIndex: highestZIndex ? highestZIndex - 1 : (0, $65441b8e33d7ac73$export$42a3bf4141986b1)
        },
        "data-testid": dataTestId
    });
}
$84700a637e00ff00$export$c6fdb837b070b4ff.propTypes = {
    backgroundColor: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string
};
$84700a637e00ff00$export$c6fdb837b070b4ff.defaultProps = {
    backgroundColor: null,
    dataTestId: null
};
function $84700a637e00ff00$export$bf688221f59024e5({ children: children }) {
    const [overlayContextStack, setOverlayContextStack] = (0, $7XTbi$useState)([]);
    const zIndexRef = (0, $7XTbi$useRef)((0, $65441b8e33d7ac73$export$42a3bf4141986b1));
    const overlayColorRef = (0, $7XTbi$useRef)((0, $65441b8e33d7ac73$export$15ea0c6dcd4860a0));
    const registerContentRef = (0, $7XTbi$useCallback)((modalRef)=>{
        const zIndex = zIndexRef.current;
        zIndexRef.current += 2; // Increment zIndex for the next modal. One for overlay and one for the conent on top.
        setOverlayContextStack((prevStack)=>[
                ...prevStack,
                {
                    modalRef: modalRef,
                    zIndex: zIndex
                }
            ]);
        return zIndex;
    }, []);
    const unregisterContentRef = (0, $7XTbi$useCallback)((modalRef)=>{
        setOverlayContextStack((prevStack)=>{
            const updatedStack = prevStack.filter((item)=>item.modalRef !== modalRef);
            // Reset zIndexRef.current if the stack is now empty
            if (updatedStack.length === 0) zIndexRef.current = (0, $65441b8e33d7ac73$export$42a3bf4141986b1);
            return updatedStack;
        });
    }, []);
    const setOverlayBGColor = (0, $7XTbi$useCallback)((bgColor)=>{
        if (bgColor) overlayColorRef.current = bgColor;
        else overlayColorRef.current = (0, $65441b8e33d7ac73$export$15ea0c6dcd4860a0);
    }, []);
    const highestZIndex = overlayContextStack.length ? Math.max(...overlayContextStack.map((item)=>item.zIndex)) : null;
    const isOverlayVisible = overlayContextStack.length > 0;
    const value = (0, $7XTbi$useMemo)(()=>({
            isOverlayVisible: isOverlayVisible,
            highestZIndex: highestZIndex,
            registerContentRef: registerContentRef,
            unregisterContentRef: unregisterContentRef,
            setOverlayBGColor: setOverlayBGColor
        }), [
        isOverlayVisible,
        highestZIndex,
        registerContentRef,
        unregisterContentRef,
        setOverlayBGColor
    ]);
    return /*#__PURE__*/ (0, $7XTbi$jsxs)($84700a637e00ff00$var$OverlayContext.Provider, {
        value: value,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)($84700a637e00ff00$export$c6fdb837b070b4ff, {
                backgroundColor: overlayColorRef.current
            }),
            children
        ]
    });
}
$84700a637e00ff00$export$bf688221f59024e5.propTypes = {
    children: (0, $7XTbi$proptypes).node
};
$84700a637e00ff00$export$bf688221f59024e5.defaultProps = {
    children: null
};
function $84700a637e00ff00$export$923364ead265c35c({ children: children }) {
    try {
        $84700a637e00ff00$export$ea8f71083e90600f(); // if not already wrapped, this will throw an error and execute the catch block
        return children; // OverlayProvider already exists, no need to wrap
    } catch  {
        return /*#__PURE__*/ (0, $7XTbi$jsx)($84700a637e00ff00$export$bf688221f59024e5, {
            children: children
        });
    }
}
$84700a637e00ff00$export$923364ead265c35c.propTypes = {
    children: (0, $7XTbi$proptypes).node.isRequired
};


/**
 * Custom hook to manage the z-index of a conetent within an overlay context.
 * Registers the conetent with the overlay context when it opens and assigns a z-index
 * for stacking. Unregisters the conetent and clears the z-index when it closes.
 *
 * @param {boolean} isOpen - Indicates whether the conetent is open.
 * @param {React.RefObject} conetentRef - React ref for the conetent element to be registered with the overlay.
 * @returns {number|null} The assigned z-index for the conetent, or null if the conetent is not open.
 */ function $33f9c97b2967408a$var$useOverlayContextManager(isOpen, contentRef, overlayBgColor) {
    const { registerContentRef: registerContentRef, unregisterContentRef: unregisterContentRef, setOverlayBGColor: setOverlayBGColor } = (0, $84700a637e00ff00$export$ea8f71083e90600f)();
    const zIndexRef = (0, $7XTbi$useRef)(null);
    (0, $7XTbi$useEffect)(()=>{
        if (isOpen) {
            zIndexRef.current = registerContentRef(contentRef);
            if (overlayBgColor && typeof overlayBgColor === "string" && overlayBgColor?.trim()?.length > 0) setOverlayBGColor(overlayBgColor);
        } else {
            unregisterContentRef(contentRef);
            setOverlayBGColor(null);
            zIndexRef.current = null;
        }
        return ()=>{
            unregisterContentRef(contentRef);
            setOverlayBGColor(null);
            zIndexRef.current = null;
        };
    }, [
        isOpen,
        contentRef,
        overlayBgColor,
        registerContentRef,
        unregisterContentRef,
        setOverlayBGColor
    ]);
    return zIndexRef.current;
}
var $33f9c97b2967408a$export$2e2bcd8739ae039 = $33f9c97b2967408a$var$useOverlayContextManager;






function $81f183f6a8c46f0f$export$49ff6f28c54f1cbe(checkboxConfigs) {
    const [checkboxStates, setCheckboxStates] = (0, $7XTbi$useState)(checkboxConfigs);
    const handleChange = (event)=>{
        const { name: name, checked: checked } = event.target;
        setCheckboxStates((prevState)=>prevState.map((checkbox)=>checkbox.name === name ? {
                    ...checkbox,
                    isChecked: checked
                } : checkbox));
    };
    const checkAllCheckboxes = ()=>{
        setCheckboxStates((prevState)=>prevState.map((checkbox)=>({
                    ...checkbox,
                    isChecked: true
                })));
    };
    const uncheckAllCheckboxes = ()=>{
        setCheckboxStates((prevState)=>prevState.map((checkbox)=>({
                    ...checkbox,
                    isChecked: false
                })));
    };
    const getCheckedNames = ()=>checkboxStates.filter((checkbox)=>checkbox.isChecked).map((checkbox)=>checkbox.name);
    const setCheckedFromArrayOfNames = (namesArray)=>setCheckboxStates((prevState)=>prevState.map((checkbox)=>({
                    ...checkbox,
                    isChecked: namesArray.includes(checkbox.name)
                })));
    const checkboxes = checkboxStates.map((checkbox)=>/*#__PURE__*/ (0, $7XTbi$jsx)((0, $ea632b95ffcf8459$export$2e2bcd8739ae039), {
            name: checkbox.name,
            dataTestId: checkbox.name,
            isChecked: checkbox.isChecked,
            onChange: handleChange,
            label: checkbox.label,
            title: checkbox?.title || null,
            isDisabled: checkbox.isDisabled,
            kind: checkbox?.kind || "text",
            size: checkbox?.size || "medium",
            showHoverLabel: checkbox?.showHoverLabel || false
        }, `Checkbox-${checkbox.name}`));
    return {
        checkboxes: checkboxes,
        checkboxStates: checkboxStates,
        checkAllCheckboxes: checkAllCheckboxes,
        uncheckAllCheckboxes: uncheckAllCheckboxes,
        getCheckedNames: getCheckedNames,
        setCheckedFromArrayOfNames: setCheckedFromArrayOfNames
    };
}


/* eslint-disable import/prefer-default-export */ 
function $bdc6e08e9265483c$export$99f94e553b895c19() {
    (0, $7XTbi$useEffect)(()=>{
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.style.setProperty("--scrollbar-width-saviynt-ds", `${scrollbarWidth}px`);
    }, []);
}


/* eslint-disable import/prefer-default-export */ 
const $050849284656386f$export$5516774f584ac19 = ({ initialText: initialText, updatedText: updatedText, closeDelay: closeDelay, closeDelayAfterClick: closeDelayAfterClick })=>{
    const [tooltipText, setTooltipText] = (0, $7XTbi$useState)(initialText);
    const [isDisabled, setIsDisabled] = (0, $7XTbi$useState)(false);
    const handleClick = ()=>{
        setTooltipText(updatedText);
        setIsDisabled(false);
    };
    // onClose will be called after the tooltip closes, resetting the text to initial
    const handleTooltipClose = ()=>{
        setTooltipText(initialText);
        setIsDisabled(true);
    };
    return {
        tooltipText: tooltipText,
        isDisabled: isDisabled,
        handleTooltipTriggerClick: handleClick,
        handleTooltipClose: handleTooltipClose,
        tooltipCloseDelay: closeDelay,
        tooltipCloseDelayAfterClick: closeDelayAfterClick
    };
};


/* eslint-disable indent */ /* eslint-disable no-continue */ /**
 * Custom hook for handling file uploads.
 *
 * @param {number} [maxFileSize=10] - Max file size allowed per file in MB. 10 is default per spec.
 * @param {number} [maxFileCount=10] - Max number of files allowed to be uploaded.
 * @param {boolean} [shouldIgnoreDuplicateFilenames=false] - Flag to determine whether to ignore duplicate filenames.
 * @param {boolean} [isReuploadWithDelete=true] - determine whether to reupload with delete (for backwards compat only).
 * @param {number} [maxTotalFileSize=50] - max total of all file size allowed in MB.
 * @param {boolean} [shouldCheckEachFileSize=true] - whether to check each file's size too.
 *
 * @returns {Object} - Object containing the uploaded files and various file handling functions.
 */ 


/* eslint-disable import/prefer-default-export */ const $6a38161dcf7a2c63$export$9f3245bec405e186 = {
    neo: {
        common: {
            browse: {
                id: "neo.common.browse",
                defaultMessage: "browse"
            }
        },
        upload: {
            fileTypeNotSupported: {
                id: "neo.upload.fileTypeNotSupported",
                defaultMessage: "File type not supported. Try again."
            },
            fileSizeExceeds: {
                id: "neo.upload.fileSizeExceeds",
                defaultMessage: "File size exceeds {maxFileSize}MB limit. Try again."
            },
            maxFilesReached: {
                id: "neo.upload.maxFilesReached",
                defaultMessage: "Max files reached."
            },
            maxUploadSizeReached: {
                id: "neo.upload.maxUploadSizeReached",
                defaultMessage: "Max upload size reached."
            },
            maxFileCount: {
                id: "neo.upload.maxFileCount",
                defaultMessage: "Max {maxFileCount} files."
            },
            maxFileSize: {
                id: "neo.upload.maxFileSize",
                defaultMessage: "Max {maxFileSizeString} per file."
            },
            allowedTypesInfoTooltip: {
                id: "neo.upload.allowedTypesInfoTooltip",
                defaultMessage: "Allows {acceptTypes} files."
            },
            dragAndDropOr: {
                id: "neo.upload.dragAndDropOr",
                defaultMessage: "Drag and drop or"
            },
            totalUploadSizeCantExceed: {
                id: "neo.upload.totalUploadSizeCantExceed",
                defaultMessage: "Total upload size can't exceed {maxTotalFileSize}MB."
            },
            attachmentSizeCantExceed: {
                id: "neo.upload.attachmentSizeCantExceed",
                defaultMessage: "Attachments can't exceed {maxFileSize}MB."
            },
            headerText: {
                id: "neo.upload.headerText",
                defaultMessage: "Upload a File"
            },
            headerTextPlural: {
                id: "neo.upload.headerTextPlural",
                defaultMessage: "Upload Files"
            }
        }
    }
};


const $efc7314c0ba6153c$var$MB_DECIMAL_PLACES = 1;
// const msgs = {
//   neo: {
//     upload: {
//       fileTypeNotSupported: {
//         id: 'neo.upload.fileTypeNotSupported',
//         defaultMessage: 'File type not supported. Try again.',
//       },
//       fileSizeExceeds: {
//         id: 'neo.upload.fileSizeExceeds',
//         defaultMessage: 'File size exceeds {maxFileSize}MB limit. Try again.',
//       },
//     },
//   },
// };
const $efc7314c0ba6153c$var$MAX_TOTAL_FILE_SIZE_REACHED_ERR_CODE = "MAX_TOTAL_FILE_SIZE_REACHED";
const $efc7314c0ba6153c$export$25a37a5353d087d9 = (maxTotalFileSize = 50, maxFileCount = 5, maxFileSize = 10, isReuploadWithDelete = true, shouldCheckEachFileSize = true, shouldIgnoreDuplicateFilenames = false // only false is supported.
)=>{
    const [uploadedFiles, setUploadedFiles] = (0, $7XTbi$useState)([]);
    const [reuploadFileName, setReuploadFileName] = (0, $7XTbi$useState)(null);
    const [isMaxTotalSizeReached, setIsMaxTotalSizeReached] = (0, $7XTbi$useState)(false);
    const intl = (0, $7XTbi$useIntl)();
    const FILE_TYPE_NOT_SUPPORTED_TEXT = (0, $7XTbi$localize)(intl, (0, $6a38161dcf7a2c63$export$9f3245bec405e186).neo.upload.fileTypeNotSupported);
    // convert MB to KB below for error message
    const FILE_SIZE_EXCEEDS_ERR_MSG = (0, $7XTbi$localize)(intl, (0, $6a38161dcf7a2c63$export$9f3245bec405e186).neo.upload.fileSizeExceeds, {
        maxFileSize: maxFileSize && maxFileSize.toString().includes(".") ? maxFileSize.toFixed($efc7314c0ba6153c$var$MB_DECIMAL_PLACES) : maxFileSize
    });
    const getTotalFileSize = (files)=>files.reduce((total, f)=>total + f.fileSize, 0);
    const handleFileSelect = async (files, allowedFileTypes)=>{
        let currentProcessedFileSize = 0; // total size of files processed in loop so far
        const allowedExtensions = allowedFileTypes ? allowedFileTypes.map((type)=>type.replace(".", "")) : null;
        let filesToProcess = files.slice(0, maxFileCount - uploadedFiles.length);
        // when reuploading, process only the first file
        if (reuploadFileName) filesToProcess = [
            files[0]
        ];
        const fileObjects = [];
        // eslint doesn't like the for...of loop.
        for(let i = 0; i < filesToProcess.length; i += 1){
            currentProcessedFileSize += filesToProcess[i].size;
            let fileName = filesToProcess[i].name;
            const fileExtension = fileName.split(".").pop();
            const isDuplicate = uploadedFiles.some((f)=>f.fileName === fileName) && fileName !== reuploadFileName;
            if (isDuplicate) {
                if (shouldIgnoreDuplicateFilenames) continue;
                fileName = `${fileName.replace(`.${fileExtension}`, "")}-${(0, $7XTbi$getRandomString)()}.${fileExtension}`;
            }
            const totalSizeAllFiles = getTotalFileSize(uploadedFiles) + +filesToProcess[i].size;
            if (currentProcessedFileSize / (0, $7XTbi$BYTES_PER_MB) > maxTotalFileSize || totalSizeAllFiles / (0, $7XTbi$BYTES_PER_MB) > maxTotalFileSize) {
                setIsMaxTotalSizeReached(true);
                fileObjects.push({
                    file: filesToProcess[i],
                    fileName: fileName,
                    fileSize: filesToProcess[i].size,
                    isError: true,
                    errorCode: $efc7314c0ba6153c$var$MAX_TOTAL_FILE_SIZE_REACHED_ERR_CODE,
                    errorMessage: (0, $7XTbi$localize)(intl, (0, $6a38161dcf7a2c63$export$9f3245bec405e186).neo.upload.totalUploadSizeCantExceed, {
                        maxTotalFileSize: maxTotalFileSize && maxTotalFileSize.toString().includes(".") ? maxTotalFileSize.toFixed($efc7314c0ba6153c$var$MB_DECIMAL_PLACES) : maxTotalFileSize
                    }),
                    isUploading: false,
                    id: Date.now() + Math.random()
                });
                break; // stop processing files if maxTotalFileSize is reached
            }
            if (shouldCheckEachFileSize) {
                if (filesToProcess[i].size / (0, $7XTbi$BYTES_PER_MB) > maxFileSize) {
                    fileObjects.push({
                        file: filesToProcess[i],
                        fileName: fileName,
                        fileSize: filesToProcess[i].size,
                        isError: true,
                        errorMessage: FILE_SIZE_EXCEEDS_ERR_MSG,
                        isUploading: false,
                        id: Date.now() + Math.random()
                    });
                    continue;
                }
            }
            if (allowedExtensions && !allowedExtensions.includes(fileExtension)) {
                fileObjects.push({
                    file: filesToProcess[i],
                    fileName: fileName,
                    fileSize: filesToProcess[i].size,
                    isError: true,
                    errorMessage: FILE_TYPE_NOT_SUPPORTED_TEXT,
                    isUploading: false,
                    id: Date.now() + Math.random()
                });
                continue;
            }
            fileObjects.push({
                file: filesToProcess[i],
                fileName: fileName,
                fileSize: filesToProcess[i].size,
                isError: false,
                errorMessage: "",
                isUploading: true,
                id: Date.now() + Math.random()
            });
        }
        // add new files and update reuploaded file in the state.
        // if reuploading and isReuploadWithDelete, the previous file has already been deleted.
        if (isReuploadWithDelete) setUploadedFiles((currentFiles)=>[
                ...currentFiles,
                ...fileObjects
            ]);
        else // old behavior for backwards compatibility (reupload cancel button broken)
        setUploadedFiles((currentFiles)=>{
            if (reuploadFileName) return currentFiles.map((file)=>file.fileName === reuploadFileName ? {
                    ...fileObjects[0]
                } : file);
            return [
                ...currentFiles,
                ...fileObjects
            ];
        });
        if (reuploadFileName) setReuploadFileName(null);
    };
    const handleFileDelete = (fileName)=>{
        setUploadedFiles((currentFiles)=>{
            const newFiles = currentFiles.filter((file)=>file.fileName !== fileName);
            const totalFileSize = getTotalFileSize(newFiles);
            if (totalFileSize / (0, $7XTbi$BYTES_PER_MB) < maxTotalFileSize) {
                setIsMaxTotalSizeReached(false);
                return newFiles.map((file)=>{
                    let { isError: isError } = file;
                    let { errorMessage: errorMessage } = file;
                    // reset the error code for file(s) with the max total size error
                    if (file?.errorCode === $efc7314c0ba6153c$var$MAX_TOTAL_FILE_SIZE_REACHED_ERR_CODE) {
                        isError = false;
                        errorMessage = "";
                    }
                    // add maxFileSize error if it's (now) over the maxFileSize
                    if (shouldCheckEachFileSize && file.fileSize / (0, $7XTbi$BYTES_PER_MB) > maxFileSize) {
                        isError = true;
                        errorMessage = FILE_SIZE_EXCEEDS_ERR_MSG;
                    }
                    return {
                        ...file,
                        isError: isError,
                        errorMessage: errorMessage
                    };
                });
            }
            return newFiles;
        });
    };
    const handleFileReupload = (fileName)=>{
        // reset the error state of the file being reuploaded
        if (!isReuploadWithDelete) setUploadedFiles((currentFiles)=>currentFiles.map((file)=>file.fileName === fileName ? {
                    ...file,
                    isError: false,
                    errorMessage: ""
                } : file));
        setReuploadFileName(fileName);
    };
    const hasAnyUploadErrors = uploadedFiles.some((file)=>file.isError);
    return {
        uploadedFiles: uploadedFiles,
        handleFileSelect: handleFileSelect,
        handleFileDelete: handleFileDelete,
        handleFileReupload: handleFileReupload,
        reuploadFileName: reuploadFileName,
        isMaxNumberUploaded: uploadedFiles.length >= maxFileCount,
        maxFileCount: Number(maxFileCount),
        maxFileSize: Number(maxFileSize),
        maxTotalFileSize: Number(maxTotalFileSize),
        isMaxTotalSizeReached: isMaxTotalSizeReached,
        hasAnyUploadErrors: hasAnyUploadErrors
    };
};













// TODO: Update label to use Typography
function $d6f276bb47558b59$var$MenuItem({ option: option, label: label, selectedValue: selectedValue, onClick: onClick, className: className, prefixIcon: prefixIcon, suffixIcon: suffixIcon, isMulti: isMulti, tabIndex: tabIndex, menuItemHeightConfigs: menuItemHeightConfigs }) {
    const { label: optionLabel, value: value, isDisabled: isDisabled, isChecked: isChecked } = option;
    const handleOptionClick = (event)=>{
        // prevent the default behavior and event bubbling.
        event.preventDefault();
        event.stopPropagation();
        if (isDisabled) return;
        onClick(event.target);
    };
    const inlineHeightStyle = menuItemHeightConfigs && {
        minHeight: menuItemHeightConfigs.minHeight,
        height: menuItemHeightConfigs.height,
        maxHeight: menuItemHeightConfigs.maxHeight
    };
    return /*#__PURE__*/ (0, $7XTbi$jsxs)("li", {
        onClick: handleOptionClick,
        className: (0, $7XTbi$classnames)("MenuItem", isDisabled && "MenuItem--isDisabled", isChecked && "MenuItem--isChecked", prefixIcon && "MenuItem--hasPrefix", suffixIcon && "MenuItem--hasSuffix", isMulti && "MenuItem--isMulti", className),
        style: inlineHeightStyle,
        role: "option",
        "aria-selected": selectedValue && selectedValue.value === value,
        tabIndex: isDisabled ? -1 : tabIndex,
        onKeyDown: (e)=>{
            if (e.key === "Enter" || e.key === " ") handleOptionClick(e);
        },
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsxs)("span", {
                className: "MenuItem-prefixIconAndLabel",
                children: [
                    prefixIcon,
                    /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                        className: "MenuItem-prefixIconAndLabel-label",
                        children: label || optionLabel
                    })
                ]
            }),
            suffixIcon && isChecked && /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                className: "MenuItem-suffixIcon",
                children: suffixIcon
            })
        ]
    }, value);
}
$d6f276bb47558b59$var$MenuItem.propTypes = {
    option: (0, $7XTbi$proptypes).shape({
        label: (0, $7XTbi$proptypes).string.isRequired,
        value: (0, $7XTbi$proptypes).string.isRequired,
        isDisabled: (0, $7XTbi$proptypes).bool,
        isChecked: (0, $7XTbi$proptypes).bool
    }).isRequired,
    label: (0, $7XTbi$proptypes).string,
    selectedValue: (0, $7XTbi$proptypes).shape({
        label: (0, $7XTbi$proptypes).string,
        value: (0, $7XTbi$proptypes).string
    }),
    onClick: (0, $7XTbi$proptypes).func.isRequired,
    className: (0, $7XTbi$proptypes).string,
    prefixIcon: (0, $7XTbi$proptypes).element,
    suffixIcon: (0, $7XTbi$proptypes).element,
    tabIndex: (0, $7XTbi$proptypes).oneOfType([
        (0, $7XTbi$proptypes).number,
        (0, $7XTbi$proptypes).string
    ]),
    isMulti: (0, $7XTbi$proptypes).bool,
    menuItemHeightConfigs: (0, $7XTbi$proptypes).shape({
        minHeight: (0, $7XTbi$proptypes).string || null,
        height: (0, $7XTbi$proptypes).string || null,
        maxHeight: (0, $7XTbi$proptypes).string || null
    })
};
$d6f276bb47558b59$var$MenuItem.defaultProps = {
    label: null,
    selectedValue: null,
    className: null,
    prefixIcon: null,
    suffixIcon: null,
    tabIndex: -1,
    isMulti: false,
    menuItemHeightConfigs: {
        minHeight: null,
        height: null,
        maxHeight: null
    }
};
var $d6f276bb47558b59$export$2e2bcd8739ae039 = $d6f276bb47558b59$var$MenuItem;


/* eslint-disable react/jsx-wrap-multilines */ /* eslint-disable react/jsx-curly-spacing */ 







function $d3ee76d8fa05c77a$var$MenuMultiSearchBar({ text: text, setText: setText, hasHeaderText: hasHeaderText, className: className, tabIndex: tabIndex, onKeyDown: onKeyDown, dataTestId: dataTestId }) {
    return /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
        className: (0, $7XTbi$classnames)("MenuMultiSearchBar", hasHeaderText && "MenuMultiSearchBar--hasHeaderText", className),
        "data-testid": dataTestId,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5f5001b799eea6c0$export$2e2bcd8739ae039), {
            name: "basic",
            placeholder: "Search",
            label: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5f880a93b57cab01$export$2e2bcd8739ae039), {
                kind: "label",
                htmlFor: "Label",
                children: "Label"
            }),
            kind: "search",
            size: "small",
            prefixIcon: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                kind: "search",
                color: "neutral-600",
                size: "smallMedium"
            }),
            onKeyDown: onKeyDown,
            value: text,
            setValue: setText,
            tabIndex: tabIndex
        })
    });
}
$d3ee76d8fa05c77a$var$MenuMultiSearchBar.propTypes = {
    text: (0, $7XTbi$proptypes).string.isRequired,
    setText: (0, $7XTbi$proptypes).func.isRequired,
    hasHeaderText: (0, $7XTbi$proptypes).string,
    onKeyDown: (0, $7XTbi$proptypes).func,
    className: (0, $7XTbi$proptypes).string,
    tabIndex: (0, $7XTbi$proptypes).oneOfType([
        (0, $7XTbi$proptypes).number,
        (0, $7XTbi$proptypes).string
    ]),
    dataTestId: (0, $7XTbi$proptypes).string
};
$d3ee76d8fa05c77a$var$MenuMultiSearchBar.defaultProps = {
    hasHeaderText: null,
    onKeyDown: null,
    className: null,
    tabIndex: 0,
    dataTestId: null
};
var $d3ee76d8fa05c77a$export$2e2bcd8739ae039 = $d3ee76d8fa05c77a$var$MenuMultiSearchBar;


/* eslint-disable import/prefer-default-export */ 
/**
 * Toggles the visibility of a dropdown menu, either opening or closing it based on the current state or a forced state.
 *
 * This function controls the dropdown's open/close animation and manages the state of the dropdown based on
 * provided parameters. When `forceState` is specified, it will directly open (`true`) or close (`false`) the dropdown.
 * Otherwise, it toggles based on the current `isOpen` state.
 *
 * @param {Object} params - Parameters for toggling the dropdown menu.
 * @param {boolean} params.isOpen - Current state of the dropdown; `true` if open, `false` if closed.
 * @param {function} params.setIsOpen - Function to update the `isOpen` state.
 * @param {function} [params.setIsExpanded] - Optional function to update an expanded state for the dropdown.
 * @param {React.MutableRefObject} params.dropdownRef - Reference to the dropdown container element.
 * @param {React.MutableRefObject} params.itemsRef - Reference to the dropdown menu items container.
 * @param {boolean} params.isMultiInput - If `true`, disables toggling; useful when multiple inputs control the dropdown.
 * @param {boolean|null} [params.forceState=null] - Optional parameter to explicitly set the dropdown state;
 *`true` opens the dropdown, `false` closes it, and `null` toggles.
 *
 * @example
 * const toggleDropdown = useCallback(
 *   (event, forceState) => {
 *     if (event?.stopPropagation) event.stopPropagation();
 *
 *     toggleDropdownMenu({
 *       isOpen,
 *       setIsOpen,
 *       setIsExpanded,
 *       dropdownRef,
 *       itemsRef,
 *       isMultiInput: false,
 *       forceState,
 *     });
 *   },
 *   [isOpen, setIsExpanded, dropdownRef, itemsRef]
 * );
 *
 * @returns {void}
 */ const $796a738a4119b82b$export$ebc10a939cccbd3f = ({ isOpen: isOpen, setIsOpen: setIsOpen, setIsExpanded: setIsExpanded, dropdownRef: dropdownRef, itemsRef: itemsRef, isMultiInput: isMultiInput, forceState: forceState = null })=>{
    if (isMultiInput) return;
    // Determine the target state based on `forceState`
    const targetState = forceState ?? !isOpen;
    if (!targetState) {
        // Closing dropdown
        const dropdownCurrent = dropdownRef.current;
        const menuItems = itemsRef.current;
        if (dropdownCurrent && menuItems) {
            const currentHeight = dropdownCurrent.offsetHeight;
            dropdownCurrent.style.height = `${currentHeight}px`;
            setTimeout(()=>{
                dropdownCurrent.style.height = "0px";
                menuItems.style.overflowY = "hidden";
            }, (0, $65441b8e33d7ac73$export$486d921bfc157ff6));
            setTimeout(()=>{
                setIsOpen(false);
                if (setIsExpanded) setIsExpanded(false);
            }, (0, $65441b8e33d7ac73$export$18d1deb4684ad36c));
        }
    } else {
        // Opening dropdown
        setIsOpen(true);
        if (setIsExpanded) setIsExpanded(true);
    }
};



const $9ef6121f0a4af6a4$var$KINDS = {
    DEFAULT: "default",
    SIMPLE: "simple"
};
const { MENU_TRIGGER: $9ef6121f0a4af6a4$var$MENU_TRIGGER } = (0, $65441b8e33d7ac73$export$800daf5fbbe96aff);
// TODO: Future iteration consider removing kind simple
const $9ef6121f0a4af6a4$var$Menu = /*#__PURE__*/ (0, $7XTbi$forwardRef)(({ kind: kind, options: options, trigger: trigger, CustomMenuItems: CustomMenuItems, CustomMenu: CustomMenu, label: label, setIsExpanded: setIsExpanded, onChange: onChange, shouldCloseMenuOnItemClick: shouldCloseMenuOnItemClick, size: size, offset: offset, crossAxisOffset: crossAxisOffset, placement: placement, isPlacementLocked: isPlacementLocked, fallbackAxisSideDirection: fallbackAxisSideDirection, fallbackPlacements: fallbackPlacements, minOptionsForSearch: minOptionsForSearch, onSearchTermChange: onSearchTermChange, dataTestId: dataTestId, className: className }, ref)=>{
    const [isOpen, setIsOpen] = (0, $7XTbi$useState)(false);
    const [dropdownOpenHeight, setDropdownOpenHeight] = (0, $7XTbi$useState)(0);
    const [searchText, setSearchText] = (0, $7XTbi$useState)("");
    const wrapperRef = (0, $7XTbi$useRef)(null);
    const dropdownRef = (0, $7XTbi$useRef)(null);
    const itemsRef = (0, $7XTbi$useRef)(null);
    const selectedElement = options?.find((option)=>option.isChecked);
    const showSearchBar = options.length >= minOptionsForSearch;
    const menuWrapperClasses = (0, $7XTbi$classnames)("Menu", `Menu--${kind}`, isOpen && "Menu--isOpen", className);
    const menuTriggerClasses = (0, $7XTbi$classnames)("Menu-trigger");
    const menuDropdownClasses = (0, $7XTbi$classnames)("Menu-dropdown", size && `Menu-dropdown--${size}`);
    const itemsClasses = (0, $7XTbi$classnames)("Menu-items");
    // Hooks and open toggle used for transitions
    (0, $6cb28ba18cf98155$export$28f8a6921de3d9b4)({
        isOpen: isOpen,
        setDropdownOpenHeight: setDropdownOpenHeight,
        dropdownRef: dropdownRef,
        itemsRef: itemsRef
    });
    (0, $1a24ce14a1841475$export$d269ac3552e3437f)({
        dropdownOpenHeight: dropdownOpenHeight,
        dropdownRef: dropdownRef
    });
    const toggleDropdown = (0, $7XTbi$useCallback)((event, forceState)=>{
        if (event?.stopPropagation) event.stopPropagation();
        (0, $796a738a4119b82b$export$ebc10a939cccbd3f)({
            isOpen: isOpen,
            setIsOpen: setIsOpen,
            setIsExpanded: setIsExpanded,
            dropdownRef: dropdownRef,
            itemsRef: itemsRef,
            isMultiInput: false,
            forceState: forceState
        });
    }, [
        isOpen,
        setIsExpanded,
        dropdownRef,
        itemsRef
    ]);
    (0, $7XTbi$useOutsideClickEffect)(wrapperRef, (event)=>toggleDropdown(event), isOpen);
    // Pass the event handler to the parent for maximum flexability
    const handleOptionClick = (option)=>{
        onChange(option);
        if (shouldCloseMenuOnItemClick) toggleDropdown();
    };
    const handleSelectFirstOption = ()=>{
        const matchingOption = options.find((option)=>!option.isDisabled && option?.label?.toLowerCase().startsWith(searchText?.toLowerCase()));
        (0, $7XTbi$Logger).info("matchingOption", matchingOption);
        if (isOpen && matchingOption) handleOptionClick(matchingOption);
    };
    const handleKeyDown = (event)=>{
        switch(event.key){
            case "Escape":
                toggleDropdown(); // close dropdown
                break;
            case "Enter":
                handleSelectFirstOption(); // select first option that's not disabled
                break;
            default:
                if (!isOpen) setIsOpen(true);
                break;
        }
    };
    // Can be used by the parent to close Menu. Retains Menu local open state and will still use the transitions
    (0, $7XTbi$useImperativeHandle)(ref, ()=>({
            closeDropdown () {
                toggleDropdown(null, false);
            },
            openDropdown () {
                toggleDropdown(null, true);
            }
        }));
    const getFilteredOptions = (0, $7XTbi$useMemo)(()=>{
        // clone the options array to avoid mutating props.
        const optionsClone = [
            ...options
        ];
        // filter based on the search text
        const lowerSearchText = searchText.toLowerCase();
        return optionsClone.filter((option)=>option.label.toLowerCase().includes(lowerSearchText));
    }, [
        options,
        searchText
    ]);
    const renderSearchBar = ()=>/*#__PURE__*/ (0, $7XTbi$jsx)((0, $d3ee76d8fa05c77a$export$2e2bcd8739ae039), {
            text: searchText,
            setText: (value)=>{
                setSearchText(value);
                onSearchTermChange(value);
            },
            tabIndex: isOpen ? 0 : -1,
            onKeyDown: handleKeyDown,
            dataTestId: "menumulti-searchbar"
        });
    const renderTrigger = ()=>trigger ? /*#__PURE__*/ (0, $7XTbi$cloneElement)(trigger, {
            isOpen: isOpen,
            onClick: (event)=>toggleDropdown(event),
            dataTestId: $9ef6121f0a4af6a4$var$MENU_TRIGGER
        }) : /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $553ba9ca1822b2c0$export$2e2bcd8739ae039), {
            type: "button",
            className: "Menu-button",
            onClick: (event)=>toggleDropdown(event),
            dataTestId: $9ef6121f0a4af6a4$var$MENU_TRIGGER,
            "aria-pressed": isOpen,
            children: [
                label || selectedElement?.label || options?.[0]?.label,
                /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                    kind: "ButtonSelectChevronDown",
                    size: "xSmall",
                    rotate: isOpen ? "180" : null
                })
            ]
        });
    const renderMenuItems = ()=>{
        const optionsToRender = showSearchBar && searchText !== "" ? getFilteredOptions : options;
        return optionsToRender.map((option)=>/*#__PURE__*/ (0, $7XTbi$jsx)((0, $7XTbi$react).Fragment, {
                children: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $d6f276bb47558b59$export$2e2bcd8739ae039), {
                    option: option,
                    onClick: ()=>!option.isDisabled && handleOptionClick(option),
                    isDisabled: option.isDisabled,
                    tabIndex: isOpen ? 0 : -1,
                    prefixIcon: option.icon && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                        kind: option.icon
                    })
                }, option.value)
            }, option.value));
    };
    // Floating UI options
    const { refs: refs, floatingStyles: originalFloatingStyles, context: context } = (0, $7XTbi$useFloating)({
        open: isOpen,
        onOpenChange: toggleDropdown,
        placement: placement,
        middleware: [
            (0, $7XTbi$flip)(!isPlacementLocked ? {
                fallbackAxisSideDirection: fallbackAxisSideDirection,
                fallbackPlacements: fallbackPlacements
            } : {
                mainAxis: false
            }),
            (0, $7XTbi$offset)({
                mainAxis: offset,
                crossAxis: crossAxisOffset
            }),
            (0, $7XTbi$shift)()
        ],
        whileElementsMounted: (0, $7XTbi$autoUpdate)
    });
    const floatingStyles = {
        ...originalFloatingStyles
    };
    const clickInteraction = (0, $7XTbi$useClick)(context);
    const dismissInteraction = (0, $7XTbi$useDismiss)(context);
    const roleInteraction = (0, $7XTbi$useRole)(context);
    const { getReferenceProps: getReferenceProps, getFloatingProps: getFloatingProps } = (0, $7XTbi$useInteractions)([
        clickInteraction,
        dismissInteraction,
        roleInteraction
    ]);
    const setDropdownRefs = (0, $7XTbi$useCallback)((node)=>{
        dropdownRef.current = node;
        refs.setFloating(node);
    }, [
        refs
    ]);
    if (CustomMenu) return /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
        tag: "div",
        ref: wrapperRef,
        role: "combobox",
        "aria-controls": "custom-menu-dropdown-box",
        "aria-expanded": isOpen,
        "aria-label": label,
        className: menuWrapperClasses,
        dataTestId: dataTestId,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                ref: refs.setReference,
                ...getReferenceProps(),
                className: menuTriggerClasses,
                children: renderTrigger()
            }),
            isOpen && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $7XTbi$FloatingFocusManager), {
                context: context,
                modal: false,
                children: /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                    className: menuDropdownClasses,
                    ref: setDropdownRefs,
                    style: floatingStyles,
                    ...getFloatingProps(),
                    children: /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                        className: "Menu-customMenu",
                        ref: itemsRef,
                        children: CustomMenu
                    })
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
        tag: "div",
        ref: wrapperRef,
        role: "combobox",
        "aria-controls": "custom-select-listbox",
        "aria-expanded": isOpen,
        "aria-label": label,
        className: menuWrapperClasses,
        dataTestId: dataTestId,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                ref: refs.setReference,
                ...getReferenceProps(),
                className: menuTriggerClasses,
                children: renderTrigger()
            }),
            isOpen && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $7XTbi$FloatingFocusManager), {
                context: context,
                modal: false,
                children: /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                    className: menuDropdownClasses,
                    ref: setDropdownRefs,
                    style: floatingStyles,
                    ...getFloatingProps(),
                    children: [
                        showSearchBar && renderSearchBar(),
                        /*#__PURE__*/ (0, $7XTbi$jsx)("ul", {
                            className: itemsClasses,
                            ref: itemsRef,
                            role: "listbox",
                            tabIndex: "-1",
                            children: CustomMenuItems || renderMenuItems()
                        })
                    ]
                })
            })
        ]
    });
});
$9ef6121f0a4af6a4$var$Menu.propTypes = {
    kind: (0, $7XTbi$proptypes).oneOf(Object.values($9ef6121f0a4af6a4$var$KINDS)),
    options: (0, $7XTbi$proptypes).arrayOf((0, $7XTbi$proptypes).shape({
        label: (0, $7XTbi$proptypes).string,
        value: (0, $7XTbi$proptypes).string,
        isDisabled: (0, $7XTbi$proptypes).bool,
        isChecked: (0, $7XTbi$proptypes).bool,
        icon: (0, $7XTbi$proptypes).string
    })),
    trigger: (0, $7XTbi$proptypes).element,
    CustomMenuItems: (0, $7XTbi$proptypes).element,
    CustomMenu: (0, $7XTbi$proptypes).element,
    label: (0, $7XTbi$proptypes).string,
    setIsExpanded: (0, $7XTbi$proptypes).func,
    onChange: (0, $7XTbi$proptypes).func,
    shouldCloseMenuOnItemClick: (0, $7XTbi$proptypes).bool,
    size: (0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$413a4c2603eff4ae))),
    offset: (0, $7XTbi$proptypes).number,
    crossAxisOffset: (0, $7XTbi$proptypes).number,
    placement: (0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$5aa24cb5f38e9127))),
    isPlacementLocked: (0, $7XTbi$proptypes).bool,
    fallbackAxisSideDirection: (0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$f37fc697bac1ac))),
    fallbackPlacements: (0, $7XTbi$proptypes).arrayOf((0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$5aa24cb5f38e9127)))),
    minOptionsForSearch: (0, $7XTbi$proptypes).number,
    onSearchTermChange: (0, $7XTbi$proptypes).func,
    className: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string
};
$9ef6121f0a4af6a4$var$Menu.defaultProps = {
    kind: $9ef6121f0a4af6a4$var$KINDS.SIMPLE,
    options: [],
    trigger: null,
    CustomMenuItems: null,
    CustomMenu: null,
    label: null,
    setIsExpanded: ()=>{},
    onChange: ()=>{},
    shouldCloseMenuOnItemClick: true,
    size: null,
    offset: 8,
    crossAxisOffset: 0,
    placement: (0, $65441b8e33d7ac73$export$5aa24cb5f38e9127).BOTTOM_START,
    isPlacementLocked: false,
    fallbackAxisSideDirection: (0, $65441b8e33d7ac73$export$f37fc697bac1ac).END,
    fallbackPlacements: null,
    minOptionsForSearch: 6,
    onSearchTermChange: ()=>{},
    className: null,
    dataTestId: null
};
var $9ef6121f0a4af6a4$export$2e2bcd8739ae039 = $9ef6121f0a4af6a4$var$Menu;


/* eslint-disable indent */ /* eslint-disable react/jsx-props-no-spreading */ 















const $e27c03c18d801a90$var$msgs = {
    neo: {
        common: {
            inputPlaceholder: {
                id: "neo.common.inputPlaceholder",
                defaultMessage: "Type to search"
            },
            loadingText: {
                id: "neo.common.loadingText",
                defaultMessage: "Loading..."
            },
            noDataAvailable: {
                id: "neo.common.noDataAvailable",
                defaultMessage: "No data available"
            }
        }
    }
};
// TODO: MenuInput Input Value needs to be handled and tested more effectively, see WIP todo list below
// 1. MenuInput Multiselect: should display selected values
// 2. MenuInput Search Disabled: Is not blocking search
function $e27c03c18d801a90$var$MenuInput({ options: options, hasMoreOptions: hasMoreOptions, selectedOptions: selectedOptions, setSelectedOptions: setSelectedOptions, label: label, onChange: onChange, setIsExpanded: setIsExpanded, backgroundColor: backgroundColor, isLoading: isLoading, loadingText: loadingText, CriticalHelperText: CriticalHelperText, isCritical: isCritical, isSearchDisabled: isSearchDisabled, isReadOnly: isReadOnly, placeholder: placeholder, isMulti: isMulti, noDataText: noDataText, menuItemHeightConfigs: menuItemHeightConfigs, searchTerm: searchTerm, setSearchTerm: setSearchTerm, onInputReset: onInputReset, onScroll: onScroll, onSearchTermChange: onSearchTermChange, prefixIcon: prefixIcon, suffixIcon: suffixIcon, size: // Floating UI
size, offset: offset, placement: placement, isPlacementLocked: isPlacementLocked, fallbackAxisSideDirection: fallbackAxisSideDirection, fallbackPlacements: fallbackPlacements, className: // Utils
className, dropdownClassName: dropdownClassName, dataTestId: dataTestId, inputFieldTestId: inputFieldTestId }) {
    const [isOpen, setIsOpen] = (0, $7XTbi$useState)(false);
    const [dropdownOpenHeight, setDropdownOpenHeight] = (0, $7XTbi$useState)(0);
    const [searchText, setSearchText] = (0, $7XTbi$useState)(searchTerm); // for input search.
    const wrapperRef = (0, $7XTbi$useRef)(null);
    const dropdownRef = (0, $7XTbi$useRef)(null);
    const itemsRef = (0, $7XTbi$useRef)(null);
    const inputRef = (0, $7XTbi$useRef)(null);
    const intl = (0, $7XTbi$useIntl)();
    const PLACEHOLDER = (0, $7XTbi$localize)(intl, $e27c03c18d801a90$var$msgs.neo.common.inputPlaceholder);
    const LOADING_TEXT = (0, $7XTbi$localize)(intl, $e27c03c18d801a90$var$msgs.neo.common.loadingText);
    const NO_DATA_AVAILABLE_TEXT = (0, $7XTbi$localize)(intl, $e27c03c18d801a90$var$msgs.neo.common.noDataAvailable);
    const menuWrapperClasses = (0, $7XTbi$classnames)("MenuInput", suffixIcon && "MenuInput--hasSuffixIcon", isOpen && "MenuInput--isOpen", className);
    const menuTriggerClasses = (0, $7XTbi$classnames)("MenuInput-trigger");
    const menuDropdownClasses = (0, $7XTbi$classnames)("MenuInput-dropdown", size && `MenuInput-dropdown--${size}`, dropdownClassName);
    const itemsClasses = (0, $7XTbi$classnames)("MenuInput-items");
    (0, $7XTbi$useEffect)(()=>{
        if (isOpen && inputRef.current) inputRef.current.focus();
    }, [
        isOpen
    ]);
    // Hooks and open toggle used for transitions
    (0, $6cb28ba18cf98155$export$28f8a6921de3d9b4)({
        isOpen: isOpen,
        setDropdownOpenHeight: setDropdownOpenHeight,
        dropdownRef: dropdownRef,
        itemsRef: itemsRef
    });
    (0, $1a24ce14a1841475$export$d269ac3552e3437f)({
        dropdownOpenHeight: dropdownOpenHeight,
        dropdownRef: dropdownRef
    });
    const toggleDropdown = (0, $7XTbi$useCallback)((event, forceState, shouldNotClose = false)=>{
        if (event?.stopPropagation) event.stopPropagation();
        (0, $796a738a4119b82b$export$ebc10a939cccbd3f)({
            isOpen: isOpen,
            setIsOpen: setIsOpen,
            setIsExpanded: setIsExpanded,
            dropdownRef: dropdownRef,
            itemsRef: itemsRef,
            isMultiInput: shouldNotClose,
            forceState: forceState
        });
    }, [
        isOpen,
        setIsExpanded,
        dropdownRef,
        itemsRef
    ]);
    (0, $7XTbi$useOutsideClickEffect)(wrapperRef, toggleDropdown, isOpen);
    const selectedElement = options.find((option)=>option.isChecked) || null;
    (0, $7XTbi$useEffect)(()=>{
        if (!isMulti && selectedElement) setSearchText(selectedElement.label);
    }, [
        selectedElement,
        isMulti
    ]);
    (0, $7XTbi$useEffect)(()=>{
        setSearchTerm?.(searchText);
    }, [
        searchText,
        setSearchTerm
    ]);
    // handler for the input X (reset/clear) icon click
    const handleResetInput = ()=>{
        onChange({}); // delete this line when all instances of this component passes onInputReset
        onInputReset();
        inputRef.current.focus();
    };
    const handleOptionClick = (clickedOption)=>{
        if (isMulti) {
            // Here we are trying to see if the selected option already exists in the list then remove it, else add it with isChecked as true
            const updatedOptions = selectedOptions?.some((selected)=>selected.value === clickedOption.value && selected.isChecked) ? selectedOptions?.filter((selected)=>selected.value !== clickedOption.value) : [
                ...selectedOptions,
                {
                    ...clickedOption,
                    isChecked: true
                }
            ];
            setSelectedOptions(updatedOptions);
            onChange(clickedOption);
            toggleDropdown(null, isMulti);
        } else {
            const setOption = (option)=>({
                    ...option,
                    isChecked: option.value === clickedOption.value
                });
            const isChecked = setOption(clickedOption);
            onChange(isChecked);
            toggleDropdown(null, isMulti);
            if (isChecked) setSearchText(clickedOption.label);
            else setSearchText(null);
        }
    };
    const handleBlur = ()=>{
        const matchingOption = options.find((option)=>option?.label?.toLowerCase() === searchText?.toLowerCase());
        if (!matchingOption) setSearchText(selectedElement?.label);
    };
    const handleSelectFirstOption = ()=>{
        const matchingOption = options.find((option)=>!option.isDisabled && option?.label?.toLowerCase().startsWith(searchText?.toLowerCase()));
        if (isOpen && matchingOption) handleOptionClick(matchingOption);
    };
    const handleKeyDown = (event)=>{
        switch(event.key){
            case "ArrowDown":
                setIsOpen(true); // open dropdown
                break;
            case "Escape":
                toggleDropdown(); // close dropdown
                break;
            case "Tab":
                handleBlur(); // ensure menu input value is valid
                break;
            case "Enter":
                handleSelectFirstOption(); // select first option
                break;
            default:
                if (!isOpen) setIsOpen(true);
                break;
        }
    };
    const handleInputOnClick = ()=>{
        if (!isOpen) toggleDropdown();
    };
    const renderTrigger = ()=>/*#__PURE__*/ (0, $7XTbi$jsx)((0, $5f5001b799eea6c0$export$2e2bcd8739ae039), {
            ref: inputRef,
            name: "MenuInput-InputField",
            placeholder: placeholder || PLACEHOLDER,
            onClick: ()=>handleInputOnClick(),
            suffixButtonType: "dropdown",
            suffixIsToggle: isOpen,
            suffixOnClick: toggleDropdown,
            value: searchText,
            setValue: setSearchText,
            prefixIcon: prefixIcon,
            onChange: (e)=>{
                const newValue = e.target.value;
                setSearchText(newValue);
                onSearchTermChange(newValue);
            },
            onKeyDown: handleKeyDown,
            backgroundColor: backgroundColor,
            isCritical: isCritical,
            CriticalHelperText: CriticalHelperText,
            isReadOnly: isReadOnly,
            isOpen: isOpen,
            resetValue: handleResetInput,
            dataTestId: inputFieldTestId
        });
    const renderLoaderAndLoadingText = ()=>/*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
            className: "MenuInput--isLoading",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsx)((0, $199d1dc410e8acb9$export$2e2bcd8739ae039), {
                    kind: "loop",
                    format: "inline",
                    color: "info",
                    size: "small"
                }),
                loadingText || LOADING_TEXT
            ]
        });
    const renderMenuItems = ()=>{
        const filteredOptions = options.map((option)=>({
                ...option,
                isChecked: selectedOptions?.some((selected)=>selected.value === option.value && selected.isChecked) || false
            })).filter((option)=>{
            if (!isSearchDisabled) return option?.label?.toLowerCase().includes(searchText?.toLowerCase());
            return true;
        });
        if (filteredOptions.length === 0) return isLoading ? renderLoaderAndLoadingText() : /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
            className: "MenuInput--hasNoData",
            children: noDataText || NO_DATA_AVAILABLE_TEXT
        });
        if (!isMulti) {
            const showOptions = isOpen && searchText !== selectedElement?.label ? filteredOptions : options;
            return /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $7XTbi$Fragment), {
                children: [
                    showOptions.map((option)=>/*#__PURE__*/ (0, $7XTbi$jsx)((0, $7XTbi$react).Fragment, {
                            children: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $d6f276bb47558b59$export$2e2bcd8739ae039), {
                                option: option,
                                onClick: ()=>!option.isDisabled && handleOptionClick(option),
                                isDisabled: option.isDisabled,
                                tabIndex: isOpen ? 0 : -1,
                                prefixIcon: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                                    kind: option.icon
                                })
                            }, option.value)
                        }, option.value)),
                    isLoading && hasMoreOptions && renderLoaderAndLoadingText()
                ]
            });
        }
        return /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $7XTbi$Fragment), {
            children: [
                filteredOptions.map((option)=>/*#__PURE__*/ (0, $7XTbi$jsx)((0, $d6f276bb47558b59$export$2e2bcd8739ae039), {
                        option: option,
                        onClick: ()=>!option.isDisabled && handleOptionClick(option),
                        isDisabled: option.isDisabled,
                        tabIndex: isOpen ? 0 : -1,
                        isMulti: isMulti,
                        suffixIcon: suffixIcon,
                        menuItemHeightConfigs: menuItemHeightConfigs
                    }, option.value)),
                isLoading && hasMoreOptions && renderLoaderAndLoadingText()
            ]
        });
    };
    // Floating UI options
    const { refs: refs, floatingStyles: originalFloatingStyles, context: context } = (0, $7XTbi$useFloating)({
        open: isOpen,
        placement: placement,
        middleware: [
            (0, $7XTbi$flip)(!isPlacementLocked ? {
                fallbackAxisSideDirection: fallbackAxisSideDirection,
                fallbackPlacements: fallbackPlacements
            } : {
                mainAxis: false
            }),
            (0, $7XTbi$offset)(offset),
            (0, $7XTbi$shift)()
        ],
        whileElementsMounted: (0, $7XTbi$autoUpdate)
    });
    const floatingStyles = {
        ...originalFloatingStyles
    };
    const clickInteraction = (0, $7XTbi$useClick)(context);
    const dismissInteraction = (0, $7XTbi$useDismiss)(context);
    const roleInteraction = (0, $7XTbi$useRole)(context);
    const { getReferenceProps: getReferenceProps, getFloatingProps: getFloatingProps } = (0, $7XTbi$useInteractions)([
        clickInteraction,
        dismissInteraction,
        roleInteraction
    ]);
    const setDropdownRefs = (0, $7XTbi$useCallback)((node)=>{
        dropdownRef.current = node;
        refs.setFloating(node);
    }, [
        refs
    ]);
    const modifiedGetReferenceProps = (props = {})=>({
            ...getReferenceProps(props),
            onKeyDown: (e)=>{
                if (e.key === " ") e.stopPropagation();
                // eslint-disable-next-line react/prop-types
                if (props.onKeyDown) props.onKeyDown(e);
            }
        });
    return /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
        tag: "div",
        ref: wrapperRef,
        role: "combobox",
        "aria-controls": "custom-select-listbox",
        "aria-expanded": isOpen,
        "aria-label": label,
        className: menuWrapperClasses,
        dataTestId: dataTestId,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                ref: refs.setReference,
                ...modifiedGetReferenceProps(),
                className: menuTriggerClasses,
                children: renderTrigger()
            }),
            isOpen && /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                className: menuDropdownClasses,
                ref: setDropdownRefs,
                style: floatingStyles,
                ...getFloatingProps(),
                children: /*#__PURE__*/ (0, $7XTbi$jsx)("ul", {
                    className: itemsClasses,
                    ref: itemsRef,
                    onScroll: onScroll,
                    role: "listbox",
                    tabIndex: "-1",
                    children: renderMenuItems()
                })
            })
        ]
    });
}
$e27c03c18d801a90$var$MenuInput.propTypes = {
    options: (0, $7XTbi$proptypes).arrayOf((0, $7XTbi$proptypes).shape({
        label: (0, $7XTbi$proptypes).string.isRequired,
        value: (0, $7XTbi$proptypes).string.isRequired,
        isDisabled: (0, $7XTbi$proptypes).bool,
        isChecked: (0, $7XTbi$proptypes).bool
    })).isRequired,
    hasMoreOptions: (0, $7XTbi$proptypes).bool,
    selectedOptions: (0, $7XTbi$proptypes).arrayOf((0, $7XTbi$proptypes).shape({
        value: (0, $7XTbi$proptypes).string.isRequired,
        isChecked: (0, $7XTbi$proptypes).bool.isRequired
    })),
    setSelectedOptions: (0, $7XTbi$proptypes).func,
    label: (0, $7XTbi$proptypes).string,
    onChange: (0, $7XTbi$proptypes).func.isRequired,
    setIsExpanded: (0, $7XTbi$proptypes).func,
    backgroundColor: (0, $7XTbi$proptypes).string,
    isLoading: (0, $7XTbi$proptypes).bool,
    loadingText: (0, $7XTbi$proptypes).string,
    CriticalHelperText: (0, $7XTbi$proptypes).node,
    isCritical: (0, $7XTbi$proptypes).bool,
    isSearchDisabled: (0, $7XTbi$proptypes).bool,
    isReadOnly: (0, $7XTbi$proptypes).bool,
    placeholder: (0, $7XTbi$proptypes).string,
    isMulti: (0, $7XTbi$proptypes).bool,
    noDataText: (0, $7XTbi$proptypes).string,
    menuItemHeightConfigs: (0, $7XTbi$proptypes).shape({
        minHeight: (0, $7XTbi$proptypes).string || null,
        height: (0, $7XTbi$proptypes).string || null,
        maxHeight: (0, $7XTbi$proptypes).string || null
    }),
    searchTerm: (0, $7XTbi$proptypes).string,
    setSearchTerm: (0, $7XTbi$proptypes).func,
    onInputReset: (0, $7XTbi$proptypes).func,
    onScroll: (0, $7XTbi$proptypes).func,
    onSearchTermChange: (0, $7XTbi$proptypes).func,
    prefixIcon: (0, $7XTbi$proptypes).element,
    suffixIcon: (0, $7XTbi$proptypes).element,
    size: (0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$413a4c2603eff4ae))),
    offset: (0, $7XTbi$proptypes).number,
    placement: (0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$5aa24cb5f38e9127))),
    isPlacementLocked: (0, $7XTbi$proptypes).bool,
    fallbackAxisSideDirection: (0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$f37fc697bac1ac))),
    fallbackPlacements: (0, $7XTbi$proptypes).arrayOf((0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$5aa24cb5f38e9127)))),
    className: (0, $7XTbi$proptypes).string,
    dropdownClassName: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string,
    inputFieldTestId: (0, $7XTbi$proptypes).string
};
$e27c03c18d801a90$var$MenuInput.defaultProps = {
    hasMoreOptions: false,
    selectedOptions: null,
    setSelectedOptions: null,
    label: null,
    setIsExpanded: null,
    backgroundColor: "neutral",
    isLoading: false,
    loadingText: "",
    CriticalHelperText: null,
    isCritical: false,
    isSearchDisabled: false,
    isReadOnly: false,
    placeholder: "",
    isMulti: false,
    noDataText: "",
    menuItemHeightConfigs: {
        minHeight: null,
        height: null,
        maxHeight: null
    },
    searchTerm: "",
    setSearchTerm: null,
    onInputReset: ()=>{},
    onScroll: null,
    onSearchTermChange: ()=>{},
    prefixIcon: null,
    suffixIcon: null,
    size: null,
    offset: 8,
    placement: (0, $65441b8e33d7ac73$export$5aa24cb5f38e9127).BOTTOM_START,
    isPlacementLocked: false,
    fallbackAxisSideDirection: (0, $65441b8e33d7ac73$export$f37fc697bac1ac).END,
    fallbackPlacements: null,
    className: "",
    dropdownClassName: "",
    dataTestId: null,
    inputFieldTestId: null
};
var $e27c03c18d801a90$export$2e2bcd8739ae039 = $e27c03c18d801a90$var$MenuInput;


/* eslint-disable react/jsx-curly-spacing */ /* eslint-disable indent */ /* eslint-disable react/jsx-props-no-spreading */ 





















const $2c40d97ad963ddb5$var$msgs = {
    neo: {
        common: {
            selectAll: {
                id: "neo.common.selectAll",
                defaultMessage: "Select All"
            },
            clear: {
                id: "neo.common.clear",
                defaultMessage: "Clear"
            }
        }
    }
};
function $2c40d97ad963ddb5$var$MenuMultiFooter({ onSelectAll: onSelectAll, onClear: onClear, isClearDisabled: isClearDisabled, isSelectAllDisabled: isSelectAllDisabled, footerLink1Text: footerLink1Text, onFooterLink1Click: onFooterLink1Click, footerLink2Text: footerLink2Text, onFooterLink2Click: onFooterLink2Click, tabIndex: tabIndex, className: className, dataTestId: dataTestId }) {
    const intl = (0, $7XTbi$useIntl)();
    const SELECT_ALL_TEXT = (0, $7XTbi$localize)(intl, $2c40d97ad963ddb5$var$msgs.neo.common.selectAll);
    const CLEAR_TEXT = (0, $7XTbi$localize)(intl, $2c40d97ad963ddb5$var$msgs.neo.common.clear);
    const wrapperClasses = (0, $7XTbi$classnames)("MenuMultiFooter", className);
    return /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
        className: wrapperClasses,
        "data-testid": dataTestId,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)((0, $47010fca98b98efb$export$2e2bcd8739ae039), {
                text: footerLink1Text || SELECT_ALL_TEXT,
                kind: "button",
                onClick: onFooterLink1Click || onSelectAll,
                isDisabled: isSelectAllDisabled,
                className: "MenuMultiFooter-selectAll",
                tabIndex: tabIndex,
                size: "small"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)((0, $47010fca98b98efb$export$2e2bcd8739ae039), {
                text: footerLink2Text || CLEAR_TEXT,
                kind: "button",
                onClick: onFooterLink2Click || onClear,
                isDisabled: isClearDisabled,
                className: "MenuMultiFooter-clear",
                size: "small",
                tabIndex: tabIndex
            })
        ]
    });
}
const $2c40d97ad963ddb5$var$isFunction = (prop)=>typeof prop === "function";
const $2c40d97ad963ddb5$var$onSelectAllOrOnFooterLink1ClickPropType = (props, propName, componentName)=>{
    const { onSelectAll: onSelectAll, onFooterLink1Click: onFooterLink1Click } = props;
    if (!onSelectAll && !onFooterLink1Click) return new Error(`One of props 'onSelectAll' or 'onFooterLink1Click' was not passed to '${componentName}'.`);
    if (onSelectAll && !$2c40d97ad963ddb5$var$isFunction(onSelectAll)) return new Error(`Invalid prop 'onSelectAll' passed to '${componentName}'. Expected a function.`);
    if (onFooterLink1Click && !$2c40d97ad963ddb5$var$isFunction(onFooterLink1Click)) return new Error(`Invalid prop 'onFooterLink1Click' passed to '${componentName}'. Expected a function.`);
    return null;
};
const $2c40d97ad963ddb5$var$onClearOrOnFooterLink2ClickPropType = (props, propName, componentName)=>{
    const { onClear: onClear, onFooterLink2Click: onFooterLink2Click } = props;
    if (!onClear && onFooterLink2Click) return new Error(`One of props 'onClear' or 'onFooterLink2Click' was not passed to '${componentName}'.`);
    if (onClear && !$2c40d97ad963ddb5$var$isFunction(onClear)) return new Error(`Invalid prop 'onClear' passed to '${componentName}'. Expected a function.`);
    if (onFooterLink2Click && !$2c40d97ad963ddb5$var$isFunction(onFooterLink2Click)) return new Error(`Invalid prop 'onFooterLink2Click' passed to '${componentName}'. Expected a function.`);
    return null;
};
$2c40d97ad963ddb5$var$MenuMultiFooter.propTypes = {
    onSelectAll: $2c40d97ad963ddb5$var$onSelectAllOrOnFooterLink1ClickPropType,
    onClear: $2c40d97ad963ddb5$var$onClearOrOnFooterLink2ClickPropType,
    isClearDisabled: (0, $7XTbi$proptypes).bool,
    isSelectAllDisabled: (0, $7XTbi$proptypes).bool,
    footerLink1Text: (0, $7XTbi$proptypes).string,
    footerLink2Text: (0, $7XTbi$proptypes).string,
    onFooterLink1Click: $2c40d97ad963ddb5$var$onSelectAllOrOnFooterLink1ClickPropType,
    onFooterLink2Click: $2c40d97ad963ddb5$var$onClearOrOnFooterLink2ClickPropType,
    tabIndex: (0, $7XTbi$proptypes).oneOfType([
        (0, $7XTbi$proptypes).number,
        (0, $7XTbi$proptypes).string
    ]),
    className: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string
};
$2c40d97ad963ddb5$var$MenuMultiFooter.defaultProps = {
    onSelectAll: null,
    onClear: null,
    isClearDisabled: true,
    isSelectAllDisabled: true,
    footerLink1Text: "",
    onFooterLink1Click: null,
    footerLink2Text: "",
    onFooterLink2Click: null,
    tabIndex: 0,
    className: null,
    dataTestId: null
};
var $2c40d97ad963ddb5$export$2e2bcd8739ae039 = $2c40d97ad963ddb5$var$MenuMultiFooter;










function $0763f327d660c515$var$MenuItemMulti({ option: option, selectedValue: selectedValue, onClick: onClick, showOptionLabelOnHover: showOptionLabelOnHover, tabIndex: tabIndex, className: className }) {
    const { value: value, label: label, isChecked: isChecked, isDisabled: isDisabled, prefixIcon: prefixIcon } = option;
    const [checkboxChecked, setIsCheckboxChecked] = (0, $7XTbi$useState)(isChecked || false);
    (0, $7XTbi$useEffect)(()=>{
        // only update if the option is not disabled
        if (!isDisabled) setIsCheckboxChecked(Boolean(isChecked));
    }, [
        isChecked,
        isDisabled
    ]);
    const handleOptionClick = (event)=>{
        // prevent the default behavior and event bubbling.
        event.preventDefault();
        event.stopPropagation();
        if (isDisabled) return;
        const newCheckedState = !checkboxChecked;
        setIsCheckboxChecked(newCheckedState);
        onClick(newCheckedState);
    };
    return /*#__PURE__*/ (0, $7XTbi$jsxs)("li", {
        onClick: handleOptionClick,
        className: (0, $7XTbi$classnames)("MenuItemMulti", isDisabled && "MenuItemMulti--isDisabled", className),
        role: "option",
        "aria-selected": selectedValue && selectedValue.value === value,
        tabIndex: isDisabled ? -1 : tabIndex,
        onKeyDown: (e)=>{
            if (e.key === "Enter" || e.key === " ") handleOptionClick(e);
        },
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                className: "MenuItemMulti-checkbox",
                children: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $ea632b95ffcf8459$export$2e2bcd8739ae039), {
                    kind: "base",
                    tabIndex: -1,
                    isChecked: checkboxChecked,
                    isDisabled: isDisabled
                })
            }),
            prefixIcon && (prefixIcon.isApplicationIcon ? /*#__PURE__*/ (0, $7XTbi$jsx)((0, $f999930470b087cd$export$2e2bcd8739ae039), {
                kind: "logo",
                logo: prefixIcon.kind,
                size: prefixIcon.size
            }) : /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                kind: prefixIcon.kind,
                size: prefixIcon.size,
                color: prefixIcon.color,
                className: "MenuItemMulti-prefixIcon"
            })),
            /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                className: "MenuItemMulti-label",
                title: showOptionLabelOnHover ? label : null,
                children: label
            })
        ]
    }, value);
}
$0763f327d660c515$var$MenuItemMulti.propTypes = {
    option: (0, $7XTbi$proptypes).shape({
        label: (0, $7XTbi$proptypes).string.isRequired,
        value: (0, $7XTbi$proptypes).string.isRequired,
        isChecked: (0, $7XTbi$proptypes).bool,
        isDisabled: (0, $7XTbi$proptypes).bool,
        prefixIcon: (0, $7XTbi$proptypes).shape({
            isApplicationIcon: (0, $7XTbi$proptypes).bool,
            kind: (0, $7XTbi$proptypes).string,
            size: (0, $7XTbi$proptypes).string,
            color: (0, $7XTbi$proptypes).string
        })
    }).isRequired,
    selectedValue: (0, $7XTbi$proptypes).shape({
        label: (0, $7XTbi$proptypes).string,
        value: (0, $7XTbi$proptypes).string
    }),
    onClick: (0, $7XTbi$proptypes).func.isRequired,
    showOptionLabelOnHover: (0, $7XTbi$proptypes).bool,
    className: (0, $7XTbi$proptypes).string,
    tabIndex: (0, $7XTbi$proptypes).oneOfType([
        (0, $7XTbi$proptypes).number,
        (0, $7XTbi$proptypes).string
    ])
};
$0763f327d660c515$var$MenuItemMulti.defaultProps = {
    selectedValue: null,
    showOptionLabelOnHover: false,
    className: null,
    tabIndex: -1
};
var $0763f327d660c515$export$2e2bcd8739ae039 = $0763f327d660c515$var$MenuItemMulti;




const $0d6416eee7308de1$var$DEFAULT_ICON_COLOR = "neutral-1000";
const $0d6416eee7308de1$var$DISABLED_ICON_COLOR = "neutral-400";
/**
 * MenuMulti renders a trigger and a multiselect dropdown list.
 */ function $0d6416eee7308de1$var$MenuMulti({ options: options, label: label, trigger: trigger, onChange: onChange, sortOnCheck: sortOnCheck, appendLabelsToButton: appendLabelsToButton, minOptionsForSearch: minOptionsForSearch, minOptionsForFooter: minOptionsForFooter, setIsExpanded: // setIsExpanded is here to allow the parents JS set a local state check. toggleDropdownMenu will let the parent know that the dropdown is open or closed using this.
setIsExpanded, onFooterLink1Click: onFooterLink1Click, footerLink1Text: footerLink1Text, onFooterLink2Click: onFooterLink2Click, footerLink2Text: footerLink2Text, headerText: headerText, headerTextConfigs: headerTextConfigs, heightToShowScrollbar: heightToShowScrollbar, showOptionLabelOnHover: showOptionLabelOnHover, isFilteringDisabled: isFilteringDisabled, onSearchTermChange: onSearchTermChange, size: size, noDataText: noDataText, placement: placement, isPlacementLocked: isPlacementLocked, fallbackAxisSideDirection: fallbackAxisSideDirection, fallbackPlacements: fallbackPlacements, offset: offset, showFooterLink1: showFooterLink1, shouldSortCheckedAtBottom: shouldSortCheckedAtBottom, dataTestId: dataTestId }) {
    const [isOpen, setIsOpen] = (0, $7XTbi$useState)(false);
    const [dropdownOpenHeight, setDropdownOpenHeight] = (0, $7XTbi$useState)(0);
    const [searchText, setSearchText] = (0, $7XTbi$useState)("");
    const wrapperRef = (0, $7XTbi$useRef)(null);
    const dropdownRef = (0, $7XTbi$useRef)(null);
    const itemsRef = (0, $7XTbi$useRef)(null);
    const localize = (0, $7XTbi$useLocalize)();
    const showSearchBar = options.length >= minOptionsForSearch;
    const NO_DATA_AVAILABLE_TEXT = localize((0, $65441b8e33d7ac73$export$9f3245bec405e186).neo.common.noDataAvailable);
    const menuMultiWrapperClasses = (0, $7XTbi$classnames)("MenuMulti-wrapper", isOpen && "MenuMulti-wrapper--isOpen");
    const menuMultiTriggerClasses = (0, $7XTbi$classnames)("MenuMulti-trigger");
    const menuMultiDropdownClasses = (0, $7XTbi$classnames)("MenuMulti-dropdown", size && `MenuMulti-dropdown--${size}`);
    const itemsClasses = (0, $7XTbi$classnames)("MenuMulti-items", options?.length === 0 && "MenuMulti-items--hasNoText");
    // Hooks and open toggle used for transitions
    (0, $6cb28ba18cf98155$export$28f8a6921de3d9b4)({
        isOpen: isOpen,
        setDropdownOpenHeight: setDropdownOpenHeight,
        dropdownRef: dropdownRef,
        itemsRef: itemsRef
    });
    (0, $1a24ce14a1841475$export$d269ac3552e3437f)({
        dropdownOpenHeight: dropdownOpenHeight,
        dropdownRef: dropdownRef
    });
    const toggleDropdown = (0, $7XTbi$useCallback)((event, forceState)=>{
        if (event?.stopPropagation) event.stopPropagation();
        (0, $796a738a4119b82b$export$ebc10a939cccbd3f)({
            isOpen: isOpen,
            setIsOpen: setIsOpen,
            setIsExpanded: setIsExpanded,
            dropdownRef: dropdownRef,
            itemsRef: itemsRef,
            isMultiInput: false,
            forceState: forceState
        });
    }, [
        isOpen,
        setIsExpanded,
        dropdownRef,
        itemsRef
    ]);
    (0, $7XTbi$useOutsideClickEffect)(wrapperRef, ()=>toggleDropdown(), isOpen);
    const handleOptionClick = (option)=>{
        // toggle the isChecked property of the clicked option
        const updatedOptions = options.map((opt)=>opt.value === option.value ? {
                ...opt,
                isChecked: !opt.isChecked
            } : opt);
        // filter out only the options that are checked
        const newSelectedOptions = updatedOptions.filter((opt)=>opt.isChecked);
        onChange(newSelectedOptions);
    };
    const handleSelectAll = ()=>{
        // set isChecked to true only for options that are not disabled.
        const newOptions = options.map((option)=>({
                ...option,
                // preserve the isChecked state if the option is disabled
                isChecked: option.isDisabled ? option.isChecked : true
            }));
        onChange(newOptions.filter((opt)=>opt.isChecked));
    };
    const handleClearAll = ()=>{
        const newOptions = options.map((option)=>({
                ...option,
                // don't modify disabled options. i.e., disabled and checked.
                isChecked: option.isDisabled ? option.isChecked : false
            }));
        const remainingSelectedOptions = newOptions.filter((opt)=>opt.isDisabled && opt.isChecked);
        onChange(remainingSelectedOptions);
    };
    const sortedAndFilteredOptions = (0, $7XTbi$useMemo)(()=>{
        if (!sortOnCheck) return options;
        // clone the options array to avoid mutating props.
        const optionsClone = [
            ...options
        ];
        if (shouldSortCheckedAtBottom) // perform the sort. unChecked
        optionsClone.sort((a, b)=>{
            const aChecked = a.isChecked === true;
            const bChecked = b.isChecked === true;
            if (aChecked === bChecked) return a.label.localeCompare(b.label);
            return aChecked ? 1 : -1;
        });
        else // perform the sort. Checked
        optionsClone.sort((a, b)=>(b.isChecked === true) - (a.isChecked === true) || a.label.localeCompare(b.label));
        // filter based on the search text
        const lowerSearchText = searchText.toLowerCase();
        return optionsClone.filter((option)=>{
            if (isFilteringDisabled) return true;
            return option.label.toLowerCase().includes(lowerSearchText);
        });
    }, [
        sortOnCheck,
        options,
        searchText,
        isFilteringDisabled,
        shouldSortCheckedAtBottom
    ]);
    const renderSearchBar = ()=>/*#__PURE__*/ (0, $7XTbi$jsx)((0, $d3ee76d8fa05c77a$export$2e2bcd8739ae039), {
            text: searchText,
            setText: (value)=>{
                setSearchText(value);
                onSearchTermChange(value);
            },
            tabIndex: isOpen ? 0 : -1,
            hasHeaderText: headerText
        });
    const renderFooter = ()=>{
        // consider disabled options in the calculations.
        const isSelectAllDisabled = options.every((opt)=>opt.isChecked || opt.isDisabled);
        const isClearDisabled = !options.some((opt)=>opt.isChecked && !opt.isDisabled);
        return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $2c40d97ad963ddb5$export$2e2bcd8739ae039), {
            onSelectAll: handleSelectAll,
            onClear: handleClearAll,
            isClearDisabled: isClearDisabled,
            isSelectAllDisabled: !showFooterLink1 && isSelectAllDisabled,
            tabIndex: isOpen ? 0 : -1,
            onFooterLink1Click: onFooterLink1Click,
            footerLink1Text: footerLink1Text,
            onFooterLink2Click: onFooterLink2Click,
            footerLink2Text: footerLink2Text
        });
    };
    const renderTrigger = ()=>{
        const checkedLabels = options.filter((option)=>option.isChecked).map((option)=>option.label).join(", ");
        const displayText = appendLabelsToButton && checkedLabels?.length ? (0, $7XTbi$styleTextBeforeToken)(`${label}: ${checkedLabels}`, ":", true, "u-button--isLabelAppended", "u-button--isLabelAppendedTags") : label;
        return trigger ? /*#__PURE__*/ (0, $7XTbi$cloneElement)(trigger, {
            label: displayText,
            isOpen: isOpen,
            onClick: toggleDropdown,
            dataTestId: "menumulti-trigger"
        }) : // TODO: style and allow as default trigger.
        /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $553ba9ca1822b2c0$export$2e2bcd8739ae039), {
            type: "button",
            className: "MenuMulti-buttonDefault",
            onClick: toggleDropdown,
            dataTestId: "menumulti-trigger",
            "aria-pressed": isOpen,
            children: [
                displayText,
                options.isApplicationIcon ? /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                    kind: "ChevronDown",
                    rotate: isOpen ? "180" : null
                }) : /*#__PURE__*/ (0, $7XTbi$jsx)((0, $f999930470b087cd$export$2e2bcd8739ae039), {
                    kind: "ChevronDown",
                    rotate: isOpen ? "180" : null
                })
            ]
        });
    };
    const sortedOptions = (0, $7XTbi$useMemo)(()=>{
        if (!options || options.length < 1) return [];
        if (!sortOnCheck) return options;
        // separate the options into two groups: checked and unchecked.
        const checkedOptions = options.filter((opt)=>opt.isChecked);
        const uncheckedOptions = options.filter((opt)=>!opt.isChecked);
        // sort both groups alphabetically.
        const sortedCheckedOptions = checkedOptions.sort((a, b)=>a.label.localeCompare(b.label));
        const sortedUncheckedOptions = uncheckedOptions.sort((a, b)=>a.label.localeCompare(b.label));
        if (shouldSortCheckedAtBottom) // merge the sorted groups, with unchecked options first.
        return [
            ...sortedUncheckedOptions,
            ...sortedCheckedOptions
        ];
        // merge the sorted groups, with checked options first.
        return [
            ...sortedCheckedOptions,
            ...sortedUncheckedOptions
        ];
    }, [
        options,
        sortOnCheck,
        shouldSortCheckedAtBottom
    ]);
    const renderMenuItems = ()=>{
        const optionsWithDefaults = sortedAndFilteredOptions.map((option)=>({
                ...option,
                prefixIcon: {
                    ...option.prefixIcon,
                    // If option.prefixIcon.color is not set and option is disabled, use gray, else use default color
                    color: option?.prefixIcon?.color ?? (option.isDisabled ? $0d6416eee7308de1$var$DISABLED_ICON_COLOR : $0d6416eee7308de1$var$DEFAULT_ICON_COLOR)
                }
            }));
        if (optionsWithDefaults.length > 0) return optionsWithDefaults.map((option, index)=>{
            const isSelected = option.isChecked;
            const isNextItemChecked = sortedOptions[index + 1] && sortedOptions[index + 1].isChecked;
            const isAllChecked = sortedOptions.every((opt)=>opt.isChecked);
            const isLastCheckedItem = !shouldSortCheckedAtBottom && isSelected && !isNextItemChecked && !isAllChecked;
            const isFirstCheckedItem = shouldSortCheckedAtBottom && !isSelected && isNextItemChecked;
            const isDividerVisible = sortOnCheck && (isLastCheckedItem || isFirstCheckedItem);
            return /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $7XTbi$react).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $7XTbi$jsx)((0, $0763f327d660c515$export$2e2bcd8739ae039), {
                        option: option,
                        onClick: ()=>!option.isDisabled && handleOptionClick(option),
                        isDisabled: option.isDisabled,
                        showOptionLabelOnHover: showOptionLabelOnHover,
                        tabIndex: isOpen ? 0 : -1
                    }, option.value),
                    isDividerVisible && /*#__PURE__*/ (0, $7XTbi$jsx)("li", {
                        className: "MenuMulti-items-selectionDivider",
                        children: /*#__PURE__*/ (0, $7XTbi$jsx)("div", {})
                    })
                ]
            }, option.value);
        });
        return /*#__PURE__*/ (0, $7XTbi$jsx)("li", {
            className: "MenuMulti--hasNoData",
            children: noDataText || NO_DATA_AVAILABLE_TEXT
        });
    };
    const styleHeaderText = ()=>{
        if (!headerTextConfigs?.splitOnToken) return headerText;
        return (0, $7XTbi$styleTextBeforeToken)(`${headerText}`, headerTextConfigs?.token, true, headerTextConfigs?.preTokenClassName, headerTextConfigs?.postTokenClassName);
    };
    // Floating UI options
    const { refs: refs, floatingStyles: originalFloatingStyles, context: context } = (0, $7XTbi$useFloating)({
        open: isOpen,
        onOpenChange: toggleDropdown,
        placement: placement,
        middleware: [
            (0, $7XTbi$flip)(!isPlacementLocked ? {
                fallbackAxisSideDirection: fallbackAxisSideDirection,
                fallbackPlacements: fallbackPlacements
            } : {
                mainAxis: false
            }),
            (0, $7XTbi$offset)(offset),
            (0, $7XTbi$shift)()
        ],
        whileElementsMounted: (0, $7XTbi$autoUpdate)
    });
    const floatingStyles = {
        ...originalFloatingStyles
    };
    const clickInteraction = (0, $7XTbi$useClick)(context);
    const dismissInteraction = (0, $7XTbi$useDismiss)(context);
    const roleInteraction = (0, $7XTbi$useRole)(context);
    const { getReferenceProps: getReferenceProps, getFloatingProps: getFloatingProps } = (0, $7XTbi$useInteractions)([
        clickInteraction,
        dismissInteraction,
        roleInteraction
    ]);
    const setDropdownRefs = (0, $7XTbi$useCallback)((node)=>{
        dropdownRef.current = node;
        refs.setFloating(node);
    }, [
        refs
    ]);
    return /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
        ref: wrapperRef,
        role: "combobox",
        "aria-controls": "custom-select-listbox",
        "aria-expanded": isOpen,
        "aria-label": label,
        className: menuMultiWrapperClasses,
        dataTestId: dataTestId,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                ref: refs.setReference,
                ...getReferenceProps(),
                className: menuMultiTriggerClasses,
                children: renderTrigger()
            }),
            isOpen && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $7XTbi$FloatingFocusManager), {
                context: context,
                modal: false,
                children: /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                    className: menuMultiDropdownClasses,
                    ref: setDropdownRefs,
                    style: floatingStyles,
                    ...getFloatingProps(),
                    children: [
                        headerText && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5f880a93b57cab01$export$2e2bcd8739ae039), {
                            kind: "body3",
                            className: (0, $7XTbi$classnames)("MenuMulti-headerText", headerTextConfigs?.headerTextClassName),
                            children: styleHeaderText()
                        }),
                        showSearchBar && renderSearchBar(),
                        /*#__PURE__*/ (0, $7XTbi$jsx)("ul", {
                            className: itemsClasses,
                            ref: itemsRef,
                            role: "listbox",
                            tabIndex: "-1",
                            style: heightToShowScrollbar ? {
                                maxHeight: heightToShowScrollbar
                            } : {},
                            children: renderMenuItems()
                        }),
                        options.length >= minOptionsForFooter && renderFooter()
                    ]
                })
            })
        ]
    });
}
$0d6416eee7308de1$var$MenuMulti.propTypes = {
    label: (0, $7XTbi$proptypes).string,
    trigger: (0, $7XTbi$proptypes).element,
    options: (0, $7XTbi$proptypes).arrayOf((0, $7XTbi$proptypes).shape({
        label: (0, $7XTbi$proptypes).string.isRequired,
        value: (0, $7XTbi$proptypes).string.isRequired,
        isDisabled: (0, $7XTbi$proptypes).bool,
        isChecked: (0, $7XTbi$proptypes).bool,
        prefixIcon: (0, $7XTbi$proptypes).shape({
            isApplicationIcon: (0, $7XTbi$proptypes).bool,
            kind: (0, $7XTbi$proptypes).string,
            size: (0, $7XTbi$proptypes).string,
            color: (0, $7XTbi$proptypes).string
        })
    })).isRequired,
    onChange: (0, $7XTbi$proptypes).func.isRequired,
    sortOnCheck: (0, $7XTbi$proptypes).bool,
    appendLabelsToButton: (0, $7XTbi$proptypes).bool,
    minOptionsForSearch: (0, $7XTbi$proptypes).number,
    minOptionsForFooter: (0, $7XTbi$proptypes).number,
    setIsExpanded: (0, $7XTbi$proptypes).func,
    isFilteringDisabled: (0, $7XTbi$proptypes).bool,
    onFooterLink1Click: (0, $7XTbi$proptypes).func,
    onSearchTermChange: (0, $7XTbi$proptypes).func,
    footerLink1Text: (0, $7XTbi$proptypes).string,
    onFooterLink2Click: (0, $7XTbi$proptypes).func,
    footerLink2Text: (0, $7XTbi$proptypes).string,
    headerText: (0, $7XTbi$proptypes).string,
    noDataText: (0, $7XTbi$proptypes).string,
    headerTextConfigs: (0, $7XTbi$proptypes).shape({
        headerTextClassName: (0, $7XTbi$proptypes).string,
        splitOnToken: (0, $7XTbi$proptypes).bool,
        token: (0, $7XTbi$proptypes).string,
        preTokenClassName: (0, $7XTbi$proptypes).string,
        postTokenClassName: (0, $7XTbi$proptypes).string
    }),
    heightToShowScrollbar: (0, $7XTbi$proptypes).string,
    showOptionLabelOnHover: (0, $7XTbi$proptypes).bool,
    size: (0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$413a4c2603eff4ae))),
    placement: (0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$5aa24cb5f38e9127))),
    isPlacementLocked: (0, $7XTbi$proptypes).bool,
    fallbackAxisSideDirection: (0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$f37fc697bac1ac))),
    fallbackPlacements: (0, $7XTbi$proptypes).arrayOf((0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$5aa24cb5f38e9127)))),
    offset: (0, $7XTbi$proptypes).number,
    showFooterLink1: (0, $7XTbi$proptypes).bool,
    dataTestId: (0, $7XTbi$proptypes).string,
    shouldSortCheckedAtBottom: (0, $7XTbi$proptypes).bool
};
$0d6416eee7308de1$var$MenuMulti.defaultProps = {
    label: "",
    trigger: null,
    sortOnCheck: true,
    appendLabelsToButton: true,
    isFilteringDisabled: false,
    minOptionsForSearch: 6,
    minOptionsForFooter: 6,
    setIsExpanded: null,
    onFooterLink1Click: null,
    footerLink1Text: "",
    onFooterLink2Click: null,
    footerLink2Text: "",
    headerText: null,
    headerTextConfigs: {
        headerTextClassName: null,
        splitOnToken: false,
        token: ":",
        preTokenClassName: null,
        postTokenClassName: null
    },
    heightToShowScrollbar: null,
    showOptionLabelOnHover: false,
    size: null,
    onSearchTermChange: ()=>{},
    noDataText: "",
    placement: (0, $65441b8e33d7ac73$export$5aa24cb5f38e9127).BOTTOM_START,
    isPlacementLocked: false,
    fallbackAxisSideDirection: (0, $65441b8e33d7ac73$export$f37fc697bac1ac).NONE,
    fallbackPlacements: null,
    offset: 8,
    showFooterLink1: false,
    dataTestId: null,
    shouldSortCheckedAtBottom: false
};
var $0d6416eee7308de1$export$2e2bcd8739ae039 = $0d6416eee7308de1$var$MenuMulti;


/* eslint-disable react/jsx-curly-spacing */ /* eslint-disable object-curly-newline */ /* eslint-disable react/jsx-props-no-spreading */ 








// TODO: Seperate these: MenuNestedItem, MenuNested, and MenuNestedComponent DSD-109
// TODO: Open and close Transitions
// TODO: Better manage the focus state to Not randomly apply outline on hover
// TODO: Add the commented out props funcitonality
const $e3ff878f28f11e4a$var$MenuContext = /*#__PURE__*/ (0, $7XTbi$createContext)({
    getItemProps: ()=>({}),
    activeIndex: null,
    setActiveIndex: ()=>{},
    setHasFocusInside: ()=>{},
    isOpen: false,
    setIsOpen: ()=>{}
});
function $e3ff878f28f11e4a$export$b308ebf3da41e866({ option: option, onChange: onChange, shouldCloseMenuOnItemClick: shouldCloseMenuOnItemClick }) {
    const tree = (0, $7XTbi$useFloatingTree)();
    const handleClick = (clickedOption)=>{
        onChange(clickedOption);
        if (tree && shouldCloseMenuOnItemClick) tree.events.emit("closeAllMenus");
    };
    return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $d6f276bb47558b59$export$2e2bcd8739ae039), {
        option: option,
        label: option.label,
        onClick: ()=>!option.isDisabled && handleClick(option),
        isDisabled: option.isDisabled,
        tabIndex: 0,
        prefixIcon: option.icon && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
            kind: option.icon
        })
    }, option.value);
}
const $e3ff878f28f11e4a$var$MenuNestedComponent = /*#__PURE__*/ (0, $7XTbi$forwardRef)((props, forwardedRef)=>{
    const { children: children, options: options, onOptionChange: onOptionChange, prefixIconKind: prefixIconKind, trigger: trigger, label: label, setIsExpanded: // setIsExpanded is here to allow the parents JS set a local state check. toggleDropdownMenu will let the parent know that the dropdown is open or closed using this.
    setIsExpanded, placement: placement, fallbackPlacements: fallbackPlacements, shouldHoverOpenSubMenu: shouldHoverOpenSubMenu, shouldCloseMenuOnItemClick: shouldCloseMenuOnItemClick, dropdownClassName: dropdownClassName, itemsClassName: itemsClassName, itemClassName: itemClassName, dataTestId: dataTestId, ...rest } = props;
    const [isOpen, setIsOpen] = (0, $7XTbi$useState)(false);
    const [hasFocusInside, setHasFocusInside] = (0, $7XTbi$useState)(false);
    const [activeIndex, setActiveIndex] = (0, $7XTbi$useState)(null);
    const elementsRef = (0, $7XTbi$useRef)([]);
    const labelsRef = (0, $7XTbi$useRef)([]);
    const parent = (0, $7XTbi$useContext)($e3ff878f28f11e4a$var$MenuContext);
    const tree = (0, $7XTbi$useFloatingTree)();
    const nodeId = (0, $7XTbi$useFloatingNodeId)();
    const parentId = (0, $7XTbi$useFloatingParentNodeId)();
    const item = (0, $7XTbi$useListItem)();
    const isNested = parentId != null;
    const dropdownClasses = (0, $7XTbi$classnames)("Menu-dropdown", dropdownClassName);
    const wrapperClasses = (0, $7XTbi$classnames)(isNested ? "MenuItem" : "MenuNested-Root", itemClassName);
    const itemsClasses = (0, $7XTbi$classnames)("Menu-items", itemsClassName);
    (0, $7XTbi$useEffect)(()=>{
        setIsExpanded(isOpen);
    }, [
        isOpen,
        setIsExpanded
    ]);
    const { floatingStyles: floatingStyles, refs: refs, context: context } = (0, $7XTbi$useFloating)({
        nodeId: nodeId,
        open: isOpen,
        onOpenChange: setIsOpen,
        placement: placement,
        middleware: [
            (0, $7XTbi$offset)({
                mainAxis: isNested ? 20 : 8,
                alignmentAxis: isNested ? 0 : 0
            }),
            (0, $7XTbi$flip)({
                fallbackPlacements: fallbackPlacements
            }),
            (0, $7XTbi$shift)()
        ],
        whileElementsMounted: (0, $7XTbi$autoUpdate)
    });
    const hover = (0, $7XTbi$useHover)(context, {
        enabled: isNested && shouldHoverOpenSubMenu,
        delay: {
            open: 75
        },
        handleClose: (0, $7XTbi$safePolygon)({
            blockPointerEvents: true
        })
    });
    const click = (0, $7XTbi$useClick)(context, {
        event: "mousedown",
        toggle: true,
        ignoreMouse: isNested && shouldHoverOpenSubMenu
    });
    const role = (0, $7XTbi$useRole)(context, {
        role: "menu"
    });
    const dismiss = (0, $7XTbi$useDismiss)(context, {
        bubbles: true
    });
    const listNavigation = (0, $7XTbi$useListNavigation)(context, {
        listRef: elementsRef,
        activeIndex: activeIndex,
        nested: isNested,
        onNavigate: setActiveIndex
    });
    const { getReferenceProps: getReferenceProps, getFloatingProps: getFloatingProps, getItemProps: getItemProps } = (0, $7XTbi$useInteractions)([
        hover,
        click,
        role,
        dismiss,
        listNavigation
    ]);
    (0, $7XTbi$useEffect)(()=>{
        if (!tree) return;
        const handleTreeClick = ()=>setIsOpen(false);
        const onSubMenuOpen = (event)=>{
            if (event.nodeId !== nodeId && event.parentId === parentId) setIsOpen(false);
        };
        const handleCloseAllMenus = ()=>setIsOpen(false);
        tree.events.on("click", handleTreeClick);
        tree.events.on("menuopen", onSubMenuOpen);
        tree.events.on("closeAllMenus", handleCloseAllMenus);
        // eslint-disable-next-line consistent-return
        return ()=>{
            tree.events.off("click", handleTreeClick);
            tree.events.off("menuopen", onSubMenuOpen);
            tree.events.off("closeAllMenus", handleCloseAllMenus);
        };
    }, [
        tree,
        nodeId,
        parentId
    ]);
    (0, $7XTbi$useEffect)(()=>{
        if (isOpen && tree) tree.events.emit("menuopen", {
            parentId: parentId,
            nodeId: nodeId
        });
    }, [
        tree,
        isOpen,
        nodeId,
        parentId
    ]);
    const getTrigger = ()=>trigger ? /*#__PURE__*/ (0, $7XTbi$cloneElement)(trigger, {
            isOpen: isOpen
        }) : /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
            className: "MenuNested-nestedTrigger",
            children: [
                prefixIconKind && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                    kind: prefixIconKind
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                    className: "MenuNested-nestedTriggerLabel",
                    children: label
                })
            ]
        });
    return /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $7XTbi$FloatingNode), {
        id: nodeId,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                ref: (0, $7XTbi$useMergeRefs)([
                    refs.setReference,
                    item.ref,
                    forwardedRef
                ]),
                role: isNested ? "menuitem" : undefined,
                // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
                tabIndex: 0,
                "data-open": isOpen ? "" : undefined,
                "data-nested": isNested ? "" : undefined,
                "data-focus-inside": hasFocusInside ? "" : undefined,
                "data-testid": dataTestId,
                className: wrapperClasses,
                ...getReferenceProps(parent.getItemProps({
                    ...rest,
                    onFocus (event) {
                        rest.onFocus?.(event);
                        setHasFocusInside(false);
                        parent.setHasFocusInside(true);
                    }
                })),
                children: getTrigger()
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)($e3ff878f28f11e4a$var$MenuContext.Provider, {
                // eslint-disable-next-line react/jsx-no-constructed-context-values
                value: {
                    activeIndex: activeIndex,
                    setActiveIndex: setActiveIndex,
                    getItemProps: getItemProps,
                    setHasFocusInside: setHasFocusInside,
                    isOpen: isOpen,
                    setIsOpen: setIsOpen
                },
                children: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $7XTbi$FloatingList), {
                    elementsRef: elementsRef,
                    labelsRef: labelsRef,
                    children: isOpen && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $7XTbi$FloatingPortal), {
                        children: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $7XTbi$FloatingFocusManager), {
                            context: context,
                            modal: false,
                            initialFocus: isNested ? -1 : 0,
                            returnFocus: !isNested,
                            children: /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                                ref: refs.setFloating,
                                className: dropdownClasses,
                                style: floatingStyles,
                                ...getFloatingProps(),
                                children: /*#__PURE__*/ (0, $7XTbi$jsxs)("ul", {
                                    className: itemsClasses,
                                    role: "listbox",
                                    tabIndex: "-1",
                                    children: [
                                        children,
                                        options && onOptionChange && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $7XTbi$Fragment), {
                                            children: options.map((option)=>/*#__PURE__*/ (0, $7XTbi$jsx)($e3ff878f28f11e4a$export$b308ebf3da41e866, {
                                                    option: option,
                                                    onChange: onOptionChange,
                                                    shouldCloseMenuOnItemClick: shouldCloseMenuOnItemClick
                                                }, option.value))
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
});
const $e3ff878f28f11e4a$var$MenuNested = /*#__PURE__*/ (0, $7XTbi$forwardRef)((props, ref)=>{
    const parentId = (0, $7XTbi$useFloatingParentNodeId)();
    if (parentId === null) return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $7XTbi$FloatingTree), {
        children: /*#__PURE__*/ (0, $7XTbi$jsx)($e3ff878f28f11e4a$var$MenuNestedComponent, {
            ...props,
            ref: ref
        })
    });
    return /*#__PURE__*/ (0, $7XTbi$jsx)($e3ff878f28f11e4a$var$MenuNestedComponent, {
        ...props,
        ref: ref
    });
});
$e3ff878f28f11e4a$export$b308ebf3da41e866.propTypes = {
    option: (0, $7XTbi$proptypes).shape({
        label: (0, $7XTbi$proptypes).string,
        value: (0, $7XTbi$proptypes).string,
        isDisabled: (0, $7XTbi$proptypes).bool,
        isChecked: (0, $7XTbi$proptypes).bool,
        icon: (0, $7XTbi$proptypes).string
    }).isRequired,
    onChange: (0, $7XTbi$proptypes).func.isRequired,
    shouldCloseMenuOnItemClick: (0, $7XTbi$proptypes).bool.isRequired
};
$e3ff878f28f11e4a$var$MenuNestedComponent.propTypes = {
    children: (0, $7XTbi$proptypes).oneOfType([
        (0, $7XTbi$proptypes).element,
        (0, $7XTbi$proptypes).arrayOf((0, $7XTbi$proptypes).element)
    ]),
    options: (0, $7XTbi$proptypes).arrayOf((0, $7XTbi$proptypes).shape({
        label: (0, $7XTbi$proptypes).string,
        value: (0, $7XTbi$proptypes).string,
        isDisabled: (0, $7XTbi$proptypes).bool,
        isChecked: (0, $7XTbi$proptypes).bool,
        icon: (0, $7XTbi$proptypes).string
    })),
    onOptionChange: (0, $7XTbi$proptypes).func,
    prefixIconKind: (0, $7XTbi$proptypes).string,
    trigger: (0, $7XTbi$proptypes).element,
    label: (0, $7XTbi$proptypes).string,
    setIsExpanded: (0, $7XTbi$proptypes).func,
    shouldCloseMenuOnItemClick: (0, $7XTbi$proptypes).bool,
    shouldHoverOpenSubMenu: (0, $7XTbi$proptypes).bool,
    placement: (0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$5aa24cb5f38e9127))),
    fallbackPlacements: (0, $7XTbi$proptypes).arrayOf((0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$5aa24cb5f38e9127)))),
    dropdownClassName: (0, $7XTbi$proptypes).string,
    itemsClassName: (0, $7XTbi$proptypes).string,
    itemClassName: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string
};
$e3ff878f28f11e4a$var$MenuNestedComponent.defaultProps = {
    children: null,
    options: [],
    onOptionChange: null,
    prefixIconKind: null,
    trigger: null,
    label: null,
    setIsExpanded: ()=>{},
    shouldCloseMenuOnItemClick: false,
    shouldHoverOpenSubMenu: false,
    placement: (0, $65441b8e33d7ac73$export$5aa24cb5f38e9127).BOTTOM_START,
    fallbackPlacements: null,
    dropdownClassName: null,
    itemsClassName: null,
    itemClassName: null,
    dataTestId: null
};
$e3ff878f28f11e4a$var$MenuNested.propTypes = {
    children: (0, $7XTbi$proptypes).oneOfType([
        (0, $7XTbi$proptypes).element,
        (0, $7XTbi$proptypes).arrayOf((0, $7XTbi$proptypes).element)
    ]),
    options: (0, $7XTbi$proptypes).arrayOf((0, $7XTbi$proptypes).shape({
        label: (0, $7XTbi$proptypes).string,
        value: (0, $7XTbi$proptypes).string,
        isDisabled: (0, $7XTbi$proptypes).bool,
        isChecked: (0, $7XTbi$proptypes).bool,
        icon: (0, $7XTbi$proptypes).string
    })),
    onOptionChange: (0, $7XTbi$proptypes).func,
    prefixIconKind: (0, $7XTbi$proptypes).string,
    trigger: (0, $7XTbi$proptypes).element,
    label: (0, $7XTbi$proptypes).string,
    setIsExpanded: (0, $7XTbi$proptypes).func,
    shouldCloseMenuOnItemClick: (0, $7XTbi$proptypes).bool,
    shouldHoverOpenSubMenu: (0, $7XTbi$proptypes).bool,
    placement: (0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$5aa24cb5f38e9127))),
    fallbackPlacements: (0, $7XTbi$proptypes).arrayOf((0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$5aa24cb5f38e9127)))),
    dropdownClassName: (0, $7XTbi$proptypes).string,
    itemsClassName: (0, $7XTbi$proptypes).string,
    itemClassName: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string
};
$e3ff878f28f11e4a$var$MenuNested.defaultProps = {
    children: null,
    options: [],
    onOptionChange: null,
    prefixIconKind: null,
    trigger: null,
    label: null,
    setIsExpanded: ()=>{},
    shouldCloseMenuOnItemClick: false,
    shouldHoverOpenSubMenu: false,
    placement: (0, $65441b8e33d7ac73$export$5aa24cb5f38e9127).BOTTOM_START,
    fallbackPlacements: null,
    dropdownClassName: null,
    itemsClassName: null,
    itemClassName: null,
    dataTestId: null
};
var $e3ff878f28f11e4a$export$2e2bcd8739ae039 = $e3ff878f28f11e4a$var$MenuNested;


/* eslint-disable react/jsx-no-useless-fragment */ /* eslint-disable react/jsx-curly-spacing */ 

















function $f5ddd953b7dd72da$var$ModalIsland({ kind: kind, customAlertIcon: customAlertIcon, isLoading: isLoading, shouldConditionallyRender: shouldConditionallyRender, isOpen: isOpen, onClose: onClose, headerIcon: headerIcon, title: title, subtitle: subtitle, alertTitle: alertTitle, alertSubtitle: alertSubtitle, contentBody: contentBody, sectionRef: sectionRef, primaryButton: primaryButton, secondaryButton: secondaryButton, HeaderComp: HeaderComp, FooterActionBarComp: FooterActionBarComp, isOverflowVisible: isOverflowVisible, isOutsideClickEnabled: isOutsideClickEnabled, isCloseOnEscapeKeyEnabled: isCloseOnEscapeKeyEnabled, isCloseButtonVisible: isCloseButtonVisible, focusShards: focusShards, overlayBackgroundColor: overlayBackgroundColor, alertBackgroundClassName: alertBackgroundClassName, dataTheme: dataTheme, className: className, dataTestId: dataTestId }) {
    const closeButtonIconRef = (0, $7XTbi$useRef)(null);
    const modalRef = (0, $7XTbi$useRef)(null);
    // Overlay Transition and placement
    const zIndex = (0, $33f9c97b2967408a$export$2e2bcd8739ae039)(isOpen, modalRef, overlayBackgroundColor);
    const { renderContent: renderContent, isOpening: isOpening, isClosing: isClosing } = (0, $487d37a99b6b914a$export$a734948050b9a715)(isOpen, closeButtonIconRef);
    // Get the highest z-index from the overlay context. Determine if this modal is the topmost modal
    const { highestZIndex: highestZIndex } = (0, $84700a637e00ff00$export$ea8f71083e90600f)();
    const isTopModal = zIndex === highestZIndex;
    // Close Events Hooks
    (0, $7XTbi$useEscapeKeyClose)(onClose, isCloseOnEscapeKeyEnabled && isTopModal);
    (0, $7XTbi$useOutsideClickEffect)(modalRef, onClose, isOutsideClickEnabled && isOpen);
    const modalIslandClasses = (0, $7XTbi$classnames)("ModalIsland", `ModalIsland-${kind}`, isOpening && "ModalIsland--isOpening", isClosing && "ModalIsland--isClosing", isOverflowVisible && "ModalIsland--isOverflowVisible", className);
    const modalIslandSectionClasses = (0, $7XTbi$classnames)("ModalIsland-section", isLoading && "ModalIsland-section--isLoading");
    const headerWrapperClasses = (0, $7XTbi$classnames)("ModalIsland-headerWrapper");
    const headerClasses = (0, $7XTbi$classnames)("ModalIsland-header", subtitle && "ModalIsland-header--hasSubtitle", headerIcon && "ModalIsland-header--hasIcon");
    const alertModalIslandClasses = (0, $7XTbi$classnames)("ModalIsland-alert", `ModalIsland-alert-${kind}`);
    const alertBgClasses = (0, $7XTbi$classnames)("ModalIsland-alertBg", `ModalIsland-alertBg-${kind}`, alertBackgroundClassName);
    const getAlertIslandIcon = ()=>{
        switch(kind){
            case (0, $65441b8e33d7ac73$export$5e945644cd84b2b0).QUESTION:
                return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                    kind: "HelpFilledSeparateColors",
                    className: "ModalIsland-alertContent-icon",
                    dataTestId: "ModalIsland-Question"
                });
            case (0, $65441b8e33d7ac73$export$5e945644cd84b2b0).SUCCESS:
                return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                    kind: "CheckCircleFilledSeparateColors",
                    className: "ModalIsland-alertContent-icon",
                    dataTestId: "ModalIsland-Success"
                });
            case (0, $65441b8e33d7ac73$export$5e945644cd84b2b0).WARNING:
                return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                    kind: "AlertWarningFilledSeparateColors",
                    className: "ModalIsland-alertContent-icon",
                    dataTestId: "ModalIsland-Warning"
                });
            case (0, $65441b8e33d7ac73$export$5e945644cd84b2b0).CRITICAL:
                return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                    kind: "AlertCriticalFilledSeparateColors",
                    className: "ModalIsland-alertContent-icon",
                    dataTestId: "ModalIsland-Critical"
                });
            case (0, $65441b8e33d7ac73$export$5e945644cd84b2b0).SAVIYNT:
                return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                    kind: "SaviyntFilledSeparateColors",
                    className: "ModalIsland-alertContent-icon",
                    dataTestId: "ModalIsland-Saviynt"
                });
            case (0, $65441b8e33d7ac73$export$5e945644cd84b2b0).CUSTOM_ALERT:
                return customAlertIcon;
            default:
                return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                    kind: "SaviyntFilledSeparateColors",
                    className: "ModalIsland-alertContent-icon",
                    dataTestId: "ModalIsland-Saviynt"
                });
        }
    };
    const getHeaderContent = ()=>{
        if (!HeaderComp) return /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
            tag: "header",
            className: headerWrapperClasses,
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                    className: headerClasses,
                    children: [
                        headerIcon,
                        /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                            className: "ModalIsland-titleContainer",
                            children: [
                                /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5f880a93b57cab01$export$2e2bcd8739ae039), {
                                    kind: "h2",
                                    className: "ModalIsland-title",
                                    children: title
                                }),
                                subtitle && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5f880a93b57cab01$export$2e2bcd8739ae039), {
                                    kind: "body2",
                                    className: "ModalIsland-subtitle",
                                    children: subtitle
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
                    tag: "div",
                    className: "ModalIsland-closeBtn",
                    children: isCloseButtonVisible && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $e34ff86c7a827ee6$export$2e2bcd8739ae039), {
                        id: `modalCloseButton-${isOpen}`,
                        dataTestId: "ModalIslandCloseButton",
                        size: "medium",
                        kind: "ghost",
                        icon: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                            kind: "close",
                            color: "neutral-100",
                            size: "smallMedium"
                        }),
                        onClick: onClose
                    })
                })
            ]
        });
        return HeaderComp;
    };
    const getModalContent = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
            tag: "section",
            className: modalIslandSectionClasses,
            children: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $199d1dc410e8acb9$export$2e2bcd8739ae039), {
                kind: "loop",
                format: "main",
                color: "brand",
                size: "large"
            })
        });
        if (kind === (0, $65441b8e33d7ac73$export$5e945644cd84b2b0).DEFAULT) return /*#__PURE__*/ (0, $7XTbi$jsxs)("section", {
            className: "ModalIsland-section",
            children: [
                getHeaderContent(),
                /*#__PURE__*/ (0, $7XTbi$jsx)("section", {
                    className: "ModalIsland-body",
                    ref: sectionRef,
                    children: contentBody
                }),
                FooterActionBarComp
            ]
        });
        return /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
            tag: "section",
            className: alertModalIslandClasses,
            children: [
                isCloseButtonVisible && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $e34ff86c7a827ee6$export$2e2bcd8739ae039), {
                    ref: closeButtonIconRef,
                    dataTestId: "ModalIslandCloseButton",
                    size: "medium",
                    kind: "ghost",
                    className: "ModalIsland-alertCloseButton",
                    icon: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                        kind: "close",
                        color: "neutral-100",
                        size: "smallMedium"
                    }),
                    onClick: onClose
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                    kind: "AlertModalBackground",
                    color: "neutral-100",
                    className: alertBgClasses
                }),
                /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                    className: "ModalIsland-alertContent",
                    children: [
                        getAlertIslandIcon(),
                        /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                            className: "ModalIsland-alertContent-body",
                            children: HeaderComp || /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $7XTbi$Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5f880a93b57cab01$export$2e2bcd8739ae039), {
                                        kind: "h2",
                                        className: `ModalIsland-alertTitle ModalIsland-alertTitle-${kind}`,
                                        children: alertTitle
                                    }),
                                    /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5f880a93b57cab01$export$2e2bcd8739ae039), {
                                        kind: "body2",
                                        className: "ModalIsland-alertSubtitle",
                                        children: alertSubtitle
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                            className: "ModalIsland-alertContent-controlsContainer",
                            children: /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                                className: "ModalIsland-alertContent-controls",
                                children: [
                                    primaryButton,
                                    secondaryButton
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    };
    if (!renderContent && shouldConditionallyRender) return null;
    return /*#__PURE__*/ (0, $7XTbi$reactdom).createPortal(/*#__PURE__*/ (0, $7XTbi$jsx)((0, $7XTbi$RemoveScroll), {
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("aside", {
            id: "ModalIsland",
            ref: modalRef,
            role: "dialog",
            "aria-modal": "true",
            style: {
                zIndex: zIndex
            },
            className: modalIslandClasses,
            "data-testid": dataTestId,
            "data-theme": dataTheme,
            children: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $7XTbi$reactfocuslock), {
                className: "ModalIsland-focusLock",
                shards: focusShards,
                children: getModalContent()
            })
        })
    }), document.body);
}
$f5ddd953b7dd72da$var$ModalIsland.propTypes = {
    kind: (0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$5e945644cd84b2b0))),
    customAlertIcon: (0, $7XTbi$proptypes).element,
    isLoading: (0, $7XTbi$proptypes).bool,
    shouldConditionallyRender: (0, $7XTbi$proptypes).bool,
    isOpen: (0, $7XTbi$proptypes).bool.isRequired,
    onClose: (0, $7XTbi$proptypes).func.isRequired,
    headerIcon: (0, $7XTbi$proptypes).element,
    title: (0, $7XTbi$proptypes).oneOfType([
        (0, $7XTbi$proptypes).string,
        (0, $7XTbi$proptypes).shape({
            current: (0, $7XTbi$proptypes).instanceOf(Element)
        })
    ]),
    subtitle: (0, $7XTbi$proptypes).oneOfType([
        (0, $7XTbi$proptypes).string,
        (0, $7XTbi$proptypes).element
    ]),
    alertTitle: (0, $7XTbi$proptypes).string,
    alertSubtitle: (0, $7XTbi$proptypes).string,
    contentBody: (0, $7XTbi$proptypes).element,
    sectionRef: (0, $7XTbi$proptypes).oneOfType([
        (0, $7XTbi$proptypes).func,
        (0, $7XTbi$proptypes).shape({
            current: (0, $7XTbi$proptypes).instanceOf(Element)
        })
    ]),
    primaryButton: (0, $7XTbi$proptypes).element,
    secondaryButton: (0, $7XTbi$proptypes).element,
    HeaderComp: (0, $7XTbi$proptypes).element,
    FooterActionBarComp: (0, $7XTbi$proptypes).element,
    isOverflowVisible: (0, $7XTbi$proptypes).bool,
    isOutsideClickEnabled: (0, $7XTbi$proptypes).bool,
    isCloseOnEscapeKeyEnabled: (0, $7XTbi$proptypes).bool,
    isCloseButtonVisible: (0, $7XTbi$proptypes).bool,
    // focusShards: an array of ref pointing to the nodes, which focus lock should consider and a part of it.
    focusShards: (0, $7XTbi$proptypes).arrayOf((0, $65441b8e33d7ac73$export$de87879afd52ccf9)),
    overlayBackgroundColor: (0, $7XTbi$proptypes).string,
    alertBackgroundClassName: (0, $7XTbi$proptypes).string,
    dataTheme: (0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$49390a4605a2336a))),
    className: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string
};
$f5ddd953b7dd72da$var$ModalIsland.defaultProps = {
    kind: (0, $65441b8e33d7ac73$export$5e945644cd84b2b0).DEFAULT,
    customAlertIcon: null,
    isLoading: false,
    shouldConditionallyRender: true,
    headerIcon: null,
    title: "",
    subtitle: null,
    alertTitle: "",
    alertSubtitle: "",
    contentBody: null,
    sectionRef: null,
    primaryButton: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $9a0a9a7cc0462999$export$2e2bcd8739ae039), {
        type: "button",
        kind: "outlined",
        size: "medium",
        children: "Primary Button"
    }),
    secondaryButton: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $9a0a9a7cc0462999$export$2e2bcd8739ae039), {
        type: "button",
        kind: "ghost",
        size: "medium",
        children: "Cancel"
    }),
    HeaderComp: null,
    FooterActionBarComp: null,
    isOverflowVisible: false,
    isOutsideClickEnabled: false,
    isCloseOnEscapeKeyEnabled: true,
    isCloseButtonVisible: true,
    focusShards: [],
    overlayBackgroundColor: null,
    alertBackgroundClassName: null,
    dataTheme: null,
    className: null,
    dataTestId: null
};
var $f5ddd953b7dd72da$export$2e2bcd8739ae039 = $f5ddd953b7dd72da$var$ModalIsland;












function $2d535bbeb08870f5$var$ModalPageHeader({ title: title, subHeadingContent: subHeadingContent, closeHandler: closeHandler, className: className, dataTheme: dataTheme, dataTestId: dataTestId }) {
    const modalPageBackgroundClasses = (0, $7XTbi$classnames)("ModalPageHeader-background", className);
    return /*#__PURE__*/ (0, $7XTbi$jsx)("header", {
        className: modalPageBackgroundClasses,
        "data-theme": dataTheme,
        "data-testid": dataTestId,
        children: /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
            tag: "div",
            className: "ModalPageHeader",
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
                    tag: "div",
                    className: "ModalPageHeader-textContainer",
                    children: [
                        /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5f880a93b57cab01$export$2e2bcd8739ae039), {
                            kind: "h1",
                            className: "ModalPageHeader-title",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $7XTbi$jsx)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
                            tag: "div",
                            className: "ModalPageHeader-subHeadingContent",
                            children: subHeadingContent
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)((0, $e34ff86c7a827ee6$export$2e2bcd8739ae039), {
                    size: "large",
                    kind: "ghost",
                    className: "ModalPageHeader-closeButton",
                    icon: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                        kind: "Close"
                    }),
                    onClick: ()=>{
                        closeHandler();
                    }
                })
            ]
        })
    });
}
$2d535bbeb08870f5$var$ModalPageHeader.propTypes = {
    title: (0, $7XTbi$proptypes).string,
    subHeadingContent: (0, $7XTbi$proptypes).node,
    closeHandler: (0, $7XTbi$proptypes).func,
    className: (0, $7XTbi$proptypes).string,
    dataTheme: (0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$49390a4605a2336a))),
    dataTestId: (0, $7XTbi$proptypes).string
};
$2d535bbeb08870f5$var$ModalPageHeader.defaultProps = {
    title: null,
    subHeadingContent: null,
    closeHandler: ()=>window.history.back(),
    className: null,
    dataTheme: (0, $65441b8e33d7ac73$export$49390a4605a2336a).DARK,
    dataTestId: null
};
var $2d535bbeb08870f5$export$2e2bcd8739ae039 = $2d535bbeb08870f5$var$ModalPageHeader;











const $a121dee67c986139$var$DEFAULT_RANGE = [
    {
        label: "5",
        value: "5"
    },
    {
        label: "15",
        value: "15"
    },
    {
        label: "20",
        value: "20"
    },
    {
        label: "25",
        value: "25",
        isChecked: true
    },
    {
        label: "50",
        value: "50"
    },
    {
        label: "100",
        value: "100"
    }
];
function $a121dee67c986139$var$PaginationCondensed({ count: count, range: range, setRange: setRange, rangeOptions: rangeOptions, pageCount: pageCount, pageIndex: pageIndex, setPageIndex: setPageIndex, className: className }) {
    const [options, setOptions] = (0, $7XTbi$useState)(rangeOptions);
    const paginationCondensedClass = (0, $7XTbi$classnames)("PaginationCondensed", className);
    const renderRangeCalulations = ()=>/*#__PURE__*/ (0, $7XTbi$jsxs)("p", {
            className: "PaginationCondensed-body",
            "data-testid": "pagination-condensed-range-body",
            children: [
                pageIndex === 1 && count !== 0 ? 1 : pageIndex * range - range,
                " - ",
                pageIndex === pageCount || count === 0 ? count : pageIndex * range,
                " of ",
                count
            ]
        });
    const renderDirectionButton = (dir)=>{
        const handlePageDirection = ()=>{
            setPageIndex(dir === "left" ? pageIndex - 1 : pageIndex + 1);
        };
        return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $e34ff86c7a827ee6$export$2e2bcd8739ae039), {
            size: "small",
            kind: "ghost",
            isDisabled: dir === "left" ? pageIndex <= 1 : pageIndex >= pageCount,
            icon: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                kind: "ChevronDown",
                rotate: dir === "left" ? "90" : "270"
            }),
            onClick: ()=>handlePageDirection(),
            dataTestId: dir === "left" ? "prev-button" : "next-button"
        });
    };
    const handleChange = (selectedOption)=>{
        setOptions((currentOptions)=>currentOptions.map((option)=>({
                    ...option,
                    isChecked: option.value === selectedOption.value
                })));
        setRange(parseInt(selectedOption.value, 10));
    };
    return /*#__PURE__*/ (0, $7XTbi$jsxs)("section", {
        className: paginationCondensedClass,
        "data-testid": "pagination-condensed-section",
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                className: "PaginationCondensed-rangePicker",
                children: [
                    /*#__PURE__*/ (0, $7XTbi$jsx)("p", {
                        className: "PaginationCondensed-body",
                        children: "Records per page:"
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsx)((0, $9ef6121f0a4af6a4$export$2e2bcd8739ae039), {
                        kind: "simple",
                        options: options,
                        onChange: handleChange
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                className: "PaginationCondensed-divider"
            }),
            /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                className: "PaginationCondensed-rangeOutline",
                children: [
                    renderRangeCalulations(),
                    renderDirectionButton("left"),
                    renderDirectionButton("right")
                ]
            })
        ]
    });
}
$a121dee67c986139$var$PaginationCondensed.defaultProps = {
    count: null,
    range: 25,
    setRange: ()=>{},
    rangeOptions: $a121dee67c986139$var$DEFAULT_RANGE,
    pageCount: null,
    pageIndex: null,
    setPageIndex: null,
    className: null
};
$a121dee67c986139$var$PaginationCondensed.propTypes = {
    count: (0, $7XTbi$proptypes).number,
    range: (0, $7XTbi$proptypes).number,
    setRange: (0, $7XTbi$proptypes).func,
    rangeOptions: (0, $7XTbi$proptypes).arrayOf((0, $7XTbi$proptypes).shape({
        label: (0, $7XTbi$proptypes).string,
        value: (0, $7XTbi$proptypes).string,
        isDisabled: (0, $7XTbi$proptypes).bool,
        isChecked: (0, $7XTbi$proptypes).bool
    })),
    pageCount: (0, $7XTbi$proptypes).number,
    pageIndex: (0, $7XTbi$proptypes).number,
    setPageIndex: (0, $7XTbi$proptypes).func,
    className: (0, $7XTbi$proptypes).string
};
var $a121dee67c986139$export$2e2bcd8739ae039 = $a121dee67c986139$var$PaginationCondensed;













const $a50b1aa2658909fb$var$KINDS = {
    number: "number",
    ellipses: "ellipses",
    start: "start",
    end: "end"
};
function $a50b1aa2658909fb$var$PaginationItem({ itemIndex: itemIndex, kind: kind, tabIndex: tabIndex, isSelected: isSelected, isDisabled: isDisabled, isVisible: isVisible, onClick: onClick, className: className, dataTestId: dataTestId }) {
    const paginationItemClass = (0, $7XTbi$classnames)("PaginationItem", `PaginationItem-${kind}`, isDisabled && `PaginationItem--isDisabled`, isSelected && `PaginationItem--isSelected`, kind === "ellipses" && `PaginationItem--isEllipses`, className);
    const renderIcon = ()=>{
        if (kind === "start" || kind === "end") return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
            kind: "ChevronDown",
            rotate: kind === "start" ? "90" : "270",
            size: "smallMedium"
        });
        return null;
    };
    if (isVisible === false) return null;
    return /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $553ba9ca1822b2c0$export$2e2bcd8739ae039), {
        tabIndex: kind === "ellipses" ? -1 : tabIndex,
        onClick: onClick,
        isDisabled: isDisabled,
        className: paginationItemClass,
        dataTestId: dataTestId,
        children: [
            kind === "number" && itemIndex,
            kind === "ellipses" && "...",
            renderIcon()
        ]
    });
}
$a50b1aa2658909fb$var$PaginationItem.defaultProps = {
    itemIndex: null,
    tabIndex: 0,
    isDisabled: false,
    isSelected: false,
    isVisible: true,
    onClick: null,
    className: null,
    dataTestId: null
};
$a50b1aa2658909fb$var$PaginationItem.propTypes = {
    itemIndex: (0, $7XTbi$proptypes).number,
    kind: (0, $7XTbi$proptypes).oneOf(Object.values($a50b1aa2658909fb$var$KINDS)).isRequired,
    tabIndex: (0, $7XTbi$proptypes).number,
    isDisabled: (0, $7XTbi$proptypes).bool,
    isSelected: (0, $7XTbi$proptypes).bool,
    isVisible: (0, $7XTbi$proptypes).bool,
    onClick: (0, $7XTbi$proptypes).func,
    className: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string
};
var $a50b1aa2658909fb$export$2e2bcd8739ae039 = $a50b1aa2658909fb$var$PaginationItem;



/**
 * #### WIP TODO:
 *
 * - Update range selection with SingleSelect
 * - Update PaginationCondensed to open Menu single select
 * - Question to design: What do you want the condensed button to be? I just made it a ghost button.
 */ function $2b436ec080a89837$var$PaginationGroup({ pageCount: pageCount, pageIndex: pageIndex, setPageIndex: setPageIndex, className: className, dataTestId: dataTestId }) {
    const prevPageIndex = (0, $7XTbi$useRef)(null);
    (0, $7XTbi$useEffect)(()=>{
        // Store the previous page index, for the transition effects with no ellipses
        prevPageIndex.current = pageIndex;
    }, [
        pageIndex
    ]);
    const paginationGroupClass = (0, $7XTbi$classnames)("PaginationGroup", className);
    // Create an array to represent the pages
    const pagesArray = Array.from({
        length: pageCount
    }, (_, index)=>index + 1);
    // Function to get transition class name for PaginationItem
    const transitionClass = (itemIndex)=>{
        if (pageCount <= 5) return "PaginationItem--transition";
        // Logic for no transition at the start of the range
        const isAtStartRange = prevPageIndex.current === 5 && itemIndex === 4 || pageIndex === 5 && itemIndex === 4;
        // Logic for no transition at the end of the range
        const isAtEndRange = prevPageIndex.current === pageCount - 4 && itemIndex === pageCount - 3 || pageIndex === pageCount - 4 && itemIndex === pageCount - 3;
        if (isAtStartRange || isAtEndRange) return "PaginationItem--noTransition";
        if (itemIndex >= pageCount - 3 || itemIndex <= 4) return "PaginationItem--transition";
        return "PaginationItem--noTransition";
    };
    const getItemKind = (itemIndex)=>{
        if (pageCount <= 5) return "number";
        // Check if the page index is centered
        const isCentered = itemIndex === pageIndex - 2 || itemIndex === pageIndex + 2;
        // Check if we are at the start or end
        const isAtExtremeEnds = itemIndex === 1 || itemIndex === pageCount;
        if (isAtExtremeEnds) return "number";
        // Check if the page index is near the start
        const isPageIndexNearStart = pageIndex >= 1 && pageIndex <= 4;
        const isItemNearStart = itemIndex >= 2 && itemIndex <= 5;
        if (isPageIndexNearStart && isItemNearStart) return "number";
        if (isPageIndexNearStart && itemIndex === 6) return "ellipses";
        // Check if the page index is near the end
        const isPageIndexNearEnd = pageIndex >= pageCount - 3 && pageIndex <= pageCount;
        const isItemNearEnd = itemIndex >= pageCount - 4 && itemIndex <= pageCount;
        if (isPageIndexNearEnd && isItemNearEnd) return "number";
        if (isPageIndexNearEnd && itemIndex === pageCount - 5) return "ellipses";
        if (isCentered) return "ellipses";
        return "number";
    };
    const getItemIsSelected = (itemIndex)=>itemIndex === pageIndex;
    const getOutOfSelectRange = (itemIndex)=>{
        if (pageCount <= 5) return true;
        // Item is the current page or adjacent to it
        if (Math.abs(itemIndex - pageIndex) <= 2) return true;
        // Item is the first or last page
        if (itemIndex === 1 || itemIndex === pageCount) return true;
        // Start and End of the pages
        if (pageIndex <= 4 && itemIndex >= 3 && itemIndex <= 6) return true;
        if (pageIndex >= pageCount - 3 && itemIndex >= pageCount - 5 && itemIndex <= pageCount) return true;
        return false;
    };
    const handlePageDirection = (dir)=>{
        setPageIndex(dir ? pageIndex + 1 : pageIndex - 1);
    };
    if (pageCount <= 1) return null;
    return /*#__PURE__*/ (0, $7XTbi$jsxs)("section", {
        className: paginationGroupClass,
        "data-testid": dataTestId,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)((0, $a50b1aa2658909fb$export$2e2bcd8739ae039), {
                kind: "start",
                isDisabled: pageIndex === 1,
                onClick: ()=>handlePageDirection(false),
                dataTestId: "prev-button"
            }),
            pagesArray.map((page, index)=>/*#__PURE__*/ (0, $7XTbi$jsx)((0, $a50b1aa2658909fb$export$2e2bcd8739ae039), {
                    kind: getItemKind(index + 1),
                    itemIndex: index + 1,
                    onClick: ()=>setPageIndex(index + 1),
                    isSelected: getItemIsSelected(index + 1),
                    isVisible: getOutOfSelectRange(index + 1),
                    className: transitionClass(index + 1),
                    dataTestId: `pagination-item-${index + 1}`
                }, index)),
            /*#__PURE__*/ (0, $7XTbi$jsx)((0, $a50b1aa2658909fb$export$2e2bcd8739ae039), {
                kind: "end",
                isDisabled: pageIndex >= pageCount,
                onClick: ()=>handlePageDirection(true),
                dataTestId: "next-button"
            })
        ]
    });
}
$2b436ec080a89837$var$PaginationGroup.defaultProps = {
    pageCount: null,
    pageIndex: null,
    setPageIndex: null,
    className: null,
    dataTestId: null
};
$2b436ec080a89837$var$PaginationGroup.propTypes = {
    pageCount: (0, $7XTbi$proptypes).number,
    pageIndex: (0, $7XTbi$proptypes).number,
    setPageIndex: (0, $7XTbi$proptypes).func,
    className: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string
};
var $2b436ec080a89837$export$2e2bcd8739ae039 = $2b436ec080a89837$var$PaginationGroup;
$2b436ec080a89837$var$PaginationGroup.displayName = "Pagination";



/* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable object-curly-newline */ 







// Important Documentation: https://floating-ui.com/
function $11e1006960f3c7db$var$Popover({ dataTheme: dataTheme, isOpen: isOpen, setIsOpen: setIsOpen, trigger: trigger, popoverContent: popoverContent, placement: placement, offset: offset, isPortalEnabled: isPortalEnabled, dataTestId: dataTestId }) {
    const arrowRef = (0, $7XTbi$useRef)(null);
    const popoverWrapperClasses = (0, $7XTbi$classnames)("Popover-wrapper", isOpen && "Popover-wrapper--isOpen");
    const { refs: refs, floatingStyles: floatingStyles, context: context } = (0, $7XTbi$useFloating)({
        open: isOpen,
        onOpenChange: setIsOpen,
        placement: placement,
        middleware: [
            (0, $7XTbi$offset)(offset),
            (0, $7XTbi$flip)({
                fallbackAxisSideDirection: "end"
            }),
            (0, $7XTbi$shift)(),
            (0, $7XTbi$arrow)({
                element: arrowRef.current
            })
        ],
        whileElementsMounted: (0, $7XTbi$autoUpdate)
    });
    const clickInteraction = (0, $7XTbi$useClick)(context);
    const dismissInteraction = (0, $7XTbi$useDismiss)(context);
    const roleInteraction = (0, $7XTbi$useRole)(context);
    const { getReferenceProps: getReferenceProps, getFloatingProps: getFloatingProps } = (0, $7XTbi$useInteractions)([
        clickInteraction,
        dismissInteraction,
        roleInteraction
    ]);
    const getPopoverKind = ()=>{
        const floatingContent = /*#__PURE__*/ (0, $7XTbi$jsx)((0, $7XTbi$FloatingFocusManager), {
            context: context,
            modal: false,
            children: /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                className: "Popover",
                ref: refs.setFloating,
                style: floatingStyles,
                ...getFloatingProps(),
                children: [
                    popoverContent,
                    /*#__PURE__*/ (0, $7XTbi$jsx)((0, $7XTbi$FloatingArrow), {
                        ref: arrowRef,
                        context: context,
                        width: 26,
                        height: 14,
                        stroke: "var(--color-border-neutral-subtlest, #cecfd9)",
                        strokeWidth: 1,
                        fill: "var(--color-background-neutral-subtlest, #fff)"
                    })
                ]
            })
        });
        return isPortalEnabled ? /*#__PURE__*/ (0, $7XTbi$jsx)((0, $7XTbi$FloatingPortal), {
            children: floatingContent
        }) : floatingContent;
    };
    return /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
        tag: "div",
        className: popoverWrapperClasses,
        dataTheme: dataTheme,
        dataTestId: dataTestId,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                ref: refs.setReference,
                ...getReferenceProps(),
                children: trigger
            }),
            isOpen && getPopoverKind()
        ]
    });
}
$11e1006960f3c7db$var$Popover.propTypes = {
    dataTheme: (0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$49390a4605a2336a))),
    isOpen: (0, $7XTbi$proptypes).bool.isRequired,
    setIsOpen: (0, $7XTbi$proptypes).func.isRequired,
    trigger: (0, $7XTbi$proptypes).element.isRequired,
    popoverContent: (0, $7XTbi$proptypes).element.isRequired,
    placement: (0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$5aa24cb5f38e9127))),
    offset: (0, $7XTbi$proptypes).number,
    isPortalEnabled: (0, $7XTbi$proptypes).bool,
    dataTestId: (0, $7XTbi$proptypes).string
};
$11e1006960f3c7db$var$Popover.defaultProps = {
    dataTheme: null,
    placement: (0, $65441b8e33d7ac73$export$5aa24cb5f38e9127).BOTTOM,
    offset: 16,
    isPortalEnabled: false,
    dataTestId: null
};
var $11e1006960f3c7db$export$2e2bcd8739ae039 = $11e1006960f3c7db$var$Popover;











const $daa9319cd1e2c635$var$RADIO_ICON_STATES = {
    OUTLINE: "radioOutline",
    HOVER: "radioOutlineHover",
    PRESSED: "radioOutlinePressed",
    SELECTED: "radioOutlineSelected"
};
function $daa9319cd1e2c635$var$RadioButton({ id: id, name: name, title: title, description: description, value: value, radioSelection: radioSelection, onClick: onClick, isDisabled: isDisabled, isTruncated: isTruncated, frontIcon: frontIcon, className: className, dataTestId: dataTestId }) {
    const [iconState, setIconState] = (0, $7XTbi$useState)($daa9319cd1e2c635$var$RADIO_ICON_STATES.OUTLINE);
    // if value or radioSelection are objects, note that it's a referential comparison.
    const isRadioChecked = value === radioSelection;
    const radioButtonClasses = (0, $7XTbi$classnames)("RadioButton", isDisabled && "RadioButton--isDisabled", frontIcon && "RadioButton--hasFrontIcon", isRadioChecked && "RadioButton--isChecked", className);
    const radioOutlineIconClasses = (0, $7XTbi$classnames)("RadioButton-button", isDisabled && "RadioButton-button--isDisabled");
    const titleClasses = (0, $7XTbi$classnames)("RadioButton-title", isTruncated && "RadioButton-title--isTruncated");
    const descriptionClasses = (0, $7XTbi$classnames)("RadioButton-description", isTruncated && "RadioButton-description--isTruncated");
    (0, $7XTbi$useEffect)(()=>{
        setIconState(isRadioChecked ? $daa9319cd1e2c635$var$RADIO_ICON_STATES.SELECTED : $daa9319cd1e2c635$var$RADIO_ICON_STATES.OUTLINE);
    }, [
        isRadioChecked
    ]);
    const handleMouseEnter = ()=>setIconState(isRadioChecked ? $daa9319cd1e2c635$var$RADIO_ICON_STATES.SELECTED : $daa9319cd1e2c635$var$RADIO_ICON_STATES.HOVER);
    const handleMouseLeave = ()=>setIconState(isRadioChecked ? $daa9319cd1e2c635$var$RADIO_ICON_STATES.SELECTED : $daa9319cd1e2c635$var$RADIO_ICON_STATES.OUTLINE);
    const handleMouseDown = ()=>setIconState($daa9319cd1e2c635$var$RADIO_ICON_STATES.PRESSED);
    const handleMouseUp = ()=>setIconState(isRadioChecked ? $daa9319cd1e2c635$var$RADIO_ICON_STATES.SELECTED : $daa9319cd1e2c635$var$RADIO_ICON_STATES.HOVER);
    const handleRadioClick = (e)=>{
        if (!isDisabled) {
            onClick(e, value);
            setIconState($daa9319cd1e2c635$var$RADIO_ICON_STATES.SELECTED);
        }
    };
    return /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $553ba9ca1822b2c0$export$2e2bcd8739ae039), {
        className: radioButtonClasses,
        isDisabled: isDisabled,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onMouseDown: handleMouseDown,
        onMouseUp: handleMouseUp,
        onClick: (e)=>{
            handleRadioClick(e);
        },
        dataTestId: `${dataTestId}-button`,
        "aria-checked": isRadioChecked,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
                tag: "div",
                className: "RadioButton-content",
                children: [
                    frontIcon,
                    /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
                        tag: "div",
                        className: "RadioButton-text",
                        children: [
                            /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5f880a93b57cab01$export$2e2bcd8739ae039), {
                                kind: "label",
                                htmlFor: name,
                                className: titleClasses,
                                children: title
                            }),
                            /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5f880a93b57cab01$export$2e2bcd8739ae039), {
                                kind: "body2",
                                className: descriptionClasses,
                                children: description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
                        tag: "div",
                        className: "RadioButton-input-contatiner",
                        children: [
                            /*#__PURE__*/ (0, $7XTbi$jsx)("input", {
                                type: "radio",
                                id: id,
                                name: name,
                                value: value,
                                checked: isRadioChecked,
                                onChange: ()=>{},
                                disabled: isDisabled,
                                className: "RadioButton-input",
                                "aria-hidden": true,
                                "data-testid": `${dataTestId}-input`
                            }),
                            /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                                kind: iconState,
                                className: radioOutlineIconClasses
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                className: "RadioButton-overlay"
            })
        ]
    });
}
$daa9319cd1e2c635$var$RadioButton.propTypes = {
    id: (0, $7XTbi$proptypes).string.isRequired,
    name: (0, $7XTbi$proptypes).string.isRequired,
    title: (0, $7XTbi$proptypes).string.isRequired,
    description: (0, $7XTbi$proptypes).string,
    value: (0, $7XTbi$proptypes).oneOfType([
        (0, $7XTbi$proptypes).number,
        (0, $7XTbi$proptypes).bool,
        (0, $7XTbi$proptypes).string,
        (0, $7XTbi$proptypes).object
    ]).isRequired,
    radioSelection: (0, $7XTbi$proptypes).oneOfType([
        (0, $7XTbi$proptypes).number,
        (0, $7XTbi$proptypes).bool,
        (0, $7XTbi$proptypes).string,
        (0, $7XTbi$proptypes).object
    ]),
    onClick: (0, $7XTbi$proptypes).func,
    frontIcon: (0, $7XTbi$proptypes).element,
    isDisabled: (0, $7XTbi$proptypes).bool,
    isTruncated: (0, $7XTbi$proptypes).bool,
    className: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string
};
$daa9319cd1e2c635$var$RadioButton.defaultProps = {
    description: null,
    radioSelection: null,
    onClick: ()=>{},
    frontIcon: null,
    isDisabled: false,
    isTruncated: false,
    className: null,
    dataTestId: null
};
var $daa9319cd1e2c635$export$2e2bcd8739ae039 = $daa9319cd1e2c635$var$RadioButton;




// TODO: delete this component when MenuMulti is in use.
function $fd4a8693f24b1189$var$SelectMulti() {
    return /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
        children: "Use MenuMulti"
    });
}
var $fd4a8693f24b1189$export$2e2bcd8739ae039 = $fd4a8693f24b1189$var$SelectMulti;



















const { SIDEPANEL_CLOSE_BUTTON: $fc451ffe085c8096$var$SIDEPANEL_CLOSE_BUTTON, SIDEPANEL_UP_BUTTON: $fc451ffe085c8096$var$SIDEPANEL_UP_BUTTON, SIDEPANEL_DOWN_BUTTON: $fc451ffe085c8096$var$SIDEPANEL_DOWN_BUTTON } = (0, $65441b8e33d7ac73$export$800daf5fbbe96aff);
// TODO: @Jacob, Update UT's
// TODO: @Jacob, Test shards are focusing the Nave buttons
const $fc451ffe085c8096$var$SidePanel = /*#__PURE__*/ (0, $7XTbi$forwardRef)(({ isOpen: isOpen, onClose: onClose, footer: footer, layout: layout, header: header, isSidePanelNavigatingList: // List Nav
isSidePanelNavigatingList, onClickUp: onClickUp, onClickDown: onClickDown, isDisabledUp: isDisabledUp, isDisabledDown: isDisabledDown, isTabletWidth: // Rendering
isTabletWidth, shouldConditionallyRender: // isMobileWidth, // TODO: isMobileWidth is just Prep for DSD-116
shouldConditionallyRender, isOutsideClickEnabled: isOutsideClickEnabled, isCloseOnEscapeKeyEnabled: isCloseOnEscapeKeyEnabled, focusShards: // Utils
focusShards, isResponsivenessDisabled: isResponsivenessDisabled, dataTheme: dataTheme, className: className, layoutClassName: layoutClassName, headerClassName: headerClassName, footerClassName: footerClassName, dataTestId: dataTestId }, ref)=>{
    const closeButtonIconRef = (0, $7XTbi$useRef)(null);
    const localRef = (0, $7XTbi$useRef)(null);
    const sidePanelRef = ref || localRef;
    // Nav Tablet Buttons
    const navUpTabletRef = (0, $7XTbi$useRef)(null);
    const navDownTabletRef = (0, $7XTbi$useRef)(null);
    // const shouldUseOverlay = isOpen && (isTabletWidth || isMobileWidth);
    const shouldUseOverlay = isOpen && isTabletWidth;
    // Overlay Transition and placement
    const zIndex = (0, $33f9c97b2967408a$export$2e2bcd8739ae039)(shouldUseOverlay ? isOpen : false, sidePanelRef);
    const { renderContent: renderContent, isOpening: isOpening, isClosing: isClosing } = (0, $487d37a99b6b914a$export$a734948050b9a715)(shouldUseOverlay ? isOpen : false, closeButtonIconRef);
    // Get the highest z-index from the overlay context. Determine if this modal is the topmost modal
    const { highestZIndex: highestZIndex } = (0, $84700a637e00ff00$export$ea8f71083e90600f)();
    const isTopModal = zIndex === highestZIndex;
    // Close Events Hooks
    (0, $7XTbi$useEscapeKeyClose)(onClose, isCloseOnEscapeKeyEnabled && isTopModal);
    (0, $7XTbi$useOutsideClickEffect)(sidePanelRef, onClose, isOutsideClickEnabled && isOpen && isTabletWidth);
    const shardsArray = [
        navUpTabletRef,
        navDownTabletRef,
        ...focusShards
    ];
    const sidePanelClasses = (0, $7XTbi$classnames)("SidePanel", isTabletWidth && "ModalSidePanel", // (isTabletWidth || isMobileWidth) && 'ModalSidePanel',
    isTabletWidth && "ModalSidePanel--isTabletWidth", // isMobileWidth && 'ModalSidePanel--isMobileWidth',
    isOpening && "ModalSidePanel--isOpening", isClosing && "ModalSidePanel--isClosing", isResponsivenessDisabled && "SidePanel--isResponsivenessDisabled", className);
    const innerSectionClasses = (0, $7XTbi$classnames)("SidePanel-innerContent");
    const headerClasses = (0, $7XTbi$classnames)("SidePanel-header", headerClassName);
    const layoutClasses = (0, $7XTbi$classnames)("SidePanel-layout", "ModalSidePanel-layout", layoutClassName);
    const footerClasses = (0, $7XTbi$classnames)("SidePanel-footer", footerClassName);
    const getInnerContent = ()=>/*#__PURE__*/ (0, $7XTbi$jsxs)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
            tag: "div",
            className: innerSectionClasses,
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                    className: headerClasses,
                    children: [
                        /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                            className: "SidePanel-headerTextIconGroup",
                            children: [
                                /*#__PURE__*/ (0, $7XTbi$jsx)((0, $f999930470b087cd$export$2e2bcd8739ae039), {
                                    logo: header?.icon,
                                    size: "large"
                                }),
                                /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                                    className: "SidePanel-headerText",
                                    children: [
                                        header?.title && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5f880a93b57cab01$export$2e2bcd8739ae039), {
                                            kind: "h3",
                                            className: "SidePanel-headerTitle",
                                            children: header.title
                                        }),
                                        header?.description && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5f880a93b57cab01$export$2e2bcd8739ae039), {
                                            kind: "body3",
                                            className: "SidePanel-headerDescription",
                                            children: header.description
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7XTbi$jsx)((0, $e34ff86c7a827ee6$export$2e2bcd8739ae039), {
                            id: "SidePanel-closeButton",
                            size: "medium",
                            kind: "ghost",
                            icon: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                                kind: "close",
                                color: "neutral-100",
                                size: "medium"
                            }),
                            onClick: onClose,
                            dataTestId: $fc451ffe085c8096$var$SIDEPANEL_CLOSE_BUTTON
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                    className: layoutClasses,
                    children: layout
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                    className: footerClasses,
                    children: footer
                })
            ]
        });
    const innerContent = getInnerContent();
    const isDesktopWidthAndOpen = !isTabletWidth && isOpen;
    // const isDesktopWidthAndOpen = (!isTabletWidth || !isMobileWidth) && isOpen;
    const isResponsivePanel = !renderContent && shouldConditionallyRender && !isDesktopWidthAndOpen;
    if (isResponsivePanel || !isOpen) return null;
    if (isTabletWidth) return /*#__PURE__*/ (0, $7XTbi$reactdom).createPortal(/*#__PURE__*/ (0, $7XTbi$jsx)((0, $7XTbi$RemoveScroll), {
        children: /*#__PURE__*/ (0, $7XTbi$jsx)("aside", {
            id: "SidePanel",
            ref: sidePanelRef,
            role: "dialog",
            "aria-modal": "true",
            style: {
                zIndex: zIndex
            },
            className: sidePanelClasses,
            "data-testid": dataTestId,
            "data-theme": dataTheme,
            children: /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $7XTbi$reactfocuslock), {
                className: "ModalSidePanel-focusLock",
                shards: shardsArray,
                children: [
                    innerContent,
                    isSidePanelNavigatingList && /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
                        tag: "div",
                        className: "ModalSidePanel-moveTileBtnGroup",
                        children: [
                            /*#__PURE__*/ (0, $7XTbi$jsx)((0, $e34ff86c7a827ee6$export$2e2bcd8739ae039), {
                                ref: navUpTabletRef,
                                size: "large",
                                kind: "outlinedNeutral",
                                icon: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                                    kind: "ChevronUp"
                                }),
                                onClick: onClickUp,
                                isDisabled: isDisabledUp,
                                dataTestId: $fc451ffe085c8096$var$SIDEPANEL_UP_BUTTON
                            }),
                            /*#__PURE__*/ (0, $7XTbi$jsx)((0, $e34ff86c7a827ee6$export$2e2bcd8739ae039), {
                                ref: navDownTabletRef,
                                size: "large",
                                kind: "outlinedNeutral",
                                icon: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                                    kind: "ChevronDown"
                                }),
                                onClick: onClickDown,
                                isDisabled: isDisabledDown,
                                dataTestId: $fc451ffe085c8096$var$SIDEPANEL_DOWN_BUTTON
                            })
                        ]
                    })
                ]
            })
        })
    }), document.body);
    return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
        kind: "aside",
        id: "SidePanel",
        ref: sidePanelRef,
        className: sidePanelClasses,
        dataTestId: dataTestId,
        children: innerContent
    });
});
$fc451ffe085c8096$var$SidePanel.propTypes = {
    isOpen: (0, $7XTbi$proptypes).bool,
    onClose: (0, $7XTbi$proptypes).func,
    layout: (0, $7XTbi$proptypes).element,
    footer: (0, $7XTbi$proptypes).element,
    header: (0, $7XTbi$proptypes).shape({
        title: (0, $7XTbi$proptypes).string,
        description: (0, $7XTbi$proptypes).string,
        icon: (0, $7XTbi$proptypes).string
    }),
    isSidePanelNavigatingList: (0, $7XTbi$proptypes).bool,
    onClickUp: (0, $7XTbi$proptypes).func,
    onClickDown: (0, $7XTbi$proptypes).func,
    isDisabledUp: (0, $7XTbi$proptypes).bool,
    isDisabledDown: (0, $7XTbi$proptypes).bool,
    isTabletWidth: (0, $7XTbi$proptypes).bool,
    // isMobileWidth: PropTypes.bool,
    shouldConditionallyRender: (0, $7XTbi$proptypes).bool,
    isOutsideClickEnabled: (0, $7XTbi$proptypes).bool,
    isCloseOnEscapeKeyEnabled: (0, $7XTbi$proptypes).bool,
    // focusShards: an array of ref pointing to the nodes, which focus lock should consider and a part of it.
    focusShards: (0, $7XTbi$proptypes).arrayOf((0, $65441b8e33d7ac73$export$de87879afd52ccf9)),
    isResponsivenessDisabled: (0, $7XTbi$proptypes).bool,
    dataTheme: (0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$49390a4605a2336a))),
    className: (0, $7XTbi$proptypes).string,
    layoutClassName: (0, $7XTbi$proptypes).string,
    headerClassName: (0, $7XTbi$proptypes).string,
    footerClassName: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string
};
$fc451ffe085c8096$var$SidePanel.defaultProps = {
    isOpen: false,
    onClose: ()=>{},
    layout: null,
    footer: null,
    header: null,
    isSidePanelNavigatingList: false,
    onClickUp: ()=>{},
    onClickDown: ()=>{},
    isDisabledUp: true,
    isDisabledDown: true,
    isTabletWidth: false,
    // isMobileWidth: false,
    shouldConditionallyRender: true,
    isOutsideClickEnabled: false,
    isCloseOnEscapeKeyEnabled: true,
    // focusShards: an array of ref pointing to the nodes, which focus lock should consider and a part of it. This is another way focus scattering
    focusShards: [],
    // TODO: Remove TEMP bool isResponsivenessDisabled, used to avoid PAM regressions
    isResponsivenessDisabled: false,
    dataTheme: null,
    className: null,
    layoutClassName: null,
    headerClassName: null,
    footerClassName: null,
    dataTestId: null
};
var $fc451ffe085c8096$export$2e2bcd8739ae039 = $fc451ffe085c8096$var$SidePanel;


/* eslint-disable object-curly-newline */ 







const $c6b4aa88d3042587$var$SWITCH_LABEL_POSITIONS = {
    RIGHT: "right",
    LEFT: "left"
};
function $c6b4aa88d3042587$var$Switch({ id: id, label: label, labelPosition: labelPosition, isChecked: isChecked, onChange: onChange, isDisabled: isDisabled, tabIndex: tabIndex, dataTheme: dataTheme, className: className, dataTestId: dataTestId }) {
    const switchClasses = (0, $7XTbi$classnames)("Switch", isChecked && "Switch--isChecked", isDisabled && "Switch--isDisabled", labelPosition && `Switch--label${(0, $7XTbi$capitalizeFirstLetter)(labelPosition)}`, className);
    const buttonClasses = (0, $7XTbi$classnames)("Switch-button");
    return /*#__PURE__*/ (0, $7XTbi$jsxs)("button", {
        id: id,
        type: "button",
        role: "switch",
        "aria-checked": isChecked,
        onClick: onChange,
        disabled: isDisabled,
        className: switchClasses,
        tabIndex: isDisabled ? -1 : tabIndex,
        "data-theme": dataTheme,
        "data-testid": dataTestId,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                className: buttonClasses,
                children: [
                    /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                        className: "Switch-handleOuterLayer"
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                        className: "Switch-handle"
                    })
                ]
            }),
            label && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5f880a93b57cab01$export$2e2bcd8739ae039), {
                kind: "label",
                desktop: "body1-d",
                mobile: "body1-d",
                htmlFor: id,
                className: "Switch-label",
                children: label
            })
        ]
    });
}
$c6b4aa88d3042587$var$Switch.propTypes = {
    id: (0, $7XTbi$proptypes).string,
    label: (0, $7XTbi$proptypes).string,
    labelPosition: (0, $7XTbi$proptypes).oneOf(Object.values($c6b4aa88d3042587$var$SWITCH_LABEL_POSITIONS)),
    isChecked: (0, $7XTbi$proptypes).bool.isRequired,
    onChange: (0, $7XTbi$proptypes).func.isRequired,
    isDisabled: (0, $7XTbi$proptypes).bool,
    tabIndex: (0, $7XTbi$proptypes).number,
    dataTheme: (0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$49390a4605a2336a))),
    className: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string
};
$c6b4aa88d3042587$var$Switch.defaultProps = {
    id: null,
    label: null,
    labelPosition: $c6b4aa88d3042587$var$SWITCH_LABEL_POSITIONS.RIGHT,
    isDisabled: false,
    tabIndex: 0,
    dataTheme: null,
    className: null,
    dataTestId: null
};
var $c6b4aa88d3042587$export$2e2bcd8739ae039 = $c6b4aa88d3042587$var$Switch;







function $5eded0bf0d8942b4$var$TabContent({ value: value, tabValue: tabValue, children: children, className: className }) {
    const classes = (0, $7XTbi$classnames)("TabContent", className);
    return value === tabValue ? /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
        role: "tabpanel",
        "aria-labelledby": `tab-${value}`,
        className: classes,
        children: children
    }) : null;
}
$5eded0bf0d8942b4$var$TabContent.propTypes = {
    value: (0, $7XTbi$proptypes).string.isRequired,
    tabValue: (0, $7XTbi$proptypes).string.isRequired,
    children: (0, $7XTbi$proptypes).node.isRequired,
    className: (0, $7XTbi$proptypes).string
};
$5eded0bf0d8942b4$var$TabContent.defaultProps = {
    className: null
};
var $5eded0bf0d8942b4$export$2e2bcd8739ae039 = $5eded0bf0d8942b4$var$TabContent;


/* eslint-disable react/jsx-curly-newline */ /* eslint-disable react/jsx-wrap-multilines */ /* eslint-disable react/jsx-curly-spacing */ 




















function $0e72242ab07afce9$var$TabItem({ label: label, value: value, tabGroupValue: tabGroupValue, moreTabOptions: moreTabOptions, isLastChild: isLastChild, moreContainerRef: moreContainerRef, tabIndex: tabIndex, onClick: onClick, moveTabItem: moveTabItem, icon: icon, size: size, tooltipProps: tooltipProps, popoverProps: popoverProps, BadgeComp: BadgeComp, PopoverContent: PopoverContent, className: className, dataTestId: dataTestId }) {
    const tabItemTargetRef = (0, $7XTbi$useRef)(null);
    const isActive = tabGroupValue === value;
    const isInMore = moreTabOptions?.some((option)=>option.value === value);
    const tabItemClasses = (0, $7XTbi$classnames)("TabItem", `TabItem--${size}`, isActive && "TabItem--isActive", className);
    const buttonClasses = (0, $7XTbi$classnames)("TabItem-button", `TabItem-button--${size}`);
    (0, $7XTbi$useEffect)(()=>{
        const tabItemTarget = tabItemTargetRef.current;
        const rootRef = moreContainerRef?.current || null;
        const shouldNotObserve = !tabItemTarget || !isLastChild || moreTabOptions.length !== 0;
        if (shouldNotObserve) return;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                const isFullyVisibleHorizontally = entry.boundingClientRect.left >= 0 && entry.boundingClientRect.right <= window.innerWidth;
                // Reference window dimensions
                if (!rootRef && !isFullyVisibleHorizontally && !isInMore) moveTabItem();
                // When using a rootRef
                if (rootRef && !entry.isIntersecting && !isInMore) moveTabItem();
            });
        }, {
            root: rootRef,
            threshold: 1
        });
        observer.observe(tabItemTarget);
        // eslint-disable-next-line consistent-return
        return ()=>observer.disconnect();
    }, [
        isInMore,
        isLastChild,
        moreContainerRef,
        moreTabOptions.length,
        moveTabItem
    ]);
    // Will need updated for more sizes in the future
    const getLabelFont = ()=>{
        if (isActive) return (0, $65441b8e33d7ac73$export$ead22628fc157ba4).LARGE ? "body1-bold-d" : "body2-bold-d";
        return (0, $65441b8e33d7ac73$export$ead22628fc157ba4).LARGE ? "body1-d" : "body2-d";
    };
    const shouldRenderTarget = isLastChild && moreTabOptions.length === 0;
    const labelFont = getLabelFont();
    const TooltipTrigger = /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
        role: "tab",
        "aria-selected": isActive,
        className: tabItemClasses,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $553ba9ca1822b2c0$export$2e2bcd8739ae039), {
                className: buttonClasses,
                onClick: onClick,
                onKeyDown: (event)=>{
                    if (event.key === "Enter") onClick();
                },
                tabIndex: tabIndex,
                dataTestId: dataTestId,
                children: [
                    icon,
                    /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5f880a93b57cab01$export$2e2bcd8739ae039), {
                        kind: "label",
                        desktop: labelFont,
                        mobile: labelFont,
                        className: "TabItem-label",
                        children: label
                    }),
                    BadgeComp && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $9e3775a9a154967e$export$2e2bcd8739ae039), {
                        className: "TabItem-badgeComp",
                        children: BadgeComp
                    })
                ]
            }),
            shouldRenderTarget && /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                "data-testid": `tabitem-observe-target-${value}`,
                ref: tabItemTargetRef,
                className: "TabItem-targetObserver"
            })
        ]
    });
    const TabItemWithTooltip = /*#__PURE__*/ (0, $7XTbi$jsx)((0, $8ff3b7072736807a$export$2e2bcd8739ae039), {
        dataTheme: tooltipProps?.dataTheme,
        trigger: TooltipTrigger,
        text: tooltipProps?.text,
        placement: tooltipProps?.placement,
        maxWidth: tooltipProps?.maxWidth,
        offset: tooltipProps?.offset,
        openDelay: tooltipProps?.openDelay,
        closeDelay: tooltipProps?.closeDelay,
        isPortalEnabled: tooltipProps?.isPortalEnabled,
        className: tooltipProps?.className,
        dataTestId: tooltipProps?.dataTestId
    });
    if (PopoverContent) return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $11e1006960f3c7db$export$2e2bcd8739ae039), {
        dataTheme: popoverProps?.dataTheme,
        isOpen: popoverProps?.isOpen,
        setIsOpen: popoverProps?.setIsOpen,
        trigger: TabItemWithTooltip,
        popoverContent: PopoverContent,
        placement: popoverProps?.placement,
        offset: popoverProps?.offset,
        isPortalEnabled: popoverProps?.isPortalEnabled,
        dataTestId: popoverProps?.dataTestId
    });
    return TabItemWithTooltip;
}
$0e72242ab07afce9$var$TabItem.propTypes = {
    label: (0, $7XTbi$proptypes).string.isRequired,
    value: (0, $7XTbi$proptypes).string.isRequired,
    tabGroupValue: (0, $7XTbi$proptypes).string,
    moreTabOptions: (0, $7XTbi$proptypes).arrayOf((0, $65441b8e33d7ac73$export$1e9d3f41160d49dc)),
    isLastChild: (0, $7XTbi$proptypes).bool,
    moreContainerRef: (0, $65441b8e33d7ac73$export$de87879afd52ccf9),
    tabIndex: (0, $7XTbi$proptypes).number,
    onClick: (0, $7XTbi$proptypes).func,
    moveTabItem: (0, $7XTbi$proptypes).func,
    icon: (0, $7XTbi$proptypes).node,
    size: (0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$ead22628fc157ba4))),
    tooltipProps: (0, $65441b8e33d7ac73$export$f34ec9f5cbfcdd45),
    popoverProps: (0, $65441b8e33d7ac73$export$836dc3e110fba957),
    BadgeComp: (0, $7XTbi$proptypes).element,
    PopoverContent: (0, $7XTbi$proptypes).element,
    className: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string
};
$0e72242ab07afce9$var$TabItem.defaultProps = {
    tabGroupValue: null,
    moreTabOptions: [],
    isLastChild: false,
    moreContainerRef: null,
    tabIndex: 0,
    onClick: ()=>{},
    moveTabItem: ()=>{},
    icon: null,
    size: (0, $65441b8e33d7ac73$export$ead22628fc157ba4).LARGE,
    tooltipProps: null,
    popoverProps: null,
    BadgeComp: null,
    PopoverContent: null,
    className: null,
    dataTestId: null
};
var $0e72242ab07afce9$export$2e2bcd8739ae039 = $0e72242ab07afce9$var$TabItem;


/* eslint-disable react/jsx-wrap-multilines */ /* eslint-disable react/jsx-curly-spacing */ 








const $ce1d91d393b93370$var$WIDTH_TO_INCREMENT_CHECK_MORE_IN_PX = 60;
function $ce1d91d393b93370$var$TabMore({ tabGroupValue: tabGroupValue, onClick: onClick, moveTabItem: moveTabItem, moreTabOptions: moreTabOptions, tabItemsArray: tabItemsArray, moreContainerRef: moreContainerRef, size: size }) {
    const moreTargetRef = (0, $7XTbi$useRef)(null);
    const moreTriggerClasses = (0, $7XTbi$classnames)("TabItem-button", `TabMore-button--${size}`, "TabMore", moreTabOptions?.length > 0 && "TabMore--isMoreVisible");
    (0, $7XTbi$useEffect)(()=>{
        const moreTarget = moreTargetRef.current;
        const rootRef = moreContainerRef?.current || null;
        if (!moreTarget) return;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                let isFullyVisibleHorizontally;
                if (rootRef) {
                    const rootBounds = rootRef.getBoundingClientRect();
                    isFullyVisibleHorizontally = entry.boundingClientRect.left >= rootBounds.left && entry.boundingClientRect.right <= rootBounds.right;
                } else // Fallback to window check
                isFullyVisibleHorizontally = entry.boundingClientRect.left >= 0 && entry.boundingClientRect.right <= window.innerWidth;
                if (!isFullyVisibleHorizontally) {
                    const availableTabs = tabItemsArray.filter((child)=>!moreTabOptions.some((tabOption)=>tabOption.value === child.value));
                    if (availableTabs.length > 0) {
                        const lastTab = availableTabs[availableTabs.length - 1];
                        const lastNoneActiveTab = availableTabs[availableTabs.length - 2];
                        const { value: value } = lastTab;
                        const isLastVisibleTabActive = value === tabGroupValue;
                        // Remove inactive tabs
                        if (!isLastVisibleTabActive) moveTabItem(lastTab.value);
                        // Don't remove active tabs
                        if (isLastVisibleTabActive && lastNoneActiveTab) moveTabItem(lastNoneActiveTab.value);
                    }
                }
            });
        }, {
            root: rootRef,
            threshold: 1
        });
        observer.observe(moreTarget);
        // eslint-disable-next-line consistent-return
        return ()=>observer.disconnect();
    }, [
        moreContainerRef,
        tabItemsArray,
        moreTabOptions,
        tabGroupValue,
        onClick,
        moveTabItem
    ]);
    // Handle resize events when moreTarget is visible
    (0, $7XTbi$useEffect)(()=>{
        let lastWindowWidth = window.innerWidth;
        const handleResize = ()=>{
            const currentWidth = window.innerWidth;
            const widthDifference = currentWidth - lastWindowWidth;
            const increments = Math.floor(Math.abs(widthDifference) / $ce1d91d393b93370$var$WIDTH_TO_INCREMENT_CHECK_MORE_IN_PX);
            if (increments > 0) {
                for(let i = 0; i < increments; i += 1)moveTabItem(null, true);
                lastWindowWidth += increments * $ce1d91d393b93370$var$WIDTH_TO_INCREMENT_CHECK_MORE_IN_PX * Math.sign(widthDifference);
            }
        };
        const handleThrottledResize = (0, $7XTbi$throttle)(handleResize, 500);
        window.addEventListener("resize", handleThrottledResize);
        return ()=>window.removeEventListener("resize", handleThrottledResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const getMenuOptions = ()=>moreTabOptions.map((tab)=>({
                label: tab.label,
                value: tab.value,
                isDisabled: tab.isDisabled || false,
                isChecked: tab.value === tabGroupValue,
                icon: tab.icon?.props?.kind
            }));
    const menuOptions = getMenuOptions(moreTabOptions);
    const handleMenuClick = (selectedValue)=>{
        moveTabItem(selectedValue, true);
        onClick(selectedValue);
    };
    return /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
        role: "tab",
        "aria-selected": false,
        "aria-controls": "more-panel",
        className: "TabMore-wrapper",
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)((0, $9ef6121f0a4af6a4$export$2e2bcd8739ae039), {
                options: menuOptions,
                onChange: (selectedOption)=>handleMenuClick(selectedOption.value),
                trigger: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $6ce488bd8de8fd90$export$2e2bcd8739ae039), {
                    size: "small",
                    kind: "rectangle",
                    label: "More",
                    className: moreTriggerClasses
                })
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                "data-testid": "tabmore-observe-target",
                ref: moreTargetRef,
                className: "TabMore-targetObserver"
            })
        ]
    });
}
$ce1d91d393b93370$var$TabMore.propTypes = {
    tabGroupValue: (0, $7XTbi$proptypes).string,
    onClick: (0, $7XTbi$proptypes).func.isRequired,
    moveTabItem: (0, $7XTbi$proptypes).func,
    tabItemsArray: (0, $7XTbi$proptypes).arrayOf((0, $65441b8e33d7ac73$export$7f89d95782f61d72)),
    moreTabOptions: (0, $7XTbi$proptypes).arrayOf((0, $65441b8e33d7ac73$export$1e9d3f41160d49dc)).isRequired,
    moreContainerRef: (0, $65441b8e33d7ac73$export$de87879afd52ccf9),
    size: (0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$ead22628fc157ba4)))
};
$ce1d91d393b93370$var$TabMore.defaultProps = {
    tabGroupValue: null,
    moveTabItem: ()=>{},
    tabItemsArray: null,
    moreContainerRef: null,
    size: (0, $65441b8e33d7ac73$export$ead22628fc157ba4).LARGE
};
var $ce1d91d393b93370$export$2e2bcd8739ae039 = $ce1d91d393b93370$var$TabMore;



const $c48ff74158c5949d$var$MORE_TEXT = "More";
const $c48ff74158c5949d$var$MIN_LENGTH_OF_ITEMS_FOR_MOBILE_MORE = 3;
const $c48ff74158c5949d$var$TABGROUP_POINTER_VISIBIILTY_DELAY = 500;
function $c48ff74158c5949d$var$TabGroup({ value: value, onChange: onChange, children: children, moreContainerRef: moreContainerRef, isHorizontalScroll: isHorizontalScroll, horizontalParentRightPadding: horizontalParentRightPadding, isVerticalWithOverFlow: isVerticalWithOverFlow, size: size, isTabOrderBeFixed: isTabOrderBeFixed, className: className, dataTestId: dataTestId, lastStickyTabTestId: lastStickyTabTestId }) {
    const validTabItemsArray = (0, $7XTbi$useMemo)(()=>(0, $7XTbi$react).Children.toArray(children).filter((child)=>child && child.type === (0, $0e72242ab07afce9$export$2e2bcd8739ae039)), [
        children
    ]);
    const tabItemsLength = validTabItemsArray.length;
    const lastChildIndex = tabItemsLength - 1;
    const lastChild = validTabItemsArray[lastChildIndex];
    const isLastChildActive = lastChild && value === lastChild.props.value;
    const tabItemsArray = (0, $7XTbi$useMemo)(()=>validTabItemsArray.map((child, index)=>{
            const { label: label, value: tabItemValue, icon: icon, size: tabItemSize, tooltipProps: tooltipProps, popoverProps: popoverProps, BadgeComp: BadgeComp, PopoverContent: PopoverContent, className: tabItemClassName, dataTestId: tabItemDataTestId } = child.props;
            const childClassName = (0, $7XTbi$classnames)(`TabItem--${index}`, tabItemClassName);
            const isLastChild = index === lastChildIndex;
            return {
                label: label,
                value: tabItemValue,
                isActive: value === tabItemValue,
                moreContainerRef: moreContainerRef,
                tabOptionIndex: index,
                isLastChild: isLastChild,
                icon: icon,
                size: size || tabItemSize,
                tooltipProps: tooltipProps,
                popoverProps: popoverProps,
                BadgeComp: BadgeComp,
                PopoverContent: PopoverContent,
                className: childClassName,
                dataTestId: tabItemDataTestId
            };
        }), [
        validTabItemsArray,
        value,
        size,
        moreContainerRef,
        lastChildIndex
    ]);
    // Children is split into child arrays based on observer visibility
    const [visibleTabOptions, setVisibleTabOptions] = (0, $7XTbi$useState)(tabItemsArray);
    const [moreTabOptions, setMoreTabOptions] = (0, $7XTbi$useState)([]);
    // isHorizontalScroll states
    const [isLastChildSticky, setIsLastChildSticky] = (0, $7XTbi$useState)(isLastChildActive);
    const [isPointerLeftVisible, setIsPointerLeftVisible] = (0, $7XTbi$useState)(false);
    const [isPointerRightVisible, setIsPointerRightVisible] = (0, $7XTbi$useState)(true);
    // Vertical states
    const [isMoreDrawerOpen, setIsMoreDrawerOpen] = (0, $7XTbi$useState)(false);
    const tabGroupRef = (0, $7XTbi$useRef)(null);
    const timeoutId = (0, $7XTbi$useRef)(null);
    const drawerRef = (0, $7XTbi$useRef)(null);
    const tabGroupClasses = (0, $7XTbi$classnames)("TabGroup", isHorizontalScroll && "TabGroup--isHorizontalScroll", isVerticalWithOverFlow && "TabGroup--isVerticalWithOverFlow", className);
    const pointerLeftClasses = (0, $7XTbi$classnames)("TabGroup-pointerLeft", isPointerLeftVisible && "TabGroup-pointerLeft--isVisible");
    const pointerRightClasses = (0, $7XTbi$classnames)("TabGroup-pointerRight", isPointerRightVisible && "TabGroup-pointerRight--isVisible");
    const lastChildClasses = (0, $7XTbi$classnames)("TabItem-noTarget", isLastChildActive && "TabItem--isLastChild");
    // Handle children updated
    (0, $7XTbi$useEffect)(()=>{
        // Create maps for quick lookup
        const visibleTabsMap = new Map(visibleTabOptions.map((tab)=>[
                tab.value,
                tab
            ]));
        const moreTabsMap = new Map(moreTabOptions.map((tab)=>[
                tab.value,
                tab
            ]));
        const newVisibleTabOptions = [];
        const newMoreTabOptions = [];
        tabItemsArray.forEach((tab)=>{
            if (visibleTabsMap.has(tab.value)) {
                // Update existing tab in visibleTabOptions
                const existingTab = visibleTabsMap.get(tab.value);
                const updatedTab = {
                    ...existingTab,
                    ...tab
                };
                newVisibleTabOptions.push(updatedTab);
            } else if (moreTabsMap.has(tab.value)) {
                // Update existing tab in moreTabOptions
                const existingTab = moreTabsMap.get(tab.value);
                const updatedTab = {
                    ...existingTab,
                    ...tab
                };
                newMoreTabOptions.push(updatedTab);
            } else // New tab, add to visibleTabOptions
            newVisibleTabOptions.push(tab);
        });
        // Update the state with new arrays
        setVisibleTabOptions(newVisibleTabOptions);
        setMoreTabOptions(newMoreTabOptions);
    // tabItemsArray is not needed and endlessly rerenders
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        children
    ]);
    // Log scroll position and determine left/right limits
    const handleScroll = (0, $7XTbi$useCallback)(()=>{
        const tabGroup = tabGroupRef?.current;
        const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, clientWidth: clientWidth } = tabGroup;
        const scrollRight = scrollWidth - scrollLeft - clientWidth;
        if (timeoutId.current) clearTimeout(timeoutId.current);
        setIsPointerLeftVisible(false);
        setIsPointerRightVisible(false);
        if (scrollRight > horizontalParentRightPadding + 4) setIsLastChildSticky(true);
        else setIsLastChildSticky(false);
        if (scrollLeft === 0) {
            timeoutId.current = setTimeout(()=>{
                setIsPointerLeftVisible(false);
                setIsPointerRightVisible(true);
            }, $c48ff74158c5949d$var$TABGROUP_POINTER_VISIBIILTY_DELAY);
            return;
        }
        if (scrollRight <= 2) {
            timeoutId.current = setTimeout(()=>{
                setIsPointerLeftVisible(true);
                setIsPointerRightVisible(false);
            }, $c48ff74158c5949d$var$TABGROUP_POINTER_VISIBIILTY_DELAY);
            return;
        }
        timeoutId.current = setTimeout(()=>{
            setIsPointerLeftVisible(true);
            setIsPointerRightVisible(true);
        }, $c48ff74158c5949d$var$TABGROUP_POINTER_VISIBIILTY_DELAY);
    }, [
        horizontalParentRightPadding
    ]);
    // Handles isHorizontalScroll version and resizing
    (0, $7XTbi$useEffect)(()=>{
        if (!isHorizontalScroll) return;
        const tabGroup = tabGroupRef?.current;
        const handleResizeOrScroll = ()=>{
            const { scrollWidth: scrollWidth, clientWidth: clientWidth } = tabGroup;
            // Check if there is overflow
            const hasOverflow = scrollWidth > clientWidth;
            if (!hasOverflow) {
                // If no overflow, hide both pointers and last child, skip the scroll handling
                setIsPointerLeftVisible(false);
                setIsPointerRightVisible(false);
                setIsLastChildSticky(false);
                return;
            }
            handleScroll();
        };
        handleResizeOrScroll();
        tabGroup.addEventListener("scroll", handleScroll);
        window.addEventListener("resize", handleResizeOrScroll);
        // eslint-disable-next-line consistent-return
        return ()=>{
            tabGroup.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleResizeOrScroll);
        };
    }, [
        handleScroll,
        children,
        isHorizontalScroll
    ]);
    const getPointerButtonIcon = (kind)=>/*#__PURE__*/ (0, $7XTbi$jsx)((0, $e34ff86c7a827ee6$export$2e2bcd8739ae039), {
            className: kind === "left" ? pointerLeftClasses : pointerRightClasses,
            size: "small",
            kind: "outlinedNeutral",
            icon: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                kind: kind === "left" ? "ChevronLeft" : "ChevronRight"
            }),
            tabIndex: -1,
            dataTestId: `tabgroup-pointer-${kind}`
        });
    const shouldDisplayFixedLastItem = lastChild && isLastChildSticky && isLastChildActive;
    const moveTabItem = (selectedValue, shouldBringItemBack = false)=>{
        // Sort by tabIndex helper function
        const sortByTabIndex = (arr)=>arr.sort((a, b)=>a.tabOptionIndex - b.tabOptionIndex);
        // If shouldBringItemBack is true, we attempt to move an item from moreTabOptions to visibleTabOptions
        if (shouldBringItemBack && !selectedValue) {
            if (moreTabOptions.length > 0) {
                // If isTabOrderBeFixed is true, we do NOT move items from dropdown to visible
                if (isTabOrderBeFixed) return;
                // Find the item with the lowest tabIndex from moreTabOptions
                const lowestTabItem = moreTabOptions.reduce((lowest, tab)=>tab.tabOptionIndex < lowest.tabOptionIndex ? tab : lowest, moreTabOptions[0]);
                // Remove the lowest tabOptionIndex item from moreTabOptions
                const updatedMoreTabs = moreTabOptions.filter((tab)=>tab.tabOptionIndex !== lowestTabItem.tabOptionIndex);
                // Add the lowest tabOptionIndex item to the visibleTabOptions
                let updatedVisibleTabs = [
                    ...visibleTabOptions,
                    lowestTabItem
                ];
                // Sort both arrays by tabOptionIndex
                updatedVisibleTabs = sortByTabIndex(updatedVisibleTabs);
                const sortedMoreTabs = sortByTabIndex(updatedMoreTabs);
                // Update the state
                setVisibleTabOptions(updatedVisibleTabs);
                setMoreTabOptions(sortedMoreTabs);
                return;
            }
        }
        // Find the index of the tab in the visibleTabOptions
        const visibleTabIndex = visibleTabOptions.findIndex((tab)=>tab.value === selectedValue);
        // Find the index of the selected tab in the moreTabOptions
        const moreTabIndex = moreTabOptions.findIndex((tab)=>tab.value === selectedValue);
        // If shouldBringItemBack is true and selectedValue exists in moreTabOptions, we are trying to move it to visibleTabOptions
        if (shouldBringItemBack && selectedValue && moreTabIndex !== -1) {
            // If isTabOrderBeFixed is true, do not bring items back to visible
            if (isTabOrderBeFixed) return;
            // Get the last item in visibleTabOptions
            const lastVisibleTab = visibleTabOptions[visibleTabOptions.length - 1];
            // Get the selected tab from moreTabOptions
            const selectedTab = moreTabOptions[moreTabIndex];
            // Update visibleTabOptions: move selected tab to the end of visibleTabOptions
            let updatedVisibleTabs = [
                ...visibleTabOptions.slice(0, visibleTabOptions.length - 1),
                selectedTab
            ];
            // Update moreTabOptions: move last visible tab to the start of moreTabOptions
            let updatedMoreTabs = [
                lastVisibleTab,
                ...moreTabOptions.filter((tab)=>tab.value !== selectedValue)
            ];
            // Sort both arrays by tabOptionIndex
            updatedVisibleTabs = sortByTabIndex(updatedVisibleTabs);
            updatedMoreTabs = sortByTabIndex(updatedMoreTabs);
            // Update the state
            setVisibleTabOptions(updatedVisibleTabs);
            setMoreTabOptions(updatedMoreTabs);
            return;
        }
        // If the tab exists in visibleTabOptions, we may move it (or its neighbor) to moreTabOptions
        if (visibleTabIndex !== -1) {
            // If the selectedValue is active, remove the previous tab instead
            if (selectedValue === value) {
                const previousTabIndex = visibleTabIndex - 1;
                // Check if there is a tab before the active one
                if (previousTabIndex >= 0) {
                    const tabToMove = visibleTabOptions[previousTabIndex];
                    // Check conditions before moving the tab (only move if not disabled or index >= 2)
                    if (!isTabOrderBeFixed || previousTabIndex >= 2) {
                        let updatedVisibleTabs = visibleTabOptions.filter((tab, index)=>index !== previousTabIndex);
                        let updatedMoreTabs = [
                            ...moreTabOptions,
                            tabToMove
                        ];
                        // Sort both arrays by tabOptionIndex
                        updatedVisibleTabs = sortByTabIndex(updatedVisibleTabs);
                        updatedMoreTabs = sortByTabIndex(updatedMoreTabs);
                        // Update the state
                        setVisibleTabOptions(updatedVisibleTabs);
                        setMoreTabOptions(updatedMoreTabs);
                    }
                }
            } else {
                // Move the selected tab if it's not the active tab
                const tabToMove = visibleTabOptions[visibleTabIndex];
                // Check conditions before moving the tab (only move if not disabled or index >= 2)
                if (!isTabOrderBeFixed || visibleTabIndex >= 2) {
                    let updatedVisibleTabs = visibleTabOptions.filter((tab)=>tab.value !== selectedValue);
                    let updatedMoreTabs = [
                        ...moreTabOptions,
                        tabToMove
                    ];
                    // Sort both arrays by tabOptionIndex
                    updatedVisibleTabs = sortByTabIndex(updatedVisibleTabs);
                    updatedMoreTabs = sortByTabIndex(updatedMoreTabs);
                    // Update the state
                    setVisibleTabOptions(updatedVisibleTabs);
                    setMoreTabOptions(updatedMoreTabs);
                }
            }
        }
    };
    const getMoreDrawerItems = ()=>/*#__PURE__*/ (0, $7XTbi$jsx)("ul", {
            className: "TabGroup-moreDrawerItemList",
            role: "tablist",
            "aria-orientation": "vertical",
            children: validTabItemsArray.map((tabOption)=>/*#__PURE__*/ (0, $7XTbi$jsx)((0, $7082d2d2e186ccb9$export$2e2bcd8739ae039), {
                    option: {
                        ...tabOption.props,
                        isChecked: tabOption.props.value === value,
                        hasTabBar: true
                    },
                    onClick: ()=>{
                        drawerRef.current.closeDrawer();
                        onChange(tabOption.props.value);
                    },
                    prefixIcon: tabOption?.props.icon
                }, tabOption.props.value))
        });
    const getDisplayedVerticalTabItems = ()=>{
        // Slice the first three items to show
        const displayedItems = validTabItemsArray.slice(0, 3);
        // Find the item with tabOption.props.value === value that should appear in the third spot
        const selectedItemIndex = validTabItemsArray.findIndex((tabOption)=>tabOption.props.value === value);
        if (selectedItemIndex > 2) // Move the selected item to the third position
        displayedItems[2] = validTabItemsArray[selectedItemIndex];
        return displayedItems;
    };
    const displayedVerticalTabItems = getDisplayedVerticalTabItems();
    const getTabItemMap = ()=>{
        // isVerticalWithOverFlow should bypass dropdown more, in favor of mobile drawer more
        if (isVerticalWithOverFlow) return /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $7XTbi$Fragment), {
            children: [
                /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                    ref: tabGroupRef,
                    className: tabGroupClasses,
                    role: "tablist",
                    "aria-orientation": "horizontal",
                    "data-testid": dataTestId,
                    children: [
                        displayedVerticalTabItems.slice(0, 3).map((tabOption, index)=>/*#__PURE__*/ (0, $7XTbi$jsx)((0, $0e72242ab07afce9$export$2e2bcd8739ae039), {
                                label: tabOption.props.label,
                                value: tabOption.props.value,
                                tabGroupValue: value,
                                onClick: ()=>onChange(tabOption.props.value),
                                // Optional
                                tabIndex: tabOption?.props.tabIndex,
                                icon: tabOption?.props.icon,
                                // Need design for large isVerticalWithOverFlow tab Item then this can be removed (isVerticalWithOverFlow ? 'medium' : )
                                size: isVerticalWithOverFlow ? "medium" : tabOption?.props.size,
                                tooltipProps: tabOption?.props.tooltipProps,
                                popoverProps: tabOption?.props.popoverProps,
                                // Not supported, no design: BadgeComp
                                BadgeComp: tabOption?.props.BadgeComp,
                                PopoverContent: tabOption?.props.PopoverContent,
                                className: tabOption?.props.className,
                                dataTestId: tabOption?.props.dataTestId
                            }, tabOption.props.value || index)),
                        validTabItemsArray?.length > $c48ff74158c5949d$var$MIN_LENGTH_OF_ITEMS_FOR_MOBILE_MORE && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $0e72242ab07afce9$export$2e2bcd8739ae039), {
                            label: $c48ff74158c5949d$var$MORE_TEXT,
                            value: $c48ff74158c5949d$var$MORE_TEXT.toLowerCase(),
                            tabGroupValue: value,
                            onClick: ()=>setIsMoreDrawerOpen(true),
                            icon: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                                kind: "MoreHorizontal"
                            }),
                            // Need design for large isVerticalWithOverFlow
                            size: "medium",
                            className: "TabGroup-verticalMore"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                    className: "TabGroup-fullWidthBorder"
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)((0, $2262e7f4cc382b2a$export$2e2bcd8739ae039), {
                    ref: drawerRef,
                    isOpen: isMoreDrawerOpen,
                    setIsOpen: setIsMoreDrawerOpen,
                    isSwipeEnabled: true,
                    content: /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $7XTbi$Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5f880a93b57cab01$export$2e2bcd8739ae039), {
                                kind: "h4",
                                className: "TabGroup-moreMobileDrawerTitle",
                                children: "All Tabs"
                            }),
                            getMoreDrawerItems()
                        ]
                    }),
                    className: "TabGroup-moreMobileDrawer"
                })
            ]
        });
        return /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
            ref: tabGroupRef,
            className: tabGroupClasses,
            role: "tablist",
            "aria-orientation": "horizontal",
            "data-testid": dataTestId,
            children: [
                visibleTabOptions.map((tabOption, index)=>/*#__PURE__*/ (0, $7XTbi$jsx)((0, $0e72242ab07afce9$export$2e2bcd8739ae039), {
                        label: tabOption.label,
                        value: tabOption.value,
                        tabGroupValue: value,
                        onClick: ()=>onChange(tabOption.value),
                        moveTabItem: ()=>moveTabItem(tabOption.value),
                        moreTabOptions: moreTabOptions,
                        setMoreTabOptions: setMoreTabOptions,
                        visibleTabOptions: visibleTabOptions,
                        setVisibleTabOptions: setVisibleTabOptions,
                        // Optional
                        isLastChild: tabOption?.isLastChild,
                        moreContainerRef: tabOption?.moreContainerRef,
                        tabIndex: tabOption?.tabIndex,
                        icon: tabOption?.icon,
                        size: tabOption?.size,
                        tooltipProps: tabOption?.tooltipProps,
                        popoverProps: tabOption?.popoverProps,
                        BadgeComp: tabOption?.BadgeComp,
                        PopoverContent: tabOption?.PopoverContent,
                        className: tabOption?.className,
                        dataTestId: tabOption?.dataTestId
                    }, tabOption.value || index)),
                moreTabOptions?.length > 0 && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $ce1d91d393b93370$export$2e2bcd8739ae039), {
                    tabGroupValue: value,
                    onClick: onChange,
                    moveTabItem: moveTabItem,
                    moreTabOptions: moreTabOptions,
                    visibleTabOptions: visibleTabOptions,
                    tabItemsArray: tabItemsArray,
                    moreContainerRef: moreContainerRef,
                    size: size
                }),
                /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                    className: "TabGroup-fullWidthBorder"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $7XTbi$Fragment), {
        children: [
            getTabItemMap(),
            isHorizontalScroll && !isVerticalWithOverFlow && /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $7XTbi$Fragment), {
                children: [
                    shouldDisplayFixedLastItem && /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                        className: lastChildClasses,
                        "data-testid": lastStickyTabTestId,
                        children: /*#__PURE__*/ (0, $7XTbi$react).cloneElement(lastChild, {
                            tabGroupValue: value,
                            isLastChild: true,
                            isActive: isLastChildActive,
                            onClick: ()=>onChange(lastChild.props.value),
                            tabIndex: !isLastChildSticky ? -1 : 0
                        })
                    }),
                    getPointerButtonIcon("left"),
                    getPointerButtonIcon("right")
                ]
            })
        ]
    });
}
$c48ff74158c5949d$var$TabGroup.propTypes = {
    value: (0, $7XTbi$proptypes).string.isRequired,
    children: (0, $7XTbi$proptypes).node.isRequired,
    onChange: (0, $7XTbi$proptypes).func.isRequired,
    moreContainerRef: (0, $65441b8e33d7ac73$export$de87879afd52ccf9),
    isHorizontalScroll: (0, $7XTbi$proptypes).bool,
    horizontalParentRightPadding: (0, $7XTbi$proptypes).number,
    isVerticalWithOverFlow: (0, $7XTbi$proptypes).bool,
    size: (0, $7XTbi$proptypes).oneOf(Object.values((0, $65441b8e33d7ac73$export$ead22628fc157ba4))),
    isTabOrderBeFixed: (0, $7XTbi$proptypes).bool,
    className: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string,
    lastStickyTabTestId: (0, $7XTbi$proptypes).string
};
$c48ff74158c5949d$var$TabGroup.defaultProps = {
    moreContainerRef: null,
    isHorizontalScroll: false,
    horizontalParentRightPadding: 0,
    isVerticalWithOverFlow: false,
    size: (0, $65441b8e33d7ac73$export$ead22628fc157ba4).LARGE,
    isTabOrderBeFixed: false,
    className: null,
    dataTestId: null,
    lastStickyTabTestId: null
};
var $c48ff74158c5949d$export$2e2bcd8739ae039 = $c48ff74158c5949d$var$TabGroup;








function $d46ab010e21b8873$var$Table({ className: className, dataTestId: dataTestId, children: children }) {
    return /*#__PURE__*/ (0, $7XTbi$jsx)("table", {
        className: (0, $7XTbi$classnames)("Neo-Table", className),
        "data-testid": dataTestId,
        children: children
    });
}
$d46ab010e21b8873$var$Table.propTypes = {
    className: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string,
    children: (0, $7XTbi$proptypes).node
};
$d46ab010e21b8873$var$Table.defaultProps = {
    className: null,
    dataTestId: null,
    children: null
};
var $d46ab010e21b8873$export$2e2bcd8739ae039 = $d46ab010e21b8873$var$Table;







function $a4e7cb3291e83c6f$var$TableBody({ className: className, dataTestId: dataTestId, children: children }) {
    return /*#__PURE__*/ (0, $7XTbi$jsx)("tbody", {
        className: (0, $7XTbi$classnames)("Neo-TableBody", className),
        "data-testid": dataTestId,
        children: children
    });
}
$a4e7cb3291e83c6f$var$TableBody.propTypes = {
    className: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string,
    children: (0, $7XTbi$proptypes).node
};
$a4e7cb3291e83c6f$var$TableBody.defaultProps = {
    className: null,
    dataTestId: null,
    children: null
};
var $a4e7cb3291e83c6f$export$2e2bcd8739ae039 = $a4e7cb3291e83c6f$var$TableBody;






function $93183887bbadf20f$var$TableCell({ className: className, isHeader: isHeader, dataTestId: dataTestId, children: children, onClick: onClick }) {
    return isHeader ? /*#__PURE__*/ (0, $7XTbi$jsx)("th", {
        className: `Neo-TableCell--headerCell ${className}`,
        "data-testid": dataTestId,
        onClick: onClick,
        children: children
    }) : /*#__PURE__*/ (0, $7XTbi$jsx)("td", {
        className: `Neo-TableCell ${className}`,
        "data-testid": dataTestId,
        children: children
    });
}
$93183887bbadf20f$var$TableCell.propTypes = {
    className: (0, $7XTbi$proptypes).string,
    isHeader: (0, $7XTbi$proptypes).bool,
    dataTestId: (0, $7XTbi$proptypes).string,
    children: (0, $7XTbi$proptypes).node,
    onClick: (0, $7XTbi$proptypes).func
};
$93183887bbadf20f$var$TableCell.defaultProps = {
    className: "",
    isHeader: false,
    dataTestId: null,
    children: null,
    onClick: null
};
var $93183887bbadf20f$export$2e2bcd8739ae039 = $93183887bbadf20f$var$TableCell;







function $c6e9c8a380fd3258$var$TableHead({ className: className, dataTestId: dataTestId, children: children }) {
    return /*#__PURE__*/ (0, $7XTbi$jsx)("thead", {
        className: (0, $7XTbi$classnames)("Neo-TableHead", className),
        "data-testid": dataTestId,
        children: children
    });
}
$c6e9c8a380fd3258$var$TableHead.propTypes = {
    className: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string,
    children: (0, $7XTbi$proptypes).node
};
$c6e9c8a380fd3258$var$TableHead.defaultProps = {
    className: null,
    dataTestId: null,
    children: null
};
var $c6e9c8a380fd3258$export$2e2bcd8739ae039 = $c6e9c8a380fd3258$var$TableHead;







function $fc2b7ce217d20b94$var$TableRow({ className: className, isHeader: isHeader, dataTestId: dataTestId, children: children }) {
    return /*#__PURE__*/ (0, $7XTbi$jsx)("tr", {
        className: (0, $7XTbi$classnames)("Neo-TableRow", isHeader && "Neo-TableRow-header", className),
        "data-testid": dataTestId,
        children: children
    });
}
$fc2b7ce217d20b94$var$TableRow.propTypes = {
    className: (0, $7XTbi$proptypes).string,
    isHeader: (0, $7XTbi$proptypes).bool,
    dataTestId: (0, $7XTbi$proptypes).string,
    children: (0, $7XTbi$proptypes).node
};
$fc2b7ce217d20b94$var$TableRow.defaultProps = {
    className: null,
    isHeader: false,
    dataTestId: null,
    children: null
};
var $fc2b7ce217d20b94$export$2e2bcd8739ae039 = $fc2b7ce217d20b94$var$TableRow;








const $0eddd663dfc2d752$var$SIZES = {
    small: "small",
    medium: "medium",
    large: "large"
};
const $0eddd663dfc2d752$var$KINDS = {
    start: "start",
    centered: "centered",
    end: "end"
};
/**
 * #### WIP Info:
 *
 * ###### TODO:
 * - ToolTips
 */ function $0eddd663dfc2d752$var$ToggleButton({ isDarkMode: isDarkMode, label: label, kind: kind, size: size, icon: icon, isDisabled: isDisabled, index: index, selection: selection, setSelection: setSelection, isPill: isPill, className: className, dataTestId: dataTestId }) {
    const toggleButtonClass = (0, $7XTbi$classnames)("ToggleButton", `ToggleButton--${isDarkMode}`, `ToggleButton--${size}`, `ToggleButton--${kind}`, isPill && `ToggleButton--isPill`, isDisabled && `ToggleButton--isDisabled`, selection === index && `ToggleButton--isSelected`, selection === index && `ToggleButton--${kind}--isSelected`, className);
    const labelClass = (0, $7XTbi$classnames)("ToggleButton-label", `ToggleButton-label--${size}`, isDisabled && `ToggleButton-label--isDisabled`, selection === index && `ToggleButton-label--${size}--isSelected`);
    const toggleButtonOverlayClass = (0, $7XTbi$classnames)("ToggleButton-overlay", `ToggleButton-overlay--${kind}`, isPill && `ToggleButton-overlay--isPill`, isDisabled && `ToggleButton-overlay--isDisabled`, selection === index && `ToggleButton-overlay--isSelected`);
    if (!kind) return /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
        children: "Error"
    });
    return /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $553ba9ca1822b2c0$export$2e2bcd8739ae039), {
        className: toggleButtonClass,
        onClick: ()=>setSelection(index),
        isDisabled: isDisabled,
        dataTestId: dataTestId,
        children: [
            icon,
            label && /*#__PURE__*/ (0, $7XTbi$jsx)("p", {
                className: labelClass,
                children: label
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                "data-testid": "toggle-button-overlay",
                className: toggleButtonOverlayClass
            })
        ]
    });
}
$0eddd663dfc2d752$var$ToggleButton.propTypes = {
    isDarkMode: (0, $7XTbi$proptypes).bool,
    label: (0, $7XTbi$proptypes).string,
    kind: (0, $7XTbi$proptypes).oneOf(Object.values($0eddd663dfc2d752$var$KINDS)),
    size: (0, $7XTbi$proptypes).oneOf(Object.values($0eddd663dfc2d752$var$SIZES)),
    icon: (0, $7XTbi$proptypes).node,
    isDisabled: (0, $7XTbi$proptypes).bool,
    index: (0, $7XTbi$proptypes).number,
    selection: (0, $7XTbi$proptypes).number,
    setSelection: (0, $7XTbi$proptypes).func,
    isPill: (0, $7XTbi$proptypes).bool,
    className: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string
};
$0eddd663dfc2d752$var$ToggleButton.defaultProps = {
    isDarkMode: false,
    label: null,
    kind: $0eddd663dfc2d752$var$KINDS.centered,
    size: $0eddd663dfc2d752$var$SIZES.medium,
    icon: null,
    isDisabled: false,
    index: null,
    selection: null,
    setSelection: ()=>{},
    isPill: false,
    className: null,
    dataTestId: null
};
var $0eddd663dfc2d752$export$2e2bcd8739ae039 = $0eddd663dfc2d752$var$ToggleButton;







/**
 * ###### TODO:
 * - ToolTips
 */ function $5b8103afa728cdea$var$ToggleButtonGroup({ children: children, className: className, selection: selection, setSelection: setSelection, isPill: isPill, dataTestId: dataTestId }) {
    const modalContentClass = (0, $7XTbi$classnames)("ToggleButtonGroup", className);
    const childrenArray = (0, $7XTbi$react).Children.toArray(children);
    const childrenWithProps = childrenArray.map((child, index)=>{
        let kind;
        if (index === 0) kind = "start";
        else if (index < childrenArray.length - 1) kind = "centered";
        else kind = "end";
        return /*#__PURE__*/ (0, $7XTbi$react).cloneElement(child, {
            index: index + 1,
            selection: selection,
            setSelection: setSelection,
            kind: kind,
            isPill: isPill
        });
    });
    return /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
        "data-testid": dataTestId,
        className: modalContentClass,
        children: childrenWithProps
    });
}
$5b8103afa728cdea$var$ToggleButtonGroup.propTypes = {
    children: (0, $7XTbi$proptypes).node.isRequired,
    className: (0, $7XTbi$proptypes).string,
    selection: (0, $7XTbi$proptypes).number,
    setSelection: (0, $7XTbi$proptypes).func,
    isPill: (0, $7XTbi$proptypes).bool,
    dataTestId: (0, $7XTbi$proptypes).string
};
$5b8103afa728cdea$var$ToggleButtonGroup.defaultProps = {
    className: null,
    selection: null,
    setSelection: null,
    isPill: false,
    dataTestId: null
};
var $5b8103afa728cdea$export$2e2bcd8739ae039 = $5b8103afa728cdea$var$ToggleButtonGroup;













/* Note: gen1 opens in a new window for browser download.
<a
  rel="noopener noreferrer"
  href={`${SERVICE_ENDPOINT}/requests/attachment/${file.attachmentKey
  }?username=${cookies.get('user_name')}`}
  target="_blank"
>
*/ const $5f1676931660893b$var$STATES = {
    READY: "ready",
    DOWNLOADING: "downloading",
    FAILED: "failed"
};
const $5f1676931660893b$var$msgs = {
    neo: {
        download: {
            downloadFailed: {
                id: "neo.download.downloadFailed",
                defaultMessage: "Download failed"
            }
        }
    }
};
/**
 * Component to display an uploaded file to download.
 * Browser capabilities for features such as cancelling and tracking
 * progress are generally limited for security and privacy.
 *
 * ###### TODO:
 * - Refactor folder structure (nice to have).
 */ function $5f1676931660893b$var$DownloadFile({ fileName: fileName, fileSize: fileSize, fileUrl: fileUrl, className: className, dataTestId: dataTestId }) {
    const [downloadStatus, setDownloadStatus] = (0, $7XTbi$useState)($5f1676931660893b$var$STATES.READY);
    const intl = (0, $7XTbi$useIntl)();
    const DOWNLOAD_FAILED_TEXT = (0, $7XTbi$localize)(intl, $5f1676931660893b$var$msgs.neo.download.downloadFailed);
    const handleDownload = async ()=>{
        setDownloadStatus($5f1676931660893b$var$STATES.DOWNLOADING);
        fetch(fileUrl).then((response)=>{
            if (!response.ok) {
                setDownloadStatus($5f1676931660893b$var$STATES.FAILED);
                (0, $7XTbi$Logger).error("Network error");
                return null;
            }
            return response.blob();
        }).then((blob)=>{
            // have the file content as a Blob now
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement("a");
            anchor.href = url;
            anchor.download = fileName; // download w/out redirect, specify filename
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
            window.URL.revokeObjectURL(url); // clean up
        }).catch((error)=>{
            setDownloadStatus($5f1676931660893b$var$STATES.FAILED);
            (0, $7XTbi$Logger).error("Download component, problem with fetch:", error);
        });
    };
    const renderButtonContent = ()=>{
        switch(downloadStatus){
            case $5f1676931660893b$var$STATES.DOWNLOADING:
                return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $e34ff86c7a827ee6$export$2e2bcd8739ae039), {
                    size: "large",
                    kind: "outlinedSecondary",
                    icon: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                        kind: "Download",
                        color: "neutral-100",
                        size: "xSmall"
                    }),
                    onClick: handleDownload
                });
            case $5f1676931660893b$var$STATES.FAILED:
                return /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $7XTbi$Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7XTbi$jsx)((0, $e34ff86c7a827ee6$export$2e2bcd8739ae039), {
                            size: "large",
                            kind: "outlinedSecondary",
                            icon: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                                kind: "Retry",
                                color: "neutral-100",
                                size: "xSmall"
                            }),
                            onClick: handleDownload
                        }),
                        /*#__PURE__*/ (0, $7XTbi$jsx)((0, $e34ff86c7a827ee6$export$2e2bcd8739ae039), {
                            size: "large",
                            kind: "outlinedSecondary",
                            icon: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                                kind: "Close",
                                color: "neutral-100",
                                size: "xSmall"
                            }),
                            onClick: ()=>{
                                setDownloadStatus($5f1676931660893b$var$STATES.READY);
                            }
                        })
                    ]
                });
            default:
                return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $e34ff86c7a827ee6$export$2e2bcd8739ae039), {
                    size: "large",
                    kind: "outlinedSecondary",
                    icon: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                        kind: "Download",
                        color: "neutral-100",
                        size: "xSmall"
                    }),
                    onClick: handleDownload
                });
        }
    };
    return /*#__PURE__*/ (0, $7XTbi$jsxs)("section", {
        className: (0, $7XTbi$classnames)("UploadedFile-container", className),
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                className: (0, $7XTbi$classnames)("UploadedFile", downloadStatus === $5f1676931660893b$var$STATES.FAILED && "UploadedFile--error"),
                "data-testid": dataTestId,
                children: [
                    /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                        kind: "document"
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                        className: "UploadedFile-nameSizeContainer",
                        children: [
                            /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                                className: "UploadedFile-fileName",
                                children: fileName
                            }),
                            /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                                className: "UploadedFile-fileSize",
                                children: fileSize?.toUpperCase()
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                        className: "UploadedFile-actionIcons",
                        children: renderButtonContent()
                    })
                ]
            }),
            downloadStatus === $5f1676931660893b$var$STATES.FAILED && /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                className: "UploadedFile-error",
                children: [
                    /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                        kind: "AlertCritical",
                        size: "xSmall",
                        className: "UploadedFile-errorIcon"
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                        className: "UploadedFile-errorMessage",
                        children: DOWNLOAD_FAILED_TEXT
                    })
                ]
            })
        ]
    });
}
$5f1676931660893b$var$DownloadFile.propTypes = {
    fileName: (0, $7XTbi$proptypes).string.isRequired,
    fileSize: (0, $7XTbi$proptypes).string.isRequired,
    fileUrl: (0, $7XTbi$proptypes).string.isRequired,
    className: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string
};
$5f1676931660893b$var$DownloadFile.defaultProps = {
    className: null,
    dataTestId: null
};
var $5f1676931660893b$export$2e2bcd8739ae039 = $5f1676931660893b$var$DownloadFile;


/* please do not use this component as there's a high chance of it being
refactored. a utility like this likely belongs in the common package,
with perhaps a thin wrapper in the design system.
with all the possible (near-future) changes, i prefer to avoid this
type of indirection for now.
i'm using this (temporarily?) for ispm and will re-evaluate later.
*/ 




var $9c8fc2d9b43b71aa$exports = {};
$9c8fc2d9b43b71aa$exports = JSON.parse('{"v":"5.10.2","fr":60,"ip":0,"op":225,"w":480,"h":480,"nm":"Cosmic Wheel","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":3,"nm":"Rotation NULL","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.48],"y":[1]},"o":{"x":[0.26],"y":[0.971]},"t":0,"s":[-45]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.26],"y":[0]},"t":68,"s":[0]},{"i":{"x":[0.74],"y":[-0.133]},"o":{"x":[0.52],"y":[0]},"t":112,"s":[0]},{"t":180,"s":[45]}],"ix":10},"p":{"a":0,"k":[240,240,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Layer 1/Savi-Icon Outlines 2","parent":1,"sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.34],"y":[1]},"o":{"x":[0.66],"y":[0]},"t":0,"s":[0]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":26,"s":[50]},{"i":{"x":[0.34],"y":[1]},"o":{"x":[0.66],"y":[0]},"t":152,"s":[50]},{"t":180,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[6,4,0],"ix":2,"l":2},"a":{"a":0,"k":[13,14.5,0],"ix":1,"l":2},"s":{"a":0,"k":[1350,1350,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[0,3.25],[2.815,1.625],[2.815,-1.625],[0,-3.25],[-2.815,-1.625],[-2.815,1.625],[-2.111,2.031]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.6],"y":[1]},"o":{"x":[0.32],"y":[1.065]},"t":0,"s":[100]},{"t":68,"s":[0]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.68],"y":[-0.065]},"o":{"x":[0.4],"y":[0]},"t":112,"s":[100]},{"t":180,"s":[0]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.654901981354,0,0.874509871006,0.501960813999],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":1.5,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[12.542,14.25],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Core","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[-11.042,-1.396],[-11.042,-6.271],[-6.501,-8.876],[-2.202,-6.399],[0,-7.646],[6.712,-3.771],[6.712,3.979],[5.158,4.876]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.68],"y":[-0.065]},"o":{"x":[0.4],"y":[0]},"t":112,"s":[0]},{"t":180,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.6],"y":[1]},"o":{"x":[0.32],"y":[1.065]},"t":0,"s":[0]},{"t":68,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":3,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.658823549747,0,0.878431379795,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":1.5,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[12.542,14.146],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Hemi-A","np":4,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[11.042,1.604],[11.042,6.479],[6.89,8.876],[2.499,6.404],[0,7.854],[-6.712,3.979],[-6.712,-3.771],[-5.034,-4.74]],"c":false},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.68],"y":[-0.065]},"o":{"x":[0.4],"y":[0]},"t":112,"s":[0]},{"t":180,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.6],"y":[1]},"o":{"x":[0.32],"y":[1.065]},"t":0,"s":[0]},{"t":68,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":3,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.658823549747,0,0.878431379795,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":1.5,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[12.542,14.146],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Hemi-B","np":4,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[-7.428,-3.424],[-3.615,-5.625],[7.428,0.75],[7.428,5.625]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.68],"y":[-0.065]},"o":{"x":[0.4],"y":[0]},"t":112,"s":[0]},{"t":180,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.6],"y":[1]},"o":{"x":[0.32],"y":[1.065]},"t":0,"s":[0]},{"t":68,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.658823549747,0,0.878431379795,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":1.5,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[16.157,7.125],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Valence-A","np":3,"cix":2,"bm":0,"ix":4,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[7.516,3.321],[3.525,5.625],[-7.516,-0.75],[-7.516,-5.625]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.68],"y":[-0.065]},"o":{"x":[0.4],"y":[0]},"t":112,"s":[0]},{"t":180,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.6],"y":[1]},"o":{"x":[0.32],"y":[1.065]},"t":0,"s":[0]},{"t":68,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.658823549747,0,0.878431379795,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":1.5,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[9.016,21.375],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Valence-B","np":3,"cix":2,"bm":0,"ix":5,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Layer 1/Savi-Icon Outlines","parent":1,"sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.34],"y":[1]},"o":{"x":[0.66],"y":[0]},"t":0,"s":[0]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":26,"s":[100]},{"i":{"x":[0.34],"y":[1]},"o":{"x":[0.66],"y":[0]},"t":152,"s":[100]},{"t":180,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[6,4,0],"ix":2,"l":2},"a":{"a":0,"k":[13,14.5,0],"ix":1,"l":2},"s":{"a":0,"k":[1350,1350,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[0,3.25],[2.815,1.625],[2.815,-1.625],[0,-3.25],[-2.815,-1.625],[-2.815,1.625],[-2.111,2.031]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.6],"y":[1]},"o":{"x":[0.32],"y":[0.94]},"t":8,"s":[100]},{"t":68,"s":[0]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.68],"y":[0.06]},"o":{"x":[0.4],"y":[0]},"t":112,"s":[100]},{"t":172,"s":[0]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.658823549747,0,0.878431379795,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":1.5,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[12.542,14.25],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Core","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[-11.042,-1.396],[-11.042,-6.271],[-6.501,-8.876],[-2.202,-6.399],[0,-7.646],[6.712,-3.771],[6.712,3.979],[5.158,4.876]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.68],"y":[0.06]},"o":{"x":[0.4],"y":[0]},"t":112,"s":[0]},{"t":172,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.6],"y":[1]},"o":{"x":[0.32],"y":[0.94]},"t":8,"s":[0]},{"t":68,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":3,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.658823549747,0,0.878431379795,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":1.5,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[12.542,14.146],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Hemi-A","np":4,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[11.042,1.604],[11.042,6.479],[6.89,8.876],[2.499,6.404],[0,7.854],[-6.712,3.979],[-6.712,-3.771],[-5.034,-4.74]],"c":false},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.68],"y":[0.06]},"o":{"x":[0.4],"y":[0]},"t":112,"s":[0]},{"t":172,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.6],"y":[1]},"o":{"x":[0.32],"y":[0.94]},"t":8,"s":[0]},{"t":68,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":3,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.658823549747,0,0.878431379795,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":1.5,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[12.542,14.146],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Hemi-B","np":4,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[-7.428,-3.424],[-3.615,-5.625],[7.428,0.75],[7.428,5.625]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.68],"y":[0.06]},"o":{"x":[0.4],"y":[0]},"t":112,"s":[0]},{"t":172,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.6],"y":[1]},"o":{"x":[0.32],"y":[0.94]},"t":8,"s":[0]},{"t":68,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.658823549747,0,0.878431379795,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":1.5,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[16.157,7.125],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Valence-A","np":3,"cix":2,"bm":0,"ix":4,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[7.516,3.321],[3.525,5.625],[-7.516,-0.75],[-7.516,-5.625]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.68],"y":[0.06]},"o":{"x":[0.4],"y":[0]},"t":112,"s":[0]},{"t":172,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.6],"y":[1]},"o":{"x":[0.32],"y":[0.94]},"t":8,"s":[0]},{"t":68,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.658823549747,0,0.878431379795,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":1.5,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[9.016,21.375],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Valence-B","np":3,"cix":2,"bm":0,"ix":5,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0}],"markers":[]}');


const $26006b130d8792a9$var$getLottieData = (kind)=>{
    switch(kind){
        case "saviLoader":
            return 0, (/*@__PURE__*/$parcel$interopDefault($9c8fc2d9b43b71aa$exports));
        default:
            (0, $7XTbi$Logger).error(`LottiePlayer: No animation data found for "${kind}"`);
            return null;
    }
};
function $26006b130d8792a9$var$LottiePlayer({ kind: kind, loop: loop, style: style, className: className, animationData: animationData }) {
    let animationDataToUse = animationData || $26006b130d8792a9$var$getLottieData(kind);
    if (typeof animationDataToUse === "string") try {
        animationDataToUse = JSON.parse(animationDataToUse);
    } catch (error) {
        (0, $7XTbi$Logger).error("LottiePlayer: Failed to convert animation string to json", error);
        return null;
    }
    if (!animationDataToUse) {
        (0, $7XTbi$Logger).info("LottiePlayer: No animation data found");
        return null;
    }
    return /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $7XTbi$lottiereact), {
            animationData: animationDataToUse,
            loop: loop,
            style: style
        })
    });
}
$26006b130d8792a9$var$LottiePlayer.propTypes = {
    kind: (0, $7XTbi$proptypes).string,
    loop: (0, $7XTbi$proptypes).bool,
    style: (0, $7XTbi$proptypes).objectOf((0, $7XTbi$proptypes).oneOfType([
        (0, $7XTbi$proptypes).string,
        (0, $7XTbi$proptypes).number
    ])),
    className: (0, $7XTbi$proptypes).string,
    animationData: (0, $7XTbi$proptypes).oneOfType([
        (0, $7XTbi$proptypes).object,
        (0, $7XTbi$proptypes).string
    ])
};
$26006b130d8792a9$var$LottiePlayer.defaultProps = {
    kind: null,
    loop: true,
    animationData: null,
    style: null,
    className: null
};
var $26006b130d8792a9$export$2e2bcd8739ae039 = $26006b130d8792a9$var$LottiePlayer;



/* eslint-disable react/jsx-curly-spacing */ 





/**
 * Custom hook to handle sorting of table data
 * @param {Array} data table data
 * @param {Object} config initial sort config { key: 'field', order: 'asc'/'desc' }
 */ function $3cad34c0fd3b7ff8$var$useSortableTable(data, config = null) {
    const [sortConfigObj, setSortConfigObj] = (0, $7XTbi$useState)(config);
    // memoize sorted data for performance
    const sortedData = (0, $7XTbi$useMemo)(()=>{
        if (!sortConfigObj) return data;
        const sortedArray = [
            ...data
        ].sort((a, b)=>{
            const aVal = a[sortConfigObj.key];
            const bVal = b[sortConfigObj.key];
            // numeric comparison
            if (typeof aVal === "number" && typeof bVal === "number") return sortConfigObj.order === "asc" ? aVal - bVal : bVal - aVal;
            // string comparison
            if (typeof aVal === "string" && typeof bVal === "string") return sortConfigObj.order === "asc" ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);
            // handle undefined values and non-sortable fields
            if (!aVal || !bVal) return 0;
            return 0;
        });
        return sortedArray;
    }, [
        data,
        sortConfigObj
    ]);
    const handleSort = (key)=>{
        let order = "asc";
        if (sortConfigObj?.key === key && sortConfigObj?.order === "asc") order = "desc"; // toggle sort
        setSortConfigObj({
            key: key,
            order: order
        });
    };
    return {
        sortedData: sortedData,
        handleSort: handleSort,
        sortConfigObj: sortConfigObj
    };
}
var $3cad34c0fd3b7ff8$export$2e2bcd8739ae039 = $3cad34c0fd3b7ff8$var$useSortableTable;










function $3b069010404a2fb8$var$TableSortable({ data: data, columns: columns, sortConfigs: sortConfigs, sortIcons: sortIcons, className: className }) {
    const { sortedData: sortedData, handleSort: handleSort, sortConfigObj: sortConfigObj } = (0, $3cad34c0fd3b7ff8$export$2e2bcd8739ae039)(data, sortConfigs);
    const getSortDirectionIcon = (key)=>{
        // if the column is not sortable, don't show any sorting icon.
        const column = columns.find((col)=>col.key === key);
        if (!column.isSortable) return null;
        if (sortConfigObj.key === key) return sortConfigObj.order === "asc" ? sortIcons.sortAsc : sortIcons.sortDesc;
        return sortIcons.sortNone;
    };
    return /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $d46ab010e21b8873$export$2e2bcd8739ae039), {
        className: className,
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsx)((0, $c6e9c8a380fd3258$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $fc2b7ce217d20b94$export$2e2bcd8739ae039), {
                    isHeader: true,
                    children: columns.map((col)=>/*#__PURE__*/ (0, $7XTbi$jsx)((0, $93183887bbadf20f$export$2e2bcd8739ae039), {
                            isHeader: true,
                            onClick: ()=>{
                                if (col.isSortable) handleSort(col.key);
                            },
                            className: (0, $7XTbi$classnames)(col?.isSortable && "Neo-TableCell--isSortable", sortConfigObj?.key === col.key && `Neo-TableCell--sorted${(0, $7XTbi$capitalizeFirstLetter)(sortConfigObj.order)}`),
                            children: /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                                className: "Neo-TableCellHeader",
                                children: [
                                    /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                                        children: col.label
                                    }),
                                    /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                                        children: getSortDirectionIcon(col.key)
                                    })
                                ]
                            })
                        }, col.key))
                })
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)((0, $a4e7cb3291e83c6f$export$2e2bcd8739ae039), {
                children: sortedData.map((row)=>{
                    // use the first 2 values of the row as the key for now.
                    const values = Object.values(row);
                    const key = `${values[0]}-${values[1]}`;
                    return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $fc2b7ce217d20b94$export$2e2bcd8739ae039), {
                        children: columns.map((col)=>/*#__PURE__*/ (0, $7XTbi$jsx)((0, $93183887bbadf20f$export$2e2bcd8739ae039), {
                                children: row[col.key]
                            }, col.key))
                    }, key);
                })
            })
        ]
    });
}
$3b069010404a2fb8$var$TableSortable.propTypes = {
    data: (0, $7XTbi$proptypes).arrayOf((0, $7XTbi$proptypes).objectOf((0, $7XTbi$proptypes).oneOfType([
        (0, $7XTbi$proptypes).string,
        (0, $7XTbi$proptypes).number
    ]))).isRequired,
    columns: (0, $7XTbi$proptypes).arrayOf((0, $7XTbi$proptypes).shape({
        key: (0, $7XTbi$proptypes).string.isRequired,
        label: (0, $7XTbi$proptypes).string.isRequired
    })).isRequired,
    sortConfigs: (0, $7XTbi$proptypes).shape({
        key: (0, $7XTbi$proptypes).string.isRequired,
        order: (0, $7XTbi$proptypes).string.isRequired
    }),
    sortIcons: (0, $7XTbi$proptypes).shape({
        sortNone: (0, $7XTbi$proptypes).element.isRequired,
        sortAsc: (0, $7XTbi$proptypes).element.isRequired,
        sortDesc: (0, $7XTbi$proptypes).element.isRequired
    }).isRequired,
    className: (0, $7XTbi$proptypes).string
};
$3b069010404a2fb8$var$TableSortable.defaultProps = {
    sortConfigs: null,
    className: null
};
var $3b069010404a2fb8$export$2e2bcd8739ae039 = $3b069010404a2fb8$var$TableSortable;


/* eslint-disable react/jsx-props-no-spreading */ 


function $b0f78e226fcf80ef$export$5523b16adee8048(props) {
    return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5f880a93b57cab01$export$2e2bcd8739ae039), {
        kind: "h1",
        ...props
    });
}
function $b0f78e226fcf80ef$export$cb94397127ac9363(props) {
    return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5f880a93b57cab01$export$2e2bcd8739ae039), {
        kind: "h2",
        ...props
    });
}
function $b0f78e226fcf80ef$export$746be9e3a3dfff1f(props) {
    return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5f880a93b57cab01$export$2e2bcd8739ae039), {
        kind: "h3",
        ...props
    });
}
function $b0f78e226fcf80ef$export$cc5e069d64fda823(props) {
    return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5f880a93b57cab01$export$2e2bcd8739ae039), {
        kind: "h4",
        ...props
    });
}
function $b0f78e226fcf80ef$export$88ef9fdaf11f7a1f(props) {
    return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5f880a93b57cab01$export$2e2bcd8739ae039), {
        kind: "h5",
        ...props
    });
}
function $b0f78e226fcf80ef$export$56c0d5a1e737357d(props) {
    return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5f880a93b57cab01$export$2e2bcd8739ae039), {
        ...props
    });
}
function $b0f78e226fcf80ef$export$b04be29aa201d4f5(props) {
    return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5f880a93b57cab01$export$2e2bcd8739ae039), {
        kind: "label",
        ...props
    });
}



/* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable object-curly-newline */ /* eslint-disable indent */ /* eslint-disable react/jsx-curly-spacing */ 












/* eslint-disable react/jsx-curly-spacing */ /* eslint-disable react/jsx-wrap-multilines */ 







/**
 * Component for displaying an uploaded file.
 *
 * @component
 * @param {string} fileName - name of the uploaded file.
 * @param {string} fileSize - size of the uploaded file.
 * @param {Function} onReupload - function to handle reuploading the file.
 * @param {Function} onDelete - function to handle deleting the file.
 * @param {string} [error] - error message, if any.
 * @param {string} [dataTestId] - data test ID for testing purposes.
 *
 * @returns {JSX.Element} The rendered component.
 */ function $34bc01b5dc28884f$var$UploadedFile({ fileName: fileName, fileSize: fileSize, onReupload: onReupload, onDelete: onDelete, error: error, dataTestId: dataTestId }) {
    return /*#__PURE__*/ (0, $7XTbi$jsxs)("section", {
        className: "UploadedFile-container",
        children: [
            /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                className: (0, $7XTbi$classnames)("UploadedFile", error && "UploadedFile--error"),
                "data-testid": dataTestId,
                children: [
                    /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                        kind: "document"
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                        className: "UploadedFile-nameSizeContainer",
                        children: [
                            /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                                className: "UploadedFile-fileName",
                                children: fileName
                            }),
                            /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                                className: "UploadedFile-fileSize",
                                children: fileSize
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                        className: "UploadedFile-actionIcons",
                        children: [
                            /*#__PURE__*/ (0, $7XTbi$jsx)((0, $8ff3b7072736807a$export$2e2bcd8739ae039), {
                                text: "Change",
                                placement: "top",
                                trigger: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $e34ff86c7a827ee6$export$2e2bcd8739ae039), {
                                    size: "large",
                                    kind: "outlinedSecondary",
                                    icon: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                                        kind: "retry",
                                        color: "neutral-100",
                                        size: "xSmall"
                                    }),
                                    onClick: onReupload
                                })
                            }),
                            /*#__PURE__*/ (0, $7XTbi$jsx)((0, $8ff3b7072736807a$export$2e2bcd8739ae039), {
                                text: "Delete",
                                placement: "top",
                                trigger: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $e34ff86c7a827ee6$export$2e2bcd8739ae039), {
                                    size: "large",
                                    kind: "outlinedSecondary",
                                    icon: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                                        kind: "delete",
                                        color: "neutral-100",
                                        size: "xSmall"
                                    }),
                                    onClick: onDelete
                                })
                            })
                        ]
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                className: "UploadedFile-error",
                children: [
                    /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                        kind: "AlertCritical",
                        size: "xSmall",
                        className: "UploadedFile-errorIcon"
                    }),
                    /*#__PURE__*/ (0, $7XTbi$jsx)("span", {
                        className: "UploadedFile-errorMessage",
                        children: error
                    })
                ]
            })
        ]
    });
}
$34bc01b5dc28884f$var$UploadedFile.propTypes = {
    fileName: (0, $7XTbi$proptypes).string.isRequired,
    fileSize: (0, $7XTbi$proptypes).string.isRequired,
    onReupload: (0, $7XTbi$proptypes).func.isRequired,
    onDelete: (0, $7XTbi$proptypes).func.isRequired,
    error: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string
};
$34bc01b5dc28884f$var$UploadedFile.defaultProps = {
    error: null,
    dataTestId: null
};
var $34bc01b5dc28884f$export$2e2bcd8739ae039 = $34bc01b5dc28884f$var$UploadedFile;



/**
 * Formats the uploaded file size.
 *
 * @param {number} fileSizeInBytes - Size of the file in bytes.
 * @returns {string} - Formatted file size in megabytes (MB).
 *
 * @example
 * Returns 'Calculating...' if fileSizeInBytes is null or undefined.
 * formatUploadFileSize(null);
 *
 * Returns the formatted size in MB format.
 * formatUploadFileSize(1024);
 *
 * @remarks
 * This function is used to format the file size regardless of whether
 * the useUploadFile custom hook is used.
 */ const $c35c58d20cfd16d5$export$b1b284d5a62e98b1 = (fileSizeInBytes)=>{
    const FILESIZE_DECIMAL_PLACES = 2;
    const BYTES_PER_KB = 1024;
    if (fileSizeInBytes === null || fileSizeInBytes === undefined) return "Calculating...";
    const fileSizeInMB = fileSizeInBytes / BYTES_PER_KB;
    return `${fileSizeInMB.toFixed(FILESIZE_DECIMAL_PLACES)}KB`;
};
/**
 * Adds 1 space between accept types in the acceptTypesString.
 *
 * @param {string} acceptTypesString - string containing accept types separated by commas.
 * @returns {string} - accept types string with 1 space added between types.
 * @example Returns '.png, .jpeg' if acceptTypesString is '.png,.jpeg'.
 */ const $c35c58d20cfd16d5$export$5f78e98b5fc21554 = (acceptTypesString)=>acceptTypesString.split(",").join(", ");
const $c35c58d20cfd16d5$export$3666509ccff84839 = (acceptTypesString)=>acceptTypesString.replace(/\./g, "");



const $4f136b804d0f05b8$var$KINDS = {
    dropzone: "dropzone",
    button: "button"
};
const $4f136b804d0f05b8$var$REUPLOAD_DELAY_MS = 100;
const $4f136b804d0f05b8$var$MB_DECIMAL_PLACES = 1;
/**
 * ###### TODO:
 * - Add uploaded preview image for uploaded images.
 */ function $4f136b804d0f05b8$var$Upload({ kind: kind, isMultiple: isMultiple, helperText: helperText, onFileSelect: onFileSelect, onFileDelete: onFileDelete, onFileReupload: onFileReupload, isReuploadWithDelete: isReuploadWithDelete, uploadedFiles: uploadedFiles, isUploading: isUploading, acceptTypes: acceptTypes, reuploadFileName: reuploadFileName, isMaxNumberUploaded: isMaxNumberUploaded, isMaxTotalSizeReached: isMaxTotalSizeReached, buttonLabel: buttonLabel, dropzoneLinkText: dropzoneLinkText, fileTypesAllowedText: fileTypesAllowedText, maxFileCount: maxFileCount, maxFileSize: maxFileSize, maxTotalFileSize: maxTotalFileSize, showHeader: showHeader, className: className, dataTestId: dataTestId }) {
    const [isDragging, setIsDragging] = (0, $7XTbi$useState)(false);
    const dragCounterRef = (0, $7XTbi$useRef)(0);
    const fileInputRef = (0, $7XTbi$useRef)(null);
    const intl = (0, $7XTbi$useIntl)();
    const MAX_UPLOADS_REACHED_TEXT = (0, $7XTbi$localize)(intl, (0, $6a38161dcf7a2c63$export$9f3245bec405e186).neo.upload.maxFilesReached);
    const headerText = isMultiple ? (0, $7XTbi$localize)(intl, (0, $6a38161dcf7a2c63$export$9f3245bec405e186).neo.upload.headerTextPlural) : (0, $7XTbi$localize)(intl, (0, $6a38161dcf7a2c63$export$9f3245bec405e186).neo.upload.headerText);
    (0, $7XTbi$useEffect)(()=>{
        // trigger file input when a file is set for reupload
        if (reuploadFileName && fileInputRef.current) fileInputRef.current.click();
    }, [
        reuploadFileName
    ]);
    const preventDefaultAndStopPropagation = (e)=>{
        e.preventDefault();
        e.stopPropagation();
    };
    const handleBrowseClick = (e)=>{
        e.stopPropagation();
        fileInputRef.current.click();
    };
    const handleDragOver = (e)=>{
        preventDefaultAndStopPropagation(e);
    };
    const handleDragEnter = (e)=>{
        preventDefaultAndStopPropagation(e);
        dragCounterRef.current += 1;
        if (dragCounterRef.current === 1) setIsDragging(true);
    };
    const handleDragLeave = (e)=>{
        preventDefaultAndStopPropagation(e);
        dragCounterRef.current -= 1;
        if (dragCounterRef.current === 0) setIsDragging(false);
    };
    const handleDrop = (e)=>{
        preventDefaultAndStopPropagation(e);
        setIsDragging(false);
        dragCounterRef.current = 0;
        let files = Array.from(e.dataTransfer.files);
        if (!isMultiple) files = files.slice(0, 1);
        const allowedFileTypes = acceptTypes ? acceptTypes.split(",").map((type)=>type.trim()) : null; // allow all types if acceptTypes is falsy
        onFileSelect?.(files, allowedFileTypes);
    };
    const handleFileChange = (e)=>{
        let files = Array.from(e.target.files);
        if (!isMultiple) files = files.slice(0, 1);
        const allowedFileTypes = acceptTypes ? acceptTypes.split(",").map((type)=>type.trim()) : null; // allow all types if acceptTypes is falsy
        onFileSelect?.(files, allowedFileTypes);
        e.target.value = null; // reset the file input for the next file.
    };
    const renderedUploadedFiles = uploadedFiles.map((file)=>{
        let fadeClass = file.isUploading ? "UploadedFile--fadingIn" : "";
        if (reuploadFileName === file.fileName) fadeClass = "UploadedFile--fadingOut";
        return /*#__PURE__*/ (0, $7XTbi$jsx)((0, $34bc01b5dc28884f$export$2e2bcd8739ae039), {
            fileName: file.fileName,
            fileSize: (0, $c35c58d20cfd16d5$export$b1b284d5a62e98b1)(file.fileSize),
            error: file.isError ? file.errorMessage : null,
            onReupload: ()=>{
                if (isReuploadWithDelete) {
                    onFileDelete?.(file.fileName);
                    setTimeout(()=>{
                        // slight delay makes the experience smoother
                        onFileReupload?.(file.fileName);
                    }, $4f136b804d0f05b8$var$REUPLOAD_DELAY_MS);
                } else onFileReupload?.(file.fileName); // original behavior for backwards compatibility
            },
            onDelete: ()=>onFileDelete(file.fileName),
            isUploading: isUploading,
            className: fadeClass
        }, file.fileName);
    });
    const isDropzoneOrButtonVisible = isMultiple || uploadedFiles.length === 0;
    const maxNumberFilesText = maxFileCount ? (0, $7XTbi$localize)(intl, (0, $6a38161dcf7a2c63$export$9f3245bec405e186).neo.upload.maxFileCount, {
        maxFileCount: maxFileCount
    }) : "";
    let totalUploadSizeCantExceedStr = "";
    let attachmentSizeCantExceedStr = "";
    const acceptTypesFormatted = (0, $c35c58d20cfd16d5$export$5f78e98b5fc21554)((0, $c35c58d20cfd16d5$export$3666509ccff84839)(acceptTypes));
    // fileTypesAllowedText prop gets priority for backwards compatibility
    let newFileTypesAllowedText = fileTypesAllowedText;
    const acceptTypesTooltip = showHeader && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $8ff3b7072736807a$export$2e2bcd8739ae039), {
        text: `
        ${(0, $7XTbi$localize)(intl, (0, $6a38161dcf7a2c63$export$9f3245bec405e186).neo.upload.allowedTypesInfoTooltip, {
            acceptTypes: (0, $c35c58d20cfd16d5$export$5f78e98b5fc21554)(acceptTypes),
            maxNumberFilesText: maxNumberFilesText
        })} ${maxFileSize ? (0, $7XTbi$localize)(intl, (0, $6a38161dcf7a2c63$export$9f3245bec405e186).neo.upload.maxFileSize, {
            maxFileSizeString: `${maxFileSize}MB`
        }) : ""} ${isMultiple && maxFileCount ? (0, $7XTbi$localize)(intl, (0, $6a38161dcf7a2c63$export$9f3245bec405e186).neo.upload.maxFileCount, {
            maxFileCount: maxFileCount
        }) : ""}
      `,
        position: "top",
        children: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
            kind: "info",
            size: "xSmall",
            color: "info-500"
        })
    });
    if (!fileTypesAllowedText) {
        newFileTypesAllowedText = `Allows ${acceptTypesFormatted} files.`;
        totalUploadSizeCantExceedStr = (0, $7XTbi$localize)(intl, (0, $6a38161dcf7a2c63$export$9f3245bec405e186).neo.upload.totalUploadSizeCantExceed, {
            maxTotalFileSize: maxTotalFileSize && maxTotalFileSize.toString().includes(".") ? Number(maxTotalFileSize).toFixed($4f136b804d0f05b8$var$MB_DECIMAL_PLACES) : maxTotalFileSize
        });
        attachmentSizeCantExceedStr = (0, $7XTbi$localize)(intl, (0, $6a38161dcf7a2c63$export$9f3245bec405e186).neo.upload.attachmentSizeCantExceed, {
            maxFileSize: maxFileSize && maxFileSize.toString().includes(".") ? Number(maxFileSize).toFixed($4f136b804d0f05b8$var$MB_DECIMAL_PLACES) : maxFileSize
        });
    }
    let buttonLabelFinal = buttonLabel;
    let dropzoneLinkTextFinal = dropzoneLinkText;
    if (buttonLabel === "Browse") {
        // localize since it's the default prop.
        buttonLabelFinal = (0, $7XTbi$localize)(intl, (0, $6a38161dcf7a2c63$export$9f3245bec405e186).neo.common.browse);
        buttonLabelFinal = (0, $7XTbi$capitalizeFirstLetter)(buttonLabelFinal);
    } else (0, $7XTbi$Logger).warn("Be sure to localize the buttonLabel prop.");
    if (dropzoneLinkText === "browse") // localize since it's the default prop.
    dropzoneLinkTextFinal = (0, $7XTbi$localize)(intl, (0, $6a38161dcf7a2c63$export$9f3245bec405e186).neo.common.browse);
    else (0, $7XTbi$Logger).warn("Be sure to localize the dropzoneLinkText prop.");
    return /*#__PURE__*/ (0, $7XTbi$jsxs)("section", {
        className: (0, $7XTbi$classnames)("Upload-container", className),
        "data-testid": dataTestId,
        children: [
            showHeader && /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                className: "Upload-headerWrapper",
                children: [
                    /*#__PURE__*/ (0, $7XTbi$jsx)((0, $5f880a93b57cab01$export$2e2bcd8739ae039), {
                        kind: "h4",
                        className: "Upload-headerText",
                        children: headerText
                    }),
                    acceptTypesTooltip
                ]
            }),
            helperText && /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                className: "Upload-helperText",
                children: helperText
            }),
            kind === $4f136b804d0f05b8$var$KINDS.dropzone ? /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $7XTbi$Fragment), {
                children: [
                    isDropzoneOrButtonVisible && /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                        className: (0, $7XTbi$classnames)("Upload-dropzone", isMaxNumberUploaded && "Upload-dropzone--isMaxNumberUploaded", isDragging && "Upload--isDragging"),
                        onDragOver: handleDragOver,
                        onDragEnter: handleDragEnter,
                        onDragLeave: handleDragLeave,
                        onDrop: handleDrop,
                        children: /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                            className: "Upload-content",
                            children: [
                                /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                                    className: "Upload-icon",
                                    children: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                                        kind: "document",
                                        color: isMaxNumberUploaded || isMaxTotalSizeReached ? "neutral-600" : "navy-900"
                                    })
                                }),
                                isMaxNumberUploaded || isMaxTotalSizeReached ? /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                                    className: "Upload-maxNumberUploaded",
                                    children: [
                                        /*#__PURE__*/ (0, $7XTbi$jsx)((0, $fb956946457df475$export$2e2bcd8739ae039), {
                                            text: isMaxTotalSizeReached ? (0, $7XTbi$localize)(intl, (0, $6a38161dcf7a2c63$export$9f3245bec405e186).neo.upload.maxUploadSizeReached) : MAX_UPLOADS_REACHED_TEXT,
                                            colorTheme: "warning",
                                            size: "small",
                                            leftIcon: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                                                kind: "Warning"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                                            className: "Upload-filetypes",
                                            children: [
                                                /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                                                    className: "Upload-dropzoneAllowedFilesInfo",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                                                            children: newFileTypesAllowedText
                                                        }),
                                                        /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                                                            children: isMultiple ? totalUploadSizeCantExceedStr : attachmentSizeCantExceedStr
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                                                    children: maxNumberFilesText
                                                })
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $7XTbi$Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                                            className: "Upload-instructions",
                                            children: [
                                                (0, $7XTbi$localize)(intl, (0, $6a38161dcf7a2c63$export$9f3245bec405e186).neo.upload.dragAndDropOr),
                                                "\xa0",
                                                /*#__PURE__*/ (0, $7XTbi$jsx)((0, $47010fca98b98efb$export$2e2bcd8739ae039), {
                                                    text: dropzoneLinkTextFinal,
                                                    onClick: handleBrowseClick
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                                            className: "Upload-filetypes",
                                            children: [
                                                /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                                                    className: "Upload-dropzoneAllowedFilesInfo",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                                                            children: newFileTypesAllowedText
                                                        }),
                                                        /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                                                            children: isMultiple ? totalUploadSizeCantExceedStr : attachmentSizeCantExceedStr
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7XTbi$jsx)("div", {
                                                    children: maxNumberFilesText
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    renderedUploadedFiles
                ]
            }) : /*#__PURE__*/ (0, $7XTbi$jsxs)((0, $7XTbi$Fragment), {
                children: [
                    renderedUploadedFiles,
                    /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                        className: "Upload-buttonTriggerContainer",
                        children: [
                            isDropzoneOrButtonVisible && /*#__PURE__*/ (0, $7XTbi$jsx)((0, $9a0a9a7cc0462999$export$2e2bcd8739ae039), {
                                type: "button",
                                kind: "filled",
                                size: "medium",
                                onClick: handleBrowseClick,
                                className: "Upload-buttonTrigger",
                                isDisabled: isMaxNumberUploaded || isMaxTotalSizeReached,
                                leftIcon: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                                    kind: "Upload",
                                    size: "smallMedium",
                                    color: "neutral-100"
                                }),
                                children: buttonLabelFinal
                            }),
                            isMultiple && (isMaxNumberUploaded || isMaxTotalSizeReached) && // don't show this for the 'single file' button, the file comp shows the error message.
                            /*#__PURE__*/ (0, $7XTbi$jsx)((0, $fb956946457df475$export$2e2bcd8739ae039), {
                                text: isMaxTotalSizeReached ? (0, $7XTbi$localize)(intl, (0, $6a38161dcf7a2c63$export$9f3245bec405e186).neo.upload.maxUploadSizeReached) : `${MAX_UPLOADS_REACHED_TEXT}`,
                                colorTheme: "warning",
                                size: "small",
                                leftIcon: /*#__PURE__*/ (0, $7XTbi$jsx)((0, $1745e04e4ee31a1f$export$2e2bcd8739ae039), {
                                    kind: "Warning"
                                })
                            }),
                            !isMaxTotalSizeReached && (isMultiple ? !isMaxNumberUploaded : renderedUploadedFiles.length === 0) && // when isMultiple, show this JSX until max number of files
                            // is reached or max total file size is reached
                            /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                                className: "Upload-filetypes",
                                children: [
                                    /*#__PURE__*/ (0, $7XTbi$jsxs)("div", {
                                        className: "Upload-buttonAllowedFilesInfo",
                                        children: [
                                            newFileTypesAllowedText,
                                            "\xa0",
                                            isMultiple ? totalUploadSizeCantExceedStr : attachmentSizeCantExceedStr
                                        ]
                                    }),
                                    isMaxTotalSizeReached ? (0, $7XTbi$localize)(intl, (0, $6a38161dcf7a2c63$export$9f3245bec405e186).neo.upload.maxUploadSizeReached) : maxNumberFilesText
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7XTbi$jsx)((0, $866a094b111604e5$export$2e2bcd8739ae039), {
                type: "file",
                className: "Upload-input",
                accept: acceptTypes,
                multiple: isMultiple,
                onChange: handleFileChange,
                ref: fileInputRef
            })
        ]
    });
}
$4f136b804d0f05b8$var$Upload.propTypes = {
    kind: (0, $7XTbi$proptypes).oneOf([
        $4f136b804d0f05b8$var$KINDS.button,
        $4f136b804d0f05b8$var$KINDS.dropzone
    ]),
    isMultiple: (0, $7XTbi$proptypes).bool,
    helperText: (0, $7XTbi$proptypes).string,
    onFileSelect: (0, $7XTbi$proptypes).func.isRequired,
    onFileDelete: (0, $7XTbi$proptypes).func.isRequired,
    onFileReupload: (0, $7XTbi$proptypes).func.isRequired,
    isReuploadWithDelete: (0, $7XTbi$proptypes).bool,
    uploadedFiles: (0, $7XTbi$proptypes).arrayOf((0, $7XTbi$proptypes).shape({
        fileName: (0, $7XTbi$proptypes).string.isRequired,
        fileSize: (0, $7XTbi$proptypes).number,
        isError: (0, $7XTbi$proptypes).bool,
        errorMessage: (0, $7XTbi$proptypes).string,
        isUploading: (0, $7XTbi$proptypes).bool
    })).isRequired,
    isUploading: (0, $7XTbi$proptypes).bool,
    acceptTypes: (0, $7XTbi$proptypes).string,
    reuploadFileName: (0, $7XTbi$proptypes).string,
    isMaxNumberUploaded: (0, $7XTbi$proptypes).bool,
    isMaxTotalSizeReached: (0, $7XTbi$proptypes).bool,
    buttonLabel: (0, $7XTbi$proptypes).string,
    dropzoneLinkText: (0, $7XTbi$proptypes).string,
    fileTypesAllowedText: (0, $7XTbi$proptypes).string,
    maxFileCount: (0, $7XTbi$proptypes).number,
    maxFileSize: (0, $7XTbi$proptypes).number,
    maxTotalFileSize: (0, $7XTbi$proptypes).number,
    showHeader: (0, $7XTbi$proptypes).bool,
    className: (0, $7XTbi$proptypes).string,
    dataTestId: (0, $7XTbi$proptypes).string
};
$4f136b804d0f05b8$var$Upload.defaultProps = {
    kind: $4f136b804d0f05b8$var$KINDS.dropzone,
    isMultiple: false,
    helperText: "",
    acceptTypes: "",
    isReuploadWithDelete: true,
    isUploading: false,
    reuploadFileName: null,
    isMaxNumberUploaded: false,
    isMaxTotalSizeReached: false,
    buttonLabel: "Browse",
    dropzoneLinkText: "browse",
    // TODO: Deprecated prop. keep below for backwards compatibility in host, remove in the future.
    fileTypesAllowedText: "",
    maxFileCount: null,
    maxFileSize: null,
    maxTotalFileSize: null,
    showHeader: false,
    className: null,
    dataTestId: null
};
var $4f136b804d0f05b8$export$2e2bcd8739ae039 = $4f136b804d0f05b8$var$Upload;






export {$52b0e94fcd4b9f4d$export$2e2bcd8739ae039 as AccordionStepper, $cc675143c5103274$export$2e2bcd8739ae039 as AlertBanner, $c9ce95d8036e4d67$export$75c3033471110567 as AlertBannerProvider, $c9ce95d8036e4d67$export$d5e01b4fb519ae55 as StackingAlertBanner, $f999930470b087cd$export$2e2bcd8739ae039 as ApplicationIcon, $f0cbdef548412548$export$2e2bcd8739ae039 as Avatar, $7897891fa90cac71$export$2e2bcd8739ae039 as Badge, $9e3775a9a154967e$export$2e2bcd8739ae039 as Box, $9a0a9a7cc0462999$export$2e2bcd8739ae039 as Button, $553ba9ca1822b2c0$export$2e2bcd8739ae039 as ButtonCore, $6ce488bd8de8fd90$export$2e2bcd8739ae039 as ButtonSelect, $e34ff86c7a827ee6$export$2e2bcd8739ae039 as ButtonIcon, $ea632b95ffcf8459$export$2e2bcd8739ae039 as Checkbox, $1c832d45f8fbd688$export$2e2bcd8739ae039 as CheckboxGroup, $b7a25e567a023755$export$2e2bcd8739ae039 as Chip, $f4c5e95c338bfebc$export$2e2bcd8739ae039 as Color, $db995900dd9f9eb4$export$2e2bcd8739ae039 as DateAndTimePicker, $2262e7f4cc382b2a$export$2e2bcd8739ae039 as MobileDrawer, $7082d2d2e186ccb9$export$2e2bcd8739ae039 as MobileDrawerItem, $d194faea1a3958a2$export$2e2bcd8739ae039 as FooterActionBar, $53adb6ae63fe1b6d$export$2e2bcd8739ae039 as Grid, $4a15bfc3fe1685a3$export$2e2bcd8739ae039 as Header, $1745e04e4ee31a1f$export$2e2bcd8739ae039 as Icon, $956ec155f2f59366$export$2e2bcd8739ae039 as Illustration, $fb956946457df475$export$2e2bcd8739ae039 as InlineMessage, $5f5001b799eea6c0$export$2e2bcd8739ae039 as InputField, $47010fca98b98efb$export$2e2bcd8739ae039 as Link, $d21d00ad66b7d185$export$2e2bcd8739ae039 as ListRow, $8cfc7d204d9eaf39$export$2e2bcd8739ae039 as ListRowAccount, $838d6cab6e92f326$export$2e2bcd8739ae039 as ListRowSession, $aaa9cfb6f823414a$export$2e2bcd8739ae039 as ListRowTarget, $199d1dc410e8acb9$export$2e2bcd8739ae039 as Loader, $540f31a7d1651db4$export$2e2bcd8739ae039 as Logo, $9ef6121f0a4af6a4$export$2e2bcd8739ae039 as Menu, $e27c03c18d801a90$export$2e2bcd8739ae039 as MenuInput, $0d6416eee7308de1$export$2e2bcd8739ae039 as MenuMulti, $e3ff878f28f11e4a$export$2e2bcd8739ae039 as MenuNested, $e3ff878f28f11e4a$export$b308ebf3da41e866 as MenuNestedItem, $f5ddd953b7dd72da$export$2e2bcd8739ae039 as ModalIsland, $2d535bbeb08870f5$export$2e2bcd8739ae039 as ModalPageHeader, $84700a637e00ff00$export$c6fdb837b070b4ff as Overlay, $84700a637e00ff00$export$ea8f71083e90600f as useOverlay, $84700a637e00ff00$export$bf688221f59024e5 as OverlayProvider, $84700a637e00ff00$export$923364ead265c35c as OverlayProviderWrapper, $a121dee67c986139$export$2e2bcd8739ae039 as PaginationCondensed, $2b436ec080a89837$export$2e2bcd8739ae039 as PaginationGroup, $a50b1aa2658909fb$export$2e2bcd8739ae039 as PaginationItem, $11e1006960f3c7db$export$2e2bcd8739ae039 as Popover, $daa9319cd1e2c635$export$2e2bcd8739ae039 as RadioButton, $fd4a8693f24b1189$export$2e2bcd8739ae039 as SelectMulti, $fc451ffe085c8096$export$2e2bcd8739ae039 as SidePanel, $c6b4aa88d3042587$export$2e2bcd8739ae039 as Switch, $5eded0bf0d8942b4$export$2e2bcd8739ae039 as TabContent, $c48ff74158c5949d$export$2e2bcd8739ae039 as TabGroup, $0e72242ab07afce9$export$2e2bcd8739ae039 as TabItem, $d46ab010e21b8873$export$2e2bcd8739ae039 as Table, $a4e7cb3291e83c6f$export$2e2bcd8739ae039 as TableBody, $93183887bbadf20f$export$2e2bcd8739ae039 as TableCell, $c6e9c8a380fd3258$export$2e2bcd8739ae039 as TableHead, $fc2b7ce217d20b94$export$2e2bcd8739ae039 as TableRow, $0eddd663dfc2d752$export$2e2bcd8739ae039 as ToggleButton, $5b8103afa728cdea$export$2e2bcd8739ae039 as ToggleButtonGroup, $8ff3b7072736807a$export$2e2bcd8739ae039 as TooltipComponent, $8ff3b7072736807a$export$2e2bcd8739ae039 as Tooltip, $5f1676931660893b$export$2e2bcd8739ae039 as DownloadFile, $26006b130d8792a9$export$2e2bcd8739ae039 as LottiePlayer, $d6f276bb47558b59$export$2e2bcd8739ae039 as MenuItem, $3b069010404a2fb8$export$2e2bcd8739ae039 as TableSortable, $b0f78e226fcf80ef$export$5523b16adee8048 as H1, $b0f78e226fcf80ef$export$cb94397127ac9363 as H2, $b0f78e226fcf80ef$export$746be9e3a3dfff1f as H3, $b0f78e226fcf80ef$export$cc5e069d64fda823 as H4, $b0f78e226fcf80ef$export$88ef9fdaf11f7a1f as H5, $b0f78e226fcf80ef$export$b04be29aa201d4f5 as Label, $b0f78e226fcf80ef$export$56c0d5a1e737357d as P, $5f880a93b57cab01$export$2e2bcd8739ae039 as Typography, $4f136b804d0f05b8$export$2e2bcd8739ae039 as Upload, $34bc01b5dc28884f$export$2e2bcd8739ae039 as UploadedFile, $1a24ce14a1841475$export$d269ac3552e3437f as useAdjustDropdownHeight, $6cb28ba18cf98155$export$28f8a6921de3d9b4 as useManageDropdownHeight, $aaccccad0f77307b$export$141ab6e47836fbe as useMenuControlImperative, $487d37a99b6b914a$export$a734948050b9a715 as useOverlayTransition, $81f183f6a8c46f0f$export$49ff6f28c54f1cbe as useCheckboxGroup, $bdc6e08e9265483c$export$99f94e553b895c19 as useScrollbarWidth, $050849284656386f$export$5516774f584ac19 as useTooltipText, $efc7314c0ba6153c$export$25a37a5353d087d9 as useUploadFile};
//# sourceMappingURL=module.js.map
